var CustomDataChart_BARRONS_0_8_56 =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 218);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.26.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(245)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.26.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(42)('wks');
var uid = __webpack_require__(28);
var Symbol = __webpack_require__(1).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAX_4U_WIDTH = exports.MAX_4U_WIDTH = 359;
var MAX_NARROW_WIDTH_PRINT = exports.MAX_NARROW_WIDTH_PRINT = 114;

var LONG = exports.LONG = 'long';
var SHORT = exports.SHORT = 'short';

var REGEXP_QUARTER = exports.REGEXP_QUARTER = /^([1-4]Q|[1-2]H)?\s*(FY)?['|\u2019]?(\d{2,4})/i;
var REGEXP_Q_ONLY = exports.REGEXP_Q_ONLY = /^([1-4]Q|[1-2]H)/i;

var REGEXP_MDY = exports.REGEXP_MDY = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\b/;
var REGEXP_MDY_FRED = exports.REGEXP_MDY_FRED = /^(\d{4})-(\d{2})-(\d{2})\b/;
var REGEXP_MD = exports.REGEXP_MD = /^(\d{1,2})\/(\d{1,2})\b/;
var REGEXP_MY = exports.REGEXP_MY = /^(\d{1,2})\/(\d{3,4})\b/;
var REGEXP_Y = exports.REGEXP_Y = /^(\d{4})\b/;
var REGEXP_TIME = exports.REGEXP_TIME = /\b(\d{1,2}):(\d{1,2})(:\d{1,2})?(\s?[a|p]\.+m\.+?)?(\s[a-z]{2,3})?$/i;

var MONTHS = exports.MONTHS = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
var MONTHS_SHORT = exports.MONTHS_SHORT = 'JFMAMJJASOND';

var CATEGORY = exports.CATEGORY = /\{category\}/g;
var SERIES = exports.SERIES = /\{series\}/g;
var VALUE = exports.VALUE = /\{value\}/g;
var POINT = exports.POINT = /\{point\}/g;
var SYMBOL = exports.SYMBOL = /\{symbol\}/g;

// Because &nbsp; does not work inside SVG.
var NBSP = exports.NBSP = '<span style="color: rgba(255,255,255,0);" class="space">.</span>';

var APOSTROPHE = exports.APOSTROPHE = '’';

var TRANSPARENT = exports.TRANSPARENT = 'rgba(0, 0, 0, 0)';

var ANNOTATIONS_SPACE = exports.ANNOTATIONS_SPACE = 4;
var ANNOTATIONS_SPACE_PRINT = exports.ANNOTATIONS_SPACE_PRINT = 2;
var ANNOTATIONS_LINEHEIGHT = exports.ANNOTATIONS_LINEHEIGHT = 24;
var ANNOTATIONS_LINEHEIGHT_VIDEO = exports.ANNOTATIONS_LINEHEIGHT_VIDEO = 42;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(220);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(233);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(58);
var toPrimitive = __webpack_require__(37);
var dP = Object.defineProperty;

exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(240);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(27)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(5);
var ctx = __webpack_require__(21);
var hide = __webpack_require__(11);
var has = __webpack_require__(13);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(22);
module.exports = __webpack_require__(9) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decimals = decimals;
exports.commas = commas;
exports.getDivisor = getDivisor;
exports.applyFull = applyFull;
function decimals(value, props) {
  var skipZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var fd = getMaxDecimalValue(props.forceDecimals);
  var md = getMaxDecimalValue(props.maxDecimals);
  // value = +value;
  value = value.toString();
  if (fd > -1) {
    value = round(value, fd); //value.toFixed(fd);
    if (md > -1 && md < fd) {
      value = round(value, md); //(+value).toFixed(md);
    }
    return value;
  } else if (md > -1) {
    value = round(value, md); //(+value).toFixed(md);
    while (value.substring(value.length - 1) === '0') {
      value = value.substr(0, value.length - 1);
      if (value.substring(value.length - 1) === '.') {
        value = value.substr(0, value.length - 1);
        break;
      }
    }
  }
  return value;
}

function addZeros(num) {
  return new Array(num + 1).join('0');
}

function useFixed(value, places) {
  var rounded = (+value).toFixed(places - 1);
  var decPt = places === 1 ? '.' : '';
  return rounded + decPt + '0';
}

function round(value, places) {
  if (places === 0) return (+value).toFixed(0);
  var decimalIdx = value.indexOf('.');
  if (decimalIdx > -1) {
    var dec = value.slice(decimalIdx + 1);
    var diff = places - dec.length;
    if (diff > 0) {
      return value + addZeros(diff);
    }
    var fixedPlaces = dec.slice(0, places - 1);
    var lastDigit = +dec[places - 1];
    var nextDigit = +dec[places];
    if (nextDigit && nextDigit >= 5) {
      if (lastDigit === 9) {
        return useFixed(value, places);
      } else {
        lastDigit += 1;
      }
    }
    var rounded = fixedPlaces + lastDigit.toString();
    return value.slice(0, decimalIdx + 1) + rounded;
  }
  var zeros = addZeros(places);
  return value + '.' + zeros;
}

function getMaxDecimalValue(value) {
  if (typeof value === 'string' && value) {
    return +value;
  } else if (typeof value === 'number' && !isNaN(value)) {
    return value;
  }
  return -1;
}

function applyMaxDecimals(value, md) {
  var dotIndex = value.indexOf('.');
  if (dotIndex !== -1) {
    var decs = value.length - dotIndex - 1;
    value = (+value).toFixed(md);
  }
  return value;
}

function commas(value) {
  var commas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  value += '';
  if (commas) {
    var dotIndex = value.indexOf('.');
    if (dotIndex === -1) {
      dotIndex = value.length;
    }
    value = [value.substr(0, dotIndex).replace(/\B(?=(\d{3})+(?!\d))/g, ','), value.substr(dotIndex)].join('');
  }
  return value;
}

// Returns a useful number that corresponds to a divisor string.
function getDivisor(unit) {
  switch (unit) {
    case 'hundreds':
      return 100;
    case 'thousands':
      return 1000;
    case 'millions':
      return 1000000;
    case 'billions':
      return 1000000000;
    case 'trillions':
      return 1000000000000;
  }
  return 1;
}

function applyFull(value, props) {
  var isPie = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var skipZero = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var tooltipOrAnnotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isSpecialHorizontal = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isStackedPercent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

  if (value === undefined || value === null) return 'n/a';
  var newProps = Object.assign({}, props);
  if (tooltipOrAnnotation) {
    var splitDecimals = value.toString().split('.');
    splitDecimals = splitDecimals.length > 1 ? splitDecimals[1].length : 0;
    if (Number(splitDecimals) >= 3 && newProps.prefix === '') {
      newProps.forceDecimals = '3';
    }
    if (newProps.prefix !== '') {
      if (newProps.prefix !== undefined) newProps.forceDecimals = splitDecimals > 0 ? '2' : '0';
    } else {
      newProps.forceDecimals = splitDecimals;
    }
    newProps.maxDecimals = '3';
  }
  value = decimals(value, newProps);
  value = commas(value, newProps.commas);
  if (isPie) {
    value += '%';
  }
  if (isSpecialHorizontal) {
    return value;
  }

  if (value.charAt(0) === '-') {
    value = newProps.prefix !== undefined ? '-' + newProps.prefix + value.substr(1) : '' + value.substr(1);
  } else {
    value = newProps.prefix !== undefined ? '' + newProps.prefix + value : '' + value;
  }
  if (!isStackedPercent) value += newProps.suffix;
  return value;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeChild = removeChild;
exports.boldText = boldText;
exports.replaceLineBreaks = replaceLineBreaks;
function removeChild(el, parentEl) {
  parentEl = parentEl || el.parentElement;
  if (parentEl) {
    parentEl.removeChild(el);
  }
}

function boldText() {
  var bold = false;
  return function (str, openTag, closeTag) {
    var startIdx = 0;
    var asteriskIdx = void 0;
    var newStr = bold ? openTag : '';
    while ((asteriskIdx = str.indexOf('**', startIdx)) !== -1) {
      newStr += str.substring(startIdx, asteriskIdx) + (bold ? closeTag : openTag);
      bold = !bold;
      startIdx = asteriskIdx + 2;
    }
    return newStr + str.substring(startIdx) + (bold ? closeTag : '');
  };
}

function replaceLineBreaks(text) {
  return text.replace(/[\n|\r|↵]/g, '<br>');
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(225);
var defined = __webpack_require__(35);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.read = read;
exports.write = write;
var regExpD = /(M|L|(\-?\d+\.?\d*))/gi;
var regExpTranslate = /(.*)(translate\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;
var regExpScale = /(.*)(scale\()(\-?\d+\.?\d*),(\-?\d+\.?\d*)(.*)/;

function read(el, prop, value) {
  var match = null;
  switch (prop) {
    case 'd':
      match = (value || getD(el)).match(regExpD);
      return match ? formatDMatch(match) : null;
    case 'translate':
      match = (value || getTransform(el)).match(regExpTranslate);
      return match ? [+match[3], +match[4]] : null;
    case 'scale':
      match = (value || getTransform(el)).match(regExpScale);
      return match ? [+match[3], +match[4]] : null;
    default:
      return el;
  }
}

function write(el, prop) {
  switch (prop) {
    case 'd':
      writeD.apply(this, arguments);
      break;
    case 'translate':
      writeTranslate.apply(this, arguments);
      break;
    case 'scale':
      writeScale.apply(this, arguments);
      break;
  }
  return el;
}

function writeD(el) {
  var d = [];
  for (var i = 2; i < arguments.length; i++) {
    d.push(i === 2 ? 'M' : 'L');
    d.push(arguments[i][0]);
    d.push(arguments[i][1]);
  }
  el.setAttribute('d', d.join(' '));
}

function writeTranslate(el) {
  var oldTransform = el.getAttribute('transform');
  var newTransform = null;
  var match = oldTransform ? oldTransform.match(regExpTranslate) : null;
  if (match) {
    newTransform = [match[1], match[2], Math.round(typeof arguments[2] === 'number' ? arguments[2] : +match[3]), ',', Math.round(typeof arguments[3] === 'number' ? arguments[3] : +match[4]), match[5]].join('');
  } else {
    newTransform = [oldTransform ? oldTransform + ' ' : '', 'translate(', Math.round(typeof arguments[2] === 'number' ? arguments[2] : 0), ',', Math.round(typeof arguments[3] === 'number' ? arguments[3] : 0), ')'].join('');
  }
  setTimeout(function () {
    // Firefox bug(?). This was not setting without this timeout.
    el.setAttribute('transform', newTransform);
  }, 1);
  el.setAttribute('transform', newTransform);
}

function writeScale(el) {
  var oldTransform = el.getAttribute('transform');
  var newTransform = null;
  var match = oldTransform ? oldTransform.match(regExpScale) : null;
  if (match) {
    newTransform = [match[1], match[2], typeof arguments[2] === 'number' ? arguments[2] : match[3], ',', typeof arguments[3] === 'number' ? arguments[3] : match[4], match[5]].join('');
  } else {
    newTransform = [oldTransform ? oldTransform + ' ' : '', 'scale(', typeof arguments[2] === 'number' ? arguments[2] : 0, ',', typeof arguments[3] === 'number' ? arguments[3] : 0, ')'].join('');
  }
  el.setAttribute('transform', newTransform);
}

function formatDMatch(match) {
  var points = [];
  var pt = [];
  match.forEach(function (m) {
    if (m !== 'M' && m !== 'L') {
      pt.push(+m);
      if (pt.length >= 2) {
        points.push([pt[0], pt[1]]);
        pt = [];
      }
    }
  });
  return points;
}

function getD(el) {
  return el.getAttribute('d') || '';
}

function getTransform(el) {
  return el.getAttribute('transform') || '';
}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(26);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(231)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(57)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.isVerticalType = isVerticalType;
exports.forAxisTicks = forAxisTicks;
exports.forAxisTicksReverse = forAxisTicksReverse;
exports.dashStylesHelper = dashStylesHelper;
exports.roundLineJoinsHelper = roundLineJoinsHelper;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Returns true if the chart type has axes in the style of a column chart.
function isVerticalType(type) {
  return type === 'line' || type === 'column' || type === 'area' || type === 'scatter';
}

// Convenience utility function for looping through the ticks on an axis,
// which is necessary a million times in this module.
function forAxisTicks(axis, callback) {
  for (var i = 0; i < axis.tickPositions.length; i++) {
    var tick = axis.ticks[axis.tickPositions[i]];
    if (callback(tick, axis.tickPositions[i], i) === false) {
      break;
    }
  }
}

// Like forAxisTicks() but runs in reverse (index high to low).
function forAxisTicksReverse(axis, callback) {
  for (var i = axis.tickPositions.length - 1; i >= 0; i--) {
    var tick = axis.ticks[axis.tickPositions[i]];
    if (callback(tick, axis.tickPositions[i], i) === false) {
      break;
    }
  }
}

function dashStylesHelper(path, size) {
  var dashArray = path.getAttribute('stroke-dasharray');
  if (dashArray !== 'none') {
    var _ref = size === 'print-wsj' ? [1.5, 3] : [2.5, 5],
        _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        width = _ref2[0],
        gap = _ref2[1];

    path.setAttribute('stroke-width', width);
    path.setAttribute('stroke-dasharray', '0.1,' + gap);
    path.setAttribute('stroke-linecap', 'round');
  }
}

function roundLineJoinsHelper(path, isVideoGroup) {
  var linejoin = isVideoGroup ? 'round' : 'bevel';
  path.setAttribute('stroke-linejoin', linejoin);
  if (isVideoGroup) {
    path.setAttribute('stroke-linecap', 'round');
  }
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(222);
var global = __webpack_require__(1);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(16);
var TO_STRING_TAG = __webpack_require__(2)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(13);
var TAG = __webpack_require__(2)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _zero = __webpack_require__(31);

var _constants = __webpack_require__(3);

var _dateutils = __webpack_require__(63);

var _quarterly = __webpack_require__(236);

var quarterly = _interopRequireWildcard(_quarterly);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// let DEBUG = false;

/**
 * Converts/parses an array of category strings into objects with date and
 * time properties.
 * TODO: explains @params
 * @returns {datetimeTemplate[]}
 */
function parse(categories, options) {
  var dates = [];
  var timezone = null;
  var category0 = categories[0].toString();
  var isQuarterlyString = !!category0.match(_constants.REGEXP_Q_ONLY);
  categories.forEach(function (category, index) {
    dates[index] = components(category, timezone, options, isQuarterlyString);
    timezone = dates[index].z;
  });

  if (options) {
    dates = options.fiscalYears ? quarterly.makeFiscalYears(dates) : quarterly.removeFiscalYears(dates);
    dates = options.quarterlyResults ? quarterly.makeQuarterly(dates) : quarterly.removeQuarterly(dates);
  }

  dates = quarterly.normalize(dates);
  dates = generateValues(dates);
  dates = removeExtraneousComponents(dates);
  return dates;
}

/**
 * Breaks a single category value into an object with date/time components.
 */
/**
 * Datetime is a module with methods that parse date strings into discrete
 * components (years, months, hours, etc).
 * TODO: Write unit tests.
 */
function components(value, timezone, options, isQuarterlyString) {
  value += '';
  var result = datetimeTemplate();
  componentsDate(value, result, options, isQuarterlyString);
  componentsTime(value, result, timezone);
  if (!result.hour) {
    var newDate = new Date(result.year, result.month, result.date, 0, 0, 0, 0).getTime();
    result.value = newDate;
  }
  return result;
}

/**
 * @private
 * For use with components().
 */
function componentsDate(value, result, options) {
  var isQuarterlyString = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var match = null;
  if (isQuarterlyString) {
    match = value.match(_constants.REGEXP_QUARTER);
    match = match || value.match(_constants.REGEXP_Q_ONLY) || [];
    result.quarter = (0, _dateutils.getQuarter)(match[1]);
    result.half = (0, _dateutils.getHalf)(match[1]);
    result.month = (0, _dateutils.quarterToMonth)(match[1]);
    result.date = (0, _dateutils.quarterToDate)(result.month);
    result.fiscalYear = !!match[2];
    result.year = match[3] ? +match[3] : undefined;
  } else if (match = value.match(_constants.REGEXP_MDY)) {
    writeDateMonth(result, match, options.reverseDateMonth);
    result.year = +(0, _dateutils.fullYear)(match[3]);
  } else if (match = value.match(_constants.REGEXP_MDY_FRED)) {
    result.year = +match[1];
    result.month = Math.max(0, +match[2] - 1);
    result.date = +match[3];
  } else if (match = value.match(_constants.REGEXP_MD)) {
    writeDateMonth(result, match, options.reverseDateMonth);
  } else if (match = value.match(_constants.REGEXP_MY)) {
    result.month = +match[1] - 1;
    result.year = +(0, _dateutils.fullYear)(match[2]);
  } else if (match = value.match(_constants.REGEXP_Y)) {
    result.year = +(0, _dateutils.fullYear)(match[1]);
  }
}

function writeDateMonth(result, match, reverseDateMonth) {
  if (reverseDateMonth) {
    result.month = +match[2] - 1;
    result.date = +match[1];
  } else {
    result.month = +match[1] - 1;
    result.date = +match[2];
  }
}

/**
 * @private
 * For use with components().
 */
function componentsTime(value, result) {
  var timezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var _value$split = value.split(' '),
      _value$split2 = (0, _slicedToArray3.default)(_value$split, 3),
      date = _value$split2[0],
      time = _value$split2[1],
      ampm = _value$split2[2];

  if (!time) return result;

  var _time$split = time.split(':'),
      _time$split2 = (0, _slicedToArray3.default)(_time$split, 3),
      hours = _time$split2[0],
      minutes = _time$split2[1],
      seconds = _time$split2[2];

  if (!minutes) return result;
  result.hour = +hours;
  result.minute = +minutes;
  result.second = +seconds;
  result.a = ampm;
  result.hour %= 12;
  if (result.a === 'p') {
    result.hour += 12;
  }
  // const match = value.match(REGEXP_TIME);
  // if (match) {
  //   // Capture time values.
  //   result.hour = +match[1];
  //   result.minute = +match[2];
  //   result.second = match[3] ? +match[3].substr(1) : undefined;
  //   result.a = match[4] ?
  //     match[4].replace(/^\s+/, '').substr(0, 1).toLowerCase() : undefined;
  //   result.z = match[5] ? match[5].substr(1) : timezone;
  //   // Convert to 24-hour clock.
  //   if (!result.a) {
  //     result.a = (result.hour < 12) ? 'a' : 'p';
  //   }
  //   result.hour %= 12;
  //   if (result.a === 'p') {
  //     result.hour += 12;
  //   }
  // }
  // return result;
}

/**
 * @param {datetimeTemplate[]} dates
 * @param {string} prop
 * @return {boolean} true if all dates have a value for prop.
 */
function allHave(dates, prop) {
  return dates.length !== 0 && !dates.some(function (date) {
    return prop === 'fiscalYear' && !date.fiscalYear || date[prop] === undefined;
  });
}

/**
 * @param {datetimeTemplate[]} dates
 * @returns {boolea} true if all date objects represent valid dates.
 */
function allValidDates(dates) {
  return !dates.some(function (d) {
    return d.second === undefined && d.minute === undefined && d.hour === undefined && d.date === undefined && d.month === undefined && d.year === undefined;
  });
}

/**
 * @param {datetimeTemplate[]} dates
 * @returns {object} with true/false for each date/time property depending
 *   on whether all dates have a value for each property.
 */
function all(dates) {
  var obj = datetimeTemplate();
  Object.keys(obj).forEach(function (key) {
    obj[key] = allHave(dates, key);
  });
  return obj;
}

/**
 * @param {datetimeTemplate[]} dates
 * @returns {boolean} true if all dates have a value for `quarter` or `half`.
 */
function allQuarterly(dates) {
  return dates.every(function (item) {
    return item.quarter || item.half;
  });
}

/**
 * @returns {object} with keys for all the properties useful in the charts
 *   tool, each set to undefined or false.
 */
function datetimeTemplate() {
  return {
    z: undefined,
    a: undefined,
    second: undefined,
    minute: undefined,
    hour: undefined,
    date: undefined,
    month: undefined,
    year: undefined,
    value: undefined,
    fiscalYear: false,
    quarter: undefined,
    half: undefined
  };
}

/**
 * Remove values that repeat for all dates and therefore are superfluous.
 * @private
 * @param {datetimeTemplate[]} dates
 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
 *    unaltered.
 */
function removeExtraneousComponents(dates) {
  var common = all(dates);
  if (common.month && common.date) {
    // && !common.year) {
    dates = removeExtraneous(dates, 'date');
  }
  if (common.month && common.year) {
    dates = removeExtraneousMD(dates);
  }
  if (common.hour && common.minute) {
    dates = removeExtraneous(dates, 'minute');
  }
  if (common.minute && common.second) {
    dates = removeExtraneous(dates, 'seconds');
  }
  return dates;
}

/**
 * Often dates are in the format Jan 1 YYYY, where Jan 1 repeats for *all*
 * rows but the years increment. In this special case, the month and date
 * should be disregarded. Also works if months but no dates are specificed;
 * e.g. 1/2000, 1/2001, etc.
 * @private
 * @param {datetimeTemplate[]} dates
 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
 *    unaltered.
 */
function removeExtraneousMD(dates) {
  var datesCopy = [];
  var month = undefined;
  var date = undefined;
  var year = undefined;
  for (var i = 0; i < dates.length; i++) {
    var d = (0, _lodash2.default)({}, dates[i]);
    if (i === 0) {
      month = d.month;
      date = d.date;
      year = d.year;
    } else if (d.month !== month || d.date !== date) {
      return dates;
    } else if (d.year <= year) {
      return dates;
    }
    year = d.year;
    d.month = d.date = undefined;
    datesCopy[i] = d;
  }
  return datesCopy;
}

/**
 * Removes values (such as seconds, minutes, or dates) when the values are the
 * same for each and every date.
 * @private
 * @param {datetimeTemplate[]} dates
 * @returns {datetimeTemplate[]} Copy of dates if altered; original dates if
 *    unaltered.
 */
function removeExtraneous(dates, prop) {
  var datesCopy = [];
  var propVal = undefined;
  var value = undefined;
  var genericVal = (0, _dateutils.genericTimeValue)(prop);
  for (var i = 0; i < dates.length; i++) {
    var d = (0, _lodash2.default)({}, dates[i]);
    if (i === 0) {
      // Set initial values to compare to.
      propVal = d[prop];
      value = d.value;
    } else if (Math.abs(d.value - value) < genericVal) {
      // Values do not increment.
      return dates;
    } else if (d[prop] !== propVal) {
      // Values are not all the same and therefor not extraneous.
      return dates;
    }
    value = d.value;
    d[prop] = undefined;
    datesCopy[i] = d;
  }
  return datesCopy;
}

/**
 * Sets a value in milliseconds for each datetime object.
 * @private
 * @param {datetimeTemplate[]} dates
 * @returns {datetimeTemplate[]}
 */
function generateValues(dates) {
  dates.forEach(function (date) {
    date.value = getValue(date);
  });
  return dates;
}

/**
 * @private
 * @param {datetimeTemplate}
 * @returns {number} value in milliseconds
 */
function getValue(date) {
  var d = new Date(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0);

  if (isDef(date.year) && isDef(date.month) && isDef(date.date)) {
    d.setUTCFullYear(date.year, date.month, date.date);
  } else if (isDef(date.year) && isDef(date.month)) {
    d.setUTCFullYear(date.year, date.month);
  } else if (isDef(date.year)) {
    d.setUTCFullYear(date.year, 0);
  } else if (isDef(date.month) && isDef(date.date)) {
    d.setUTCMonth(date.month, date.date);
  } else if (isDef(date.month)) {
    d.setUTCMonth(date.month);
  } else if (isDef(date.date)) {
    d.setUTCDate(date.date);
  }

  if (isDef(date.hour) && isDef(date.minute) && isDef(date.second)) {
    d.setUTCHours(date.hour, date.minute, date.second);
  } else if (isDef(date.hour) && isDef(date.minute)) {
    d.setUTCHours(date.hour, date.minute);
  } else if (isDef(date.hour)) {
    d.setUTCHours(date.hour);
  } else if (isDef(date.minute) && isDef(date.second)) {
    d.setUTCMinutes(date.minute, date.second);
  } else if (isDef(date.minute)) {
    d.setUTCMinutes(date.minute);
  } else if (isDef(date.second)) {
    d.setUTCSeconds(date.second);
  } else {
    d.setUTCHours(0, 0, 0);
  }

  return d.valueOf();
}

function isDef(value) {
  return value !== undefined;
}

/**
 * @private
 * @param {datetimeTemplate[]} dates
 * @returns {datetimeTemplate[]} dates sorted by value
 */
// function sortDates(dates) {
//   return dates.sort((a, b) => {
//     if (a.value === undefined || b.value === undefined) {
//       return 0;
//     }
//     return a.value - b.value;
//   });
// }


// Not used in this module but is used by the app/client.
// @returns {boolean} true is @param str is a quartlery date value.
function isQuarterlyString(str) {
  return _constants.REGEXP_Q_ONLY.test(str);
}

exports.default = {
  parse: parse,
  components: components,
  allHave: allHave,
  all: all,
  allQuarterly: allQuarterly,
  stripZeroes: _zero.stripZeroes,
  addZeroes: _zero.addZeroes,
  allValidDates: allValidDates,
  datetimeTemplate: datetimeTemplate,
  isQuarterlyString: isQuarterlyString
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripZeroes = stripZeroes;
exports.addZeroes = addZeroes;
// Utility to transform '002' to '2'.
function stripZeroes(value) {
  value += '';
  while (value[0] === '0') {
    value = value.substr(1);
  }
  return value;
}

// Utility to transform '2' to '002'.
function addZeroes(value, len) {
  value += '';
  while (value.length > len) {
    if (value.charAt(0) === '0') {
      value = value.substr(1);
    } else {
      break;
    }
  }
  while (value.length < len) {
    value = '0' + value;
  }
  return value;
}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderInvalidatedColors = renderInvalidatedColors;
// TODO: Check if this can be re-enabled with newer version of Highcharts.
function renderInvalidatedColors(rendered, invalidated) {
  // This is no longer applied because of issues with hover states not being
  // updated. Instead, on color change, entire chart is re-rendered.
  if (false) {
    // const colors = (function (invalidated) {
    //   return invalidated.filter(item => {
    //     return item.indexOf('chart/colors') === 0;
    //   });
    // })(invalidated);
    //
    // const updatePointColor = function (dataPoint, color) {
    //   const el = (dataPoint && dataPoint.graphic) ? dataPoint.graphic.element : null;
    //   if (el) {
    //     el.setAttribute('fill', color);
    //   }
    // };
    //
    // const updateLegendColor = function (render, index, color) {
    //   const items = render.container.querySelectorAll('.highcharts-legend-item');
    //   if (items && items.length) {
    //     const text = items[index].querySelector('text');
    //     text.style.color = text.style.fill = color;
    //   }
    // }
    //
    // if (colors.length) {
    //   colors.forEach(item => {
    //     const bits = item.split('/');
    //     const series = +bits[2];
    //     const point = bits[3];
    //     const color = bits[4];
    //     const chartSeries = rendered.inner.series[series];
    //     let dataPoint = null;
    //     let el = null;
    //
    //     if (chartSeries) {
    //       // if (point.indexOf('#') === 0) {
    //         // updateLegendColor(rendered.inner, series, point);
    //         // Color for entire series.
    //         // chartSeries.color = point;
    //         // Setting render to true re-renders *everything* while false makes
    //         // the lines and legend vanish (if it supposedly does not re-render,
    //         // then like wtf?).
    //         // chartSeries.update({ color: point }, true);
    //
    //       if (chartSeries.graph) {
    //         // Line charts.
    //         chartSeries.graph.element.setAttribute('stroke', color);
    //       } else {
    //         // Bar, column, pie charts.
    //         if (point === '*') {
    //           chartSeries.data.forEach(dataPoint => {
    //             updatePointColor(dataPoint, color);
    //           });
    //         } else {
    //           //originalIndex
    //           let ptIndex = +point;
    //           if (rendered.inner.options.chart.type === 'pie') {
    //             // Find the correct index if the data has been optimized.
    //             for (let i = 0; i < chartSeries.data.length; i++) {
    //               if (!chartSeries.data[i].hasOwnProperty('originalIndex')) {
    //                 break;
    //               }
    //               if (chartSeries.data[i].originalIndex === ptIndex) {
    //                 ptIndex = i;
    //                 break;
    //               }
    //             }
    //           }
    //           dataPoint = chartSeries ? chartSeries.data[ptIndex] : null;
    //           updatePointColor(dataPoint, color);
    //         }
    //       }
    //     }
    //   });
    // }
  }
}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(1).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(61);
var enumBugKeys = __webpack_require__(43);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(40);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(42)('keys');
var uid = __webpack_require__(28);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(5);
var global = __webpack_require__(1);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(20) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(35);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(19);
var TAG = __webpack_require__(2)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(45);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(5).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seriesDefaults = exports.dataDefaults = exports.TIMETYPES = exports.FREQUENCY = exports.RANGE = exports.MORE_TICKERS = undefined;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MORE_TICKERS = exports.MORE_TICKERS = {
  'Oil Futures': [{ name: 'Crude Oil', symbol: 'Crude%20Oil%20-%20Electronic' }, { name: 'Brent Crude', symbol: 'BRENT%20CRUDE' }],
  Currencies: [{ name: 'USD/EUR', symbol: 'USDEUR' }, { name: 'USDJPY', symbol: 'USDJPY' }, { name: 'WSJ DollarIdx', symbol: 'XX:BUXX' }],
  Bonds: [{ name: '10 Year Yield', symbol: 'BX:TMUBMUSD10Y' }],
  'Foreign Indexes': [{ name: 'Stoxx Europe 600', symbol: 'XX:SXXP' }, { name: 'Nikkei IDX', symbol: 'JP:NIK' }, { name: 'HANG SENG INDEX', symbol: 'HK:HSI' }, { name: 'Shanghai Comp', symbol: 'CN:SHCOMP' }, { name: 'Shenzhen', symbol: 'CN:399106' }]
};

var RANGE = exports.RANGE = {
  '1D': { value: 'D1', start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '2D': { value: 'D2', start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '3D': { value: 'D3', start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '4D': { value: 'D4', start: 'PT1M', end: 'PT1H', default: 'PT10M' },
  '5D': { value: 'D5', start: 'PT1M', end: 'P1D', default: 'PT10M' },
  '10D': { value: 'D10', start: 'PT1M', end: 'P1D', default: 'PT15M' },
  '1M': { value: 'P29D', start: 'P1D', end: 'P7D', default: 'P1D' },
  '3M': { value: 'P3M', start: 'P1D', end: 'P1M', default: 'P1D' },
  '6M': { value: 'P6M', start: 'P1D', end: 'P3M', default: 'P1D' },
  'YTD': { value: 'YTD', start: 'P1D', end: 'P1M', default: 'P1D' },
  '1Y': { value: 'P1Y', start: 'P1D', end: 'P3M', default: 'P1D' },
  '2Y': { value: 'P2Y', start: 'P1D', end: 'P1Y', default: 'P7D' },
  '3Y': { value: 'P3Y', start: 'P1D', end: 'P1Y', default: 'P7D' },
  '5Y': { value: 'P5Y', start: 'P1D', end: 'P1Y', default: 'P1M' },
  '10Y': { value: 'P10Y', start: 'P1D', end: 'P1Y', default: 'P3M' },
  'All': { value: 'all', start: 'P1D', end: 'P1Y', default: 'P3M' },
  'Custom': { value: 'custom' }
};

var FREQUENCY = exports.FREQUENCY = [{ value: 'PT1M', text: '1 min' }, { value: 'PT5M', text: '5 min' }, { value: 'PT10M', text: '10 min' }, { value: 'PT15M', text: '15 min' }, { value: 'PT1H', text: 'Hourly' }, { value: 'P1D', text: 'Daily' }, { value: 'P7D', text: 'Weekly' }, { value: 'P1M', text: 'Monthly' }, { value: 'P3M', text: 'Quarterly' }, { value: 'P1Y', text: 'Yearly' }];

var D = 1000 * 60 * 60 * 24;
var M = D * 30;
var Y = D * 365;

var TIMETYPES = exports.TIMETYPES = { D: D, M: M, Y: Y };

var dataDefaults = exports.dataDefaults = {
  markdown: '{series}',
  showInLegend: true,
  line: 'solid'
};

var seriesDefaults = exports.seriesDefaults = {
  firstRowAsNames: false,
  firstColumnAsCategories: false,
  categoriesAreDates: true
};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkArticle = checkArticle;
/**
 * Functions and vars shared between axes-prerender and axes-postrender.
 */
var YEAR_MILLISECONDS = exports.YEAR_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;

function checkArticle(id, product) {
  switch (product) {
    case 'wsj':
      return id.slice(-1) === 'u' || id === 'preview' || id.toLowerCase().includes('video');
    case 'barrons':
      return id.slice(-1) === 'u' || id.includes('inset');
    case 'financialnews':
      return id.slice(-1) === 'u' || id.includes('inset') || id === 'preview';
    case 'marketwatch':
    case 'mansionglobal':
      return id.includes('inset');
    default:
      return true;
  }
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = processSeries;
exports.checkForceLegendTop = checkForceLegendTop;
exports.convertToRGBA = convertToRGBA;
exports.truncateData = truncateData;

var _constants = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes and build the chart series data.
 */

function processSeries(options) {
  // Prepare series for Highcharts.
  options.originalSeries = options.series.map(function (currentSeries) {
    return currentSeries.data.map(function (data) {
      return Object.assign({}, data);
    });
  });
  var liveMarketData = options.liveMarketData;

  var data = options.series.map(function (item) {
    var name = item.name,
        symbol = item.symbol,
        decimals = item.decimals,
        prefix = item.prefix,
        suffix = item.suffix,
        markdown = item.markdown,
        showInLegend = item.showInLegend,
        tickerType = item.tickerType;

    var series = {
      zoneAxis: options.type === 'line' ? 'x' : 'y',
      zones: getZones(options, item.data, item.color),
      zIndex: getZIndex(liveMarketData, tickerType),
      data: item.data,
      name: name,
      symbol: symbol,
      decimals: decimals,
      prefix: prefix,
      suffix: suffix,
      step: options.step ? 'left' : null,
      markdown: markdown,
      showInLegend: showInLegend,
      animation: false,
      color: item.color || options.defaults.colors[0],
      fillColor: options.type === 'area' && item.color === 'rgba(0, 0, 0, 0)' ? 'rgba(0,0,0,0)' : null,
      dashStyle: options.step || item.dashStyle !== 'dotted' ? 'solid' : 'dot',
      negativeColor: options.colorMode === 'THRESHOLD' && (options.type === 'column' || options.type === 'bar') ? item.negativeColor || options.defaults.colors[1] : null,
      events: {
        legendItemClick: function legendItemClick() {
          return false;
        }
      },
      turboThreshold: 0,
      states: {
        hover: {
          enabled: options.type === 'line'
        },
        inactive: {
          enabled: false
        }
      }
    };
    return series;
  });
  if (options.categoriesAreMonthly && options.type === 'column') {
    startOfMonth(data);
  }
  // Customize the data for the particular chart type.
  switch (options.type) {
    case 'pie':
      data = data.slice(0, 1);
      break;
    case 'bar':
      // Save data to do this later, when options.styles.lineHeight is known.
      // return truncateData(options, data);
      options.series = data; //sortData(data, options);
      return options;
    case 'column':
      var forceLegendTop = checkForceLegendTop(options);
      var rightLegend = options.legend.layout === 'right' || options.legend.layout === 'default' && !forceLegendTop;
      var reverseLegend = needsReverseLegend(rightLegend, data);
      data = options.stacking ? reverseDataOrder(data, reverseLegend) : data;
      break;
    case 'line':
      data = handleLineData(data, options);
      break;
  }

  options.series = data; //sortData(data, options);
  for (var i = 0; i < options.series.length; i++) {
    var seriesData = options.series[i].data;
    for (var z = 0; z < seriesData.length; z++) {
      seriesData[z].index = z;
    }
  }
  return options;
}

function checkForceLegendTop(options) {
  return options.id === 'video' || options.id === 'twitterVideo' || options.legend.layout === 'default' && (options.print && options.width <= _constants.MAX_NARROW_WIDTH_PRINT || !options.print && options.width <= _constants.MAX_4U_WIDTH);
}

function convertToRGBA(color) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  var rgb = '';
  for (var i = 1; i <= 5; i += 2) {
    rgb += parseInt(color.slice(i, i + 2), 16) + ',';
  }
  var percent = opacity / 100;
  return 'rgba(' + rgb + percent + ')';
}

function needsReverseLegend(rightLegend, data) {
  var lastSeriesFirstValue = data[data.length - 1].data[0].y;
  var isNegative = lastSeriesFirstValue < 0;
  return rightLegend && !isNegative;
}

function getZIndex(liveMarketData, tickerType) {
  if (liveMarketData) {
    return tickerType === 'Index' ? 1 : 2;
  }
}

function getZones(options, data, seriesColor) {
  if (options.type === 'line' && options.connectEmptyDataPoints === 'dotted') {
    var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
    var hasData = data[0].y !== null;
    return data.map(function (point, index) {
      if (hasData && point.y === null || !hasData && point.y !== null) {
        var _ref = hasData ? [1, 'solid', seriesColor] : noDataOptions(isVideoGroup, seriesColor),
            _ref2 = (0, _slicedToArray3.default)(_ref, 3),
            offset = _ref2[0],
            dashStyle = _ref2[1],
            color = _ref2[2];

        var value = data[index - offset].x;
        hasData = !hasData;
        return { value: value, dashStyle: dashStyle, color: color };
      }
    }).filter(function (zone) {
      return zone;
    });
  }
}

function noDataOptions(isVideoGroup, seriesColor) {
  var attrs = isVideoGroup ? ['solid', convertToRGBA(seriesColor, 50)] : ['dot', seriesColor];
  return [0].concat(attrs);
}

// For line charts, first column should be top layer. This also reverses the
// legend items, so that must be fixed separately.
function reverseDataOrder(data) {
  var reverseLegend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var dataLen = data.length;
  data.forEach(function (item, index) {
    item.index = dataLen - index - 1;
    item.legendIndex = reverseLegend ? dataLen - index - 1 : index;
  });
  return data;
}

function handleLineData(data, options) {
  reverseDataOrder(data);
  if (options.legend.itemsInOrder === undefined) {
    //sets default for 'market' charts
    //keeps old econ charts as they were
    if (options.tickers.length) options.legend.itemsInOrder = true;
    //everything else
    else options.legend.itemsInOrder = false;
  }
  //if legend is right aligned, always order items by final value, if itemsInOrder toggled on, switch order for 'top' aligned items
  if (options.legend.layout === 'default' && !checkForceLegendTop(options) || options.legend.layout === 'right') {
    setLengendItemsOrder(data);
  } else if (options.legend.itemsInOrder && (checkForceLegendTop(options) || options.legend.layout === 'top')) {
    setLengendItemsOrder(data);
  }
  return data;
}

function setLengendItemsOrder(series) {
  //array sorted by lastValue of each series in descending order [{seriesIdx, lastValue}]
  var sortedArr = series.reduce(function (accum, s, idx) {
    //noticed that sometimes last value comes as null
    for (var i = 1; i < s.data.length; i++) {
      if (s.data[s.data.length - i].y !== null && s.data[s.data.length - i].y) {
        accum.push({ seriesIdx: idx, lastValue: s.data[s.data.length - i].y });
        break;
      }
    }
    return accum;
  }, []).sort(function (a, b) {
    return b.lastValue - a.lastValue;
  });
  //updates order of legend items
  sortedArr.forEach(function (s, i) {
    series[s.seriesIdx].legendIndex = i;
  });
}

function startOfMonth(data) {
  // for column charts with one date per month, shift x value to first of month
  data.forEach(function (series) {
    series.data.forEach(function (position) {
      var date = new Date(position.x);
      date.setUTCDate(1);
      position.x = date.valueOf();
    });
  });
}

// For horizontal bar charts, removes data to improve visual appearance.
function truncateData(options, data) {
  // Guestimate the maximum data rows that will fit.
  var maxRows = Math.floor(options.height / (parseFloat(options.styles.lineHeight.large) * 1.5));
  // Remove data so rows does not exceed maxRows.
  var overflow = Math.ceil(data[0].data.length / maxRows);
  var originalCategories = options.categories ? options.categories.slice() : null;
  var categories = [];
  if (overflow > 1) {
    data.forEach(function (item, index) {
      var items = [];
      var n = 0;
      while (n < item.data.length) {
        if (index === 0 && options.categories) {
          categories.push(originalCategories[n]);
          options.categories = categories;
        }
        items.push(item.data[n]);
        n += overflow;
      }
      item.data = items;
    });
  }
  options.series = data;
  return options;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(2);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(5);
var LIBRARY = __webpack_require__(20);
var wksExt = __webpack_require__(51);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.arrowWidth = arrowWidth;
exports.findOffset = findOffset;
exports.getHeight = getHeight;
function preRender(data, options) {
  var refX = findOffset(options);
  var width = arrowWidth(options.print);
  var midpoint = width / 2;
  var height = getHeight(width, midpoint);
  data.defs.marker0 = {
    tagName: 'marker',
    id: 'custom-arrow',
    refY: midpoint,
    refX: refX,
    children: [{
      tagName: 'path',
      d: 'M 0 0 L ' + height + ' ' + midpoint + ' L 0 ' + width + ' Z'
    }]
  };
}

function arrowWidth(print) {
  return print ? 3.5 : 6.5;
}

function findOffset(options) {
  var print = options.print,
      product = options.product;

  var printOffset = print ? 4.25 : 8.5;
  var productOffset = product === 'wsj' ? 4 : 0;
  return printOffset + productOffset;
}

function getHeight(width, midpoint) {
  return Math.sqrt(width * width - midpoint * midpoint);
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(26);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v8.1.0 (2020-05-05)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(X,Q){"object"===typeof module&&module.exports?(Q["default"]=Q,module.exports=X.document?Q(X):Q): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Q(X)}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(X.Highcharts&&X.Highcharts.error(16,!0),X.Highcharts=Q(X))})("undefined"!==typeof window?window:this,function(X){function Q(d,f,E,q){d.hasOwnProperty(f)||(d[f]=q.apply(null,E))}var A={};Q(A,"parts/Globals.js",[],function(){var d="undefined"!==typeof X?X:"undefined"!==typeof window?window:{},f=d.document,
E=d.navigator&&d.navigator.userAgent||"",q=f&&f.createElementNS&&!!f.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,M=/(edge|msie|trident)/i.test(E)&&!d.opera,K=-1!==E.indexOf("Firefox"),J=-1!==E.indexOf("Chrome"),L=K&&4>parseInt(E.split("Firefox/")[1],10);return{product:"Highcharts",version:"8.1.0",deg2rad:2*Math.PI/360,doc:f,hasBidiBug:L,hasTouch:!!d.TouchEvent,isMS:M,isWebKit:-1!==E.indexOf("AppleWebKit"),isFirefox:K,isChrome:J,isSafari:!J&&-1!==E.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(E),
SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:q,win:d,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});Q(A,"parts/Utilities.js",[A["parts/Globals.js"]],function(d){function f(){var a,c=arguments,k={},r=function(a,c){"object"!==typeof a&&(a={});Z(c,function(k,e){!E(k,!0)||t(k)||n(k)?a[e]=c[e]:a[e]=r(a[e]||{},k)});return a};!0===c[0]&&(k=c[1],c=Array.prototype.slice.call(c,2));var e=c.length;for(a=0;a<
e;a++)k=r(k,c[a]);return k}function E(a,c){return!!a&&"object"===typeof a&&(!c||!w(a))}function q(a,c,k){var r;D(c)?b(k)?a.setAttribute(c,k):a&&a.getAttribute&&((r=a.getAttribute(c))||"class"!==c||(r=a.getAttribute(c+"Name"))):Z(c,function(c,k){a.setAttribute(k,c)});return r}function M(){for(var a=arguments,c=a.length,k=0;k<c;k++){var r=a[k];if("undefined"!==typeof r&&null!==r)return r}}function K(a,c){if(!a)return c;var k=a.split(".").reverse();if(1===k.length)return c[a];for(a=k.pop();"undefined"!==
typeof a&&"undefined"!==typeof c&&null!==c;)c=c[a],a=k.pop();return c}d.timers=[];var J=d.charts,L=d.doc,x=d.win,F=d.error=function(a,c,k,r){var e=N(a),z=e?"Highcharts error #"+a+": www.highcharts.com/errors/"+a+"/":a.toString(),b=function(){if(c)throw Error(z);x.console&&console.log(z)};if("undefined"!==typeof r){var g="";e&&(z+="?");Z(r,function(a,c){g+="\n"+c+": "+a;e&&(z+=encodeURI(c)+"="+encodeURI(a))});z+=g}k?ba(k,"displayError",{code:a,message:z,params:r},b):b()},H=function(){function a(a,
c,k){this.options=c;this.elem=a;this.prop=k}a.prototype.dSetter=function(){var a=this.paths,c=a&&a[0];a=a&&a[1];var k=[],r=this.now||0;if(1!==r&&c&&a)if(c.length===a.length&&1>r)for(var e=0;e<a.length;e++){for(var z=c[e],b=a[e],g=[],l=0;l<b.length;l++){var h=z[l],P=b[l];g[l]="number"===typeof h&&"number"===typeof P&&("A"!==b[0]||4!==l&&5!==l)?h+r*(P-h):P}k.push(g)}else k=a;else k=this.toD||[];this.elem.attr("d",k,void 0,!0)};a.prototype.update=function(){var a=this.elem,c=this.prop,k=this.now,r=this.options.step;
if(this[c+"Setter"])this[c+"Setter"]();else a.attr?a.element&&a.attr(c,k,null,!0):a.style[c]=k+this.unit;r&&r.call(a,k,this)};a.prototype.run=function(a,c,k){var r=this,e=r.options,z=function(a){return z.stopped?!1:r.step(a)},b=x.requestAnimationFrame||function(a){setTimeout(a,13)},l=function(){for(var a=0;a<d.timers.length;a++)d.timers[a]()||d.timers.splice(a--,1);d.timers.length&&b(l)};a!==c||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=a,this.end=c,this.unit=k,this.now=
this.start,this.pos=0,z.elem=this.elem,z.prop=this.prop,z()&&1===d.timers.push(z)&&b(l)):(delete e.curAnim[this.prop],e.complete&&0===Object.keys(e.curAnim).length&&e.complete.call(this.elem))};a.prototype.step=function(a){var c=+new Date,k=this.options,r=this.elem,e=k.complete,z=k.duration,b=k.curAnim;if(r.attr&&!r.element)a=!1;else if(a||c>=z+this.startTime){this.now=this.end;this.pos=1;this.update();var l=b[this.prop]=!0;Z(b,function(a){!0!==a&&(l=!1)});l&&e&&e.call(r);a=!1}else this.pos=k.easing((c-
this.startTime)/z),this.now=this.start+(this.end-this.start)*this.pos,this.update(),a=!0;return a};a.prototype.initPath=function(a,c,k){function r(a,c){for(;a.length<p;){var k=a[0],r=c[p-a.length];r&&"M"===k[0]&&(a[0]="C"===r[0]?["C",k[1],k[2],k[1],k[2],k[1],k[2]]:["L",k[1],k[2]]);a.unshift(k);l&&a.push(a[a.length-1])}}function e(a,c){for(;a.length<p;)if(c=a[a.length/g-1].slice(),"C"===c[0]&&(c[1]=c[5],c[2]=c[6]),l){var k=a[a.length/g].slice();a.splice(a.length/2,0,c,k)}else a.push(c)}var z=a.startX,
b=a.endX;c=c&&c.slice();k=k.slice();var l=a.isArea,g=l?2:1;if(!c)return[k,k];if(z&&b){for(a=0;a<z.length;a++)if(z[a]===b[0]){var h=a;break}else if(z[0]===b[b.length-z.length+a]){h=a;var P=!0;break}else if(z[z.length-1]===b[b.length-z.length+a]){h=z.length-a;break}"undefined"===typeof h&&(c=[])}if(c.length&&N(h)){var p=k.length+h*g;P?(r(c,k),e(k,c)):(r(k,c),e(c,k))}return[c,k]};a.prototype.fillSetter=function(){a.prototype.strokeSetter.apply(this,arguments)};a.prototype.strokeSetter=function(){this.elem.attr(this.prop,
d.color(this.start).tweenTo(d.color(this.end),this.pos),null,!0)};return a}();d.Fx=H;d.merge=f;var C=d.pInt=function(a,c){return parseInt(a,c||10)},D=d.isString=function(a){return"string"===typeof a},w=d.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};d.isObject=E;var n=d.isDOMElement=function(a){return E(a)&&"number"===typeof a.nodeType},t=d.isClass=function(a){var c=a&&a.constructor;return!(!E(a,!0)||n(a)||!c||!c.name||"Object"===
c.name)},N=d.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a},m=d.erase=function(a,c){for(var k=a.length;k--;)if(a[k]===c){a.splice(k,1);break}},b=d.defined=function(a){return"undefined"!==typeof a&&null!==a};d.attr=q;var g=d.splat=function(a){return w(a)?a:[a]},v=d.syncTimeout=function(a,c,k){if(0<c)return setTimeout(a,c,k);a.call(0,k);return-1},h=d.clearTimeout=function(a){b(a)&&clearTimeout(a)},e=d.extend=function(a,c){var k;a||(a={});for(k in c)a[k]=c[k];return a};
d.pick=M;var p=d.css=function(a,c){d.isMS&&!d.svg&&c&&"undefined"!==typeof c.opacity&&(c.filter="alpha(opacity="+100*c.opacity+")");e(a.style,c)},l=d.createElement=function(a,c,k,r,z){a=L.createElement(a);c&&e(a,c);z&&p(a,{padding:"0",border:"none",margin:"0"});k&&p(a,k);r&&r.appendChild(a);return a},I=d.extendClass=function(a,c){var k=function(){};k.prototype=new a;e(k.prototype,c);return k},u=d.pad=function(a,c,k){return Array((c||2)+1-String(a).replace("-","").length).join(k||"0")+a},y=d.relativeLength=
function(a,c,k){return/%$/.test(a)?c*parseFloat(a)/100+(k||0):parseFloat(a)},G=d.wrap=function(a,c,k){var r=a[c];a[c]=function(){var a=Array.prototype.slice.call(arguments),c=arguments,e=this;e.proceed=function(){r.apply(e,arguments.length?arguments:c)};a.unshift(r);a=k.apply(this,a);e.proceed=null;return a}},S=d.format=function(a,c,k){var r="{",e=!1,z=[],b=/f$/,l=/\.([0-9])/,g=d.defaultOptions.lang,h=k&&k.time||d.time;for(k=k&&k.numberFormatter||T;a;){var P=a.indexOf(r);if(-1===P)break;var p=a.slice(0,
P);if(e){p=p.split(":");r=K(p.shift()||"",c);if(p.length&&"number"===typeof r)if(p=p.join(":"),b.test(p)){var u=parseInt((p.match(l)||["","-1"])[1],10);null!==r&&(r=k(r,u,g.decimalPoint,-1<p.indexOf(",")?g.thousandsSep:""))}else r=h.dateFormat(p,r);z.push(r)}else z.push(p);a=a.slice(P+1);r=(e=!e)?"}":"{"}z.push(a);return z.join("")},R=d.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))},B=d.normalizeTickInterval=function(a,c,k,r,e){var z=a;k=M(k,1);var b=a/k;c||(c=e?[1,
1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===r&&(1===k?c=c.filter(function(a){return 0===a%1}):.1>=k&&(c=[1/k])));for(r=0;r<c.length&&!(z=c[r],e&&z*k>=a||!e&&b<=(c[r]+(c[r+1]||c[r]))/2);r++);return z=P(z*k,-Math.round(Math.log(.001)/Math.LN10))},c=d.stableSort=function(a,c){var k=a.length,r,e;for(e=0;e<k;e++)a[e].safeI=e;a.sort(function(a,k){r=c(a,k);return 0===r?a.safeI-k.safeI:r});for(e=0;e<k;e++)delete a[e].safeI},a=d.arrayMin=function(a){for(var c=a.length,k=a[0];c--;)a[c]<k&&(k=a[c]);return k},
k=d.arrayMax=function(a){for(var c=a.length,k=a[0];c--;)a[c]>k&&(k=a[c]);return k},r=d.destroyObjectProperties=function(a,c){Z(a,function(k,r){k&&k!==c&&k.destroy&&k.destroy();delete a[r]})},z=d.discardElement=function(a){var c=d.garbageBin;c||(c=l("div"));a&&c.appendChild(a);c.innerHTML=""},P=d.correctFloat=function(a,c){return parseFloat(a.toPrecision(c||14))},U=d.setAnimation=function(a,c){c.renderer.globalAnimation=M(a,c.options.chart.animation,!0)},W=d.animObject=function(a){return E(a)?f(a):
{duration:a?500:0}},Y=d.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5},T=d.numberFormat=function(a,c,k,r){a=+a||0;c=+c;var e=d.defaultOptions.lang,z=(a.toString().split(".")[1]||"").split("e")[0].length,b=a.toString().split("e");if(-1===c)c=Math.min(z,20);else if(!N(c))c=2;else if(c&&b[1]&&0>b[1]){var l=c+ +b[1];0<=l?(b[0]=(+b[0]).toExponential(l).split("e")[0],c=l):(b[0]=b[0].split(".")[0]||0,a=20>c?(b[0]*Math.pow(10,b[1])).toFixed(c):
0,b[1]=0)}var g=(Math.abs(b[1]?b[0]:a)+Math.pow(10,-Math.max(c,z)-1)).toFixed(c);z=String(C(g));l=3<z.length?z.length%3:0;k=M(k,e.decimalPoint);r=M(r,e.thousandsSep);a=(0>a?"-":"")+(l?z.substr(0,l)+r:"");a+=z.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+r);c&&(a+=k+g.slice(-c));b[1]&&0!==+a&&(a+="e"+b[1]);return a};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};var ca=d.getStyle=function(a,c,k){if("width"===c)return c=Math.min(a.offsetWidth,a.scrollWidth),k=a.getBoundingClientRect&&
a.getBoundingClientRect().width,k<c&&k>=c-1&&(c=Math.floor(k)),Math.max(0,c-d.getStyle(a,"padding-left")-d.getStyle(a,"padding-right"));if("height"===c)return Math.max(0,Math.min(a.offsetHeight,a.scrollHeight)-d.getStyle(a,"padding-top")-d.getStyle(a,"padding-bottom"));x.getComputedStyle||F(27,!0);if(a=x.getComputedStyle(a,void 0))a=a.getPropertyValue(c),M(k,"opacity"!==c)&&(a=C(a));return a},aa=d.inArray=function(a,c,k){return c.indexOf(a,k)},O=d.find=Array.prototype.find?function(a,c){return a.find(c)}:
function(a,c){var k,r=a.length;for(k=0;k<r;k++)if(c(a[k],k))return a[k]};d.keys=Object.keys;var V=d.offset=function(a){var c=L.documentElement;a=a.parentElement||a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(x.pageYOffset||c.scrollTop)-(c.clientTop||0),left:a.left+(x.pageXOffset||c.scrollLeft)-(c.clientLeft||0)}},da=d.stop=function(a,c){for(var k=d.timers.length;k--;)d.timers[k].elem!==a||c&&c!==d.timers[k].prop||(d.timers[k].stopped=!0)},Z=d.objectEach=function(a,c,k){for(var r in a)Object.hasOwnProperty.call(a,
r)&&c.call(k||a[r],a[r],r,a)};Z({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(a,c){d[c]=function(c){return Array.prototype[a].apply(c,[].slice.call(arguments,1))}});var ha=d.addEvent=function(a,c,k,r){void 0===r&&(r={});var e=a.addEventListener||d.addEventListenerPolyfill;var z="function"===typeof a&&a.prototype?a.prototype.protoEvents=a.prototype.protoEvents||{}:a.hcEvents=a.hcEvents||{};d.Point&&a instanceof d.Point&&a.series&&a.series.chart&&(a.series.chart.runTrackerClick=
!0);e&&e.call(a,c,k,!1);z[c]||(z[c]=[]);z[c].push({fn:k,order:"number"===typeof r.order?r.order:Infinity});z[c].sort(function(a,c){return a.order-c.order});return function(){ea(a,c,k)}},ea=d.removeEvent=function(a,c,k){function r(c,k){var r=a.removeEventListener||d.removeEventListenerPolyfill;r&&r.call(a,c,k,!1)}function e(k){var e;if(a.nodeName){if(c){var z={};z[c]=!0}else z=k;Z(z,function(a,c){if(k[c])for(e=k[c].length;e--;)r(c,k[c][e].fn)})}}var z;["protoEvents","hcEvents"].forEach(function(b,
l){var g=(l=l?a:a.prototype)&&l[b];g&&(c?(z=g[c]||[],k?(g[c]=z.filter(function(a){return k!==a.fn}),r(c,k)):(e(g),g[c]=[])):(e(g),l[b]={}))})},ba=d.fireEvent=function(a,c,k,r){var z;k=k||{};if(L.createEvent&&(a.dispatchEvent||a.fireEvent)){var b=L.createEvent("Events");b.initEvent(c,!0,!0);e(b,k);a.dispatchEvent?a.dispatchEvent(b):a.fireEvent(c,b)}else k.target||e(k,{preventDefault:function(){k.defaultPrevented=!0},target:a,type:c}),function(c,r){void 0===c&&(c=[]);void 0===r&&(r=[]);var e=0,b=0,
l=c.length+r.length;for(z=0;z<l;z++)!1===(c[e]?r[b]?c[e].order<=r[b].order?c[e++]:r[b++]:c[e++]:r[b++]).fn.call(a,k)&&k.preventDefault()}(a.protoEvents&&a.protoEvents[c],a.hcEvents&&a.hcEvents[c]);r&&!k.defaultPrevented&&r.call(a,k)},A=d.animate=function(a,c,k){var r,e="",z,b;if(!E(k)){var l=arguments;k={duration:l[2],easing:l[3],complete:l[4]}}N(k.duration)||(k.duration=400);k.easing="function"===typeof k.easing?k.easing:Math[k.easing]||Math.easeInOutSine;k.curAnim=f(c);Z(c,function(l,g){da(a,g);
b=new H(a,k,g);z=null;"d"===g&&w(c.d)?(b.paths=b.initPath(a,a.pathArray,c.d),b.toD=c.d,r=0,z=1):a.attr?r=a.attr(g):(r=parseFloat(ca(a,g))||0,"opacity"!==g&&(e="px"));z||(z=l);z&&z.match&&z.match("px")&&(z=z.replace(/px/g,""));b.run(r,z,e)})},ia=d.seriesType=function(a,c,k,r,e){var z=d.getOptions(),b=d.seriesTypes;z.plotOptions[a]=f(z.plotOptions[c],k);b[a]=I(b[c]||function(){},r);b[a].prototype.type=a;e&&(b[a].prototype.pointClass=I(d.Point,e));return b[a]},fa=d.uniqueKey=function(){var a=Math.random().toString(36).substring(2,
9),c=0;return function(){return"highcharts-"+a+"-"+c++}}(),ja=d.isFunction=function(a){return"function"===typeof a};x.jQuery&&(x.jQuery.fn.highcharts=function(){var a=[].slice.call(arguments);if(this[0])return a[0]?(new (d[D(a[0])?a.shift():"Chart"])(this[0],a[0],a[1]),this):J[q(this[0],"data-highcharts-chart")]});return{Fx:d.Fx,addEvent:ha,animate:A,animObject:W,arrayMax:k,arrayMin:a,attr:q,clamp:function(a,c,k){return a>c?a<k?a:k:c},clearTimeout:h,correctFloat:P,createElement:l,css:p,defined:b,
destroyObjectProperties:r,discardElement:z,erase:m,error:F,extend:e,extendClass:I,find:O,fireEvent:ba,format:S,getMagnitude:R,getNestedProperty:K,getStyle:ca,inArray:aa,isArray:w,isClass:t,isDOMElement:n,isFunction:ja,isNumber:N,isObject:E,isString:D,merge:f,normalizeTickInterval:B,numberFormat:T,objectEach:Z,offset:V,pad:u,pick:M,pInt:C,relativeLength:y,removeEvent:ea,seriesType:ia,setAnimation:U,splat:g,stableSort:c,stop:da,syncTimeout:v,timeUnits:Y,uniqueKey:fa,wrap:G}});Q(A,"parts/Color.js",[A["parts/Globals.js"],
A["parts/Utilities.js"]],function(d,f){var E=f.isNumber,q=f.merge,M=f.pInt;f=function(){function d(f){this.parsers=[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(d){return[M(d[1]),M(d[2]),M(d[3]),parseFloat(d[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(d){return[M(d[1]),M(d[2]),M(d[3]),1]}}];this.rgba=[];if(!(this instanceof d))return new d(f);this.init(f)}d.parse=function(f){return new d(f)};
d.prototype.init=function(f){var q,x;if((this.input=f=d.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=f.stops.map(function(f){return new d(f[1])});else{if(f&&f.charAt&&"#"===f.charAt()){var F=f.length;f=parseInt(f.substr(1),16);7===F?q=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===F&&(q=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])}if(!q)for(x=this.parsers.length;x--&&!q;){var H=this.parsers[x];(F=H.regex.exec(f))&&(q=H.parse(F))}}this.rgba=q||[]};d.prototype.get=
function(d){var f=this.input,x=this.rgba;if("undefined"!==typeof this.stops){var F=q(f);F.stops=[].concat(F.stops);this.stops.forEach(function(f,x){F.stops[x]=[F.stops[x][0],f.get(d)]})}else F=x&&E(x[0])?"rgb"===d||!d&&1===x[3]?"rgb("+x[0]+","+x[1]+","+x[2]+")":"a"===d?x[3]:"rgba("+x.join(",")+")":f;return F};d.prototype.brighten=function(d){var f,x=this.rgba;if(this.stops)this.stops.forEach(function(f){f.brighten(d)});else if(E(d)&&0!==d)for(f=0;3>f;f++)x[f]+=M(255*d),0>x[f]&&(x[f]=0),255<x[f]&&
(x[f]=255);return this};d.prototype.setOpacity=function(d){this.rgba[3]=d;return this};d.prototype.tweenTo=function(d,f){var x=this.rgba,q=d.rgba;q.length&&x&&x.length?(d=1!==q[3]||1!==x[3],f=(d?"rgba(":"rgb(")+Math.round(q[0]+(x[0]-q[0])*(1-f))+","+Math.round(q[1]+(x[1]-q[1])*(1-f))+","+Math.round(q[2]+(x[2]-q[2])*(1-f))+(d?","+(q[3]+(x[3]-q[3])*(1-f)):"")+")"):f=d.input||"none";return f};d.names={white:"#ffffff",black:"#000000"};return d}();d.Color=f;d.color=f.parse;return d.Color});Q(A,"parts/SVGElement.js",
[A["parts/Color.js"],A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f,E){var q=f.deg2rad,M=f.doc,K=f.hasTouch,J=f.isFirefox,L=f.noop,x=f.svg,F=f.SVG_NS,H=f.win,C=E.animate,D=E.animObject,w=E.attr,n=E.createElement,t=E.css,N=E.defined,m=E.erase,b=E.extend,g=E.fireEvent,v=E.inArray,h=E.isArray,e=E.isFunction,p=E.isNumber,l=E.isString,I=E.merge,u=E.objectEach,y=E.pick,G=E.pInt,S=E.stop,R=E.uniqueKey;E=function(){function B(){this.height=this.element=void 0;this.opacity=1;this.renderer=void 0;
this.SVG_NS=F;this.symbolCustomAttribs="x y width height r start end innerR anchorX anchorY rounded".split(" ");this.textProps="color cursor direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" ");this.width=void 0}B.prototype._defaultGetter=function(c){c=y(this[c+"Value"],this[c],this.element?this.element.getAttribute(c):null,0);/^[\-0-9\.]+$/.test(c)&&(c=parseFloat(c));return c};B.prototype._defaultSetter=function(c,a,k){k.setAttribute(a,
c)};B.prototype.add=function(c){var a=this.renderer,k=this.element;c&&(this.parentGroup=c);this.parentInverted=c&&c.inverted;"undefined"!==typeof this.textStr&&a.buildText(this);this.added=!0;if(!c||c.handleZ||this.zIndex)var r=this.zIndexSetter();r||(c?c.element:a.box).appendChild(k);if(this.onAdd)this.onAdd();return this};B.prototype.addClass=function(c,a){var k=a?"":this.attr("class")||"";c=(c||"").split(/ /g).reduce(function(a,c){-1===k.indexOf(c)&&a.push(c);return a},k?[k]:[]).join(" ");c!==
k&&this.attr("class",c);return this};B.prototype.afterSetters=function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)};B.prototype.align=function(c,a,k){var r,e={};var b=this.renderer;var g=b.alignedObjects;var h,p;if(c){if(this.alignOptions=c,this.alignByTranslate=a,!k||l(k))this.alignTo=r=k||"renderer",m(g,this),g.push(this),k=void 0}else c=this.alignOptions,a=this.alignByTranslate,r=this.alignTo;k=y(k,b[r],b);r=c.align;b=c.verticalAlign;g=(k.x||0)+(c.x||0);var u=(k.y||0)+(c.y||
0);"right"===r?h=1:"center"===r&&(h=2);h&&(g+=(k.width-(c.width||0))/h);e[a?"translateX":"x"]=Math.round(g);"bottom"===b?p=1:"middle"===b&&(p=2);p&&(u+=(k.height-(c.height||0))/p);e[a?"translateY":"y"]=Math.round(u);this[this.placed?"animate":"attr"](e);this.placed=!0;this.alignAttr=e;return this};B.prototype.alignSetter=function(c){var a={left:"start",center:"middle",right:"end"};a[c]&&(this.alignValue=c,this.element.setAttribute("text-anchor",a[c]))};B.prototype.animate=function(c,a,k){var r=D(y(a,
this.renderer.globalAnimation,!0));y(M.hidden,M.msHidden,M.webkitHidden,!1)&&(r.duration=0);0!==r.duration?(k&&(r.complete=k),C(this,c,r)):(this.attr(c,void 0,k),u(c,function(a,c){r.step&&r.step.call(this,a,{prop:c,pos:1})},this));return this};B.prototype.applyTextOutline=function(c){var a=this.element,k;-1!==c.indexOf("contrast")&&(c=c.replace(/contrast/g,this.renderer.getContrast(a.style.fill)));c=c.split(" ");var r=c[c.length-1];if((k=c[0])&&"none"!==k&&f.svg){this.fakeTS=!0;c=[].slice.call(a.getElementsByTagName("tspan"));
this.ySetter=this.xSetter;k=k.replace(/(^[\d\.]+)(.*?)$/g,function(a,c,k){return 2*c+k});this.removeTextOutline(c);var e=a.textContent?/^[\u0591-\u065F\u066A-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(a.textContent):!1;var b=a.firstChild;c.forEach(function(c,z){0===z&&(c.setAttribute("x",a.getAttribute("x")),z=a.getAttribute("y"),c.setAttribute("y",z||0),null===z&&a.setAttribute("y",0));z=c.cloneNode(!0);w(e&&!J?c:z,{"class":"highcharts-text-outline",fill:r,stroke:r,"stroke-width":k,"stroke-linejoin":"round"});
a.insertBefore(z,b)});e&&J&&c[0]&&(c=c[0].cloneNode(!0),c.textContent=" ",a.insertBefore(c,b))}};B.prototype.attr=function(c,a,k,r){var e=this.element,b,l=this,g,h,p=this.symbolCustomAttribs;if("string"===typeof c&&"undefined"!==typeof a){var m=c;c={};c[m]=a}"string"===typeof c?l=(this[c+"Getter"]||this._defaultGetter).call(this,c,e):(u(c,function(a,k){g=!1;r||S(this,k);this.symbolName&&-1!==v(k,p)&&(b||(this.symbolAttr(c),b=!0),g=!0);!this.rotation||"x"!==k&&"y"!==k||(this.doTransform=!0);g||(h=
this[k+"Setter"]||this._defaultSetter,h.call(this,a,k,e),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(k)&&this.updateShadows(k,a,h))},this),this.afterSetters());k&&k.call(this);return l};B.prototype.clip=function(c){return this.attr("clip-path",c?"url("+this.renderer.url+"#"+c.id+")":"none")};B.prototype.crisp=function(c,a){a=a||c.strokeWidth||0;var k=Math.round(a)%2/2;c.x=Math.floor(c.x||this.x||0)+k;c.y=Math.floor(c.y||this.y||0)+k;c.width=Math.floor((c.width||
this.width||0)-2*k);c.height=Math.floor((c.height||this.height||0)-2*k);N(c.strokeWidth)&&(c.strokeWidth=a);return c};B.prototype.complexColor=function(c,a,k){var r=this.renderer,e,b,l,p,m,v,y,n,O,V,t=[],G;g(this.renderer,"complexColor",{args:arguments},function(){c.radialGradient?b="radialGradient":c.linearGradient&&(b="linearGradient");if(b){l=c[b];m=r.gradients;v=c.stops;O=k.radialReference;h(l)&&(c[b]=l={x1:l[0],y1:l[1],x2:l[2],y2:l[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===b&&O&&
!N(l.gradientUnits)&&(p=l,l=I(l,r.getRadialAttr(O,p),{gradientUnits:"userSpaceOnUse"}));u(l,function(a,c){"id"!==c&&t.push(c,a)});u(v,function(a){t.push(a)});t=t.join(",");if(m[t])V=m[t].attr("id");else{l.id=V=R();var z=m[t]=r.createElement(b).attr(l).add(r.defs);z.radAttr=p;z.stops=[];v.forEach(function(a){0===a[1].indexOf("rgba")?(e=d.parse(a[1]),y=e.get("rgb"),n=e.get("a")):(y=a[1],n=1);a=r.createElement("stop").attr({offset:a[0],"stop-color":y,"stop-opacity":n}).add(z);z.stops.push(a)})}G="url("+
r.url+"#"+V+")";k.setAttribute(a,G);k.gradient=t;c.toString=function(){return G}}})};B.prototype.css=function(c){var a=this.styles,k={},r=this.element,e="",l=!a,g=["textOutline","textOverflow","width"];c&&c.color&&(c.fill=c.color);a&&u(c,function(c,r){a&&a[r]!==c&&(k[r]=c,l=!0)});if(l){a&&(c=b(a,k));if(c)if(null===c.width||"auto"===c.width)delete this.textWidth;else if("text"===r.nodeName.toLowerCase()&&c.width)var h=this.textWidth=G(c.width);this.styles=c;h&&!x&&this.renderer.forExport&&delete c.width;
if(r.namespaceURI===this.SVG_NS){var p=function(a,c){return"-"+c.toLowerCase()};u(c,function(a,c){-1===g.indexOf(c)&&(e+=c.replace(/([A-Z])/g,p)+":"+a+";")});e&&w(r,"style",e)}else t(r,c);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),c&&c.textOutline&&this.applyTextOutline(c.textOutline))}return this};B.prototype.dashstyleSetter=function(c){var a=this["stroke-width"];"inherit"===a&&(a=1);if(c=c&&c.toLowerCase()){var k=c.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot",
"3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(c=k.length;c--;)k[c]=""+G(k[c])*y(a,NaN);c=k.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",c)}};B.prototype.destroy=function(){var c=this,a=c.element||{},k=c.renderer,r=k.isSVG&&"SPAN"===a.nodeName&&c.parentGroup||void 0,e=a.ownerSVGElement;a.onclick=a.onmouseout=a.onmouseover=a.onmousemove=a.point=
null;S(c);if(c.clipPath&&e){var b=c.clipPath;[].forEach.call(e.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){-1<a.getAttribute("clip-path").indexOf(b.element.id)&&a.removeAttribute("clip-path")});c.clipPath=b.destroy()}if(c.stops){for(e=0;e<c.stops.length;e++)c.stops[e].destroy();c.stops.length=0;c.stops=void 0}c.safeRemoveChild(a);for(k.styledMode||c.destroyShadows();r&&r.div&&0===r.div.childNodes.length;)a=r.parentGroup,c.safeRemoveChild(r.div),delete r.div,r=a;c.alignTo&&m(k.alignedObjects,
c);u(c,function(a,k){c[k]&&c[k].parentGroup===c&&c[k].destroy&&c[k].destroy();delete c[k]})};B.prototype.destroyShadows=function(){(this.shadows||[]).forEach(function(c){this.safeRemoveChild(c)},this);this.shadows=void 0};B.prototype.destroyTextPath=function(c,a){var k=c.getElementsByTagName("text")[0];if(k){if(k.removeAttribute("dx"),k.removeAttribute("dy"),a.element.setAttribute("id",""),this.textPathWrapper&&k.getElementsByTagName("textPath").length){for(c=this.textPathWrapper.element.childNodes;c.length;)k.appendChild(c[0]);
k.removeChild(this.textPathWrapper.element)}}else if(c.getAttribute("dx")||c.getAttribute("dy"))c.removeAttribute("dx"),c.removeAttribute("dy");this.textPathWrapper&&(this.textPathWrapper=this.textPathWrapper.destroy())};B.prototype.dSetter=function(c,a,k){h(c)&&("string"===typeof c[0]&&(c=this.renderer.pathToSegments(c)),this.pathArray=c,c=c.reduce(function(a,c,k){return c&&c.join?(k?a+" ":"")+c.join(" "):(c||"").toString()},""));/(NaN| {2}|^$)/.test(c)&&(c="M 0 0");this[a]!==c&&(k.setAttribute(a,
c),this[a]=c)};B.prototype.fadeOut=function(c){var a=this;a.animate({opacity:0},{duration:y(c,150),complete:function(){a.attr({y:-9999}).hide()}})};B.prototype.fillSetter=function(c,a,k){"string"===typeof c?k.setAttribute(a,c):c&&this.complexColor(c,a,k)};B.prototype.getBBox=function(c,a){var k,r=this.renderer,z=this.element,l=this.styles,g=this.textStr,h=r.cache,p=r.cacheKeys,u=z.namespaceURI===this.SVG_NS;a=y(a,this.rotation,0);var m=r.styledMode?z&&B.prototype.getStyle.call(z,"font-size"):l&&l.fontSize;
if(N(g)){var v=g.toString();-1===v.indexOf("<")&&(v=v.replace(/[0-9]/g,"0"));v+=["",a,m,this.textWidth,l&&l.textOverflow,l&&l.fontWeight].join()}v&&!c&&(k=h[v]);if(!k){if(u||r.forExport){try{var O=this.fakeTS&&function(a){[].forEach.call(z.querySelectorAll(".highcharts-text-outline"),function(c){c.style.display=a})};e(O)&&O("none");k=z.getBBox?b({},z.getBBox()):{width:z.offsetWidth,height:z.offsetHeight};e(O)&&O("")}catch(V){""}if(!k||0>k.width)k={width:0,height:0}}else k=this.htmlGetBBox();r.isSVG&&
(c=k.width,r=k.height,u&&(k.height=r={"11px,17":14,"13px,20":16}[l&&l.fontSize+","+Math.round(r)]||r),a&&(l=a*q,k.width=Math.abs(r*Math.sin(l))+Math.abs(c*Math.cos(l)),k.height=Math.abs(r*Math.cos(l))+Math.abs(c*Math.sin(l))));if(v&&0<k.height){for(;250<p.length;)delete h[p.shift()];h[v]||p.push(v);h[v]=k}}return k};B.prototype.getStyle=function(c){return H.getComputedStyle(this.element||this,"").getPropertyValue(c)};B.prototype.hasClass=function(c){return-1!==(""+this.attr("class")).split(" ").indexOf(c)};
B.prototype.hide=function(c){c?this.attr({y:-9999}):this.attr({visibility:"hidden"});return this};B.prototype.htmlGetBBox=function(){return{height:0,width:0,x:0,y:0}};B.prototype.init=function(c,a){this.element="span"===a?n(a):M.createElementNS(this.SVG_NS,a);this.renderer=c;g(this,"afterInit")};B.prototype.invert=function(c){this.inverted=c;this.updateTransform();return this};B.prototype.on=function(c,a){var k,r,e=this.element,b;K&&"click"===c?(e.ontouchstart=function(a){k=a.touches[0].clientX;r=
a.touches[0].clientY},e.ontouchend=function(c){k&&4<=Math.sqrt(Math.pow(k-c.changedTouches[0].clientX,2)+Math.pow(r-c.changedTouches[0].clientY,2))||a.call(e,c);b=!0;c.preventDefault()},e.onclick=function(c){b||a.call(e,c)}):e["on"+c]=a;return this};B.prototype.opacitySetter=function(c,a,k){this[a]=c;k.setAttribute(a,c)};B.prototype.removeClass=function(c){return this.attr("class",(""+this.attr("class")).replace(l(c)?new RegExp(" ?"+c+" ?"):c,""))};B.prototype.removeTextOutline=function(c){for(var a=
c.length,k;a--;)k=c[a],"highcharts-text-outline"===k.getAttribute("class")&&m(c,this.element.removeChild(k))};B.prototype.safeRemoveChild=function(c){var a=c.parentNode;a&&a.removeChild(c)};B.prototype.setRadialReference=function(c){var a=this.element.gradient&&this.renderer.gradients[this.element.gradient];this.element.radialReference=c;a&&a.radAttr&&a.animate(this.renderer.getRadialAttr(c,a.radAttr));return this};B.prototype.setTextPath=function(c,a){var k=this.element,r={textAnchor:"text-anchor"},
e=!1,b=this.textPathWrapper,l=!b;a=I(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},a);var g=a.attributes;if(c&&a&&a.enabled){b&&null===b.element.parentNode?(l=!0,b=b.destroy()):b&&this.removeTextOutline.call(b.parentGroup,[].slice.call(k.getElementsByTagName("tspan")));this.options&&this.options.padding&&(g.dx=-this.options.padding);b||(this.textPathWrapper=b=this.renderer.createElement("textPath"),e=!0);var h=b.element;(a=c.element.getAttribute("id"))||c.element.setAttribute("id",
a=R());if(l)for(c=k.getElementsByTagName("tspan");c.length;)c[0].setAttribute("y",0),p(g.dx)&&c[0].setAttribute("x",-g.dx),h.appendChild(c[0]);e&&b&&b.add({element:this.text?this.text.element:k});h.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+a);N(g.dy)&&(h.parentNode.setAttribute("dy",g.dy),delete g.dy);N(g.dx)&&(h.parentNode.setAttribute("dx",g.dx),delete g.dx);u(g,function(a,c){h.setAttribute(r[c]||c,a)});k.removeAttribute("transform");this.removeTextOutline.call(b,
[].slice.call(k.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=this.updateTransform=L}else b&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(k,c),this.updateTransform(),this.options&&this.options.rotation&&this.applyTextOutline(this.options.style.textOutline));return this};B.prototype.shadow=function(c,a,k){var r=[],e=this.element,l=!1,g=this.oldShadowOptions;var h={color:"#000000",
offsetX:1,offsetY:1,opacity:.15,width:3};var p;!0===c?p=h:"object"===typeof c&&(p=b(h,c));p&&(p&&g&&u(p,function(a,c){a!==g[c]&&(l=!0)}),l&&this.destroyShadows(),this.oldShadowOptions=p);if(!p)this.destroyShadows();else if(!this.shadows){var m=p.opacity/p.width;var v=this.parentInverted?"translate(-1,-1)":"translate("+p.offsetX+", "+p.offsetY+")";for(h=1;h<=p.width;h++){var y=e.cloneNode(!1);var O=2*p.width+1-2*h;w(y,{stroke:c.color||"#000000","stroke-opacity":m*h,"stroke-width":O,transform:v,fill:"none"});
y.setAttribute("class",(y.getAttribute("class")||"")+" highcharts-shadow");k&&(w(y,"height",Math.max(w(y,"height")-O,0)),y.cutHeight=O);a?a.element.appendChild(y):e.parentNode&&e.parentNode.insertBefore(y,e);r.push(y)}this.shadows=r}return this};B.prototype.show=function(c){return this.attr({visibility:c?"inherit":"visible"})};B.prototype.strokeSetter=function(c,a,k){this[a]=c;this.stroke&&this["stroke-width"]?(B.prototype.fillSetter.call(this,this.stroke,"stroke",k),k.setAttribute("stroke-width",
this["stroke-width"]),this.hasStroke=!0):"stroke-width"===a&&0===c&&this.hasStroke?(k.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&(k.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};B.prototype.strokeWidth=function(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var c=this.getStyle("stroke-width"),a=0;if(c.indexOf("px")===c.length-2)a=G(c);else if(""!==c){var k=M.createElementNS(F,"rect");w(k,{width:c,"stroke-width":0});
this.element.parentNode.appendChild(k);a=k.getBBox().width;k.parentNode.removeChild(k)}return a};B.prototype.symbolAttr=function(c){var a=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(k){a[k]=y(c[k],a[k])});a.attr({d:a.renderer.symbols[a.symbolName](a.x,a.y,a.width,a.height,a)})};B.prototype.textSetter=function(c){c!==this.textStr&&(delete this.textPxLength,this.textStr=c,this.added&&this.renderer.buildText(this))};B.prototype.titleSetter=function(c){var a=
this.element.getElementsByTagName("title")[0];a||(a=M.createElementNS(this.SVG_NS,"title"),this.element.appendChild(a));a.firstChild&&a.removeChild(a.firstChild);a.appendChild(M.createTextNode(String(y(c,"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")))};B.prototype.toFront=function(){var c=this.element;c.parentNode.appendChild(c);return this};B.prototype.translate=function(c,a){return this.attr({translateX:c,translateY:a})};B.prototype.updateShadows=function(c,a,k){var r=this.shadows;
if(r)for(var e=r.length;e--;)k.call(r[e],"height"===c?Math.max(a-(r[e].cutHeight||0),0):"d"===c?this.d:a,c,r[e])};B.prototype.updateTransform=function(){var c=this.translateX||0,a=this.translateY||0,k=this.scaleX,r=this.scaleY,e=this.inverted,b=this.rotation,l=this.matrix,g=this.element;e&&(c+=this.width,a+=this.height);c=["translate("+c+","+a+")"];N(l)&&c.push("matrix("+l.join(",")+")");e?c.push("rotate(90) scale(-1,1)"):b&&c.push("rotate("+b+" "+y(this.rotationOriginX,g.getAttribute("x"),0)+" "+
y(this.rotationOriginY,g.getAttribute("y")||0)+")");(N(k)||N(r))&&c.push("scale("+y(k,1)+" "+y(r,1)+")");c.length&&g.setAttribute("transform",c.join(" "))};B.prototype.visibilitySetter=function(c,a,k){"inherit"===c?k.removeAttribute(a):this[a]!==c&&k.setAttribute(a,c);this[a]=c};B.prototype.xGetter=function(c){"circle"===this.element.nodeName&&("x"===c?c="cx":"y"===c&&(c="cy"));return this._defaultGetter(c)};B.prototype.zIndexSetter=function(c,a){var k=this.renderer,r=this.parentGroup,e=(r||k).element||
k.box,b=this.element,l=!1;k=e===k.box;var g=this.added;var h;N(c)?(b.setAttribute("data-z-index",c),c=+c,this[a]===c&&(g=!1)):N(this[a])&&b.removeAttribute("data-z-index");this[a]=c;if(g){(c=this.zIndex)&&r&&(r.handleZ=!0);a=e.childNodes;for(h=a.length-1;0<=h&&!l;h--){r=a[h];g=r.getAttribute("data-z-index");var p=!N(g);if(r!==b)if(0>c&&p&&!k&&!h)e.insertBefore(b,a[h]),l=!0;else if(G(g)<=c||p&&(!N(c)||0<=c))e.insertBefore(b,a[h+1]||null),l=!0}l||(e.insertBefore(b,a[k?3:0]||null),l=!0)}return l};return B}();
E.prototype["stroke-widthSetter"]=E.prototype.strokeSetter;E.prototype.yGetter=E.prototype.xGetter;E.prototype.matrixSetter=E.prototype.rotationOriginXSetter=E.prototype.rotationOriginYSetter=E.prototype.rotationSetter=E.prototype.scaleXSetter=E.prototype.scaleYSetter=E.prototype.translateXSetter=E.prototype.translateYSetter=E.prototype.verticalAlignSetter=function(e,c){this[c]=e;this.doTransform=!0};f.SVGElement=E;return f.SVGElement});Q(A,"parts/SvgRenderer.js",[A["parts/Color.js"],A["parts/Globals.js"],
A["parts/SVGElement.js"],A["parts/Utilities.js"]],function(d,f,E,q){var M=d.parse,K=q.addEvent,J=q.attr,L=q.createElement,x=q.css,F=q.defined,H=q.destroyObjectProperties,C=q.extend,D=q.isArray,w=q.isNumber,n=q.isObject,t=q.isString,N=q.merge,m=q.objectEach,b=q.pick,g=q.pInt,v=q.removeEvent,h=q.splat,e=q.uniqueKey,p=f.charts,l=f.deg2rad,I=f.doc,u=f.isFirefox,y=f.isMS,G=f.isWebKit;q=f.noop;var S=f.svg,R=f.SVG_NS,B=f.symbolSizes,c=f.win;d=f.SVGRenderer=function(){this.init.apply(this,arguments)};C(d.prototype,
{Element:E,SVG_NS:R,init:function(a,k,r,e,b,l,g){var z=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});g||z.css(this.getStyle(e));e=z.element;a.appendChild(e);J(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&J(e,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=e;this.boxWrapper=z;this.alignedObjects=[];this.url=(u||G)&&I.getElementsByTagName("base").length?c.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(I.createTextNode("Created with Highcharts 8.1.0"));
this.defs=this.createElement("defs").add();this.allowHTML=l;this.forExport=b;this.styledMode=g;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(k,r,!1);var h;u&&a.getBoundingClientRect&&(k=function(){x(a,{left:0,top:0});h=a.getBoundingClientRect();x(a,{left:Math.ceil(h.left)-h.left+"px",top:Math.ceil(h.top)-h.top+"px"})},k(),this.unSubPixelFix=K(c,"resize",k))},definition:function(a){function c(a,k){var e;h(a).forEach(function(a){var b=r.createElement(a.tagName),l={};
m(a,function(a,c){"tagName"!==c&&"children"!==c&&"textContent"!==c&&(l[c]=a)});b.attr(l);b.add(k||r.defs);a.textContent&&b.element.appendChild(I.createTextNode(a.textContent));c(a.children||[],b);e=b});return e}var r=this;return c(a)},getStyle:function(a){return this.style=C({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();H(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var c=new this.Element;c.init(this,a);return c},draw:q,getRadialAttr:function(a,c){return{cx:a[0]-a[2]/2+c.cx*a[2],cy:a[1]-a[2]/2+c.cy*a[2],r:c.r*a[2]}},truncate:function(a,c,r,e,b,l,g){var k=this,z=a.rotation,h,p=e?1:0,u=(r||e).length,P=u,m=[],v=function(a){c.firstChild&&
c.removeChild(c.firstChild);a&&c.appendChild(I.createTextNode(a))},y=function(l,z){z=z||l;if("undefined"===typeof m[z])if(c.getSubStringLength)try{m[z]=b+c.getSubStringLength(0,e?z+1:z)}catch(fa){""}else k.getSpanWidth&&(v(g(r||e,l)),m[z]=b+k.getSpanWidth(a,c));return m[z]},n;a.rotation=0;var U=y(c.textContent.length);if(n=b+U>l){for(;p<=u;)P=Math.ceil((p+u)/2),e&&(h=g(e,P)),U=y(P,h&&h.length-1),p===u?p=u+1:U>l?u=P-1:p=P;0===u?v(""):r&&u===r.length-1||v(h||g(r||e,P))}e&&e.splice(0,P);a.actualWidth=
U;a.rotation=z;return n},escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},buildText:function(a){var c=a.element,r=this,e=r.forExport,l=b(a.textStr,"").toString(),h=-1!==l.indexOf("<"),p=c.childNodes,u,v=J(c,"x"),y=a.styles,n=a.textWidth,O=y&&y.lineHeight,V=y&&y.textOutline,t=y&&"ellipsis"===y.textOverflow,G=y&&"nowrap"===y.whiteSpace,d=y&&y.fontSize,w,B=p.length;y=n&&!a.added&&this.box;var f=function(a){var k;r.styledMode||(k=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:
d||r.style.fontSize||12);return O?g(O):r.fontMetrics(k,a.getAttribute("style")?a:c).h},N=function(a,c){m(r.escapes,function(k,r){c&&-1!==c.indexOf(k)||(a=a.toString().replace(new RegExp(k,"g"),r))});return a},C=function(a,c){var k=a.indexOf("<");a=a.substring(k,a.indexOf(">")-k);k=a.indexOf(c+"=");if(-1!==k&&(k=k+c.length+1,c=a.charAt(k),'"'===c||"'"===c))return a=a.substring(k+1),a.substring(0,a.indexOf(c))},D=/<br.*?>/g;var q=[l,t,G,O,V,d,n].join();if(q!==a.textCache){for(a.textCache=q;B--;)c.removeChild(p[B]);
h||V||t||n||-1!==l.indexOf(" ")&&(!G||D.test(l))?(y&&y.appendChild(c),h?(l=r.styledMode?l.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):l.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),l=l.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(D)):l=[l],l=l.filter(function(a){return""!==a}),l.forEach(function(k,b){var l=0,g=0;k=k.replace(/^\s+|\s+$/g,
"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var z=k.split("|||");z.forEach(function(k){if(""!==k||1===z.length){var h={},p=I.createElementNS(r.SVG_NS,"tspan"),m,P;(m=C(k,"class"))&&J(p,"class",m);if(m=C(k,"style"))m=m.replace(/(;| |^)color([ :])/,"$1fill$2"),J(p,"style",m);(P=C(k,"href"))&&!e&&(J(p,"onclick",'location.href="'+P+'"'),J(p,"class","highcharts-anchor"),r.styledMode||x(p,{cursor:"pointer"}));k=N(k.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==k){p.appendChild(I.createTextNode(k));
l?h.dx=0:b&&null!==v&&(h.x=v);J(p,h);c.appendChild(p);!l&&w&&(!S&&e&&x(p,{display:"block"}),J(p,"dy",f(p)));if(n){var O=k.replace(/([^\^])-/g,"$1- ").split(" ");h=!G&&(1<z.length||b||1<O.length);P=0;var y=f(p);if(t)u=r.truncate(a,p,k,void 0,0,Math.max(0,n-parseInt(d||12,10)),function(a,c){return a.substring(0,c)+"\u2026"});else if(h)for(;O.length;)O.length&&!G&&0<P&&(p=I.createElementNS(R,"tspan"),J(p,{dy:y,x:v}),m&&J(p,"style",m),p.appendChild(I.createTextNode(O.join(" ").replace(/- /g,"-"))),c.appendChild(p)),
r.truncate(a,p,null,O,0===P?g:0,n,function(a,c){return O.slice(0,c).join(" ").replace(/- /g,"-")}),g=a.actualWidth,P++}l++}}});w=w||c.childNodes.length}),t&&u&&a.attr("title",N(a.textStr,["&lt;","&gt;"])),y&&y.removeChild(c),V&&a.applyTextOutline&&a.applyTextOutline(V)):c.appendChild(I.createTextNode(N(l)))}},getContrast:function(a){a=M(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,c,r,e,b,l,g,h,p,u){var k=this.label(a,c,r,p,void 0,void 0,u,void 0,
"button"),z=0,m=this.styledMode;k.attr(N({padding:8,r:2},b));if(!m){b=N({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},b);var P=b.style;delete b.style;l=N(b,{fill:"#e6e6e6"},l);var v=l.style;delete l.style;g=N(b,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},g);var n=g.style;delete g.style;h=N(b,{style:{color:"#cccccc"}},h);var U=h.style;delete h.style}K(k.element,y?"mouseover":"mouseenter",function(){3!==z&&k.setState(1)});
K(k.element,y?"mouseout":"mouseleave",function(){3!==z&&k.setState(z)});k.setState=function(a){1!==a&&(k.state=z=a);k.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);m||k.attr([b,l,g,h][a||0]).css([P,v,n,U][a||0])};m||k.attr(b).css(C({cursor:"default"},P));return k.on("click",function(a){3!==z&&e.call(k,a)})},crispLine:function(a,c,r){void 0===r&&(r="round");var k=a[0],e=a[1];k[1]===e[1]&&(k[1]=e[1]=Math[r](k[1])-
c%2/2);k[2]===e[2]&&(k[2]=e[2]=Math[r](k[2])+c%2/2);return a},path:function(a){var c=this.styledMode?{}:{fill:"none"};D(a)?c.d=a:n(a)&&C(c,a);return this.createElement("path").attr(c)},circle:function(a,c,r){a=n(a)?a:"undefined"===typeof a?{}:{x:a,y:c,r:r};c=this.createElement("circle");c.xSetter=c.ySetter=function(a,c,k){k.setAttribute("c"+c,a)};return c.attr(a)},arc:function(a,c,r,e,b,l){n(a)?(e=a,c=e.y,r=e.r,a=e.x):e={innerR:e,start:b,end:l};a=this.symbol("arc",a,c,r,r,e);a.r=r;return a},rect:function(a,
c,r,e,b,l){b=n(a)?a.r:b;var k=this.createElement("rect");a=n(a)?a:"undefined"===typeof a?{}:{x:a,y:c,width:Math.max(r,0),height:Math.max(e,0)};this.styledMode||("undefined"!==typeof l&&(a.strokeWidth=l,a=k.crisp(a)),a.fill="none");b&&(a.r=b);k.rSetter=function(a,c,r){k.r=a;J(r,{rx:a,ry:a})};k.rGetter=function(){return k.r};return k.attr(a)},setSize:function(a,c,r){var k=this.alignedObjects,e=k.length;this.width=a;this.height=c;for(this.boxWrapper.animate({width:a,height:c},{step:function(){this.attr({viewBox:"0 0 "+
this.attr("width")+" "+this.attr("height")})},duration:b(r,!0)?void 0:0});e--;)k[e].align()},g:function(a){var c=this.createElement("g");return a?c.attr({"class":"highcharts-"+a}):c},image:function(a,k,r,e,b,l){var g={preserveAspectRatio:"none"},h=function(a,c){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",c):a.setAttribute("hc-svg-href",c)},z=function(c){h(p.element,a);l.call(p,c)};1<arguments.length&&C(g,{x:k,y:r,width:e,height:b});var p=this.createElement("image").attr(g);
l?(h(p.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),g=new c.Image,K(g,"load",z),g.src=a,g.complete&&z({})):h(p.element,a);return p},symbol:function(a,c,r,e,l,g){var k=this,h=/^url\((.*?)\)$/,z=h.test(a),u=!z&&(this.symbols[a]?a:"circle"),m=u&&this.symbols[u],v;if(m){"number"===typeof c&&(v=m.call(this.symbols,Math.round(c||0),Math.round(r||0),e,l,g));var P=this.path(v);k.styledMode||P.attr("fill","none");C(P,{symbolName:u,x:c,y:r,width:e,height:l});g&&C(P,
g)}else if(z){var y=a.match(h)[1];P=this.image(y);P.imgwidth=b(B[y]&&B[y].width,g&&g.width);P.imgheight=b(B[y]&&B[y].height,g&&g.height);var n=function(){P.attr({width:P.width,height:P.height})};["width","height"].forEach(function(a){P[a+"Setter"]=function(a,c){var k={},r=this["img"+c],e="width"===c?"translateX":"translateY";this[c]=a;F(r)&&(g&&"within"===g.backgroundSize&&this.width&&this.height&&(r=Math.round(r*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&this.element.setAttribute(c,
r),this.alignByTranslate||(k[e]=((this[c]||0)-r)/2,this.attr(k)))}});F(c)&&P.attr({x:c,y:r});P.isImg=!0;F(P.imgwidth)&&F(P.imgheight)?n():(P.attr({width:0,height:0}),L("img",{onload:function(){var a=p[k.chartIndex];0===this.width&&(x(this,{position:"absolute",top:"-999em"}),I.body.appendChild(this));B[y]={width:this.width,height:this.height};P.imgwidth=this.width;P.imgheight=this.height;P.element&&n();this.parentNode&&this.parentNode.removeChild(this);k.imgCount--;if(!k.imgCount&&a&&!a.hasLoaded)a.onload()},
src:y}),this.imgCount++)}return P},symbols:{circle:function(a,c,r,e){return this.arc(a+r/2,c+e/2,r/2,e/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,c,r,e){return[["M",a,c],["L",a+r,c],["L",a+r,c+e],["L",a,c+e],["Z"]]},triangle:function(a,c,r,e){return[["M",a+r/2,c],["L",a+r,c+e],["L",a,c+e],["Z"]]},"triangle-down":function(a,c,r,e){return[["M",a,c],["L",a+r,c],["L",a+r/2,c+e],["Z"]]},diamond:function(a,c,r,e){return[["M",a+r/2,c],["L",a+r,c+e/2],["L",a+r/2,c+e],["L",a,c+e/2],["Z"]]},
arc:function(a,c,r,e,l){var k=l.start,g=l.r||r,h=l.r||e||r,p=l.end-.001;r=l.innerR;e=b(l.open,.001>Math.abs(l.end-l.start-2*Math.PI));var z=Math.cos(k),u=Math.sin(k),m=Math.cos(p);p=Math.sin(p);k=b(l.longArc,.001>l.end-k-Math.PI?0:1);g=[["M",a+g*z,c+h*u],["A",g,h,0,k,b(l.clockwise,1),a+g*m,c+h*p]];F(r)&&g.push(e?["M",a+r*m,c+r*p]:["L",a+r*m,c+r*p],["A",r,r,0,k,F(l.clockwise)?1-l.clockwise:0,a+r*z,c+r*u]);e||g.push(["Z"]);return g},callout:function(a,c,r,e,b){var k=Math.min(b&&b.r||0,r,e),l=k+6,g=
b&&b.anchorX;b=b&&b.anchorY;var h=[["M",a+k,c],["L",a+r-k,c],["C",a+r,c,a+r,c,a+r,c+k],["L",a+r,c+e-k],["C",a+r,c+e,a+r,c+e,a+r-k,c+e],["L",a+k,c+e],["C",a,c+e,a,c+e,a,c+e-k],["L",a,c+k],["C",a,c,a,c,a+k,c]];g&&g>r?b>c+l&&b<c+e-l?h.splice(3,1,["L",a+r,b-6],["L",a+r+6,b],["L",a+r,b+6],["L",a+r,c+e-k]):h.splice(3,1,["L",a+r,e/2],["L",g,b],["L",a+r,e/2],["L",a+r,c+e-k]):g&&0>g?b>c+l&&b<c+e-l?h.splice(7,1,["L",a,b+6],["L",a-6,b],["L",a,b-6],["L",a,c+k]):h.splice(7,1,["L",a,e/2],["L",g,b],["L",a,e/2],
["L",a,c+k]):b&&b>e&&g>a+l&&g<a+r-l?h.splice(5,1,["L",g+6,c+e],["L",g,c+e+6],["L",g-6,c+e],["L",a+k,c+e]):b&&0>b&&g>a+l&&g<a+r-l&&h.splice(1,1,["L",g-6,c],["L",g,c-6],["L",g+6,c],["L",r-k,c]);return h}},clipRect:function(a,c,r,b){var k=e()+"-",l=this.createElement("clipPath").attr({id:k}).add(this.defs);a=this.rect(a,c,r,b,0).add(l);a.id=k;a.clipPath=l;a.count=0;return a},text:function(a,c,e,b){var k={};if(b&&(this.allowHTML||!this.forExport))return this.html(a,c,e);k.x=Math.round(c||0);e&&(k.y=Math.round(e));
F(a)&&(k.text=a);a=this.createElement("text").attr(k);b||(a.xSetter=function(a,c,k){var e=k.getElementsByTagName("tspan"),r=k.getAttribute(c),b;for(b=0;b<e.length;b++){var l=e[b];l.getAttribute(c)===r&&l.setAttribute(c,a)}k.setAttribute(c,a)});return a},fontMetrics:function(a,k){a=!this.styledMode&&/px/.test(a)||!c.getComputedStyle?a||k&&k.style&&k.style.fontSize||this.style&&this.style.fontSize:k&&E.prototype.getStyle.call(k,"font-size");a=/px/.test(a)?g(a):12;k=24>a?a+3:Math.round(1.2*a);return{h:k,
b:Math.round(.8*k),f:a}},rotCorr:function(a,c,e){var k=a;c&&e&&(k=Math.max(k*Math.cos(c*l),4));return{x:-a/3*Math.sin(c*l),y:k}},pathToSegments:function(a){for(var c=[],e=[],b={A:8,C:7,H:2,L:3,M:3,Q:5,S:5,T:3,V:2},l=0;l<a.length;l++)t(e[0])&&w(a[l])&&e.length===b[e[0].toUpperCase()]&&a.splice(l,0,e[0].replace("M","L").replace("m","l")),"string"===typeof a[l]&&(e.length&&c.push(e.slice(0)),e.length=0),e.push(a[l]);c.push(e.slice(0));return c},label:function(a,c,e,b,l,g,h,p,u){var k=this,r=k.styledMode,
z=k.g("button"!==u&&"label"),m=z.text=k.text("",0,0,h).attr({zIndex:1}),y,P={width:0,height:0,x:0,y:0},n=P,t=0,I=3,G=0,U,d,B,f,S,R={},x,W,T=/^url\((.*?)\)$/.test(b),D=r||T,q=function(){return r?y.strokeWidth()%2/2:(x?parseInt(x,10):0)%2/2};u&&z.addClass("highcharts-"+u);var Y=function(){var a=m.element.style,c={};n=w(U)&&w(d)&&!S||!F(m.textStr)?P:m.getBBox();z.width=(U||n.width||0)+2*I+G;z.height=(d||n.height||0)+2*I;W=I+Math.min(k.fontMetrics(a&&a.fontSize,m).b,n.height||Infinity);D&&(y||(z.box=
y=k.symbols[b]||T?k.symbol(b):k.rect(),y.addClass(("button"===u?"":"highcharts-label-box")+(u?" highcharts-"+u+"-box":"")),y.add(z),a=q(),c.x=a,c.y=(p?-W:0)+a),c.width=Math.round(z.width),c.height=Math.round(z.height),y.attr(C(c,R)),R={})};var H=function(){var a=G+I;var c=p?0:W;F(U)&&n&&("center"===S||"right"===S)&&(a+={center:.5,right:1}[S]*(U-n.width));if(a!==m.x||c!==m.y)m.attr("x",a),m.hasBoxWidthChanged&&(n=m.getBBox(!0),Y()),"undefined"!==typeof c&&m.attr("y",c);m.x=a;m.y=c};var L=function(a,
c){y?y.attr(a,c):R[a]=c};z.onAdd=function(){m.add(z);z.attr({text:a||0===a?a:"",x:c,y:e});y&&F(l)&&z.attr({anchorX:l,anchorY:g})};z.widthSetter=function(a){U=w(a)?a:null};z.heightSetter=function(a){d=a};z["text-alignSetter"]=function(a){S=a};z.paddingSetter=function(a){F(a)&&a!==I&&(I=z.padding=a,H())};z.paddingLeftSetter=function(a){F(a)&&a!==G&&(G=a,H())};z.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==t&&(t=a,n&&z.attr({x:B}))};z.textSetter=function(a){"undefined"!==typeof a&&m.attr({text:a});
Y();H()};z["stroke-widthSetter"]=function(a,c){a&&(D=!0);x=this["stroke-width"]=a;L(c,a)};r?z.rSetter=function(a,c){L(c,a)}:z.strokeSetter=z.fillSetter=z.rSetter=function(a,c){"r"!==c&&("fill"===c&&a&&(D=!0),z[c]=a);L(c,a)};z.anchorXSetter=function(a,c){l=z.anchorX=a;L(c,Math.round(a)-q()-B)};z.anchorYSetter=function(a,c){g=z.anchorY=a;L(c,a-f)};z.xSetter=function(a){z.x=a;t&&(a-=t*((U||n.width)+2*I),z["forceAnimate:x"]=!0);B=Math.round(a);z.attr("translateX",B)};z.ySetter=function(a){f=z.y=Math.round(a);
z.attr("translateY",f)};z.isLabel=!0;var J=z.css;h={css:function(a){if(a){var c={};a=N(a);z.textProps.forEach(function(k){"undefined"!==typeof a[k]&&(c[k]=a[k],delete a[k])});m.css(c);var k="fontSize"in c||"fontWeight"in c;if("width"in c||k)Y(),k&&H()}return J.call(z,a)},getBBox:function(){return{width:n.width+2*I,height:n.height+2*I,x:n.x-I,y:n.y-I}},destroy:function(){v(z.element,"mouseenter");v(z.element,"mouseleave");m&&m.destroy();y&&(y=y.destroy());E.prototype.destroy.call(z);z=k=m=Y=H=L=null}};
z.on=function(a,c){var k=m&&"SPAN"===m.element.tagName?m:void 0;if(k){var e=function(e){("mouseenter"===a||"mouseleave"===a)&&e.relatedTarget instanceof Element&&(z.element.contains(e.relatedTarget)||k.element.contains(e.relatedTarget))||c.call(z.element,e)};k.on(a,e)}E.prototype.on.call(z,a,e||c);return z};r||(h.shadow=function(a){a&&(Y(),y&&y.shadow(a));return z});return C(z,h)}});f.Renderer=d});Q(A,"parts/Html.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.attr,q=f.createElement,
M=f.css,K=f.defined,J=f.extend,L=f.pick,x=f.pInt,F=d.isFirefox,H=d.isMS,C=d.isWebKit,D=d.SVGElement;f=d.SVGRenderer;var w=d.win;J(D.prototype,{htmlCss:function(n){var t="SPAN"===this.element.tagName&&n&&"width"in n,d=L(t&&n.width,void 0);if(t){delete n.width;this.textWidth=d;var m=!0}n&&"ellipsis"===n.textOverflow&&(n.whiteSpace="nowrap",n.overflow="hidden");this.styles=J(this.styles,n);M(this.element,n);m&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var n=this.element;return{x:n.offsetLeft,
y:n.offsetTop,width:n.offsetWidth,height:n.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var n=this.renderer,t=this.element,d=this.translateX||0,m=this.translateY||0,b=this.x||0,g=this.y||0,v=this.textAlign||"left",h={left:0,center:.5,right:1}[v],e=this.styles,p=e&&e.whiteSpace;M(t,{marginLeft:d,marginTop:m});!n.styledMode&&this.shadows&&this.shadows.forEach(function(e){M(e,{marginLeft:d+1,marginTop:m+1})});this.inverted&&[].forEach.call(t.childNodes,function(e){n.invertChild(e,t)});
if("SPAN"===t.tagName){e=this.rotation;var l=this.textWidth&&x(this.textWidth),I=[e,v,t.innerHTML,this.textWidth,this.textAlign].join(),u;(u=l!==this.oldTextWidth)&&!(u=l>this.oldTextWidth)&&((u=this.textPxLength)||(M(t,{width:"",whiteSpace:p||"nowrap"}),u=t.offsetWidth),u=u>l);u&&(/[ \-]/.test(t.textContent||t.innerText)||"ellipsis"===t.style.textOverflow)?(M(t,{width:l+"px",display:"block",whiteSpace:p||"normal"}),this.oldTextWidth=l,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;I!==this.cTT&&
(p=n.fontMetrics(t.style.fontSize,t).b,!K(e)||e===(this.oldRotation||0)&&v===this.oldAlign||this.setSpanRotation(e,h,p),this.getSpanCorrection(!K(e)&&this.textPxLength||t.offsetWidth,p,h,e,v));M(t,{left:b+(this.xCorr||0)+"px",top:g+(this.yCorr||0)+"px"});this.cTT=I;this.oldRotation=e;this.oldAlign=v}}else this.alignOnAdd=!0},setSpanRotation:function(n,t,d){var m={},b=this.renderer.getTransformKey();m[b]=m.transform="rotate("+n+"deg)";m[b+(F?"Origin":"-origin")]=m.transformOrigin=100*t+"% "+d+"px";
M(this.element,m)},getSpanCorrection:function(n,t,d){this.xCorr=-n*d;this.yCorr=-t}});J(f.prototype,{getTransformKey:function(){return H&&!/Edge/.test(w.navigator.userAgent)?"-ms-transform":C?"-webkit-transform":F?"MozTransform":w.opera?"-o-transform":""},html:function(n,t,d){var m=this.createElement("span"),b=m.element,g=m.renderer,v=g.isSVG,h=function(e,b){["opacity","visibility"].forEach(function(l){e[l+"Setter"]=function(g,h,p){var u=e.div?e.div.style:b;D.prototype[l+"Setter"].call(this,g,h,p);
u&&(u[h]=g)}});e.addedSetters=!0};m.textSetter=function(e){e!==b.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=e;b.innerHTML=L(e,"");m.doTransform=!0};v&&h(m,m.element.style);m.xSetter=m.ySetter=m.alignSetter=m.rotationSetter=function(e,b){"align"===b&&(b="textAlign");m[b]=e;m.doTransform=!0};m.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};m.attr({text:n,x:Math.round(t),y:Math.round(d)}).css({position:"absolute"});g.styledMode||m.css({fontFamily:this.style.fontFamily,
fontSize:this.style.fontSize});b.style.whiteSpace="nowrap";m.css=m.htmlCss;v&&(m.add=function(e){var p=g.box.parentNode,l=[];if(this.parentGroup=e){var v=e.div;if(!v){for(;e;)l.push(e),e=e.parentGroup;l.reverse().forEach(function(e){function b(b,l){e[l]=b;"translateX"===l?u.left=b+"px":u.top=b+"px";e.doTransform=!0}var g=E(e.element,"class");v=e.div=e.div||q("div",g?{className:g}:void 0,{position:"absolute",left:(e.translateX||0)+"px",top:(e.translateY||0)+"px",display:e.display,opacity:e.opacity,
pointerEvents:e.styles&&e.styles.pointerEvents},v||p);var u=v.style;J(e,{classSetter:function(e){return function(b){this.element.setAttribute("class",b);e.className=b}}(v),on:function(){l[0].div&&m.on.apply({element:l[0].div},arguments);return e},translateXSetter:b,translateYSetter:b});e.addedSetters||h(e)})}}else v=p;v.appendChild(b);m.added=!0;m.alignOnAdd&&m.htmlUpdateTransform();return m});return m}})});Q(A,"parts/Tick.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.clamp,
q=f.correctFloat,M=f.defined,K=f.destroyObjectProperties,J=f.extend,L=f.fireEvent,x=f.isNumber,F=f.merge,H=f.objectEach,C=f.pick,D=d.deg2rad;f=function(){function d(n,t,d,m,b){this.isNewLabel=this.isNew=!0;this.axis=n;this.pos=t;this.type=d||"";this.parameters=b||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;L(this,"init");d||m||this.addLabel()}d.prototype.addLabel=function(){var n=this,t=n.axis,d=t.options,m=t.chart,b=t.categories,g=t.logarithmic,v=t.names,
h=n.pos,e=C(n.options&&n.options.labels,d.labels),p=t.tickPositions,l=h===p[0],I=h===p[p.length-1];v=this.parameters.category||(b?C(b[h],v[h],h):h);var u=n.label;b=(!e.step||1===e.step)&&1===t.tickInterval;p=p.info;var y,G;if(t.dateTime&&p){var f=m.time.resolveDTLFormat(d.dateTimeLabelFormats[!d.grid&&p.higherRanks[h]||p.unitName]);var w=f.main}n.isFirst=l;n.isLast=I;n.formatCtx={axis:t,chart:m,isFirst:l,isLast:I,dateTimeLabelFormat:w,tickPositionInfo:p,value:g?q(g.lin2log(v)):v,pos:h};d=t.labelFormatter.call(n.formatCtx,
this.formatCtx);if(G=f&&f.list)n.shortenLabel=function(){for(y=0;y<G.length;y++)if(u.attr({text:t.labelFormatter.call(J(n.formatCtx,{dateTimeLabelFormat:G[y]}))}),u.getBBox().width<t.getSlotWidth(n)-2*C(e.padding,5))return;u.attr({text:""})};b&&t._addedPlotLB&&t.isXAxis&&n.moveLabel(d,e);M(u)||n.movedLabel?u&&u.textStr!==d&&!b&&(!u.textWidth||e.style&&e.style.width||u.styles.width||u.css({width:null}),u.attr({text:d}),u.textPxLength=u.getBBox().width):(n.label=u=n.createLabel({x:0,y:0},d,e),n.rotation=
0)};d.prototype.createLabel=function(n,t,d){var m=this.axis,b=m.chart;if(n=M(t)&&d.enabled?b.renderer.text(t,n.x,n.y,d.useHTML).add(m.labelGroup):null)b.styledMode||n.css(F(d.style)),n.textPxLength=n.getBBox().width;return n};d.prototype.destroy=function(){K(this,this.axis)};d.prototype.getPosition=function(n,t,d,m){var b=this.axis,g=b.chart,v=m&&g.oldChartHeight||g.chartHeight;n={x:n?q(b.translate(t+d,null,null,m)+b.transB):b.left+b.offset+(b.opposite?(m&&g.oldChartWidth||g.chartWidth)-b.right-b.left:
0),y:n?v-b.bottom+b.offset-(b.opposite?b.height:0):q(v-b.translate(t+d,null,null,m)-b.transB)};n.y=E(n.y,-1E5,1E5);L(this,"afterGetPosition",{pos:n});return n};d.prototype.getLabelPosition=function(n,t,d,m,b,g,v,h){var e=this.axis,p=e.transA,l=e.isLinked&&e.linkedParent?e.linkedParent.reversed:e.reversed,I=e.staggerLines,u=e.tickRotCorr||{x:0,y:0},y=b.y,G=m||e.reserveSpaceDefault?0:-e.labelOffset*("center"===e.labelAlign?.5:1),f={};M(y)||(y=0===e.side?d.rotation?-8:-d.getBBox().height:2===e.side?
u.y+8:Math.cos(d.rotation*D)*(u.y-d.getBBox(!1,0).height/2));n=n+b.x+G+u.x-(g&&m?g*p*(l?-1:1):0);t=t+y-(g&&!m?g*p*(l?1:-1):0);I&&(d=v/(h||1)%I,e.opposite&&(d=I-d-1),t+=e.labelOffset/I*d);f.x=n;f.y=Math.round(t);L(this,"afterGetLabelPosition",{pos:f,tickmarkOffset:g,index:v});return f};d.prototype.getLabelSize=function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0};d.prototype.getMarkPath=function(n,d,f,m,b,g){return g.crispLine([["M",n,d],["L",n+(b?0:-f),d+(b?f:0)]],
m)};d.prototype.handleOverflow=function(n){var d=this.axis,f=d.options.labels,m=n.x,b=d.chart.chartWidth,g=d.chart.spacing,v=C(d.labelLeft,Math.min(d.pos,g[3]));g=C(d.labelRight,Math.max(d.isRadial?0:d.pos+d.len,b-g[1]));var h=this.label,e=this.rotation,p={left:0,center:.5,right:1}[d.labelAlign||h.attr("align")],l=h.getBBox().width,I=d.getSlotWidth(this),u=I,y=1,G,w={};if(e||"justify"!==C(f.overflow,"justify"))0>e&&m-p*l<v?G=Math.round(m/Math.cos(e*D)-v):0<e&&m+p*l>g&&(G=Math.round((b-m)/Math.cos(e*
D)));else if(b=m+(1-p)*l,m-p*l<v?u=n.x+u*(1-p)-v:b>g&&(u=g-n.x+u*p,y=-1),u=Math.min(I,u),u<I&&"center"===d.labelAlign&&(n.x+=y*(I-u-p*(I-Math.min(l,u)))),l>u||d.autoRotation&&(h.styles||{}).width)G=u;G&&(this.shortenLabel?this.shortenLabel():(w.width=Math.floor(G)+"px",(f.style||{}).textOverflow||(w.textOverflow="ellipsis"),h.css(w)))};d.prototype.moveLabel=function(n,d){var t=this,m=t.label,b=!1,g=t.axis,v=g.reversed,h=g.chart.inverted;m&&m.textStr===n?(t.movedLabel=m,b=!0,delete t.label):H(g.ticks,
function(e){b||e.isNew||e===t||!e.label||e.label.textStr!==n||(t.movedLabel=e.label,b=!0,e.labelPos=t.movedLabel.xy,delete e.label)});if(!b&&(t.labelPos||m)){var e=t.labelPos||m.xy;m=h?e.x:v?0:g.width+g.left;g=h?v?g.width+g.left:0:e.y;t.movedLabel=t.createLabel({x:m,y:g},n,d);t.movedLabel&&t.movedLabel.attr({opacity:0})}};d.prototype.render=function(n,d,f){var m=this.axis,b=m.horiz,g=this.pos,v=C(this.tickmarkOffset,m.tickmarkOffset);g=this.getPosition(b,g,v,d);v=g.x;var h=g.y;m=b&&v===m.pos+m.len||
!b&&h===m.pos?-1:1;f=C(f,1);this.isActive=!0;this.renderGridLine(d,f,m);this.renderMark(g,f,m);this.renderLabel(g,d,f,n);this.isNew=!1;L(this,"afterRender")};d.prototype.renderGridLine=function(n,d,f){var m=this.axis,b=m.options,g=this.gridLine,v={},h=this.pos,e=this.type,p=C(this.tickmarkOffset,m.tickmarkOffset),l=m.chart.renderer,I=e?e+"Grid":"grid",u=b[I+"LineWidth"],y=b[I+"LineColor"];b=b[I+"LineDashStyle"];g||(m.chart.styledMode||(v.stroke=y,v["stroke-width"]=u,b&&(v.dashstyle=b)),e||(v.zIndex=
1),n&&(d=0),this.gridLine=g=l.path().attr(v).addClass("highcharts-"+(e?e+"-":"")+"grid-line").add(m.gridGroup));if(g&&(f=m.getPlotLinePath({value:h+p,lineWidth:g.strokeWidth()*f,force:"pass",old:n})))g[n||this.isNew?"attr":"animate"]({d:f,opacity:d})};d.prototype.renderMark=function(n,d,f){var m=this.axis,b=m.options,g=m.chart.renderer,v=this.type,h=v?v+"Tick":"tick",e=m.tickSize(h),p=this.mark,l=!p,I=n.x;n=n.y;var u=C(b[h+"Width"],!v&&m.isXAxis?1:0);b=b[h+"Color"];e&&(m.opposite&&(e[0]=-e[0]),l&&
(this.mark=p=g.path().addClass("highcharts-"+(v?v+"-":"")+"tick").add(m.axisGroup),m.chart.styledMode||p.attr({stroke:b,"stroke-width":u})),p[l?"attr":"animate"]({d:this.getMarkPath(I,n,e[0],p.strokeWidth()*f,m.horiz,g),opacity:d}))};d.prototype.renderLabel=function(n,d,f,m){var b=this.axis,g=b.horiz,v=b.options,h=this.label,e=v.labels,p=e.step;b=C(this.tickmarkOffset,b.tickmarkOffset);var l=!0,I=n.x;n=n.y;h&&x(I)&&(h.xy=n=this.getLabelPosition(I,n,h,g,e,b,m,p),this.isFirst&&!this.isLast&&!C(v.showFirstLabel,
1)||this.isLast&&!this.isFirst&&!C(v.showLastLabel,1)?l=!1:!g||e.step||e.rotation||d||0===f||this.handleOverflow(n),p&&m%p&&(l=!1),l&&x(n.y)?(n.opacity=f,h[this.isNewLabel?"attr":"animate"](n),this.isNewLabel=!1):(h.attr("y",-9999),this.isNewLabel=!0))};d.prototype.replaceMovedLabel=function(){var n=this.label,d=this.axis,f=d.reversed,m=this.axis.chart.inverted;if(n&&!this.isNew){var b=m?n.xy.x:f?d.left:d.width+d.left;f=m?f?d.width+d.top:d.top:n.xy.y;n.animate({x:b,y:f,opacity:0},void 0,n.destroy);
delete this.label}d.isDirty=!0;this.label=this.movedLabel;delete this.movedLabel};return d}();d.Tick=f;return d.Tick});Q(A,"parts/Time.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.defined,q=f.error,M=f.extend,K=f.isObject,J=f.merge,L=f.objectEach,x=f.pad,F=f.pick,H=f.splat,C=f.timeUnits,D=d.win;f=function(){function f(d){this.options={};this.variableTimezone=this.useUTC=!1;this.Date=D.Date;this.getTimezoneOffset=this.timezoneOffsetFunction();this.update(d)}f.prototype.get=
function(d,t){if(this.variableTimezone||this.timezoneOffset){var n=t.getTime(),m=n-this.getTimezoneOffset(t);t.setTime(m);d=t["getUTC"+d]();t.setTime(n);return d}return this.useUTC?t["getUTC"+d]():t["get"+d]()};f.prototype.set=function(d,t,f){if(this.variableTimezone||this.timezoneOffset){if("Milliseconds"===d||"Seconds"===d||"Minutes"===d)return t["setUTC"+d](f);var m=this.getTimezoneOffset(t);m=t.getTime()-m;t.setTime(m);t["setUTC"+d](f);d=this.getTimezoneOffset(t);m=t.getTime()+d;return t.setTime(m)}return this.useUTC?
t["setUTC"+d](f):t["set"+d](f)};f.prototype.update=function(d){var n=F(d&&d.useUTC,!0);this.options=d=J(!0,this.options||{},d);this.Date=d.Date||D.Date||Date;this.timezoneOffset=(this.useUTC=n)&&d.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();this.variableTimezone=!(n&&!d.getTimezoneOffset&&!d.timezone)};f.prototype.makeTime=function(n,f,w,m,b,g){if(this.useUTC){var v=this.Date.UTC.apply(0,arguments);var h=this.getTimezoneOffset(v);v+=h;var e=this.getTimezoneOffset(v);h!==e?
v+=e-h:h-36E5!==this.getTimezoneOffset(v-36E5)||d.isSafari||(v-=36E5)}else v=(new this.Date(n,f,F(w,1),F(m,0),F(b,0),F(g,0))).getTime();return v};f.prototype.timezoneOffsetFunction=function(){var d=this,f=this.options,w=D.moment;if(!this.useUTC)return function(m){return 6E4*(new Date(m.toString())).getTimezoneOffset()};if(f.timezone){if(w)return function(m){return 6E4*-w.tz(m,f.timezone).utcOffset()};q(25)}return this.useUTC&&f.getTimezoneOffset?function(m){return 6E4*f.getTimezoneOffset(m.valueOf())}:
function(){return 6E4*(d.timezoneOffset||0)}};f.prototype.dateFormat=function(n,f,w){var m;if(!E(f)||isNaN(f))return(null===(m=d.defaultOptions.lang)||void 0===m?void 0:m.invalidDate)||"";n=F(n,"%Y-%m-%d %H:%M:%S");var b=this;m=new this.Date(f);var g=this.get("Hours",m),v=this.get("Day",m),h=this.get("Date",m),e=this.get("Month",m),p=this.get("FullYear",m),l=d.defaultOptions.lang,I=null===l||void 0===l?void 0:l.weekdays,u=null===l||void 0===l?void 0:l.shortWeekdays;m=M({a:u?u[v]:I[v].substr(0,3),
A:I[v],d:x(h),e:x(h,2," "),w:v,b:l.shortMonths[e],B:l.months[e],m:x(e+1),o:e+1,y:p.toString().substr(2,2),Y:p,H:x(g),k:g,I:x(g%12||12),l:g%12||12,M:x(this.get("Minutes",m)),p:12>g?"AM":"PM",P:12>g?"am":"pm",S:x(m.getSeconds()),L:x(Math.floor(f%1E3),3)},d.dateFormats);L(m,function(e,l){for(;-1!==n.indexOf("%"+l);)n=n.replace("%"+l,"function"===typeof e?e.call(b,f):e)});return w?n.substr(0,1).toUpperCase()+n.substr(1):n};f.prototype.resolveDTLFormat=function(d){return K(d,!0)?d:(d=H(d),{main:d[0],from:d[1],
to:d[2]})};f.prototype.getTimeTicks=function(d,f,w,m){var b=this,g=[],v={};var h=new b.Date(f);var e=d.unitRange,p=d.count||1,l;m=F(m,1);if(E(f)){b.set("Milliseconds",h,e>=C.second?0:p*Math.floor(b.get("Milliseconds",h)/p));e>=C.second&&b.set("Seconds",h,e>=C.minute?0:p*Math.floor(b.get("Seconds",h)/p));e>=C.minute&&b.set("Minutes",h,e>=C.hour?0:p*Math.floor(b.get("Minutes",h)/p));e>=C.hour&&b.set("Hours",h,e>=C.day?0:p*Math.floor(b.get("Hours",h)/p));e>=C.day&&b.set("Date",h,e>=C.month?1:Math.max(1,
p*Math.floor(b.get("Date",h)/p)));if(e>=C.month){b.set("Month",h,e>=C.year?0:p*Math.floor(b.get("Month",h)/p));var n=b.get("FullYear",h)}e>=C.year&&b.set("FullYear",h,n-n%p);e===C.week&&(n=b.get("Day",h),b.set("Date",h,b.get("Date",h)-n+m+(n<m?-7:0)));n=b.get("FullYear",h);m=b.get("Month",h);var u=b.get("Date",h),y=b.get("Hours",h);f=h.getTime();b.variableTimezone&&(l=w-f>4*C.month||b.getTimezoneOffset(f)!==b.getTimezoneOffset(w));f=h.getTime();for(h=1;f<w;)g.push(f),f=e===C.year?b.makeTime(n+h*p,
0):e===C.month?b.makeTime(n,m+h*p):!l||e!==C.day&&e!==C.week?l&&e===C.hour&&1<p?b.makeTime(n,m,u,y+h*p):f+e*p:b.makeTime(n,m,u+h*p*(e===C.day?1:7)),h++;g.push(f);e<=C.hour&&1E4>g.length&&g.forEach(function(e){0===e%18E5&&"000000000"===b.dateFormat("%H%M%S%L",e)&&(v[e]="day")})}g.info=M(d,{higherRanks:v,totalRange:e*p});return g};f.defaultOptions={Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0};return f}();d.Time=f;return d.Time});Q(A,"parts/Options.js",[A["parts/Globals.js"],
A["parts/Time.js"],A["parts/Color.js"],A["parts/Utilities.js"]],function(d,f,E,q){E=E.parse;var M=q.merge;d.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:f.defaultOptions,chart:{styledMode:!1,borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,
widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},
itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:d.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",
second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:d.isTouchDevice?25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:E("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",
whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};d.setOptions=function(f){d.defaultOptions=M(!0,d.defaultOptions,f);(f.time||f.global)&&d.time.update(M(d.defaultOptions.global,d.defaultOptions.time,f.global,f.time));return d.defaultOptions};d.getOptions=function(){return d.defaultOptions};d.defaultPlotOptions=d.defaultOptions.plotOptions;
d.time=new f(M(d.defaultOptions.global,d.defaultOptions.time));d.dateFormat=function(f,q,L){return d.time.dateFormat(f,q,L)};""});Q(A,"parts/Axis.js",[A["parts/Color.js"],A["parts/Globals.js"],A["parts/Tick.js"],A["parts/Utilities.js"]],function(d,f,E,q){var M=q.addEvent,K=q.animObject,J=q.arrayMax,L=q.arrayMin,x=q.clamp,F=q.correctFloat,H=q.defined,C=q.destroyObjectProperties,D=q.error,w=q.extend,n=q.fireEvent,t=q.format,N=q.getMagnitude,m=q.isArray,b=q.isFunction,g=q.isNumber,v=q.isString,h=q.merge,
e=q.normalizeTickInterval,p=q.objectEach,l=q.pick,I=q.relativeLength,u=q.removeEvent,y=q.splat,G=q.syncTimeout,S=f.defaultOptions,R=f.deg2rad;q=function(){function B(c,a){this.zoomEnabled=this.width=this.visible=this.userOptions=this.translationSlope=this.transB=this.transA=this.top=this.ticks=this.tickRotCorr=this.tickPositions=this.tickmarkOffset=this.tickInterval=this.tickAmount=this.side=this.series=this.right=this.positiveValuesOnly=this.pos=this.pointRangePadding=this.pointRange=this.plotLinesAndBandsGroups=
this.plotLinesAndBands=this.paddedTicks=this.overlap=this.options=this.oldMin=this.oldMax=this.offset=this.names=this.minPixelPadding=this.minorTicks=this.minorTickInterval=this.min=this.maxLabelLength=this.max=this.len=this.left=this.labelFormatter=this.labelEdge=this.isLinked=this.height=this.hasVisibleSeries=this.hasNames=this.coll=this.closestPointRange=this.chart=this.categories=this.bottom=this.alternateBands=void 0;this.init(c,a)}B.prototype.init=function(c,a){var k=a.isX,e=this;e.chart=c;
e.horiz=c.inverted&&!e.isZAxis?!k:k;e.isXAxis=k;e.coll=e.coll||(k?"xAxis":"yAxis");n(this,"init",{userOptions:a});e.opposite=a.opposite;e.side=a.side||(e.horiz?e.opposite?0:2:e.opposite?1:3);e.setOptions(a);var g=this.options,h=g.type;e.labelFormatter=g.labels.formatter||e.defaultLabelFormatter;e.userOptions=a;e.minPixelPadding=0;e.reversed=g.reversed;e.visible=!1!==g.visible;e.zoomEnabled=!1!==g.zoomEnabled;e.hasNames="category"===h||!0===g.categories;e.categories=g.categories||e.hasNames;e.names||
(e.names=[],e.names.keys={});e.plotLinesAndBandsGroups={};e.positiveValuesOnly=!(!e.logarithmic||g.allowNegativeLog);e.isLinked=H(g.linkedTo);e.ticks={};e.labelEdge=[];e.minorTicks={};e.plotLinesAndBands=[];e.alternateBands={};e.len=0;e.minRange=e.userMinRange=g.minRange||g.maxZoom;e.range=g.range;e.offset=g.offset||0;e.max=null;e.min=null;e.crosshair=l(g.crosshair,y(c.options.tooltip.crosshairs)[k?0:1],!1);a=e.options.events;-1===c.axes.indexOf(e)&&(k?c.axes.splice(c.xAxis.length,0,e):c.axes.push(e),
c[e.coll].push(e));e.series=e.series||[];c.inverted&&!e.isZAxis&&k&&"undefined"===typeof e.reversed&&(e.reversed=!0);e.labelRotation=e.options.labels.rotation;p(a,function(a,c){b(a)&&M(e,c,a)});n(this,"afterInit")};B.prototype.setOptions=function(c){this.options=h(B.defaultOptions,"yAxis"===this.coll&&B.defaultYAxisOptions,[B.defaultTopAxisOptions,B.defaultRightAxisOptions,B.defaultBottomAxisOptions,B.defaultLeftAxisOptions][this.side],h(S[this.coll],c));n(this,"afterSetOptions",{userOptions:c})};
B.prototype.defaultLabelFormatter=function(){var c=this.axis,a=this.value,k=c.chart.time,e=c.categories,b=this.dateTimeLabelFormat,l=S.lang,g=l.numericSymbols;l=l.numericSymbolMagnitude||1E3;var h=g&&g.length,p=c.options.labels.format;c=c.logarithmic?Math.abs(a):c.tickInterval;var m=this.chart,u=m.numberFormatter;if(p)var v=t(p,this,m);else if(e)v=a;else if(b)v=k.dateFormat(b,a);else if(h&&1E3<=c)for(;h--&&"undefined"===typeof v;)k=Math.pow(l,h+1),c>=k&&0===10*a%k&&null!==g[h]&&0!==a&&(v=u(a/k,-1)+
g[h]);"undefined"===typeof v&&(v=1E4<=Math.abs(a)?u(a,-1):u(a,-1,void 0,""));return v};B.prototype.getSeriesExtremes=function(){var c=this,a=c.chart,k;n(this,"getSeriesExtremes",null,function(){c.hasVisibleSeries=!1;c.dataMin=c.dataMax=c.threshold=null;c.softThreshold=!c.isXAxis;c.stacking&&c.stacking.buildStacks();c.series.forEach(function(e){if(e.visible||!a.options.chart.ignoreHiddenSeries){var b=e.options,r=b.threshold;c.hasVisibleSeries=!0;c.positiveValuesOnly&&0>=r&&(r=null);if(c.isXAxis){if(b=
e.xData,b.length){k=e.getXExtremes(b);var h=k.min;var p=k.max;g(h)||h instanceof Date||(b=b.filter(g),k=e.getXExtremes(b),h=k.min,p=k.max);b.length&&(c.dataMin=Math.min(l(c.dataMin,h),h),c.dataMax=Math.max(l(c.dataMax,p),p))}}else if(e=e.applyExtremes(),g(e.dataMin)&&(h=e.dataMin,c.dataMin=Math.min(l(c.dataMin,h),h)),g(e.dataMax)&&(p=e.dataMax,c.dataMax=Math.max(l(c.dataMax,p),p)),H(r)&&(c.threshold=r),!b.softThreshold||c.positiveValuesOnly)c.softThreshold=!1}})});n(this,"afterGetSeriesExtremes")};
B.prototype.translate=function(c,a,k,e,b,l){var r=this.linkedParent||this,h=1,p=0,z=e?r.oldTransA:r.transA;e=e?r.oldMin:r.min;var m=r.minPixelPadding;b=(r.isOrdinal||r.brokenAxis&&r.brokenAxis.hasBreaks||r.logarithmic&&b)&&r.lin2val;z||(z=r.transA);k&&(h*=-1,p=r.len);r.reversed&&(h*=-1,p-=h*(r.sector||r.len));a?(c=(c*h+p-m)/z+e,b&&(c=r.lin2val(c))):(b&&(c=r.val2lin(c)),c=g(e)?h*(c-e)*z+p+h*m+(g(l)?z*l:0):void 0);return c};B.prototype.toPixels=function(c,a){return this.translate(c,!1,!this.horiz,null,
!0)+(a?0:this.pos)};B.prototype.toValue=function(c,a){return this.translate(c-(a?0:this.pos),!0,!this.horiz,null,!0)};B.prototype.getPlotLinePath=function(c){function a(a,c,k){if("pass"!==d&&a<c||a>k)d?a=x(a,c,k):B=!0;return a}var k=this,e=k.chart,b=k.left,h=k.top,p=c.old,m=c.value,u=c.translatedValue,v=c.lineWidth,d=c.force,y,O,f,I,G=p&&e.oldChartHeight||e.chartHeight,t=p&&e.oldChartWidth||e.chartWidth,B,w=k.transB;c={value:m,lineWidth:v,old:p,force:d,acrossPanes:c.acrossPanes,translatedValue:u};
n(this,"getPlotLinePath",c,function(c){u=l(u,k.translate(m,null,null,p));u=x(u,-1E5,1E5);y=f=Math.round(u+w);O=I=Math.round(G-u-w);g(u)?k.horiz?(O=h,I=G-k.bottom,y=f=a(y,b,b+k.width)):(y=b,f=t-k.right,O=I=a(O,h,h+k.height)):(B=!0,d=!1);c.path=B&&!d?null:e.renderer.crispLine([["M",y,O],["L",f,I]],v||1)});return c.path};B.prototype.getLinearTickPositions=function(c,a,k){var e=F(Math.floor(a/c)*c);k=F(Math.ceil(k/c)*c);var b=[],l;F(e+c)===e&&(l=20);if(this.single)return[a];for(a=e;a<=k;){b.push(a);a=
F(a+c,l);if(a===g)break;var g=a}return b};B.prototype.getMinorTickInterval=function(){var c=this.options;return!0===c.minorTicks?l(c.minorTickInterval,"auto"):!1===c.minorTicks?null:c.minorTickInterval};B.prototype.getMinorTickPositions=function(){var c=this.options,a=this.tickPositions,k=this.minorTickInterval,e=[],b=this.pointRangePadding||0,l=this.min-b;b=this.max+b;var g=b-l;if(g&&g/k<this.len/3){var h=this.logarithmic;if(h)this.paddedTicks.forEach(function(a,c,b){c&&e.push.apply(e,h.getLogTickPositions(k,
b[c-1],b[c],!0))});else if(this.dateTime&&"auto"===this.getMinorTickInterval())e=e.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(k),l,b,c.startOfWeek));else for(c=l+(a[0]-l)%k;c<=b&&c!==e[0];c+=k)e.push(c)}0!==e.length&&this.trimTicks(e);return e};B.prototype.adjustForMinRange=function(){var c=this.options,a=this.min,k=this.max,e=this.logarithmic,b,g,h,p,u;this.isXAxis&&"undefined"===typeof this.minRange&&!e&&(H(c.min)||H(c.max)?this.minRange=null:(this.series.forEach(function(a){p=
a.xData;for(g=u=a.xIncrement?1:p.length-1;0<g;g--)if(h=p[g]-p[g-1],"undefined"===typeof b||h<b)b=h}),this.minRange=Math.min(5*b,this.dataMax-this.dataMin)));if(k-a<this.minRange){var m=this.dataMax-this.dataMin>=this.minRange;var v=this.minRange;var d=(v-k+a)/2;d=[a-d,l(c.min,a-d)];m&&(d[2]=this.logarithmic?this.logarithmic.log2lin(this.dataMin):this.dataMin);a=J(d);k=[a+v,l(c.max,a+v)];m&&(k[2]=e?e.log2lin(this.dataMax):this.dataMax);k=L(k);k-a<v&&(d[0]=k-v,d[1]=l(c.min,k-v),a=J(d))}this.min=a;this.max=
k};B.prototype.getClosest=function(){var c;this.categories?c=1:this.series.forEach(function(a){var k=a.closestPointRange,e=a.visible||!a.chart.options.chart.ignoreHiddenSeries;!a.noSharedTooltip&&H(k)&&e&&(c=H(c)?Math.min(c,k):k)});return c};B.prototype.nameToX=function(c){var a=m(this.categories),k=a?this.categories:this.names,e=c.options.x;c.series.requireSorting=!1;H(e)||(e=!1===this.options.uniqueNames?c.series.autoIncrement():a?k.indexOf(c.name):l(k.keys[c.name],-1));if(-1===e){if(!a)var b=k.length}else b=
e;"undefined"!==typeof b&&(this.names[b]=c.name,this.names.keys[c.name]=b);return b};B.prototype.updateNames=function(){var c=this,a=this.names;0<a.length&&(Object.keys(a.keys).forEach(function(c){delete a.keys[c]}),a.length=0,this.minRange=this.userMinRange,(this.series||[]).forEach(function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)c.max=Math.max(c.max,a.xData.length-1),a.processData(),a.generatePoints();a.data.forEach(function(e,k){if(e&&e.options&&"undefined"!==typeof e.name){var b=c.nameToX(e);
"undefined"!==typeof b&&b!==e.x&&(e.x=b,a.xData[k]=b)}})}))};B.prototype.setAxisTranslation=function(c){var a=this,e=a.max-a.min,b=a.axisPointRange||0,g=0,h=0,p=a.linkedParent,m=!!a.categories,u=a.transA,d=a.isXAxis;if(d||m||b){var y=a.getClosest();p?(g=p.minPointOffset,h=p.pointRangePadding):a.series.forEach(function(c){var e=m?1:d?l(c.options.pointRange,y,0):a.axisPointRange||0,k=c.options.pointPlacement;b=Math.max(b,e);if(!a.single||m)c=c.is("xrange")?!d:d,g=Math.max(g,c&&v(k)?0:e/2),h=Math.max(h,
c&&"on"===k?0:e)});p=a.ordinal&&a.ordinal.slope&&y?a.ordinal.slope/y:1;a.minPointOffset=g*=p;a.pointRangePadding=h*=p;a.pointRange=Math.min(b,a.single&&m?1:e);d&&(a.closestPointRange=y)}c&&(a.oldTransA=u);a.translationSlope=a.transA=u=a.staticScale||a.len/(e+h||1);a.transB=a.horiz?a.left:a.bottom;a.minPixelPadding=u*g;n(this,"afterSetAxisTranslation")};B.prototype.minFromRange=function(){return this.max-this.range};B.prototype.setTickInterval=function(c){var a=this,k=a.chart,b=a.logarithmic,h=a.options,
p=a.isXAxis,m=a.isLinked,u=h.maxPadding,v=h.minPadding,d=h.tickInterval,y=h.tickPixelInterval,f=a.categories,O=g(a.threshold)?a.threshold:null,I=a.softThreshold;a.dateTime||f||m||this.getTickAmount();var G=l(a.userMin,h.min);var t=l(a.userMax,h.max);if(m){a.linkedParent=k[a.coll][h.linkedTo];var B=a.linkedParent.getExtremes();a.min=l(B.min,B.dataMin);a.max=l(B.max,B.dataMax);h.type!==a.linkedParent.options.type&&D(11,1,k)}else{if(!I&&H(O))if(a.dataMin>=O)B=O,v=0;else if(a.dataMax<=O){var w=O;u=0}a.min=
l(G,B,a.dataMin);a.max=l(t,w,a.dataMax)}b&&(a.positiveValuesOnly&&!c&&0>=Math.min(a.min,l(a.dataMin,a.min))&&D(10,1,k),a.min=F(b.log2lin(a.min),16),a.max=F(b.log2lin(a.max),16));a.range&&H(a.max)&&(a.userMin=a.min=G=Math.max(a.dataMin,a.minFromRange()),a.userMax=t=a.max,a.range=null);n(a,"foundExtremes");a.beforePadding&&a.beforePadding();a.adjustForMinRange();!(f||a.axisPointRange||a.stacking&&a.stacking.usePercentage||m)&&H(a.min)&&H(a.max)&&(k=a.max-a.min)&&(!H(G)&&v&&(a.min-=k*v),!H(t)&&u&&(a.max+=
k*u));g(a.userMin)||(g(h.softMin)&&h.softMin<a.min&&(a.min=G=h.softMin),g(h.floor)&&(a.min=Math.max(a.min,h.floor)));g(a.userMax)||(g(h.softMax)&&h.softMax>a.max&&(a.max=t=h.softMax),g(h.ceiling)&&(a.max=Math.min(a.max,h.ceiling)));I&&H(a.dataMin)&&(O=O||0,!H(G)&&a.min<O&&a.dataMin>=O?a.min=a.options.minRange?Math.min(O,a.max-a.minRange):O:!H(t)&&a.max>O&&a.dataMax<=O&&(a.max=a.options.minRange?Math.max(O,a.min+a.minRange):O));a.tickInterval=a.min===a.max||"undefined"===typeof a.min||"undefined"===
typeof a.max?1:m&&!d&&y===a.linkedParent.options.tickPixelInterval?d=a.linkedParent.tickInterval:l(d,this.tickAmount?(a.max-a.min)/Math.max(this.tickAmount-1,1):void 0,f?1:(a.max-a.min)*y/Math.max(a.len,y));p&&!c&&a.series.forEach(function(c){c.processData(a.min!==a.oldMin||a.max!==a.oldMax)});a.setAxisTranslation(!0);a.beforeSetTickPositions&&a.beforeSetTickPositions();a.ordinal&&(a.tickInterval=a.ordinal.postProcessTickInterval(a.tickInterval));a.pointRange&&!d&&(a.tickInterval=Math.max(a.pointRange,
a.tickInterval));c=l(h.minTickInterval,a.dateTime&&a.closestPointRange);!d&&a.tickInterval<c&&(a.tickInterval=c);a.dateTime||a.logarithmic||d||(a.tickInterval=e(a.tickInterval,void 0,N(a.tickInterval),l(h.allowDecimals,.5>a.tickInterval||void 0!==this.tickAmount),!!this.tickAmount));this.tickAmount||(a.tickInterval=a.unsquish());this.setTickPositions()};B.prototype.setTickPositions=function(){var c=this.options,a=c.tickPositions;var e=this.getMinorTickInterval();var b=c.tickPositioner,l=this.hasVerticalPanning(),
g="colorAxis"===this.coll,h=(g||!l)&&c.startOnTick;l=(g||!l)&&c.endOnTick;this.tickmarkOffset=this.categories&&"between"===c.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===e&&this.tickInterval?this.tickInterval/5:e;this.single=this.min===this.max&&H(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==c.allowDecimals);this.tickPositions=e=a&&a.slice();!e&&(this.ordinal&&this.ordinal.positions||!((this.max-this.min)/this.tickInterval>Math.max(2*this.len,
200))?e=this.dateTime?this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval,c.units),this.min,this.max,c.startOfWeek,this.ordinal&&this.ordinal.positions,this.closestPointRange,!0):this.logarithmic?this.logarithmic.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max):(e=[this.min,this.max],D(19,!1,this.chart)),e.length>this.len&&(e=[e[0],e.pop()],e[0]===e[1]&&(e.length=1)),this.tickPositions=e,b&&(b=b.apply(this,
[this.min,this.max])))&&(this.tickPositions=e=b);this.paddedTicks=e.slice(0);this.trimTicks(e,h,l);this.isLinked||(this.single&&2>e.length&&!this.categories&&!this.series.some(function(a){return a.is("heatmap")&&"between"===a.options.pointPlacement})&&(this.min-=.5,this.max+=.5),a||b||this.adjustTickAmount());n(this,"afterSetTickPositions")};B.prototype.trimTicks=function(c,a,e){var k=c[0],b=c[c.length-1],l=!this.isOrdinal&&this.minPointOffset||0;n(this,"trimTicks");if(!this.isLinked){if(a&&-Infinity!==
k)this.min=k;else for(;this.min-l>c[0];)c.shift();if(e)this.max=b;else for(;this.max+l<c[c.length-1];)c.pop();0===c.length&&H(k)&&!this.options.tickPositions&&c.push((b+k)/2)}};B.prototype.alignToOthers=function(){var c={},a,e=this.options;!1===this.chart.options.chart.alignTicks||!1===e.alignTicks||!1===e.startOnTick||!1===e.endOnTick||this.logarithmic||this.chart[this.coll].forEach(function(e){var k=e.options;k=[e.horiz?k.left:k.top,k.width,k.height,k.pane].join();e.series.length&&(c[k]?a=!0:c[k]=
1)});return a};B.prototype.getTickAmount=function(){var c=this.options,a=c.tickAmount,e=c.tickPixelInterval;!H(c.tickInterval)&&!a&&this.len<e&&!this.isRadial&&!this.logarithmic&&c.startOnTick&&c.endOnTick&&(a=2);!a&&this.alignToOthers()&&(a=Math.ceil(this.len/e)+1);4>a&&(this.finalTickAmt=a,a=5);this.tickAmount=a};B.prototype.adjustTickAmount=function(){var c=this.options,a=this.tickInterval,e=this.tickPositions,b=this.tickAmount,g=this.finalTickAmt,h=e&&e.length,p=l(this.threshold,this.softThreshold?
0:null),m;if(this.hasData()){if(h<b){for(m=this.min;e.length<b;)e.length%2||m===p?e.push(F(e[e.length-1]+a)):e.unshift(F(e[0]-a));this.transA*=(h-1)/(b-1);this.min=c.startOnTick?e[0]:Math.min(this.min,e[0]);this.max=c.endOnTick?e[e.length-1]:Math.max(this.max,e[e.length-1])}else h>b&&(this.tickInterval*=2,this.setTickPositions());if(H(g)){for(a=c=e.length;a--;)(3===g&&1===a%2||2>=g&&0<a&&a<c-1)&&e.splice(a,1);this.finalTickAmt=void 0}}};B.prototype.setScale=function(){var c,a=!1,e=!1;this.series.forEach(function(c){var k;
a=a||c.isDirtyData||c.isDirty;e=e||(null===(k=c.xAxis)||void 0===k?void 0:k.isDirty)||!1});this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();(c=this.len!==this.oldAxisLength)||a||e||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.stacking&&this.stacking.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,
this.isDirty||(this.isDirty=c||this.min!==this.oldMin||this.max!==this.oldMax)):this.stacking&&this.stacking.cleanStacks();a&&this.panningState&&(this.panningState.isDirty=!0);n(this,"afterSetScale")};B.prototype.setExtremes=function(c,a,e,b,g){var k=this,h=k.chart;e=l(e,!0);k.series.forEach(function(a){delete a.kdTree});g=w(g,{min:c,max:a});n(k,"setExtremes",g,function(){k.userMin=c;k.userMax=a;k.eventArgs=g;e&&h.redraw(b)})};B.prototype.zoom=function(c,a){var e=this,b=this.dataMin,g=this.dataMax,
h=this.options,p=Math.min(b,l(h.min,b)),m=Math.max(g,l(h.max,g));c={newMin:c,newMax:a};n(this,"zoom",c,function(a){var c=a.newMin,k=a.newMax;if(c!==e.min||k!==e.max)e.allowZoomOutside||(H(b)&&(c<p&&(c=p),c>m&&(c=m)),H(g)&&(k<p&&(k=p),k>m&&(k=m))),e.displayBtn="undefined"!==typeof c||"undefined"!==typeof k,e.setExtremes(c,k,!1,void 0,{trigger:"zoom"});a.zoomed=!0});return c.zoomed};B.prototype.setAxisSize=function(){var c=this.chart,a=this.options,e=a.offsets||[0,0,0,0],b=this.horiz,g=this.width=Math.round(I(l(a.width,
c.plotWidth-e[3]+e[1]),c.plotWidth)),h=this.height=Math.round(I(l(a.height,c.plotHeight-e[0]+e[2]),c.plotHeight)),p=this.top=Math.round(I(l(a.top,c.plotTop+e[0]),c.plotHeight,c.plotTop));a=this.left=Math.round(I(l(a.left,c.plotLeft+e[3]),c.plotWidth,c.plotLeft));this.bottom=c.chartHeight-h-p;this.right=c.chartWidth-g-a;this.len=Math.max(b?g:h,0);this.pos=b?a:p};B.prototype.getExtremes=function(){var c=this.logarithmic;return{min:c?F(c.lin2log(this.min)):this.min,max:c?F(c.lin2log(this.max)):this.max,
dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}};B.prototype.getThreshold=function(c){var a=this.logarithmic,e=a?a.lin2log(this.min):this.min;a=a?a.lin2log(this.max):this.max;null===c||-Infinity===c?c=e:Infinity===c?c=a:e>c?c=e:a<c&&(c=a);return this.translate(c,0,1,0,1)};B.prototype.autoLabelAlign=function(c){var a=(l(c,0)-90*this.side+720)%360;c={align:"center"};n(this,"autoLabelAlign",c,function(c){15<a&&165>a?c.align="right":195<a&&345>a&&(c.align="left")});
return c.align};B.prototype.tickSize=function(c){var a=this.options,e=a["tick"===c?"tickLength":"minorTickLength"],b=l(a["tick"===c?"tickWidth":"minorTickWidth"],"tick"===c&&this.isXAxis&&!this.categories?1:0);if(b&&e){"inside"===a[c+"Position"]&&(e=-e);var g=[e,b]}c={tickSize:g};n(this,"afterTickSize",c);return c.tickSize};B.prototype.labelMetrics=function(){var c=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,
this.ticks[c]&&this.ticks[c].label)};B.prototype.unsquish=function(){var c=this.options.labels,a=this.horiz,e=this.tickInterval,b=e,g=this.len/(((this.categories?1:0)+this.max-this.min)/e),h,p=c.rotation,m=this.labelMetrics(),u,v=Number.MAX_VALUE,d,y=this.max-this.min,f=function(a){var c=a/(g||1);c=1<c?Math.ceil(c):1;c*e>y&&Infinity!==a&&Infinity!==g&&y&&(c=Math.ceil(y/e));return F(c*e)};a?(d=!c.staggerLines&&!c.step&&(H(p)?[p]:g<l(c.autoRotationLimit,80)&&c.autoRotation))&&d.forEach(function(a){if(a===
p||a&&-90<=a&&90>=a){u=f(Math.abs(m.h/Math.sin(R*a)));var c=u+Math.abs(a/360);c<v&&(v=c,h=a,b=u)}}):c.step||(b=f(m.h));this.autoRotation=d;this.labelRotation=l(h,p);return b};B.prototype.getSlotWidth=function(c){var a,e=this.chart,b=this.horiz,l=this.options.labels,h=Math.max(this.tickPositions.length-(this.categories?0:1),1),p=e.margin[3];if(c&&g(c.slotWidth))return c.slotWidth;if(b&&l&&2>(l.step||0))return l.rotation?0:(this.staggerLines||1)*this.len/h;if(!b){c=null===(a=null===l||void 0===l?void 0:
l.style)||void 0===a?void 0:a.width;if(void 0!==c)return parseInt(c,10);if(p)return p-e.spacing[3]}return.33*e.chartWidth};B.prototype.renderUnsquish=function(){var c=this.chart,a=c.renderer,e=this.tickPositions,b=this.ticks,l=this.options.labels,g=l&&l.style||{},h=this.horiz,p=this.getSlotWidth(),m=Math.max(1,Math.round(p-2*(l.padding||5))),u={},d=this.labelMetrics(),y=l.style&&l.style.textOverflow,f=0;v(l.rotation)||(u.rotation=l.rotation||0);e.forEach(function(a){a=b[a];a.movedLabel&&a.replaceMovedLabel();
a&&a.label&&a.label.textPxLength>f&&(f=a.label.textPxLength)});this.maxLabelLength=f;if(this.autoRotation)f>m&&f>d.h?u.rotation=this.labelRotation:this.labelRotation=0;else if(p){var n=m;if(!y){var I="clip";for(m=e.length;!h&&m--;){var G=e[m];if(G=b[G].label)G.styles&&"ellipsis"===G.styles.textOverflow?G.css({textOverflow:"clip"}):G.textPxLength>p&&G.css({width:p+"px"}),G.getBBox().height>this.len/e.length-(d.h-d.f)&&(G.specificTextOverflow="ellipsis")}}}u.rotation&&(n=f>.5*c.chartHeight?.33*c.chartHeight:
f,y||(I="ellipsis"));if(this.labelAlign=l.align||this.autoLabelAlign(this.labelRotation))u.align=this.labelAlign;e.forEach(function(a){var c=(a=b[a])&&a.label,e=g.width,k={};c&&(c.attr(u),a.shortenLabel?a.shortenLabel():n&&!e&&"nowrap"!==g.whiteSpace&&(n<c.textPxLength||"SPAN"===c.element.tagName)?(k.width=n+"px",y||(k.textOverflow=c.specificTextOverflow||I),c.css(k)):c.styles&&c.styles.width&&!k.width&&!e&&c.css({width:null}),delete c.specificTextOverflow,a.rotation=u.rotation)},this);this.tickRotCorr=
a.rotCorr(d.b,this.labelRotation||0,0!==this.side)};B.prototype.hasData=function(){return this.series.some(function(c){return c.hasData()})||this.options.showEmpty&&H(this.min)&&H(this.max)};B.prototype.addTitle=function(c){var a=this.chart.renderer,e=this.horiz,b=this.opposite,l=this.options.title,g,p=this.chart.styledMode;this.axisTitle||((g=l.textAlign)||(g=(e?{low:"left",middle:"center",high:"right"}:{low:b?"right":"left",middle:"center",high:b?"left":"right"})[l.align]),this.axisTitle=a.text(l.text,
0,0,l.useHTML).attr({zIndex:7,rotation:l.rotation||0,align:g}).addClass("highcharts-axis-title"),p||this.axisTitle.css(h(l.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);p||l.style.width||this.isRadial||this.axisTitle.css({width:this.len+"px"});this.axisTitle[c?"show":"hide"](c)};B.prototype.generateTick=function(c){var a=this.ticks;a[c]?a[c].addLabel():a[c]=new E(this,c)};B.prototype.getOffset=function(){var c=this,a=c.chart,e=a.renderer,b=c.options,g=c.tickPositions,h=c.ticks,
m=c.horiz,u=c.side,v=a.inverted&&!c.isZAxis?[1,0,3,2][u]:u,d,y=0,f=0,O=b.title,I=b.labels,G=0,t=a.axisOffset;a=a.clipOffset;var B=[-1,1,1,-1][u],w=b.className,S=c.axisParent;var R=c.hasData();c.showAxis=d=R||l(b.showEmpty,!0);c.staggerLines=c.horiz&&I.staggerLines;c.axisGroup||(c.gridGroup=e.g("grid").attr({zIndex:b.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(w||"")).add(S),c.axisGroup=e.g("axis").attr({zIndex:b.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+
" "+(w||"")).add(S),c.labelGroup=e.g("axis-labels").attr({zIndex:I.zIndex||7}).addClass("highcharts-"+c.coll.toLowerCase()+"-labels "+(w||"")).add(S));R||c.isLinked?(g.forEach(function(a,e){c.generateTick(a,e)}),c.renderUnsquish(),c.reserveSpaceDefault=0===u||2===u||{1:"left",3:"right"}[u]===c.labelAlign,l(I.reserveSpace,"center"===c.labelAlign?!0:null,c.reserveSpaceDefault)&&g.forEach(function(a){G=Math.max(h[a].getLabelSize(),G)}),c.staggerLines&&(G*=c.staggerLines),c.labelOffset=G*(c.opposite?
-1:1)):p(h,function(a,c){a.destroy();delete h[c]});if(O&&O.text&&!1!==O.enabled&&(c.addTitle(d),d&&!1!==O.reserveSpace)){c.titleOffset=y=c.axisTitle.getBBox()[m?"height":"width"];var x=O.offset;f=H(x)?0:l(O.margin,m?5:10)}c.renderLine();c.offset=B*l(b.offset,t[u]?t[u]+(b.margin||0):0);c.tickRotCorr=c.tickRotCorr||{x:0,y:0};e=0===u?-c.labelMetrics().h:2===u?c.tickRotCorr.y:0;f=Math.abs(G)+f;G&&(f=f-e+B*(m?l(I.y,c.tickRotCorr.y+8*B):I.x));c.axisTitleMargin=l(x,f);c.getMaxLabelDimensions&&(c.maxLabelDimensions=
c.getMaxLabelDimensions(h,g));m=this.tickSize("tick");t[u]=Math.max(t[u],c.axisTitleMargin+y+B*c.offset,f,g&&g.length&&m?m[0]+B*c.offset:0);b=b.offset?0:2*Math.floor(c.axisLine.strokeWidth()/2);a[v]=Math.max(a[v],b);n(this,"afterGetOffset")};B.prototype.getLinePath=function(c){var a=this.chart,e=this.opposite,b=this.offset,l=this.horiz,g=this.left+(e?this.width:0)+b;b=a.chartHeight-this.bottom-(e?this.height:0)+b;e&&(c*=-1);return a.renderer.crispLine([["M",l?this.left:g,l?b:this.top],["L",l?a.chartWidth-
this.right:g,l?b:a.chartHeight-this.bottom]],c)};B.prototype.renderLine=function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))};B.prototype.getTitlePosition=function(){var c=this.horiz,a=this.left,e=this.top,b=this.len,l=this.options.title,g=c?a:e,h=this.opposite,p=this.offset,m=l.x||0,u=l.y||0,d=this.axisTitle,
v=this.chart.renderer.fontMetrics(l.style&&l.style.fontSize,d);d=Math.max(d.getBBox(null,0).height-v.h-1,0);b={low:g+(c?0:b),middle:g+b/2,high:g+(c?b:0)}[l.align];a=(c?e+this.height:a)+(c?1:-1)*(h?-1:1)*this.axisTitleMargin+[-d,d,v.f,-d][this.side];c={x:c?b+m:a+(h?this.width:0)+p+m,y:c?a+u-(h?this.height:0)+p:b+u};n(this,"afterGetTitlePosition",{titlePosition:c});return c};B.prototype.renderMinorTick=function(c){var a=this.chart.hasRendered&&g(this.oldMin),e=this.minorTicks;e[c]||(e[c]=new E(this,
c,"minor"));a&&e[c].isNew&&e[c].render(null,!0);e[c].render(null,!1,1)};B.prototype.renderTick=function(c,a){var e=this.isLinked,b=this.ticks,l=this.chart.hasRendered&&g(this.oldMin);if(!e||c>=this.min&&c<=this.max)b[c]||(b[c]=new E(this,c)),l&&b[c].isNew&&b[c].render(a,!0,-1),b[c].render(a)};B.prototype.render=function(){var c=this,a=c.chart,e=c.logarithmic,b=c.options,l=c.isLinked,h=c.tickPositions,m=c.axisTitle,u=c.ticks,d=c.minorTicks,v=c.alternateBands,y=b.stackLabels,I=b.alternateGridColor,
O=c.tickmarkOffset,t=c.axisLine,B=c.showAxis,w=K(a.renderer.globalAnimation),S,R;c.labelEdge.length=0;c.overlap=!1;[u,d,v].forEach(function(a){p(a,function(a){a.isActive=!1})});if(c.hasData()||l)c.minorTickInterval&&!c.categories&&c.getMinorTickPositions().forEach(function(a){c.renderMinorTick(a)}),h.length&&(h.forEach(function(a,e){c.renderTick(a,e)}),O&&(0===c.min||c.single)&&(u[-1]||(u[-1]=new E(c,-1,null,!0)),u[-1].render(-1))),I&&h.forEach(function(k,b){R="undefined"!==typeof h[b+1]?h[b+1]+O:
c.max-O;0===b%2&&k<c.max&&R<=c.max+(a.polar?-O:O)&&(v[k]||(v[k]=new f.PlotLineOrBand(c)),S=k+O,v[k].options={from:e?e.lin2log(S):S,to:e?e.lin2log(R):R,color:I},v[k].render(),v[k].isActive=!0)}),c._addedPlotLB||((b.plotLines||[]).concat(b.plotBands||[]).forEach(function(a){c.addPlotBandOrLine(a)}),c._addedPlotLB=!0);[u,d,v].forEach(function(c){var e,k=[],b=w.duration;p(c,function(a,c){a.isActive||(a.render(c,!1,0),a.isActive=!1,k.push(c))});G(function(){for(e=k.length;e--;)c[k[e]]&&!c[k[e]].isActive&&
(c[k[e]].destroy(),delete c[k[e]])},c!==v&&a.hasRendered&&b?b:0)});t&&(t[t.isPlaced?"animate":"attr"]({d:this.getLinePath(t.strokeWidth())}),t.isPlaced=!0,t[B?"show":"hide"](B));m&&B&&(b=c.getTitlePosition(),g(b.y)?(m[m.isNew?"attr":"animate"](b),m.isNew=!1):(m.attr("y",-9999),m.isNew=!0));y&&y.enabled&&c.stacking&&c.stacking.renderStackTotals();c.isDirty=!1;n(this,"afterRender")};B.prototype.redraw=function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(c){c.render()}));this.series.forEach(function(c){c.isDirty=
!0})};B.prototype.getKeepProps=function(){return this.keepProps||B.keepProps};B.prototype.destroy=function(c){var a=this,e=a.plotLinesAndBands,b;n(this,"destroy",{keepEvents:c});c||u(a);[a.ticks,a.minorTicks,a.alternateBands].forEach(function(a){C(a)});if(e)for(c=e.length;c--;)e[c].destroy();"axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(c){a[c]&&(a[c]=a[c].destroy())});for(b in a.plotLinesAndBandsGroups)a.plotLinesAndBandsGroups[b]=a.plotLinesAndBandsGroups[b].destroy();
p(a,function(c,e){-1===a.getKeepProps().indexOf(e)&&delete a[e]})};B.prototype.drawCrosshair=function(c,a){var e=this.crosshair,b=l(e.snap,!0),g,h=this.cross,p=this.chart;n(this,"drawCrosshair",{e:c,point:a});c||(c=this.cross&&this.cross.e);if(this.crosshair&&!1!==(H(a)||!b)){b?H(a)&&(g=l("colorAxis"!==this.coll?a.crosshairPos:null,this.isXAxis?a.plotX:this.len-a.plotY)):g=c&&(this.horiz?c.chartX-this.pos:this.len-c.chartY+this.pos);if(H(g)){var m={value:a&&(this.isXAxis?a.x:l(a.stackY,a.y)),translatedValue:g};
p.polar&&w(m,{isCrosshair:!0,chartX:c&&c.chartX,chartY:c&&c.chartY,point:a});m=this.getPlotLinePath(m)||null}if(!H(m)){this.hideCrosshair();return}b=this.categories&&!this.isRadial;h||(this.cross=h=p.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+e.className).attr({zIndex:l(e.zIndex,2)}).add(),p.styledMode||(h.attr({stroke:e.color||(b?d.parse("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":l(e.width,1)}).css({"pointer-events":"none"}),e.dashStyle&&
h.attr({dashstyle:e.dashStyle})));h.show().attr({d:m});b&&!e.width&&h.attr({"stroke-width":this.transA});this.cross.e=c}else this.hideCrosshair();n(this,"afterDrawCrosshair",{e:c,point:a})};B.prototype.hideCrosshair=function(){this.cross&&this.cross.hide();n(this,"afterHideCrosshair")};B.prototype.hasVerticalPanning=function(){var c,a;return/y/.test((null===(a=null===(c=this.chart.options.chart)||void 0===c?void 0:c.panning)||void 0===a?void 0:a.type)||"")};B.defaultOptions={dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"};B.defaultYAxisOptions={endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){var c=this.axis.chart.numberFormatter;return c(this.total,
-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0};B.defaultLeftAxisOptions={labels:{x:-15},title:{rotation:270}};B.defaultRightAxisOptions={labels:{x:15},title:{rotation:90}};B.defaultBottomAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};B.defaultTopAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};B.keepProps="extKey hcEvents names series userMax userMin".split(" ");return B}();
f.Axis=q;return f.Axis});Q(A,"parts/DateTimeAxis.js",[A["parts/Axis.js"],A["parts/Utilities.js"]],function(d,f){var E=f.addEvent,q=f.getMagnitude,M=f.normalizeTickInterval,K=f.timeUnits,J=function(){function d(d){this.axis=d}d.prototype.normalizeTimeTickInterval=function(d,f){var x=f||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];f=x[x.length-1];var C=
K[f[0]],D=f[1],w;for(w=0;w<x.length&&!(f=x[w],C=K[f[0]],D=f[1],x[w+1]&&d<=(C*D[D.length-1]+K[x[w+1][0]])/2);w++);C===K.year&&d<5*C&&(D=[1,2,5]);d=M(d/C,D,"year"===f[0]?Math.max(q(d/C),1):1);return{unitRange:C,count:d,unitName:f[0]}};return d}();f=function(){function d(){}d.compose=function(d){d.keepProps.push("dateTime");d.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};E(d,"init",function(d){"datetime"!==d.userOptions.type?this.dateTime=void 0:
this.dateTime||(this.dateTime=new J(this))})};d.AdditionsClass=J;return d}();f.compose(d);return f});Q(A,"parts/LogarithmicAxis.js",[A["parts/Axis.js"],A["parts/Utilities.js"]],function(d,f){var E=f.addEvent,q=f.getMagnitude,M=f.normalizeTickInterval,K=f.pick,J=function(){function d(d){this.axis=d}d.prototype.getLogTickPositions=function(d,f,H,C){var x=this.axis,w=x.len,n=x.options,t=[];C||(this.minorAutoInterval=void 0);if(.5<=d)d=Math.round(d),t=x.getLinearTickPositions(d,f,H);else if(.08<=d){n=
Math.floor(f);var N,m;for(w=.3<d?[1,2,4]:.15<d?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];n<H+1&&!m;n++){var b=w.length;for(N=0;N<b&&!m;N++){var g=this.log2lin(this.lin2log(n)*w[N]);g>f&&(!C||v<=H)&&"undefined"!==typeof v&&t.push(v);v>H&&(m=!0);var v=g}}}else f=this.lin2log(f),H=this.lin2log(H),d=C?x.getMinorTickInterval():n.tickInterval,d=K("auto"===d?null:d,this.minorAutoInterval,n.tickPixelInterval/(C?5:1)*(H-f)/((C?w/x.tickPositions.length:w)||1)),d=M(d,void 0,q(d)),t=x.getLinearTickPositions(d,f,H).map(this.log2lin),
C||(this.minorAutoInterval=d/5);C||(x.tickInterval=d);return t};d.prototype.lin2log=function(d){return Math.pow(10,d)};d.prototype.log2lin=function(d){return Math.log(d)/Math.LN10};return d}();f=function(){function d(){}d.compose=function(d){d.keepProps.push("logarithmic");var f=d.prototype,x=J.prototype;f.log2lin=x.log2lin;f.lin2log=x.lin2log;E(d,"init",function(d){var f=this.logarithmic;"logarithmic"!==d.userOptions.type?this.logarithmic=void 0:(f||(f=this.logarithmic=new J(this)),this.log2lin!==
f.log2lin&&(f.log2lin=this.log2lin.bind(this)),this.lin2log!==f.lin2log&&(f.lin2log=this.lin2log.bind(this)))});E(d,"afterInit",function(){var d=this.logarithmic;d&&(this.lin2val=function(f){return d.lin2log(f)},this.val2lin=function(f){return d.log2lin(f)})})};return d}();f.compose(d);return f});Q(A,"parts/PlotLineOrBand.js",[A["parts/Globals.js"],A["parts/Axis.js"],A["parts/Utilities.js"]],function(d,f,E){var q=E.arrayMax,M=E.arrayMin,K=E.defined,J=E.destroyObjectProperties,L=E.erase,x=E.extend,
F=E.merge,H=E.objectEach,C=E.pick,D=function(){function f(d,f){this.axis=d;f&&(this.options=f,this.id=f.id)}f.prototype.render=function(){d.fireEvent(this,"render");var f=this,t=f.axis,w=t.horiz,m=t.logarithmic,b=f.options,g=b.label,v=f.label,h=b.to,e=b.from,p=b.value,l=K(e)&&K(h),I=K(p),u=f.svgElem,y=!u,G=[],S=b.color,R=C(b.zIndex,0),B=b.events;G={"class":"highcharts-plot-"+(l?"band ":"line ")+(b.className||"")};var c={},a=t.chart.renderer,k=l?"bands":"lines";m&&(e=m.log2lin(e),h=m.log2lin(h),p=
m.log2lin(p));t.chart.styledMode||(I?(G.stroke=S||"#999999",G["stroke-width"]=C(b.width,1),b.dashStyle&&(G.dashstyle=b.dashStyle)):l&&(G.fill=S||"#e6ebf5",b.borderWidth&&(G.stroke=b.borderColor,G["stroke-width"]=b.borderWidth)));c.zIndex=R;k+="-"+R;(m=t.plotLinesAndBandsGroups[k])||(t.plotLinesAndBandsGroups[k]=m=a.g("plot-"+k).attr(c).add());y&&(f.svgElem=u=a.path().attr(G).add(m));if(I)G=t.getPlotLinePath({value:p,lineWidth:u.strokeWidth(),acrossPanes:b.acrossPanes});else if(l)G=t.getPlotBandPath(e,
h,b);else return;(y||!u.d)&&G&&G.length?(u.attr({d:G}),B&&H(B,function(a,c){u.on(c,function(a){B[c].apply(f,[a])})})):u&&(G?(u.show(!0),u.animate({d:G})):u.d&&(u.hide(),v&&(f.label=v=v.destroy())));g&&(K(g.text)||K(g.formatter))&&G&&G.length&&0<t.width&&0<t.height&&!G.isFlat?(g=F({align:w&&l&&"center",x:w?!l&&4:10,verticalAlign:!w&&l&&"middle",y:w?l?16:10:l?6:-4,rotation:w&&!l&&90},g),this.renderLabel(g,G,l,R)):v&&v.hide();return f};f.prototype.renderLabel=function(d,f,w,m){var b=this.label,g=this.axis.chart.renderer;
b||(b={align:d.textAlign||d.align,rotation:d.rotation,"class":"highcharts-plot-"+(w?"band":"line")+"-label "+(d.className||"")},b.zIndex=m,m=this.getLabelText(d),this.label=b=g.text(m,0,0,d.useHTML).attr(b).add(),this.axis.chart.styledMode||b.css(d.style));g=f.xBounds||[f[0][1],f[1][1],w?f[2][1]:f[0][1]];f=f.yBounds||[f[0][2],f[1][2],w?f[2][2]:f[0][2]];w=M(g);m=M(f);b.align(d,!1,{x:w,y:m,width:q(g)-w,height:q(f)-m});b.show(!0)};f.prototype.getLabelText=function(d){return K(d.formatter)?d.formatter.call(this):
d.text};f.prototype.destroy=function(){L(this.axis.plotLinesAndBands,this);delete this.axis;J(this)};return f}();x(f.prototype,{getPlotBandPath:function(d,f){var n=this.getPlotLinePath({value:f,force:!0,acrossPanes:this.options.acrossPanes}),w=this.getPlotLinePath({value:d,force:!0,acrossPanes:this.options.acrossPanes}),m=[],b=this.horiz,g=1;d=d<this.min&&f<this.min||d>this.max&&f>this.max;if(w&&n){if(d){var v=w.toString()===n.toString();g=0}for(d=0;d<w.length;d+=2){f=w[d];var h=w[d+1],e=n[d],p=n[d+
1];"M"!==f[0]&&"L"!==f[0]||"M"!==h[0]&&"L"!==h[0]||"M"!==e[0]&&"L"!==e[0]||"M"!==p[0]&&"L"!==p[0]||(b&&e[1]===f[1]?(e[1]+=g,p[1]+=g):b||e[2]!==f[2]||(e[2]+=g,p[2]+=g),m.push(["M",f[1],f[2]],["L",h[1],h[2]],["L",p[1],p[2]],["L",e[1],e[2]],["Z"]));m.isFlat=v}}return m},addPlotBand:function(d){return this.addPlotBandOrLine(d,"plotBands")},addPlotLine:function(d){return this.addPlotBandOrLine(d,"plotLines")},addPlotBandOrLine:function(d,f){var n=(new D(this,d)).render(),w=this.userOptions;if(n){if(f){var m=
w[f]||[];m.push(d);w[f]=m}this.plotLinesAndBands.push(n)}return n},removePlotBandOrLine:function(d){for(var f=this.plotLinesAndBands,t=this.options,w=this.userOptions,m=f.length;m--;)f[m].id===d&&f[m].destroy();[t.plotLines||[],w.plotLines||[],t.plotBands||[],w.plotBands||[]].forEach(function(b){for(m=b.length;m--;)(b[m]||{}).id===d&&L(b,b[m])})},removePlotBand:function(d){this.removePlotBandOrLine(d)},removePlotLine:function(d){this.removePlotBandOrLine(d)}});d.PlotLineOrBand=D;return d.PlotLineOrBand});
Q(A,"parts/Tooltip.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.clamp,q=f.css,M=f.defined,K=f.discardElement,J=f.extend,L=f.fireEvent,x=f.format,F=f.isNumber,H=f.isString,C=f.merge,D=f.pick,w=f.splat,n=f.syncTimeout,t=f.timeUnits;"";var N=d.doc,m=function(){function b(b,d){this.crosshairs=[];this.distance=0;this.isHidden=!0;this.isSticky=!1;this.now={};this.options={};this.outside=!1;this.chart=b;this.init(b,d)}b.prototype.applyFilter=function(){var b=this.chart;b.renderer.definition({tagName:"filter",
id:"drop-shadow-"+b.index,opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});b.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+b.index+"{filter:url(#drop-shadow-"+b.index+")}"})};b.prototype.bodyFormatter=function(b){return b.map(function(b){var g=
b.series.tooltipOptions;return(g[(b.point.formatPrefix||"point")+"Formatter"]||b.point.tooltipFormatter).call(b.point,g[(b.point.formatPrefix||"point")+"Format"]||"")})};b.prototype.cleanSplit=function(b){this.chart.series.forEach(function(g){var h=g&&g.tt;h&&(!h.isActive||b?g.tt=h.destroy():h.isActive=!1)})};b.prototype.defaultFormatter=function(b){var g=this.points||w(this);var h=[b.tooltipFooterHeaderFormatter(g[0])];h=h.concat(b.bodyFormatter(g));h.push(b.tooltipFooterHeaderFormatter(g[0],!0));
return h};b.prototype.destroy=function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),K(this.container));f.clearTimeout(this.hideTimer);f.clearTimeout(this.tooltipTimeout)};b.prototype.getAnchor=function(b,d){var g=this.chart,e=g.pointer,p=g.inverted,l=g.plotTop,m=g.plotLeft,u=0,f=0,v,n;b=w(b);this.followPointer&&d?("undefined"===typeof d.chartX&&(d=e.normalize(d)),
b=[d.chartX-m,d.chartY-l]):b[0].tooltipPos?b=b[0].tooltipPos:(b.forEach(function(e){v=e.series.yAxis;n=e.series.xAxis;u+=e.plotX+(!p&&n?n.left-m:0);f+=(e.plotLow?(e.plotLow+e.plotHigh)/2:e.plotY)+(!p&&v?v.top-l:0)}),u/=b.length,f/=b.length,b=[p?g.plotWidth-f:u,this.shared&&!p&&1<b.length&&d?d.chartY-l:p?g.plotHeight-u:f]);return b.map(Math.round)};b.prototype.getDateFormat=function(b,d,h,e){var g=this.chart.time,l=g.dateFormat("%m-%d %H:%M:%S.%L",d),m={millisecond:15,second:12,minute:9,hour:6,day:3},
u="millisecond";for(f in t){if(b===t.week&&+g.dateFormat("%w",d)===h&&"00:00:00.000"===l.substr(6)){var f="week";break}if(t[f]>b){f=u;break}if(m[f]&&l.substr(m[f])!=="01-01 00:00:00.000".substr(m[f]))break;"week"!==f&&(u=f)}if(f)var v=g.resolveDTLFormat(e[f]).main;return v};b.prototype.getLabel=function(){var b,m,h=this,e=this.chart.renderer,p=this.chart.styledMode,l=this.options,f="tooltip"+(M(l.className)?" "+l.className:""),u=(null===(b=l.style)||void 0===b?void 0:b.pointerEvents)||(!this.followPointer&&
l.stickOnContact?"auto":"none"),y;b=function(){h.inContact=!0};var G=function(){var e=h.chart.hoverSeries;h.inContact=!1;if(e&&e.onMouseOut)e.onMouseOut()};if(!this.label){this.outside&&(this.container=y=d.doc.createElement("div"),y.className="highcharts-tooltip-container",q(y,{position:"absolute",top:"1px",pointerEvents:u,zIndex:3}),d.doc.body.appendChild(y),this.renderer=e=new d.Renderer(y,0,0,null===(m=this.chart.options.chart)||void 0===m?void 0:m.style,void 0,void 0,e.styledMode));this.split?
this.label=e.g(f):(this.label=e.label("",0,0,l.shape||"callout",null,null,l.useHTML,null,f).attr({padding:l.padding,r:l.borderRadius}),p||this.label.attr({fill:l.backgroundColor,"stroke-width":l.borderWidth}).css(l.style).css({pointerEvents:u}).shadow(l.shadow));p&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index));if(h.outside&&!h.split){var n={x:this.label.xSetter,y:this.label.ySetter};this.label.xSetter=function(e,b){n[b].call(this.label,h.distance);y.style.left=e+
"px"};this.label.ySetter=function(e,b){n[b].call(this.label,h.distance);y.style.top=e+"px"}}this.label.on("mouseenter",b).on("mouseleave",G).attr({zIndex:8}).add()}return this.label};b.prototype.getPosition=function(b,d,h){var e=this.chart,g=this.distance,l={},m=e.inverted&&h.h||0,u,f=this.outside,v=f?N.documentElement.clientWidth-2*g:e.chartWidth,n=f?Math.max(N.body.scrollHeight,N.documentElement.scrollHeight,N.body.offsetHeight,N.documentElement.offsetHeight,N.documentElement.clientHeight):e.chartHeight,
t=e.pointer.getChartPosition(),B=e.containerScaling,c=function(a){return B?a*B.scaleX:a},a=function(a){return B?a*B.scaleY:a},k=function(k){var l="x"===k;return[k,l?v:n,l?b:d].concat(f?[l?c(b):a(d),l?t.left-g+c(h.plotX+e.plotLeft):t.top-g+a(h.plotY+e.plotTop),0,l?v:n]:[l?b:d,l?h.plotX+e.plotLeft:h.plotY+e.plotTop,l?e.plotLeft:e.plotTop,l?e.plotLeft+e.plotWidth:e.plotTop+e.plotHeight])},r=k("y"),z=k("x"),w=!this.followPointer&&D(h.ttBelow,!e.inverted===!!h.negative),x=function(e,b,k,h,p,r,d){var u=
"y"===e?a(g):c(g),f=(k-h)/2,v=h<p-g,y=p+g+h<b,z=p-u-k+f;p=p+u-f;if(w&&y)l[e]=p;else if(!w&&v)l[e]=z;else if(v)l[e]=Math.min(d-h,0>z-m?z:z-m);else if(y)l[e]=Math.max(r,p+m+k>b?p:p+m);else return!1},C=function(a,c,e,b,k){var h;k<g||k>c-g?h=!1:l[a]=k<e/2?1:k>c-b/2?c-b-2:k-e/2;return h},q=function(a){var c=r;r=z;z=c;u=a},T=function(){!1!==x.apply(0,r)?!1!==C.apply(0,z)||u||(q(!0),T()):u?l.x=l.y=0:(q(!0),T())};(e.inverted||1<this.len)&&q();T();return l};b.prototype.getXDateFormat=function(b,d,h){d=d.dateTimeLabelFormats;
var e=h&&h.closestPointRange;return(e?this.getDateFormat(e,b.x,h.options.startOfWeek,d):d.day)||d.year};b.prototype.hide=function(b){var g=this;f.clearTimeout(this.hideTimer);b=D(b,this.options.hideDelay,500);this.isHidden||(this.hideTimer=n(function(){g.getLabel().fadeOut(b?void 0:b);g.isHidden=!0},b))};b.prototype.init=function(b,d){this.chart=b;this.options=d;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=d.split&&!b.inverted&&!b.polar;this.shared=d.shared||this.split;this.outside=
D(d.outside,!(!b.scrollablePixelsX&&!b.scrollablePixelsY))};b.prototype.isStickyOnContact=function(){return!(this.followPointer||!this.options.stickOnContact||!this.inContact)};b.prototype.move=function(b,d,h,e){var g=this,l=g.now,m=!1!==g.options.animation&&!g.isHidden&&(1<Math.abs(b-l.x)||1<Math.abs(d-l.y)),u=g.followPointer||1<g.len;J(l,{x:m?(2*l.x+b)/3:b,y:m?(l.y+d)/2:d,anchorX:u?void 0:m?(2*l.anchorX+h)/3:h,anchorY:u?void 0:m?(l.anchorY+e)/2:e});g.getLabel().attr(l);g.drawTracker();m&&(f.clearTimeout(this.tooltipTimeout),
this.tooltipTimeout=setTimeout(function(){g&&g.move(b,d,h,e)},32))};b.prototype.refresh=function(b,d){var h=this.chart,e=this.options,g=b,l={},m=[],u=e.formatter||this.defaultFormatter;l=this.shared;var v=h.styledMode;if(e.enabled){f.clearTimeout(this.hideTimer);this.followPointer=w(g)[0].series.tooltipOptions.followPointer;var n=this.getAnchor(g,d);d=n[0];var t=n[1];!l||g.series&&g.series.noSharedTooltip?l=g.getLabelConfig():(h.pointer.applyInactiveState(g),g.forEach(function(e){e.setState("hover");
m.push(e.getLabelConfig())}),l={x:g[0].category,y:g[0].y},l.points=m,g=g[0]);this.len=m.length;h=u.call(l,this);u=g.series;this.distance=D(u.tooltipOptions.distance,16);!1===h?this.hide():(this.split?this.renderSplit(h,w(b)):(b=this.getLabel(),e.style.width&&!v||b.css({width:this.chart.spacingBox.width+"px"}),b.attr({text:h&&h.join?h.join(""):h}),b.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+D(g.colorIndex,u.colorIndex)),v||b.attr({stroke:e.borderColor||g.color||u.color||"#666666"}),
this.updatePosition({plotX:d,plotY:t,negative:g.negative,ttBelow:g.ttBelow,h:n[2]||0})),this.isHidden&&this.label&&this.label.attr({opacity:1}).show(),this.isHidden=!1);L(this,"refresh")}};b.prototype.renderSplit=function(b,m){function g(a,c,e,b,k){void 0===k&&(k=!0);e?(c=C?0:F,a=E(a-b/2,x.left,x.right-b)):(c-=T,a=k?a-b-r:a+r,a=E(a,k?a:x.left,x.right));return{x:a,y:c}}var e=this,p=e.chart,l=e.chart,f=l.plotHeight,u=l.plotLeft,v=l.plotTop,n=l.pointer,t=l.renderer,w=l.scrollablePixelsY,B=void 0===w?
0:w;w=l.scrollingContainer;w=void 0===w?{scrollLeft:0,scrollTop:0}:w;var c=w.scrollLeft,a=w.scrollTop,k=l.styledMode,r=e.distance,z=e.options,P=e.options.positioner,x={left:c,right:c+l.chartWidth,top:a,bottom:a+l.chartHeight},q=e.getLabel(),C=!(!p.xAxis[0]||!p.xAxis[0].opposite),T=v+a,N=0,F=f-B;H(b)&&(b=[!1,b]);b=b.slice(0,m.length+1).reduce(function(c,b,l){if(!1!==b&&""!==b){l=m[l-1]||{isHeader:!0,plotX:m[0].plotX,plotY:f,series:{}};var h=l.isHeader,d=h?e:l.series,p=d.tt,y=l.isHeader;var n=l.series;
var G="highcharts-color-"+D(l.colorIndex,n.colorIndex,"none");p||(p={padding:z.padding,r:z.borderRadius},k||(p.fill=z.backgroundColor,p["stroke-width"]=z.borderWidth),p=t.label("",0,0,z[y?"headerShape":"shape"]||"callout",void 0,void 0,z.useHTML).addClass((y?"highcharts-tooltip-header ":"")+"highcharts-tooltip-box "+G).attr(p).add(q));p.isActive=!0;p.attr({text:b});k||p.css(z.style).shadow(z.shadow).attr({stroke:z.borderColor||l.color||n.color||"#333333"});b=d.tt=p;y=b.getBBox();d=y.width+b.strokeWidth();
h&&(N=y.height,F+=N,C&&(T-=N));n=l.plotX;n=void 0===n?0:n;G=l.plotY;G=void 0===G?0:G;var O=l.series;if(l.isHeader){n=u+n;var I=v+f/2}else p=O.xAxis,O=O.yAxis,n=p.pos+E(n,-r,p.len+r),O.pos+G>=a+v&&O.pos+G<=a+v+f-B&&(I=O.pos+G);n=E(n,x.left-r,x.right+r);"number"===typeof I?(y=y.height+1,G=P?P.call(e,d,y,l):g(n,I,h,d),c.push({align:P?0:void 0,anchorX:n,anchorY:I,boxWidth:d,point:l,rank:D(G.rank,h?1:0),size:y,target:G.y,tt:b,x:G.x})):b.isActive=!1}return c},[]);!P&&b.some(function(a){return a.x<x.left})&&
(b=b.map(function(a){var c=g(a.anchorX,a.anchorY,a.point.isHeader,a.boxWidth,!1);return J(a,{target:c.y,x:c.x})}));e.cleanSplit();d.distribute(b,F);b.forEach(function(a){var c=a.pos;a.tt.attr({visibility:"undefined"===typeof c?"hidden":"inherit",x:a.x,y:c+T,anchorX:a.anchorX,anchorY:a.anchorY})});b=e.container;p=e.renderer;e.outside&&b&&p&&(l=q.getBBox(),p.setSize(l.width+l.x,l.height+l.y,!1),n=n.getChartPosition(),b.style.left=n.left+"px",b.style.top=n.top+"px")};b.prototype.drawTracker=function(){if(this.followPointer||
!this.options.stickOnContact)this.tracker&&this.tracker.destroy();else{var b=this.chart,d=this.label,h=b.hoverPoint;if(d&&h){var e={x:0,y:0,width:0,height:0};h=this.getAnchor(h);var p=d.getBBox();h[0]+=b.plotLeft-d.translateX;h[1]+=b.plotTop-d.translateY;e.x=Math.min(0,h[0]);e.y=Math.min(0,h[1]);e.width=0>h[0]?Math.max(Math.abs(h[0]),p.width-h[0]):Math.max(Math.abs(h[0]),p.width);e.height=0>h[1]?Math.max(Math.abs(h[1]),p.height-Math.abs(h[1])):Math.max(Math.abs(h[1]),p.height);this.tracker?this.tracker.attr(e):
(this.tracker=d.renderer.rect(e).addClass("highcharts-tracker").add(d),b.styledMode||this.tracker.attr({fill:"rgba(0,0,0,0)"}))}}};b.prototype.styledModeFormat=function(b){return b.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')};b.prototype.tooltipFooterHeaderFormatter=function(b,d){var h=d?"footer":"header",e=b.series,g=e.tooltipOptions,l=g.xDateFormat,m=e.xAxis,u=m&&"datetime"===m.options.type&&
F(b.key),f=g[h+"Format"];d={isFooter:d,labelConfig:b};L(this,"headerFormatter",d,function(h){u&&!l&&(l=this.getXDateFormat(b,g,m));u&&l&&(b.point&&b.point.tooltipDateKeys||["key"]).forEach(function(e){f=f.replace("{point."+e+"}","{point."+e+":"+l+"}")});e.chart.styledMode&&(f=this.styledModeFormat(f));h.text=x(f,{point:b,series:e},this.chart)});return d.text};b.prototype.update=function(b){this.destroy();C(!0,this.chart.options.tooltip.userOptions,b);this.init(this.chart,C(!0,this.options,b))};b.prototype.updatePosition=
function(b){var g=this.chart,h=g.pointer,e=this.getLabel(),d=b.plotX+g.plotLeft,l=b.plotY+g.plotTop;h=h.getChartPosition();b=(this.options.positioner||this.getPosition).call(this,e.width,e.height,b);if(this.outside){var m=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(e.width+m,e.height+m,!1);if(g=g.containerScaling)q(this.container,{transform:"scale("+g.scaleX+", "+g.scaleY+")"}),d*=g.scaleX,l*=g.scaleY;d+=h.left-b.x;l+=h.top-b.y}this.move(Math.round(b.x),Math.round(b.y||0),
d,l)};return b}();d.Tooltip=m;return d.Tooltip});Q(A,"parts/Pointer.js",[A["parts/Globals.js"],A["parts/Utilities.js"],A["parts/Tooltip.js"],A["parts/Color.js"]],function(d,f,E,q){var M=f.addEvent,K=f.attr,J=f.css,L=f.defined,x=f.extend,F=f.find,H=f.fireEvent,C=f.isNumber,D=f.isObject,w=f.objectEach,n=f.offset,t=f.pick,N=f.splat,m=q.parse,b=d.charts,g=d.noop;f=function(){function f(b,e){this.lastValidTouch={};this.pinchDown=[];this.runChartClick=!1;this.chart=b;this.hasDragged=!1;this.options=e;this.unbindContainerMouseLeave=
function(){};this.init(b,e)}f.prototype.applyInactiveState=function(b){var e=[],h;(b||[]).forEach(function(b){h=b.series;e.push(h);h.linkedParent&&e.push(h.linkedParent);h.linkedSeries&&(e=e.concat(h.linkedSeries));h.navigatorSeries&&e.push(h.navigatorSeries)});this.chart.series.forEach(function(b){-1===e.indexOf(b)?b.setState("inactive",!0):b.options.inactiveOtherPoints&&b.setAllPointsToState("inactive")})};f.prototype.destroy=function(){var b=this;"undefined"!==typeof b.unDocMouseMove&&b.unDocMouseMove();
this.unbindContainerMouseLeave();d.chartCount||(d.unbindDocumentMouseUp&&(d.unbindDocumentMouseUp=d.unbindDocumentMouseUp()),d.unbindDocumentTouchEnd&&(d.unbindDocumentTouchEnd=d.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);w(b,function(e,h){b[h]=null})};f.prototype.drag=function(b){var e=this.chart,h=e.options.chart,l=b.chartX,g=b.chartY,d=this.zoomHor,f=this.zoomVert,v=e.plotLeft,n=e.plotTop,t=e.plotWidth,B=e.plotHeight,c=this.selectionMarker,a=this.mouseDownX||0,k=this.mouseDownY||
0,r=D(h.panning)?h.panning&&h.panning.enabled:h.panning,z=h.panKey&&b[h.panKey+"Key"];if(!c||!c.touch)if(l<v?l=v:l>v+t&&(l=v+t),g<n?g=n:g>n+B&&(g=n+B),this.hasDragged=Math.sqrt(Math.pow(a-l,2)+Math.pow(k-g,2)),10<this.hasDragged){var w=e.isInsidePlot(a-v,k-n);e.hasCartesianSeries&&(this.zoomX||this.zoomY)&&w&&!z&&!c&&(this.selectionMarker=c=e.renderer.rect(v,n,d?1:t,f?1:B,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),e.styledMode||c.attr({fill:h.selectionMarkerFill||m("#335cad").setOpacity(.25).get()}));
c&&d&&(l-=a,c.attr({width:Math.abs(l),x:(0<l?0:l)+a}));c&&f&&(l=g-k,c.attr({height:Math.abs(l),y:(0<l?0:l)+k}));w&&!c&&r&&e.pan(b,h.panning)}};f.prototype.dragStart=function(b){var e=this.chart;e.mouseIsDown=b.type;e.cancelClick=!1;e.mouseDownX=this.mouseDownX=b.chartX;e.mouseDownY=this.mouseDownY=b.chartY};f.prototype.drop=function(b){var e=this,h=this.chart,l=this.hasPinched;if(this.selectionMarker){var g={originalEvent:b,xAxis:[],yAxis:[]},d=this.selectionMarker,m=d.attr?d.attr("x"):d.x,f=d.attr?
d.attr("y"):d.y,v=d.attr?d.attr("width"):d.width,n=d.attr?d.attr("height"):d.height,B;if(this.hasDragged||l)h.axes.forEach(function(c){if(c.zoomEnabled&&L(c.min)&&(l||e[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var a=c.horiz,k="touchend"===b.type?c.minPixelPadding:0,h=c.toValue((a?m:f)+k);a=c.toValue((a?m+v:f+n)-k);g[c.coll].push({axis:c,min:Math.min(h,a),max:Math.max(h,a)});B=!0}}),B&&H(h,"selection",g,function(c){h.zoom(x(c,l?{animation:!1}:null))});C(h.index)&&(this.selectionMarker=this.selectionMarker.destroy());
l&&this.scaleGroups()}h&&C(h.index)&&(J(h.container,{cursor:h._cursor}),h.cancelClick=10<this.hasDragged,h.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])};f.prototype.findNearestKDPoint=function(b,e,g){var l=this.chart,h=l.hoverPoint;l=l.tooltip;if(h&&l&&l.isStickyOnContact())return h;var d;b.forEach(function(b){var l=!(b.noSharedTooltip&&e)&&0>b.options.findNearestPointBy.indexOf("y");b=b.searchPoint(g,l);if((l=D(b,!0))&&!(l=!D(d,!0))){l=d.distX-b.distX;var h=d.dist-b.dist,p=(b.series.group&&
b.series.group.zIndex)-(d.series.group&&d.series.group.zIndex);l=0<(0!==l&&e?l:0!==h?h:0!==p?p:d.series.index>b.series.index?-1:1)}l&&(d=b)});return d};f.prototype.getChartCoordinatesFromPoint=function(b,e){var h=b.series,l=h.xAxis;h=h.yAxis;var g=t(b.clientX,b.plotX),d=b.shapeArgs;if(l&&h)return e?{chartX:l.len+l.pos-g,chartY:h.len+h.pos-b.plotY}:{chartX:g+l.pos,chartY:b.plotY+h.pos};if(d&&d.x&&d.y)return{chartX:d.x,chartY:d.y}};f.prototype.getChartPosition=function(){return this.chartPosition||
(this.chartPosition=n(this.chart.container))};f.prototype.getCoordinates=function(b){var e={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(h){e[h.isXAxis?"xAxis":"yAxis"].push({axis:h,value:h.toValue(b[h.horiz?"chartX":"chartY"])})});return e};f.prototype.getHoverData=function(b,e,g,l,d,m){var h,p=[];l=!(!l||!b);var f=e&&!e.stickyTracking,u={chartX:m?m.chartX:void 0,chartY:m?m.chartY:void 0,shared:d};H(this,"beforeGetHoverData",u);f=f?[e]:g.filter(function(e){return u.filter?u.filter(e):e.visible&&
!(!d&&e.directTouch)&&t(e.options.enableMouseTracking,!0)&&e.stickyTracking});e=(h=l||!m?b:this.findNearestKDPoint(f,d,m))&&h.series;h&&(d&&!e.noSharedTooltip?(f=g.filter(function(e){return u.filter?u.filter(e):e.visible&&!(!d&&e.directTouch)&&t(e.options.enableMouseTracking,!0)&&!e.noSharedTooltip}),f.forEach(function(e){var c=F(e.points,function(a){return a.x===h.x&&!a.isNull});D(c)&&(e.chart.isBoosting&&(c=e.getPoint(c)),p.push(c))})):p.push(h));u={hoverPoint:h};H(this,"afterGetHoverData",u);return{hoverPoint:u.hoverPoint,
hoverSeries:e,hoverPoints:p}};f.prototype.getPointFromEvent=function(b){b=b.target;for(var e;b&&!e;)e=b.point,b=b.parentNode;return e};f.prototype.onTrackerMouseOut=function(b){b=b.relatedTarget||b.toElement;var e=this.chart.hoverSeries;this.isDirectTouch=!1;if(!(!e||!b||e.stickyTracking||this.inClass(b,"highcharts-tooltip")||this.inClass(b,"highcharts-series-"+e.index)&&this.inClass(b,"highcharts-tracker")))e.onMouseOut()};f.prototype.inClass=function(b,e){for(var g;b;){if(g=K(b,"class")){if(-1!==
g.indexOf(e))return!0;if(-1!==g.indexOf("highcharts-container"))return!1}b=b.parentNode}};f.prototype.init=function(b,e){this.options=e;this.chart=b;this.runChartClick=e.chart.events&&!!e.chart.events.click;this.pinchDown=[];this.lastValidTouch={};E&&(b.tooltip=new E(b,e.tooltip),this.followTouchMove=t(e.tooltip.followTouchMove,!0));this.setDOMEvents()};f.prototype.normalize=function(b,e){var g=b.touches,l=g?g.length?g.item(0):g.changedTouches[0]:b;e||(e=this.getChartPosition());g=l.pageX-e.left;
e=l.pageY-e.top;if(l=this.chart.containerScaling)g/=l.scaleX,e/=l.scaleY;return x(b,{chartX:Math.round(g),chartY:Math.round(e)})};f.prototype.onContainerClick=function(b){var e=this.chart,g=e.hoverPoint;b=this.normalize(b);var l=e.plotLeft,h=e.plotTop;e.cancelClick||(g&&this.inClass(b.target,"highcharts-tracker")?(H(g.series,"click",x(b,{point:g})),e.hoverPoint&&g.firePointEvent("click",b)):(x(b,this.getCoordinates(b)),e.isInsidePlot(b.chartX-l,b.chartY-h)&&H(e,"click",b)))};f.prototype.onContainerMouseDown=
function(b){b=this.normalize(b);if(d.isFirefox&&0!==b.button)this.onContainerMouseMove(b);if("undefined"===typeof b.button||1===((b.buttons||b.button)&1))this.zoomOption(b),this.dragStart(b)};f.prototype.onContainerMouseLeave=function(g){var e=b[t(d.hoverChartIndex,-1)],h=this.chart.tooltip;g=this.normalize(g);e&&(g.relatedTarget||g.toElement)&&(e.pointer.reset(),e.pointer.chartPosition=void 0);h&&!h.isHidden&&this.reset()};f.prototype.onContainerMouseMove=function(b){var e=this.chart;b=this.normalize(b);
this.setHoverChartIndex();b.preventDefault||(b.returnValue=!1);"mousedown"===e.mouseIsDown&&this.drag(b);e.openMenu||!this.inClass(b.target,"highcharts-tracker")&&!e.isInsidePlot(b.chartX-e.plotLeft,b.chartY-e.plotTop)||this.runPointActions(b)};f.prototype.onDocumentTouchEnd=function(g){b[d.hoverChartIndex]&&b[d.hoverChartIndex].pointer.drop(g)};f.prototype.onContainerTouchMove=function(b){this.touch(b)};f.prototype.onContainerTouchStart=function(b){this.zoomOption(b);this.touch(b,!0)};f.prototype.onDocumentMouseMove=
function(b){var e=this.chart,g=this.chartPosition;b=this.normalize(b,g);var l=e.tooltip;!g||l&&l.isStickyOnContact()||e.isInsidePlot(b.chartX-e.plotLeft,b.chartY-e.plotTop)||this.inClass(b.target,"highcharts-tracker")||this.reset()};f.prototype.onDocumentMouseUp=function(g){var e=b[t(d.hoverChartIndex,-1)];e&&e.pointer.drop(g)};f.prototype.pinch=function(b){var e=this,h=e.chart,l=e.pinchDown,d=b.touches||[],m=d.length,f=e.lastValidTouch,v=e.hasZoom,n=e.selectionMarker,w={},B=1===m&&(e.inClass(b.target,
"highcharts-tracker")&&h.runTrackerClick||e.runChartClick),c={};1<m&&(e.initiated=!0);v&&e.initiated&&!B&&b.preventDefault();[].map.call(d,function(a){return e.normalize(a)});"touchstart"===b.type?([].forEach.call(d,function(a,c){l[c]={chartX:a.chartX,chartY:a.chartY}}),f.x=[l[0].chartX,l[1]&&l[1].chartX],f.y=[l[0].chartY,l[1]&&l[1].chartY],h.axes.forEach(function(a){if(a.zoomEnabled){var c=h.bounds[a.horiz?"h":"v"],e=a.minPixelPadding,b=a.toPixels(Math.min(t(a.options.min,a.dataMin),a.dataMin)),
l=a.toPixels(Math.max(t(a.options.max,a.dataMax),a.dataMax)),g=Math.max(b,l);c.min=Math.min(a.pos,Math.min(b,l)-e);c.max=Math.max(a.pos+a.len,g+e)}}),e.res=!0):e.followTouchMove&&1===m?this.runPointActions(e.normalize(b)):l.length&&(n||(e.selectionMarker=n=x({destroy:g,touch:!0},h.plotBox)),e.pinchTranslate(l,d,w,n,c,f),e.hasPinched=v,e.scaleGroups(w,c),e.res&&(e.res=!1,this.reset(!1,0)))};f.prototype.pinchTranslate=function(b,e,g,l,d,m){this.zoomHor&&this.pinchTranslateDirection(!0,b,e,g,l,d,m);
this.zoomVert&&this.pinchTranslateDirection(!1,b,e,g,l,d,m)};f.prototype.pinchTranslateDirection=function(b,e,g,l,d,m,f,v){var h=this.chart,p=b?"x":"y",u=b?"X":"Y",c="chart"+u,a=b?"width":"height",k=h["plot"+(b?"Left":"Top")],r,z,y=v||1,n=h.inverted,G=h.bounds[b?"h":"v"],t=1===e.length,w=e[0][c],I=g[0][c],x=!t&&e[1][c],O=!t&&g[1][c];g=function(){"number"===typeof O&&20<Math.abs(w-x)&&(y=v||Math.abs(I-O)/Math.abs(w-x));z=(k-I)/y+w;r=h["plot"+(b?"Width":"Height")]/y};g();e=z;if(e<G.min){e=G.min;var V=
!0}else e+r>G.max&&(e=G.max-r,V=!0);V?(I-=.8*(I-f[p][0]),"number"===typeof O&&(O-=.8*(O-f[p][1])),g()):f[p]=[I,O];n||(m[p]=z-k,m[a]=r);m=n?1/y:y;d[a]=r;d[p]=e;l[n?b?"scaleY":"scaleX":"scale"+u]=y;l["translate"+u]=m*k+(I-m*w)};f.prototype.reset=function(b,e){var g=this.chart,l=g.hoverSeries,d=g.hoverPoint,h=g.hoverPoints,m=g.tooltip,f=m&&m.shared?h:d;b&&f&&N(f).forEach(function(e){e.series.isCartesian&&"undefined"===typeof e.plotX&&(b=!1)});if(b)m&&f&&N(f).length&&(m.refresh(f),m.shared&&h?h.forEach(function(e){e.setState(e.state,
!0);e.series.isCartesian&&(e.series.xAxis.crosshair&&e.series.xAxis.drawCrosshair(null,e),e.series.yAxis.crosshair&&e.series.yAxis.drawCrosshair(null,e))}):d&&(d.setState(d.state,!0),g.axes.forEach(function(e){e.crosshair&&d.series[e.coll]===e&&e.drawCrosshair(null,d)})));else{if(d)d.onMouseOut();h&&h.forEach(function(e){e.setState()});if(l)l.onMouseOut();m&&m.hide(e);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());g.axes.forEach(function(e){e.hideCrosshair()});this.hoverX=g.hoverPoints=
g.hoverPoint=null}};f.prototype.runPointActions=function(g,e){var h=this.chart,l=h.tooltip&&h.tooltip.options.enabled?h.tooltip:void 0,m=l?l.shared:!1,f=e||h.hoverPoint,y=f&&f.series||h.hoverSeries;y=this.getHoverData(f,y,h.series,(!g||"touchmove"!==g.type)&&(!!e||y&&y.directTouch&&this.isDirectTouch),m,g);f=y.hoverPoint;var v=y.hoverPoints;e=(y=y.hoverSeries)&&y.tooltipOptions.followPointer;m=m&&y&&!y.noSharedTooltip;if(f&&(f!==h.hoverPoint||l&&l.isHidden)){(h.hoverPoints||[]).forEach(function(e){-1===
v.indexOf(e)&&e.setState()});if(h.hoverSeries!==y)y.onMouseOver();this.applyInactiveState(v);(v||[]).forEach(function(e){e.setState("hover")});h.hoverPoint&&h.hoverPoint.firePointEvent("mouseOut");if(!f.series)return;f.firePointEvent("mouseOver");h.hoverPoints=v;h.hoverPoint=f;l&&l.refresh(m?v:f,g)}else e&&l&&!l.isHidden&&(f=l.getAnchor([{}],g),l.updatePosition({plotX:f[0],plotY:f[1]}));this.unDocMouseMove||(this.unDocMouseMove=M(h.container.ownerDocument,"mousemove",function(e){var l=b[d.hoverChartIndex];
if(l)l.pointer.onDocumentMouseMove(e)}));h.axes.forEach(function(e){var b=t((e.crosshair||{}).snap,!0),l;b&&((l=h.hoverPoint)&&l.series[e.coll]===e||(l=F(v,function(c){return c.series[e.coll]===e})));l||!b?e.drawCrosshair(g,l):e.hideCrosshair()})};f.prototype.scaleGroups=function(b,e){var g=this.chart,l;g.series.forEach(function(d){l=b||d.getPlotBox();d.xAxis&&d.xAxis.zoomEnabled&&d.group&&(d.group.attr(l),d.markerGroup&&(d.markerGroup.attr(l),d.markerGroup.clip(e?g.clipRect:null)),d.dataLabelsGroup&&
d.dataLabelsGroup.attr(l))});g.clipRect.attr(e||g.clipBox)};f.prototype.setDOMEvents=function(){var b=this.chart.container,e=b.ownerDocument;b.onmousedown=this.onContainerMouseDown.bind(this);b.onmousemove=this.onContainerMouseMove.bind(this);b.onclick=this.onContainerClick.bind(this);this.unbindContainerMouseLeave=M(b,"mouseleave",this.onContainerMouseLeave.bind(this));d.unbindDocumentMouseUp||(d.unbindDocumentMouseUp=M(e,"mouseup",this.onDocumentMouseUp.bind(this)));d.hasTouch&&(M(b,"touchstart",
this.onContainerTouchStart.bind(this)),M(b,"touchmove",this.onContainerTouchMove.bind(this)),d.unbindDocumentTouchEnd||(d.unbindDocumentTouchEnd=M(e,"touchend",this.onDocumentTouchEnd.bind(this))))};f.prototype.setHoverChartIndex=function(){var b=this.chart,e=d.charts[t(d.hoverChartIndex,-1)];if(e&&e!==b)e.pointer.onContainerMouseLeave({relatedTarget:!0});e&&e.mouseIsDown||(d.hoverChartIndex=b.index)};f.prototype.touch=function(b,e){var g=this.chart,l;this.setHoverChartIndex();if(1===b.touches.length)if(b=
this.normalize(b),(l=g.isInsidePlot(b.chartX-g.plotLeft,b.chartY-g.plotTop))&&!g.openMenu){e&&this.runPointActions(b);if("touchmove"===b.type){e=this.pinchDown;var d=e[0]?4<=Math.sqrt(Math.pow(e[0].chartX-b.chartX,2)+Math.pow(e[0].chartY-b.chartY,2)):!1}t(d,!0)&&this.pinch(b)}else e&&this.reset();else 2===b.touches.length&&this.pinch(b)};f.prototype.zoomOption=function(b){var e=this.chart,g=e.options.chart,l=g.zoomType||"";e=e.inverted;/touch/.test(b.type)&&(l=t(g.pinchType,l));this.zoomX=b=/x/.test(l);
this.zoomY=l=/y/.test(l);this.zoomHor=b&&!e||l&&e;this.zoomVert=l&&!e||b&&e;this.hasZoom=b||l};return f}();d.Pointer=f;return d.Pointer});Q(A,"parts/MSPointer.js",[A["parts/Globals.js"],A["parts/Pointer.js"],A["parts/Utilities.js"]],function(d,f,E){function q(){var d=[];d.item=function(d){return this[d]};x(w,function(f){d.push({pageX:f.pageX,pageY:f.pageY,target:f.target})});return d}function M(f,n,m,b){"touch"!==f.pointerType&&f.pointerType!==f.MSPOINTER_TYPE_TOUCH||!H[d.hoverChartIndex]||(b(f),
b=H[d.hoverChartIndex].pointer,b[n]({type:m,target:f.currentTarget,preventDefault:D,touches:q()}))}var K=this&&this.__extends||function(){var d=function(f,m){d=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(b,g){b.__proto__=g}||function(b,g){for(var d in g)g.hasOwnProperty(d)&&(b[d]=g[d])};return d(f,m)};return function(f,m){function b(){this.constructor=f}d(f,m);f.prototype=null===m?Object.create(m):(b.prototype=m.prototype,new b)}}(),J=E.addEvent,L=E.css,x=E.objectEach,F=E.removeEvent,
H=d.charts,C=d.doc,D=d.noop,w={},n=!!d.win.PointerEvent;return function(d){function f(){return null!==d&&d.apply(this,arguments)||this}K(f,d);f.prototype.batchMSEvents=function(d){d(this.chart.container,n?"pointerdown":"MSPointerDown",this.onContainerPointerDown);d(this.chart.container,n?"pointermove":"MSPointerMove",this.onContainerPointerMove);d(C,n?"pointerup":"MSPointerUp",this.onDocumentPointerUp)};f.prototype.destroy=function(){this.batchMSEvents(F);d.prototype.destroy.call(this)};f.prototype.init=
function(m,b){d.prototype.init.call(this,m,b);this.hasZoom&&L(m.container,{"-ms-touch-action":"none","touch-action":"none"})};f.prototype.onContainerPointerDown=function(d){M(d,"onContainerTouchStart","touchstart",function(b){w[b.pointerId]={pageX:b.pageX,pageY:b.pageY,target:b.currentTarget}})};f.prototype.onContainerPointerMove=function(d){M(d,"onContainerTouchMove","touchmove",function(b){w[b.pointerId]={pageX:b.pageX,pageY:b.pageY};w[b.pointerId].target||(w[b.pointerId].target=b.currentTarget)})};
f.prototype.onDocumentPointerUp=function(d){M(d,"onDocumentTouchEnd","touchend",function(b){delete w[b.pointerId]})};f.prototype.setDOMEvents=function(){d.prototype.setDOMEvents.call(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(J)};return f}(f)});Q(A,"parts/Legend.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.addEvent,q=f.animObject,M=f.css,K=f.defined,J=f.discardElement,L=f.find,x=f.fireEvent,F=f.format,H=f.isNumber,C=f.merge,D=f.pick,w=f.relativeLength,
n=f.setAnimation,t=f.stableSort,N=f.syncTimeout;f=f.wrap;var m=d.isFirefox,b=d.marginNames,g=d.win,v=function(){function g(e,b){this.allItems=[];this.contentGroup=this.box=void 0;this.display=!1;this.group=void 0;this.offsetWidth=this.maxLegendWidth=this.maxItemWidth=this.legendWidth=this.legendHeight=this.lastLineHeight=this.lastItemY=this.itemY=this.itemX=this.itemMarginTop=this.itemMarginBottom=this.itemHeight=this.initialItemY=0;this.options={};this.padding=0;this.pages=[];this.proximate=!1;this.scrollGroup=
void 0;this.widthOption=this.totalItemWidth=this.titleHeight=this.symbolWidth=this.symbolHeight=0;this.chart=e;this.init(e,b)}g.prototype.init=function(e,b){this.chart=e;this.setOptions(b);b.enabled&&(this.render(),E(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=E(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())};g.prototype.setOptions=function(e){var b=D(e.padding,
8);this.options=e;this.chart.styledMode||(this.itemStyle=e.itemStyle,this.itemHiddenStyle=C(this.itemStyle,e.itemHiddenStyle));this.itemMarginTop=e.itemMarginTop||0;this.itemMarginBottom=e.itemMarginBottom||0;this.padding=b;this.initialItemY=b-5;this.symbolWidth=D(e.symbolWidth,16);this.pages=[];this.proximate="proximate"===e.layout&&!this.chart.inverted;this.baseline=void 0};g.prototype.update=function(e,b){var g=this.chart;this.setOptions(C(!0,this.options,e));this.destroy();g.isDirtyLegend=g.isDirtyBox=
!0;D(b,!0)&&g.redraw();x(this,"afterUpdate")};g.prototype.colorizeItem=function(e,b){e.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var g=this.options,d=e.legendItem,h=e.legendLine,m=e.legendSymbol,f=this.itemHiddenStyle.color;g=b?g.itemStyle.color:f;var p=b?e.color||f:f,v=e.options&&e.options.marker,n={fill:p};d&&d.css({fill:g,color:g});h&&h.attr({stroke:p});m&&(v&&m.isMarker&&(n=e.pointAttribs(),b||(n.stroke=n.fill=f)),m.attr(n))}x(this,"afterColorizeItem",
{item:e,visible:b})};g.prototype.positionItems=function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()};g.prototype.positionItem=function(e){var b=this.options,g=b.symbolPadding;b=!b.rtl;var d=e._legendItemPos,h=d[0];d=d[1];var m=e.checkbox;if((e=e.legendGroup)&&e.element)e[K(e.translateY)?"animate":"attr"]({translateX:b?h:this.legendWidth-h-2*g-4,translateY:d});m&&(m.x=h,m.y=d)};g.prototype.destroyItem=function(e){var b=e.checkbox;["legendItem","legendLine",
"legendSymbol","legendGroup"].forEach(function(b){e[b]&&(e[b]=e[b].destroy())});b&&J(e.checkbox)};g.prototype.destroy=function(){function b(b){this[b]&&(this[b]=this[b].destroy())}this.getAllItems().forEach(function(e){["legendItem","legendGroup"].forEach(b,e)});"clipRect up down pager nav box title group".split(" ").forEach(b,this);this.display=null};g.prototype.positionCheckboxes=function(){var b=this.group&&this.group.alignAttr,g=this.clipHeight||this.legendHeight,l=this.titleHeight;if(b){var d=
b.translateY;this.allItems.forEach(function(e){var h=e.checkbox;if(h){var m=d+l+h.y+(this.scrollOffset||0)+3;M(h,{left:b.translateX+e.checkboxOffset+h.x-20+"px",top:m+"px",display:this.proximate||m>d-6&&m<d+g-6?"":"none"})}},this)}};g.prototype.renderTitle=function(){var b=this.options,g=this.padding,l=b.title,d=0;l.text&&(this.title||(this.title=this.chart.renderer.label(l.text,g-3,g-4,null,null,null,b.useHTML,null,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(l.style),this.title.add(this.group)),
l.width||this.title.css({width:this.maxLegendWidth+"px"}),b=this.title.getBBox(),d=b.height,this.offsetWidth=b.width,this.contentGroup.attr({translateY:d}));this.titleHeight=d};g.prototype.setText=function(b){var e=this.options;b.legendItem.attr({text:e.labelFormat?F(e.labelFormat,b,this.chart):e.labelFormatter.call(b)})};g.prototype.renderItem=function(b){var e=this.chart,g=e.renderer,d=this.options,h=this.symbolWidth,m=d.symbolPadding,f=this.itemStyle,v=this.itemHiddenStyle,n="horizontal"===d.layout?
D(d.itemDistance,20):0,w=!d.rtl,c=b.legendItem,a=!b.series,k=!a&&b.series.drawLegendSymbol?b.series:b,r=k.options;r=this.createCheckboxForItem&&r&&r.showCheckbox;n=h+m+n+(r?20:0);var z=d.useHTML,t=b.options.className;c||(b.legendGroup=g.g("legend-item").addClass("highcharts-"+k.type+"-series highcharts-color-"+b.colorIndex+(t?" "+t:"")+(a?" highcharts-series-"+b.index:"")).attr({zIndex:1}).add(this.scrollGroup),b.legendItem=c=g.text("",w?h+m:-m,this.baseline||0,z),e.styledMode||c.css(C(b.visible?
f:v)),c.attr({align:w?"left":"right",zIndex:2}).add(b.legendGroup),this.baseline||(this.fontMetrics=g.fontMetrics(e.styledMode?12:f.fontSize,c),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,c.attr("y",this.baseline)),this.symbolHeight=d.symbolHeight||this.fontMetrics.f,k.drawLegendSymbol(this,b),this.setItemEvents&&this.setItemEvents(b,c,z));r&&!b.checkbox&&this.createCheckboxForItem&&this.createCheckboxForItem(b);this.colorizeItem(b,b.visible);!e.styledMode&&f.width||c.css({width:(d.itemWidth||
this.widthOption||e.spacingBox.width)-n+"px"});this.setText(b);e=c.getBBox();b.itemWidth=b.checkboxOffset=d.itemWidth||b.legendItemWidth||e.width+n;this.maxItemWidth=Math.max(this.maxItemWidth,b.itemWidth);this.totalItemWidth+=b.itemWidth;this.itemHeight=b.itemHeight=Math.round(b.legendItemHeight||e.height||this.symbolHeight)};g.prototype.layoutItem=function(b){var e=this.options,g=this.padding,d="horizontal"===e.layout,h=b.itemHeight,m=this.itemMarginBottom,f=this.itemMarginTop,v=d?D(e.itemDistance,
20):0,n=this.maxLegendWidth;e=e.alignColumns&&this.totalItemWidth>n?this.maxItemWidth:b.itemWidth;d&&this.itemX-g+e>n&&(this.itemX=g,this.lastLineHeight&&(this.itemY+=f+this.lastLineHeight+m),this.lastLineHeight=0);this.lastItemY=f+this.itemY+m;this.lastLineHeight=Math.max(h,this.lastLineHeight);b._legendItemPos=[this.itemX,this.itemY];d?this.itemX+=e:(this.itemY+=f+h+m,this.lastLineHeight=h);this.offsetWidth=this.widthOption||Math.max((d?this.itemX-g-(b.checkbox?0:v):e)+g,this.offsetWidth)};g.prototype.getAllItems=
function(){var b=[];this.chart.series.forEach(function(e){var g=e&&e.options;e&&D(g.showInLegend,K(g.linkedTo)?!1:void 0,!0)&&(b=b.concat(e.legendItems||("point"===g.legendType?e.data:e)))});x(this,"afterGetAllItems",{allItems:b});return b};g.prototype.getAlignment=function(){var b=this.options;return this.proximate?b.align.charAt(0)+"tv":b.floating?"":b.align.charAt(0)+b.verticalAlign.charAt(0)+b.layout.charAt(0)};g.prototype.adjustMargins=function(e,g){var l=this.chart,d=this.options,h=this.getAlignment();
h&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(m,f){m.test(h)&&!K(e[f])&&(l[b[f]]=Math.max(l[b[f]],l.legend[(f+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][f]*d[f%2?"x":"y"]+D(d.margin,12)+g[f]+(l.titleOffset[f]||0)))})};g.prototype.proximatePositions=function(){var b=this.chart,g=[],l="left"===this.options.align;this.allItems.forEach(function(e){var d=l;if(e.yAxis&&e.points){e.xAxis.options.reversed&&(d=!d);var h=L(d?e.points:e.points.slice(0).reverse(),function(b){return H(b.plotY)});
d=this.itemMarginTop+e.legendItem.getBBox().height+this.itemMarginBottom;var m=e.yAxis.top-b.plotTop;e.visible?(h=h?h.plotY:e.yAxis.height,h+=m-.3*d):h=m+e.yAxis.height;g.push({target:h,size:d,item:e})}},this);d.distribute(g,b.plotHeight);g.forEach(function(e){e.item._legendItemPos[1]=b.plotTop-b.spacing[0]+e.pos})};g.prototype.render=function(){var b=this.chart,g=b.renderer,l=this.group,d=this.box,h=this.options,m=this.padding;this.itemX=m;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=
0;this.widthOption=w(h.width,b.spacingBox.width-m);var f=b.spacingBox.width-2*m-h.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(f/=2);this.maxLegendWidth=this.widthOption||f;l||(this.group=l=g.g("legend").attr({zIndex:7}).add(),this.contentGroup=g.g().attr({zIndex:1}).add(l),this.scrollGroup=g.g().add(this.contentGroup));this.renderTitle();var v=this.getAllItems();t(v,function(b,c){return(b.options&&b.options.legendIndex||0)-(c.options&&c.options.legendIndex||0)});h.reversed&&v.reverse();
this.allItems=v;this.display=f=!!v.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;v.forEach(this.renderItem,this);v.forEach(this.layoutItem,this);v=(this.widthOption||this.offsetWidth)+m;var n=this.lastItemY+this.lastLineHeight+this.titleHeight;n=this.handleOverflow(n);n+=m;d||(this.box=d=g.rect().addClass("highcharts-legend-box").attr({r:h.borderRadius}).add(l),d.isNew=!0);b.styledMode||d.attr({stroke:h.borderColor,"stroke-width":h.borderWidth||0,fill:h.backgroundColor||
"none"}).shadow(h.shadow);0<v&&0<n&&(d[d.isNew?"attr":"animate"](d.crisp.call({},{x:0,y:0,width:v,height:n},d.strokeWidth())),d.isNew=!1);d[f?"show":"hide"]();b.styledMode&&"none"===l.getStyle("display")&&(v=n=0);this.legendWidth=v;this.legendHeight=n;f&&this.align();this.proximate||this.positionItems();x(this,"afterRender")};g.prototype.align=function(b){void 0===b&&(b=this.chart.spacingBox);var e=this.chart,g=this.options,d=b.y;/(lth|ct|rth)/.test(this.getAlignment())&&0<e.titleOffset[0]?d+=e.titleOffset[0]:
/(lbh|cb|rbh)/.test(this.getAlignment())&&0<e.titleOffset[2]&&(d-=e.titleOffset[2]);d!==b.y&&(b=C(b,{y:d}));this.group.align(C(g,{width:this.legendWidth,height:this.legendHeight,verticalAlign:this.proximate?"top":g.verticalAlign}),!0,b)};g.prototype.handleOverflow=function(b){var e=this,g=this.chart,d=g.renderer,h=this.options,m=h.y,f=this.padding;m=g.spacingBox.height+("top"===h.verticalAlign?-m:m)-f;var v=h.maxHeight,n,w=this.clipRect,c=h.navigation,a=D(c.animation,!0),k=c.arrowSize||12,r=this.nav,
z=this.pages,t,x=this.allItems,q=function(a){"number"===typeof a?w.attr({height:a}):w&&(e.clipRect=w.destroy(),e.contentGroup.clip());e.contentGroup.div&&(e.contentGroup.div.style.clip=a?"rect("+f+"px,9999px,"+(f+a)+"px,0)":"auto")},C=function(a){e[a]=d.circle(0,0,1.3*k).translate(k/2,k/2).add(r);g.styledMode||e[a].attr("fill","rgba(0,0,0,0.0001)");return e[a]};"horizontal"!==h.layout||"middle"===h.verticalAlign||h.floating||(m/=2);v&&(m=Math.min(m,v));z.length=0;b>m&&!1!==c.enabled?(this.clipHeight=
n=Math.max(m-20-this.titleHeight-f,0),this.currentPage=D(this.currentPage,1),this.fullHeight=b,x.forEach(function(a,c){var b=a._legendItemPos[1],e=Math.round(a.legendItem.getBBox().height),k=z.length;if(!k||b-z[k-1]>n&&(t||b)!==z[k-1])z.push(t||b),k++;a.pageIx=k-1;t&&(x[c-1].pageIx=k-1);c===x.length-1&&b+e-z[k-1]>n&&b!==t&&(z.push(b),a.pageIx=k);b!==t&&(t=b)}),w||(w=e.clipRect=d.clipRect(0,f,9999,0),e.contentGroup.clip(w)),q(n),r||(this.nav=r=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol("triangle",
0,0,k,k).add(r),C("upTracker").on("click",function(){e.scroll(-1,a)}),this.pager=d.text("",15,10).addClass("highcharts-legend-navigation"),g.styledMode||this.pager.css(c.style),this.pager.add(r),this.down=d.symbol("triangle-down",0,0,k,k).add(r),C("downTracker").on("click",function(){e.scroll(1,a)})),e.scroll(0),b=m):r&&(q(),this.nav=r.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return b};g.prototype.scroll=function(b,g){var e=this,d=this.chart,h=this.pages,m=h.length,f=this.currentPage+
b;b=this.clipHeight;var p=this.options.navigation,v=this.pager,w=this.padding;f>m&&(f=m);0<f&&("undefined"!==typeof g&&n(g,d),this.nav.attr({translateX:w,translateY:b+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(c){c.attr({"class":1===f?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),v.attr({text:f+"/"+m}),[this.down,this.downTracker].forEach(function(c){c.attr({x:18+this.pager.getBBox().width,"class":f===m?"highcharts-legend-nav-inactive":
"highcharts-legend-nav-active"})},this),d.styledMode||(this.up.attr({fill:1===f?p.inactiveColor:p.activeColor}),this.upTracker.css({cursor:1===f?"default":"pointer"}),this.down.attr({fill:f===m?p.inactiveColor:p.activeColor}),this.downTracker.css({cursor:f===m?"default":"pointer"})),this.scrollOffset=-h[f-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=f,this.positionCheckboxes(),g=q(D(g,d.renderer.globalAnimation,!0)),N(function(){x(e,"afterScroll",
{currentPage:f})},g.duration||0))};return g}();(/Trident\/7\.0/.test(g.navigator&&g.navigator.userAgent)||m)&&f(v.prototype,"positionItem",function(b,e){var g=this,d=function(){e._legendItemPos&&b.call(g,e)};d();g.bubbleLegend||setTimeout(d)});d.Legend=v;return d.Legend});Q(A,"parts/Chart.js",[A["parts/Globals.js"],A["parts/Legend.js"],A["parts/MSPointer.js"],A["parts/Pointer.js"],A["parts/Time.js"],A["parts/Utilities.js"]],function(d,f,E,q,M,K){var J=K.addEvent,L=K.animate,x=K.animObject,F=K.attr,
H=K.createElement,C=K.css,D=K.defined,w=K.discardElement,n=K.erase,t=K.error,N=K.extend,m=K.find,b=K.fireEvent,g=K.getStyle,v=K.isArray,h=K.isFunction,e=K.isNumber,p=K.isObject,l=K.isString,I=K.merge,u=K.numberFormat,y=K.objectEach,G=K.pick,S=K.pInt,R=K.relativeLength,B=K.removeEvent,c=K.setAnimation,a=K.splat,k=K.syncTimeout,r=K.uniqueKey,z=d.doc,P=d.Axis,U=d.defaultOptions,W=d.charts,Y=d.marginNames,T=d.seriesTypes,A=d.win,aa=d.Chart=function(){this.getArgs.apply(this,arguments)};d.chart=function(a,
c,b){return new aa(a,c,b)};N(aa.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(l(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(a,c){var e,k=a.series,g=a.plotOptions||{};b(this,"init",{args:arguments},function(){a.series=null;e=I(U,a);var l=e.chart||{};y(e.plotOptions,function(a,c){p(a)&&(a.tooltip=g[c]&&I(g[c].tooltip)||void 0)});e.tooltip.userOptions=a.chart&&a.chart.forExport&&a.tooltip.userOptions||a.tooltip;e.series=a.series=k;this.userOptions=
a;var m=l.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=e;this.axes=[];this.series=[];this.time=a.time&&Object.keys(a.time).length?new M(a.time):d.time;this.numberFormatter=l.numberFormatter||u;this.styledMode=l.styledMode;this.hasCartesianSeries=l.showAxes;var f=this;f.index=W.length;W.push(f);d.chartCount++;m&&y(m,function(a,c){h(a)&&J(f,c,a)});f.xAxis=[];f.yAxis=[];f.pointCount=f.colorCounter=f.symbolCounter=
0;b(f,"afterInit");f.firstRender()})},initSeries:function(a){var c=this.options.chart;c=a.type||c.type||c.defaultSeriesType;var b=T[c];b||t(17,!0,this,{missingModuleFor:c});c=new b;c.init(this,a);return c},setSeriesData:function(){this.getSeriesOrderByLinks().forEach(function(a){a.points||a.data||!a.enabledDataSorting||a.setData(a.options.data,!1)})},getSeriesOrderByLinks:function(){return this.series.concat().sort(function(a,c){return a.linkedSeries.length||c.linkedSeries.length?c.linkedSeries.length-
a.linkedSeries.length:0})},orderSeries:function(a){var c=this.series;for(a=a||0;a<c.length;a++)c[a]&&(c[a].index=a,c[a].name=c[a].getName())},isInsidePlot:function(a,c,e){var k=e?c:a;a=e?a:c;k={x:k,y:a,isInsidePlot:0<=k&&k<=this.plotWidth&&0<=a&&a<=this.plotHeight};b(this,"afterIsInsidePlot",k);return k.isInsidePlot},redraw:function(a){b(this,"beforeRedraw");var e=this.axes,k=this.series,g=this.pointer,d=this.legend,l=this.userOptions.legend,h=this.isDirtyLegend,f=this.hasCartesianSeries,m=this.isDirtyBox,
r=this.renderer,u=r.isHidden(),p=[];this.setResponsive&&this.setResponsive(!1);c(this.hasRendered?a:!1,this);u&&this.temporaryDisplay();this.layOutTitles();for(a=k.length;a--;){var v=k[a];if(v.options.stacking){var z=!0;if(v.isDirty){var n=!0;break}}}if(n)for(a=k.length;a--;)v=k[a],v.options.stacking&&(v.isDirty=!0);k.forEach(function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),h=!0):l&&(l.labelFormatter||l.labelFormat)&&(h=!0));a.isDirtyData&&b(a,"updatedData")});
h&&d&&d.options.enabled&&(d.render(),this.isDirtyLegend=!1);z&&this.getStacks();f&&e.forEach(function(a){a.updateNames();a.setScale()});this.getMargins();f&&(e.forEach(function(a){a.isDirty&&(m=!0)}),e.forEach(function(a){var c=a.min+","+a.max;a.extKey!==c&&(a.extKey=c,p.push(function(){b(a,"afterSetExtremes",N(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(m||z)&&a.redraw()}));m&&this.drawChartBox();b(this,"predraw");k.forEach(function(a){(m||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=
!1});g&&g.reset(!0);r.draw();b(this,"redraw");b(this,"render");u&&this.temporaryDisplay(!0);p.forEach(function(a){a.call()})},get:function(a){function c(c){return c.id===a||c.options&&c.options.id===a}var b=this.series,e;var k=m(this.axes,c)||m(this.series,c);for(e=0;!k&&e<b.length;e++)k=m(b[e].points||[],c);return k},getAxes:function(){var c=this,e=this.options,k=e.xAxis=a(e.xAxis||{});e=e.yAxis=a(e.yAxis||{});b(this,"getAxes");k.forEach(function(a,c){a.index=c;a.isX=!0});e.forEach(function(a,c){a.index=
c});k.concat(e).forEach(function(a){new P(c,a)});b(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];this.series.forEach(function(c){a=a.concat(c.getPointsCollection().filter(function(a){return G(a.selectedStaging,a.selected)}))});return a},getSelectedSeries:function(){return this.series.filter(function(a){return a.selected})},setTitle:function(a,c,b){this.applyDescription("title",a);this.applyDescription("subtitle",c);this.applyDescription("caption",void 0);this.layOutTitles(b)},applyDescription:function(a,
c){var b=this,e="title"===a?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:{color:"#666666"};e=this.options[a]=I(!this.styledMode&&{style:e},this.options[a],c);var k=this[a];k&&c&&(this[a]=k=k.destroy());e&&!k&&(k=this.renderer.text(e.text,0,0,e.useHTML).attr({align:e.align,"class":"highcharts-"+a,zIndex:e.zIndex||4}).add(),k.update=function(c){b[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[a]](c)},this.styledMode||k.css(e.style),this[a]=k)},layOutTitles:function(a){var c=
[0,0,0],e=this.renderer,k=this.spacingBox;["title","subtitle","caption"].forEach(function(a){var b=this[a],g=this.options[a],d=g.verticalAlign||"top";a="title"===a?-3:"top"===d?c[0]+2:0;if(b){if(!this.styledMode)var l=g.style.fontSize;l=e.fontMetrics(l,b).b;b.css({width:(g.width||k.width+(g.widthAdjust||0))+"px"});var h=Math.round(b.getBBox(g.useHTML).height);b.align(N({y:"bottom"===d?l:a+l,height:h},g),!1,"spacingBox");g.floating||("top"===d?c[0]=Math.ceil(c[0]+h):"bottom"===d&&(c[2]=Math.ceil(c[2]+
h)))}},this);c[0]&&"top"===(this.options.title.verticalAlign||"top")&&(c[0]+=this.options.title.margin);c[2]&&"bottom"===this.options.caption.verticalAlign&&(c[2]+=this.options.caption.margin);var g=!this.titleOffset||this.titleOffset.join(",")!==c.join(",");this.titleOffset=c;b(this,"afterLayOutTitles");!this.isDirtyBox&&g&&(this.isDirtyBox=this.isDirtyLegend=g,this.hasRendered&&G(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=this.options.chart,c=a.width;a=a.height;var b=
this.renderTo;D(c)||(this.containerWidth=g(b,"width"));D(a)||(this.containerHeight=g(b,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,R(a,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(a){var c=this.renderTo;if(a)for(;c&&c.style;)c.hcOrigStyle&&(C(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(z.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){z.body.contains(c)||
c.parentNode||(c.hcOrigDetached=!0,z.body.appendChild(c));if("none"===g(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},a={display:"block",overflow:"hidden"},c!==this.renderTo&&(a.height=0),C(c,a),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===z.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var a=this.options,k=
a.chart;var g=this.renderTo;var h=r(),m,f;g||(this.renderTo=g=k.renderTo);l(g)&&(this.renderTo=g=z.getElementById(g));g||t(13,!0,this);var u=S(F(g,"data-highcharts-chart"));e(u)&&W[u]&&W[u].hasRendered&&W[u].destroy();F(g,"data-highcharts-chart",this.index);g.innerHTML="";k.skipClone||g.offsetWidth||this.temporaryDisplay();this.getChartSize();u=this.chartWidth;var p=this.chartHeight;C(g,{overflow:"hidden"});this.styledMode||(m=N({position:"relative",overflow:"hidden",width:u+"px",height:p+"px",textAlign:"left",
lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},k.style));this.container=g=H("div",{id:h},m,g);this._cursor=g.style.cursor;this.renderer=new (d[k.renderer]||d.Renderer)(g,u,p,null,k.forExport,a.exporting&&a.exporting.allowHTML,this.styledMode);c(void 0,this);this.setClassName(k.className);if(this.styledMode)for(f in a.defs)this.renderer.definition(a.defs[f]);else this.renderer.setStyle(k.style);this.renderer.chartIndex=this.index;b(this,"afterGetContainer")},getMargins:function(a){var c=
this.spacing,e=this.margin,k=this.titleOffset;this.resetMargins();k[0]&&!D(e[0])&&(this.plotTop=Math.max(this.plotTop,k[0]+c[0]));k[2]&&!D(e[2])&&(this.marginBottom=Math.max(this.marginBottom,k[2]+c[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(e,c);b(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,c=a.axisOffset=[0,0,0,0],b=a.colorAxis,e=a.margin,k=function(a){a.forEach(function(a){a.visible&&a.getOffset()})};a.hasCartesianSeries?k(a.axes):b&&
b.length&&k(b);Y.forEach(function(b,k){D(e[k])||(a[b]+=c[k])});a.setChartSize()},reflow:function(a){var c=this,b=c.options.chart,e=c.renderTo,d=D(b.width)&&D(b.height),l=b.width||g(e,"width");b=b.height||g(e,"height");e=a?a.target:A;if(!d&&!c.isPrinting&&l&&b&&(e===A||e===z)){if(l!==c.containerWidth||b!==c.containerHeight)K.clearTimeout(c.reflowTimeout),c.reflowTimeout=k(function(){c.container&&c.setSize(void 0,void 0,!1)},a?100:0);c.containerWidth=l;c.containerHeight=b}},setReflow:function(a){var c=
this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=J(A,"resize",function(a){c.options&&c.reflow(a)}),J(this,"destroy",this.unbindReflow))},setSize:function(a,e,g){var d=this,l=d.renderer;d.isResizing+=1;c(g,d);g=l.globalAnimation;d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;"undefined"!==typeof a&&(d.options.chart.width=a);"undefined"!==typeof e&&(d.options.chart.height=e);d.getChartSize();d.styledMode||(g?L:C)(d.container,
{width:d.chartWidth+"px",height:d.chartHeight+"px"},g);d.setChartSize(!0);l.setSize(d.chartWidth,d.chartHeight,g);d.axes.forEach(function(a){a.isDirty=!0;a.setScale()});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(g);d.oldChartHeight=null;b(d,"resize");k(function(){d&&b(d,"endResize",null,function(){--d.isResizing})},x(g).duration||0)},setChartSize:function(a){var c=this.inverted,e=this.renderer,k=this.chartWidth,g=this.chartHeight,d=this.options.chart,l=this.spacing,
h=this.clipOffset,m,f,r,u;this.plotLeft=m=Math.round(this.plotLeft);this.plotTop=f=Math.round(this.plotTop);this.plotWidth=r=Math.max(0,Math.round(k-m-this.marginRight));this.plotHeight=u=Math.max(0,Math.round(g-f-this.marginBottom));this.plotSizeX=c?u:r;this.plotSizeY=c?r:u;this.plotBorderWidth=d.plotBorderWidth||0;this.spacingBox=e.spacingBox={x:l[3],y:l[0],width:k-l[3]-l[1],height:g-l[0]-l[2]};this.plotBox=e.plotBox={x:m,y:f,width:r,height:u};k=2*Math.floor(this.plotBorderWidth/2);c=Math.ceil(Math.max(k,
h[3])/2);e=Math.ceil(Math.max(k,h[0])/2);this.clipBox={x:c,y:e,width:Math.floor(this.plotSizeX-Math.max(k,h[1])/2-c),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(k,h[2])/2-e))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});b(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){b(this,"resetMargins");var a=this,c=a.options.chart;["margin","spacing"].forEach(function(b){var e=c[b],k=p(e)?e:[e,e,e,e];["Top","Right","Bottom","Left"].forEach(function(e,g){a[b][g]=
G(c[b+e],k[g])})});Y.forEach(function(c,b){a[c]=G(a.margin[b],a.spacing[b])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,c=this.renderer,e=this.chartWidth,k=this.chartHeight,g=this.chartBackground,d=this.plotBackground,l=this.plotBorder,h=this.styledMode,m=this.plotBGImage,f=a.backgroundColor,r=a.plotBackgroundColor,u=a.plotBackgroundImage,p,v=this.plotLeft,z=this.plotTop,n=this.plotWidth,y=this.plotHeight,w=this.plotBox,t=this.clipRect,B=this.clipBox,
P="animate";g||(this.chartBackground=g=c.rect().addClass("highcharts-background").add(),P="attr");if(h)var G=p=g.strokeWidth();else{G=a.borderWidth||0;p=G+(a.shadow?8:0);f={fill:f||"none"};if(G||g["stroke-width"])f.stroke=a.borderColor,f["stroke-width"]=G;g.attr(f).shadow(a.shadow)}g[P]({x:p/2,y:p/2,width:e-p-G%2,height:k-p-G%2,r:a.borderRadius});P="animate";d||(P="attr",this.plotBackground=d=c.rect().addClass("highcharts-plot-background").add());d[P](w);h||(d.attr({fill:r||"none"}).shadow(a.plotShadow),
u&&(m?(u!==m.attr("href")&&m.attr("href",u),m.animate(w)):this.plotBGImage=c.image(u,v,z,n,y).add()));t?t.animate({width:B.width,height:B.height}):this.clipRect=c.clipRect(B);P="animate";l||(P="attr",this.plotBorder=l=c.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());h||l.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});l[P](l.crisp({x:v,y:z,width:n,height:y},-l.strokeWidth()));this.isDirtyBox=!1;b(this,"afterDrawChartBox")},propFromSeries:function(){var a=
this,c=a.options.chart,b,e=a.options.series,k,g;["inverted","angular","polar"].forEach(function(d){b=T[c.type||c.defaultSeriesType];g=c[d]||b&&b.prototype[d];for(k=e&&e.length;!g&&k--;)(b=T[e[k].type])&&b.prototype[d]&&(g=!0);a[d]=g})},linkSeries:function(){var a=this,c=a.series;c.forEach(function(a){a.linkedSeries.length=0});c.forEach(function(c){var b=c.options.linkedTo;l(b)&&(b=":previous"===b?a.series[c.index-1]:a.get(b))&&b.linkedParent!==c&&(b.linkedSeries.push(c),c.linkedParent=b,b.enabledDataSorting&&
c.setDataSortingOptions(),c.visible=G(c.options.visible,b.options.visible,c.visible))});b(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(a){a.translate();a.render()})},renderLabels:function(){var a=this,c=a.options.labels;c.items&&c.items.forEach(function(b){var e=N(c.style,b.style),k=S(e.left)+a.plotLeft,g=S(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(b.html,k,g).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,c=this.colorAxis,
b=this.renderer,e=this.options,k=0,g=function(a){a.forEach(function(a){a.visible&&a.render()})};this.setTitle();this.legend=new f(this,e.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();e=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return k=21,!0});var d=this.plotHeight=Math.max(this.plotHeight-k,0);a.forEach(function(a){a.setScale()});this.getAxisMargins();var l=1.1<e/this.plotWidth;var h=1.05<d/this.plotHeight;
if(l||h)a.forEach(function(a){(a.horiz&&l||!a.horiz&&h)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?g(a):c&&c.length&&g(c);this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();this.hasRendered=!0},addCredits:function(a){var c=this;a=I(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=
this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(A.location.href=a.href)}).attr({align:a.position.align,zIndex:8}),c.styledMode||this.credits.css(a.style),this.credits.add().align(a.position),this.credits.update=function(a){c.credits=c.credits.destroy();c.addCredits(a)})},updateContainerScaling:function(){var a=this.container;if(a.offsetWidth&&a.offsetHeight&&a.getBoundingClientRect){var c=a.getBoundingClientRect(),b=c.width/a.offsetWidth;
a=c.height/a.offsetHeight;1!==b||1!==a?this.containerScaling={scaleX:b,scaleY:a}:delete this.containerScaling}},destroy:function(){var a=this,c=a.axes,e=a.series,k=a.container,g,l=k&&k.parentNode;b(a,"destroy");a.renderer.forExport?n(W,a):W[a.index]=void 0;d.chartCount--;a.renderTo.removeAttribute("data-highcharts-chart");B(a);for(g=c.length;g--;)c[g]=c[g].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(g=e.length;g--;)e[g]=e[g].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(c){var b=
a[c];b&&b.destroy&&(a[c]=b.destroy())});k&&(k.innerHTML="",B(k),l&&w(k));y(a,function(c,b){delete a[b]})},firstRender:function(){var a=this,c=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();(v(c.series)?c.series:[]).forEach(function(c){a.initSeries(c)});a.linkSeries();a.setSeriesData();b(a,"beforeRender");q&&(a.pointer=d.hasTouch||!A.PointerEvent&&!A.MSPointerEvent?new q(a,c):new E(a,c));a.render();if(!a.renderer.imgCount&&
!a.hasLoaded)a.onload();a.temporaryDisplay(!0)}},onload:function(){this.callbacks.concat([this.callback]).forEach(function(a){a&&"undefined"!==typeof this.index&&a.apply(this,[this])},this);b(this,"load");b(this,"render");D(this.index)&&this.setReflow(this.options.chart.reflow);this.hasLoaded=!0}})});Q(A,"parts/ScrollablePlotArea.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.addEvent,q=f.createElement,A=f.pick,K=f.stop;f=d.Chart;"";E(f,"afterSetChartSize",function(f){var q=
this.options.chart.scrollablePlotArea,x=q&&q.minWidth;q=q&&q.minHeight;if(!this.renderer.forExport){if(x){if(this.scrollablePixelsX=x=Math.max(0,x-this.chartWidth)){this.plotWidth+=x;this.inverted?(this.clipBox.height+=x,this.plotBox.height+=x):(this.clipBox.width+=x,this.plotBox.width+=x);var F={1:{name:"right",value:x}}}}else q&&(this.scrollablePixelsY=x=Math.max(0,q-this.chartHeight))&&(this.plotHeight+=x,this.inverted?(this.clipBox.width+=x,this.plotBox.width+=x):(this.clipBox.height+=x,this.plotBox.height+=
x),F={2:{name:"bottom",value:x}});F&&!f.skipAxes&&this.axes.forEach(function(f){F[f.side]?f.getPlotLinePath=function(){var x=F[f.side].name,q=this[x];this[x]=q-F[f.side].value;var w=d.Axis.prototype.getPlotLinePath.apply(this,arguments);this[x]=q;return w}:(f.setAxisSize(),f.setAxisTranslation())})}});E(f,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});f.prototype.setUpScrolling=function(){var d=
this,f={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(f.overflowX="auto");this.scrollablePixelsY&&(f.overflowY="auto");this.scrollingContainer=q("div",{className:"highcharts-scrolling"},f,this.renderTo);E(this.scrollingContainer,"scroll",function(){d.pointer&&delete d.pointer.chartPosition});this.innerContainer=q("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=
null};f.prototype.moveFixedElements=function(){var d=this.container,f=this.fixedRenderer,x=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),q;this.scrollablePixelsX&&!this.inverted?q=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?q=".highcharts-xaxis":
this.scrollablePixelsY&&!this.inverted?q=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(q=".highcharts-yaxis");x.push(q,q+"-labels");x.forEach(function(x){[].forEach.call(d.querySelectorAll(x),function(d){(d.namespaceURI===f.SVG_NS?f.box:f.box.parentNode).appendChild(d);d.style.pointerEvents="auto"})})};f.prototype.applyFixed=function(){var f,L,x=!this.fixedDiv,F=this.options.chart.scrollablePlotArea;x?(this.fixedDiv=q("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",
pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=L=new d.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight,null===(f=this.options.chart)||void 0===f?void 0:f.style),this.scrollableMask=L.path().attr({fill:this.options.chart.backgroundColor||"#fff","fill-opacity":A(F.opacity,.85),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),this.moveFixedElements(),E(this,"afterShowResetZoom",
this.moveFixedElements),E(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);f=this.chartWidth+(this.scrollablePixelsX||0);L=this.chartHeight+(this.scrollablePixelsY||0);K(this.container);this.container.style.width=f+"px";this.container.style.height=L+"px";this.renderer.boxWrapper.attr({width:f,height:L,viewBox:[0,0,f,L].join(" ")});this.chartBackground.attr({width:f,height:L});this.scrollingContainer.style.height=this.chartHeight+"px";x&&
(F.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*F.scrollPositionX),F.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*F.scrollPositionY));L=this.axisOffset;x=this.plotTop-L[0]-1;F=this.plotLeft-L[3]-1;f=this.plotTop+this.plotHeight+L[2]+1;L=this.plotLeft+this.plotWidth+L[1]+1;var H=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),C=this.plotTop+this.plotHeight-(this.scrollablePixelsY||0);x=this.scrollablePixelsX?[["M",0,x],["L",this.plotLeft-
1,x],["L",this.plotLeft-1,f],["L",0,f],["Z"],["M",H,x],["L",this.chartWidth,x],["L",this.chartWidth,f],["L",H,f],["Z"]]:this.scrollablePixelsY?[["M",F,0],["L",F,this.plotTop-1],["L",L,this.plotTop-1],["L",L,0],["Z"],["M",F,C],["L",F,this.chartHeight],["L",L,this.chartHeight],["L",L,C],["Z"]]:[["M",0,0]];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:x})}});Q(A,"parts/StackingAxis.js",[A["parts/Utilities.js"]],function(d){var f=d.addEvent,E=d.destroyObjectProperties,q=d.fireEvent,
A=d.objectEach,K=d.pick,J=function(){function d(d){this.oldStacks={};this.stacks={};this.stacksTouched=0;this.axis=d}d.prototype.buildStacks=function(){var d=this.axis,f=d.series,H=K(d.options.reversedStacks,!0),C=f.length,D;if(!d.isXAxis){this.usePercentage=!1;for(D=C;D--;){var w=f[H?D:C-D-1];w.setStackedPoints()}for(D=0;D<C;D++)f[D].modifyStacks();q(d,"afterBuildStacks")}};d.prototype.cleanStacks=function(){if(!this.axis.isXAxis){if(this.oldStacks)var d=this.stacks=this.oldStacks;A(d,function(d){A(d,
function(d){d.cumulative=d.total})})}};d.prototype.resetStacks=function(){var d=this,f=d.stacks;d.axis.isXAxis||A(f,function(f){A(f,function(q,x){q.touched<d.stacksTouched?(q.destroy(),delete f[x]):(q.total=null,q.cumulative=null)})})};d.prototype.renderStackTotals=function(){var d=this.axis.chart,f=d.renderer,q=this.stacks,C=this.stackTotalGroup=this.stackTotalGroup||f.g("stack-labels").attr({visibility:"visible",zIndex:6}).add();C.translate(d.plotLeft,d.plotTop);A(q,function(d){A(d,function(d){d.render(C)})})};
return d}();return function(){function d(){}d.compose=function(q){f(q,"init",d.onInit);f(q,"destroy",d.onDestroy)};d.onDestroy=function(){var d=this.stacking;if(d){var f=d.stacks;A(f,function(d,q){E(d);f[q]=null});d&&d.stackTotalGroup&&d.stackTotalGroup.destroy()}};d.onInit=function(){this.stacking||(this.stacking=new J(this))};return d}()});Q(A,"mixins/legend-symbol.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var E=f.merge,q=f.pick;d.LegendSymbolMixin={drawRectangle:function(d,
f){var E=d.symbolHeight,A=d.options.squareSymbol;f.legendSymbol=this.chart.renderer.rect(A?(d.symbolWidth-E)/2:0,d.baseline-E+1,A?E:d.symbolWidth,E,q(d.options.symbolRadius,E/2)).addClass("highcharts-point").attr({zIndex:3}).add(f.legendGroup)},drawLineMarker:function(d){var f=this.options,A=f.marker,L=d.symbolWidth,x=d.symbolHeight,F=x/2,H=this.chart.renderer,C=this.legendGroup;d=d.baseline-Math.round(.3*d.fontMetrics.b);var D={};this.chart.styledMode||(D={"stroke-width":f.lineWidth||0},f.dashStyle&&
(D.dashstyle=f.dashStyle));this.legendLine=H.path(["M",0,d,"L",L,d]).addClass("highcharts-graph").attr(D).add(C);A&&!1!==A.enabled&&L&&(f=Math.min(q(A.radius,F),F),0===this.symbol.indexOf("url")&&(A=E(A,{width:x,height:x}),f=0),this.legendSymbol=A=H.symbol(this.symbol,L/2-f,d-f,2*f,2*f,A).addClass("highcharts-point").add(C),A.isMarker=!0)}};return d.LegendSymbolMixin});Q(A,"parts/Point.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){"";var A=f.animObject,q=f.defined,M=f.erase,K=
f.extend,J=f.fireEvent,L=f.format,x=f.getNestedProperty,F=f.isArray,H=f.isNumber,C=f.isObject,D=f.syncTimeout,w=f.pick,n=f.removeEvent,t=f.uniqueKey;f=function(){function d(){this.colorIndex=this.category=void 0;this.formatPrefix="point";this.id=void 0;this.isNull=!1;this.percentage=this.options=this.name=void 0;this.selected=!1;this.total=this.series=void 0;this.visible=!0;this.x=void 0}d.prototype.animateBeforeDestroy=function(){var d=this,b={x:d.startXPos,opacity:0},g,f=d.getGraphicalProps();f.singular.forEach(function(f){g=
"dataLabel"===f;d[f]=d[f].animate(g?{x:d[f].startXPos,y:d[f].startYPos,opacity:0}:b)});f.plural.forEach(function(b){d[b].forEach(function(b){b.element&&b.animate(K({x:d.startXPos},b.startYPos?{x:b.startXPos,y:b.startYPos}:{}))})})};d.prototype.applyOptions=function(f,b){var g=this.series,m=g.options.pointValKey||g.pointValKey;f=d.prototype.optionsToObject.call(this,f);K(this,f);this.options=this.options?K(this.options,f):f;f.group&&delete this.group;f.dataLabels&&delete this.dataLabels;m&&(this.y=
d.prototype.getNestedProperty.call(this,m));this.formatPrefix=(this.isNull=w(this.isValid&&!this.isValid(),null===this.x||!H(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&"undefined"===typeof b&&g.xAxis&&g.xAxis.hasNames&&(this.x=g.xAxis.nameToX(this));"undefined"===typeof this.x&&g&&(this.x="undefined"===typeof b?g.autoIncrement(this):b);return this};d.prototype.destroy=function(){function d(){if(b.graphic||b.dataLabel||b.dataLabels)n(b),b.destroyElements();for(p in b)b[p]=
null}var b=this,g=b.series,f=g.chart;g=g.options.dataSorting;var h=f.hoverPoints,e=A(b.series.chart.renderer.globalAnimation),p;b.legendItem&&f.legend.destroyItem(b);h&&(b.setState(),M(h,b),h.length||(f.hoverPoints=null));if(b===f.hoverPoint)b.onMouseOut();g&&g.enabled?(this.animateBeforeDestroy(),D(d,e.duration)):d();f.pointCount--};d.prototype.destroyElements=function(d){var b=this;d=b.getGraphicalProps(d);d.singular.forEach(function(d){b[d]=b[d].destroy()});d.plural.forEach(function(d){b[d].forEach(function(b){b.element&&
b.destroy()});delete b[d]})};d.prototype.firePointEvent=function(d,b,g){var f=this,h=this.series.options;(h.point.events[d]||f.options&&f.options.events&&f.options.events[d])&&f.importEvents();"click"===d&&h.allowPointSelect&&(g=function(b){f.select&&f.select(null,b.ctrlKey||b.metaKey||b.shiftKey)});J(f,d,b,g)};d.prototype.getClassName=function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+
("undefined"!==typeof this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")};d.prototype.getGraphicalProps=function(d){var b=this,g=[],f,h={singular:[],plural:[]};d=d||{graphic:1,dataLabel:1};d.graphic&&g.push("graphic","shadowGroup");d.dataLabel&&g.push("dataLabel","dataLabelUpper","connector");for(f=g.length;f--;){var e=g[f];b[e]&&h.singular.push(e)}["dataLabel",
"connector"].forEach(function(e){var g=e+"s";d[e]&&b[g]&&h.plural.push(g)});return h};d.prototype.getLabelConfig=function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}};d.prototype.getNestedProperty=function(d){if(d)return 0===d.indexOf("custom.")?x(d,this.options):this[d]};d.prototype.getZone=function(){var d=this.series,b=d.zones;d=d.zoneAxis||
"y";var g=0,f;for(f=b[g];this[d]>=f.value;)f=b[++g];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=f&&f.color&&!this.options.color?f.color:this.nonZonedColor;return f};d.prototype.hasNewShapeType=function(){return(this.graphic&&(this.graphic.symbolName||this.graphic.element.nodeName))!==this.shapeType};d.prototype.init=function(d,b,g){this.series=d;this.applyOptions(b,g);this.id=q(this.id)?this.id:t();this.resolveColor();d.chart.pointCount++;J(this,"afterInit");return this};d.prototype.optionsToObject=
function(f){var b={},g=this.series,m=g.options.keys,h=m||g.pointArrayMap||["y"],e=h.length,p=0,l=0;if(H(f)||null===f)b[h[0]]=f;else if(F(f))for(!m&&f.length>e&&(g=typeof f[0],"string"===g?b.name=f[0]:"number"===g&&(b.x=f[0]),p++);l<e;)m&&"undefined"===typeof f[p]||(0<h[l].indexOf(".")?d.prototype.setNestedProperty(b,f[p],h[l]):b[h[l]]=f[p]),p++,l++;else"object"===typeof f&&(b=f,f.dataLabels&&(g._hasPointLabels=!0),f.marker&&(g._hasPointMarkers=!0));return b};d.prototype.resolveColor=function(){var d=
this.series;var b=d.chart.options.chart.colorCount;var g=d.chart.styledMode;delete this.nonZonedColor;g||this.options.color||(this.color=d.color);d.options.colorByPoint?(g||(b=d.options.colors||d.chart.options.colors,this.color=this.color||b[d.colorCounter],b=b.length),g=d.colorCounter,d.colorCounter++,d.colorCounter===b&&(d.colorCounter=0)):g=d.colorIndex;this.colorIndex=w(this.colorIndex,g)};d.prototype.setNestedProperty=function(d,b,g){g.split(".").reduce(function(d,g,e,f){d[g]=f.length-1===e?
b:C(d[g],!0)?d[g]:{};return d[g]},d);return d};d.prototype.tooltipFormatter=function(d){var b=this.series,g=b.tooltipOptions,f=w(g.valueDecimals,""),h=g.valuePrefix||"",e=g.valueSuffix||"";b.chart.styledMode&&(d=b.chart.tooltip.styledModeFormat(d));(b.pointArrayMap||["y"]).forEach(function(b){b="{point."+b;if(h||e)d=d.replace(RegExp(b+"}","g"),h+b+"}"+e);d=d.replace(RegExp(b+"}","g"),b+":,."+f+"f}")});return L(d,{point:this,series:this.series},b.chart)};return d}();d.Point=f;return d.Point});Q(A,
"parts/Series.js",[A["mixins/legend-symbol.js"],A["parts/Globals.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(d,f,A,q){"";var E=q.addEvent,K=q.animObject,J=q.arrayMax,L=q.arrayMin,x=q.clamp,F=q.correctFloat,H=q.defined,C=q.erase,D=q.error,w=q.extend,n=q.find,t=q.fireEvent,N=q.getNestedProperty,m=q.isArray,b=q.isFunction,g=q.isNumber,v=q.isString,h=q.merge,e=q.objectEach,p=q.pick,l=q.removeEvent,I=q.seriesType,u=q.splat,y=q.syncTimeout,G=f.defaultOptions,S=f.defaultPlotOptions,R=f.seriesTypes,
B=f.SVGElement,c=f.win;f.Series=I("line",null,{lineWidth:2,allowPointSelect:!1,crisp:!0,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{enabledThreshold:2,lineColor:"#ffffff",lineWidth:0,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){var a=this.series.chart.numberFormatter;return"number"!==typeof this.y?
"":a(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],coll:"series",
colorCounter:0,cropShoulder:1,directTouch:!1,eventsToUnbind:[],isCartesian:!0,parallelArrays:["x","y"],pointClass:A,requireSorting:!0,sorted:!0,init:function(a,c){t(this,"init",{options:c});var d=this,k=a.series,g;this.eventOptions=this.eventOptions||{};d.chart=a;d.options=c=d.setOptions(c);d.linkedSeries=[];d.bindAxes();w(d,{name:c.name,state:"",visible:!1!==c.visible,selected:!0===c.selected});var f=c.events;e(f,function(a,c){b(a)&&d.eventOptions[c]!==a&&(b(d.eventOptions[c])&&l(d,c,d.eventOptions[c]),
d.eventOptions[c]=a,E(d,c,a))});if(f&&f.click||c.point&&c.point.events&&c.point.events.click||c.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();d.parallelArrays.forEach(function(a){d[a+"Data"]||(d[a+"Data"]=[])});d.isCartesian&&(a.hasCartesianSeries=!0);k.length&&(g=k[k.length-1]);d._i=p(g&&g._i,-1)+1;a.orderSeries(this.insert(k));c.dataSorting&&c.dataSorting.enabled?d.setDataSortingOptions():d.points||d.data||d.setData(c.data,!1);t(this,"afterInit")},is:function(a){return R[a]&&
this instanceof R[a]},insert:function(a){var c=this.options.index,b;if(g(c)){for(b=a.length;b--;)if(c>=p(a[b].options.index,a[b]._i)){a.splice(b+1,0,this);break}-1===b&&a.unshift(this);b+=1}else a.push(this);return p(b,a.length-1)},bindAxes:function(){var a=this,c=a.options,b=a.chart,e;t(this,"bindAxes",null,function(){(a.axisTypes||[]).forEach(function(d){b[d].forEach(function(b){e=b.options;if(c[d]===e.index||"undefined"!==typeof c[d]&&c[d]===e.id||"undefined"===typeof c[d]&&0===e.index)a.insert(b.series),
a[d]=b,b.isDirty=!0});a[d]||a.optionalAxis===d||D(18,!0,b)})});t(this,"afterBindAxes")},updateParallelArrays:function(a,c){var b=a.series,e=arguments,d=g(c)?function(e){var d="y"===e&&b.toYData?b.toYData(a):a[e];b[e+"Data"][c]=d}:function(a){Array.prototype[c].apply(b[a+"Data"],Array.prototype.slice.call(e,2))};b.parallelArrays.forEach(d)},hasData:function(){return this.visible&&"undefined"!==typeof this.dataMax&&"undefined"!==typeof this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=
this.options,c=this.xIncrement,b,e=a.pointIntervalUnit,d=this.chart.time;c=p(c,a.pointStart,0);this.pointInterval=b=p(this.pointInterval,a.pointInterval,1);e&&(a=new d.Date(c),"day"===e?d.set("Date",a,d.get("Date",a)+b):"month"===e?d.set("Month",a,d.get("Month",a)+b):"year"===e&&d.set("FullYear",a,d.get("FullYear",a)+b),b=a.getTime()-c);this.xIncrement=c+b;return c},setDataSortingOptions:function(){var a=this.options;w(this,{requireSorting:!1,sorted:!1,enabledDataSorting:!0,allowDG:!1});H(a.pointRange)||
(a.pointRange=1)},setOptions:function(a){var c=this.chart,b=c.options,e=b.plotOptions,d=c.userOptions||{};a=h(a);c=c.styledMode;var g={plotOptions:e,userOptions:a};t(this,"setOptions",g);var l=g.plotOptions[this.type],f=d.plotOptions||{};this.userOptions=g.userOptions;d=h(l,e.series,d.plotOptions&&d.plotOptions[this.type],a);this.tooltipOptions=h(G.tooltip,G.plotOptions.series&&G.plotOptions.series.tooltip,G.plotOptions[this.type].tooltip,b.tooltip.userOptions,e.series&&e.series.tooltip,e[this.type].tooltip,
a.tooltip);this.stickyTracking=p(a.stickyTracking,f[this.type]&&f[this.type].stickyTracking,f.series&&f.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:d.stickyTracking);null===l.marker&&delete d.marker;this.zoneAxis=d.zoneAxis;b=this.zones=(d.zones||[]).slice();!d.negativeColor&&!d.negativeFillColor||d.zones||(e={value:d[this.zoneAxis+"Threshold"]||d.threshold||0,className:"highcharts-negative"},c||(e.color=d.negativeColor,e.fillColor=d.negativeFillColor),b.push(e));b.length&&
H(b[b.length-1].value)&&b.push(c?{}:{color:this.color,fillColor:this.fillColor});t(this,"afterSetOptions",{options:d});return d},getName:function(){return p(this.options.name,"Series "+(this.index+1))},getCyclic:function(a,c,b){var e=this.chart,d=this.userOptions,k=a+"Index",g=a+"Counter",l=b?b.length:p(e.options.chart[a+"Count"],e[a+"Count"]);if(!c){var f=p(d[k],d["_"+k]);H(f)||(e.series.length||(e[g]=0),d["_"+k]=f=e[g]%l,e[g]+=1);b&&(c=b[f])}"undefined"!==typeof f&&(this[k]=f);this[a]=c},getColor:function(){this.chart.styledMode?
this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||S[this.type].color,this.chart.options.colors)},getPointsCollection:function(){return(this.hasGroupedData?this.points:this.data)||[]},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,c){var b=a.id,e=a.x,d=this.points,k,l=this.options.dataSorting;if(b)var f=this.chart.get(b);else if(this.linkedParent||this.enabledDataSorting){var h=
l&&l.matchByName?"name":"index";f=n(d,function(c){return!c.touched&&c[h]===a[h]});if(!f)return}if(f){var m=f&&f.index;"undefined"!==typeof m&&(k=!0)}"undefined"===typeof m&&g(e)&&(m=this.xData.indexOf(e,c));-1!==m&&"undefined"!==typeof m&&this.cropped&&(m=m>=this.cropStart?m-this.cropStart:m);!k&&d[m]&&d[m].touched&&(m=void 0);return m},drawLegendSymbol:d.drawLineMarker,updateData:function(a,c){var b=this.options,e=b.dataSorting,d=this.points,k=[],l,f,h,m=this.requireSorting,u=a.length===d.length,
p=!0;this.xIncrement=null;a.forEach(function(a,c){var f=H(a)&&this.pointClass.prototype.optionsToObject.call({series:this},a)||{};var r=f.x;if(f.id||g(r)){if(r=this.findPointIndex(f,h),-1===r||"undefined"===typeof r?k.push(a):d[r]&&a!==b.data[r]?(d[r].update(a,!1,null,!1),d[r].touched=!0,m&&(h=r+1)):d[r]&&(d[r].touched=!0),!u||c!==r||e&&e.enabled||this.hasDerivedData)l=!0}else k.push(a)},this);if(l)for(a=d.length;a--;)(f=d[a])&&!f.touched&&f.remove&&f.remove(!1,c);else!u||e&&e.enabled?p=!1:(a.forEach(function(a,
c){d[c].update&&a!==d[c].y&&d[c].update(a,!1,null,!1)}),k.length=0);d.forEach(function(a){a&&(a.touched=!1)});if(!p)return!1;k.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);null===this.xIncrement&&this.xData&&this.xData.length&&(this.xIncrement=J(this.xData),this.autoIncrement());return!0},setData:function(a,c,b,e){var d=this,k=d.points,l=k&&k.length||0,f,h=d.options,r=d.chart,u=h.dataSorting,n=null,z=d.xAxis;n=h.turboThreshold;var y=this.xData,w=this.yData,t=(f=d.pointArrayMap)&&f.length,
B=h.keys,G=0,q=1,x;a=a||[];f=a.length;c=p(c,!0);u&&u.enabled&&(a=this.sortData(a));!1!==e&&f&&l&&!d.cropped&&!d.hasGroupedData&&d.visible&&!d.isSeriesBoosting&&(x=this.updateData(a,b));if(!x){d.xIncrement=null;d.colorCounter=0;this.parallelArrays.forEach(function(a){d[a+"Data"].length=0});if(n&&f>n)if(n=d.getFirstValidPoint(a),g(n))for(b=0;b<f;b++)y[b]=this.autoIncrement(),w[b]=a[b];else if(m(n))if(t)for(b=0;b<f;b++)e=a[b],y[b]=e[0],w[b]=e.slice(1,t+1);else for(B&&(G=B.indexOf("x"),q=B.indexOf("y"),
G=0<=G?G:0,q=0<=q?q:1),b=0;b<f;b++)e=a[b],y[b]=e[G],w[b]=e[q];else D(12,!1,r);else for(b=0;b<f;b++)"undefined"!==typeof a[b]&&(e={series:d},d.pointClass.prototype.applyOptions.apply(e,[a[b]]),d.updateParallelArrays(e,b));w&&v(w[0])&&D(14,!0,r);d.data=[];d.options.data=d.userOptions.data=a;for(b=l;b--;)k[b]&&k[b].destroy&&k[b].destroy();z&&(z.minRange=z.userMinRange);d.isDirty=r.isDirtyBox=!0;d.isDirtyData=!!k;b=!1}"point"===h.legendType&&(this.processData(),this.generatePoints());c&&r.redraw(b)},
sortData:function(a){var c=this,b=c.options.dataSorting.sortKey||"y",e=function(a,c){return H(c)&&a.pointClass.prototype.optionsToObject.call({series:a},c)||{}};a.forEach(function(b,d){a[d]=e(c,b);a[d].index=d},this);a.concat().sort(function(a,c){a=N(b,a);c=N(b,c);return c<a?-1:c>a?1:0}).forEach(function(a,c){a.x=c},this);c.linkedSeries&&c.linkedSeries.forEach(function(c){var b=c.options,d=b.data;b.dataSorting&&b.dataSorting.enabled||!d||(d.forEach(function(b,k){d[k]=e(c,b);a[k]&&(d[k].x=a[k].x,d[k].index=
k)}),c.setData(d,!1))});return a},getProcessedData:function(a){var c=this.xData,b=this.yData,e=c.length;var d=0;var g=this.xAxis,f=this.options;var l=f.cropThreshold;var h=a||this.getExtremesFromAll||f.getExtremesFromAll,m=this.isCartesian;a=g&&g.val2lin;f=!(!g||!g.logarithmic);var u=this.requireSorting;if(g){g=g.getExtremes();var p=g.min;var n=g.max}if(m&&this.sorted&&!h&&(!l||e>l||this.forceCrop))if(c[e-1]<p||c[0]>n)c=[],b=[];else if(this.yData&&(c[0]<p||c[e-1]>n)){d=this.cropData(this.xData,this.yData,
p,n);c=d.xData;b=d.yData;d=d.start;var v=!0}for(l=c.length||1;--l;)if(e=f?a(c[l])-a(c[l-1]):c[l]-c[l-1],0<e&&("undefined"===typeof y||e<y))var y=e;else 0>e&&u&&(D(15,!1,this.chart),u=!1);return{xData:c,yData:b,cropped:v,cropStart:d,closestPointRange:y}},processData:function(a){var c=this.xAxis;if(this.isCartesian&&!this.isDirty&&!c.isDirty&&!this.yAxis.isDirty&&!a)return!1;a=this.getProcessedData();this.cropped=a.cropped;this.cropStart=a.cropStart;this.processedXData=a.xData;this.processedYData=a.yData;
this.closestPointRange=this.basePointRange=a.closestPointRange},cropData:function(a,c,b,e,d){var g=a.length,k=0,l=g,f;d=p(d,this.cropShoulder);for(f=0;f<g;f++)if(a[f]>=b){k=Math.max(0,f-d);break}for(b=f;b<g;b++)if(a[b]>e){l=b+d;break}return{xData:a.slice(k,l),yData:c.slice(k,l),start:k,end:l}},generatePoints:function(){var a=this.options,c=a.data,b=this.data,e,d=this.processedXData,g=this.processedYData,f=this.pointClass,l=d.length,h=this.cropStart||0,m=this.hasGroupedData;a=a.keys;var p=[],n;b||
m||(b=[],b.length=c.length,b=this.data=b);a&&m&&(this.options.keys=!1);for(n=0;n<l;n++){var v=h+n;if(m){var y=(new f).init(this,[d[n]].concat(u(g[n])));y.dataGroup=this.groupMap[n];y.dataGroup.options&&(y.options=y.dataGroup.options,w(y,y.dataGroup.options),delete y.dataLabels)}else(y=b[v])||"undefined"===typeof c[v]||(b[v]=y=(new f).init(this,c[v],d[n]));y&&(y.index=v,p[n]=y)}this.options.keys=a;if(b&&(l!==(e=b.length)||m))for(n=0;n<e;n++)n!==h||m||(n+=l),b[n]&&(b[n].destroyElements(),b[n].plotX=
void 0);this.data=b;this.points=p;t(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:L(a),max:J(a)}},getExtremes:function(a,c){var b=this.xAxis,e=this.yAxis,d=this.processedXData||this.xData,k=[],l=0,f=0;var h=0;var u=this.requireSorting?this.cropShoulder:0,n=e?e.positiveValuesOnly:!1,p;a=a||this.stackedYData||this.processedYData||[];e=a.length;b&&(h=b.getExtremes(),f=h.min,h=h.max);for(p=0;p<e;p++){var v=d[p];var y=a[p];var w=(g(y)||m(y))&&(y.length||0<y||!n);v=c||this.getExtremesFromAll||
this.options.getExtremesFromAll||this.cropped||!b||(d[p+u]||v)>=f&&(d[p-u]||v)<=h;if(w&&v)if(w=y.length)for(;w--;)g(y[w])&&(k[l++]=y[w]);else k[l++]=y}a={dataMin:L(k),dataMax:J(k)};t(this,"afterGetExtremes",{dataExtremes:a});return a},applyExtremes:function(){var a=this.getExtremes();this.dataMin=a.dataMin;this.dataMax=a.dataMax;return a},getFirstValidPoint:function(a){for(var c=null,b=a.length,e=0;null===c&&e<b;)c=a[e],e++;return c},translate:function(){this.processedXData||this.processData();this.generatePoints();
var a=this.options,c=a.stacking,b=this.xAxis,e=b.categories,d=this.enabledDataSorting,l=this.yAxis,f=this.points,h=f.length,u=!!this.modifyValue,n,v=this.pointPlacementToXValue(),y=!!v,w=a.threshold,B=a.startFromThreshold?w:0,G,q=this.zoneAxis||"y",I=Number.MAX_VALUE;for(n=0;n<h;n++){var C=f[n],D=C.x,R=C.y,S=C.low,A=c&&l.stacking&&l.stacking.stacks[(this.negStacks&&R<(B?0:w)?"-":"")+this.stackKey];l.positiveValuesOnly&&null!==R&&0>=R&&(C.isNull=!0);C.plotX=G=F(x(b.translate(D,0,0,0,1,v,"flags"===
this.type),-1E5,1E5));if(c&&this.visible&&A&&A[D]){var E=this.getStackIndicator(E,D,this.index);if(!C.isNull){var N=A[D];var L=N.points[E.key]}}m(L)&&(S=L[0],R=L[1],S===B&&E.key===A[D].base&&(S=p(g(w)&&w,l.min)),l.positiveValuesOnly&&0>=S&&(S=null),C.total=C.stackTotal=N.total,C.percentage=N.total&&C.y/N.total*100,C.stackY=R,this.irregularWidths||N.setOffset(this.pointXOffset||0,this.barW||0));C.yBottom=H(S)?x(l.translate(S,0,1,0,1),-1E5,1E5):null;u&&(R=this.modifyValue(R,C));C.plotY="number"===typeof R&&
Infinity!==R?x(l.translate(R,0,1,0,1),-1E5,1E5):void 0;C.isInside=this.isPointInside(C);C.clientX=y?F(b.translate(D,0,0,0,1,v)):G;C.negative=C[q]<(a[q+"Threshold"]||w||0);C.category=e&&"undefined"!==typeof e[C.x]?e[C.x]:C.x;if(!C.isNull&&!1!==C.visible){"undefined"!==typeof J&&(I=Math.min(I,Math.abs(G-J)));var J=G}C.zone=this.zones.length&&C.getZone();!C.graphic&&this.group&&d&&(C.isNew=!0)}this.closestPointRangePx=I;t(this,"afterTranslate")},getValidPoints:function(a,c,b){var e=this.chart;return(a||
this.points||[]).filter(function(a){return c&&!e.isInsidePlot(a.plotX,a.plotY,e.inverted)?!1:!1!==a.visible&&(b||!a.isNull)})},getClipBox:function(a,c){var b=this.options,e=this.chart,d=e.inverted,g=this.xAxis,k=g&&this.yAxis;a&&!1===b.clip&&k?a=d?{y:-e.chartWidth+k.len+k.pos,height:e.chartWidth,width:e.chartHeight,x:-e.chartHeight+g.len+g.pos}:{y:-k.pos,height:e.chartHeight,width:e.chartWidth,x:-g.pos}:(a=this.clipBox||e.clipBox,c&&(a.width=e.plotSizeX,a.x=0));return c?{width:a.width,x:a.x}:a},setClip:function(a){var c=
this.chart,b=this.options,e=c.renderer,d=c.inverted,g=this.clipBox,l=this.getClipBox(a),f=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,l.height,b.xAxis,b.yAxis].join(),h=c[f],m=c[f+"m"];a&&(l.width=0,d&&(l.x=c.plotHeight+(!1!==b.clip?0:c.plotTop)));h?c.hasLoaded||h.attr(l):(a&&(c[f+"m"]=m=e.clipRect(d?c.plotSizeX+99:-99,d?-c.plotLeft:-c.plotTop,99,d?c.chartWidth:c.chartHeight)),c[f]=h=e.clipRect(l),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=
1);if(!1!==b.clip||a)this.group.clip(a||g?h:c.clipRect),this.markerGroup.clip(m),this.sharedClipKey=f;a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),0===h.count.length&&f&&c[f]&&(g||(c[f]=c[f].destroy()),c[f+"m"]&&(c[f+"m"]=c[f+"m"].destroy())))},animate:function(a){var c=this.chart,b=K(this.options.animation);if(!c.hasRendered)if(a)this.setClip(b);else{var e=this.sharedClipKey;a=c[e];var d=this.getClipBox(b,!0);a&&a.animate(d,b);c[e+"m"]&&c[e+"m"].animate({width:d.width+99,
x:d.x-(c.inverted?0:99)},b)}},afterAnimate:function(){this.setClip();t(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,c=this.chart,b,e,d=this.options.marker,g=this[this.specialGroup]||this.markerGroup,f=this.xAxis,l=p(d.enabled,!f||f.isRadial?!0:null,this.closestPointRangePx>=d.enabledThreshold*d.radius);if(!1!==d.enabled||this._hasPointMarkers)for(b=0;b<a.length;b++){var h=a[b];var m=(e=h.graphic)?"animate":"attr";var u=h.marker||{};var n=!!h.marker;if((l&&
"undefined"===typeof u.enabled||u.enabled)&&!h.isNull&&!1!==h.visible){var v=p(u.symbol,this.symbol);var y=this.markerAttribs(h,h.selected&&"select");this.enabledDataSorting&&(h.startXPos=f.reversed?-y.width:f.width);var w=!1!==h.isInside;e?e[w?"show":"hide"](w).animate(y):w&&(0<y.width||h.hasImage)&&(h.graphic=e=c.renderer.symbol(v,y.x,y.y,y.width,y.height,n?u:d).add(g),this.enabledDataSorting&&c.hasRendered&&(e.attr({x:h.startXPos}),m="animate"));e&&"animate"===m&&e[w?"show":"hide"](w).animate(y);
if(e&&!c.styledMode)e[m](this.pointAttribs(h,h.selected&&"select"));e&&e.addClass(h.getClassName(),!0)}else e&&(h.graphic=e.destroy())}},markerAttribs:function(a,c){var b=this.options,e=b.marker,d=a.marker||{},g=d.symbol||e.symbol,k=p(d.radius,e.radius);c&&(e=e.states[c],c=d.states&&d.states[c],k=p(c&&c.radius,e&&e.radius,k+(e&&e.radiusPlus||0)));a.hasImage=g&&0===g.indexOf("url");a.hasImage&&(k=0);a={x:b.crisp?Math.floor(a.plotX)-k:a.plotX-k,y:a.plotY-k};k&&(a.width=a.height=2*k);return a},pointAttribs:function(a,
c){var b=this.options.marker,e=a&&a.options,d=e&&e.marker||{},g=this.color,k=e&&e.color,f=a&&a.color;e=p(d.lineWidth,b.lineWidth);var l=a&&a.zone&&a.zone.color;a=1;g=k||l||f||g;k=d.fillColor||b.fillColor||g;g=d.lineColor||b.lineColor||g;c=c||"normal";b=b.states[c];c=d.states&&d.states[c]||{};e=p(c.lineWidth,b.lineWidth,e+p(c.lineWidthPlus,b.lineWidthPlus,0));k=c.fillColor||b.fillColor||k;g=c.lineColor||b.lineColor||g;a=p(c.opacity,b.opacity,a);return{stroke:g,"stroke-width":e,fill:k,opacity:a}},destroy:function(a){var b=
this,d=b.chart,g=/AppleWebKit\/533/.test(c.navigator.userAgent),f,l,h=b.data||[],m,u;t(b,"destroy");this.removeEvents(a);(b.axisTypes||[]).forEach(function(a){(u=b[a])&&u.series&&(C(u.series,b),u.isDirty=u.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(l=h.length;l--;)(m=h[l])&&m.destroy&&m.destroy();b.points=null;q.clearTimeout(b.animationTimeout);e(b,function(a,c){a instanceof B&&!a.survive&&(f=g&&"group"===c?"hide":"destroy",a[f]())});d.hoverSeries===b&&(d.hoverSeries=null);
C(d.series,b);d.orderSeries();e(b,function(c,e){a&&"hcEvents"===e||delete b[e]})},getGraphPath:function(a,c,b){var e=this,d=e.options,g=d.step,k,f=[],l=[],h;a=a||e.points;(k=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&k&&(g=4-g);a=this.getValidPoints(a,!1,!(d.connectNulls&&!c&&!b));a.forEach(function(k,m){var u=k.plotX,r=k.plotY,n=a[m-1];(k.leftCliff||n&&n.rightCliff)&&!b&&(h=!0);k.isNull&&!H(c)&&0<m?h=!d.connectNulls:k.isNull&&!c?h=!0:(0===m||h?m=[["M",k.plotX,k.plotY]]:e.getPointSpline?
m=[e.getPointSpline(a,k,m)]:g?(m=1===g?[["L",n.plotX,r]]:2===g?[["L",(n.plotX+u)/2,n.plotY],["L",(n.plotX+u)/2,r]]:[["L",u,n.plotY]],m.push(["L",u,r])):m=[["L",u,r]],l.push(k.x),g&&(l.push(k.x),2===g&&l.push(k.x)),f.push.apply(f,m),h=!1)});f.xMap=l;return e.graphPath=f},drawGraph:function(){var a=this,c=this.options,b=(this.gappedPath||this.getGraphPath).call(this),e=this.chart.styledMode,d=[["graph","highcharts-graph"]];e||d[0].push(c.lineColor||this.color||"#cccccc",c.dashStyle);d=a.getZonesGraphs(d);
d.forEach(function(d,g){var k=d[0],f=a[k],l=f?"animate":"attr";f?(f.endX=a.preventGraphAnimation?null:b.xMap,f.animate({d:b})):b.length&&(a[k]=f=a.chart.renderer.path(b).addClass(d[1]).attr({zIndex:1}).add(a.group));f&&!e&&(k={stroke:d[2],"stroke-width":c.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?k.dashstyle=d[3]:"square"!==c.linecap&&(k["stroke-linecap"]=k["stroke-linejoin"]="round"),f[l](k).shadow(2>g&&c.shadow));f&&(f.startX=b.xMap,f.isArea=b.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(c,
b){b=["zone-graph-"+b,"highcharts-graph highcharts-zone-graph-"+b+" "+(c.className||"")];this.chart.styledMode||b.push(c.color||this.color,c.dashStyle||this.options.dashStyle);a.push(b)},this);return a},applyZones:function(){var a=this,c=this.chart,b=c.renderer,e=this.zones,d,g,f=this.clips||[],l,h=this.graph,m=this.area,u=Math.max(c.chartWidth,c.chartHeight),n=this[(this.zoneAxis||"y")+"Axis"],v=c.inverted,y,w,t,B=!1,G,q;if(e.length&&(h||m)&&n&&"undefined"!==typeof n.min){var C=n.reversed;var I=
n.horiz;h&&!this.showLine&&h.hide();m&&m.hide();var D=n.getExtremes();e.forEach(function(e,k){d=C?I?c.plotWidth:0:I?0:n.toPixels(D.min)||0;d=x(p(g,d),0,u);g=x(Math.round(n.toPixels(p(e.value,D.max),!0)||0),0,u);B&&(d=g=n.toPixels(D.max));y=Math.abs(d-g);w=Math.min(d,g);t=Math.max(d,g);n.isXAxis?(l={x:v?t:w,y:0,width:y,height:u},I||(l.x=c.plotHeight-l.x)):(l={x:0,y:v?t:w,width:u,height:y},I&&(l.y=c.plotWidth-l.y));v&&b.isVML&&(l=n.isXAxis?{x:0,y:C?w:t,height:l.width,width:c.chartWidth}:{x:l.y-c.plotLeft-
c.spacingBox.x,y:0,width:l.height,height:c.chartHeight});f[k]?f[k].animate(l):f[k]=b.clipRect(l);G=a["zone-area-"+k];q=a["zone-graph-"+k];h&&q&&q.clip(f[k]);m&&G&&G.clip(f[k]);B=e.value>D.max;a.resetZones&&0===g&&(g=void 0)});this.clips=f}else a.visible&&(h&&h.show(!0),m&&m.show(!0))},invertGroups:function(a){function c(){["group","markerGroup"].forEach(function(c){b[c]&&(e.renderer.isVML&&b[c].attr({width:b.yAxis.len,height:b.xAxis.len}),b[c].width=b.yAxis.len,b[c].height=b.xAxis.len,b[c].invert(b.isRadialSeries?
!1:a))})}var b=this,e=b.chart;b.xAxis&&(b.eventsToUnbind.push(E(e,"resize",c)),c(),b.invertGroups=c)},plotGroup:function(a,c,b,e,d){var g=this[a],k=!g;k&&(this[a]=g=this.chart.renderer.g().attr({zIndex:e||.1}).add(d));g.addClass("highcharts-"+c+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(H(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:b})[k?"attr":
"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,c=this.xAxis,b=this.yAxis;a.inverted&&(c=b,b=this.xAxis);return{translateX:c?c.left:a.plotLeft,translateY:b?b.top:a.plotTop,scaleX:1,scaleY:1}},removeEvents:function(a){a?this.eventsToUnbind.length&&(this.eventsToUnbind.forEach(function(a){a()}),this.eventsToUnbind.length=0):l(this)},render:function(){var a=this,c=a.chart,b=a.options,e=!a.finishedAnimating&&c.renderer.isSVG&&K(b.animation).duration,d=a.visible?"inherit":
"hidden",g=b.zIndex,f=a.hasRendered,l=c.seriesGroup,h=c.inverted;t(this,"render");var m=a.plotGroup("group","series",d,g,l);a.markerGroup=a.plotGroup("markerGroup","markers",d,g,l);e&&a.animate&&a.animate(!0);m.inverted=a.isCartesian||a.invertable?h:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.visible&&a.drawPoints();a.drawDataLabels&&a.drawDataLabels();a.redrawPoints&&a.redrawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(h);!1===b.clip||a.sharedClipKey||
f||m.clip(c.clipRect);e&&a.animate&&a.animate();f||(a.animationTimeout=y(function(){a.afterAnimate()},e||0));a.isDirty=!1;a.hasRendered=!0;t(a,"afterRender")},redraw:function(){var a=this.chart,c=this.isDirty||this.isDirtyData,b=this.group,e=this.xAxis,d=this.yAxis;b&&(a.inverted&&b.attr({width:a.plotWidth,height:a.plotHeight}),b.animate({translateX:p(e&&e.left,a.plotLeft),translateY:p(d&&d.top,a.plotTop)}));this.translate();this.render();c&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,
c){var b=this.xAxis,e=this.yAxis,d=this.chart.inverted;return this.searchKDTree({clientX:d?b.len-a.chartY+b.pos:a.chartX-b.pos,plotY:d?e.len-a.chartX+e.pos:a.chartY-e.pos},c,a)},buildKDTree:function(a){function c(a,e,d){var g;if(g=a&&a.length){var k=b.kdAxisArray[e%d];a.sort(function(a,c){return a[k]-c[k]});g=Math.floor(g/2);return{point:a[g],left:c(a.slice(0,g),e+1,d),right:c(a.slice(g+1),e+1,d)}}}this.buildingKdTree=!0;var b=this,e=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;
y(function(){b.kdTree=c(b.getValidPoints(null,!b.directTouch),e,e);b.buildingKdTree=!1},b.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,c,b){function e(a,c,b,l){var h=c.point,m=d.kdAxisArray[b%l],u=h;var n=H(a[g])&&H(h[g])?Math.pow(a[g]-h[g],2):null;var p=H(a[k])&&H(h[k])?Math.pow(a[k]-h[k],2):null;p=(n||0)+(p||0);h.dist=H(p)?Math.sqrt(p):Number.MAX_VALUE;h.distX=H(n)?Math.sqrt(n):Number.MAX_VALUE;m=a[m]-h[m];p=0>m?"left":"right";n=0>m?"right":"left";c[p]&&(p=e(a,c[p],b+1,
l),u=p[f]<u[f]?p:h);c[n]&&Math.sqrt(m*m)<u[f]&&(a=e(a,c[n],b+1,l),u=a[f]<u[f]?a:u);return u}var d=this,g=this.kdAxisArray[0],k=this.kdAxisArray[1],f=c?"distX":"dist";c=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree(b);if(this.kdTree)return e(a,this.kdTree,c,c)},pointPlacementToXValue:function(){var a=this.options,c=a.pointRange,b=this.xAxis;a=a.pointPlacement;"between"===a&&(a=b.reversed?-.5:.5);return g(a)?a*p(c,b.pointRange):0},isPointInside:function(a){return"undefined"!==
typeof a.plotY&&"undefined"!==typeof a.plotX&&0<=a.plotY&&a.plotY<=this.yAxis.len&&0<=a.plotX&&a.plotX<=this.xAxis.len}});""});Q(A,"parts/Stacking.js",[A["parts/Axis.js"],A["parts/Globals.js"],A["parts/StackingAxis.js"],A["parts/Utilities.js"]],function(d,f,A,q){var E=q.correctFloat,K=q.defined,J=q.destroyObjectProperties,L=q.format,x=q.pick;"";q=f.Chart;var F=f.Series,H=function(){function d(d,f,n,t,q){var m=d.chart.inverted;this.axis=d;this.isNegative=n;this.options=f=f||{};this.x=t;this.total=
null;this.points={};this.stack=q;this.rightCliff=this.leftCliff=0;this.alignOptions={align:f.align||(m?n?"left":"right":"center"),verticalAlign:f.verticalAlign||(m?"middle":n?"bottom":"top"),y:f.y,x:f.x};this.textAlign=f.textAlign||(m?n?"right":"left":"center")}d.prototype.destroy=function(){J(this,this.axis)};d.prototype.render=function(d){var f=this.axis.chart,n=this.options,t=n.format;t=t?L(t,this,f):n.formatter.call(this);this.label?this.label.attr({text:t,visibility:"hidden"}):(this.label=f.renderer.label(t,
null,null,n.shape,null,null,n.useHTML,!1,"stack-labels"),t={r:n.borderRadius||0,text:t,rotation:n.rotation,padding:x(n.padding,5),visibility:"hidden"},f.styledMode||(t.fill=n.backgroundColor,t.stroke=n.borderColor,t["stroke-width"]=n.borderWidth,this.label.css(n.style)),this.label.attr(t),this.label.added||this.label.add(d));this.label.labelrank=f.plotHeight};d.prototype.setOffset=function(d,f,n,t,q){var m=this.axis,b=m.chart;t=m.translate(m.stacking.usePercentage?100:t?t:this.total,0,0,0,1);n=m.translate(n?
n:0);n=K(t)&&Math.abs(t-n);d=x(q,b.xAxis[0].translate(this.x))+d;m=K(t)&&this.getStackBox(b,this,d,t,f,n,m);f=this.label;n=this.isNegative;d="justify"===x(this.options.overflow,"justify");var g=this.textAlign;f&&m&&(q=f.getBBox(),t=f.padding,g="left"===g?b.inverted?-t:t:"right"===g?q.width:b.inverted&&"center"===g?q.width/2:b.inverted?n?q.width+t:-t:q.width/2,n=b.inverted?q.height/2:n?-t:q.height,this.alignOptions.x=x(this.options.x,0),this.alignOptions.y=x(this.options.y,0),m.x-=g,m.y-=n,f.align(this.alignOptions,
null,m),b.isInsidePlot(f.alignAttr.x+g-this.alignOptions.x,f.alignAttr.y+n-this.alignOptions.y)?f.show():(f.alignAttr.y=-9999,d=!1),d&&F.prototype.justifyDataLabel.call(this.axis,f,this.alignOptions,f.alignAttr,q,m),f.attr({x:f.alignAttr.x,y:f.alignAttr.y}),x(!d&&this.options.crop,!0)&&((b=b.isInsidePlot(f.x-t+f.width,f.y)&&b.isInsidePlot(f.x+t,f.y))||f.hide()))};d.prototype.getStackBox=function(d,f,n,t,q,m,b){var g=f.axis.reversed,v=d.inverted,h=b.height+b.pos-(v?d.plotLeft:d.plotTop);f=f.isNegative&&
!g||!f.isNegative&&g;return{x:v?f?t-b.right:t-m+b.pos-d.plotLeft:n+d.xAxis[0].transB-d.plotLeft,y:v?b.height-n-q:f?h-t-m:h-t,width:v?m:q,height:v?q:m}};return d}();q.prototype.getStacks=function(){var d=this,f=d.inverted;d.yAxis.forEach(function(d){d.stacking&&d.stacking.stacks&&d.hasVisibleSeries&&(d.stacking.oldStacks=d.stacking.stacks)});d.series.forEach(function(w){var n=w.xAxis&&w.xAxis.options||{};!w.options.stacking||!0!==w.visible&&!1!==d.options.chart.ignoreHiddenSeries||(w.stackKey=[w.type,
x(w.options.stack,""),f?n.top:n.left,f?n.height:n.width].join())})};A.compose(d);F.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var d=this.processedXData,f=this.processedYData,w=[],n=f.length,t=this.options,q=t.threshold,m=x(t.startFromThreshold&&q,0),b=t.stack;t=t.stacking;var g=this.stackKey,v="-"+g,h=this.negStacks,e=this.yAxis,p=e.stacking.stacks,l=e.stacking.oldStacks,I,u;e.stacking.stacksTouched+=1;for(u=
0;u<n;u++){var y=d[u];var G=f[u];var S=this.getStackIndicator(S,y,this.index);var R=S.key;var B=(I=h&&G<(m?0:q))?v:g;p[B]||(p[B]={});p[B][y]||(l[B]&&l[B][y]?(p[B][y]=l[B][y],p[B][y].total=null):p[B][y]=new H(e,e.options.stackLabels,I,y,b));B=p[B][y];null!==G?(B.points[R]=B.points[this.index]=[x(B.cumulative,m)],K(B.cumulative)||(B.base=R),B.touched=e.stacking.stacksTouched,0<S.index&&!1===this.singleStacks&&(B.points[R][0]=B.points[this.index+","+y+",0"][0])):B.points[R]=B.points[this.index]=null;
"percent"===t?(I=I?g:v,h&&p[I]&&p[I][y]?(I=p[I][y],B.total=I.total=Math.max(I.total,B.total)+Math.abs(G)||0):B.total=E(B.total+(Math.abs(G)||0))):B.total=E(B.total+(G||0));B.cumulative=x(B.cumulative,m)+(G||0);null!==G&&(B.points[R].push(B.cumulative),w[u]=B.cumulative)}"percent"===t&&(e.stacking.usePercentage=!0);this.stackedYData=w;e.stacking.oldStacks={}}};F.prototype.modifyStacks=function(){var d=this,f=d.stackKey,w=d.yAxis.stacking.stacks,n=d.processedXData,t,q=d.options.stacking;d[q+"Stacker"]&&
[f,"-"+f].forEach(function(f){for(var b=n.length,g,m;b--;)if(g=n[b],t=d.getStackIndicator(t,g,d.index,f),m=(g=w[f]&&w[f][g])&&g.points[t.key])d[q+"Stacker"](m,g,b)})};F.prototype.percentStacker=function(d,f,w){f=f.total?100/f.total:0;d[0]=E(d[0]*f);d[1]=E(d[1]*f);this.stackedYData[w]=d[1]};F.prototype.getStackIndicator=function(d,f,w,n){!K(d)||d.x!==f||n&&d.key!==n?d={x:f,index:0,key:n}:d.index++;d.key=[w,f,d.index].join();return d};f.StackItem=H;return f.StackItem});Q(A,"parts/Dynamics.js",[A["parts/Globals.js"],
A["parts/Point.js"],A["parts/Time.js"],A["parts/Utilities.js"]],function(d,f,A,q){var E=q.addEvent,K=q.animate,J=q.createElement,L=q.css,x=q.defined,F=q.erase,H=q.error,C=q.extend,D=q.fireEvent,w=q.isArray,n=q.isNumber,t=q.isObject,N=q.isString,m=q.merge,b=q.objectEach,g=q.pick,v=q.relativeLength,h=q.setAnimation,e=q.splat,p=d.Axis;q=d.Chart;var l=d.Series,I=d.seriesTypes;d.cleanRecursively=function(e,g){var f={};b(e,function(b,l){if(t(e[l],!0)&&!e.nodeType&&g[l])b=d.cleanRecursively(e[l],g[l]),Object.keys(b).length&&
(f[l]=b);else if(t(e[l])||e[l]!==g[l])f[l]=e[l]});return f};C(q.prototype,{addSeries:function(b,e,d){var f,l=this;b&&(e=g(e,!0),D(l,"addSeries",{options:b},function(){f=l.initSeries(b);l.isDirtyLegend=!0;l.linkSeries();f.enabledDataSorting&&f.setData(b.data,!1);D(l,"afterAddSeries",{series:f});e&&l.redraw(d)}));return f},addAxis:function(b,e,d,g){return this.createAxis(e?"xAxis":"yAxis",{axis:b,redraw:d,animation:g})},addColorAxis:function(b,e,d){return this.createAxis("colorAxis",{axis:b,redraw:e,
animation:d})},createAxis:function(b,f){var l=this.options,h="colorAxis"===b,u=f.redraw,n=f.animation;f=m(f.axis,{index:this[b].length,isX:"xAxis"===b});var c=h?new d.ColorAxis(this,f):new p(this,f);l[b]=e(l[b]||{});l[b].push(f);h&&(this.isDirtyLegend=!0,this.axes.forEach(function(a){a.series=[]}),this.series.forEach(function(a){a.bindAxes();a.isDirtyData=!0}));g(u,!0)&&this.redraw(n);return c},showLoading:function(b){var e=this,d=e.options,f=e.loadingDiv,l=d.loading,h=function(){f&&L(f,{left:e.plotLeft+
"px",top:e.plotTop+"px",width:e.plotWidth+"px",height:e.plotHeight+"px"})};f||(e.loadingDiv=f=J("div",{className:"highcharts-loading highcharts-loading-hidden"},null,e.container),e.loadingSpan=J("span",{className:"highcharts-loading-inner"},null,f),E(e,"redraw",h));f.className="highcharts-loading";e.loadingSpan.innerHTML=g(b,d.lang.loading,"");e.styledMode||(L(f,C(l.style,{zIndex:10})),L(e.loadingSpan,l.labelStyle),e.loadingShown||(L(f,{opacity:0,display:""}),K(f,{opacity:l.style.opacity||.5},{duration:l.showDuration||
0})));e.loadingShown=!0;h()},hideLoading:function(){var b=this.options,e=this.loadingDiv;e&&(e.className="highcharts-loading highcharts-loading-hidden",this.styledMode||K(e,{opacity:0},{duration:b.loading.hideDuration||100,complete:function(){L(e,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),collectionsWithUpdate:["xAxis","yAxis","zAxis","series"],update:function(f,l,h,p){var u=this,y={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},c,a,k,r=f.isResponsiveOptions,t=[];D(u,"update",{options:f});r||u.setResponsive(!1,!0);f=d.cleanRecursively(f,u.options);m(!0,u.userOptions,f);if(c=f.chart){m(!0,u.options.chart,c);"className"in
c&&u.setClassName(c.className);"reflow"in c&&u.setReflow(c.reflow);if("inverted"in c||"polar"in c||"type"in c){u.propFromSeries();var w=!0}"alignTicks"in c&&(w=!0);b(c,function(c,b){-1!==u.propsRequireUpdateSeries.indexOf("chart."+b)&&(a=!0);-1!==u.propsRequireDirtyBox.indexOf(b)&&(u.isDirtyBox=!0);r||-1===u.propsRequireReflow.indexOf(b)||(k=!0)});!u.styledMode&&"style"in c&&u.renderer.setStyle(c.style)}!u.styledMode&&f.colors&&(this.options.colors=f.colors);f.plotOptions&&m(!0,this.options.plotOptions,
f.plotOptions);f.time&&this.time===d.time&&(this.time=new A(f.time));b(f,function(c,b){if(u[b]&&"function"===typeof u[b].update)u[b].update(c,!1);else if("function"===typeof u[y[b]])u[y[b]](c);"chart"!==b&&-1!==u.propsRequireUpdateSeries.indexOf(b)&&(a=!0)});this.collectionsWithUpdate.forEach(function(a){if(f[a]){if("series"===a){var c=[];u[a].forEach(function(a,b){a.options.isInternal||c.push(g(a.options.index,b))})}e(f[a]).forEach(function(b,e){(e=x(b.id)&&u.get(b.id)||u[a][c?c[e]:e])&&e.coll===
a&&(e.update(b,!1),h&&(e.touched=!0));!e&&h&&u.collectionsWithInit[a]&&(u.collectionsWithInit[a][0].apply(u,[b].concat(u.collectionsWithInit[a][1]||[]).concat([!1])).touched=!0)});h&&u[a].forEach(function(a){a.touched||a.options.isInternal?delete a.touched:t.push(a)})}});t.forEach(function(a){a.remove&&a.remove(!1)});w&&u.axes.forEach(function(a){a.update({},!1)});a&&u.getSeriesOrderByLinks().forEach(function(a){a.chart&&a.update({},!1)},this);f.loading&&m(!0,u.options.loading,f.loading);w=c&&c.width;
c=c&&c.height;N(c)&&(c=v(c,w||u.chartWidth));k||n(w)&&w!==u.chartWidth||n(c)&&c!==u.chartHeight?u.setSize(w,c,p):g(l,!0)&&u.redraw(p);D(u,"afterUpdate",{options:f,redraw:l,animation:p})},setSubtitle:function(b,e){this.applyDescription("subtitle",b);this.layOutTitles(e)},setCaption:function(b,e){this.applyDescription("caption",b);this.layOutTitles(e)}});q.prototype.collectionsWithInit={xAxis:[q.prototype.addAxis,[!0]],yAxis:[q.prototype.addAxis,[!1]],series:[q.prototype.addSeries]};C(f.prototype,{update:function(b,
e,d,f){function l(){h.applyOptions(b);var f=a&&h.hasDummyGraphic;f=null===h.y?!f:f;a&&f&&(h.graphic=a.destroy(),delete h.hasDummyGraphic);t(b,!0)&&(a&&a.element&&b&&b.marker&&"undefined"!==typeof b.marker.symbol&&(h.graphic=a.destroy()),b&&b.dataLabels&&h.dataLabel&&(h.dataLabel=h.dataLabel.destroy()),h.connector&&(h.connector=h.connector.destroy()));k=h.index;c.updateParallelArrays(h,k);u.data[k]=t(u.data[k],!0)||t(b,!0)?h.options:g(b,u.data[k]);c.isDirty=c.isDirtyData=!0;!c.fixedBox&&c.hasCartesianSeries&&
(m.isDirtyBox=!0);"point"===u.legendType&&(m.isDirtyLegend=!0);e&&m.redraw(d)}var h=this,c=h.series,a=h.graphic,k,m=c.chart,u=c.options;e=g(e,!0);!1===f?l():h.firePointEvent("update",{options:b},l)},remove:function(b,e){this.series.removePoint(this.series.data.indexOf(this),b,e)}});C(l.prototype,{addPoint:function(b,e,d,f,l){var h=this.options,c=this.data,a=this.chart,k=this.xAxis;k=k&&k.hasNames&&k.names;var m=h.data,u=this.xData,n;e=g(e,!0);var p={series:this};this.pointClass.prototype.applyOptions.apply(p,
[b]);var v=p.x;var y=u.length;if(this.requireSorting&&v<u[y-1])for(n=!0;y&&u[y-1]>v;)y--;this.updateParallelArrays(p,"splice",y,0,0);this.updateParallelArrays(p,y);k&&p.name&&(k[v]=p.name);m.splice(y,0,b);n&&(this.data.splice(y,0,null),this.processData());"point"===h.legendType&&this.generatePoints();d&&(c[0]&&c[0].remove?c[0].remove(!1):(c.shift(),this.updateParallelArrays(p,"shift"),m.shift()));!1!==l&&D(this,"addPoint",{point:p});this.isDirtyData=this.isDirty=!0;e&&a.redraw(f)},removePoint:function(b,
e,d){var f=this,l=f.data,m=l[b],c=f.points,a=f.chart,k=function(){c&&c.length===l.length&&c.splice(b,1);l.splice(b,1);f.options.data.splice(b,1);f.updateParallelArrays(m||{series:f},"splice",b,1);m&&m.destroy();f.isDirty=!0;f.isDirtyData=!0;e&&a.redraw()};h(d,a);e=g(e,!0);m?m.firePointEvent("remove",null,k):k()},remove:function(b,e,d,f){function l(){h.destroy(f);h.remove=null;c.isDirtyLegend=c.isDirtyBox=!0;c.linkSeries();g(b,!0)&&c.redraw(e)}var h=this,c=h.chart;!1!==d?D(h,"remove",null,l):l()},
update:function(b,e){b=d.cleanRecursively(b,this.userOptions);D(this,"update",{options:b});var f=this,l=f.chart,h=f.userOptions,n=f.initialType||f.type,c=b.type||h.type||l.options.chart.type,a=!(this.hasDerivedData||b.dataGrouping||c&&c!==this.type||"undefined"!==typeof b.pointStart||b.pointInterval||b.pointIntervalUnit||b.keys),k=I[n].prototype,p,u=["group","markerGroup","dataLabelsGroup","transformGroup"],v=["eventOptions","navigatorSeries","baseSeries"],y=f.finishedAnimating&&{animation:!1},t=
{};a&&(v.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==b.visible&&v.push("area","graph"),f.parallelArrays.forEach(function(a){v.push(a+"Data")}),b.data&&(b.dataSorting&&C(f.options.dataSorting,b.dataSorting),this.setData(b.data,!1)));b=m(h,y,{index:"undefined"===typeof h.index?f.index:h.index,pointStart:g(h.pointStart,f.xData[0])},!a&&{data:f.options.data},b);a&&b.data&&(b.data=
f.options.data);v=u.concat(v);v.forEach(function(a){v[a]=f[a];delete f[a]});f.remove(!1,null,!1,!0);for(p in k)f[p]=void 0;I[c||n]?C(f,I[c||n].prototype):H(17,!0,l,{missingModuleFor:c||n});v.forEach(function(a){f[a]=v[a]});f.init(l,b);if(a&&this.points){var w=f.options;!1===w.visible?(t.graphic=1,t.dataLabel=1):f._hasPointLabels||(c=w.marker,k=w.dataLabels,c&&(!1===c.enabled||"symbol"in c)&&(t.graphic=1),k&&!1===k.enabled&&(t.dataLabel=1));this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),
Object.keys(t).length&&a.destroyElements(t),!1===w.showInLegend&&a.legendItem&&l.legend.destroyItem(a))},this)}b.zIndex!==h.zIndex&&u.forEach(function(a){f[a]&&f[a].attr({zIndex:b.zIndex})});f.initialType=n;l.linkSeries();D(this,"afterUpdate");g(e,!0)&&l.redraw(a?void 0:!1)},setName:function(b){this.name=this.options.name=this.userOptions.name=b;this.chart.isDirtyLegend=!0}});C(p.prototype,{update:function(e,d){var f=this.chart,l=e&&e.events||{};e=m(this.userOptions,e);f.options[this.coll].indexOf&&
(f.options[this.coll][f.options[this.coll].indexOf(this.userOptions)]=e);b(f.options[this.coll].events,function(b,e){"undefined"===typeof l[e]&&(l[e]=void 0)});this.destroy(!0);this.init(f,C(e,{events:l}));f.isDirtyBox=!0;g(d,!0)&&f.redraw()},remove:function(b){for(var e=this.chart,d=this.coll,f=this.series,l=f.length;l--;)f[l]&&f[l].remove(!1);F(e.axes,this);F(e[d],this);w(e.options[d])?e.options[d].splice(this.options.index,1):delete e.options[d];e[d].forEach(function(b,c){b.options.index=b.userOptions.index=
c});this.destroy();e.isDirtyBox=!0;g(b,!0)&&e.redraw()},setTitle:function(b,e){this.update({title:b},e)},setCategories:function(b,e){this.update({categories:b},e)}})});Q(A,"parts/AreaSeries.js",[A["parts/Globals.js"],A["parts/Color.js"],A["mixins/legend-symbol.js"],A["parts/Utilities.js"]],function(d,f,A,q){var E=f.parse,K=q.objectEach,J=q.pick;f=q.seriesType;var L=d.Series;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(d){var f=[],q=[],x=this.xAxis,D=this.yAxis,
w=D.stacking.stacks[this.stackKey],n={},t=this.index,A=D.series,m=A.length,b=J(D.options.reversedStacks,!0)?1:-1,g;d=d||this.points;if(this.options.stacking){for(g=0;g<d.length;g++)d[g].leftNull=d[g].rightNull=void 0,n[d[g].x]=d[g];K(w,function(b,e){null!==b.total&&q.push(e)});q.sort(function(b,e){return b-e});var v=A.map(function(b){return b.visible});q.forEach(function(d,e){var h=0,l,I;if(n[d]&&!n[d].isNull)f.push(n[d]),[-1,1].forEach(function(f){var h=1===f?"rightNull":"leftNull",p=0,u=w[q[e+f]];
if(u)for(g=t;0<=g&&g<m;)l=u.points[g],l||(g===t?n[d][h]=!0:v[g]&&(I=w[d].points[g])&&(p-=I[1]-I[0])),g+=b;n[d][1===f?"rightCliff":"leftCliff"]=p});else{for(g=t;0<=g&&g<m;){if(l=w[d].points[g]){h=l[1];break}g+=b}h=D.translate(h,0,1,0,1);f.push({isNull:!0,plotX:x.translate(d,0,0,0,1),x:d,plotY:h,yBottom:h})}})}return f},getGraphPath:function(d){var f=L.prototype.getGraphPath,q=this.options,x=q.stacking,D=this.yAxis,w,n=[],t=[],A=this.index,m=D.stacking.stacks[this.stackKey],b=q.threshold,g=Math.round(D.getThreshold(q.threshold));
q=J(q.connectNulls,"percent"===x);var v=function(f,h,p){var l=d[f];f=x&&m[l.x].points[A];var u=l[p+"Null"]||0;p=l[p+"Cliff"]||0;l=!0;if(p||u){var v=(u?f[0]:f[1])+p;var w=f[0]+p;l=!!u}else!x&&d[h]&&d[h].isNull&&(v=w=b);"undefined"!==typeof v&&(t.push({plotX:e,plotY:null===v?g:D.getThreshold(v),isNull:l,isCliff:!0}),n.push({plotX:e,plotY:null===w?g:D.getThreshold(w),doCurve:!1}))};d=d||this.points;x&&(d=this.getStackPoints(d));for(w=0;w<d.length;w++){x||(d[w].leftCliff=d[w].rightCliff=d[w].leftNull=
d[w].rightNull=void 0);var h=d[w].isNull;var e=J(d[w].rectPlotX,d[w].plotX);var p=J(d[w].yBottom,g);if(!h||q)q||v(w,w-1,"left"),h&&!x&&q||(t.push(d[w]),n.push({x:w,plotX:e,plotY:p})),q||v(w,w+1,"right")}w=f.call(this,t,!0,!0);n.reversed=!0;h=f.call(this,n,!0,!0);(p=h[0])&&"M"===p[0]&&(h[0]=["L",p[1],p[2]]);h=w.concat(h);f=f.call(this,t,!1,q);h.xMap=w.xMap;this.areaPath=h;return f},drawGraph:function(){this.areaPath=[];L.prototype.drawGraph.apply(this);var d=this,f=this.areaPath,q=this.options,C=[["area",
"highcharts-area",this.color,q.fillColor]];this.zones.forEach(function(f,w){C.push(["zone-area-"+w,"highcharts-area highcharts-zone-area-"+w+" "+f.className,f.color||d.color,f.fillColor||q.fillColor])});C.forEach(function(x){var w=x[0],n=d[w],t=n?"animate":"attr",C={};n?(n.endX=d.preventGraphAnimation?null:f.xMap,n.animate({d:f})):(C.zIndex=0,n=d[w]=d.chart.renderer.path(f).addClass(x[1]).add(d.group),n.isArea=!0);d.chart.styledMode||(C.fill=J(x[3],E(x[2]).setOpacity(J(q.fillOpacity,.75)).get()));
n[t](C);n.startX=f.xMap;n.shiftUnit=q.step?2:1})},drawLegendSymbol:A.drawRectangle});""});Q(A,"parts/SplineSeries.js",[A["parts/Utilities.js"]],function(d){var f=d.pick;d=d.seriesType;d("spline","line",{},{getPointSpline:function(d,q,A){var E=q.plotX||0,J=q.plotY||0,L=d[A-1];A=d[A+1];if(L&&!L.isNull&&!1!==L.doCurve&&!q.isCliff&&A&&!A.isNull&&!1!==A.doCurve&&!q.isCliff){d=L.plotY||0;var x=A.plotX||0;A=A.plotY||0;var F=0;var H=(1.5*E+(L.plotX||0))/2.5;var C=(1.5*J+d)/2.5;x=(1.5*E+x)/2.5;var D=(1.5*
J+A)/2.5;x!==H&&(F=(D-C)*(x-E)/(x-H)+J-D);C+=F;D+=F;C>d&&C>J?(C=Math.max(d,J),D=2*J-C):C<d&&C<J&&(C=Math.min(d,J),D=2*J-C);D>A&&D>J?(D=Math.max(A,J),C=2*J-D):D<A&&D<J&&(D=Math.min(A,J),C=2*J-D);q.rightContX=x;q.rightContY=D}q=["C",f(L.rightContX,L.plotX,0),f(L.rightContY,L.plotY,0),f(H,E,0),f(C,J,0),E,J];L.rightContX=L.rightContY=void 0;return q}});""});Q(A,"parts/AreaSplineSeries.js",[A["parts/Globals.js"],A["mixins/legend-symbol.js"],A["parts/Utilities.js"]],function(d,f,A){A=A.seriesType;var q=
d.seriesTypes.area.prototype;A("areaspline","spline",d.defaultPlotOptions.area,{getStackPoints:q.getStackPoints,getGraphPath:q.getGraphPath,drawGraph:q.drawGraph,drawLegendSymbol:f.drawRectangle});""});Q(A,"parts/ColumnSeries.js",[A["parts/Globals.js"],A["parts/Color.js"],A["mixins/legend-symbol.js"],A["parts/Utilities.js"]],function(d,f,A,q){"";var E=f.parse,K=q.animObject,J=q.clamp,L=q.defined,x=q.extend,F=q.isNumber,H=q.merge,C=q.pick;f=q.seriesType;var D=d.Series;f("column","line",{borderRadius:0,
groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){D.prototype.init.apply(this,arguments);var d=this,f=d.chart;
f.hasRendered&&f.series.forEach(function(f){f.type===d.type&&(f.isDirty=!0)})},getColumnMetrics:function(){var d=this,f=d.options,t=d.xAxis,q=d.yAxis,m=t.options.reversedStacks;m=t.reversed&&!m||!t.reversed&&m;var b,g={},v=0;!1===f.grouping?v=1:d.chart.series.forEach(function(e){var f=e.yAxis,l=e.options;if(e.type===d.type&&(e.visible||!d.chart.options.chart.ignoreHiddenSeries)&&q.len===f.len&&q.pos===f.pos){if(l.stacking){b=e.stackKey;"undefined"===typeof g[b]&&(g[b]=v++);var h=g[b]}else!1!==l.grouping&&
(h=v++);e.columnIndex=h}});var h=Math.min(Math.abs(t.transA)*(t.ordinal&&t.ordinal.slope||f.pointRange||t.closestPointRange||t.tickInterval||1),t.len),e=h*f.groupPadding,p=(h-2*e)/(v||1);f=Math.min(f.maxPointWidth||t.len,C(f.pointWidth,p*(1-2*f.pointPadding)));d.columnMetrics={width:f,offset:(p-f)/2+(e+((d.columnIndex||0)+(m?1:0))*p-h/2)*(m?-1:1)};return d.columnMetrics},crispCol:function(d,f,t,q){var m=this.chart,b=this.borderWidth,g=-(b%2?.5:0);b=b%2?.5:1;m.inverted&&m.renderer.isVML&&(b+=1);this.options.crisp&&
(t=Math.round(d+t)+g,d=Math.round(d)+g,t-=d);q=Math.round(f+q)+b;g=.5>=Math.abs(f)&&.5<q;f=Math.round(f)+b;q-=f;g&&q&&(--f,q+=1);return{x:d,y:f,width:t,height:q}},translate:function(){var d=this,f=d.chart,t=d.options,q=d.dense=2>d.closestPointRange*d.xAxis.transA;q=d.borderWidth=C(t.borderWidth,q?0:1);var m=d.xAxis,b=d.yAxis,g=t.threshold,v=d.translatedThreshold=b.getThreshold(g),h=C(t.minPointLength,5),e=d.getColumnMetrics(),p=e.width,l=d.barW=Math.max(p,1+2*q),I=d.pointXOffset=e.offset,u=d.dataMin,
y=d.dataMax;f.inverted&&(v-=.5);t.pointPadding&&(l=Math.ceil(l));D.prototype.translate.apply(d);d.points.forEach(function(e){var n=C(e.yBottom,v),t=999+Math.abs(n),q=p,c=e.plotX;t=J(e.plotY,-t,b.len+t);var a=e.plotX+I,k=l,r=Math.min(t,n),w=Math.max(t,n)-r;if(h&&Math.abs(w)<h){w=h;var x=!b.reversed&&!e.negative||b.reversed&&e.negative;F(g)&&F(y)&&e.y===g&&y<=g&&(b.min||0)<g&&u!==y&&(x=!x);r=Math.abs(r-v)>h?n-h:v-(x?h:0)}L(e.options.pointWidth)&&(q=k=Math.ceil(e.options.pointWidth),a-=Math.round((q-
p)/2));e.barX=a;e.pointWidth=q;e.tooltipPos=f.inverted?[b.len+b.pos-f.plotLeft-t,m.len+m.pos-f.plotTop-(c||0)-I-k/2,w]:[a+k/2,t+b.pos-f.plotTop,w];e.shapeType=d.pointClass.prototype.shapeType||"rect";e.shapeArgs=d.crispCol.apply(d,e.isNull?[a,v,k,0]:[a,r,k,w])})},getSymbol:d.noop,drawLegendSymbol:A.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(d,f){var n=this.options,q=this.pointAttrToOptions||{};var m=q.stroke||
"borderColor";var b=q["stroke-width"]||"borderWidth",g=d&&d.color||this.color,v=d&&d[m]||n[m]||this.color||g,h=d&&d[b]||n[b]||this[b]||0;q=d&&d.options.dashStyle||n.dashStyle;var e=C(d&&d.opacity,n.opacity,1);if(d&&this.zones.length){var p=d.getZone();g=d.options.color||p&&(p.color||d.nonZonedColor)||this.color;p&&(v=p.borderColor||v,q=p.dashStyle||q,h=p.borderWidth||h)}f&&d&&(d=H(n.states[f],d.options.states&&d.options.states[f]||{}),f=d.brightness,g=d.color||"undefined"!==typeof f&&E(g).brighten(d.brightness).get()||
g,v=d[m]||v,h=d[b]||h,q=d.dashStyle||q,e=C(d.opacity,e));m={fill:g,stroke:v,"stroke-width":h,opacity:e};q&&(m.dashstyle=q);return m},drawPoints:function(){var d=this,f=this.chart,q=d.options,x=f.renderer,m=q.animationLimit||250,b;d.points.forEach(function(g){var n=g.graphic,h=!!n,e=n&&f.pointCount<m?"animate":"attr";if(F(g.plotY)&&null!==g.y){b=g.shapeArgs;n&&g.hasNewShapeType()&&(n=n.destroy());d.enabledDataSorting&&(g.startXPos=d.xAxis.reversed?-(b?b.width:0):d.xAxis.width);n||(g.graphic=n=x[g.shapeType](b).add(g.group||
d.group))&&d.enabledDataSorting&&f.hasRendered&&f.pointCount<m&&(n.attr({x:g.startXPos}),h=!0,e="animate");if(n&&h)n[e](H(b));if(q.borderRadius)n[e]({r:q.borderRadius});f.styledMode||n[e](d.pointAttribs(g,g.selected&&"select")).shadow(!1!==g.allowShadow&&q.shadow,null,q.stacking&&!q.borderRadius);n.addClass(g.getClassName(),!0)}else n&&(g.graphic=n.destroy())})},animate:function(d){var f=this,q=this.yAxis,w=f.options,m=this.chart.inverted,b={},g=m?"translateX":"translateY";if(d)b.scaleY=.001,d=J(q.toPixels(w.threshold),
q.pos,q.pos+q.len),m?b.translateX=d-q.len:b.translateY=d,f.clipBox&&f.setClip(),f.group.attr(b);else{var v=f.group.attr(g);f.group.animate({scaleY:1},x(K(f.options.animation),{step:function(d,e){f.group&&(b[g]=v+e.pos*(q.pos-v),f.group.attr(b))}}))}},remove:function(){var d=this,f=d.chart;f.hasRendered&&f.series.forEach(function(f){f.type===d.type&&(f.isDirty=!0)});D.prototype.remove.apply(d,arguments)}});""});Q(A,"parts/BarSeries.js",[A["parts/Utilities.js"]],function(d){d=d.seriesType;d("bar","column",
null,{inverted:!0});""});Q(A,"parts/ScatterSeries.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var A=f.addEvent;f=f.seriesType;var q=d.Series;f("scatter","line",{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group",
"markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&q.prototype.drawGraph.call(this)},applyJitter:function(){var d=this,f=this.options.jitter,q=this.points.length;f&&this.points.forEach(function(A,x){["x","y"].forEach(function(E,H){var C="plot"+E.toUpperCase();if(f[E]&&!A.isNull){var D=d[E+"Axis"];var w=f[E]*D.transA;if(D&&!D.isLog){var n=Math.max(0,A[C]-w);D=Math.min(D.len,A[C]+w);H=1E4*Math.sin(x+H*q);A[C]=n+(D-n)*(H-Math.floor(H));"x"===E&&(A.clientX=
A.plotX)}}})})}});A(q,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});Q(A,"mixins/centered-series.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var A=f.isNumber,q=f.pick,M=f.relativeLength,K=d.deg2rad;d.CenteredSeriesMixin={getCenter:function(){var d=this.options,f=this.chart,x=2*(d.slicedOffset||0),A=f.plotWidth-2*x,E=f.plotHeight-2*x,C=d.center,D=Math.min(A,E),w=d.size,n=d.innerSize||0;"string"===typeof w&&(w=parseFloat(w));"string"===typeof n&&(n=parseFloat(n));
d=[q(C[0],"50%"),q(C[1],"50%"),q(w&&0>w?void 0:d.size,"100%"),q(n&&0>n?void 0:d.innerSize||0,"0%")];f.angular&&(d[3]=0);for(C=0;4>C;++C)w=d[C],f=2>C||2===C&&/%$/.test(w),d[C]=M(w,[A,E,D,d[2]][C])+(f?x:0);d[3]>d[2]&&(d[3]=d[2]);return d},getStartAndEndRadians:function(d,f){d=A(d)?d:0;f=A(f)&&f>d&&360>f-d?f:d+360;return{start:K*(d+-90),end:K*(f+-90)}}}});Q(A,"parts/PieSeries.js",[A["parts/Globals.js"],A["mixins/legend-symbol.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(d,f,A,q){var E=
q.addEvent,K=q.clamp,J=q.defined,L=q.fireEvent,x=q.isNumber,F=q.merge,H=q.pick,C=q.relativeLength,D=q.seriesType,w=q.setAnimation;q=d.CenteredSeriesMixin;var n=q.getStartAndEndRadians,t=d.noop,N=d.Series;D("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,connectorShape:"fixedOffset",crookDistance:"70%",distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},softConnector:!0,x:0},fillColor:void 0,ignoreHiddenPoint:!0,
inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:d.seriesTypes.column.prototype.pointAttribs,animate:function(d){var b=this,f=b.points,m=b.startAngleRad;d||f.forEach(function(d){var e=d.graphic,
f=d.shapeArgs;e&&f&&(e.attr({r:H(d.startR,b.center&&b.center[3]/2),start:m,end:m}),e.animate({r:f.r,start:f.start,end:f.end},b.options.animation))})},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var d,b=0,f=this.points,n=f.length,h=this.options.ignoreHiddenPoint;for(d=0;d<n;d++){var e=f[d];b+=h&&!e.visible?0:e.isNull?0:e.y}this.total=b;for(d=0;d<n;d++)e=f[d],e.percentage=0<b&&(e.visible||!h)?e.y/b*100:0,e.total=b},generatePoints:function(){N.prototype.generatePoints.call(this);
this.updateTotals()},getX:function(d,b,f){var g=this.center,h=this.radii?this.radii[f.index]:g[2]/2;d=Math.asin(K((d-g[1])/(h+f.labelDistance),-1,1));return g[0]+(b?-1:1)*Math.cos(d)*(h+f.labelDistance)+(0<f.labelDistance?(b?-1:1)*this.options.dataLabels.padding:0)},translate:function(d){this.generatePoints();var b=0,f=this.options,m=f.slicedOffset,h=m+(f.borderWidth||0),e=n(f.startAngle,f.endAngle),p=this.startAngleRad=e.start;e=(this.endAngleRad=e.end)-p;var l=this.points,q=f.dataLabels.distance;
f=f.ignoreHiddenPoint;var u,y=l.length;d||(this.center=d=this.getCenter());for(u=0;u<y;u++){var t=l[u];var w=p+b*e;if(!f||t.visible)b+=t.percentage/100;var x=p+b*e;t.shapeType="arc";t.shapeArgs={x:d[0],y:d[1],r:d[2]/2,innerR:d[3]/2,start:Math.round(1E3*w)/1E3,end:Math.round(1E3*x)/1E3};t.labelDistance=H(t.options.dataLabels&&t.options.dataLabels.distance,q);t.labelDistance=C(t.labelDistance,t.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,t.labelDistance);x=(x+w)/2;x>1.5*Math.PI?
x-=2*Math.PI:x<-Math.PI/2&&(x+=2*Math.PI);t.slicedTranslation={translateX:Math.round(Math.cos(x)*m),translateY:Math.round(Math.sin(x)*m)};var B=Math.cos(x)*d[2]/2;var c=Math.sin(x)*d[2]/2;t.tooltipPos=[d[0]+.7*B,d[1]+.7*c];t.half=x<-Math.PI/2||x>Math.PI/2?1:0;t.angle=x;w=Math.min(h,t.labelDistance/5);t.labelPosition={natural:{x:d[0]+B+Math.cos(x)*t.labelDistance,y:d[1]+c+Math.sin(x)*t.labelDistance},"final":{},alignment:0>t.labelDistance?"center":t.half?"right":"left",connectorPosition:{breakAt:{x:d[0]+
B+Math.cos(x)*w,y:d[1]+c+Math.sin(x)*w},touchingSliceAt:{x:d[0]+B,y:d[1]+c}}}}L(this,"afterTranslate")},drawEmpty:function(){var d=this.options;if(0===this.total){var b=this.center[0];var f=this.center[1];this.graph||(this.graph=this.chart.renderer.circle(b,f,0).addClass("highcharts-graph").add(this.group));this.graph.animate({"stroke-width":d.borderWidth,cx:b,cy:f,r:this.center[2]/2,fill:d.fillColor||"none",stroke:d.color||"#cccccc"},this.options.animation)}else this.graph&&(this.graph=this.graph.destroy())},
redrawPoints:function(){var d=this,b=d.chart,f=b.renderer,n,h,e,p,l=d.options.shadow;this.drawEmpty();!l||d.shadowGroup||b.styledMode||(d.shadowGroup=f.g("shadow").attr({zIndex:-1}).add(d.group));d.points.forEach(function(g){var m={};h=g.graphic;if(!g.isNull&&h){p=g.shapeArgs;n=g.getTranslate();if(!b.styledMode){var v=g.shadowGroup;l&&!v&&(v=g.shadowGroup=f.g("shadow").add(d.shadowGroup));v&&v.attr(n);e=d.pointAttribs(g,g.selected&&"select")}g.delayedRendering?(h.setRadialReference(d.center).attr(p).attr(n),
b.styledMode||h.attr(e).attr({"stroke-linejoin":"round"}).shadow(l,v),g.delayedRendering=!1):(h.setRadialReference(d.center),b.styledMode||F(!0,m,e),F(!0,m,p,n),h.animate(m));h.attr({visibility:g.visible?"inherit":"hidden"});h.addClass(g.getClassName())}else h&&(g.graphic=h.destroy())})},drawPoints:function(){var d=this.chart.renderer;this.points.forEach(function(b){b.graphic&&b.hasNewShapeType()&&(b.graphic=b.graphic.destroy());b.graphic||(b.graphic=d[b.shapeType](b.shapeArgs).add(b.series.group),
b.delayedRendering=!0)})},searchPoint:t,sortByAngle:function(d,b){d.sort(function(d,f){return"undefined"!==typeof d.angle&&(f.angle-d.angle)*b})},drawLegendSymbol:f.drawRectangle,getCenter:q.getCenter,getSymbol:t,drawGraph:null},{init:function(){A.prototype.init.apply(this,arguments);var d=this;d.name=H(d.name,"Slice");var b=function(b){d.slice("select"===b.type)};E(d,"select",b);E(d,"unselect",b);return d},isValid:function(){return x(this.y)&&0<=this.y},setVisible:function(d,b){var f=this,m=f.series,
h=m.chart,e=m.options.ignoreHiddenPoint;b=H(b,e);d!==f.visible&&(f.visible=f.options.visible=d="undefined"===typeof d?!f.visible:d,m.options.data[m.data.indexOf(f)]=f.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(b){if(f[b])f[b][d?"show":"hide"](!0)}),f.legendItem&&h.legend.colorizeItem(f,d),d||"hover"!==f.state||f.setState(""),e&&(m.isDirty=!0),b&&h.redraw())},slice:function(d,b,f){var g=this.series;w(f,g.chart);H(b,!0);this.sliced=this.options.sliced=J(d)?d:!this.sliced;
g.options.data[g.data.indexOf(this)]=this.options;this.graphic&&this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(d){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+d,b.r+d,{innerR:b.r-1,start:b.start,end:b.end})},connectorShapes:{fixedOffset:function(d,b,f){var g=b.breakAt;
b=b.touchingSliceAt;return[["M",d.x,d.y],f.softConnector?["C",d.x+("left"===d.alignment?-5:5),d.y,2*g.x-b.x,2*g.y-b.y,g.x,g.y]:["L",g.x,g.y],["L",b.x,b.y]]},straight:function(d,b){b=b.touchingSliceAt;return[["M",d.x,d.y],["L",b.x,b.y]]},crookedLine:function(d,b,f){b=b.touchingSliceAt;var g=this.series,h=g.center[0],e=g.chart.plotWidth,m=g.chart.plotLeft;g=d.alignment;var l=this.shapeArgs.r;f=C(f.crookDistance,1);e="left"===g?h+l+(e+m-h-l)*(1-f):m+(h-l)*f;f=["L",e,d.y];h=!0;if("left"===g?e>d.x||e<
b.x:e<d.x||e>b.x)h=!1;d=[["M",d.x,d.y]];h&&d.push(f);d.push(["L",b.x,b.y]);return d}},getConnectorPath:function(){var d=this.labelPosition,b=this.series.options.dataLabels,f=b.connectorShape,n=this.connectorShapes;n[f]&&(f=n[f]);return f.call(this,{x:d.final.x,y:d.final.y,alignment:d.alignment},d.connectorPosition,b)}});""});Q(A,"parts/DataLabels.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var A=f.animObject,q=f.arrayMax,M=f.clamp,K=f.defined,J=f.extend,L=f.fireEvent,x=f.format,
F=f.isArray,H=f.merge,C=f.objectEach,D=f.pick,w=f.relativeLength,n=f.splat,t=f.stableSort;f=d.noop;var N=d.Series,m=d.seriesTypes;d.distribute=function(b,f,m){function g(b,e){return b.target-e.target}var e,n=!0,l=b,v=[];var u=0;var q=l.reducedLen||f;for(e=b.length;e--;)u+=b[e].size;if(u>q){t(b,function(b,e){return(e.rank||0)-(b.rank||0)});for(u=e=0;u<=q;)u+=b[e].size,e++;v=b.splice(e-1,b.length)}t(b,g);for(b=b.map(function(b){return{size:b.size,targets:[b.target],align:D(b.align,.5)}});n;){for(e=
b.length;e--;)n=b[e],u=(Math.min.apply(0,n.targets)+Math.max.apply(0,n.targets))/2,n.pos=M(u-n.size*n.align,0,f-n.size);e=b.length;for(n=!1;e--;)0<e&&b[e-1].pos+b[e-1].size>b[e].pos&&(b[e-1].size+=b[e].size,b[e-1].targets=b[e-1].targets.concat(b[e].targets),b[e-1].align=.5,b[e-1].pos+b[e-1].size>f&&(b[e-1].pos=f-b[e-1].size),b.splice(e,1),n=!0)}l.push.apply(l,v);e=0;b.some(function(b){var g=0;if(b.targets.some(function(){l[e].pos=b.pos+g;if("undefined"!==typeof m&&Math.abs(l[e].pos-l[e].target)>m)return l.slice(0,
e+1).forEach(function(b){delete b.pos}),l.reducedLen=(l.reducedLen||f)-.1*f,l.reducedLen>.1*f&&d.distribute(l,f,m),!0;g+=l[e].size;e++}))return!0});t(l,g)};N.prototype.drawDataLabels=function(){function b(c,a){var b=a.filter;return b?(a=b.operator,c=c[b.property],b=b.value,">"===a&&c>b||"<"===a&&c<b||">="===a&&c>=b||"<="===a&&c<=b||"=="===a&&c==b||"==="===a&&c===b?!0:!1):!0}function d(c,a){var b=[],e;if(F(c)&&!F(a))b=c.map(function(c){return H(c,a)});else if(F(a)&&!F(c))b=a.map(function(a){return H(c,
a)});else if(F(c)||F(a))for(e=Math.max(c.length,a.length);e--;)b[e]=H(c[e],a[e]);else b=H(c,a);return b}var f=this,h=f.chart,e=f.options,m=e.dataLabels,l=f.points,q,u=f.hasRendered||0,t=A(e.animation).duration,w=Math.min(t,200),E=!h.renderer.forExport&&D(m.defer,0<w),J=h.renderer;m=d(d(h.options.plotOptions&&h.options.plotOptions.series&&h.options.plotOptions.series.dataLabels,h.options.plotOptions&&h.options.plotOptions[f.type]&&h.options.plotOptions[f.type].dataLabels),m);L(this,"drawDataLabels");
if(F(m)||m.enabled||f._hasPointLabels){var B=f.plotGroup("dataLabelsGroup","data-labels",E&&!u?"hidden":"inherit",m.zIndex||6);E&&(B.attr({opacity:+u}),u||setTimeout(function(){var c=f.dataLabelsGroup;c&&(f.visible&&B.show(!0),c[e.animation?"animate":"attr"]({opacity:1},{duration:w}))},t-w));l.forEach(function(c){q=n(d(m,c.dlOptions||c.options&&c.options.dataLabels));q.forEach(function(a,d){var g=a.enabled&&(!c.isNull||c.dataLabelOnNull)&&b(c,a),l=c.dataLabels?c.dataLabels[d]:c.dataLabel,k=c.connectors?
c.connectors[d]:c.connector,m=D(a.distance,c.labelDistance),n=!l;if(g){var p=c.getLabelConfig();var u=D(a[c.formatPrefix+"Format"],a.format);p=K(u)?x(u,p,h):(a[c.formatPrefix+"Formatter"]||a.formatter).call(p,a);u=a.style;var v=a.rotation;h.styledMode||(u.color=D(a.color,u.color,f.color,"#000000"),"contrast"===u.color?(c.contrastColor=J.getContrast(c.color||f.color),u.color=!K(m)&&a.inside||0>m||e.stacking?c.contrastColor:"#000000"):delete c.contrastColor,e.cursor&&(u.cursor=e.cursor));var q={r:a.borderRadius||
0,rotation:v,padding:a.padding,zIndex:1};h.styledMode||(q.fill=a.backgroundColor,q.stroke=a.borderColor,q["stroke-width"]=a.borderWidth);C(q,function(a,c){"undefined"===typeof a&&delete q[c]})}!l||g&&K(p)?g&&K(p)&&(l?q.text=p:(c.dataLabels=c.dataLabels||[],l=c.dataLabels[d]=v?J.text(p,0,-9999,a.useHTML).addClass("highcharts-data-label"):J.label(p,0,-9999,a.shape,null,null,a.useHTML,null,"data-label"),d||(c.dataLabel=l),l.addClass(" highcharts-data-label-color-"+c.colorIndex+" "+(a.className||"")+
(a.useHTML?" highcharts-tracker":""))),l.options=a,l.attr(q),h.styledMode||l.css(u).shadow(a.shadow),l.added||l.add(B),a.textPath&&!a.useHTML&&(l.setTextPath(c.getDataLabelPath&&c.getDataLabelPath(l)||c.graphic,a.textPath),c.dataLabelPath&&!a.textPath.enabled&&(c.dataLabelPath=c.dataLabelPath.destroy())),f.alignDataLabel(c,l,a,null,n)):(c.dataLabel=c.dataLabel&&c.dataLabel.destroy(),c.dataLabels&&(1===c.dataLabels.length?delete c.dataLabels:delete c.dataLabels[d]),d||delete c.dataLabel,k&&(c.connector=
c.connector.destroy(),c.connectors&&(1===c.connectors.length?delete c.connectors:delete c.connectors[d])))})})}L(this,"afterDrawDataLabels")};N.prototype.alignDataLabel=function(b,d,f,h,e){var g=this,l=this.chart,m=this.isCartesian&&l.inverted,n=this.enabledDataSorting,q=D(b.dlBox&&b.dlBox.centerX,b.plotX,-9999),v=D(b.plotY,-9999),t=d.getBBox(),w=f.rotation,x=f.align,c=l.isInsidePlot(q,Math.round(v),m),a="justify"===D(f.overflow,n?"none":"justify"),k=this.visible&&!1!==b.visible&&(b.series.forceDL||
n&&!a||c||f.inside&&h&&l.isInsidePlot(q,m?h.x+1:h.y+h.height-1,m));var r=function(f){n&&g.xAxis&&!a&&g.setDataLabelStartPos(b,d,e,c,f)};if(k){var z=l.renderer.fontMetrics(l.styledMode?void 0:f.style.fontSize,d).b;h=J({x:m?this.yAxis.len-v:q,y:Math.round(m?this.xAxis.len-q:v),width:0,height:0},h);J(f,{width:t.width,height:t.height});w?(a=!1,q=l.renderer.rotCorr(z,w),q={x:h.x+f.x+h.width/2+q.x,y:h.y+f.y+{top:0,middle:.5,bottom:1}[f.verticalAlign]*h.height},r(q),d[e?"attr":"animate"](q).attr({align:x}),
r=(w+720)%360,r=180<r&&360>r,"left"===x?q.y-=r?t.height:0:"center"===x?(q.x-=t.width/2,q.y-=t.height/2):"right"===x&&(q.x-=t.width,q.y-=r?0:t.height),d.placed=!0,d.alignAttr=q):(r(h),d.align(f,null,h),q=d.alignAttr);a&&0<=h.height?this.justifyDataLabel(d,f,q,t,h,e):D(f.crop,!0)&&(k=l.isInsidePlot(q.x,q.y)&&l.isInsidePlot(q.x+t.width,q.y+t.height));if(f.shape&&!w)d[e?"attr":"animate"]({anchorX:m?l.plotWidth-b.plotY:b.plotX,anchorY:m?l.plotHeight-b.plotX:b.plotY})}e&&n&&(d.placed=!1);k||n&&!a||(d.hide(!0),
d.placed=!1)};N.prototype.setDataLabelStartPos=function(b,d,f,h,e){var g=this.chart,l=g.inverted,m=this.xAxis,n=m.reversed,q=l?d.height/2:d.width/2;b=(b=b.pointWidth)?b/2:0;m=l?e.x:n?-q-b:m.width-q+b;e=l?n?this.yAxis.height-q+b:-q-b:e.y;d.startXPos=m;d.startYPos=e;h?"hidden"===d.visibility&&(d.show(),d.attr({opacity:0}).animate({opacity:1})):d.attr({opacity:1}).animate({opacity:0},void 0,d.hide);g.hasRendered&&(f&&d.attr({x:d.startXPos,y:d.startYPos}),d.placed=!0)};N.prototype.justifyDataLabel=function(b,
d,f,h,e,m){var g=this.chart,n=d.align,p=d.verticalAlign,q=b.box?0:b.padding||0;var v=f.x+q;if(0>v){"right"===n?(d.align="left",d.inside=!0):d.x=-v;var t=!0}v=f.x+h.width-q;v>g.plotWidth&&("left"===n?(d.align="right",d.inside=!0):d.x=g.plotWidth-v,t=!0);v=f.y+q;0>v&&("bottom"===p?(d.verticalAlign="top",d.inside=!0):d.y=-v,t=!0);v=f.y+h.height-q;v>g.plotHeight&&("top"===p?(d.verticalAlign="bottom",d.inside=!0):d.y=g.plotHeight-v,t=!0);t&&(b.placed=!m,b.align(d,null,e));return t};m.pie&&(m.pie.prototype.dataLabelPositioners=
{radialDistributionY:function(b){return b.top+b.distributeBox.pos},radialDistributionX:function(b,d,f,h){return b.getX(f<d.top+2||f>d.bottom-2?h:f,d.half,d)},justify:function(b,d,f){return f[0]+(b.half?-1:1)*(d+b.labelDistance)},alignToPlotEdges:function(b,d,f,h){b=b.getBBox().width;return d?b+h:f-b-h},alignToConnectors:function(b,d,f,h){var e=0,g;b.forEach(function(b){g=b.dataLabel.getBBox().width;g>e&&(e=g)});return d?e+h:f-e-h}},m.pie.prototype.drawDataLabels=function(){var b=this,f=b.data,m,h=
b.chart,e=b.options.dataLabels||{},n=e.connectorPadding,l,t=h.plotWidth,u=h.plotHeight,y=h.plotLeft,w=Math.round(h.chartWidth/3),x,C=b.center,B=C[2]/2,c=C[1],a,k,r,z,A=[[],[]],E,F,L,J,M=[0,0,0,0],Q=b.dataLabelPositioners,O;b.visible&&(e.enabled||b._hasPointLabels)&&(f.forEach(function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),N.prototype.drawDataLabels.apply(b),f.forEach(function(a){a.dataLabel&&
(a.visible?(A[a.half].push(a),a.dataLabel._pos=null,!K(e.style.width)&&!K(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>w&&(a.dataLabel.css({width:Math.round(.7*w)+"px"}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&delete a.dataLabels))}),A.forEach(function(f,g){var l=f.length,p=[],q;if(l){b.sortByAngle(f,g-.5);if(0<b.maxLabelDistance){var v=Math.max(0,c-B-b.maxLabelDistance);
var w=Math.min(c+B+b.maxLabelDistance,h.plotHeight);f.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,c-B-a.labelDistance),a.bottom=Math.min(c+B+a.labelDistance,h.plotHeight),q=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+q/2,size:q,rank:a.y},p.push(a.distributeBox))});v=w+q-v;d.distribute(p,v,v/5)}for(J=0;J<l;J++){m=f[J];r=m.labelPosition;a=m.dataLabel;L=!1===m.visible?"hidden":"inherit";F=v=r.natural.y;p&&K(m.distributeBox)&&("undefined"===
typeof m.distributeBox.pos?L="hidden":(z=m.distributeBox.size,F=Q.radialDistributionY(m)));delete m.positionIndex;if(e.justify)E=Q.justify(m,B,C);else switch(e.alignTo){case "connectors":E=Q.alignToConnectors(f,g,t,y);break;case "plotEdges":E=Q.alignToPlotEdges(a,g,t,y);break;default:E=Q.radialDistributionX(b,m,F,v)}a._attr={visibility:L,align:r.alignment};O=m.options.dataLabels||{};a._pos={x:E+D(O.x,e.x)+({left:n,right:-n}[r.alignment]||0),y:F+D(O.y,e.y)-10};r.final.x=E;r.final.y=F;D(e.crop,!0)&&
(k=a.getBBox().width,v=null,E-k<n&&1===g?(v=Math.round(k-E+n),M[3]=Math.max(v,M[3])):E+k>t-n&&0===g&&(v=Math.round(E+k-t+n),M[1]=Math.max(v,M[1])),0>F-z/2?M[0]=Math.max(Math.round(-F+z/2),M[0]):F+z/2>u&&(M[2]=Math.max(Math.round(F+z/2-u),M[2])),a.sideOverflow=v)}}}),0===q(M)||this.verifyDataLabelOverflow(M))&&(this.placeDataLabels(),this.points.forEach(function(c){O=H(e,c.options.dataLabels);if(l=D(O.connectorWidth,1)){var d;x=c.connector;if((a=c.dataLabel)&&a._pos&&c.visible&&0<c.labelDistance){L=
a._attr.visibility;if(d=!x)c.connector=x=h.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+c.colorIndex+(c.className?" "+c.className:"")).add(b.dataLabelsGroup),h.styledMode||x.attr({"stroke-width":l,stroke:O.connectorColor||c.color||"#666666"});x[d?"attr":"animate"]({d:c.getConnectorPath()});x.attr("visibility",L)}else x&&(c.connector=x.destroy())}}))},m.pie.prototype.placeDataLabels=function(){this.points.forEach(function(b){var d=b.dataLabel,f;d&&b.visible&&((f=d._pos)?
(d.sideOverflow&&(d._attr.width=Math.max(d.getBBox().width-d.sideOverflow,0),d.css({width:d._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),d.shortened=!0),d.attr(d._attr),d[d.moved?"animate":"attr"](f),d.moved=!0):d&&d.attr({y:-9999}));delete b.distributeBox},this)},m.pie.prototype.alignDataLabel=f,m.pie.prototype.verifyDataLabelOverflow=function(b){var d=this.center,f=this.options,h=f.center,e=f.minSize||80,m=null!==f.size;if(!m){if(null!==h[0])var l=
Math.max(d[2]-Math.max(b[1],b[3]),e);else l=Math.max(d[2]-b[1]-b[3],e),d[0]+=(b[3]-b[1])/2;null!==h[1]?l=M(l,e,d[2]-Math.max(b[0],b[2])):(l=M(l,e,d[2]-b[0]-b[2]),d[1]+=(b[0]-b[2])/2);l<d[2]?(d[2]=l,d[3]=Math.min(w(f.innerSize||0,l),l),this.translate(d),this.drawDataLabels&&this.drawDataLabels()):m=!0}return m});m.column&&(m.column.prototype.alignDataLabel=function(b,d,f,h,e){var g=this.chart.inverted,l=b.series,m=b.dlBox||b.shapeArgs,n=D(b.below,b.plotY>D(this.translatedThreshold,l.yAxis.len)),q=
D(f.inside,!!this.options.stacking);m&&(h=H(m),0>h.y&&(h.height+=h.y,h.y=0),m=h.y+h.height-l.yAxis.len,0<m&&m<h.height&&(h.height-=m),g&&(h={x:l.yAxis.len-h.y-h.height,y:l.xAxis.len-h.x-h.width,width:h.height,height:h.width}),q||(g?(h.x+=n?0:h.width,h.width=0):(h.y+=n?h.height:0,h.height=0)));f.align=D(f.align,!g||q?"center":n?"right":"left");f.verticalAlign=D(f.verticalAlign,g||q?"middle":n?"top":"bottom");N.prototype.alignDataLabel.call(this,b,d,f,h,e);f.inside&&b.contrastColor&&d.css({color:b.contrastColor})})});
Q(A,"modules/overlapping-datalabels.src.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var A=f.addEvent,q=f.fireEvent,M=f.isArray,K=f.objectEach,J=f.pick;d=d.Chart;A(d,"render",function(){var d=[];(this.labelCollectors||[]).forEach(function(f){d=d.concat(f())});(this.yAxis||[]).forEach(function(f){f.stacking&&f.options.stackLabels&&!f.options.stackLabels.allowOverlap&&K(f.stacking.stacks,function(f){K(f,function(f){d.push(f.label)})})});(this.series||[]).forEach(function(f){var q=
f.options.dataLabels;f.visible&&(!1!==q.enabled||f._hasPointLabels)&&(f.nodes||f.points).forEach(function(f){f.visible&&(M(f.dataLabels)?f.dataLabels:f.dataLabel?[f.dataLabel]:[]).forEach(function(q){var x=q.options;q.labelrank=J(x.labelrank,f.labelrank,f.shapeArgs&&f.shapeArgs.height);x.allowOverlap||d.push(q)})})});this.hideOverlappingLabels(d)});d.prototype.hideOverlappingLabels=function(d){var f=this,A=d.length,E=f.renderer,C,D,w,n=!1;var t=function(b){var d,f=b.box?0:b.padding||0,h=d=0,e;if(b&&
(!b.alignAttr||b.placed)){var m=b.alignAttr||{x:b.attr("x"),y:b.attr("y")};var l=b.parentGroup;b.width||(d=b.getBBox(),b.width=d.width,b.height=d.height,d=E.fontMetrics(null,b.element).h);var n=b.width-2*f;(e={left:"0",center:"0.5",right:"1"}[b.alignValue])?h=+e*n:Math.round(b.x)!==b.translateX&&(h=b.x-b.translateX);return{x:m.x+(l.translateX||0)+f-h,y:m.y+(l.translateY||0)+f-d,width:b.width-2*f,height:b.height-2*f}}};for(D=0;D<A;D++)if(C=d[D])C.oldOpacity=C.opacity,C.newOpacity=1,C.absoluteBox=t(C);
d.sort(function(b,d){return(d.labelrank||0)-(b.labelrank||0)});for(D=0;D<A;D++){var J=(t=d[D])&&t.absoluteBox;for(C=D+1;C<A;++C){var m=(w=d[C])&&w.absoluteBox;!J||!m||t===w||0===t.newOpacity||0===w.newOpacity||m.x>J.x+J.width||m.x+m.width<J.x||m.y>J.y+J.height||m.y+m.height<J.y||((t.labelrank<w.labelrank?t:w).newOpacity=0)}}d.forEach(function(b){if(b){var d=b.newOpacity;b.oldOpacity!==d&&(b.alignAttr&&b.placed?(b[d?"removeClass":"addClass"]("highcharts-data-label-hidden"),n=!0,b.alignAttr.opacity=
d,b[b.isOld?"animate":"attr"](b.alignAttr,null,function(){f.styledMode||b.css({pointerEvents:d?"auto":"none"});b.visibility=d?"inherit":"hidden";b.placed=!!d}),q(f,"afterHideOverlappingLabel")):b.attr({opacity:d}));b.isOld=!0}});n&&q(f,"afterHideAllOverlappingLabels")}});Q(A,"parts/Interaction.js",[A["parts/Globals.js"],A["parts/Legend.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(d,f,A,q){var E=q.addEvent,K=q.createElement,J=q.css,L=q.defined,x=q.extend,F=q.fireEvent,H=q.isArray,C=q.isFunction,
D=q.isNumber,w=q.isObject,n=q.merge,t=q.objectEach,N=q.pick;q=d.Chart;var m=d.defaultOptions,b=d.defaultPlotOptions,g=d.hasTouch,v=d.Series,h=d.seriesTypes,e=d.svg;var p=d.TrackerMixin={drawTrackerPoint:function(){var b=this,d=b.chart,e=d.pointer,f=function(b){var d=e.getPointFromEvent(b);"undefined"!==typeof d&&(e.isDirectTouch=!0,d.onMouseOver(b))},h;b.points.forEach(function(b){h=H(b.dataLabels)?b.dataLabels:b.dataLabel?[b.dataLabel]:[];b.graphic&&(b.graphic.element.point=b);h.forEach(function(d){d.div?
d.div.point=b:d.element.point=b})});b._hasTracking||(b.trackerGroups.forEach(function(l){if(b[l]){b[l].addClass("highcharts-tracker").on("mouseover",f).on("mouseout",function(b){e.onTrackerMouseOut(b)});if(g)b[l].on("touchstart",f);!d.styledMode&&b.options.cursor&&b[l].css(J).css({cursor:b.options.cursor})}}),b._hasTracking=!0);F(this,"afterDrawTracker")},drawTrackerGraph:function(){var b=this,d=b.options,f=d.trackByArea,h=[].concat(f?b.areaPath:b.graphPath),m=b.chart,n=m.pointer,p=m.renderer,q=m.options.tooltip.snap,
c=b.tracker,a=function(a){if(m.hoverSeries!==b)b.onMouseOver()},k="rgba(192,192,192,"+(e?.0001:.002)+")";c?c.attr({d:h}):b.graph&&(b.tracker=p.path(h).attr({visibility:b.visible?"visible":"hidden",zIndex:2}).addClass(f?"highcharts-tracker-area":"highcharts-tracker-line").add(b.group),m.styledMode||b.tracker.attr({"stroke-linecap":"round","stroke-linejoin":"round",stroke:k,fill:f?k:"none","stroke-width":b.graph.strokeWidth()+(f?0:2*q)}),[b.tracker,b.markerGroup].forEach(function(c){c.addClass("highcharts-tracker").on("mouseover",
a).on("mouseout",function(a){n.onTrackerMouseOut(a)});d.cursor&&!m.styledMode&&c.css({cursor:d.cursor});if(g)c.on("touchstart",a)}));F(this,"afterDrawTracker")}};h.column&&(h.column.prototype.drawTracker=p.drawTrackerPoint);h.pie&&(h.pie.prototype.drawTracker=p.drawTrackerPoint);h.scatter&&(h.scatter.prototype.drawTracker=p.drawTrackerPoint);x(f.prototype,{setItemEvents:function(b,d,e){var f=this,g=f.chart.renderer.boxWrapper,l=b instanceof A,h="highcharts-legend-"+(l?"point":"series")+"-active",
m=f.chart.styledMode;(e?[d,b.legendSymbol]:[b.legendGroup]).forEach(function(c){if(c)c.on("mouseover",function(){b.visible&&f.allItems.forEach(function(a){b!==a&&a.setState("inactive",!l)});b.setState("hover");b.visible&&g.addClass(h);m||d.css(f.options.itemHoverStyle)}).on("mouseout",function(){f.chart.styledMode||d.css(n(b.visible?f.itemStyle:f.itemHiddenStyle));f.allItems.forEach(function(a){b!==a&&a.setState("",!l)});g.removeClass(h);b.setState()}).on("click",function(a){var c=function(){b.setVisible&&
b.setVisible();f.allItems.forEach(function(a){b!==a&&a.setState(b.visible?"inactive":"",!l)})};g.removeClass(h);a={browserEvent:a};b.firePointEvent?b.firePointEvent("legendItemClick",a,c):F(b,"legendItemClick",a,c)})})},createCheckboxForItem:function(b){b.checkbox=K("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:b.selected,defaultChecked:b.selected},this.options.itemCheckboxStyle,this.chart.container);E(b.checkbox,"click",function(d){F(b.series||b,"checkboxClick",{checked:d.target.checked,
item:b},function(){b.select()})})}});x(q.prototype,{showResetZoom:function(){function b(){d.zoomOut()}var d=this,e=m.lang,f=d.options.chart.resetZoomButton,g=f.theme,h=g.states,n="chart"===f.relativeTo||"spaceBox"===f.relativeTo?null:"plotBox";F(this,"beforeShowResetZoom",null,function(){d.resetZoomButton=d.renderer.button(e.resetZoom,null,null,b,g,h&&h.hover).attr({align:f.position.align,title:e.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(f.position,!1,n)});F(this,"afterShowResetZoom")},
zoomOut:function(){F(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(b){var d=this,e,f=d.pointer,g=!1,l=d.inverted?f.mouseDownX:f.mouseDownY;!b||b.resetSelection?(d.axes.forEach(function(b){e=b.zoom()}),f.initiated=!1):b.xAxis.concat(b.yAxis).forEach(function(b){var c=b.axis,a=d.inverted?c.left:c.top,k=d.inverted?a+c.width:a+c.height,h=c.isXAxis,m=!1;if(!h&&l>=a&&l<=k||h||!L(l))m=!0;f[h?"zoomX":"zoomY"]&&m&&(e=c.zoom(b.min,b.max),c.displayBtn&&(g=!0))});var h=d.resetZoomButton;g&&!h?
d.showResetZoom():!g&&w(h)&&(d.resetZoomButton=h.destroy());e&&d.redraw(N(d.options.chart.animation,b&&b.animation,100>d.pointCount))},pan:function(b,e){var f=this,g=f.hoverPoints,l=f.options.chart,h=f.options.mapNavigation&&f.options.mapNavigation.enabled,m;e="object"===typeof e?e:{enabled:e,type:"x"};l&&l.panning&&(l.panning=e);var n=e.type;F(this,"pan",{originalEvent:b},function(){g&&g.forEach(function(a){a.setState()});var c=[1];"xy"===n?c=[1,0]:"y"===n&&(c=[0]);c.forEach(function(a){var c=f[a?
"xAxis":"yAxis"][0],e=c.options,g=c.horiz,l=b[g?"chartX":"chartY"];g=g?"mouseDownX":"mouseDownY";var p=f[g],q=(c.pointRange||0)/2,u=c.reversed&&!f.inverted||!c.reversed&&f.inverted?-1:1,t=c.getExtremes(),v=c.toValue(p-l,!0)+q*u;u=c.toValue(p+c.len-l,!0)-q*u;var w=u<v;p=w?u:v;v=w?v:u;var y=c.hasVerticalPanning(),x=c.panningState;c.series.forEach(function(b){if(y&&!a&&(!x||x.isDirty)){var c=b.getProcessedData(!0);b=b.getExtremes(c.yData,!0);x||(x={startMin:Number.MAX_VALUE,startMax:-Number.MAX_VALUE});
D(b.dataMin)&&D(b.dataMax)&&(x.startMin=Math.min(b.dataMin,x.startMin),x.startMax=Math.max(b.dataMax,x.startMax))}});u=Math.min(d.pick(null===x||void 0===x?void 0:x.startMin,t.dataMin),q?t.min:c.toValue(c.toPixels(t.min)-c.minPixelPadding));q=Math.max(d.pick(null===x||void 0===x?void 0:x.startMax,t.dataMax),q?t.max:c.toValue(c.toPixels(t.max)+c.minPixelPadding));c.panningState=x;if(!e.ordinal){e=u-p;0<e&&(v+=e,p=u);e=v-q;0<e&&(v=q,p-=e);if(c.series.length&&p!==t.min&&v!==t.max&&a||x&&p>=u&&v<=q)c.setExtremes(p,
v,!1,!1,{trigger:"pan"}),f.resetZoomButton||h||!n.match("y")||(f.showResetZoom(),c.displayBtn=!1),m=!0;f[g]=l}});m&&f.redraw(!1);J(f.container,{cursor:"move"})})}});x(A.prototype,{select:function(b,d){var e=this,f=e.series,g=f.chart;this.selectedStaging=b=N(b,!e.selected);e.firePointEvent(b?"select":"unselect",{accumulate:d},function(){e.selected=e.options.selected=b;f.options.data[f.data.indexOf(e)]=e.options;e.setState(b&&"select");d||g.getSelectedPoints().forEach(function(b){var d=b.series;b.selected&&
b!==e&&(b.selected=b.options.selected=!1,d.options.data[d.data.indexOf(b)]=b.options,b.setState(g.hoverPoints&&d.options.inactiveOtherPoints?"inactive":""),b.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(b){var d=this.series.chart,e=d.pointer;b=b?e.normalize(b):e.getChartCoordinatesFromPoint(this,d.inverted);e.runPointActions(b,this)},onMouseOut:function(){var b=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(b.hoverPoints||
[]).forEach(function(b){b.setState()});b.hoverPoints=b.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,d=n(b.series.options.point,b.options).events;b.events=d;t(d,function(d,e){C(d)&&E(b,e,d)});this.hasImportedEvents=!0}},setState:function(d,e){var f=this.series,g=this.state,l=f.options.states[d||"normal"]||{},h=b[f.type].marker&&f.options.marker,m=h&&!1===h.enabled,n=h&&h.states&&h.states[d||"normal"]||{},c=!1===n.enabled,a=f.stateMarkerGraphic,k=this.marker||{},p=
f.chart,q=f.halo,t,v=h&&f.markerAttribs;d=d||"";if(!(d===this.state&&!e||this.selected&&"select"!==d||!1===l.enabled||d&&(c||m&&!1===n.enabled)||d&&k.states&&k.states[d]&&!1===k.states[d].enabled)){this.state=d;v&&(t=f.markerAttribs(this,d));if(this.graphic){g&&this.graphic.removeClass("highcharts-point-"+g);d&&this.graphic.addClass("highcharts-point-"+d);if(!p.styledMode){var w=f.pointAttribs(this,d);var A=N(p.options.chart.animation,l.animation);f.options.inactiveOtherPoints&&w.opacity&&((this.dataLabels||
[]).forEach(function(a){a&&a.animate({opacity:w.opacity},A)}),this.connector&&this.connector.animate({opacity:w.opacity},A));this.graphic.animate(w,A)}t&&this.graphic.animate(t,N(p.options.chart.animation,n.animation,h.animation));a&&a.hide()}else{if(d&&n){g=k.symbol||f.symbol;a&&a.currentSymbol!==g&&(a=a.destroy());if(t)if(a)a[e?"animate":"attr"]({x:t.x,y:t.y});else g&&(f.stateMarkerGraphic=a=p.renderer.symbol(g,t.x,t.y,t.width,t.height).add(f.markerGroup),a.currentSymbol=g);!p.styledMode&&a&&a.attr(f.pointAttribs(this,
d))}a&&(a[d&&this.isInside?"show":"hide"](),a.element.point=this)}d=l.halo;l=(a=this.graphic||a)&&a.visibility||"inherit";d&&d.size&&a&&"hidden"!==l&&!this.isCluster?(q||(f.halo=q=p.renderer.path().add(a.parentGroup)),q.show()[e?"animate":"attr"]({d:this.haloPath(d.size)}),q.attr({"class":"highcharts-halo highcharts-color-"+N(this.colorIndex,f.colorIndex)+(this.className?" "+this.className:""),visibility:l,zIndex:-1}),q.point=this,p.styledMode||q.attr(x({fill:this.color||f.color,"fill-opacity":d.opacity},
d.attributes))):q&&q.point&&q.point.haloPath&&q.animate({d:q.point.haloPath(0)},null,q.hide);F(this,"afterSetState")}},haloPath:function(b){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-b,this.plotY-b,2*b,2*b)}});x(v.prototype,{onMouseOver:function(){var b=this.chart,d=b.hoverSeries;b.pointer.setHoverChartIndex();if(d&&d!==this)d.onMouseOut();this.options.events.mouseOver&&F(this,"mouseOver");this.setState("hover");b.hoverSeries=this},onMouseOut:function(){var b=this.options,
d=this.chart,e=d.tooltip,f=d.hoverPoint;d.hoverSeries=null;if(f)f.onMouseOut();this&&b.events.mouseOut&&F(this,"mouseOut");!e||this.stickyTracking||e.shared&&!this.noSharedTooltip||e.hide();d.series.forEach(function(b){b.setState("",!0)})},setState:function(b,d){var e=this,f=e.options,g=e.graph,l=f.inactiveOtherPoints,h=f.states,m=f.lineWidth,c=f.opacity,a=N(h[b||"normal"]&&h[b||"normal"].animation,e.chart.options.chart.animation);f=0;b=b||"";if(e.state!==b&&([e.group,e.markerGroup,e.dataLabelsGroup].forEach(function(a){a&&
(e.state&&a.removeClass("highcharts-series-"+e.state),b&&a.addClass("highcharts-series-"+b))}),e.state=b,!e.chart.styledMode)){if(h[b]&&!1===h[b].enabled)return;b&&(m=h[b].lineWidth||m+(h[b].lineWidthPlus||0),c=N(h[b].opacity,c));if(g&&!g.dashstyle)for(h={"stroke-width":m},g.animate(h,a);e["zone-graph-"+f];)e["zone-graph-"+f].attr(h),f+=1;l||[e.group,e.markerGroup,e.dataLabelsGroup,e.labelBySeries].forEach(function(b){b&&b.animate({opacity:c},a)})}d&&l&&e.points&&e.setAllPointsToState(b)},setAllPointsToState:function(b){this.points.forEach(function(d){d.setState&&
d.setState(b)})},setVisible:function(b,d){var e=this,f=e.chart,g=e.legendItem,h=f.options.chart.ignoreHiddenSeries,l=e.visible;var m=(e.visible=b=e.options.visible=e.userOptions.visible="undefined"===typeof b?!l:b)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(b){if(e[b])e[b][m]()});if(f.hoverSeries===e||(f.hoverPoint&&f.hoverPoint.series)===e)e.onMouseOut();g&&f.legend.colorizeItem(e,b);e.isDirty=!0;e.options.stacking&&f.series.forEach(function(b){b.options.stacking&&
b.visible&&(b.isDirty=!0)});e.linkedSeries.forEach(function(c){c.setVisible(b,!1)});h&&(f.isDirtyBox=!0);F(e,m);!1!==d&&f.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(b){this.selected=b=this.options.selected="undefined"===typeof b?!this.selected:b;this.checkbox&&(this.checkbox.checked=b);F(this,b?"select":"unselect")},drawTracker:p.drawTrackerGraph})});Q(A,"parts/Responsive.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(d,f){var A=
f.find,q=f.isArray,M=f.isObject,K=f.merge,J=f.objectEach,L=f.pick,x=f.splat,F=f.uniqueKey;d=d.Chart;d.prototype.setResponsive=function(d,f){var q=this.options.responsive,w=[],n=this.currentResponsive;!f&&q&&q.rules&&q.rules.forEach(function(d){"undefined"===typeof d._id&&(d._id=F());this.matchResponsiveRule(d,w)},this);f=K.apply(0,w.map(function(d){return A(q.rules,function(f){return f._id===d}).chartOptions}));f.isResponsiveOptions=!0;w=w.toString()||void 0;w!==(n&&n.ruleIds)&&(n&&this.update(n.undoOptions,
d,!0),w?(n=this.currentOptions(f),n.isResponsiveOptions=!0,this.currentResponsive={ruleIds:w,mergedOptions:f,undoOptions:n},this.update(f,d,!0)):this.currentResponsive=void 0)};d.prototype.matchResponsiveRule=function(d,f){var q=d.condition;(q.callback||function(){return this.chartWidth<=L(q.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=L(q.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=L(q.minWidth,0)&&this.chartHeight>=L(q.minHeight,0)}).call(this)&&f.push(d._id)};d.prototype.currentOptions=function(d){function f(d,
t,w,m){var b;J(d,function(d,n){if(!m&&-1<A.collectionsWithUpdate.indexOf(n))for(d=x(d),w[n]=[],b=0;b<d.length;b++)t[n][b]&&(w[n][b]={},f(d[b],t[n][b],w[n][b],m+1));else M(d)?(w[n]=q(d)?[]:{},f(d,t[n]||{},w[n],m+1)):w[n]="undefined"===typeof t[n]?null:t[n]})}var A=this,w={};f(d,this.options,w,0);return w}});Q(A,"masters/highcharts.src.js",[A["parts/Globals.js"]],function(d){return d});A["masters/highcharts.src.js"]._modules=A;return A["masters/highcharts.src.js"]});
//# sourceMappingURL=highcharts.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(20);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(59);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(16);
var $iterCreate = __webpack_require__(226);
var setToStringTag = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(230);
var ITERATOR = __webpack_require__(2)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(9) && !__webpack_require__(27)(function () {
  return Object.defineProperty(__webpack_require__(36)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(227);
var enumBugKeys = __webpack_require__(43);
var IE_PROTO = __webpack_require__(41)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(36)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(62).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(13);
var toIObject = __webpack_require__(17);
var arrayIndexOf = __webpack_require__(228)(false);
var IE_PROTO = __webpack_require__(41)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(1).document;
module.exports = document && document.documentElement;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullYear = fullYear;
exports.abbrYear = abbrYear;
exports.isSameCentury = isSameCentury;
exports.getQuarter = getQuarter;
exports.getHalf = getHalf;
exports.quarterToMonth = quarterToMonth;
exports.quarterToDate = quarterToDate;
exports.genericTimeValue = genericTimeValue;

var _zero = __webpack_require__(31);

/**
 * Transform a partial year value (84) into a full year value (1984)
 * according to a formula agreed upon at WSJ.
 * @param {number|string} value
 * @returns {number}
 */

function fullYear(value) {
  value = +value;
  if (value < 100) {
    if (value + 2000 > new Date().getUTCFullYear() + 15) {
      value += 1900;
    } else {
      value += 2000;
    }
  }
  return value;
}

/**
 * Transforms a year value into 2-digit number: 1984 to 84.
 * @param {number|string} value
 * @returns {string} of length 2
 */
/**
 * Bring addZeroes and stripZeroes function directly into dateutils to 
 * expose for testing
 */

function abbrYear(value) {
  value = (0, _zero.addZeroes)((0, _zero.stripZeroes)(value), 2);
  return value.substr(-2, 2);
}

/**
 * @param {number|string} year1
 * @param {number|string} year2
 * @returns {boolean} true if y1 and y2 represent years in the same century.
 */
function isSameCentury(year1, year2) {
  var y1 = (0, _zero.addZeroes)(fullYear(year1), 4);
  var y2 = (0, _zero.addZeroes)(fullYear(year2), 4);
  return y1.substr(0, 2) === y2.substr(0, 2);
}

/**
 * @private
 * @param {string} str
 * @returns {string|undefined} if str is a Quartar ("2Q") or else undefined.
 */
function getQuarter(str) {
  if (typeof str === 'string') {
    str = str.toUpperCase();
    return str.indexOf('Q') !== -1 ? str : undefined;
  }
  return undefined;
}

/**
 * @private
 * @param {string} str
 * @returns {string|undefined} if str is a Half ("2H") or else undefined.
 */
function getHalf(str) {
  if (typeof str === 'string') {
    str = str.toUpperCase();
    return str.indexOf('H') !== -1 ? str : undefined;
  }
  return undefined;
}

/**
 * For a given quarter, returns the index of the month that represents the end
 * of that quarter.
 * @private
 * @param {number} q Index of a quarter, 0 to 3.
 * @returns {number} Index of month, 2, 4, 8, or 11.
 */
function quarterToMonth(q) {
  q = typeof q === 'string' ? q.toUpperCase() : null;
  switch (q) {
    case '1Q':
      return 2;
    case '2Q':
    case '1H':
      return 5;
    case '3Q':
      return 8;
    case '4Q':
    case '2H':
      return 11;
  }
  return undefined;
}

/**
 * For a given month that represents the end of a quarter, returns the date
 * that represents the end of that quarter.
 * @private
 * @param {number} month Index of a month, 0 to 11.
 * @returns {number} Date of the month, 1 to 31.
 */
function quarterToDate(month) {
  switch (month) {
    case undefined:
    case null:
      return undefined;
    case 1:
      return 28;
    case 3:
    case 5:
    case 8:
    case 10:
      return 30;
    default:
      return 31;
  }
}

/**
 * For use with removeExtraneous().
 * @private
 * @param {string} prop 'second', 'minute', etc.
 * @returns {number} in milliseconds
 */
function genericTimeValue(prop) {
  switch (prop) {
    case 'second':
      return 1000 * 60;
    case 'minute':
      return 1000 * 60 * 60;
    case 'hour':
      return 1000 * 60 * 60 * 60;
    case 'date':
      return 1000 * 60 * 60 * 24;
  }
  return 0;
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterOptionsForSize;
exports.getSize = getSize;

/**
 * Options passed to the renderer include options for multiple sizes. This
 * function narrows down all those options to those relevant to the current
 * size only.
 */
function filterOptionsForSize(options) {
  var size = getSize(options);
  var sizeObj = options.sizes[size.id];
  if (!options.headings) options.headings = sizeObj.headings;
  options.interactive = size.interactive;
  options.target = size.target;
  options.size = size.id;
  options.height = options.useContainerSize ? options.height : sizeObj.height || size.height;
  options.stacking = sizeObj.stacking;
  options.axes = sizeObj.axes;
  options.xAxis = sizeObj.xAxis;
  options.yAxis = sizeObj.yAxis;
  options.tooltips = sizeObj.tooltips.sameAsAxes ? sizeObj.axes.units : sizeObj.tooltips;
  return options;
}

function getSize(options) {
  var index = indexOfSize(options);
  if (index !== -1) {
    return options.defaults.sizes[index];
  }
  options.defaults.sizes.sort(function (a, b) {
    if (a.hasOwnProperty('minWidth') && b.hasOwnProperty('minWidth')) {
      return a.minWidth - b.minWidth;
    }
    return 1;
  });
  var size = options.defaults.sizes[0];
  options.defaults.sizes.forEach(function (item, index) {
    if (item.hasOwnProperty('minWidth') && Math.ceil(options.width) >= item.minWidth) {
      size = options.defaults.sizes[index];
    }
  });
  return size;
}

function indexOfSize(options) {
  if (options.size) {
    for (var i = 0; i < options.defaults.sizes.length; i++) {
      if (options.size === options.defaults.sizes[i].id) {
        return i;
      }
    }
  }
  return -1;
}

// set alignment
function writeAnnotations(annotations) {
  annotations.items.forEach(function (item) {
    item.textAlign = item.textAlign || annotations.textAlign || 'left';
    item.flushAlign = item.flushAlign || annotations.flushAlign || 'flush';
    item.lineEnd = item.lineEnd || 'dot';
  });
  return annotations;
}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(16);
var ITERATOR = __webpack_require__(2)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(2)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '١',
            '2': '٢',
            '3': '٣',
            '4': '٤',
            '5': '٥',
            '6': '٦',
            '7': '٧',
            '8': '٨',
            '9': '٩',
            '0': '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '1',
            '2': '2',
            '3': '3',
            '4': '4',
            '5': '5',
            '6': '6',
            '7': '7',
            '8': '8',
            '9': '9',
            '0': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '١',
            '2': '٢',
            '3': '٣',
            '4': '٤',
            '5': '٥',
            '6': '٦',
            '7': '٧',
            '8': '٨',
            '9': '٩',
            '0': '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'birneçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '১',
            '2': '২',
            '3': '৩',
            '4': '৪',
            '5': '৫',
            '6': '৬',
            '7': '৭',
            '8': '৮',
            '9': '৯',
            '0': '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '༡',
            '2': '༢',
            '3': '༣',
            '4': '༤',
            '5': '༥',
            '6': '༦',
            '7': '༧',
            '8': '༨',
            '9': '༩',
            '0': '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha invalida',
    });

    return es;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '۱',
            '2': '۲',
            '3': '۳',
            '4': '۴',
            '5': '۵',
            '6': '۶',
            '7': '۷',
            '8': '۸',
            '9': '۹',
            '0': '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '१',
            '2': '२',
            '3': '३',
            '4': '४',
            '5': '५',
            '6': '६',
            '7': '७',
            '8': '८',
            '9': '९',
            '0': '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var hi = moment.defineLocale('hi', {
        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split(
            '_'
        ),
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '១',
            '2': '២',
            '3': '៣',
            '4': '៤',
            '5': '៥',
            '6': '៦',
            '7': '៧',
            '8': '៨',
            '9': '៩',
            '0': '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '೧',
            '2': '೨',
            '3': '೩',
            '4': '೪',
            '5': '೫',
            '6': '೬',
            '7': '೭',
            '8': '೮',
            '9': '೯',
            '0': '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '١',
            '2': '٢',
            '3': '٣',
            '4': '٤',
            '5': '٥',
            '6': '٦',
            '7': '٧',
            '8': '٨',
            '9': '٩',
            '0': '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '१',
            '2': '२',
            '3': '३',
            '4': '४',
            '5': '५',
            '6': '६',
            '7': '७',
            '8': '८',
            '9': '९',
            '0': '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '၁',
            '2': '၂',
            '3': '၃',
            '4': '၄',
            '5': '၅',
            '6': '၆',
            '7': '၇',
            '8': '၈',
            '9': '၉',
            '0': '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '१',
            '2': '२',
            '3': '३',
            '4': '४',
            '5': '५',
            '6': '६',
            '7': '७',
            '8': '८',
            '9': '९',
            '0': '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '੧',
            '2': '੨',
            '3': '੩',
            '4': '੪',
            '5': '੫',
            '6': '੬',
            '7': '੭',
            '8': '੮',
            '9': '੯',
            '0': '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        );
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return (
                    '(' +
                    monthsSubjective[momentToFormat.month()] +
                    '|' +
                    monthsNominative[momentToFormat.month()] +
                    ')'
                );
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
    });

    return ptBr;

})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            '1': '௧',
            '2': '௨',
            '3': '௩',
            '4': '௪',
            '5': '௫',
            '6': '௬',
            '7': '௭',
            '8': '௮',
            '9': '௯',
            '0': '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Пагоҳ соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js language configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processCategories;
exports.createLongCategories = createLongCategories;
exports.formatQText = formatQText;

var _constants = __webpack_require__(3);

var _datetime = __webpack_require__(30);

var _datetime2 = _interopRequireDefault(_datetime);

var _zero = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes and builds the chart categories.
 */
function processCategories(options) {
  if (Array.isArray(options.categories)) {
    options.maxDataLength = getMaxDataLength(options);
    options.originalCategories = options.categories.slice();
    if (options.categoriesAreDates) {
      return formatAsDates(options);
    } else {
      return formatAsCategories(options);
    }
  } else {
    options = writeDefaultCategories(options);
  }
  return options;
}

function getMaxDataLength(options) {
  var maxLen = 0;
  options.series.forEach(function (series) {
    maxLen = Math.max(maxLen, series.data.length);
  });
  return maxLen;
}

// Makes the index of each row into a default category value.
function writeDefaultCategories(options) {
  options.categories = [[]];
  for (var i = 0; i < options.maxDataLength; i++) {
    options.categories[0][i] = i;
  }
  options.originalCategories = options.categories[0].slice();
  return options;
}

// Returns the categories as is, but wrapped in an array as the axes module needs.
function formatAsCategories(options) {
  options.longCategories = options.originalCategories.slice(0);
  options.categories = [options.categories];
  return options;
}

// Casts the categories from strings into dates.
function formatAsDates(options) {
  var dates = options.dates;

  options.fiscalYears = !!options.datesAll.fiscalYear;
  options.quarterlyResults = _datetime2.default.allQuarterly(dates);
  options.longCategories = createLongCategories(options, dates);
  // if (options.quarterlyResults || options.fiscalYears) {
  //   options.longCategories = formatQLong(options);
  // } else {
  //   options.longCategories = formatLong(options.dates);
  // }
  options.categories = [options.quarterlyResults ? formatQ(dates) : options.longCategories];
  return options;
}

function createLongCategories(options, dates) {
  var quarterlyResults = options.quarterlyResults,
      fiscalYears = options.fiscalYears;

  var action = quarterlyResults || fiscalYears ? formatQLong : formatLong;
  return action(dates);
}

// For tooltips: standard dates/times.
function formatLong(dates) {
  return dates.map(function (date) {
    var str = formatDateLong(date);
    return formatTimeLong(date, str);
  });
}

function formatDateLong(date) {
  if (date.month !== undefined && date.date && date.year) {
    return [_constants.MONTHS[date.month], date.date + ',', date.year].join(' ');
  } else if (date.month !== undefined && date.date) {
    return [_constants.MONTHS[date.month], date.date].join(' ');
  } else if (date.month !== undefined && date.year) {
    return [_constants.MONTHS[date.month], date.year].join(' ');
  } else if (date.month !== undefined) {
    return _constants.MONTHS[date.month];
  } else if (date.year) {
    return date.year.toString();
  }
  return null;
}

function formatTimeLong(date, str) {
  if (date.hour !== undefined) {
    var h = '';
    var a = '';
    str = str ? str + ' ' : '';
    if (date.a === 'a' || date.a === 'p') {
      h = date.hour % 12 + '';
      h = h === '0' ? '12' : h;
      a = date.a;
    } else {
      if (date.hour === 0) {
        h = '12';
        a = 'a';
      } else if (date.hour === 12) {
        h = '12';
        a = 'p';
      } else if (date.hour > 12) {
        h = date.hour % 12 + '';
        a = 'p';
      } else {
        // same as: if (date.hour < 12) {
        h = date.hour + '';
        a = 'a';
      }
    }
    str += h;
    if (date.minute) {
      str += ':' + (0, _zero.addZeroes)(date.minute, 2);
    }
    if (date.second) {
      str += ':' + (0, _zero.addZeroes)(date.second, 2);
    }
    if (a) {
      str += ' ' + (date.a === 'a' ? 'a.m.' : 'p.m.');
    }
    if (isNoon(str, date)) {
      str = 'noon';
    }
    if (date.z) {
      str += ' ' + date.z;
    }
  }
  return str;
}

function isNoon(str, date) {
  return date.minute === undefined && /^12/.test(str) || date.second === undefined && /^12:00/.test(str) || /^12:00:00/.test(str);
}

// Returns array of quarterly/half year categories.
function formatQ(dates, long) {
  return dates.map(function (item, index) {
    return formatQText(item, index, long);
  });
}

function formatQText(item, index, long) {
  var str = '';
  str += item.quarter || '';
  str += item.half || '';
  str += item.year !== undefined ? ' ' : '';
  str += (index === 0 || long) && item.fiscalYear ? 'FY' : '';
  str += item.year || '';
  return str;
}

// For tooltips: quarterly results.
function formatQLong(dates) {
  return formatQ(dates, true);
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(48)(module)))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(249);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(251);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 203 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(61);
var hiddenKeys = __webpack_require__(43).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {



/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(263);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBestRule = getBestRule;
var TEXT_RULES = {
  thumb: {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false
  }
};

if (false) {
  TEXT_RULES.E = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: true,
    tagline: false,
    thumb: false,
    subdekPromo: true,
    sourcePromo: true,
    notePromo: true
  };
  TEXT_RULES.D = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: true,
    tagline: false,
    thumb: false,
    subdekPromo: true,
    sourcePromo: true,
    notePromo: true
  };
  TEXT_RULES.G = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: true,
    tagline: false,
    thumb: false,
    subdekPromo: true,
    sourcePromo: true,
    notePromo: true
  };
  TEXT_RULES.top = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: true,
    tagline: false,
    thumb: false,
    subdekPromo: true,
    sourcePromo: true,
    notePromo: true
  };
  TEXT_RULES.soc = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: true,
    tagline: false,
    thumb: false,
    subdekPromo: true,
    sourcePromo: true,
    notePromo: true
  };
  TEXT_RULES.tab = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES.fon = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['4u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['8u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['12u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['16u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['appfeed'] = {
    title: false,
    dek: false,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false,
    subdekPromo: true,
    sourcePromo: true,
    notePromo: true
  };
  TEXT_RULES['video'] = {
    title: true,
    dek: true,
    subdek: false,
    note: false,
    source: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['twitterVideo'] = {
    title: true,
    dek: false,
    subdek: false,
    note: true,
    source: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['preview'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
}

if (true) {
  TEXT_RULES['barrons-4col-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['barrons-8col-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['barrons-10col-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  }, TEXT_RULES['barrons-fullscreen-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['b4u'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['barrons-8col-inset'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['barrons-10col-inset'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  }, TEXT_RULES['barrons-fullscreen-inset'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  }, TEXT_RULES['print-barrons'] = {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
}

if (false) {
  TEXT_RULES['fn-small-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['fn-medium-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: false,
    thumb: false
  };
  TEXT_RULES['fn-large-image'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['fn4u'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['fn-medium-inset'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['fn-large-inset'] = {
    title: true,
    dek: true,
    subdek: false,
    note: true,
    source: true,
    date: true,
    tagline: true,
    thumb: false
  };
  TEXT_RULES['print-fn'] = {
    title: false,
    dek: false,
    subdek: false,
    note: false,
    source: false,
    date: false,
    tagline: false,
    thumb: false
  };
}

if (false) {
  TEXT_RULES['marketwatch-ZT'] = {
    title: false,
    dek: false,
    subdek: false,
    legend: false,
    note: false,
    source: false,
    date: false,
    tagline: false
  };
  TEXT_RULES['marketwatch-ZR'] = {
    title: false,
    dek: false,
    subdek: false,
    legend: false,
    note: false,
    source: false,
    date: false,
    tagline: false
  };
}
TEXT_RULES['k4u'] = {
  title: true,
  dek: false,
  subdek: true,
  note: true,
  source: true,
  date: true,
  tagline: false,
  thumb: false
};

function getBestRule(id) {
  // If a rule for @param id is found, return it.
  if (TEXT_RULES[id] !== undefined) {
    return TEXT_RULES[id];
  }
  // If a rules that begins with @param id is found, return it. This is useful
  // for example with any id that starts with "thumb".
  for (var i = 0, keys = Object.keys(TEXT_RULES); i < keys.length; i++) {
    var key = keys[i];
    if (id.indexOf(key) === 0) {
      return TEXT_RULES[key];
    }
  }
  // Default:
  return {
    title: true,
    dek: true,
    subdek: true,
    note: true,
    source: true,
    date: true,
    tagline: 'right'
  };
}

exports.default = TEXT_RULES;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEl = removeEl;

var _element = __webpack_require__(15);

var element = _interopRequireWildcard(_element);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function removeEl(item) {
  if (item && item.el) {
    element.removeChild(item.el.element);
    item.el = null;
  }
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.preRender = preRender;
exports.findMilliseconds = findMilliseconds;

var _element = __webpack_require__(15);

var _constants = __webpack_require__(3);

var _processCategories = __webpack_require__(200);

var _getPoint = __webpack_require__(281);

var _getPoint2 = _interopRequireDefault(_getPoint);

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

var _datetime = __webpack_require__(30);

var _datetime2 = _interopRequireDefault(_datetime);

var _defs = __webpack_require__(54);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLOR = '#333';

function preRender(data, options) {
  var shapeOptions = getShapeOptions();
  var labelOptions = getLabelOptions(options);

  var _createAnnotations = createAnnotations(options),
      _createAnnotations2 = (0, _slicedToArray3.default)(_createAnnotations, 3),
      labels = _createAnnotations2[0],
      shapes = _createAnnotations2[1],
      extraSpace = _createAnnotations2[2];

  var visible = options.size !== 'marketwatch-ZT';
  if (visible) addSpacing(data, options, extraSpace);
  data.annotations.push({ labels: labels, labelOptions: labelOptions, shapes: shapes, shapeOptions: shapeOptions, visible: visible });
}

function getShapeOptions() {
  return {
    fill: COLOR,
    stroke: COLOR,
    type: 'circle',
    strokeWidth: 0
  };
}

function getLabelOptions(options) {
  var _options$styles$annot = options.styles.annotations,
      color = _options$styles$annot.color,
      fontSize = _options$styles$annot.fontSize,
      lineHeight = _options$styles$annot.lineHeight,
      fontWeight = _options$styles$annot.fontWeight,
      fontFamily = _options$styles$annot.fontFamily;

  return {
    style: { color: color, fontFamily: fontFamily, fontSize: fontSize, fontWeight: fontWeight, lineHeight: lineHeight, cursor: 'default' },
    backgroundColor: 'rgba(0, 0, 0, 0)', // defaults to gray, must be made transparent
    borderWidth: 0, // defaults to a border, which must be removed
    padding: 0, // label sits on top line before y applied
    y: setY(options), // margin above top line
    overflow: 'none', // allow labels rendered outside plot area
    allowOverlap: true // keep highcharts from hiding labels; spacing handled in postrender
  };
}

function isWsjDigital(options) {
  return options.product === 'wsj' && !options.print;
}

function setY(options) {
  // shift labels up 10px when suffix or recession label enabled
  var id = options.id,
      axes = options.axes;
  var units = axes.units,
      showRecessions = axes.showRecessions,
      showUkRecessions = axes.showUkRecessions;

  var offset = id === 'video' || id === 'twitterVideo' ? 30 : 0;
  var y = units.suffix.length > 2 || showRecessions || showUkRecessions ? -20 : -10;
  return y - offset;
}

function createAnnotations(options) {
  var labels = [],
      shapes = [];
  var lineHeight = getLineHeight(options);
  var spacing = {};
  var maxHeight = 0;

  options.annotations.forEach(function (item) {
    // create label
    var flushAlign = item.flushAlign,
        showLine = item.showLine,
        lineType = item.lineType;

    var style = { flushAlign: flushAlign, showLine: showLine, lineType: lineType }; // info needed in postrender

    var formattedText = formatText(item, options);
    var text = formattedText.join('<br>');

    var _getXY = getXY(item, options),
        _getXY2 = (0, _slicedToArray3.default)(_getXY, 5),
        x = _getXY2[0],
        y = _getXY2[1],
        yAxis = _getXY2[2],
        endPoints = _getXY2[3],
        ms = _getXY2[4];

    var label = { point: { x: x, y: 0, xAxis: 0 }, text: text, style: style }; // position at chart top

    // create corresponding shape
    var shape = createShape(item, options, x, y, yAxis);

    labels.push(label);
    shapes.push(shape);

    // extra space needed for tallest annotation
    var offset = options.id === 'video' || options.id === 'twitterVideo' ? 1 : 0;
    var numLines = (lastIdx(formattedText) + offset) * lineHeight;
    maxHeight = Math.max(maxHeight, numLines);

    // extra space needed for shape on right or left
    if (item.lineEnd !== 'nothing') {
      findMinMax(options, item, spacing, endPoints, ms);
    }
  });
  var min = spacing.min,
      max = spacing.max;

  return [labels, shapes, { top: maxHeight, min: min, max: max }];
}

function getLineHeight(options) {
  var id = options.id,
      print = options.print,
      styles = options.styles,
      product = options.product;

  var wsjHeight = id === 'video' || id === 'twitterVideo' ? _constants.ANNOTATIONS_LINEHEIGHT_VIDEO : _constants.ANNOTATIONS_LINEHEIGHT;
  return product === 'wsj' && !print ? wsjHeight : parseFloat(styles.normal.lineHeight);
}

function formatText(item, options) {
  var text = compileText(item, options);
  var textBr = (0, _element.replaceLineBreaks)(text);
  var lines = textBr.split('<br>');
  var wsjDigital = isWsjDigital(options);

  var _ref = wsjDigital ? ['<span style="font-weight:500">', '</span>'] : ['<strong>', '</strong>'],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      openTag = _ref2[0],
      closeTag = _ref2[1];

  var boldAnnotation = (0, _element.boldText)();
  return lines.map(function (line) {
    return boldAnnotation(line, openTag, closeTag);
  });
}

function compileText(item, options) {
  var text = item.text,
      category = item.category,
      series = item.series,
      value = item.value;

  return (text || '').replace(/\\{/g, '__LEFT_BRACKET__').replace(/\\}/g, '__RIGHT_BRACKET__').replace(_constants.CATEGORY, compiledCategory(category.toString(), options)).replace(_constants.SERIES, series).replace(_constants.VALUE, value).replace(_constants.POINT, compiledPoint(value, options)).replace(/__LEFT_BRACKET__/g, '{').replace(/__RIGHT_BRACKET__/g, '}');
}

function compiledCategory(category, options) {
  return options.categoriesAreDates ? formatDate(category, options) : category;
}

function formatDate(category, options) {
  var value = findValue(category, options);
  var dateObj = options.dates.find(function (date) {
    return date.value === value;
  });
  var formattedCategory = (0, _processCategories.createLongCategories)(options, [dateObj]);
  return formattedCategory[0];
}

function parseDate(category, options) {
  return _datetime2.default.parse([category], options);
}

function compiledPoint(value, options) {
  if (isFinite(value)) {
    var tooltips = options.tooltips,
        type = options.type;

    return format.applyFull(value, tooltips, type === 'pie', true, true);
  }
  return 'n/a';
}

function getXY(item, options) {
  var dataIdx = void 0,
      x = void 0;
  var category = item.category,
      seriesName = item.series,
      attachTo = item.attachTo;
  var series = options.series,
      categories = options.categories,
      irregularDates = options.irregularDates;

  var _findSeries = findSeries(series, seriesName),
      data = _findSeries.data;

  if (data[0].hasOwnProperty('x')) {
    var value = findValue(category, options);
    dataIdx = data.findIndex(function (point) {
      return point.x === value;
    });
    x = value;
  } else {
    dataIdx = findCatIdx(options, categories[0], category);
    x = dataIdx;
  }
  var y = data[dataIdx].y;

  var _ref3 = attachTo === 'point' ? [0, y] : [undefined, undefined],
      _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
      yAxis = _ref4[0],
      yValue = _ref4[1];

  var first = dataIdx === 0;
  var last = dataIdx === lastIdx(data);
  var ms = void 0;
  if (irregularDates) ms = findMilliseconds(options, data);
  return [x, yValue, yAxis, { first: first, last: last }, ms];
}

function findSeries(series, seriesName) {
  return series.find(function (_ref5) {
    var name = _ref5.name;
    return name.toString() === seriesName.toString();
  });
}

function findValue(category, options) {
  var date = parseDate(category, options);
  return date[0].value;
}

function findCatIdx(options, categories, annotationCategory) {
  return categories.findIndex(function (currentCategory, i) {
    return compareCategory(options, currentCategory, annotationCategory, i);
  });
}

function compareCategory(options, category, annotationCategory, index) {
  return options.quarterlyResults ? checkQuarterly(options, category, annotationCategory, index) : category === annotationCategory;
}

function checkQuarterly(options, category, annotationCategory, index) {
  var date = parseDate(annotationCategory, options);
  var formattedCategory = (0, _processCategories.formatQText)(date[0], index);
  return formattedCategory === category;
}

function getAreaY(options, seriesIdx, dataIdx) {
  // for area charts, need to calculate top y for each section of stack
  var series = options.originalSeries;
  var totalForPercent = series.reduce(function (total, currentSeries) {
    return total + currentSeries[dataIdx].y;
  }, 0);
  var seriesY = 0;
  for (var i = lastIdx(series); i >= seriesIdx; i--) {
    var y = series[i][dataIdx].y;

    var height = options.stacking === 'normal' ? y : y / totalForPercent * 100;
    seriesY += height;
  }
  return seriesY;
}

function lastIdx(arr) {
  return arr.length - 1;
}

function findMilliseconds(options, series) {
  // for highstocks charts, calculate how many milliseconds equal shape's radius
  var delta = findDelta(series);
  var pxPerX = options.width / series.length - 1;
  return delta / pxPerX;
}

function findDelta(series) {
  var prevDelta = 0,
      currentDelta = void 0;
  for (var i = 1; i < series.length; i++) {
    currentDelta = series[i].x - series[i - 1].x;
    if (currentDelta === prevDelta) return currentDelta;
    prevDelta = currentDelta;
  }
}

function createShape(item, options, x, y, yAxis) {
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  var shape = {};
  var point = { x: x, y: y, xAxis: 0, yAxis: yAxis };
  var print = options.print;

  switch (item.lineEnd) {
    case 'circle':
      shape.r = circleR(print);
      shape.strokeWidth = print ? 0.5 : 1;
      shape.fill = 'rgba(0, 0, 0, 0)';
      shape.point = point;
      break;
    case 'arrow':
      // transparent path ending with custom arrow (created in defs)
      shape.type = 'path';
      shape.markerEnd = 'custom-arrow';
      shape.points = [{ x: x, y: 0, xAxis: 0 }, { x: x, y: y, xAxis: 0, yAxis: yAxis }];
      break;
    case 'nothing':
      // transparent shape used for drawing line in postrender
      shape.point = point;
      break;
    default:
      // dot
      shape.r = isVideoGroup ? 9 : dotR(print);
      shape.fill = isVideoGroup ? '#fff' : undefined;
      shape.point = point;
  }
  return shape;
}

function circleR(print) {
  return print ? 4 : 6.5;
}

function dotR(print) {
  return print ? 1.5 : 3;
}

function findMinMax(options, item, spacing, endPoints, ms) {
  var print = options.print,
      irregularDates = options.irregularDates;
  var lineEnd = item.lineEnd;

  var r = getRadius(print, lineEnd);
  if (endPoints.first) {
    spacing.min = r;
  } else if (endPoints.last) {
    spacing.max = irregularDates ? ms * (r + 2) : r;
  }
}

function getRadius(print, lineEnd) {
  switch (lineEnd) {
    case 'dot':
      return dotR(print);
    case 'circle':
      return circleR(print);
    case 'arrow':
      return (0, _defs.arrowWidth)(print) / 2;
  }
}

function addSpacing(data, options, extraSpace) {
  data.chart.spacing[0] += extraSpace.top; // for multiline annotations
  // for shapes for 1st or last data point, add sufficient padding
  var padding = setPadding(data, options, extraSpace);
  padding('min', 'max');
}

function setPadding(data, options, extraSpace) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args.forEach(function (type) {
      var space = extraSpace[type];
      var xAxis = data.xAxis;
      var irregularDates = options.irregularDates,
          width = options.width;

      if (space) {
        irregularDates ? xAxis.overscroll += extraSpace.max || 0 : xAxis[type + 'Padding'] = (space + 5) / width;
      }
    });
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UK_RECESSIONS = exports.RECESSIONS = exports.VIDEO_COLOR_BAND = exports.COLOR_BAND = undefined;

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.preRender = preRender;
exports.postRender = postRender;

var _transform = __webpack_require__(18);

var transform = _interopRequireWildcard(_transform);

var _util = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLOR_BAND = exports.COLOR_BAND = '#EDEEEF';
var VIDEO_COLOR_BAND = exports.VIDEO_COLOR_BAND = '#444444';
var COLOR_LABEL_VER = '#666666'; //'rgba(0, 0, 0, 0.2)';
var COLOR_LABEL_HOR = '#666666'; //#727272
var MARGIN_VER = 8;
var MARGIN_HOR = 2;
var OFFSET = 0; //-0.38;

// Data from http://www.nber.org/cycles.html
var RECESSIONS = exports.RECESSIONS = [{ start: { month: 5, year: 1857 }, end: { month: 11, year: 1858 } }, { start: { month: 9, year: 1860 }, end: { month: 5, year: 1861 } }, { start: { month: 3, year: 1865 }, end: { month: 11, year: 1867 } }, { start: { month: 5, year: 1869 }, end: { month: 11, year: 1870 } }, { start: { month: 9, year: 1873 }, end: { month: 2, year: 1879 } }, { start: { month: 2, year: 1882 }, end: { month: 4, year: 1885 } }, { start: { month: 2, year: 1887 }, end: { month: 3, year: 1888 } }, { start: { month: 6, year: 1890 }, end: { month: 4, year: 1891 } }, { start: { month: 0, year: 1893 }, end: { month: 5, year: 1894 } }, { start: { month: 11, year: 1895 }, end: { month: 5, year: 1897 } }, { start: { month: 5, year: 1899 }, end: { month: 11, year: 1900 } }, { start: { month: 8, year: 1902 }, end: { month: 7, year: 1904 } }, { start: { month: 4, year: 1907 }, end: { month: 5, year: 1908 } }, { start: { month: 0, year: 1910 }, end: { month: 0, year: 1912 } }, { start: { month: 0, year: 1913 }, end: { month: 11, year: 1914 } }, { start: { month: 7, year: 1918 }, end: { month: 2, year: 1919 } }, { start: { month: 0, year: 1920 }, end: { month: 6, year: 1921 } }, { start: { month: 4, year: 1923 }, end: { month: 6, year: 1924 } }, { start: { month: 9, year: 1926 }, end: { month: 10, year: 1927 } }, { start: { month: 7, year: 1929 }, end: { month: 2, year: 1933 } }, { start: { month: 4, year: 1937 }, end: { month: 5, year: 1938 } }, { start: { month: 1, year: 1945 }, end: { month: 9, year: 1945 } }, { start: { month: 10, year: 1948 }, end: { month: 9, year: 1949 } }, { start: { month: 6, year: 1953 }, end: { month: 4, year: 1954 } }, { start: { month: 7, year: 1957 }, end: { month: 3, year: 1958 } }, { start: { month: 3, year: 1960 }, end: { month: 1, year: 1961 } }, { start: { month: 11, year: 1969 }, end: { month: 10, year: 1970 } }, { start: { month: 10, year: 1973 }, end: { month: 2, year: 1975 } }, { start: { month: 0, year: 1980 }, end: { month: 6, year: 1980 } }, { start: { month: 6, year: 1981 }, end: { month: 10, year: 1982 } }, { start: { month: 6, year: 1990 }, end: { month: 2, year: 1991 } }, { start: { month: 2, year: 2001 }, end: { month: 10, year: 2001 } }, { start: { month: 11, year: 2007 }, end: { month: 5, year: 2009 } }, { start: { month: 1, year: 2020 }, end: false }];

var UK_RECESSIONS = exports.UK_RECESSIONS = [{ start: { month: 4, year: 1956 }, end: { month: 9, year: 1956 } }, { start: { month: 7, year: 1961 }, end: { month: 12, year: 1961 } }, { start: { month: 7, year: 1973 }, end: { month: 3, year: 1974 } }, { start: { month: 4, year: 1975 }, end: { month: 9, year: 1975 } }, { start: { month: 1, year: 1980 }, end: { month: 3, year: 1981 } }, { start: { month: 7, year: 1990 }, end: { month: 9, year: 1991 } }, { start: { month: 4, year: 2008 }, end: { month: 6, year: 2009 } }];

/**
 * Pre Render
 */
function preRender(data, options) {
  if (canShowRecessions(options)) {
    var values = convertDataToValues(options.axes.showRecessions, options.axes.showUkRecessions);
    var dateA = options.dates[0];
    var dateB = options.dates[options.dates.length - 1];
    var axisValueA = new Date(dateA.year, dateA.month || 0).valueOf();
    var axisValueB = new Date(dateB.year, dateB.month || 0, dateB.date || 1).valueOf();

    var conditionalColorBand = void 0;
    if (options.product === 'marketwatch') {
      conditionalColorBand = '#eeeff0';
    } else if (options.id === 'video' || options.id === 'twitterVideo') {
      conditionalColorBand = VIDEO_COLOR_BAND;
    } else {
      conditionalColorBand = COLOR_BAND;
    }

    var plotBands = values.map(function (v) {
      if (v.start <= axisValueB && v.end >= axisValueA) {
        return {
          from: Math.max(axisValueA, v.start),
          to: Math.min(axisValueB, v.end),
          color: conditionalColorBand,
          className: 'recession'
        };
      }
      return null;
    }).filter(function (item) {
      return item !== null;
    });

    if (plotBands.length) {
      if (options.quarterlyResults && options.series[0].data.length <= 44) {
        plotBands = convertDatetimeToLinear(plotBands, options.dates);
      }
      data.xAxis.plotBands = [].concat((0, _toConsumableArray3.default)(data.xAxis.plotBands), (0, _toConsumableArray3.default)(plotBands));
    }
  }
  return data;
}

function canShowRecessions(options) {
  return (options.axes.showRecessions || options.axes.showUkRecessions) && options.dates && options.type !== 'pie' && options.type !== 'bar' && allHaveYears(options.dates);
}

function allHaveYears(dates) {
  return !dates.some(function (date) {
    return date.year === undefined;
  });
}

function convertDataToValues(showRecessions, showUkRecessions) {
  if (showRecessions) return convertDataToValuesHelper(RECESSIONS);
  if (showUkRecessions) return convertDataToValuesHelper(UK_RECESSIONS);
}

function convertDataToValuesHelper(recessionsDates) {
  return recessionsDates.map(function (r) {
    return {
      start: new Date(r.start.year, r.start.month).valueOf(),
      end: r.end ? new Date(r.end.year, r.end.month).valueOf() : new Date().valueOf()
    };
  });
}

// On datetime axes, values are milliseconds. On linear axes, values are
// just indices. For quarterly results, the axis is actually linear and just
// pretends to be datetime, so plotBands must be converted from datetime.
function convertDatetimeToLinear(plotBands, dates) {
  var datesLen = dates.length;
  plotBands.forEach(function (pb) {
    var newFrom = 0;
    var newTo = datesLen - 1;
    dates.forEach(function (date, index) {
      if (pb.from >= date.value) {
        newFrom = index;
      }
      if (pb.to >= date.value) {
        newTo = index;
      }
    });
    newFrom = getLinearPrecise(newFrom, pb.from, dates);
    newTo = getLinearPrecise(newTo, pb.to, dates);
    pb.from = newFrom;
    pb.to = newTo;
  });
  return plotBands;
}

// For use with convertDatetimeToLinear().
function getLinearPrecise(linear, datetime, dates) {
  if (linear < dates.length - 1) {
    linear += (datetime - dates[linear].value) / (dates[linear + 1].value - dates[linear].value);
  }
  return linear;
}

/**
 * Post Render
 */
function postRender(highchart, options) {
  var xAxis = highchart.xAxis[0];
  var pb = xAxis.plotLinesAndBands.filter(function (band) {
    return band.options.className === 'recession';
  });

  if (pb.length) {
    var pos = null;
    var rtext = null;
    var maxPx = 0;

    if (options.type === 'bar') {
      pos = {
        x: highchart.plotLeft + highchart.plotWidth - MARGIN_HOR,
        y: highchart.plotTop + parseFloat(options.styles.small.fontSize)
      };
      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_HOR);
      rtext.element.setAttribute('x', +rtext.element.getAttribute('x') - rtext.element.getBoundingClientRect().width);
      maxPx = highchart.plotTop + highchart.plotHeight;

      moveRecessionTextHorizontal(pb, rtext.element, maxPx);
    } else {
      if (options.ticksOffsetX) {
        offsetPlotBands(pb, options.ticksOffsetX);
      }
      pos = topYAxisLabelPosition(highchart, options);
      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_VER);
      maxPx = highchart.plotLeft + highchart.plotWidth;
      moveRecessionTextVertical(pb, rtext.element, options.ticksOffsetX || 0, maxPx);
    }
  }
}

function offsetPlotBands(plotBands, offsetX) {
  plotBands.forEach(function (pb) {
    transform.write(pb.svgElem.element, 'translate', offsetX);
  });
}

function moveRecessionTextHorizontal(pb, el, maxY) {
  var y = +el.getAttribute('y');
  var origY = y;
  var elHeight = el.getBoundingClientRect().height + MARGIN_HOR;
  for (var i = 0; i < pb.length; i++) {
    if (!pb[i].svgElem) continue;
    var d = transform.read(null, 'd', pb[i].svgElem.d);
    if (d[2][1] - d[1][1] >= elHeight) {
      y = d[2][1] - MARGIN_HOR;
      break;
    } else if (i === pb.length - 1) {
      y = d[1][1] - MARGIN_HOR;
    }
  }
  el.setAttribute('y', Math.max(origY, Math.min(y, maxY - elHeight)));
}

function moveRecessionTextVertical(pb, el, offsetX, maxX) {
  var elWidth = el.getBoundingClientRect().width;
  var x = +el.getAttribute('x');
  for (var i = 0; i < pb.length; i++) {
    if (!pb[i].svgElem) continue;
    var d = transform.read(null, 'd', pb[i].svgElem.d);
    if (d[0][0] >= x) {
      x = d[0][0];
      break;
    } else if (d[2][0] >= x + elWidth) {
      x = d[2][0] - elWidth;
      break;
    }
  }
  x += offsetX;
  el.setAttribute('x', Math.min(x, maxX - elWidth));
}

function writeRecessionText(highchart, options, pos, color) {
  if ((options.product === 'marketwatch' || options.product === 'financialnews') && options.type === 'line') {
    var bandsX = highchart.container.getElementsByClassName('highcharts-plot-bands-0')[0].getBoundingClientRect();
    bandsX = bandsX.left - bandsX.width;
    pos.x = bandsX;
  }

  var css = options.styles.get('normal', { color: color });

  if (false) {
    if (options.product === 'wsj') {
      css.fontSize = "13px";
      css.fontFamily = "Retina Narrow";

      if (options.print) {
        css.fontSize = "7.5px";
      }

      if (options.id === 'video') {
        css.fontSize = '32px';
        css.fontFamily = 'Retina Narrow';
        css.fontWeight = 400;
      }
    }
  }

  var regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
  var recessionLabel = 'RECESSION';
  if (regex.test(options.el.innerHTML)) recessionLabel = '景気後退';
  var text = options.product === 'barrons' ? 'Recessions are shaded' : recessionLabel;

  return highchart.renderer.text(text, pos.x, pos.y).css(css).attr('class', 'label-recession').add();
}

// Finds the Y of the top label on the y-axis in order to align "recession"
// on the same baseline. If units have been set, uses that as a shortcut.
function topYAxisLabelPosition(highchart, options) {
  var pos = { x: 0, y: 0 };
  var textUnits = highchart.container.querySelector('text.units');
  if (textUnits) {
    pos.x = +textUnits.getAttribute('x') + textUnits.getBoundingClientRect().width;
    pos.y = +textUnits.getAttribute('y') - 1;
  } else {
    (0, _util.forAxisTicks)(highchart.yAxis[0], function (tick) {
      if (tick.isLast) {
        pos.x = +tick.label.element.getAttribute('x') + tick.label.element.getBoundingClientRect().width;
        pos.y = +tick.label.element.getAttribute('y');
        return false;
      }
    });
  }

  if (false) {
    if (options.product === 'wsj' && options.print) {
      pos.y = pos.y + 1;
    }
  }

  pos.x += MARGIN_VER;
  return pos;
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(282);
moment.tz.load(__webpack_require__(283));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(206);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.checkInstrumentType = checkInstrumentType;
exports.selectProps = selectProps;
exports.updateProps = updateProps;
exports.createNewProps = createNewProps;
exports.getSourceLine = getSourceLine;
exports.checkIntradayFrequency = checkIntradayFrequency;
exports.createETMoment = createETMoment;
exports.lastItem = lastItem;
exports.getRangeOptions = getRangeOptions;
exports.getFrequencyOptions = getFrequencyOptions;
exports.parseDateRange = parseDateRange;
exports.getFrequencyDefaults = getFrequencyDefaults;
exports.checkSeriesLength = checkSeriesLength;
exports.getLastValue = getLastValue;
exports.parseData = parseData;
exports.parseDataColumn = parseDataColumn;

var _momentTimezone = __webpack_require__(211);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _marketdata = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkInstrumentType(tickers, instrumentType) {
  return tickers.some(function (_ref) {
    var type = _ref.type;
    return type === instrumentType;
  });
}

function selectProps(obj, props) {
  return props.reduce(function (newObj, prop) {
    return Object.assign(newObj, (0, _defineProperty3.default)({}, prop, obj[prop]));
  }, {});
}

function updateProps(props, ticker) {
  var newProps = selectProps(props, ['dateRange', 'start', 'end', 'frequency', 'isPercent', 'isRolling']);
  newProps.tickers = [].concat((0, _toConsumableArray3.default)(props.tickers), [ticker]);
  return newProps;
}

function createNewProps(props, isCustom, categories, prop) {
  var start = props.start,
      end = props.end,
      frequency = props.frequency;

  var newProps = findStartEnd(isCustom, start, end, categories, frequency);

  if (prop !== 'update') newProps[prop] = props[prop];

  var hasCrypto = checkCrypto(props, prop);
  if (prop === 'dateRange' || hasCrypto) newProps.frequency = frequency;

  return newProps;
}

function getSourceLine(series) {
  var sources = compileSources(series);
  var sourceNames = Object.keys(sources);

  return sourceNames.length === 1 ? 'Source: ' + sourceNames[0] : writeMultipleSources(sourceNames, sources);
}

function checkIntradayFrequency(frequency) {
  return frequency.includes('T') && frequency.includes('M') || frequency.includes('H');
}

function createETMoment(date) {
  return _momentTimezone2.default.tz(date, 'America/New_York');
}

function lastItem(arr) {
  return arr[arr.length - 1];
}

function getRangeOptions(chartType) {
  var ranges = Object.keys(_marketdata.RANGE);
  var offset = chartType === 'column' ? 4 : 0;
  return ranges.slice(offset);
}

function getFrequencyOptions(dateRange, startDate, endDate, hasCrypto, currentFrequency, chartType) {
  // populate frequency dropdown with proper options for specified date range
  var isCustom = dateRange === 'Custom';
  if (isCustom) {
    // for custom dates, determine which preset date range is closest in length
    var _map = [startDate, endDate].map(convertDate),
        _map2 = (0, _slicedToArray3.default)(_map, 2),
        unixStart = _map2[0],
        unixEnd = _map2[1];

    var timeSpan = unixEnd - unixStart;
    dateRange = getRange(timeSpan);
  }
  var noIntraday = checkCustomIntraday(endDate, isCustom); // for older custom dates, intraday intervals unavailable 

  var _getFrequencyDefaults = getFrequencyDefaults(dateRange, hasCrypto, chartType, noIntraday),
      start = _getFrequencyDefaults.start,
      end = _getFrequencyDefaults.end,
      defaultFrequency = _getFrequencyDefaults.defaultFrequency;

  var frequencyOptions = getOptions(hasCrypto, defaultFrequency, start, end, chartType);

  var frequency = getDefaultFrequency(isCustom, frequencyOptions, defaultFrequency, currentFrequency);

  return { frequencyOptions: frequencyOptions, defaultFrequency: frequency };
}

function parseDateRange(dateRange) {
  return {
    timePeriodType: dateRange.slice(-1),
    timeValue: +dateRange.slice(0, -1)
  };
}

function getFrequencyDefaults(dateRange, hasCrypto, chartType, noIntraday) {
  var _RANGE$dateRange = _marketdata.RANGE[dateRange],
      start = _RANGE$dateRange.start,
      end = _RANGE$dateRange.end,
      frequency = _RANGE$dateRange.default;


  var isColumn = chartType === 'column';
  var isIntraday = isFrequencyIntraday(frequency);
  var needsInterday = (noIntraday || isColumn) && isIntraday;
  if (needsInterday) {
    return { start: 'P1D', end: getEnd(end), defaultFrequency: 'P1D' };
  }

  var defaultFrequency = hasCrypto && frequency === 'P7D' ? 'P1M' : frequency;
  return { start: start, end: end, defaultFrequency: defaultFrequency };
}

function checkSeriesLength(series) {
  return series && series.length === 1;
}

function getLastValue(data) {
  for (var i = data.length - 1; i >= 0; i--) {
    var value = data[i];
    var y = value.y;

    if (y !== null && y !== undefined) {
      return value;
    }
  }
  return null;
}

function parseData(data) {
  return data.map(function (point) {
    return selectProps(point, ['y']);
  });
}

function parseDataColumn(data, prevData) {
  return data.map(function (point, i) {
    if (i > 0) {
      var y = getColumnY(point, data, i);
      var updatedPoint = { y: y };
      if (prevData && prevData[i - 1] && prevData[i - 1].color) {
        updatedPoint.color = prevData[i - 1].color;
      }
      return updatedPoint;
    }
  }).slice(1);
}

// getFrequencyOptions helper functions
function convertDate(date) {
  return date.format('x');
}

function getRange(timeSpan) {
  var timePeriods = getTimePeriods();
  var current = void 0;
  for (var i = 0; i < timePeriods.length; i++) {
    current = timePeriods[i];
    if (timeSpan < current.milliseconds) {
      var prev = timePeriods[i - 1];
      return i === 0 || checkDate(timeSpan, prev, current) ? current.range : prev.range;
    }
  }
  return current.range;
}

function getTimePeriods() {
  return Object.keys(_marketdata.RANGE).map(createTimeSpanObj).filter(function (_ref2) {
    var milliseconds = _ref2.milliseconds;
    return !isNaN(milliseconds);
  });
}

function createTimeSpanObj(range) {
  var _parseDateRange = parseDateRange(range),
      timePeriodType = _parseDateRange.timePeriodType,
      timeValue = _parseDateRange.timeValue;

  var milliseconds = _marketdata.TIMETYPES[timePeriodType] * timeValue;
  return { range: range, milliseconds: milliseconds };
}

function checkDate(timeSpan, prev, current) {
  return timeSpan - prev.milliseconds > current.milliseconds - timeSpan;
}

function checkCustomIntraday(endDate, isCustom) {
  return isCustom && endDate.isBefore((0, _momentTimezone2.default)().subtract(2, 'w'));
}

function getOptions(hasCrypto, defaultFrequency, start, end) {
  return hasCrypto && !isFrequencyIntraday(defaultFrequency) ? getInterdayCryptoOptions() : getDefaultOptions(start, end);
}

function isFrequencyIntraday(code) {
  return code.includes('T');
}

function getInterdayCryptoOptions() {
  return _marketdata.FREQUENCY.filter(function (_ref3) {
    var value = _ref3.value;
    return value !== 'P7D' && !isFrequencyIntraday(value);
  });
}

function getDefaultOptions(start, end) {
  var _map3 = [start, end].map(findFrequencyIndex),
      _map4 = (0, _slicedToArray3.default)(_map3, 2),
      startIdx = _map4[0],
      endIdx = _map4[1];

  return _marketdata.FREQUENCY.slice(startIdx, endIdx + 1);
}

function findFrequencyIndex(prop) {
  return _marketdata.FREQUENCY.findIndex(function (_ref4) {
    var value = _ref4.value;
    return value === prop;
  });
}

function getDefaultFrequency(isCustom, frequencyOptions, defaultFrequency, currentFrequency) {
  var validFrequency = frequencyOptions.some(function (_ref5) {
    var value = _ref5.value;
    return value === currentFrequency;
  });
  return isCustom && validFrequency ? currentFrequency : defaultFrequency;
}

// getFrequencyDefaults helper function
function getEnd(end) {
  return isFrequencyIntraday(end) ? 'P1D' : end;
}

// createNewProps helper functions
function findStartEnd(isCustom, startProp, endProp, categories, frequency) {
  var _ref6 = isCustom && frequency !== 'P7D' && frequency !== 'P1M' && frequency !== 'P3M' && frequency !== 'P1Y' ? [startProp, endProp] : getDates(categories),
      _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
      start = _ref7[0],
      end = _ref7[1];

  return { start: start, end: end };
}

function getDates(categories) {
  return [categories[0], lastItem(categories)].map(formatDate);
}

function formatDate(date) {
  var isIntraday = date.split(' ').length > 1;
  if (isIntraday) date += 'm';
  var format = isIntraday ? 'MM-DD-YYYY h:mm:ss a' : 'MM-DD-YYYY';
  return _momentTimezone2.default.tz(date, format, 'America/New_York').format();
}

function checkCrypto(props, prop) {
  var tickers = props.tickers;

  var cryptoAdded = tickers.length && lastItem(tickers).type === 'CryptoCurrency';
  return prop === 'tickers' && cryptoAdded;
}

// getSourceLine helper functions
function compileSources(series) {
  var sources = {};

  series.forEach(function (_ref8) {
    var sourceInfo = _ref8.sourceInfo;
    var type = sourceInfo.type,
        symbol = sourceInfo.symbol,
        source = sourceInfo.source;


    if (!sources[source]) sources[source] = [];
    var types = sources[source];

    if (checkMultiple(series, type, source)) {
      types.push(symbol); // when same ticker type appears under different sources, list symbol
    } else if (!types.includes(type)) {
      types.push(type); // otherwise list type
    }
  });

  return sources;
}

function checkMultiple(series, currentType, currentSource) {
  // does same ticker type appear under multiple sources?
  return series.some(function (_ref9) {
    var sourceInfo = _ref9.sourceInfo;
    var type = sourceInfo.type,
        source = sourceInfo.source;

    return type === currentType && source !== currentSource;
  });
}

function writeMultipleSources(sourceKeys, sources) {
  return sourceKeys.reduce(function (str, source) {
    return str + writeSource(sources, source);
  }, 'Sources: ').slice(0, -2);
}

function writeSource(sources, source) {
  return source + ' (' + writeList(sources[source]) + '); ';
}

function writeList(listArr) {
  return listArr.reduce(function (str, listItem) {
    return str + (listItem + ', ');
  }, '').slice(0, -2);
}

// parseDataColumn helper function
function getColumnY(point, data, i) {
  var prevY = data[i - 1].y;
  return (point.y - prevY) / prevY * 100;
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(26);
var SPECIES = __webpack_require__(2)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(21);
var invoke = __webpack_require__(300);
var html = __webpack_require__(62);
var cel = __webpack_require__(36);
var global = __webpack_require__(1);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(19)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(12);
var newPromiseCapability = __webpack_require__(55);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(219);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _datetime = __webpack_require__(30);

var _datetime2 = _interopRequireDefault(_datetime);

var _processOptions = __webpack_require__(237);

var _processOptions2 = _interopRequireDefault(_processOptions);

var _processSeries = __webpack_require__(50);

var _preload = __webpack_require__(248);

var preload = _interopRequireWildcard(_preload);

var _outer = __webpack_require__(262);

var OuterChart = _interopRequireWildcard(_outer);

var _inner = __webpack_require__(269);

var InnerChart = _interopRequireWildcard(_inner);

var _element = __webpack_require__(15);

var element = _interopRequireWildcard(_element);

var _filterOptionsForSize = __webpack_require__(64);

var _marketDataHelpers = __webpack_require__(289);

var _constants = __webpack_require__(3);

var _marketdata = __webpack_require__(212);

var _highcharts = __webpack_require__(56);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _annotations = __webpack_require__(313);

var _annotations2 = _interopRequireDefault(_annotations);

var _exporting = __webpack_require__(314);

var _exporting2 = _interopRequireDefault(_exporting);

var _highstock = __webpack_require__(315);

var _highstock2 = _interopRequireDefault(_highstock);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _annotations2.default)(_highcharts2.default);
(0, _annotations2.default)(_highstock2.default);
(0, _exporting2.default)(_highcharts2.default);
(0, _exporting2.default)(_highstock2.default);

// Store charts so they can be destroyed as needed.
var charts = [];

/**
 * Public API functions.
 */

function render(options) {
  var uploadFonts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var done = arguments[2];

  // for published auto-updating market data charts, fetch the latest data
  var liveMarketData = options.liveMarketData,
      isRolling = options.isRolling,
      skipUpdate = options.skipUpdate;

  var mustUpdate = liveMarketData && isRolling && !skipUpdate;
  var renderAction = mustUpdate ? renderRolling : startRender;
  return renderAction(options, done, uploadFonts);
}

function renderRolling(options, done, uploadFonts) {
  var tickers = options.tickers,
      frequency = options.frequency,
      start = options.start,
      end = options.end,
      isPercent = options.isPercent,
      product = options.product,
      dateRange = options.dateRange,
      singleIsPercent = options.singleIsPercent;

  var instruments = tickers.map(function (ticker) {
    return ticker.chartingSymbol;
  });
  var isCustom = dateRange === 'Custom';
  var usePercent = tickers.length > 1 && isPercent || tickers.length === 1 && singleIsPercent;
  var cb = createCallback(options, done, usePercent, isCustom, frequency, dateRange, end, uploadFonts);
  (0, _marketDataHelpers.fetchData)(instruments, start, end, frequency, isCustom, dateRange, true, product, cb);
}

function createCallback(options, done, isPercent, isCustom, frequency, dateRange, end, uploadFonts) {
  return function (data) {
    var parseData = (0, _marketDataHelpers.createDataParser)(data, isPercent, isCustom, frequency, dateRange, end);
    var size = (0, _filterOptionsForSize.getSize)(options);
    var sizeObj = options.sizes[size.id];
    var headings = options.headings || sizeObj.headings;
    var barData = [];
    var prevData = options.series[0].data;
    data.forEach(function (series, index) {
      var _parseData = parseData(series, index),
          _parseData2 = (0, _slicedToArray3.default)(_parseData, 3),
          seriesArr = _parseData2[0],
          categories = _parseData2[1],
          date = _parseData2[2];

      if (options.type === 'bar') {
        var lastValue = (0, _marketdata.getLastValue)(seriesArr);
        var color = prevData[index].color;

        if (color) {
          lastValue.color = color;
        }
        barData.push(lastValue);
      } else {
        var _ref = options.type === 'line' ? [categories, seriesArr] : [categories.slice(1), (0, _marketdata.parseDataColumn)(seriesArr, prevData)],
            _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            updatedCategories = _ref2[0],
            updatedData = _ref2[1];

        options.categories = updatedCategories;
        options.series[index].data = updatedData;
      }
      headings.date.text = 'As of ' + date;
    });
    if (options.type === 'bar') {
      options.series[0].data = barData;
    }
    options.annotations.filter(function (annotation) {
      return options.categories.includes(annotation.category);
    });
    startRender(options, done, uploadFonts);
  };
}

function startRender(options, done, uploadFonts) {
  done = typeof done === 'function' ? done : function () {};
  options = options.irregularDates ? (0, _processOptions2.default)(options, _highstock2.default) : (0, _processOptions2.default)(options, _highcharts2.default);
  var invalidated = options.invalidated && options.invalidated[options.size];
  if (!!invalidated) {
    var existChart = getExistChart(options.el).chart;
    if (existChart && existChart.outer && existChart.inner) {
      renderInvalidated(existChart, options, done, uploadFonts);
      return;
    }
  }
  resetRender(options, done, uploadFonts);
}

function resetRender(options, done, uploadFonts) {
  destroy(options.el);
  // console.log(`CHART.${options.id}.fonts.START`);
  if (uploadFonts || options.product !== 'wsj') {
    preload.fonts(options, function () {
      // also need to add a data attribute to element
      // when chart is done loading, for testing purposes
      var doneWithFlag = function doneWithFlag(params) {
        done(params);
        params.container.dataset.rendered = true;
      };
      renderChart(options, doneWithFlag);
    });
  } else {
    renderChart(options, done);
  }
}

// Instead of re-rendering the entirety of both inner and outer charts, only
// the invalidate parts of re-rendered.
// TODO: Create preview/editing views and get this working again.
function renderInvalidated(rendered, options, done, uploadFonts) {
  if (false) {
    var invalidated = options.invalidated[options.size] || [];

    var invalidAll = ['chart/targets', 'chart/height', 'chart/annotations',
    // ];
    // const invalidChart = [
    'chart/data', 'chart/type', 'chart/series-names', 'chart/hide-legend', 'chart/axis', 'chart/legend', 'chart/stacking', 'chart/height', 'chart/colors', 'headings/title'];
    var invalidChart = [];

    // Some changes require a full chart re-render while others can force a
    // more limited re-render.
    var mustRender = function mustRender(invalidated, renderItems) {
      return true;
      // return renderItems.some(item => {
      //   return invalidated.indexOf(item) !== -1 || invalidated.some(invItem => {
      //     return invItem.indexOf(item) === 0;
      //   });
      // });
    };

    if (mustRender(invalidated, invalidAll)) {
      window.__charts_fonts_loaded__ = undefined;
      resetRender(options, done, uploadFonts);
      return;
    }

    // Some items only force a re-render under specific conditions. For example,
    // changes to series name should only trigger a re-render if the legend is
    // enabled since that is the only place where series names appear.
    invalidated = invalidated.filter(function (item) {
      switch (item) {
        case 'chart/series-names':
          return options.legend.enabled;
        default:
          return true;
      }
    });

    var outerHeight = rendered.outerInfo.height;
    OuterChart.renderInvalidated(rendered, options, invalidated);

    if (outerHeight !== rendered.outerInfo.height || mustRender(invalidated, invalidChart)) {
      // mustRenderColor(invalidated)) {
      destroyInner(rendered.inner);
      setTimeout(function () {
        renderInnerChart(options, rendered, rendered.outerInfo, done);
      }, 1);
    } else {
      InnerChart.renderInvalidated(rendered, options, invalidated);
      done(rendered.inner);
    }
  }
}

// The outer chart containers headlines and notes.
function renderChart(options, done) {
  if (options.type === 'bar') {
    // options = truncateData(options, options.series);
  }
  var renderObj = { el: options.el, outer: null, inner: null, options: options };
  var chartObj = OuterChart.preRender(options);
  charts.push(renderObj);
  renderObj.outer = renderHighchart(options, chartObj, function (highchart) {
    var outer = OuterChart.postRender(highchart, options);
    renderObj.outerInfo = outer;
    if (outer.innerEl) {
      renderInnerChart(options, renderObj, outer, done);
    } else {
      done(null);
    }
  });
}

// The inner charts contains the actual chart.
function renderInnerChart(options, renderObj, outer, done) {
  var outerY = outer.y;
  options.width = outer.width;
  var fontSize = parseFloat(options.styles.normal.fontSize);
  if (options.size.indexOf('thumb') !== 0) {
    options.height = outer.height - (options.type === 'pie' || options.size === 'marketwatch-ZT' ? 0 : 16);
  }
  var offset = options.id === 'D' || options.id === 'appfeed' ? 12 : 8;
  options.height += offset;
  options.spacing = createInnerSpacing(options, outer.spacing);
  var chartObj = InnerChart.preRender(options);
  getHighchart(options, chartObj).then(function (highchart) {
    InnerChart.postRender(highchart, options);
    var hc = chartObj.chart.renderTo.querySelector('.highcharts-container');
    if (hc) {
      hc.style.position = 'absolute';
      hc.style.left = outer.x + 'px';
      hc.style.top = outerY + 'px';
      hc.style.overflow = 'visible';

      var svg = hc.querySelector('svg');
      svg.setAttribute('x', outer.x);
      svg.setAttribute('y', outerY);
      svg.setAttribute('height', Math.max(0, options.height + fontSize));

      if (options.size.indexOf('print') === 0) {
        // This causes tooltip issues, but needs to be done (at the time) for
        // image export and svg download:
        outer.innerEl.appendChild(svg);
        element.removeChild(hc);
      }
    }
    done(highchart);
  });
}

function getMaxTicksDecimals(axis) {
  var maxDecimals = 0;
  forAxisTicks(axis, function (tick, pos) {
    var decimal = tick.label.textStr.split('.')[1];
    if (decimal !== undefined) {
      maxDecimals = Math.max(decimal.length, maxDecimals);
    }
  });
  return maxDecimals;
}

function getHighchart(options, data) {
  return new Promise(function (resolve, reject) {
    return resolve(renderHighchart(options, data));
  });
}

// async function getHighchart(options, data) {
//   const newChart = await renderHighchart(options, data);
//   return newChart;
// }

function createInnerSpacing(options, spacing) {
  var inner = spacing ? spacing.map(function (n) {
    return n;
  }) : [0, 0, 0, 0];
  var annotations = options.annotations,
      axes = options.axes,
      product = options.product,
      styles = options.styles,
      id = options.id;
  // const { items } = annotations;

  var units = axes.units,
      showRecessions = axes.showRecessions,
      showUkRecessions = axes.showUkRecessions;

  if (annotations /*items*/ && annotations /*items*/.length && (units.suffix.length > 2 || showRecessions || showUkRecessions)) {
    var isVideoGroup = id === 'video' || id === 'twitterVideo';
    var wsjHeight = isVideoGroup ? _constants.ANNOTATIONS_LINEHEIGHT_VIDEO : _constants.ANNOTATIONS_LINEHEIGHT;
    inner[0] += product === 'wsj' ? wsjHeight : parseFloat(styles.normal.lineHeight);
    inner[0] = Math.max(0, inner[0]);
  }
  return inner;
}

// Render a Highcharts chart via either the standalone Highcharts adapter or
// jQuery, depending on the environment.
function renderHighchart(options, data, postRender) {
  if (options.irregularDates) {
    return new _highstock2.default.stockChart(data, postRender);
  } else {
    return new _highcharts2.default.chart(data, postRender);
  }
}

function destroy(el) {
  if (el) {
    var obj = getExistChart(el);
    if (obj.chart) {
      destroyOuter(obj.chart.outer, obj.chart.inner);
    }
    if (obj.index !== -1) {
      charts.splice(obj.index, 1);
    }
  } else {
    // charts.forEach(c => {
    //   if (c.el) {
    //     destroy(c.el);
    //   }
    // });
    while (charts.length) {
      destroy(charts[0].el);
    }
  }
}

function destroyOuter(outer, inner) {
  destroyInner(inner);
  if (outer) {
    try {
      destroyCommon(outer);
      outer.destroy();
    } catch (e) {
      // Highcharts error.... because older version?
      // console.warn(e);
    }
  }
}

function destroyInner(inner) {
  if (inner) {
    try {
      destroyCommon(inner);
      inner.destroy();
    } catch (e) {
      // Usually exception caused by no innerEl !?!
      // console.warn(e);
    }
  }
}

// The version of Highcharts used at DJ does not do this automatically.
function destroyCommon(chart) {
  if (chart.series) {
    chart.series.forEach(function (s) {
      try {
        s.update({
          enableMouseTracking: false
        });
      } catch (e) {
        //
      }
    });
  }
}

function getExistChart(el) {
  var existChartIndex = chartIndexOf(el);
  return {
    index: existChartIndex,
    chart: existChartIndex !== -1 ? charts[existChartIndex] : null
  };
}

function chartIndexOf(el) {
  for (var i = 0; i < charts.length; i++) {
    if (charts[i].el === el) {
      return i;
    }
  }
  return -1;
}

exports.default = { render: render, destroy: destroy, datetime: _datetime2.default, chart: getExistChart };

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(221), __esModule: true };

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(25);
__webpack_require__(23);
module.exports = __webpack_require__(232);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(223);
var step = __webpack_require__(224);
var Iterators = __webpack_require__(16);
var toIObject = __webpack_require__(17);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(57)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(19);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(60);
var descriptor = __webpack_require__(22);
var setToStringTag = __webpack_require__(29);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(38);

module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(229);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(40);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(13);
var toObject = __webpack_require__(44);
var IE_PROTO = __webpack_require__(41)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(40);
var defined = __webpack_require__(35);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(45);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(5).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(25);
__webpack_require__(23);
module.exports = __webpack_require__(235);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var get = __webpack_require__(46);
module.exports = __webpack_require__(5).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalize = normalize;
exports.makeFiscalYears = makeFiscalYears;
exports.removeFiscalYears = removeFiscalYears;
exports.makeQuarterly = makeQuarterly;
exports.removeQuarterly = removeQuarterly;
exports.getQuarter = getQuarter;
exports.getHalf = getHalf;

var _dateutils = __webpack_require__(63);

/**
 * For quarterly data, fills in missing quarters, years, etc.
 */
function normalize(items) {
  // Quarters, halves, years must be declared/set in first item of a year.
  var hasQ = items[0].quarter !== undefined;
  var hasH = items[0].half !== undefined;
  var hasY = items[0].year !== undefined;
  var FY = hasY && items[0].fiscalYear;

  // Dates are neither quarterly, halves, or fiscal years, so just return.
  if (!(hasQ || hasH || FY)) {
    return items;
  }

  var quarter = undefined;
  var half = undefined;
  var year = undefined;
  var currYear = undefined;
  items.forEach(function (item) {
    var prevQ = hasQ ? quarter : hasH ? half : null;
    item.fiscalYear = FY;

    if (hasQ) {
      if (!item.quarter) {
        if (item.hasOwnProperty('month')) {
          // - 1 because getQuarter starts months from 0:
          item.quarter = getQuarter(item.month - 1);
        } else {
          quarter += 1;
          quarter %= 4;
          quarter = quarter === 0 ? 4 : quarter;
          item.quarter = quarter + 'Q';
        }
      }
      quarter = +item.quarter.substring(0, 1);
    } else {
      item.quarter = undefined;
    }

    if (hasH) {
      if (!item.half) {
        half += 1;
        half %= 2;
        half = half === 0 ? 2 : half;
        item.half = half + 'H';
      }
      half = +item.half.substring(0, 1);
    } else {
      item.half = undefined;
    }

    if (hasY) {
      if (item.year === undefined) {
        item.year = year;
        if (hasQ && quarter <= prevQ || hasH && half <= prevQ) {
          item.year += 1;
        }
      }
      item.year = year = (0, _dateutils.fullYear)(item.year);

      if (currYear !== year) {
        currYear = year;
        hasQ = item.quarter !== undefined;
        hasH = item.half !== undefined;
      }
    }
  });

  return items;
}

/**
 * Transforms items into a fiscal years by declaring fiscalYear to be true for
 * first item. Assumes normalize() will be called subsequently.
 */
function makeFiscalYears(items) {
  items[0].fiscalYear = items[0].year !== undefined;
  return items;
}

function removeFiscalYears(items) {
  items.forEach(function (item) {
    item.fiscalYear = false;
  });
  return items;
}

function makeQuarterly(items) {
  items.forEach(function (item) {
    if (item.quarter === undefined && item.half === undefined && item.month !== undefined) {
      item.quarter = getQuarter(item.month);
    }
  });
  return makeHalves(items);
}

function makeHalves(items) {
  var isHalf = false;
  var yearBlocks = {};

  // Separate dates into blocks of years.
  items.forEach(function (item) {
    if (item.quarter && item.year !== undefined) {
      yearBlocks[item.year] = yearBlocks[item.year] || [];
      if (item.month !== undefined) {
        yearBlocks[item.year].push(item);
      }
    }
  });

  // Transform any year blocks with 2 dates 6 months or more apart into halves.
  Object.keys(yearBlocks).forEach(function (key) {
    var block = yearBlocks[key];
    if (block.length === 2) {
      if (block[1].month - block[0].month >= 6) {
        isHalf = true;
        block[0].quarter = block[1].quarter = undefined;
        block[0].half = '1H';
        block[1].half = '2H';
      }
    }
  });

  if (isHalf) {
    // Data if halves, not quarters, so convert quarters in years with only
    // one quarter to a half.
    Object.keys(yearBlocks).forEach(function (key) {
      block = yearBlocks[key];
      if (block.length === 1) {
        block[0].quarter = undefined;
        block[0].half = getHalf(block[0].month);
      }
    });
  }
  return items;
}

function removeQuarterly(items) {
  items.forEach(function (item) {
    item.quarter = item.half = undefined;
  });
  return items;
}

/**
 * Converts a month index to a quarterly string value.
 * @private
 */
function getQuarter(month) {
  if (month < 3) {
    return '1Q';
  } else if (month < 6) {
    return '2Q';
  } else if (month < 9) {
    return '3Q';
  } else {
    return '4Q';
  }
}

/**
 * Converts a month index to a half year string value.
 * @private
 */
function getHalf(month) {
  return month < 6 ? '1H' : '2H';
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processOptions;

var _highchartsVersion = __webpack_require__(238);

var _highchartsVersion2 = _interopRequireDefault(_highchartsVersion);

var _filterOptionsForSize = __webpack_require__(64);

var _filterOptionsForSize2 = _interopRequireDefault(_filterOptionsForSize);

var _processData = __webpack_require__(239);

var _processData2 = _interopRequireDefault(_processData);

var _processCategories = __webpack_require__(200);

var _processCategories2 = _interopRequireDefault(_processCategories);

var _processSeries = __webpack_require__(50);

var _processSeries2 = _interopRequireDefault(_processSeries);

var _style = __webpack_require__(246);

var _lodash = __webpack_require__(201);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(247);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processOptions(options, Highcharts) {
  removeOldProperties(options);
  options = copyOptions(options, Highcharts);
  options = (0, _filterOptionsForSize2.default)(options);
  options = (0, _processData2.default)(options);
  options = (0, _processCategories2.default)(options);
  options.styles = (0, _style.processStyles)(options);
  options = (0, _processSeries2.default)(options);
  options.el = containerElement(options.el);
  //new added propeerties are handled here
  addNewProperties(options);
  return options;
}

function removeOldProperties(options) {
  //if layout is bottom make it default;
  if (options.legend.layout === 'bottom') {
    options.legend.layout = 'default';
  };
}

function copyOptions(options, Highcharts) {
  return (0, _lodash2.default)({}, {
    HIGHCHARTS_VERSION: (0, _highchartsVersion2.default)(Highcharts),
    id: options.el.getAttribute('id') || options.size
  }, options);
}

// Prepares the container DOM element.
function containerElement(el) {
  el = typeof el === 'string' ? document.querySelector(el) : el;
  if (!el.querySelector('div.dj-chart-container')) {
    var divA = document.createElement('div');
    var divB = document.createElement('div');
    divA.className = 'dj-chart-container';
    divB.className = 'dj-chart-inner';
    el.appendChild(divA);
    el.appendChild(divB);
  }
  return el;
}

function addNewProperties(options) {
  //promo fields
  options.headings.sourcePromo = options.headings.sourcePromo ? options.headings.sourcePromo : { text: options.headings.source.text, enabled: true };
  options.headings.notePromo = options.headings.notePromo ? options.headings.notePromo : { text: options.headings.note.text, enabled: true };
  options.headings.subdekPromo = options.headings.subdekPromo ? options.headings.subdekPromo : { text: options.headings.subdek.text, enabled: true };
  //plot lines
  options.plotLines = options.plotLines ? options.plotLines : [{ plotLineValue: '',
    plotLineDashStyle: 'solid',
    plotLineLabel: '',
    plotLineLabelPosition: 'top right',
    plotLineColor: '' }];
  //allowDecimals yAxis
  options.allowDecimals = options.allowDecimals === undefined ? true : options.allowDecimals;
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = highchartsVersion;
function highchartsVersion() {
  var localHighcharts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var parts = (localHighcharts || Highcharts).version.split(' ');
  for (var i = 0; i < parts.length; i++) {
    var n = parseFloat(parts[i]);
    if (!isNaN(n)) {
      return n;
    }
  }
  return 0;
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = processData;

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

var _datetime = __webpack_require__(30);

var _datetime2 = _interopRequireDefault(_datetime);

var _constants = __webpack_require__(3);

var _axisIntervals = __webpack_require__(244);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _axesCommon = __webpack_require__(49);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes and optimizes the chart data before building categories and series.
 */
function processData(options) {
  if (options.categoriesAreDates) {
    options.dates = _datetime2.default.parse(options.categories, options);
    if ((!options.quarterlyResults || options.quarterlyResults && options.series[0].data.length > 44) && options.type !== 'bar') {
      var _options = options,
          fiscalYears = _options.fiscalYears;

      var sortedDates = [].concat((0, _toConsumableArray3.default)(options.dates)).sort(function (a, b) {
        return a.value - b.value;
      });
      options.xAxisTicks = {};
      var isArticle = (0, _axesCommon.checkArticle)(options.size, options.product);
      var majorValue = isArticle ? options.majorTicksArticle : options.majorTicksPromo;
      var minorValue = isArticle ? options.minorTicksArticle : options.minorTicksPromo;
      var isDecade = majorValue === 'decade';
      var isHalfDecade = majorValue === 'halfDecade';
      var isCentury = majorValue === 'century';
      var longerThanYear = isDecade || isHalfDecade || isCentury;
      var major = longerThanYear ? 'year' : majorValue;
      var minor = minorValue === 'decade' ? 'year' : minorValue;
      var firstDate = sortedDates[0];
      var lastDate = sortedDates[sortedDates.length - 1];
      var majorTick = firstDate[major];
      var minorTick = firstDate[minor];
      var isFirstLabel = true;
      var interval = _axisIntervals.INTERVALS.find(function (_ref) {
        var name = _ref.name;
        return name === majorValue;
      }).time;
      var tickPerColumn = options.dateSpan / interval >= options.series[0].data.length - 2;
      if (options.type === 'column' && tickPerColumn) {
        sortedDates.forEach(function (date) {
          var label = createLabel(date, majorValue, isFirstLabel, fiscalYears);
          options.xAxisTicks[date.value] = { label: label, type: 'major' };
          isFirstLabel = false;
        });
      } else {
        if (options.liveMarketData) {
          sortedDates.forEach(function (date, i) {
            var needsMajor = date[major] !== majorTick && (!longerThanYear || isDecade && date.year % 10 === 0 || isHalfDecade && date.year % 5 === 0 || isCentury && date.year % 100 === 0);
            var needsMinor = date[minor] !== minorTick && (options.type !== 'column' || isFirstLabel) && (minorValue !== 'decade' || minorValue === 'decade' && date.year % 10 === 0);
            if (needsMajor) {
              majorTick = date[major];
              minorTick = date[minor];
              var label = createLabel(date, majorValue, isFirstLabel, fiscalYears);
              options.xAxisTicks[date.value] = { label: label, type: 'major' };
              isFirstLabel = false;
            } else if (needsMinor) {
              minorTick = date[minor];
              var _label = isFirstLabel ? createLabel(date, minorValue, isFirstLabel, fiscalYears) : '';
              options.xAxisTicks[date.value] = { type: 'minor', label: _label };
              isFirstLabel = false;
            }
          });
        } else {
          var firstTick = void 0;
          var needsMajor = void 0;
          for (var i = 1; i < sortedDates.length; i++) {
            var date = sortedDates[i];
            needsMajor = date[major] !== majorTick && (!longerThanYear || isDecade && date.year % 10 === 0 || isHalfDecade && date.year % 5 === 0 || isCentury && date.year % 100 === 0);
            var needsMinor = date[minor] !== minorTick && (options.type !== 'column' || isFirstLabel) && (minorValue !== 'decade' || minorValue === 'decade' && date.year % 10 === 0);
            if (needsMajor || needsMinor) {
              firstTick = date.value;
              break;
            }
          }
          var tick = _moment2.default.utc(firstTick);
          var lastMoment = _moment2.default.utc(lastDate.value);
          while (tick.isBefore(lastMoment) || tick.isSame(lastMoment)) {
            needsMajor = tick[major]() !== majorTick && (!longerThanYear || isDecade && tick.year() % 10 === 0 || isHalfDecade && tick.year() % 5 === 0 || isCentury && tick.year() % 100 === 0);
            if (needsMajor) {
              var label = createLabel(tick.toObject(), majorValue, isFirstLabel, fiscalYears);
              options.xAxisTicks[tick.valueOf()] = { label: label, type: 'major' };
              majorTick = tick[major]();
              isFirstLabel = false;
            } else if (options.type !== 'column' || isFirstLabel) {
              var _label2 = isFirstLabel ? createLabel(tick.toObject(), minorValue, isFirstLabel, fiscalYears) : '';
              options.xAxisTicks[tick.valueOf()] = { label: _label2, type: 'minor' };
              isFirstLabel = false;
            }

            var _getTimeType = getTimeType(minorValue),
                _getTimeType2 = (0, _slicedToArray3.default)(_getTimeType, 2),
                n = _getTimeType2[0],
                timeType = _getTimeType2[1];

            tick.add(n, timeType);
            isFirstLabel = false;
          }
        }
        var tickValues = Object.keys(options.xAxisTicks);
        var labeledTicks = tickValues.filter(function (key) {
          return options.xAxisTicks[key].label;
        });
        if (labeledTicks.length === 1) {
          var lastTickValue = Math.max.apply(Math, (0, _toConsumableArray3.default)(tickValues));
          var firstTickValue = Math.min.apply(Math, (0, _toConsumableArray3.default)(tickValues));
          var lastTickDate = _moment2.default.utc(lastTickValue).toObject();
          var firstTickDate = _moment2.default.utc(firstTickValue).toObject();
          options.xAxisTicks[lastTickValue].label = createLabel(lastTickDate, minorValue, false);
          options.xAxisTicks[firstTickValue].label = createLabel(firstTickDate, minorValue, true, fiscalYears);
        } else if (!labeledTicks.length) {
          var _label3 = createLabel(firstDate, minorValue, true, fiscalYears);
          options.xAxisTicks[firstDate.value] = { label: _label3, type: 'minor' };
        }
      }
    }

    options.datesAll = _datetime2.default.all(options.dates);
    if ((!options.quarterlyResults || options.quarterlyResults && options.series[0].data.length > 44) && options.type !== 'bar') {
      options.series = insertDates(options.series, options);
    }
  }
  if (options.type === 'pie' && options.optimizeDataOrder) {
    options = optimizePieData(options);
  } else if (options.categoriesAreDates && (!options.quarterlyResults || options.quarterlyResults && options.series[0].data.length > 44)) {
    options = sortDataByDate(options);
  }
  if (options.axes && options.axes.units && options.axes.units.divisor !== "none") {
    options = divideYAxisValues(options);
  }
  return options;
}

function getTimeType(minorValue) {
  var timeType = minorValue;
  if (minorValue === 'date') timeType = 'day';
  if (minorValue === 'decade') timeType = 'year';
  var n = minorValue === 'decade' ? 10 : 1;
  return [n, timeType];
}

function createLabel(dateObj, type, isFirst, fiscalYears) {
  var year = dateObj.year || dateObj.years;
  var month = dateObj.month === undefined ? dateObj.months : dateObj.month;
  var date = dateObj.date;
  var hour = dateObj.hour || dateObj.hours;
  var minute = dateObj.minute || dateObj.minutes;
  var shortYear = year.toString().slice(2);
  var yearText = isFirst || shortYear === '00' ? year : '\'' + shortYear;
  if (isFirst && fiscalYears) yearText = 'FY' + yearText;
  var monthText = _constants.MONTHS[month];
  var quarterText = (month - (date === 1 ? 0 : 2)) / 3 + 1 + 'Q';
  switch (type) {
    case 'year':
    case 'decade':
    case 'halfDecade':
    case 'century':
      return yearText;
    case 'quarter':
      return month === 0 || month === 2 ? quarterText + ' ' + yearText : quarterText;
    case 'month':
      return month === 0 || isFirst ? monthText + ' ' + yearText : monthText;
    case 'date':
      return monthText + ' ' + date;
    case 'hour':
      var ampm = hour >= 12 ? 'p.m.' : 'a.m.';
      var formattedHour = hour === 12 ? 'noon' : hour % 12 + ' ' + ampm;
      return isFirst ? monthText + ' ' + date : formattedHour;
    default:
      return '';
  }
}

// Insert date values into all data.
function insertDates(data, options) {
  var proxyYears = getProxyYears(options);
  data.forEach(function (series) {
    series.data.forEach(function (item, index) {
      var dateObj = options.dates[index];
      var date = new Date(dateObj.value);
      if (dateObj.year === undefined && proxyYears[index] !== undefined) {
        dateObj.yearIsProxy = true;
        date.setUTCFullYear(proxyYears[index]);
      }
      item.x = date.valueOf();
    });
  });
  return data;
}

// For data with dates with months but not years, create proxy years so the
// dates can be sorted correctly.
function getProxyYears(options) {
  var proxyYears = [];
  if (options.datesAll.month && !options.datesAll.year) {
    var year = new Date().getUTCFullYear();
    var month = undefined;
    for (var i = options.dates.length - 1; i >= 0; i--) {
      if (month !== undefined && month <= options.dates[i].month) {
        year -= 1;
      }
      proxyYears[i] = year;
      month = options.dates[i].month;
    }
  }
  return proxyYears;
}

function sortDataByDate(options) {
  options.series.forEach(function (item) {
    item.data.forEach(function (pt, index) {
      pt.index = index;
    });
    if (item.data.every(function (point) {
      return point.x;
    })) {
      item.data.sort(function (a, b) {
        // if (a.x === undefined || b.x === undefined) {
        //   return 0;
        // }
        return a.x - b.x;
      });
    }
    // item.data.forEach((pt, index) => {
    // pt.index = index;
    // });
  });
  return options;
}

// Data should be ordered like so:
//      2 1
//    3     10
//  4         9
//    5     8
//      6 7
// Also, category names get attached to points.
function optimizePieData(options) {
  if (Array.isArray(options.categories)) {
    // Link each point to a category.
    options.series[0].data.forEach(function (point, index) {
      point.name = options.categories[index];
      point.originalIndex = index;
    });
  }
  // Sort the data smallest to largest.
  options.series[0].data.sort(function (a, b) {
    if (a.y > b.y) {
      return 1;
    } else if (a.y < b.y) {
      return -1;
    }
    return 0;
  });
  // Take the largest data at the end and make it first.
  options.series[0].data.unshift(options.series[0].data.pop());
  return options;
}

function divideYAxisValues(options) {
  var divisor = format.getDivisor(options.axes.units.divisor);
  for (var i = 0; i < options.series.length; i++) {
    var yAxisValue = options.series[i].data;
    yAxisValue.forEach(function (value) {
      if (value.y !== null) {
        value.y = value.y / divisor;
      }
    });
  }
  return options;
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(241), __esModule: true };

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(23);
__webpack_require__(242);
module.exports = __webpack_require__(5).Array.from;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(21);
var $export = __webpack_require__(10);
var toObject = __webpack_require__(44);
var call = __webpack_require__(65);
var isArrayIter = __webpack_require__(66);
var toLength = __webpack_require__(39);
var createProperty = __webpack_require__(243);
var getIterFn = __webpack_require__(46);

$export($export.S + $export.F * !__webpack_require__(67)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(22);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERVALS = undefined;
exports.getWidth = getWidth;

var _marketdata = __webpack_require__(47);

var Y = _marketdata.TIMETYPES.Y,
    D = _marketdata.TIMETYPES.D,
    M = _marketdata.TIMETYPES.M;
var INTERVALS = exports.INTERVALS = [{ name: 'century', time: 100 * Y }, { name: 'decade', time: 10 * Y }, { name: 'halfDecade', time: 5 * Y }, { name: 'year', time: Y }, { name: 'month', time: M }, { name: 'date', time: D }, { name: 'hour', time: 1000 * 60 * 60 }, { name: 'minute', time: 1000 * 60 }];

function getWidth(type, printWidth) {
  return type = 'Print' && printWidth > 114 ? printWidth : 300;
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 68,
	"./af.js": 68,
	"./ar": 69,
	"./ar-dz": 70,
	"./ar-dz.js": 70,
	"./ar-kw": 71,
	"./ar-kw.js": 71,
	"./ar-ly": 72,
	"./ar-ly.js": 72,
	"./ar-ma": 73,
	"./ar-ma.js": 73,
	"./ar-sa": 74,
	"./ar-sa.js": 74,
	"./ar-tn": 75,
	"./ar-tn.js": 75,
	"./ar.js": 69,
	"./az": 76,
	"./az.js": 76,
	"./be": 77,
	"./be.js": 77,
	"./bg": 78,
	"./bg.js": 78,
	"./bm": 79,
	"./bm.js": 79,
	"./bn": 80,
	"./bn.js": 80,
	"./bo": 81,
	"./bo.js": 81,
	"./br": 82,
	"./br.js": 82,
	"./bs": 83,
	"./bs.js": 83,
	"./ca": 84,
	"./ca.js": 84,
	"./cs": 85,
	"./cs.js": 85,
	"./cv": 86,
	"./cv.js": 86,
	"./cy": 87,
	"./cy.js": 87,
	"./da": 88,
	"./da.js": 88,
	"./de": 89,
	"./de-at": 90,
	"./de-at.js": 90,
	"./de-ch": 91,
	"./de-ch.js": 91,
	"./de.js": 89,
	"./dv": 92,
	"./dv.js": 92,
	"./el": 93,
	"./el.js": 93,
	"./en-au": 94,
	"./en-au.js": 94,
	"./en-ca": 95,
	"./en-ca.js": 95,
	"./en-gb": 96,
	"./en-gb.js": 96,
	"./en-ie": 97,
	"./en-ie.js": 97,
	"./en-il": 98,
	"./en-il.js": 98,
	"./en-in": 99,
	"./en-in.js": 99,
	"./en-nz": 100,
	"./en-nz.js": 100,
	"./en-sg": 101,
	"./en-sg.js": 101,
	"./eo": 102,
	"./eo.js": 102,
	"./es": 103,
	"./es-do": 104,
	"./es-do.js": 104,
	"./es-us": 105,
	"./es-us.js": 105,
	"./es.js": 103,
	"./et": 106,
	"./et.js": 106,
	"./eu": 107,
	"./eu.js": 107,
	"./fa": 108,
	"./fa.js": 108,
	"./fi": 109,
	"./fi.js": 109,
	"./fil": 110,
	"./fil.js": 110,
	"./fo": 111,
	"./fo.js": 111,
	"./fr": 112,
	"./fr-ca": 113,
	"./fr-ca.js": 113,
	"./fr-ch": 114,
	"./fr-ch.js": 114,
	"./fr.js": 112,
	"./fy": 115,
	"./fy.js": 115,
	"./ga": 116,
	"./ga.js": 116,
	"./gd": 117,
	"./gd.js": 117,
	"./gl": 118,
	"./gl.js": 118,
	"./gom-deva": 119,
	"./gom-deva.js": 119,
	"./gom-latn": 120,
	"./gom-latn.js": 120,
	"./gu": 121,
	"./gu.js": 121,
	"./he": 122,
	"./he.js": 122,
	"./hi": 123,
	"./hi.js": 123,
	"./hr": 124,
	"./hr.js": 124,
	"./hu": 125,
	"./hu.js": 125,
	"./hy-am": 126,
	"./hy-am.js": 126,
	"./id": 127,
	"./id.js": 127,
	"./is": 128,
	"./is.js": 128,
	"./it": 129,
	"./it-ch": 130,
	"./it-ch.js": 130,
	"./it.js": 129,
	"./ja": 131,
	"./ja.js": 131,
	"./jv": 132,
	"./jv.js": 132,
	"./ka": 133,
	"./ka.js": 133,
	"./kk": 134,
	"./kk.js": 134,
	"./km": 135,
	"./km.js": 135,
	"./kn": 136,
	"./kn.js": 136,
	"./ko": 137,
	"./ko.js": 137,
	"./ku": 138,
	"./ku.js": 138,
	"./ky": 139,
	"./ky.js": 139,
	"./lb": 140,
	"./lb.js": 140,
	"./lo": 141,
	"./lo.js": 141,
	"./lt": 142,
	"./lt.js": 142,
	"./lv": 143,
	"./lv.js": 143,
	"./me": 144,
	"./me.js": 144,
	"./mi": 145,
	"./mi.js": 145,
	"./mk": 146,
	"./mk.js": 146,
	"./ml": 147,
	"./ml.js": 147,
	"./mn": 148,
	"./mn.js": 148,
	"./mr": 149,
	"./mr.js": 149,
	"./ms": 150,
	"./ms-my": 151,
	"./ms-my.js": 151,
	"./ms.js": 150,
	"./mt": 152,
	"./mt.js": 152,
	"./my": 153,
	"./my.js": 153,
	"./nb": 154,
	"./nb.js": 154,
	"./ne": 155,
	"./ne.js": 155,
	"./nl": 156,
	"./nl-be": 157,
	"./nl-be.js": 157,
	"./nl.js": 156,
	"./nn": 158,
	"./nn.js": 158,
	"./oc-lnc": 159,
	"./oc-lnc.js": 159,
	"./pa-in": 160,
	"./pa-in.js": 160,
	"./pl": 161,
	"./pl.js": 161,
	"./pt": 162,
	"./pt-br": 163,
	"./pt-br.js": 163,
	"./pt.js": 162,
	"./ro": 164,
	"./ro.js": 164,
	"./ru": 165,
	"./ru.js": 165,
	"./sd": 166,
	"./sd.js": 166,
	"./se": 167,
	"./se.js": 167,
	"./si": 168,
	"./si.js": 168,
	"./sk": 169,
	"./sk.js": 169,
	"./sl": 170,
	"./sl.js": 170,
	"./sq": 171,
	"./sq.js": 171,
	"./sr": 172,
	"./sr-cyrl": 173,
	"./sr-cyrl.js": 173,
	"./sr.js": 172,
	"./ss": 174,
	"./ss.js": 174,
	"./sv": 175,
	"./sv.js": 175,
	"./sw": 176,
	"./sw.js": 176,
	"./ta": 177,
	"./ta.js": 177,
	"./te": 178,
	"./te.js": 178,
	"./tet": 179,
	"./tet.js": 179,
	"./tg": 180,
	"./tg.js": 180,
	"./th": 181,
	"./th.js": 181,
	"./tl-ph": 182,
	"./tl-ph.js": 182,
	"./tlh": 183,
	"./tlh.js": 183,
	"./tr": 184,
	"./tr.js": 184,
	"./tzl": 185,
	"./tzl.js": 185,
	"./tzm": 186,
	"./tzm-latn": 187,
	"./tzm-latn.js": 187,
	"./tzm.js": 186,
	"./ug-cn": 188,
	"./ug-cn.js": 188,
	"./uk": 189,
	"./uk.js": 189,
	"./ur": 190,
	"./ur.js": 190,
	"./uz": 191,
	"./uz-latn": 192,
	"./uz-latn.js": 192,
	"./uz.js": 191,
	"./vi": 193,
	"./vi.js": 193,
	"./x-pseudo": 194,
	"./x-pseudo.js": 194,
	"./yo": 195,
	"./yo.js": 195,
	"./zh-cn": 196,
	"./zh-cn.js": 196,
	"./zh-hk": 197,
	"./zh-hk.js": 197,
	"./zh-mo": 198,
	"./zh-mo.js": 198,
	"./zh-tw": 199,
	"./zh-tw.js": 199
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 245;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyles = processStyles;

var _lodash = __webpack_require__(201);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(32);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Whitney SSm will be displayed in the SVG, but in the image export, the
// fonts prepended below ('Whitney SSm Regular') will be used.
var BASE_STYLE = {
  color: {
    background: '#fff',
    normal: '#333',
    light: '#666',
    hed: '#333',
    dek: '#666'
  },
  font: {
    light: 'sans-serif',
    normal: 'sans-serif',
    semibold: 'sans-serif',
    bold: 'sans-serif'
  },
  weight: {
    light: 300,
    normal: 400,
    semibold: 600,
    bold: 700
  },
  size: {
    small: '11px',
    normal: '13px',
    large: '16px',
    xlarge: '16px'
  },
  lineHeight: {
    small: '16px',
    normal: '16px',
    large: '20px',
    xlarge: '20px'
  },
  annotations: {},
  headline: {},
  title: {},
  description: {},
  notes: {},
  source: {},
  tick: {},
  axes: {
    zeroGridLine: {},
    label: {
      seriesAreNotDates: {},
      bar: {
        x: {},
        y: {}
      }
    }
  },
  legend: {},
  dataLabel: {}
};

function processStyles(options) {
  var STYLE = (0, _lodash2.default)({}, BASE_STYLE);
  var product = options.product,
      print = options.print,
      id = options.id;

  if (false) {
    if (product === 'wsj') {
      if (print) {
        STYLE.annotations.fontSize = 7.5;
        STYLE.annotations.lineHeight = 10;
        STYLE.axes.label.bar.x.fontSize = 7.5;
        STYLE.axes.label.bar.x.fontWeight = 'normal';
        STYLE.axes.label.bar.x.lineHeight = 7.5;
        STYLE.axes.label.bar.y.fontSize = 7.5;
        STYLE.axes.label.bar.y.fontWeight = 'normal';
        STYLE.axes.label.bar.y.lineHeight = 7.5;
        STYLE.axes.label.color = '#666';
        STYLE.axes.label.fontSize = 7.5;
        STYLE.axes.label.fontWeight = 400;
        STYLE.axes.label.lineHeight = 7.5;
        STYLE.axes.label.seriesAreNotDates.fontSize = 7;
        STYLE.axes.label.seriesAreNotDates.fontWeight = 'normal';
        STYLE.axes.label.seriesAreNotDates.lineHeight = 8;
        STYLE.axes.zeroGridLine.color = '#333';
        STYLE.color.dek = '#000';
        STYLE.color.hed = '#000';
        STYLE.color.normal = '#000';
        STYLE.description.color = '#000';
        STYLE.description.fontFamily = '"DJ5RetinaNr Medium",sans-serif';
        STYLE.description.fontSize = 8.4;
        STYLE.description.fontWeight = 400;
        STYLE.description.lineHeight = 10;
        STYLE.font.bold = '"DJ5RetinaNr Bold",' + STYLE.font.bold;
        STYLE.font.light = '"DJ5RetinaNr Light",' + STYLE.font.light;
        STYLE.font.normal = '"DJ5RetinaNr Medium",' + STYLE.font.normal;
        STYLE.font.semibold = '"DJ5RetinaNr Semibold",' + STYLE.font.bold;
        STYLE.headline.color = '#000';
        STYLE.headline.fontFamily = '"DJ5RetinaNr Bold",sans-serif';
        STYLE.headline.fontSize = 12.6;
        STYLE.headline.fontWeight = 'normal';
        STYLE.headline.lineHeight = 14.4;
        STYLE.legend.fontSize = 7.5;
        STYLE.legend.fontWeight = 400;
        STYLE.legend.lineHeight = 'inherit';
        STYLE.legend.rectHeight = 6;
        STYLE.legend.rectWidth = 4;
        STYLE.lineHeight.large = 9.6;
        STYLE.lineHeight.normal = 8;
        STYLE.lineHeight.small = 7.2;
        STYLE.lineHeight.xlarge = 14.4;
        STYLE.size.large = 8.4;
        STYLE.size.normal = 7.5;
        STYLE.size.small = 6;
        STYLE.size.xlarge = 12.6;
        STYLE.tick.color = '#333';
        STYLE.tick.longSize = 5;
        STYLE.tick.mediumSize = 4;
        STYLE.tick.shortSize = 2;
        STYLE.tick.yOffset = 1;
        STYLE.weight.bold = 'normal';
        STYLE.weight.light = 'normal';
        STYLE.weight.normal = 'normal';
        STYLE.weight.semibold = 'normal';
      } else {
        STYLE.annotations.fontSize = '15px';
        STYLE.annotations.fontWeight = 300;
        STYLE.annotations.lineHeight = 20;
        STYLE.annotations.color = '#333';
        STYLE.annotations.fontFamily = '"Retina", sans-serif';
        // STYLE.axes.label.fontFamily = '"Retina", "Retina Narrow"'
        STYLE.axes.label.bar.x.fontSize = '15px';
        STYLE.axes.label.bar.x.fontWeight = 500;
        STYLE.axes.label.bar.x.lineHeight = '16px';
        STYLE.axes.label.bar.y.fontSize = '13px';
        STYLE.axes.label.bar.y.fontWeight = 300;
        STYLE.axes.label.bar.y.lineHeight = 20;
        STYLE.axes.label.color = '#333';
        // weirdly breaks if I set below to '13px' in firefox
        STYLE.axes.label.fontSize = 13;
        STYLE.axes.label.fontWeight = 300;
        STYLE.axes.label.lineHeight = 20;
        STYLE.axes.label.seriesAreNotDates.fontSize = '15px';
        STYLE.axes.label.seriesAreNotDates.fontWeight = 500;
        STYLE.axes.label.seriesAreNotDates.lineHeight = 18;
        STYLE.axes.label.seriesAreNotDates.fontFamily = '"Retina", sans-serif';
        STYLE.axes.zeroGridLine.color = '#333';
        STYLE.description.color = '#333';
        STYLE.description.fontFamily = '"Retina", sans-serif';
        STYLE.description.fontSize = '15px';
        STYLE.description.fontWeight = 300;
        STYLE.description.lineHeight = 20;
        STYLE.font.bold = '"Retina",' + STYLE.font.bold;
        STYLE.font.light = '"Retina",' + STYLE.font.light;
        STYLE.font.normal = '"Retina",' + STYLE.font.normal;
        STYLE.font.semibold = '"Retina",' + STYLE.font.bold;
        STYLE.weight.bold = 500;
        STYLE.weight.light = 300;
        STYLE.weight.normal = 300;
        STYLE.weight.semibold = 500;
        STYLE.title.fontFamily = 'Retina Narrow';
        STYLE.title.fontSize = '13px';
        STYLE.headline.color = '#333';
        STYLE.headline.fontFamily = "Retina";
        STYLE.headline.fontSize = '18px';
        STYLE.headline.fontWeight = 500;
        STYLE.headline.lineHeight = '20px';
        STYLE.legend.fontSize = '15px';
        STYLE.dataLabel.fontSize = '15px';
        STYLE.dataLabel.lineHeight = '18px';
        STYLE.legend.fontWeight = 300;
        STYLE.legend.lineHeight = 18;
        STYLE.legend.rectHeight = 10;
        STYLE.legend.rectWidth = 10;
        STYLE.notes.lineHeight = 14;
        STYLE.source.lineHeight = 14;
        STYLE.source.fontWeight = 300;
        STYLE.tick.color = '#333';
        STYLE.tick.longSize = 7;
        STYLE.tick.mediumSize = 5;
        STYLE.tick.shortSize = 3;
        STYLE.tick.yOffset = 1.5;
        STYLE.weight.bold = 500;
        STYLE.weight.semibold = 500;
      }
      if (id === 'video') {
        STYLE.annotations.fontSize = '24px';
        STYLE.annotations.color = '#fff';
        STYLE.annotations.fontWeight = 400;
        STYLE.annotations.fontFamily = 'Retina Narrow';
        STYLE.color.background = '#222222';
        STYLE.color.hed = '#fff';
        STYLE.axes.label.color = '#fff';
        STYLE.color.normal = '#fff';
        STYLE.headline.color = '#fff';
        STYLE.headline.fontSize = '60px';
        STYLE.headline.fontFamily = 'Retina Narrow';
        STYLE.headline.fontWeight = 'bold';
        STYLE.description.fontFamily = 'Retina Narrow';
        STYLE.description.fontWeight = 400;
        STYLE.description.fontSize = '35px';
        STYLE.description.color = '#fff';
        STYLE.legend.fontSize = '35px';
        STYLE.legend.fontWeight = 400;
        STYLE.axes.label.fontSize = 32;
        STYLE.axes.zeroGridLine.color = '#656565';
        STYLE.axes.label.seriesAreNotDates.fontSize = '32px';
        STYLE.axes.label.seriesAreNotDates.fontWeight = 'normal';
        STYLE.axes.label.seriesAreNotDates.lineHeight = 15;
        STYLE.font.normal = 'Retina Narrow';
      }
      if (id === 'twitterVideo') {
        STYLE.annotations.fontSize = '18px';
        STYLE.annotations.color = '#fff';
        STYLE.annotations.fontWeight = 300;
        STYLE.annotations.fontFamily = 'Retina Narrow';
        STYLE.color.background = '#222222';
        STYLE.color.hed = '#fff';
        STYLE.axes.label.color = '#fff';
        STYLE.color.normal = '#fff';
        STYLE.headline.color = '#fff';
        STYLE.headline.fontSize = '50px';
        STYLE.headline.fontFamily = 'Retina Narrow';
        STYLE.headline.fontWeight = 'bold';
        STYLE.description.fontSize = '35px';
        STYLE.description.color = '#fff';
        STYLE.legend.fontSize = '35px';
        STYLE.legend.fontWeight = 400;
        STYLE.axes.label.fontSize = 30;
        STYLE.axes.zeroGridLine.color = '#656565';
        STYLE.axes.label.seriesAreNotDates.fontSize = '30px';
        STYLE.axes.label.seriesAreNotDates.fontWeight = 'normal';
        STYLE.axes.label.seriesAreNotDates.lineHeight = 15;
        STYLE.font.normal = 'Retina Narrow';
      }
    }
  }
  if (true) {
    if (product === 'barrons') {
      if (print) {
        STYLE.annotations.color = '#000';
        STYLE.annotations.fontSize = '12px';
        STYLE.color.normal = '#000000';
        STYLE.color.light = '#000000';
        STYLE.color.hed = '#000000';
        STYLE.color.dek = '#000000';
        STYLE.font.light = 'Aileron,' + STYLE.font.light;
        STYLE.font.normal = 'Aileron,' + STYLE.font.normal;
        STYLE.font.semibold = 'Aileron,' + STYLE.font.bold;
        STYLE.font.bold = 'Aileron,' + STYLE.font.bold;
        STYLE.size.small = '12px';
        STYLE.size.normal = '12px';
        STYLE.size.large = '9.5px';
        STYLE.size.xlarge = '14px';
        STYLE.lineHeight.large = '12.5px';
        STYLE.lineHeight.xlarge = '15.5px';
      } else {
        STYLE.annotations.color = '#6F7878';
        STYLE.annotations.fontSize = '14px';
        STYLE.annotations.lineHeight = 21;
        STYLE.annotations.fontFamily = 'Aileron,' + STYLE.font.normal;
        STYLE.annotations.fontWeight = 400;
        STYLE.color.normal = '#6F7878';
        STYLE.color.light = '#6F7878';
        STYLE.color.hed = '#001E20';
        STYLE.color.dek = '#001E20';
        STYLE.font.light = 'Aileron,' + STYLE.font.light;
        STYLE.font.normal = 'Aileron,' + STYLE.font.normal;
        STYLE.font.semibold = 'Aileron,' + STYLE.font.bold;
        STYLE.font.bold = 'Aileron,' + STYLE.font.bold;
        STYLE.title.fontFamily = 'Aileron';
        STYLE.title.fontSize = '13px';
        STYLE.size.small = '14px';
        STYLE.lineHeight.small = '18px';
        STYLE.size.normal = '14px';
        STYLE.lineHeight.normal = '21px';
        STYLE.size.large = '16px';
        STYLE.lineHeight.large = '21px';
        STYLE.size.xlarge = '22px';
        STYLE.lineHeight.xlarge = '24px';
      }
    }
  }
  // if (__ALL__ || __KNEWZ__) {
  if (product === 'knewz') {
    STYLE.annotations.color = '#6F7878';
    STYLE.annotations.fontSize = '14px';
    STYLE.annotations.lineHeight = 21;
    STYLE.annotations.fontFamily = 'Aileron,' + STYLE.font.normal;
    STYLE.annotations.fontWeight = 400;
    // STYLE.color.background = 'transparent';
    STYLE.color.normal = '#000000';
    STYLE.color.light = '#000000';
    STYLE.color.hed = '#000000';
    STYLE.legend.color = '#4A4A4A';
    STYLE.legend.fontWeight = 400;
    STYLE.legend.fontSize = '10px';
    STYLE.legend.lineHeight = '12px';
    STYLE.axes.label.fontSize = '12px';
    STYLE.axes.label.lineHeight = '16px';
    STYLE.color.dek = '#000000';
    STYLE.font.light = 'Ringside Condensed,' + STYLE.font.bold;
    STYLE.font.normal = 'Ringside Condensed,' + STYLE.font.bold;
    STYLE.font.semibold = 'Ringside Condensed,' + STYLE.font.bold;
    STYLE.font.bold = 'Ringside Condensed,' + STYLE.font.bold;
    STYLE.title.fontFamily = 'Ringside Condensed';
    STYLE.title.fontSize = '13px';
    STYLE.size.small = '14px';
    STYLE.lineHeight.small = '18px';
    STYLE.size.normal = '14px';
    STYLE.lineHeight.normal = '21px';
    STYLE.size.large = '16px';
    STYLE.lineHeight.large = '21px';
    STYLE.size.xlarge = '22px';
    STYLE.lineHeight.xlarge = '24px';
  }
  // }
  if (false) {
    if (product === 'financialnews') {
      STYLE.annotations.color = '#70808C';
      STYLE.annotations.fontSize = '12px';
      STYLE.annotations.lineHeight = '17px';
      STYLE.annotations.fontFamily = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
      STYLE.annotations.fontWeight = 400;
      STYLE.color.background = 'transparent';
      STYLE.color.normal = '#70808C';
      STYLE.color.light = '#70808C';
      STYLE.color.hed = '#005879';
      STYLE.color.dek = '#4D6172';
      STYLE.font.light = 'Theinhardt,TheinhardtRegular,' + STYLE.font.light;
      STYLE.font.normal = 'Theinhardt,TheinhardtRegular,' + STYLE.font.normal;
      STYLE.font.semibold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
      STYLE.font.bold = 'Theinhardt,TheinhardtBold,' + STYLE.font.bold;
      STYLE.size.small = '12px';
      STYLE.size.normal = '12px';
      STYLE.size.large = '16px';
      STYLE.size.xlarge = '24px';
      STYLE.title.fontFamily = 'Theinhardt,TheinhardtRegular';
      STYLE.title.fontSize = '13px';
      STYLE.lineHeight.small = '17px';
      STYLE.lineHeight.normal = '17px';
      STYLE.lineHeight.large = '22px';
      STYLE.lineHeight.xlarge = '28px';
    }
  }
  if (false) {
    if (product === 'marketwatch') {
      STYLE.font.light = 'Lato,' + STYLE.font.light;
      STYLE.font.normal = 'Lato,' + STYLE.font.normal;
      STYLE.font.semibold = 'Lato,' + STYLE.font.semibold;
      STYLE.font.bold = 'Lato,' + STYLE.font.bold;
      STYLE.font.axes = 'Lato,' + 'sans-serif';
      STYLE.title.fontFamily = 'Lato';
      STYLE.title.fontSize = '13px';
      STYLE.weight.light = 300;
      STYLE.weight.normal = 400;
      STYLE.weight.semibold = 700;
      STYLE.weight.bold = 900;
      STYLE.weight.axes = 700;
      STYLE.annotations.color = '#555';
      STYLE.annotations.fontSize = '13px';
      STYLE.annotations.lineHeight = '19px';
      STYLE.annotations.fontFamily = 'Lato,' + STYLE.font.normal;
      STYLE.annotations.fontWeight = 400;
      STYLE.color.normal = '#555';
      STYLE.color.dek = '#555';
      STYLE.color.light = '#555';
      STYLE.color.axes = '#555';
      STYLE.size.small = '13px';
      STYLE.size.axes = '13px';
      STYLE.size.normal = '13px';
      STYLE.size.large = '16px';
      STYLE.size.xlarge = '28px';
      STYLE.lineHeight.small = '19px';
      STYLE.lineHeight.normal = '19px';
      STYLE.lineHeight.large = '25px';
      STYLE.lineHeight.xlarge = '34px';
    }
  }
  if (product === 'mansionglobal') {
    STYLE.font.light = '"Whitney SSm Light","Whitney SSm",Whitney,' + STYLE.font.light;
    STYLE.font.normal = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
    STYLE.font.normal = '"Whitney SSm Book","Whitney SSm",Whitney,' + STYLE.font.normal;
    STYLE.font.semibold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.semibold;
    STYLE.font.bold = '"Whitney SSm Semi-Bold","Whitney SSm",Whitney,' + STYLE.font.bold;
    STYLE.title.fontFamily = 'Whitney SSm Regular","Whitney SSm",Whitney';
    STYLE.title.fontSize = '13px';
    STYLE.weight.light = 400;
    STYLE.weight.normal = 400;
    STYLE.weight.semibold = 600;
    STYLE.weight.semibold = 500;
    STYLE.weight.bold = 700;
    STYLE.color.light = '#666';
    STYLE.color.normal = '#333';
    STYLE.size.small = '14px';
    STYLE.size.normal = '14px';
    STYLE.size.large = '18px';
    STYLE.size.xlarge = '24px';
    STYLE.lineHeight.xlarge = '28px';
    STYLE.lineHeight.dek = '22px';
    STYLE.lineHeight.subdek = '22px';
    STYLE.notes.color = '#777';
    STYLE.axes.color = '#777';
    STYLE.legend.color = '#777';
    STYLE.annotations.color = '#777';
    STYLE.annotations.fontSize = '14px';
    STYLE.annotations.lineHeight = '16px';
    STYLE.annotations.fontFamily = '"Whitney SSm Regular","Whitney SSm",Whitney,' + STYLE.font.normal;
    STYLE.annotations.fontWeight = 400;
  }
  STYLE.base = {
    fontFamily: STYLE.font.normal,
    fontSize: STYLE.size.normal,
    fontWeight: STYLE.weight.normal,
    lineHeight: STYLE.lineHeight.normal,
    color: STYLE.color.normal
  };
  STYLE.get = function (size, options) {
    var sizeStyle = STYLE[size];
    return sizeStyle ? (0, _lodash4.default)({}, sizeStyle, options) : STYLE.base;
  };
  STYLE.small = STYLE.get('base', {
    fontSize: STYLE.size.small,
    lineHeight: STYLE.lineHeight.small
  });
  STYLE.normal = STYLE.get('base');
  STYLE.large = STYLE.get('base', {
    fontSize: STYLE.size.large,
    lineHeight: STYLE.lineHeight.large
  });
  STYLE.xlarge = STYLE.get('base', {
    fontSize: STYLE.size.xlarge,
    lineHeight: STYLE.lineHeight.xlarge
  });
  return STYLE;
}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(202);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.fonts = fonts;

var _webfontloader = __webpack_require__(261);

var _webfontloader2 = _interopRequireDefault(_webfontloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Preload fonts depending on product. If fonts are *not* preloaded, then
 * line breaks fail (because line breaks are determined with a fallback font).
 */
function fonts(options, complete) {
  var product = options.product,
      print = options.print;

  var info = fontsInfo(product, print);
  var interval = 0;
  if (info === true) {
    complete();
  } else {
    var status = window.__charts_fonts_status__ = (0, _typeof3.default)(window.__charts_fonts_status__) === 'object' ? window.__charts_fonts_status__ : {};

    var callbackComplete = function callbackComplete() {
      status[info.product] = 'complete';
      complete();
    };

    var checkComplete = function checkComplete() {
      if (status[info.product] === 'complete') {
        clearInterval(interval);
        complete();
      }
    };

    var checkQueued = function checkQueued() {
      if (!areFontsLoading()) {
        clearInterval(interval);
        if (status[info.product] === 'complete') {
          complete();
        } else {
          status[info.product] = 'loading';
          _webfontloader2.default.load({
            custom: info,
            active: callbackComplete,
            inactive: callbackComplete
          });
        }
      }
    };

    if (status[info.product] === 'loading') {
      interval = setInterval(checkComplete, 1);
    } else if (status[info.product] === 'complete') {
      complete();
    } else {
      interval = setInterval(checkQueued, 1);
    }
  }
}

function areFontsLoading() {
  var status = window.__charts_fonts_status__;
  if (status) {
    var keys = Object.keys(status);
    for (var i = 0; i < keys.length; i++) {
      if (status[keys[i]] === 'loading') {
        return true;
      }
    }
  }
  return false;
}

function fontsInfo(product) {
  var print = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (false) {
    if (product === 'wsj') {
      if (print) {
        return {
          product: 'wsj-print',
          families: [
          // 'Retina Standard Narrow:n3,n4,n6',
          // 'DJ5EscrowCond:n6'
          'DJ5RetinaNr Light', 'DJ5RetinaNr Medium', 'DJ5RetinaNr Semibold', 'DJ5RetinaNr Bold', 'DJ5RetinaAgReg Medium', 'DJ5EscrowCond'],
          urls: ['/assets/css/wsj-print.css']
        };
      } else {
        return {
          product: product,
          families: ['Retina', 'Retina Narrow'],
          urls: ['https://www.wsj.com/fonts/retina.css']
        };
      }
    }
  }
  if (true) {
    if (product === 'barrons') {
      return {
        product: product,
        families: ['Aileron'],
        urls: ['https://www.barrons.com/fonts/Aileron.css']
      };
    }
  }
  if (false) {
    if (product === 'financialnews') {
      return {
        product: product,
        families: ['Publico:n6', 'Theinhardt:n3,n4,n6'],
        urls: ['https://fonts.wsj.net/PublicoMedium.css', 'https://s3.amazonaws.com/fonts.wsj.net/Theinhardt.css']
      };
    }
  }
  if (false) {
    if (product === 'marketwatch') {
      return {
        product: product,
        families: ['Lato'],
        urls: ['https://fonts.googleapis.com/css?family=Lato:400,700,900']
      };
    }
  }
  if (false) {
    if (product === 'mansionglobal') {
      return {
        product: product,
        families: ['Whitney SSm A:n4,n6,n7'],
        urls: ['https://www.mansionglobal.com/fonts/442807/457709E0582EC35B6.css']
      };
    }
  }
  // if (__ALL__ || __KNEWZ__) {
  if (product === 'knewz') {
    return {
      product: product,
      families: ['Ringside Condensed'],
      urls: ['https://knewz.com/wp-content/themes/wp-knewz-theme/knewz-fonts.css']
    };
  }
  // }
  return true;
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(250), __esModule: true };

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(23);
__webpack_require__(25);
module.exports = __webpack_require__(51).f('iterator');


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(252), __esModule: true };

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(253);
__webpack_require__(205);
__webpack_require__(259);
__webpack_require__(260);
module.exports = __webpack_require__(5).Symbol;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(1);
var has = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(9);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(59);
var META = __webpack_require__(254).KEY;
var $fails = __webpack_require__(27);
var shared = __webpack_require__(42);
var setToStringTag = __webpack_require__(29);
var uid = __webpack_require__(28);
var wks = __webpack_require__(2);
var wksExt = __webpack_require__(51);
var wksDefine = __webpack_require__(52);
var enumKeys = __webpack_require__(255);
var isArray = __webpack_require__(256);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(12);
var toObject = __webpack_require__(44);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(37);
var createDesc = __webpack_require__(22);
var _create = __webpack_require__(60);
var gOPNExt = __webpack_require__(257);
var $GOPD = __webpack_require__(258);
var $GOPS = __webpack_require__(203);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(38);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(204).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(53).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(20)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(28)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(13);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(27)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(203);
var pIE = __webpack_require__(53);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(19);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(17);
var gOPN = __webpack_require__(204).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(53);
var createDesc = __webpack_require__(22);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(37);
var has = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(58);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('asyncIterator');


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52)('observable');


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Z}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(206);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _spacing = __webpack_require__(266);

var _spacing2 = _interopRequireDefault(_spacing);

var _headlines = __webpack_require__(267);

var headlines = _interopRequireWildcard(_headlines);

var _notes = __webpack_require__(268);

var notes = _interopRequireWildcard(_notes);

var _element = __webpack_require__(15);

var element = _interopRequireWildcard(_element);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Outer Chart renders headlines, footnotes, and credits.
 */
var MARGIN = 12;
var BARRONS_PRINT_MARGIN = 0;

function preRender(options) {
  // const hasAccessibility = options.headings.accessibilityDescription.text;
  // const  defaultDescription = hasAccessibility ? hasAccessibility : options.headings.subdek.text || options.headings.title.text;

  var data = {
    exporting: {
      enabled: false
    },
    // accessibility: {
    //   description: defaultDescription
    // },
    chart: (0, _defineProperty3.default)({
      renderTo: options.el.querySelector('.dj-chart-container'),
      width: options.width,
      height: options.height,
      reflow: false,
      backgroundColor: 'transparent'
    }, 'backgroundColor', options.styles.color.background),
    title: { text: null },
    subtitle: { text: null },
    credits: { enabled: false },
    navigator: { enabled: false }
  };
  if (options.size.indexOf('thumb') !== 0) {
    data.chart.spacing = (0, _spacing2.default)(options);
    data = headlines.preRender(data, options);
    data = notes.preRender(data, options);
  }
  return data;
}

function postRender(highchart, options) {
  if (options.size.indexOf('thumb') === 0) {
    return {
      innerEl: createInnerEl(highchart, options),
      x: 0,
      y: 0,
      width: options.width,
      height: options.height,
      info: null
    };
  } else {
    if (false) {
      if (options.size === 'print-wsj') {
        highchart.renderer.rect(0, 3.2, options.width, 0.5, 0).attr({
          'fill': '#000'
        }).add();
        // let y = 0;
        // while (y < options.height) {
        //   highchart.renderer.rect(0, y, options.width, 0.5, 0)
        //     .attr({
        //       'fill': 'rgba(255, 0, 0, 0.25)',
        //     })
        //     .add();
        //   y += 9.6;
        // }
      }
    }
    var isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
    var info = {
      headlines: headlines.postRender(highchart, options),
      notes: notes.postRender(highchart, options)
    };
    var margin = void 0;
    if (options.size === 'print-wsj' || info.headlines.y <= 0) {
      margin = 0;
    } else if (options.id === 'print-barrons') {
      margin = BARRONS_PRINT_MARGIN;
    } else {
      margin = MARGIN;
    }
    var heightOffset = options.id === 'print-barrons' ? 12 : 0;
    return {
      innerEl: createInnerEl(highchart, options),
      x: highchart.spacing[3],
      y: info.headlines.y + margin,
      width: options.width - highchart.spacing[1] - highchart.spacing[3],
      height: info.notes.y - info.headlines.y - margin + heightOffset,
      spacing: [0, 0, 0, 0],
      info: info
    };
  }
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    var updateH = headlines.renderInvalidated(rendered, options, invalidated);
    var updateN = notes.renderInvalidated(rendered, options, invalidated);
    var margin = rendered.outerInfo.info && rendered.outerInfo.info.headlines.y > 0 ? MARGIN : 0;
    if (__WSJ__) {
      margin = options.size === 'print-wsj' ? 0 : margin;
    }
    if (updateH) {
      rendered.outerInfo.y += margin;
    }
    if (updateH || updateN) {
      rendered.outerInfo.height = 0;
      if (rendered.outerInfo.info) {
        rendered.outerInfo.height = rendered.outerInfo.info.notes.y - rendered.outerInfo.info.headlines.y - margin;
      }
    }
  }
}

function getTopHeight(highchart, options) {
  var svg = options.el.querySelector('svg');
  var svgY = svg.getBoundingClientRect().top;
  if (highchart.subtitle) {
    var srect = highchart.subtitle.element.getBoundingClientRect();
    return srect.top - svgY + srect.height;
  } else if (highchart.title) {
    var trect = highchart.title.element.getBoundingClientRect();
    return trect.top - svgY + trect.height;
  }
  return highchart.spacing[0];
}

function getBottomHeight(highchart, options) {
  return highchart.spacing[2];
}

// Cleans up the outer SVG, removing unnecessary `g` elements, and creates a
// `g` element specifically for the inner chart SVG.
function createInnerEl(highchart, options) {
  var svg = options.el.querySelector('svg');
  if (svg) {
    var gEls = svg.querySelectorAll('g');
    for (var i = 0; i < gEls.length; i++) {
      element.removeChild(gEls[i]);
    }
    return highchart.renderer.g('djchart').add().element;
  }
  return null;
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(264), __esModule: true };

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(265);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function spacing(options) {
  switch (options.size) {
    case 'fon':
      return [30, 15, 0, 15];
    case 'soc':
      return [10, 10, 10, 10];
    case 'appfeed':
      return [3, 0, 3, 0];
    case 'video':
      return [120, 220, 140, 120];
    case 'twitterVideo':
      return [40, 60, 60, 60];
  }

  var left = options.type === 'scatter' ? 1 : 0;
  if (options.product === 'knewz') {
    return [10, 10, 10, 10];
  }
  return [0, 0, 0, 0];
}

exports.default = spacing;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _textRules = __webpack_require__(207);

var _textRules2 = _interopRequireDefault(_textRules);

var _util = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRINT_LINE = 9.6;

function preRender(data, options) {
  return data;
}

function postRender(highchart, options) {
  var R = getRules(options);
  var result = {
    hed: null,
    dek: null,
    subdek: null,
    x: highchart.spacing[3],
    y: highchart.spacing[0],
    width: options.width - highchart.spacing[3] - highchart.spacing[1] + 'px'
  };
  if (R.HED) {
    writeHed(options, highchart.renderer, R.HEADINGS.title.text, result);
  }
  if (R.HED && R.DEK || R.HED && R.SUBDEK) {
    result.y += getMargin(options, true);
    if (options.product === 'wsj' && !options.print) result.y -= 3;
  }
  if (R.DEK) {
    writeDek(options, highchart.renderer, R.HEADINGS.dek.text, result, R);
  }
  if (R.HED && R.DEK && R.SUBDEK || R.DEK && R.SUBDEK) {
    result.y += getMargin(options, false);
    if (options.product === 'wsj' && !options.print) result.y += 9;
  }
  if (R.SUBDEK && !R.RULE.subdekPromo) {
    writeChartLabel(options, highchart.renderer, R.HEADINGS.subdek.text, result, R);
  }
  if (R.SUBDEKPROMO) {
    writeChartLabel(options, highchart.renderer, R.HEADINGS.subdekPromo.text, result, R);
  }
  if (R.WSJ_PRINT) {
    result.y = Math.max(result.y, PRINT_LINE);
  }
  return result;
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    if (!rendered.outerInfo.info) {
      return false;
    }
    var R = getRules(options);
    var result = rendered.outerInfo.info.headlines;
    var invalidHed = invalidated.indexOf('headings/title') !== -1;
    var invalidDek = invalidated.indexOf('headings/dek') !== -1 || R.DEK && invalidHed && !result.hed;

    if ((invalidHed || invalidDek) && !!rendered.outer.spacing) {
      result.y = rendered.outer.spacing[0];

      // If previously there was no HED but now there is, rewrite the DEK to
      // force the face to change from bold to normal.
      var invalidDek2 = R.DEK && invalidHed && !result.hed;

      if (invalidHed) {
        (0, _util.removeEl)(result.hed);
        if (R.HED) {
          writeHed(options, rendered.outer.renderer, R.HEADINGS.title.text, result);
        } else {
          result.hed = null;
        }
      } else if (result.hed) {
        result.y = result.hed.bottom;
      }

      if (R.HED && R.DEK) {
        result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
      }

      if (invalidDek) {
        (0, _util.removeEl)(result.dek);
        if (R.DEK) {
          writeDek(options, rendered.outer.renderer, R.HEADINGS.dek.text, result, R.HED);
        } else {
          result.dek = null;
        }
      } else if (result.dek) {
        if (result.y !== result.dek.y) {
          var delta = result.y - result.dek.y;
          if (result.dek.el) {
            var nowY = +result.dek.el.element.getAttribute('y');
            result.dek.el.element.setAttribute('y', nowY + delta);
          }
          result.dek.y += delta;
          result.dek.bottom += delta;
        }
        result.y = result.dek.bottom;
      }

      rendered.outerInfo.y = result.y;
      if (R.WSJ_PRINT) {
        rendered.outerInfo.y = Math.max(rendered.outerInfo.y, PRINT_LINE);
      }
      return true;
    }
    return false;
  }
}

function getRules(options) {
  var RULE = (0, _textRules.getBestRule)(options.size);
  var HEADINGS = options.headings;
  var HED = HEADINGS.title.text && HEADINGS.title.enabled && RULE.title;
  var DEK = HEADINGS.dek.text && HEADINGS.dek.enabled && RULE.dek;
  var SUBDEK = HEADINGS.subdek.text && HEADINGS.subdek.enabled && RULE.subdek;
  var SUBDEKPROMO = HEADINGS.subdekPromo.text && HEADINGS.subdekPromo.enabled && RULE.subdekPromo;
  var WSJ_PRINT = options.size === 'print-wsj';
  return { RULE: RULE, HEADINGS: HEADINGS, HED: HED, DEK: DEK, SUBDEK: SUBDEK, SUBDEKPROMO: SUBDEKPROMO, WSJ_PRINT: WSJ_PRINT };
}

function writeHed(options, renderer, text, result) {
  var css = getCss(options, 'hed', result.width);
  var wsjPrint = false;
  if (false) {
    if (wsjPrint = options.size === 'print-wsj') {
      result.y = PRINT_LINE * 2;
    }
  }
  var financialnewsFirstLetterJ = false;
  if (false) {
    if (text.charAt(0) === "J") {
      financialnewsFirstLetterJ = true;
    }
  }

  var _ref = options.id === 'video' || options.id === 'twitterVideo' ? [text.toUpperCase(), options.legend.enabled ? 0 : 15] : [text, 0],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      formattedText = _ref2[0],
      offset = _ref2[1];

  var obj = writeText(financialnewsFirstLetterJ, renderer, formattedText, result.x, result.y, css, wsjPrint, 'charts-headline', options.id);
  result.hed = {
    x: result.x,
    y: result.y,
    width: result.width,
    offsetY: obj.offsetY,
    bottom: obj.bottom,
    el: obj.el
  };
  result.y = obj.bottom + offset;
}

function writeDek(options, renderer, text, result, rules) {
  var financialnewsFirstLetterJ = false;
  if (false) {
    if (!rules.HED && options.size === 'print-wsj') {
      result.y = PRINT_LINE;
    }
  }
  var css = getCss(options, 'dek', result.width);
  if (options.product === 'mansionglobal') {
    css.lineHeight = options.styles.lineHeight.dek;
  }
  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek');
  result.dek = {
    x: result.x,
    y: result.y,
    width: result.width,
    offsetY: obj.offsetY,
    bottom: obj.bottom,
    el: obj.el
  };
  var offset = options.id === 'video' || options.id === 'twitterVideo' ? 30 : 0;
  result.y = obj.bottom + offset;
}

function writeChartLabel(options, renderer, text, result, rules) {
  var financialnewsFirstLetterJ = false;
  if (false) {
    if (!rules.HED && !rules.DEK && options.size === 'print-wsj') {
      result.y = PRINT_LINE;
    }
  }
  var css = getCss(options, 'subdek', result.width, rules);
  if (options.product === 'mansionglobal') {
    css.lineHeight = options.styles.lineHeight.subdek;
    css.fontWeight = options.styles.weight.semibold;
  }
  var obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek', options.id, options.legend.enabled);
  result.chartLabel = {
    x: result.x,
    y: result.y,
    width: result.width,
    offsetY: obj.offsetY,
    bottom: obj.bottom,
    el: obj.el
  };
  result.y = obj.bottom;
}

function getCss(options, headline, width, rules) {
  var size = headline === 'hed' ? 'xlarge' : 'large';
  var type = headline === 'dek' ? headline : 'hed';
  var boldSubdek = headline === 'subdek' && (rules.DEK || !rules.HED && !rules.DEK);
  var subdekSameAsDek = headline === 'subdek' && rules.HED && rules.SUBDEK && !rules.DEK;
  var weight = boldSubdek ? 'bold' : 'normal';
  var fontFamily = options.styles.font.normal;
  var fontWeight = options.styles.weight[weight];
  var color = options.styles.color[type];
  // HED
  if (headline === 'hed') {
    if (options.product === 'financialnews') {
      fontFamily = '"Publico Text","Publico"';
      fontWeight = options.styles.weight.bold;
    } else if (options.product === 'marketwatch') {
      color = '#666F7D';
      fontFamily = options.styles.font.bold;
      fontWeight = options.styles.weight.bold;
    } else if (options.product === 'mansionglobal') {
      fontFamily = '"Whitney SSm Medium", "Whitney SSm"';
      fontWeight = options.styles.weight.semibold;
    } else if (options.product === 'heatstreet') {
      fontFamily = options.styles.font.semibold;
      fontWeight = options.styles.weight.semibold;
    } else if (options.product === 'barrons') {
      fontFamily = options.styles.font.bold;
      fontWeight = options.styles.weight.bold;
    } else if (options.product === 'knewz') {
      fontWeight = 700;
    }
  }
  if (headline === 'subdek' && options.product === 'knewz') {
    if (options.headings.title.text) {
      fontWeight = 500;
    } else {
      fontWeight = 700;
    }
  }

  var css = options.styles.get(size, {
    fontFamily: fontFamily,
    fontWeight: fontWeight,
    color: color,
    width: width
  });

  if (options.id === 'print-barrons') {
    switch (headline) {
      case 'hed':
        css.fontWeight = 700;
        break;
      case 'dek':
        css.fontWeight = 700;
        break;
      case 'subdek':
        css.fontSize = '7.5px';
        css.fontWeight = 300;
        css.lineHeight = '9px';
        break;
    }
  }

  if (false) {
    if (options.product === 'wsj') {
      var prop = headline === 'hed' ? 'headline' : 'description';
      var colorProp = type === 'dek' ? 'description' : 'headline';
      var printSubdek = options.print && headline === 'subdek';
      css.fontFamily = printSubdek && boldSubdek ? options.styles.headline.fontFamily : options.styles[prop].fontFamily;
      css.color = options.id === 'appfeed' ? '#222' : options.styles[colorProp].color;
      css.fontSize = headline === 'subdek' && !options.print ? '15px' : options.styles[prop].fontSize;
      if (options.size === 'appfeed') {
        css.fontSize = headline === 'subdek' ? '16px' : options.styles[prop].fontSize;
      }
      css.fontWeight = headline === 'subdek' ? css.fontWeight : options.styles[prop].fontWeight;
      css.lineHeight = options.styles[prop].lineHeight;

      if (subdekSameAsDek && headline === 'subdek') {
        css.fontSize = options.styles['description'].fontSize;
        css.lineHeight = options.styles['description'].lineHeight;
        css.fontWeight = options.styles['description'].fontWeight;
        css.color = options.styles['description'].color;
      }
    }
  }
  return css;
}

// Renders a generic block of text (either hed, dek or subdek) and returns the element
// and its bottom y.
function writeText(financialnewsFirstLetterJ, renderer, text, x, y, css) {
  var skipOffsetY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var className = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var id = arguments[8];
  var legendEnabled = arguments[9];

  var offsetY = void 0;
  if (skipOffsetY) offsetY = 0;else offsetY = parseInt(css.fontSize, 10);
  var addOffset = offsetY;
  if (legendEnabled) {
    if (id === 'D') addOffset = 2;
    if (id === 'appfeed') addOffset = 12;
  }
  if (financialnewsFirstLetterJ) {
    x = 3;
  };
  var el = renderer.text(text).css(css).attr({ x: x, y: y + offsetY, class: className }).add();
  var tspan = el.element.querySelectorAll('tspan');
  var lines = tspan && tspan.length ? tspan.length : 1;
  var lineHeight = parseInt(css.lineHeight, 10);
  var bottom = y + addOffset + lineHeight * (lines - 1);
  return { el: el, offsetY: offsetY, bottom: bottom };
}

function getMargin(options, hed) {
  switch (options.id) {
    case 'print-wsj':
      return hed ? 4 : 7;
    case 'print-barrons':
      return hed ? 3.5 : 2;
    default:
      return hed ? 8 : 14;
  }
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _textRules = __webpack_require__(207);

var _textRules2 = _interopRequireDefault(_textRules);

var _util = __webpack_require__(208);

var _constants = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function preRender(data, options) {
  return data;
}

function postRender(highchart, options) {
  var R = getRules(options);
  var renderer = highchart.renderer;
  var result = {
    tagline: null,
    source: null,
    note: null,
    date: null,
    x: highchart.spacing[3],
    y: getStartY(highchart, options),
    width: options.width - highchart.spacing[3] - highchart.spacing[1] + 'px'
  };
  var sText = R.headings.source.text;
  var nText = R.headings.note.text;
  var spText = R.headings.sourcePromo.text;
  var npText = R.headings.notePromo.text;

  var sourceText = getText(options.id, sText);
  var noteText = getText(options.id, nText);
  var sourcePromoText = getText(options.id, spText);
  var notePromoText = getText(options.id, npText);
  if (R.tagline) {
    var wsjPrintTagline = isWsjPrintTagline(options.size, 'tagline');
    var taglineAlign = getTaglineAlign(options);
    if (wsjPrintTagline) {
      result.y = options.height;
    }
    result = writeSection(R.headings, options, 'tagline', renderer, R.headings.tagline.text, result, taglineAlign);
    if (wsjPrintTagline) {
      result.y = options.height - 9.2;
    }
  }
  if (R.source && !R.rule.sourcePromo) {
    result = writeSection(R.headings, options, 'source', renderer, sourceText, result, getSourceAlign(options));
  }
  if (R.note && !R.rule.notePromo) {
    result = writeSection(R.headings, options, 'note', renderer, noteText, result, getNoteAlign(options));
  }
  if (R.sourcePromo) {
    result = writeSection(R.headings, options, 'source', renderer, sourcePromoText, result, getSourceAlign(options));
  }
  if (R.notePromo) {
    result = writeSection(R.headings, options, 'note', renderer, notePromoText, result, getNoteAlign(options));
  }
  if (R.date) {
    result = writeSection(R.headings, options, 'date', renderer, R.headings.date.text, result, 'right');
  }

  return result;
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    var invalidSections = {};
    ['tagline', 'source', 'note', 'date'].forEach(function (section) {
      return invalidSections[section] = invalidated.includes('headings/' + section);
    });
    // const invalidTagline = invalidated.indexOf('headings/tagline') !== -1;
    // const invalidSource = invalidated.indexOf('headings/source') !== -1;
    // const invalidNote = invalidated.indexOf('headings/note') !== -1;
    if (Object.values(invalidSections).includes(true)) {
      var _R = getRules(options);
      var _renderer = rendered.outer.renderer;
      var _info = rendered.outerInfo.info;
      if (!_info) return true;
      _info = _info.notes;
      _info.y = getStartY(rendered.outer, options);

      var taglineAlign = getTaglineAlign(options);
      if (invalidSections.tagline) {
        (0, _util.removeEl)(_info.tagline);
        if (_R.tagline) {
          _info = writeSection(_R.headings, options, 'tagline', _renderer, _R.headings.tagline.text, _info, taglineAlign);
        } else {
          _info.tagline = null;
        }
      } else if (_info.tagline) {
        _info.y = _info.tagline.top;
      }
      ['source', 'note', 'date'].forEach(function (section) {
        return invalidSection(section, invalidSections[section]);
      });
      return true;
    }
    return false;
  }
}

function invalidSection(type, isInvalid) {
  if (isInvalid) {
    (0, _util.removeEl)(info[type]);
    if (R[type]) {
      info = writeSection(R.headings, options, type, renderer, R.headings[type].text, info);
    } else {
      info[type] = null;
    }
  } else if (info[type]) {
    if (info.y !== info[type].y) {
      var delta = info.y - info[type].y;
      if (info[type].el) {
        var nowY = +info[type].el.element.getAttribute('y');
        info[type].el.element.setAttribute('y', nowY + delta);
      }
      info[type].y += delta;
      info[type].top += delta;
    }
    info.y = info[type].top;
  }
}

function getRules(options) {
  var rule = (0, _textRules.getBestRule)(options.size);
  var headings = options.headings;

  var rules = { rule: rule, headings: headings };
  ['tagline', 'source', 'note', 'date', 'notePromo', 'sourcePromo'].forEach(function (section) {
    var _headings$section = headings[section],
        text = _headings$section.text,
        enabled = _headings$section.enabled;

    rules[section] = text && enabled && rule[section];
  });
  return rules;
}

function writeSection(headings, options, section, renderer, text, result) {
  var align = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'left';

  result[section] = {
    x: result.x,
    y: result.y,
    width: result.width,
    top: result.y,
    el: null
  };
  var obj = writeText(options, renderer, text, result, align, section);
  result[section].el = obj.el;
  result[section].top = obj.top;
  result.y = obj.top;
  if ((section === 'source' || section === 'note') && options.product === 'wsj' && !options.print) {
    if (result.note && !headings.source.text) result.y -= 3;
    if (!headings.note.text && result.source) result.y -= 3;
    if (headings.note.text && headings.source.text && section === 'source') {
      result.y -= 1;
    }
  }
  if (options.id === 'video') {
    result.y -= 28;
  }
  if (options.id === 'twitterVideo') {
    if (!headings.note.text) result.y -= 28;else result.y -= 6;
  }
  if (section === 'date') {
    var isWsjSmall = options.id === 'appfeed' || options.id === 'E' || options.id === 'D';
    var wsjOffset = isWsjSmall ? 0 : 9;
    var offset = options.product === 'wsj' ? wsjOffset : 2;
    result.y += offset;
  }

  return result;
}

// Renders a generic block of text (tagline or source) and returns the element
// and its top y.
function writeText(options, renderer, text, result) {
  var align = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'left';
  var section = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

  var offsetTagline = options.print ? 1 : 0;
  var css = options.styles.get('small', {
    width: result.width
  });
  if (options.product === 'wsj' && !options.print) {
    css.fontSize = '13px';
    css.lineHeight = 17;
  }
  if (options.id === 'video' || options.id === 'twitterVideo') {
    css.fontSize = '24px';
    css.fontFamily = 'Retina Narrow';
    css.color = '#CCC';
    css.fontWeight = 500;
  }
  if (options.product === 'mansionglobal') {
    css.color = options.styles.notes.color;
  }
  if (options.product === 'knewz') {
    css.fontWeight = 900;
    css.color = '#8C8C8C';
  }
  if (false) {
    if (isWsjPrintTagline(options.size, section)) {
      css.fontFamily = "'DJ5EscrowCond Semibold'";
      css.fontSize = 6.6;
    } else if (options.size === 'print-wsj') {
      css.fontFamily = "'DJ5RetinaAgReg Medium'";
    }
    if (options.product === 'wsj' && (section === 'source' || section === 'note')) {
      css.color = '#666';
    }
  }
  if (options.id === 'print-barrons') {
    css.fontSize = 6;
  }
  if (section === 'date' && options.product === 'wsj') {
    css.fontFamily = 'Retina Narrow';
  }

  var resultY = options.id === 'twitterVideo' ? 477 : result.y - offsetTagline;
  var resultX = getResultX(options, align, result);
  var el = renderer.text(text).css(css).attr({
    x: resultX,
    y: resultY,
    align: align
  }).add();

  var lines = el.element.querySelectorAll('tspan').length;
  var lineHeight = parseFloat(css.lineHeight);
  var height = lines * lineHeight;
  var yPx = result.y;
  if (lines > 1) {
    yPx = +el.element.getAttribute('y');
    yPx -= (lines - 1) * lineHeight;
    el.element.setAttribute('y', yPx);
  }
  return {
    el: el,
    y: yPx,
    top: yPx - lineHeight
  };
}

function getSourceAlign(options) {
  return options.product === 'marketwatch' || options.id === 'print-barrons' ? 'right' : 'left';
}

function getNoteAlign(options) {
  switch (options.id) {
    case 'print-barrons':
    case 'twitterVideo':
      return 'right';
    default:
      'left';
  }
}

function getTaglineAlign(options) {
  if (false) {
    if (options.size === 'print-wsj') {
      return options.sizes['print-wsj'].columns >= 2 ? 'right' : 'left';
    } else {
      return options.width > _constants.MAX_4U_WIDTH ? 'right' : 'left';
    }
  }
  if (true) {
    return options.width > _constants.MAX_4U_WIDTH ? 'right' : 'left';
  }
}

function getStartY(highchart, options) {
  return options.height - highchart.spacing[2] - yOffset(options);
}

// Lifts text just enough so that bottom line shows tails.
function yOffset(options) {
  return Math.round((parseFloat(options.styles.lineHeight.small) - parseFloat(options.styles.size.small)) * 0.5);
}

function isWsjPrintTagline(size, section) {
  if (false) {
    return size === 'print-wsj' && section === 'tagline';
  }
  return false;
}

function getResultX(options, align, result) {
  if (options.id === 'twitterVideo' && align === 'right') return parseFloat(result.width) + 60;
  if (align === 'left') return result.x;
  return parseFloat(result.width);
}

function getText(id, text) {
  return (id === 'twitterVideo' || id === 'video') && text ? text.toUpperCase() : text;
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _spacing = __webpack_require__(270);

var _chart = __webpack_require__(271);

var chart = _interopRequireWildcard(_chart);

var _legend = __webpack_require__(277);

var legend = _interopRequireWildcard(_legend);

var _tooltips = __webpack_require__(278);

var tooltips = _interopRequireWildcard(_tooltips);

var _axes = __webpack_require__(279);

var axes = _interopRequireWildcard(_axes);

var _recessions = __webpack_require__(210);

var recessions = _interopRequireWildcard(_recessions);

var _defs = __webpack_require__(54);

var defs = _interopRequireWildcard(_defs);

var _annotationsPrerender = __webpack_require__(209);

var annotationsPre = _interopRequireWildcard(_annotationsPrerender);

var _annotationsPostrender = __webpack_require__(287);

var annotationsPost = _interopRequireWildcard(_annotationsPostrender);

var _plotLinesPostrender = __webpack_require__(288);

var plotLines = _interopRequireWildcard(_plotLinesPostrender);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * The Inner Chart renders the actual chart sans headlines or footnotes.
 */
function preRender(options) {
  // const hasAccessibility = options.headings.accessibilityDescription.text;
  // const  defaultDescription = hasAccessibility ? hasAccessibility : options.headings.subdek.text || options.headings.title.text;
  var isVideo = options.id === 'video' || options.id === 'twitterVideo';

  var data = {
    exporting: {
      enabled: false
    },
    // accessibility: {
    //   description: defaultDescription
    // },
    series: options.series,
    chart: {
      reflow: false,
      type: options.type,
      width: options.width,
      height: options.height,
      style: isVideo ? JSON.stringify(options.styles.base) : options.styles.base,
      renderTo: options.el.querySelector('.dj-chart-inner'),
      backgroundColor: 'transparent',
      panning: false
      // backgroundColor: 'rgba(255, 0, 0, 0.1)'
    },
    credits: { enabled: false },
    title: { text: null },
    legend: { enabled: false },
    annotations: [],
    defs: {},
    plotOptions: {},
    xAxis: {},
    yAxis: {}
  };
  if (options.irregularDates) {
    data.scrollbar = { enabled: false };
    data.rangeSelector = { enabled: false };
    data.navigator = { enabled: false };
  }
  data.chart.spacing = (0, _spacing.chartSpacing)(options);
  var isSmallMW = options.product === 'marketwatch' && (options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT' || options.size === 'thumb-marketwatch-MA');
  // only invoke addSpaceForAnnotations for charts that can't be found in isSmallMW variable
  // if (!isSmallMW) {
  //   data.chart.spacing = addSpaceForAnnotations(data.chart.spacing, options);
  // }

  data.plotOptions[options.type] = {};
  data = chart.preRender(data, options);
  var isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
  if (isZR || options.size.indexOf('thumb') === 0) {
    data.plotOptions.series = data.plotOptions.series || {};
    data.plotOptions.series.enableMouseTracking = false;
    data.xAxis.labels = data.xAxis.labels || {};
    data.yAxis.labels = data.yAxis.labels || {};
    data.yAxis.labels.enabled = false;
    if (isZR) data.xAxis.labels.enabled = false;
    data.xAxis.tickWidth = 0;
    data.yAxis.title = data.yAxis.title || {};
    data.yAxis.title.text = '';
    data.yAxis.gridLineWidth = data.xAxis.gridLineWidth = 0;
    data.xAxis.lineWidth = 0;
    data.chart.spacingTop = 0;
  } else {
    data = legend.preRender(data, options);
    data = tooltips.preRender(data, options);
    data = axes.preRender(data, options);
    data = recessions.preRender(data, options);
    if (options.annotations.length) {
      defs.preRender(data, options);
      annotationsPre.preRender(data, options);
    }
  }
  if (options.size === 'marketwatch-ZT') {
    data.xAxis.labels.enabled = false;
    data.chart.spacingBottom = 20;
  }
  if (options.irregularDates) {
    data.xAxis.crosshair = { width: 0 };
    data.yAxis.showLastLabel = true;
  }
  return data;
}

function postRender(highchart, options) {
  chart.postRender(highchart, options);
  var isZR = options.product === 'marketwatch' && options.size === 'marketwatch-ZR';
  if (options.size.indexOf('thumb') === 0 || isZR || options.size === 'marketwatch-ZT') {
    if (false) {
      if (options.type !== 'bar') {
        // unclear what this did
        var topEl = options.el.lastChild.lastChild.lastChild.lastChild;
        var firstChildThumb = topEl.firstChild;
        var secondChildThumb = topEl.lastChild;
        // firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
        // firstChildThumb.transform.baseVal.getItem(0).setTranslate(0, 0);
      }
    }
  } else {
    // if (options.type !== 'scatter') {
    legend.postRender(highchart, options);
    // }

    tooltips.postRender(highchart, options);
    axes.postRender(highchart, options);
    recessions.postRender(highchart, options);
    if (options.plotLines[0].plotLineValue) plotLines.postRender(highchart, options);
    if (options.type !== 'pie' && options.type !== 'bar' && options.annotations.length) {
      annotationsPost.postRender(highchart, options);
    }
  }
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    chart.renderInvalidated(rendered, options, invalidated);
  }
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartSpacing = chartSpacing;
exports.chartMargin = chartMargin;

var _constants = __webpack_require__(3);

function chartSpacing(options) {
  var spacing = [16, 0, 0, 0]; // formerly 28 for index 2
  if (options.type === 'bar') {
    spacing[0] += options.print ? -28 : -40; // This makes no sense to me.
    if (options.print) {
      spacing[2] = 0;
    }

    if (false) {
      if (options.product === 'wsj') {
        if (options.print) {
          spacing[0] = -12;
          spacing[2] = 4;
        } else {
          spacing[0] = -20;
          spacing[2] = 8;
        }
      }
    }

    if (options.horizontalBarType === 'aboveBar' || options.horizontalBarType === 'noScaleAndLeft') {
      spacing[0] = 5;
      spacing[2] = 0;
    }
  } else {
    if (false) {
      if (options.product === 'marketwatch') {
        var hasExtraLegendSpacingRight = options.legend.layout === 'right' && options.legend.enabled ? true : false;
        var isLineOrColumn = options.type === 'line' || options.type === 'column';
        var isThumb = options.size === 'thumb-marketwatch-MA' || options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT';
        var hasSuffix = options.axes.units.suffix;
        var hasPrefix = options.axes.units.prefix;
        if (isThumb) {
          return spacing;
        }
        if (isLineOrColumn && options.annotations.length) {
          // if no annotations spacing[0] should equal 6
          spacing[0] = options.annotations.length === 0 ? 6 : 16;
        }
        if (isLineOrColumn && !options.annotations.length) {
          spacing[0] = 6;
        }
        if (isLineOrColumn && !hasExtraLegendSpacingRight) {
          var givenSuffix = hasSuffix === " thousand" || hasSuffix === "%" || hasSuffix === " hundred" || hasSuffix === " billion" || hasSuffix === " trillion" || hasSuffix === " cents";
          if (hasSuffix) {
            if (hasSuffix === " thousand") {
              spacing[1] = 70;
            }
            if (hasSuffix === "%") {
              spacing[1] = 20;
            }
            if (hasSuffix === " hundred") {
              spacing[1] = 60;
            }
            if (hasSuffix === " billion") {
              spacing[1] = 45;
            }
            if (hasSuffix === " trillion") {
              spacing[1] = 50;
            }
            if (hasSuffix === " cents") {
              spacing[1] = 40;
            }
            if (!givenSuffix) {
              var suffixLength = hasSuffix.length;
              var thousand = " thousand";
              var thousandLength = thousand.length;
              var diff = suffixLength - thousandLength;
              if (suffixLength === thousandLength) {
                spacing[1] = 70;
              }
              if (suffixLength > thousandLength) {
                spacing[1] = 70 + diff * 7;
              } else {
                spacing[1] = 70 + diff * 5;
              }
            }
          } else {
            spacing[1] = 6;
          }
          if (hasPrefix && !options.axes.units.formatDecimals && !hasExtraLegendSpacingRight) {
            spacing[1] = spacing[1] + 5;
          }
        }
      }
    }
    if (false) {
      if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
        spacing[1] = options.type === 'column' && options.axes.units.suffix === '%' ? 15 : 6;
      }
    }

    if (false) {
      if (options.product === 'wsj') {
        spacing[0] = 15;
        spacing[2] = 9;

        if (options.print) {
          spacing[0] = 14;
          spacing[2] = 9;
        }

        if (options.id === '16u') {
          spacing[0] = 16;
          spacing[2] = 10;
        }

        if (options.id === '12u') {
          spacing[0] = 14;
          spacing[2] = 10;
        }

        if (options.id === '8u') {
          spacing[0] = 13;
          spacing[2] = 7;
        }

        if (options.id === '4u') {
          spacing[0] = 12;
          spacing[2] = 6;
        }

        if (options.id === 'D' || options.id === 'appfeed') {
          spacing[0] = options.legend.enabled && (options.legend.layout === 'default' || options.legend.layout === 'top') ? 0 : 12;
          spacing[2] = 0;
        }

        if (options.id === 'E') {
          spacing[0] = 10;
          spacing[2] = 0;
        }

        if (options.annotations.length) {
          spacing[0] = 18;
        }
        if (options.id === 'video' || options.id === 'twitterVideo') {
          if (options.id === 'twitterVideo') {
            spacing[0] = 35;
          } else {
            spacing[0] = options.legend.enabled ? 20 : 35;
          }
          spacing[2] = 0;
        }
      }
    }

    if (options.type === 'scatter' && (options.product === 'wsj' || options.product === 'mansionglobal' || options.product === 'barrons')) {
      spacing[1] = 6;
    }

    if (options.type === 'scatter' && (options.product === 'financialnews' || options.product === 'marketwatch')) {
      spacing[3] = 6;
    }

    if (options.type === 'line' && options.product === 'marketwatch') {
      spacing[3] = 6;
    }
  }
  if (Array.isArray(options.spacing)) {
    spacing.forEach(function (n, i) {
      spacing[i] += options.spacing[i] || 0;
    });
  }
  return spacing;
}

// DO NOT USE! Interferes with legend spacing!!!
function chartMargin(options) {
  return [null, null, null, null];
  // const lineHeight = parseFloat(options.styles.normal.lineHeight);
  // const margin = [lineHeight, null, lineHeight * 2, null];
  // if (options.type === 'bar') {
  //   margin[0] += 4;
  //   margin[2] -= lineHeight;
  // }
  // return margin;
  // if (options.size.indexOf('thumb') === 0) {
  //   return margin;
  // }
  // margin[0] = 16;
  // margin[2] = 28;
  // if (options.quarterlyResults && options.series[0].data.length <= 9) {
  //   margin[2] += parseFloat(options.styles.normal.fontSize);
  // }
  // if (__WSJ__) {
  //   if (options.size === 'print-wsj') {
  //     if (options.type === 'bar') {
  //       margin[0] = 14;
  //       margin[2] = 0;
  //     } else {
  //       margin[0] = 12;
  //       margin[2] = 8;
  //     }
  //   }
  // }
  // return margin;
}

// export function addSpaceForAnnotations(spacing, options) {
//   if (possibleAnnotationsSpacing(options)/* && needsAnnotationSpace(options)*/) {
//     spacing[1] += options.print ? ANNOTATIONS_SPACE_PRINT : ANNOTATIONS_SPACE;
//     options.spaceAddedForAnnotations = true;
//   }
//   return spacing;
// }

// function possibleAnnotationsSpacing(options) {
//   return !(
//     options.product === 'marketwatch' ||
//     options.type === 'pie' ||
//     options.type === 'bar' ||
//     (options.type === 'column' && options.stacking)
//   );
// }

// function needsAnnotationSpace(options) {
//   const endIndex = Math.floor((options.maxDataLength - 1) * 0.95);
//   for (let i = 0; i < options.annotations.length; i++) {
//     const a = options.annotations[i];
//     const attach = a.attach.point.enabled ? a.attach.point : a.attach.category;
//     const index = attach.index;
//     if (index >= endIndex) {
//       if (a.lineEnd === 'circle') {
//         return true;
//       }
//       if (options.print && a.lineEnd === 'dot') {
//         return true;
//       }
//     }
//   }
//   return false;
// }

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _chartLine = __webpack_require__(272);

var line = _interopRequireWildcard(_chartLine);

var _chartArea = __webpack_require__(273);

var area = _interopRequireWildcard(_chartArea);

var _chartBar = __webpack_require__(274);

var bar = _interopRequireWildcard(_chartBar);

var _chartPie = __webpack_require__(275);

var pie = _interopRequireWildcard(_chartPie);

var _chartScatter = __webpack_require__(276);

var scatter = _interopRequireWildcard(_chartScatter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Updates options for specific chart types.
 */
function preRender(data, options) {
  switch (options.type) {
    case 'line':
      return line.preRender(data, options);
    case 'area':
      return area.preRender(data, options);
    case 'pie':
      return pie.preRender(data, options);
    case 'scatter':
      return scatter.preRender(data, options);
    case 'bar':
    case 'column':
      return bar.preRender(data, options);
  }
  return data;
}

function postRender(highchart, options) {

  switch (options.type) {
    case 'line':
      line.postRender(highchart, options);
      break;
    case 'area':
      area.postRender(highchart, options);
      break;
    case 'pie':
      pie.postRender(highchart, options);
      break;
    case 'bar':
    case 'column':
      bar.postRender(highchart, options);
      break;
  }
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    switch (options.type) {
      case 'line':
        return line.renderInvalidated(rendered, options, invalidated);
      case 'area':
        return area.renderInvalidated(rendered, options, invalidated);
      case 'pie':
        return pie.renderInvalidated(rendered, options, invalidated);
      case 'bar':
      case 'column':
        return bar.renderInvalidated(rendered, options, invalidated);
    }
    return false;
  }
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _chartUtil = __webpack_require__(34);

var _util = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Adds options for LINE charts.
 */
function preRender(data, options) {
  var radius = 0;
  var hoverRadius = 2.5;
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  var notVideoGroup = options.id !== 'video' && options.id !== 'twitterVideo';
  if (options.markedDataPoints) {
    if (options.print) !options.step ? radius = 1.25 : radius = 0;else {
      radius = !options.step ? 2.5 : 0;
      hoverRadius = !options.step ? 3.5 : 0;
    }
  }
  var showOnHover = options.showTooltips;
  data.plotOptions.line = {
    clip: notVideoGroup,
    lineWidth: options.id === 'video' ? 11 : options.id === 'twitterVideo' ? 8 : 2,
    linecap: isVideoGroup ? 'round' : 'square',
    enableMouseTracking: options.interactive,
    states: {
      hover: {
        halo: {
          opacity: 1,
          size: hoverRadius
        },
        lineWidthPlus: 0
      }
    }
  };
  data.plotOptions.series = {
    marker: {
      symbol: 'circle',
      radius: radius,
      lineWidth: 0,
      lineColor: null,
      enabled: options.markedDataPoints,
      states: {
        hover: {
          enabled: showOnHover
        }
      }
    },
    dataGrouping: {
      enabled: !options.irregularDates
    }
  };
  if (false) {
    if (options.size === 'print-wsj') {
      data.plotOptions.line.lineWidth = 1.5;
      data.plotOptions.line.linecap = 'round';
    }
  }
  return data;
}

function postRender(highchart, options) {
  updateDashStyle(highchart, options);
  roundLineJoins(highchart, options);
}

function updateDashStyle(highchart, options) {
  var paths = [].concat((0, _toConsumableArray3.default)(highchart.container.querySelectorAll('.highcharts-graph')));
  paths.forEach(function (path) {
    return (0, _util.dashStylesHelper)(path, options.size);
  });
}

function roundLineJoins(highchart, options) {
  var selector = 'g.highcharts-series-group g.highcharts-series path';
  var paths = highchart.container.querySelectorAll(selector);
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  for (var i = 0; i < paths.length; i++) {
    (0, _util.roundLineJoinsHelper)(paths[i], isVideoGroup);
  }
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
  }
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _chartUtil = __webpack_require__(34);

/**
 * Adds options for LINE charts.
 */
function preRender(data, options) {
  var showOnHover = options.showTooltips;
  data.plotOptions.area = {
    lineWidth: options.series.length > 1 ? 1 : 0,
    lineColor: '#fff',
    linecap: 'square',
    fillOpacity: 1.0,
    enableMouseTracking: options.interactive,
    stacking: options.stacking,
    states: {
      hover: {
        halo: {
          opacity: 1,
          size: 4
        },
        lineWidthPlus: 0
      }
    }
  };
  data.plotOptions.series = {
    marker: {
      symbol: 'circle',
      radius: 0,
      lineWidth: 0,
      lineColor: null,
      states: {
        hover: {
          enabled: showOnHover
        }
      }
    }
  };
  if (false) {
    if (options.size === 'print-wsj') {
      data.plotOptions.area.lineWidth = 1.5;
      // data.plotOptions.area.linecap = 'butt';
    }
  }
  return data;
}

function postRender(highchart, options) {
  roundLineJoins(highchart, options);
}

function roundLineJoins(highchart, options) {
  var selector = 'g.highcharts-series-group g.highcharts-series path';
  var paths = highchart.container.querySelectorAll(selector);
  for (var i = 0; i < paths.length; i++) {
    paths[i].setAttribute('stroke-linejoin', 'bevel');
    if (false) {
      if (options.size === 'print-wsj') {
        paths[i].setAttribute('stroke-linecap', 'butt');
      }
    }
  }
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
  }
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _chartUtil = __webpack_require__(34);

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Adds options for BAR and COLUMN charts.
 */

function preRender(data, options) {
  var bar = data.plotOptions[options.type];
  bar.stacking = options.stacking;
  bar.marker = {
    enabled: false
  };
  bar.borderWidth = 0;
  if (options.horizontalBarType === 'aboveBar') {
    var defaultHeight = 263;
    if (options.product === 'barrons') defaultHeight = 251;
    if (options.product === 'mansionglobal') defaultHeight = 225;
    if (options.product === 'marketwatch') defaultHeight = 231;
    if (options.product === 'financialnews') defaultHeight = 231;
    if (options.product === 'knewz') defaultHeight = 251;
    var scaleFrom400 = options.height / defaultHeight < 1 ? options.height / defaultHeight : defaultHeight / options.height;
    scaleFrom400 = options.height === defaultHeight ? 0.8 : scaleFrom400;
    data.plotOptions[options.type].pointPadding = 0.2 / scaleFrom400;
    data.plotOptions[options.type].groupPadding = options.series.length > 1 && options.stacking === null ? 0.2 / scaleFrom400 : 0;
    // data.plotOptions[options.type].pointWidth = 15;
  } else {
    data.plotOptions[options.type].pointPadding = 0.2;
    data.plotOptions[options.type].groupPadding = options.series.length > 1 && options.stacking === null ? 0.2 : 0;
    // data.plotOptions[options.type].pointWidth = 15;
  }

  if (options.type === 'bar') {
    if (options.horizontalBarType === 'aboveBar' || options.horizontalBarType === 'noScaleAndLeft') {
      var hasPrefix = options.tooltips.prefix ? 1 : 0;
      var firstBarLength = options.series[0].data[0].y.toString().length + hasPrefix;
      firstBarLength = firstBarLength > 3 ? firstBarLength + firstBarLength : firstBarLength;
      var defaultOffset = firstBarLength === 1 ? 20 : 30 + firstBarLength * 2;
      data.plotOptions[options.type].dataLabels = {
        enabled: true,
        align: 'right',
        allowOverlap: true,
        padding: 0,
        style: {
          fontFamily: options.styles.font.normal,
          fontWeight: options.styles.weight.normal,
          fontSize: options.styles.dataLabel.fontSize,
          lineHeight: options.styles.dataLabel.lineHeight,
          textOutline: false,
          shadow: false,
          color: 'black'
        },
        x: options.horizontalBarLabel ? -5 : defaultOffset, // if I set to this to 0 it sits inside the bar,
        y: 4,
        formatter: function formatter() {
          return _formatter(data, options, this);
        }
      };
    }
  }
  data.plotOptions.series = {
    dataGrouping: {
      enabled: !options.irregularDates
    }
  };
  return data;
}

function _formatter(data, options, context) {
  var dataLabel = context.y;
  var value = format.applyFull(context.point.y, false, false, true, true, true);
  // const value = format.applyFull(context.point.y, options.tooltips, options.type === 'pie', true, true);
  var prefix = options.axes.units.prefix;
  var suffix = options.axes.units.suffix;
  if (context.point.index === 0) {
    if (prefix) {
      value = options.axes.units.prefix + value;
    }

    if (suffix) {
      value = value + suffix;
    }
  }

  return value;
}

// For bar charts, tweaks the spacing between bars.
// function adjustBarsWidth(data, options) {
//   if (options.type === 'column') {
//     const c = data.plotOptions[options.type];
//     const seriesLen = options.stacking ? 1 : data.series.length;
//     let maxDataLen = 0;
//     data.series.forEach(item => {
//       maxDataLen = Math.max(maxDataLen, item.data.length);
//     });
//     const yAxisEstimate = getYAxisEstimatedWidth(data, options);
//     const xAxisWidth = options.width - yAxisEstimate;
//     const bars = seriesLen * maxDataLen;
//     const groupBars = (seriesLen > 1) ? (maxDataLen - 1) : 0;
//     const pointBars = (seriesLen === 1) ? (maxDataLen - 1) :
//       (maxDataLen * (seriesLen - 1));

//     const adjustedGroupBars = groupBars * 2;
//     // designed = 0.25 :
//     const adjustedPointBars = pointBars * (0.35 + 0.2 * seriesLen);

//     c.pointWidth = Math.max(2, xAxisWidth /
//       (bars + adjustedGroupBars + adjustedPointBars));

//     // if (options.legend.enabled && options.legend.layout === 'right') {
//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.25);
//     // } else {
//     //   c.pointWidth = c.pointWidth + (c.pointWidth * 0.5)
//     // }


//     // let factorToSubtractBy = 0;

//     // if (data.series[0].data.length > 100) {
//     //   if (options.width < 500) {
//     //     factorToSubtractBy = 0.95;
//     //   }
//     //   if (options.width < 620 && options.width > 500) {
//     //     factorToSubtractBy = 0.75;
//     //   }
//     //   if (options.width >= 620) {
//     //     factorToSubtractBy = 0.25;
//     //   }
//     // }

//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length > 100) {
//     //   if (options.width < 500) {
//     //     factorToSubtractBy = 0.95;
//     //   }
//     //   if (options.width < 620 && options.width > 500) {
//     //     factorToSubtractBy = 0.9;
//     //   }
//     //   if (options.width === 620) {
//     //     factorToSubtractBy = 0.7;
//     //   }
//     //   if (options.width > 620) {
//     //     factorToSubtractBy = 0.25;
//     //   }
//     // }

//     // if ((options.legend.enabled && options.legend.layout === 'right') && data.series[0].data.length < 100) {
//     //   factorToSubtractBy = options.width < 420 ? 0.35 : 0.25;
//     // }

//     // c.pointWidth = c.pointWidth - (c.pointWidth * factorToSubtractBy);
//     // c.pointPadding = 0.5;
//     // c.groupPadding = 0;

//   }
//   return data;
// }

// NEVER CALLED
// function getYAxisEstimatedWidth(data, options) {
//   let maxNum = 0;
//   data.series.forEach(series => {
//     for (let i = 0; i < series.data.length; i++) {
//       maxNum = Math.max(maxNum, series.data[i].y);
//     }
//   });
//   maxNum = (Math.round(maxNum) + '').length;
//   const units = options.axes.units;
//   const forceDecimals = (units.forceDecimals !== undefined) ?
//     units.forceDecimals : 0;
//   const maxDecimals = (units.maxDecimals !== undefined) ?
//     units.maxDecimals : Number.MAX_VALUE;
//   const len = maxNum + Math.min(forceDecimals, maxDecimals);
//   const fontSize = parseFloat(options.styles.normal.fontSize) * 0.5;
//   return len * fontSize;
// }

function postRender(highchart, options) {
  if (options.type === 'column') {
    adjustBarSpacing(highchart, options);
  }
  stylizeStacks(highchart, options);
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
  }
}

// Tweak spacing to improve rounding/pixel issues.
function adjustBarSpacing(highchart, options) {
  var axis = highchart.yAxis[0];
  var delta = {
    index1: -1,
    index2: -1
  };
  // Set X for each bar to NOT rounded position. I thought this would look
  // terrible, but it's fine.
  var seriesLen = axis.series.length;
  axis.series.forEach(function (series) {
    for (var i = 0; i < series.data.length; i++) {
      var point = series.data[i];
      if (point.graphic) {
        point.graphic.element.setAttribute('x', point.barX);
        // Measure the distance between bars:
        if (delta.index1 === -1) {
          delta.index1 = i;
          delta.bar1 = point.barX;
        } else if (delta.index2 === -1) {
          if (delta.index1 < i - 1) {
            delta.index1 = -1;
          } else {
            delta.index2 = i;
            delta.bar2 = point.barX - point.pointWidth;
          }
        }
      }
    }
  });
  // if (delta.index1 !== -1 && delta.index2 !== -1) {
  //   // If bars are too close together, merge them:
  //   const deltaPx = delta.bar2 - delta.bar1;
  //   console.log(deltaPx);
  //   const hasOverOneFiftyDataPoints = options.series[0].data.length > 150 ? 1.5 : 0.5;
  //   console.log(deltaPx, options.size);
  //   if (deltaPx < hasOverOneFiftyDataPoints) {
  //     axis.series.forEach(series => {
  //       for (let i = 0; i < series.data.length; i++) {
  //         const point = series.data[i];
  //         if (point.graphic) {
  //           let isLegendRight = options.legend.enabled && options.legend.layout === 'right' ? 0.25 : 0.125;
  //           isLegendRight = options.series[0].data.length > 150 ? isLegendRight + 0.05 : isLegendRight;
  //           point.graphic.element.setAttribute('x', point.barX + (deltaPx / 2));
  //           point.graphic.element.setAttribute('width', point.pointWidth - deltaPx);
  //         }
  //       }
  //     });
  //   }
  // }
}

// If stacking is enabled, adjust the style of the stacks.
function stylizeStacks(highchart, options) {
  if (options.stacking) {
    highchart.yAxis[0].series.forEach(function (series) {
      series.data.forEach(function (item) {
        if (item.graphic) {
          var el = item.graphic.element;
          var px = parseFloat(el.attributes.height.value);
          if (px > 0) {
            el.setAttribute('height', px - 1);
          }
        }
      });
    });
  }
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;
exports.renderInvalidated = renderInvalidated;

var _transform = __webpack_require__(18);

var transform = _interopRequireWildcard(_transform);

var _chartUtil = __webpack_require__(34);

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var TOP_LEFT = 0; /**
                   * Adds options for PIE charts.
                   */

var TOP_RIGHT = 1;
var BOTTOM_RIGHT = 2;
var BOTTOM_LEFT = 3;

var PERC_MARGIN = 4;
var LABEL_MARGIN = 10;

function preRender(data, options) {
  options = writeDataNames(options);
  var arrayofYValues = data.series[0].data;
  var sumofYValues = 0;
  arrayofYValues.forEach(function (data) {
    sumofYValues += data.y;
  });
  arrayofYValues.forEach(function (data) {
    data.y = data.y / sumofYValues;
    // data.y = format.decimals(data.y, options.axes.units, true, true);
    data.y = parseFloat(data.y * 100);
    var forceDecimals = Number(options.axes.units.forceDecimals);
    if (forceDecimals === 1) forceDecimals = 10;
    if (forceDecimals === 2) forceDecimals = 100;
    if (forceDecimals === 3) forceDecimals = 1000;
    if (forceDecimals === 0) forceDecimals = 'round';
    if (forceDecimals) {
      data.y = forceDecimals !== 'round' ? Math.ceil(data.y * forceDecimals) / forceDecimals : data.y;
      if (data.y.toString().length > 4 && forceDecimals === 'round') {
        data.y = Math.round(data.y);
      }
    }
  });
  data.plotOptions.pie = {
    dataLabels: { enabled: false },
    enableMouseTracking: options.interactive,
    showInLegend: true,
    minSize: minSize(data, options),
    center: ['50%', '50%'],
    states: {
      hover: {
        enabled: false
      }
    }
  };
  return data;
}

// Writes the categories into the series[0] data so that they are available
// for data labels.
function writeDataNames(options) {
  options.series[0].data.forEach(function (item, index) {
    if (options.type === 'pie' && options.optimizeDataOrder) {
      item.name = options.longCategories[item.originalIndex];
    } else {
      item.name = options.longCategories[index];
    }
  });
  return options;
}

// Set a minimum radius for the chart to render.
function minSize(data, options) {
  return Math.min(options.height - data.chart.spacing[0] - data.chart.spacing[2], options.width - data.chart.spacing[3] - data.chart.spacing[1]) * 0.5;
}

/**
 * Draws the data labels using custom methods instead of Highcharts.
 * 1) Draw labels into corners of quadrants.
 * 2) Resize and move pie chart based on data labels locations.
 * 3) Draw connectors.
 */
function postRender(highchart, options) {
  if (options.legend.enabled && options.size.indexOf('thumb') !== 0) {
    var g = drawLabelsGroup(highchart);
    var rect = getPieRect(highchart);
    if (rect) {
      var labels = drawLabels(highchart, options, g, rect);
      if (labels.length) {
        var sorted = sortLabels(labels);
        sorted = positionLabels(highchart, sorted, rect);
        var resizedRect = resizeChart(highchart, rect, sorted, labels[0].lineHeight);
        truncateLabels(highchart, labels, resizedRect);
        improveLabelPositions(highchart, labels, resizedRect);
        if (options.product === 'financialnews') {
          makeDonutChart(highchart, options);
        }
      }
    }
  }
}

// Creates a `g` element to contain the data labels, translated to the same
// position as the pie chart.
function drawLabelsGroup(highchart) {
  var gPieSelector = '.highcharts-series-group .highcharts-series';
  var gPie = highchart.container.querySelector(gPieSelector);
  var g = highchart.renderer.g().add();
  g.element.setAttribute('transform', gPie.getAttribute('transform'));
  g.element.setAttribute('class', 'pie-chart-data-labels');
  return g;
}

function drawLabels(highchart, options, g, rect) {
  var labels = [];
  var data = highchart.series[0].data;
  var smallSize = isSmall(options.size);
  var styleLabel = options.styles.get(smallSize ? 'small' : 'normal', {
    fontFamily: options.styles.font.bold,
    fontWeight: options.styles.weight.bold
  });
  var stylePerc = options.styles.get(smallSize ? 'small' : 'normal');
  var lineHeight = parseFloat(styleLabel.fontSize);
  var pi2 = Math.PI * 2;

  for (var i = 0; i < data.length; i++) {
    var slice = data[i];
    labels[i] = {};
    labels[i].slice = slice;
    labels[i].radians = (slice.angle + pi2) % pi2;
    labels[i].styleLabel = options.styles.get(smallSize ? 'small' : 'normal', {
      fontFamily: options.styles.font.bold,
      fontWeight: options.styles.weight.bold
    });
    labels[i].stylePerc = options.styles.get(smallSize ? 'small' : 'normal', {});
    labels[i].g = highchart.renderer.g().add(g);

    // const labelName = getLabelName(slice, options);
    labels[i].labelName = highchart.renderer.text(slice.name, 0, 0).css(labels[i].styleLabel).add(labels[i].g);
    labels[i].labelPerc = highchart.renderer.text(slice.y + '%', labels[i].labelName.element.getBoundingClientRect().width + PERC_MARGIN, 0).css(labels[i].stylePerc).add(labels[i].g);
    labels[i].lineHeight = smallSize ? 14 : parseFloat(styleLabel.lineHeight);
    var isMW = options.product === 'marketwatch';
    var isFN = options.product === 'financialnews';
    var widthVal = isMW ? 12 : 9;
    var heightVal = isMW ? 12 : 13;
    if (!isFN) {
      highchart.renderer.rect().attr({
        width: widthVal,
        height: heightVal,
        fill: slice.color
      }).add(labels[i].g);
    } else {
      highchart.renderer.circle(5, -4, widthVal / 2).attr({
        fill: slice.color
      }).add(labels[i].g);
    }

    var xVal = isMW ? 15 : 12;
    var yVal = isMW ? -10 : -12;
    labels[i].g.element.lastElementChild.setAttribute('x', 0);
    labels[i].g.element.firstElementChild.setAttribute('x', xVal);
    var percentageCurrentX = Number(labels[i].g.element.children[1].getAttribute('x'));
    labels[i].g.element.children[1].setAttribute('x', percentageCurrentX + xVal);
    labels[i].g.element.lastElementChild.setAttribute('y', yVal);
  }

  return labels;
}

// function getLabelName(slice, options) {
//   if (options.optimizeDataOrder && Array.isArray(options.categories) &&
//       options.categories.length) {
//     return options.categories[0][slice.originalIndex] || slice.name;
//   }
//   return slice.name
// }


// Sorts labels intro quadrants.
function sortLabels(labels, rect) {
  var BR = [];
  var BL = [];
  var TL = [];
  var TR = [];

  labels = labels.sort(sortOnRadians);
  for (var i = 0; i < labels.length; i++) {
    var r = labels[i].radians;
    if (r > 0 && r <= Math.PI * 0.5) {
      BR.push(labels[i]);
    } else if (r > Math.PI * 0.5 && r < Math.PI) {
      BL.push(labels[i]);
    } else if (r >= Math.PI && r < Math.PI * 1.5) {
      TL.push(labels[i]);
    } else {
      TR.push(labels[i]);
    }
  }

  if (TR.length === 0 && BR.length) {
    TR.push(BR.shift());
  }
  BR.reverse();
  TL.reverse();
  return { BR: BR, BL: BL, TL: TL, TR: TR };
}

function positionLabels(highchart, sorted, rect) {
  // Top right
  var x = void 0;
  var y = 0;
  sorted.TR.forEach(function (label) {
    label.x = getRightX(highchart, label);
    label.y = y + label.lineHeight;
    transform.write(label.g.element, 'translate', label.x, label.y);
    y += label.lineHeight;
  });

  // Bottom right
  y = getBottomY(highchart);
  sorted.BR.forEach(function (label) {
    label.x = getRightX(highchart, label);
    label.y = y;
    transform.write(label.g.element, 'translate', label.x, label.y);
    y -= label.lineHeight;
  });

  // Bottom left
  x = getLeftX(highchart);
  y = getBottomY(highchart);
  sorted.BL.forEach(function (label) {
    label.x = x;
    label.y = y;
    transform.write(label.g.element, 'translate', label.x, label.y);
    y -= label.lineHeight;
  });

  // Top left
  y = 0;
  sorted.TL.forEach(function (label) {
    label.x = x;
    label.y = y + label.lineHeight;
    transform.write(label.g.element, 'translate', label.x, label.y);
    y += label.lineHeight;
  });
  return sorted;
}

// Returns default label left x.
function getLeftX(highchart) {
  return 0; //highchart.plotLeft;
}

// Returns default label right x.
function getRightX(highchart, label) {
  return highchart.plotLeft + highchart.plotWidth - highchart.spacing[1] - label.g.element.getBoundingClientRect().width;
}

// Returns default label bottom y.
function getBottomY(highchart) {
  return highchart.plotHeight - LABEL_MARGIN; // - highchart.spacing[2];
}

// Scales the chart down to compensate for labels.
function resizeChart(highchart, rect, sorted, lineHeight) {
  var maxLabelsTop = Math.max(sorted.TL.length, sorted.TR.length);
  var maxLabelsBot = Math.max(sorted.BL.length, sorted.BR.length);
  var newHeight = rect.height - (maxLabelsTop + maxLabelsBot) * lineHeight;
  newHeight = Math.max(newHeight, Math.min(highchart.plotWidth * 0.6, highchart.plotHeight * 0.6));

  var scaleRatio = newHeight / rect.height;
  var pieG = highchart.series[0].data[0].graphic.parentGroup;
  var pieContainer = pieG.element.parentElement;
  var translate = transform.read(pieG.element, 'translate');
  var x = (highchart.chartWidth - highchart.chartWidth * scaleRatio) * 0.5;
  var y = translate[1];
  y += maxLabelsTop * lineHeight;
  // y += (rect.height - newHeight) / 2;

  transform.write(pieG.element, 'translate', translate[0], 0);
  pieContainer.setAttribute('transform', ['matrix(', scaleRatio, ',0,0,', scaleRatio, ',', x, ',', y, ')'].join(''));

  var r = {
    width: rect.width * scaleRatio
  };
  r.height = r.width;
  r.left = rect.center - r.width / 2 + highchart.spacing[3];
  r.center = rect.center;
  r.right = r.left + r.width;
  r.top = y + 10 * scaleRatio;
  r.middle = r.top + r.height / 2;
  r.bottom = r.top + r.height;
  // debugRect(highchart, r.left, r.top, r.width, r.height);
  return r;
}

// Truncate any labels that overlap the pie chart with '…'.
function truncateLabels(highchart, labels, rect) {
  var labelsLen = labels.length;
  if (labelsLen) {
    var parentGroup = labels[0].g.element.parentElement;
    var parentTop = transform.read(parentGroup, 'translate')[1];

    for (var i = 0; i < labelsLen; i++) {
      var label = labels[i];
      parentGroup = parentGroup || label.g.element.parentElement;
      var labelRect = label.g.element.getBoundingClientRect();
      label.bounds = {
        x: label.x + highchart.spacing[3],
        y: label.y + parentTop - parseFloat(label.styleLabel.fontSize) + highchart.spacing[0],
        width: labelRect.width,
        height: labelRect.height
      };
      // debugRect(highchart, testRect.x, testRect.y, testRect.width, testRect.height);

      var maxWidth;
      if (label.bounds.y > rect.top && label.bounds.y < rect.bottom) {
        // Label is next to pie chart.
        if (label.x < rect.left) {
          maxWidth = rect.left - label.x - LABEL_MARGIN;
          truncateLabelLeft(labelRect, label, rect.left - label.x - LABEL_MARGIN);
        } else {
          maxWidth = highchart.chartWidth - highchart.spacing[1] - rect.right;
          truncateLabelRight(labelRect, label, label.bounds.x + labelRect.width, maxWidth);
        }
      } else {
        // Label is above or below the pie.
        if (label.radians > Math.PI / 2 && label.radians < Math.PI * 1.5) {
          maxWidth = rect.center - label.x - LABEL_MARGIN;
          truncateLabelLeft(labelRect, label, maxWidth);
        } else {
          maxWidth = highchart.chartWidth - highchart.spacing[1] - rect.center;
          truncateLabelRight(labelRect, label, label.bounds.x + labelRect.width, maxWidth);
        }
      }
    }
  }
}

function truncateLabelLeft(labelRect, label, maxWidth) {
  var tspan = label.labelName.element.querySelector('tspan') || label.labelName.element;
  var s = label.labelName.textStr;
  var n = s.length - 2;
  while (labelRect.width > maxWidth && n > 0) {
    s = s.substr(0, n--);
    tspan.innerHTML = s + '…';
    label.labelPerc.element.setAttribute('x', label.labelName.element.getBoundingClientRect().width + PERC_MARGIN);
    labelRect = label.g.element.getBoundingClientRect();
  }
}

function truncateLabelRight(labelRect, label, rightX, maxWidth) {
  var tspan = label.labelName.element.querySelector('tspan') || label.labelName.element;
  var s = label.labelName.textStr;
  var n = s.length - 2;
  while (labelRect.width > maxWidth && n > 0) {
    s = s.substr(0, n--);
    tspan.innerHTML = s + '…';
    label.labelPerc.element.setAttribute('x', label.labelName.element.getBoundingClientRect().width + PERC_MARGIN);
    labelRect = label.g.element.getBoundingClientRect();
  }
  var translate = transform.read(label.g.element, 'translate');
  transform.write(label.g.element, 'translate', rightX - labelRect.width, translate[1]);
}

// Moves labels closer to the chart, if possible.
function improveLabelPositions(highchart, labels, rect) {
  var L = [];
  var R = [];
  var maxL = 0;
  var maxR = 0;
  for (var i = 0; i < labels.length; i++) {
    var label = labels[i];
    if (label.radians > Math.PI * 0.5 && label.radians < Math.PI * 1.5) {
      L.push(label);
      maxL = Math.max(maxL, label.bounds.width);
    } else {
      R.push(label);
      maxR = Math.max(maxR, label.bounds.width);
    }
  }
  var delta = rect.left - LABEL_MARGIN - maxL;
  if (delta > 0) {
    L.forEach(function (item) {
      var t = transform.read(item.g.element, 'translate');
      transform.write(item.g.element, 'translate', t[0] + delta, t[1]);
    });
  }
  delta = highchart.chartWidth - (rect.right + LABEL_MARGIN) - maxR;
  if (delta > 0) {
    R.forEach(function (item) {
      var t = transform.read(item.g.element, 'translate');
      transform.write(item.g.element, 'translate', t[0] - delta, t[1]);
    });
  }
}

// We decided, at least for the moment, not to do this.
function connectLabels(highchart, rect, labels) {}
//


// For sorting the labels from top to bottom.
function sortOnY(a, b) {
  // var ta = transform.read(a.dataLabel.element, 'translate')[1];
  // var tb = transform.read(b.dataLabel.element, 'translate')[1];
  // return ta - tb;
  return a.y - b.y;
}

// Sorts the labels clockwise around the pie, starting at 3 o'clock. The
// radians should already have been normalized to a number >= 0 and
// <= Math.PI * 2.
function sortOnRadians(a, b) {
  return a.radians - b.radians;
}

// Returns position and dimensions of the pie graphic.
function getPieRect(highchart) {
  var d = highchart.series[0].data[0];
  var g = !!d ? d.graphic : null;
  if (g) {
    var r = {
      left: g.x - g.r,
      top: g.y - g.r
    };
    r.width = g.r * 2;
    r.height = r.width;
    r.right = r.left + r.width;
    r.bottom = r.top + r.height;
    r.center = r.left + r.width / 2;
    r.middle = r.top + r.height / 2;
    return r;
  }
  return null;
}

function debugRect(highchart, x, y, width, height) {
  return highchart.renderer.rect(x, y, width, height).attr({
    'stroke-width': 1,
    'stroke': 'red',
    'fill': 'rgba(255, 255, 255, 0)'
  }).add();
}

// Used for determining whether to use 'small' or 'normal' font sizes.
function isSmall(size) {
  return size === 'D' || size === '4u' || size === 'fon';
}

function makeDonutChart(highchart, options) {
  if (false) {
    var highchartContainer = highchart.container;
    var highchartContainerSVG = highchartContainer.firstElementChild;
    var pieRect = highchartContainerSVG.querySelectorAll('.highcharts-pie-series')[0];
    var rectRadius = pieRect.getBBox().width;
    var radius = rectRadius / 4.1;
    var svgWidth = Number(highchartContainerSVG.getAttribute('width'));
    var svgHeight = highchartContainerSVG.getAttribute('height');
    var groupOfPieValue = highchartContainer.getElementsByClassName('highcharts-pie-series')[0];
    var lastPathOfPie = groupOfPieValue.lastElementChild.getAttribute('d').split(' ');
    var lastPathOfPieYVal = Number(lastPathOfPie[lastPathOfPie.length - 2]);
    var circle = highchart.renderer.circle(svgWidth / 2, lastPathOfPieYVal, radius).attr({
      fill: '#fefaf3'
    });
    var text = highchart.renderer.text('%', svgWidth / 2 - radius / 2 * .85, lastPathOfPieYVal + radius / 2 * .75).attr({
      'font-size': radius,
      stroke: 'black',
      text: '%'
    }).add();
    groupOfPieValue.append(circle.element);
    groupOfPieValue.append(text.element);
  }
}

function renderInvalidated(rendered, options, invalidated) {
  if (false) {
    (0, _chartUtil.renderInvalidatedColors)(rendered, invalidated);
  }
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
function preRender(data, options) {
  var showOnHover = options.showTooltips;
  data.plotOptions.series = {
    // dataLabels: {
    //   enabled: true,
    //   formatter: function() {
    //     return this.point.value;
    //   }
    // },
    stickyTracking: false,
    marker: {
      symbol: 'circle',
      radius: 4,
      enabled: true,
      states: {
        hover: {
          enabled: showOnHover
        }
      }
    }
  };
  return data;
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.preRender = preRender;
exports.postRender = postRender;
exports.checkHideColorChips = checkHideColorChips;

var _constants = __webpack_require__(3);

var _transform = __webpack_require__(18);

var transform = _interopRequireWildcard(_transform);

var _element = __webpack_require__(15);

var element = _interopRequireWildcard(_element);

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

var _processSeries = __webpack_require__(50);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_ITEM_CHARS = 16;
var MAX_ITEM_CHARS = 32;
var MIN_CHARS_RATIO = MIN_ITEM_CHARS / _constants.MAX_4U_WIDTH;

function preRender(data, options) {
  if (false) {
    if (options.size === 'marketwatch-ZT') {
      return data;
    }
  }
  data.legend = {
    enabled: options.id === 'twitterVideo' ? false : options.legend.enabled && options.type !== 'pie',
    navigation: { enabled: false }
  };

  if (data.legend.enabled) {
    options.forceLegendTop = (0, _processSeries.checkForceLegendTop)(options);
    styleLegend(data, options);
    compileLegendText(data, options);
    positionLegend(data, options);
  }
  return data;
}

function positionLegend(data, options) {
  var LH = parseFloat(options.styles.normal.lineHeight);
  if (options.legend.layout === 'default') {
    options.legend.layout = 'right';
  }
  if (options.forceLegendTop) {
    options.legend.layout = 'top';
  }
  switch (options.legend.layout) {
    case 'top':
      data.legend.layout = 'horizontal';
      data.legend.align = 'left';
      data.legend.verticalAlign = 'top';
      if (options.print) {
        data.legend.margin = options.type === 'bar' ? 8 : 4;
      }
      if (options.id === 'D') {
        data.legend.margin = 15;
      }
      if (options.id === 'appfeed') {
        data.legend.margin = 25;
      }
      if (options.id === 'video' || options.id === 'twitterVideo') {
        data.legend.margin = 50;
        data.legend.x = 6;
      }
      break;
    // case 'right':
    default:
      data.legend.layout = 'vertical';
      data.legend.align = 'right';
      data.legend.verticalAlign = 'middle';
      data.legend.margin = 10;
      break;
  }
  return data;
}

function compileLegendText(data, options) {
  data.legend.labelFormatter = function () {
    var _this = this;

    var openTag = '<b>',
        closeTag = '</b>';
    var series = options.series.find(function (series) {
      return series.name === _this.name;
    });
    var text = compileText(series, this, options);
    var textBr = element.replaceLineBreaks(text);
    var lines = textBr.split('<br>');
    var boldLegend = element.boldText();
    var bolded = lines.map(function (line) {
      return boldLegend(line, openTag, closeTag);
    });
    return bolded.join('<br>');
  };
}

function styleLegend(data, options) {
  var fontFamilyStyle = options.product === 'financialnews' ? options.styles.font.normal : options.styles.font.semibold;
  var fontFamilyWeight = options.product === 'financialnews' ? options.styles.weight.normal : options.styles.weight.semibold;
  var fontSizePrint = 7.5;
  if (false) {
    if (options.product === 'financialnews') {
      fontSizePrint = options.print && options.sizes['print-fn'].columns <= 2 ? '7.75px' : '12px';
    }
  }
  var fontStyle = options.print ? {
    fontFamily: options.styles.font.normal,
    fontWeight: options.styles.weight.normal,
    fontSize: fontSizePrint
  } : {
    fontFamily: fontFamilyStyle,
    fontWeight: fontFamilyStyle
  };
  var styles = options.styles.get('normal', fontStyle);

  if (false) {
    if (options.product === 'wsj') {
      styles = Object.assign({}, {
        fontSize: options.styles.legend.fontSize,
        fontWeight: options.styles.legend.fontWeight,
        lineHeight: options.styles.legend.lineHeight
      });
      if (options.id === 'video' || options.id === 'twitterVideo') {
        styles.fontFamily = 'Retina Narrow';
        styles.color = '#fff';
      }
      if (options.id === 'appfeed') {
        styles.color = '#666';
        styles.fontSize = '14px';
      }
    }
  }

  if (false) {
    if (options.product === 'mansionglobal') {
      styles = Object.assign({}, {
        fontSize: options.styles.legend.fontSize,
        fontWeight: options.styles.legend.fontWeight,
        lineHeight: options.styles.legend.lineHeight,
        color: options.styles.legend.color
      });
    }
  }
  if (options.product === 'knewz') {
    styles = Object.assign({}, {
      color: options.styles.legend.color,
      fontFamily: styles.fontFamily,
      lineHeight: options.styles.legend.lineHeight,
      fontSize: options.styles.legend.fontSize,
      fontWeight: options.styles.legend.fontWeight
    });
  }
  data.legend.itemStyle = styles;

  if (options.legend.layout === 'default' && !options.forceLegendTop || options.legend.layout === 'right') {
    // if (options.print) {
    var width = options.width * 0.25 - 17; //data.legend.margin;
    data.legend.itemStyle.width = width; //`${width}px`;
    // }

    if (options.print) {
      data.legend.margin = 4;
    }
    data.legend.padding = 2;
  } else {
    data.legend.padding = options.print ? 0 : 2;
  }
  data.legend.itemDistance = options.print ? 6 : 12;
  data.legend.itemMarginBottom = options.print ? 4 : 5;
  data.legend.symbolPadding = 7;

  // this doesnt do what you think it does.
  // for some reason this helps space the series name and the series symbol
  if (options.print) {
    data.legend.symbolWidth = 4;
  } else if (options.product === 'wsj') {
    data.legend.symbolWidth = 7;
  } else {
    data.legend.symbolWidth = 9;
  }

  if (!options.print) {
    data.legend.itemStyle.textOverflow = null;
  }
  // data.legend.squareSymbol = false;
  if (options.type === 'scatter') {
    data.legend.symbolHeight = 24;
  } else if (options.print) {
    data.legend.symbolHeight = 6;
  } else {
    data.legend.symbolHeight = 12;
  }

  data.legend.symbolRadius = options.type === 'scatter' ? 12 : 0;

  if (options.id === 'video' || options.id === 'twitterVideo') {
    data.legend.symbolHeight = 30;
    data.legend.symbolWidth = undefined;
    data.legend.itemDistance = 75;
    data.legend.symbolPadding = 30;
  }

  var isTooSmallForLineUp = options.series.length > 4 && options.height < 400;
  if (isTooSmallForLineUp) {
    data.legend.verticalAlign = 'middle';
  }

  return data;
}

function postRender(highchart, options) {
  if (highchart.legend.options.enabled && options.type !== 'scatter') {
    positionLegendContainer(highchart, options);
    var items = highchart.container.querySelectorAll('.highcharts-legend-item');
    disableItems(highchart, options, items);
    if (options.id !== 'video' && options.id !== 'twitterVideo') {
      formatItems(highchart, options, items);
    } else {
      [].concat((0, _toConsumableArray3.default)(items)).forEach(function (item) {
        if (options.type === 'line') {
          var path = item.querySelector('path');
          path.setAttribute('stroke-width', 30);
          var d = path.getAttribute('d').split(' ');
          d[4] = '23';
          d[1] = '-7';
          path.setAttribute('d', d.join(' '));
        } else {
          var rect = item.querySelector('rect');
          var y = +rect.getAttribute('y');
          rect.setAttribute('y', y + 4);
        }
      });
    }
    if (options.legend.layout === 'right' && items.length) {
      positionRightAlignedItems(highchart, options, items);
    }
    if ((options.type === 'column' || options.type === 'bar') && options.colorMode === 'THRESHOLD' && items.length) {
      styleColorChip(options.series[0], items[0]);
    }
  } else {
    if (options.type === 'scatter' && highchart.legend.options.enabled) {
      var _items = highchart.container.querySelectorAll('.highcharts-legend-item');
      disableItems(highchart, options, _items);
      positionLegendContainer(highchart, options);
      if (options.legend.layout === 'right' && _items.length) {
        positionItemsMiddle(highchart);
      }
      formatScatterLegend(_items);
    }
  }
}

function formatScatterLegend(items) {
  items.forEach(function (item) {
    var editCircle = item.children[1];
    var editCircleDVal = editCircle.getAttribute('d');
    var indexOfFourValue = editCircleDVal.indexOf('4 4');
    editCircleDVal = editCircleDVal.replace('4 4', '5.5 5.5');
    editCircle.setAttribute('d', editCircleDVal);
  });
}

// Resets the legend group Y as items will track data/item paths instead.
// Note that `null` in Highcharts is not the same as `0`.
function positionLegendContainer(highchart, options) {
  var el = highchart.container.querySelector('.highcharts-legend');
  var isBar = options.type === 'bar';
  var x = null;
  var y = null;
  if (options.legend.layout === 'top') {
    y = isBar ? 0 : 0;
    x = options.type === 'scatter' ? 1 : x;
  }
  // else if (options.legend.layout === 'bottom') {
  // y = highchart.spacingBox.height + highchart.legend.itemHeight;
  // y = options.height - parseFloat(options.styles.normal.lineHeight) * 2;
  // } 
  else if (options.legend.layout === 'right') {
      y = isBar ? null : 0;
    }
  transform.write(el, 'translate', x, y);
}

// Disable clicks on legend items since the Highcharts behavior is not
// requested and also a bit strange.
function disableItems(highchart, options, items) {
  for (var i = 0; i < highchart.series.length; i++) {
    if (highchart.series[i].legendGroup) {
      highchart.series[i].legendGroup.element.onmouseover = null;
      if (items[i]) items[i].querySelector('text').style.cursor = 'default';
    }
  }
}

function checkHideColorChips(options) {
  var product = options.product,
      type = options.type,
      legend = options.legend;
  var layout = legend.layout,
      showColorChips = legend.showColorChips;

  return product === 'wsj' && layout === 'right' && !showColorChips && (type === 'line' || type === 'area');
}

// Takes the color in the block and applies it to the text.
function formatItems(highchart, options, items) {
  var hideColorChips = checkHideColorChips(options);
  var x = 0;
  var initX = 0;
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    // Draw the key with the correct dimensions:
    var rect = null;
    var path = null;

    if (rect = item.querySelector('rect')) {
      if (options.product !== 'marketwatch' && options.id !== 'video' && options.id !== 'twitterVideo') {
        var _ref = options.product === 'wsj' ? [10, 10, 7] : [13, 9, 5],
            _ref2 = (0, _slicedToArray3.default)(_ref, 3),
            height = _ref2[0],
            width = _ref2[1],
            y = _ref2[2];

        rect.setAttribute('width', options.print ? 4 : width);
        rect.setAttribute('height', options.print ? 6 : height);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', options.print ? 9 : y);
      }
      if (false) {
        if (options.product === 'financialnews') {
          var circleX = Number(items[i].children[0].getAttribute('x'));
          var circleY = Number(items[i].children[0].getAttribute('y'));
          var circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
          var positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 11;
          var positionX = options.print ? 0 : 7;
          var circle = highchart.renderer.circle(positionX, positionY, circleRadius).attr({
            fill: items[i].children[1].getAttribute('fill')
          });
          items[i].append(circle.element);
          if (options.print) {
            items[i].children[0].setAttribute('x', circleX + 10);
          }
          rect.setAttribute('opacity', 0);
        }
      }

      if (false) {
        if ((options.type === 'bar' || options.type === 'area' || options.type === 'column') && options.product === 'marketwatch') {
          rect.setAttribute('width', 13);
          rect.setAttribute('height', 13);
          rect.setAttribute('x', -3);
          rect.setAttribute('y', 5);
        }
      }
      if (hideColorChips) {
        rect.setAttribute('display', 'none');
      }
    } else if (path = item.querySelector('path')) {
      path.setAttribute('stroke-dasharray', 'none');
      path.setAttribute('stroke-linecap', 'butt');

      if (options.product !== 'marketwatch') {
        path.setAttribute('stroke-width', options.print ? 6 : 13);
        path.setAttribute('d', options.print ? 'M 0 12 L 4 12' : 'M 0 11 L 9 11');
      }

      if (false) {
        if (options.product === 'wsj') {
          path.setAttribute('stroke-width', options.styles.legend.rectHeight);
          path.setAttribute('d', 'M 0 12 L ' + options.styles.legend.rectWidth + ' 12');
        }
      }

      if (false) {
        if (options.type === 'line' && options.product === 'marketwatch') {
          path.setAttribute('stroke-width', 3);
          path.setAttribute('d', 'M 0 11 L 9 11');
        } else if (options.type !== 'line' && options.product === 'marketwatch') {
          path.setAttribute('stroke-width', options.print ? 6 : 13);
          path.setAttribute('d', options.print ? 'M 0 12 L 4 12' : 'M 0 11 L 9 11');
        }
      }
      if (false) {
        if (options.product === 'financialnews') {
          var itemsChildrenLength = items[i].children.length;
          var pathColorIndex = 0;
          var circleIndex = 1;
          if (itemsChildrenLength === 3) {
            pathColorIndex = 1;
            circleIndex = 2;
          }
          var pathColor = items[i].children[pathColorIndex].getAttribute('stroke');
          var _circleX = Number(items[i].children[circleIndex].getAttribute('x'));
          var _circleY = Number(items[i].children[circleIndex].getAttribute('y'));
          var _circleRadius = options.print && options.sizes['print-fn'].columns <= 2 ? 5.5 : 5;
          var _positionY = options.print && options.sizes['print-fn'].columns <= 2 ? 3 : 4;
          var _positionX = options.print ? 10 : 8;
          var _circle = highchart.renderer.circle(_circleX - _positionX, _circleY - _positionY, _circleRadius).attr({
            fill: pathColor
          });
          items[i].append(_circle.element);
          path.setAttribute('opacity', 0);
          if (options.print) {
            var translateVal = items[i].getAttribute('transform');
            var getLastVal = translateVal.split(',');
            items[i].setAttribute('transform', 'translate(10,' + getLastVal[1]);
          }
        }
      }

      if (hideColorChips) {
        path.setAttribute('display', 'none');
        if (options.markedDataPoints) {
          var marker = item.querySelector('.highcharts-point');
          marker.setAttribute('display', 'none');
        }
      }
    }

    if (options.print) {
      var text = item.querySelector('text');
      text.setAttribute('x', 6);
    }

    if (options.product === 'wsj' && !options.print) {
      var _text = item.querySelector('text');
      _text.setAttribute('y', 17);
    }

    if (hideColorChips) {
      var tspans = item.querySelectorAll('tspan');
      [].concat((0, _toConsumableArray3.default)(tspans)).forEach(function (tspan) {
        var currentX = +tspan.getAttribute('x');
        tspan.setAttribute('x', -2);
      });
    }

    // Space the items apart. TODO: Figure out how to make Highcharts do this!
    // if (options.legend.layout !== 'right') {
    //   const translate = transform.read(item, 'translate');
    //   if (i === 0) {
    //      initX = translate[0];
    //   }
    //   if (translate[0] <= initX) {
    //     x = 0;
    //   }
    //   transform.write(item, 'translate', translate[0] + x);
    //   x += options.print ? 6 : 12;
    // }
  }
}

function positionRightAlignedItems(highchart, options, items) {
  switch (options.type) {
    case 'area':
    case 'line':
      positionLineItems(highchart, items, options);
      break;
    case 'column':
      positionColumnItems(highchart, items, options);
      break;
    case 'bar':
      positionItemsMiddle(highchart);
      break;
  }
}

function positionLineItems(highchart, items, options) {
  // const isTooSmallForLineUp = options.series.length > 4 && options.height < 400;
  var itemY = getLineItemsY(highchart.container, items, options);
  var botY = highchart.plotTop + highchart.plotHeight;
  positionLegendItems(itemY, items, options, botY, highchart);
  // if (!isTooSmallForLineUp) {
  //   positionLegendItems(itemY, items, options, botY, highchart);
  // } else {
  //   positionItemsMiddle(highchart);
  // } 
}

function positionColumnItems(highchart, items, options) {
  var itemY = getColumnItemsY(highchart.container, items, options);
  var botY = highchart.plotTop + highchart.plotHeight;
  positionItemsMiddle(highchart);
}

// Necessary because Highcharts messes up "middle".
function positionItemsMiddle(highchart) {
  var legendEl = highchart.container.querySelector('g.highcharts-legend');
  var translate = transform.read(legendEl, 'translate');
  var height = legendEl.getBoundingClientRect().height;
  var newY = highchart.plotTop + (highchart.plotHeight - height) / 2;
  if (translate) transform.write(legendEl, 'translate', translate[0], newY);
}

// Positions the legend items to track data points but not overlap.
function positionLegendItems(itemY, items, options, botY, highchart) {
  var lineHeight = parseFloat(options.styles.lineHeight.normal);
  var midIndex = Math.min(itemY.length - 1, Math.round(itemY.length / 2));
  var margin = 8; //options.print ? 4 : 8;
  var willFit = true;

  // let y = itemY[midIndex].y;
  // for (let i = midIndex - 1; i >= 0; i--) {
  //   let h = items[itemY[i].index].getBoundingClientRect().height + margin;
  //   itemY[i].y = Math.min(itemY[i].y, y - h);
  //   y = itemY[i].y;
  // }
  // y = itemY[midIndex].y +
  // items[itemY[midIndex].index].getBoundingClientRect().height + margin;

  // find the Y positions for the corresponding series by matching color
  var legendItemPositions = [].concat((0, _toConsumableArray3.default)(items)).map(function (legendItem, i) {
    var _ref3 = options.type === 'line' ? ['path', 'stroke'] : ['rect', 'fill'],
        _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        el = _ref4[0],
        attr = _ref4[1];

    var colorChip = legendItem.querySelector(el);
    var color = window.getComputedStyle(colorChip).getPropertyValue(attr);
    var match = itemY.find(function (obj) {
      return obj.color === color;
    });
    return { index: i, y: match.y };
  });
  sortItemY(legendItemPositions);
  var y = legendItemPositions[0].y;

  legendItemPositions.forEach(function (position) {
    position.y = Math.max(position.y, y);
    y = position.y + items[position.index].getBoundingClientRect().height + margin;
  });

  // y = 0;
  // for (let i = 0; i < midIndex; i++) {
  //   itemY[i].y = Math.max(y, itemY[i].y);
  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  // }

  // for (let i = midIndex; i < items.length; i++) {
  //   // let h = y + items[itemY[i - 1].index].getBoundingClientRect().height;// + margin;
  //   itemY[i].y = Math.max(itemY[i].y, y);
  //   y = itemY[i].y + items[itemY[i].index].getBoundingClientRect().height + margin;
  // }


  legendItemPositions.forEach(function (position) {
    if (position.y > botY) {
      positionItemsMiddle(highchart);
      willFit = false;
    }
  });

  // Finally, set the Y of the actual legend item element.
  if (willFit) {
    legendItemPositions.forEach(function (position) {
      if (position.y < botY) {
        transform.write(items[position.index], 'translate', null, position.y);
      }
    });
  }
}

// Returns array of Y positions for each legend item for column charts.
function getColumnItemsY(container, items, options) {
  var fontSize = parseFloat(options.styles.size.normal);
  var seriesEl = container.querySelector('.highcharts-series-group');
  var barsEl = seriesEl.querySelectorAll('.highcharts-series');
  var printOffset = options.print ? -8 : 0;
  var itemY = [];

  for (var i = 0; i < items.length; i++) {
    // Get the path's parent and path Y.
    var g = barsEl[i];
    var rects = g.querySelectorAll('rect');
    var r = rects[rects.length - 1];
    var rY = rects && rects.length ? transform.read(g, 'translate')[1] + (+r.getAttribute('y') + +r.getAttribute('height') / 2) : fontSize;

    // Combine the results.
    itemY[i] = {
      index: i,
      y: rY - fontSize + printOffset
    };
  }

  return sortItemY(itemY);
}

// Returns array of Y positions for each legend item for line/area charts.
function getLineItemsY(container, items, options) {
  var fontSize = parseFloat(options.styles.size.normal);
  var seriesEl = container.querySelector('.highcharts-series-group');
  var linesEl = seriesEl.querySelectorAll('.highcharts-series');
  var itemY = [];

  for (var i = 0; i < linesEl.length; i++) {
    // Get the path's parent and path Y.
    var _ref5 = options.type === 'area' ? [i, 'fill'] : [linesEl.length - i - 1, 'stroke'],
        _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
        lineIndex = _ref6[0],
        attr = _ref6[1];

    var pathEl = linesEl[lineIndex];
    var pathElY = transform.read(pathEl, 'translate')[1];
    var paths = pathEl.querySelectorAll('path');
    var d = transform.read(paths[0], 'd');
    var color = window.getComputedStyle(paths[0]).getPropertyValue(attr);
    d.sort(function (a, b) {
      return b[0] - a[0];
    });

    var pathY = void 0;
    if (options.type === 'line') {
      pathY = d[0][1];
    } else {
      (function () {
        var dx = d[0][0];
        var d0 = d.filter(function (item) {
          return item[0] === dx;
        }).sort(function (a, b) {
          return a[1] - b[1];
        });
        if (d0.length >= 2) {
          pathY = (d0[d0.length - 1][1] - d0[0][1]) / 2 + d0[0][1];
        } else {
          pathY = d0[0][1];
        }
      })();
    }

    // Combine the results.
    itemY[i] = {
      index: i,
      y: pathY, // + fontSize / 2,
      color: color
    };
  }
  return sortItemY(itemY);
}

// Sort on Y and return.
function sortItemY(itemY) {
  itemY.sort(function (a, b) {
    return a.y - b.y;
  });
  return itemY;
}

function compileText(series, item, options) {
  var val = options.type === 'scatter' ? series.name : lastItem(item.yData);
  return (series.markdown || '').replace(_constants.CATEGORY, options.liveMarketData || options.type === 'scatter' ? 'n/a' : compiledCategory(options) || 'n/a').replace(_constants.SERIES, series.name || 'n/a').replace(_constants.SYMBOL, item.userOptions.symbol || 'n/a').replace(_constants.VALUE, options.liveMarketData ? 'n/a' : val).replace(_constants.POINT, options.liveMarketData ? 'n/a' : compiledPoint(item.yData, options));
}

function compiledCategory(options) {
  if (!options.longCategories) return 'n/a';
  return options.categoriesAreDates && options.dates[0].value > lastItem(options.dates).value ? options.longCategories[0] : lastItem(options.longCategories);
}

function compiledPoint(data, options) {
  return lastItem(data) ? format.applyFull(lastItem(data), options.tooltips, options.type === 'pie', true, true) : 'null';
}

function lastItem(arr) {
  return typeof arr === 'string' ? arr : arr[arr.length - 1];
}

// split the color chip into two colors for threshold charts
function styleColorChip(series, item) {
  var colorChip = item.querySelector('rect');
  var topColor = series.color;
  var bottomColor = series.negativeColor;
  var _ref7 = [createSvgEl('defs'), createSvgEl('linearGradient'), createSvgEl('stop'), createSvgEl('stop')],
      defs = _ref7[0],
      gradient = _ref7[1],
      topStop = _ref7[2],
      bottomStop = _ref7[3];

  var gradientAttrs = { 'id': 'lg', 'x2': '0%', 'y2': '100%' };
  setAttrs(gradient, gradientAttrs);
  setOffset(topStop, bottomStop);
  setColor(topStop, topColor);
  setColor(bottomStop, bottomColor);
  gradient.appendChild(topStop);
  gradient.appendChild(bottomStop);
  defs.appendChild(gradient);
  item.appendChild(defs);
  colorChip.setAttribute('fill', 'url(#lg)');
}

function createSvgEl(type) {
  var svgns = 'http://www.w3.org/2000/svg';
  return document.createElementNS(svgns, type);
}

function setAttrs(el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
}

function setOffset() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (arg) {
    return arg.setAttribute('offset', '50%');
  });
}

function setColor(el, color) {
  el.setAttribute('stop-color', color);
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.preRender = preRender;
exports.postRender = postRender;

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function preRender(data, options) {
  data.tooltip = { enabled: options.interactive && options.showTooltips };
  var tooltip = data.tooltip;
  if (tooltip.enabled) {
    tooltip.borderWidth = 1;
    tooltip.borderColor = '#CCC';
    tooltip.shared = false;
    tooltip.style = getStyle(options);
    tooltip.split = false;
    tooltip.shadow = false;
    tooltip.hideDelay = options.type === 'line' || options.type === 'area' ? 500 : 5000;
    tooltip.formatter = function () {
      return formatter(data, options, this);
    };
  }

  if (false) {
    if (options.product === 'wsj') {
      tooltip.borderRadius = 0;
      tooltip.padding = 5;
    }
  }
  return data;
}

function formatter(data, options, context) {
  // hide tooltip for transparent data
  if (context.color === _constants.TRANSPARENT) return false;

  var needsCommas = options.needsCommas,
      liveMarketData = options.liveMarketData,
      isPercent = options.isPercent,
      isIntraday = options.isIntraday,
      series = options.series,
      longCategories = options.longCategories,
      tooltips = options.tooltips,
      type = options.type,
      categoriesAreDates = options.categoriesAreDates,
      optimizeDataOrder = options.optimizeDataOrder,
      stacking = options.stacking,
      axes = options.axes;


  var categories = longCategories || (options.categories ? options.categories[0] : null);

  var marketNotBar = liveMarketData && type !== 'bar';
  var category = void 0;
  if (marketNotBar) {
    var catIdx = series[0].data.findIndex(function (_ref) {
      var x = _ref.x;
      return x === context.x;
    });
    category = formatCategory(categories[catIdx]);
  }

  var _context$series$userO = context.series.userOptions,
      decimals = _context$series$userO.decimals,
      prefix = _context$series$userO.prefix,
      suffix = _context$series$userO.suffix;

  var tooltipY = getTooltipY(axes, tooltips, context.point.y);
  var isStackedPercent = (type === 'column' || type === 'area' || type === 'bar') && stacking === 'percent';
  var value = marketNotBar ? getValue(context.y, isPercent, prefix, suffix, decimals, needsCommas) : format.applyFull(tooltipY, tooltips, type === 'pie', true, true, false, isStackedPercent);

  if (!marketNotBar) {
    var firstYear = categories[0];
    var lastYear = categories[categories.length - 1];
    var isReverse = false;
    if (typeof firstYear === 'string' && typeof lastYear === 'string' && categoriesAreDates) {
      var firstYearSplit = firstYear.split(' ');
      var lastYearSplit = lastYear.split(' ');
      if (firstYearSplit.indexOf('p.m.') !== -1 && firstYearSplit.indexOf('a.m.') !== -1) {
        var firstYearTime = firstYearSplit[firstYearSplit.length - 2];
        var firstYearTimeSplit = firstYearTime.split(':');
        var hourFirstTimeSplit = parseInt(firstYearTimeSplit) + 12;
        hourFirstTimeSplit = hourFirstTimeSplit.toString();
        firstYearTimeSplit[0] = hourFirstTimeSplit;
        firstYearTimeSplit = firstYearTimeSplit.join(':');
        var lastYearTime = lastYearSplit[lastYearSplit.length - 2];
        var lastYearTimeSplit = lastYearTime.split(':');
        var hourLastTimeSplit = parseInt(lastYearTimeSplit) + 12;
        hourLastTimeSplit = hourLastTimeSplit.toString();
        lastYearTimeSplit[0] = hourLastTimeSplit;
        lastYearTimeSplit = lastYearTimeSplit.join(':');

        isReverse = firstYearTimeSplit > lastYearTimeSplit;
      } else {
        isReverse = findIfReverse(categories);
      }
    }

    if (isReverse) {
      categories.reverse();
    }
    var seriesData = !data.series ? series : data.series;
    var dataPoint = getDataPoint(seriesData, context, isReverse);
  }
  var index = dataPoint ? dataPoint.index : null;

  if (type === 'pie' && optimizeDataOrder && dataPoint.point.hasOwnProperty('originalIndex')) {
    category = context.point.name;
  } else if (!marketNotBar) {
    category = categories ? categories[index] : context.point.category || context.point.options.name;
  }
  var formatter = { category: category, value: value, index: index };

  if (isStackedPercent) {
    return formatStackedPercent(data, options, context, formatter);
  }
  return formatStandard(options, context, formatter);
}

function formatCategory(category) {
  var month = category.match(/([A-za-z]{3,})(\s|.)/g);
  var day = category.match(/(\d{1,2}),/g);
  var year = category.match(/\d{4}/g);
  var time = category.match(/(\d{1,2}):(\d{2})|\s\d{1,2}\s/g);
  var ampm = category.match(/(a|p).m./g);
  var updatedDate = '';
  if (month) updatedDate += formatMonth(month) + ' ';
  if (day) updatedDate += day[0] + ' ';
  if (year) updatedDate += year[0];
  if (time) {
    updatedDate += ' ' + time[0] + ' ' + ampm[0];
  }
  return updatedDate;
}

function formatMonth(month) {
  return month[0].slice(0, 3);
}

function getTooltipY(axes, tooltips, y) {
  if (axes.units) {
    return format.getDivisor(axes.units.divisor) * y / format.getDivisor(tooltips.divisor);
  }
  return y;
}

function getValue(y, isPercent, prefix, suffix, decimals, needsCommas) {
  return isPercent ? y.toFixed(1) + '%' : formatY(y, decimals, needsCommas, prefix, suffix);
}

function formatY(y, decimals, needsCommas, prefix, suffix) {
  y = y.toFixed(decimals);

  if (!needsCommas) return y;

  var _y$split = y.split('.'),
      _y$split2 = (0, _slicedToArray3.default)(_y$split, 2),
      dollars = _y$split2[0],
      cents = _y$split2[1];

  var digitsArr = dollars.split('').reverse();
  var commasAdded = addCommas(digitsArr);
  var finalString = prefix + formatDollars(commasAdded);
  if (cents) finalString += '.' + cents;
  return finalString + suffix;
}

function addCommas(digits) {
  return digits.reduce(function (str, digit, i) {
    return str + checkComma(i) + digit;
  }, '');
}

function checkComma(i) {
  return i % 3 === 0 && i > 0 ? ',' : '';
}

function formatDollars(digits) {
  return digits.split('').reverse().join('');
}

function findIfReverse(categories) {
  var currentDateComparison = categories[0];
  if (isNaN(Date.parse(currentDateComparison))) {
    var currentDateComparisonLength = currentDateComparison.split(' ').length;
    if (currentDateComparisonLength === 2) {
      currentDateComparison = currentDateComparison.split(' ').join(' 1, ');
      currentDateComparison = currentDateComparison.replace('.', '');
    }
  }
  for (var f = 1; f < categories.length; f++) {
    var currentCategory = categories[f];
    if (isNaN(Date.parse(currentCategory))) {
      var currentIndexComparisonLength = categories[f].split(' ').length;
      if (currentIndexComparisonLength === 2) {
        currentCategory = currentCategory.split(' ').join(' 1, ');
        currentCategory = currentCategory.replace('.', '');
      }
    }
    if (isNaN(new Date(currentCategory))) {
      return false;
    }
    if (f === 1) {
      if (Date.parse(currentDateComparison) < Date.parse(currentCategory)) {
        return false;
      }
    } else {
      // currentDateComparison = categories[f - 1];
      if (Date.parse(currentDateComparison) < Date.parse(currentCategory)) {
        return false;
      }
      if (f === categories.length - 1 && Date.parse(currentDateComparison) > Date.parse(currentCategory)) {
        return true;
      }
    }
  }
}

function getDataPoint(series, context, isReverse) {
  if (context.x !== undefined) {
    for (var s = 0; s < series.length; s++) {
      for (var d = 0; d < series[s].data.length; d++) {
        if (series[s].data[d].x === context.x) {
          return { point: series[s].data[d], index: series[s].data[d].index };
        }
      }
    }
  }
  return {
    point: context.point,
    index: context.point.hasOwnProperty('index') ? context.point.index : context.point.x
  };
}

// NEVER CALLED
// function divideValue(value, divisorUnit) {
//   if (divisorUnit && divisorUnit !== 'none') {
//     const divisor = format.getDivisor(divisorUnit);
//     return +value / divisor;
//   }
//   return value;
// }

function space() {
  return '<span style="color: rgba(255, 255, 255, 0);">x</span>';
}

function formatStandard(options, context, formatter) {
  var isWSJWeight = options.product === 'wsj' ? 500 : 600;
  return ['<span>', formatSeries(options, context), '<span>', formatter.category, '</span>', space(), '<span style="font-weight: ' + isWSJWeight + ';">', formatter.value, '</span>', '</span>'].join('');
}

function formatStackedPercent(data, options, context, formatter) {
  var isWSJWeight = options.product === 'wsj' ? 500 : 600;
  var total = 0;
  data.series.forEach(function (item) {
    total += item.data[formatter.index].y;
  });
  return ['<span style="', formatter.style, '">', formatSeries(options, context), '<span style="padding: 0 6px 0 0;">', formatter.category, '</span>', space(), '<span style="font-weight: ' + isWSJWeight + '; margin: 0 0 0 24px">', formatter.value, ' (', Math.round(context.point.y / total * 100), '%)', '</span>', '</span>'].join('');
}

function formatSeries(options, context) {
  if (options.legend.enabled && options.series.length > 1) {
    var css = void 0;
    var defaultCSS = ['padding: 0 6px 0 0;'];

    if (options.product !== 'wsj') {
      css = defaultCSS.concat(['font-weight: 600;', 'color: ' + context.series.color + ';']).join('');
    }

    if (options.product === 'wsj') {
      css = defaultCSS.concat(['font-weight: 500;']).join('');
    }
    var nameArray = options.type === 'scatter' ? context.point.value.toString().split(' ') : context.series.name.toString().split(' ');
    if (nameArray[0] === '<br') {
      for (var i = 0; i < nameArray.length; i++) {
        if (nameArray[i] === '<br' || nameArray[i] === '/>') {
          nameArray.splice(i, 1);
          i--;
        }
      }
    }
    nameArray = nameArray.join(' ');
    return ['<span style="' + css + '">', nameArray, '</span>', space()].join('');
  }
}

function getStyle(options) {
  var width = options.width > 300 ? '400px' : '250px';
  var data = {
    padding: '8px',
    width: width,
    fontSize: '14px',
    fontFamily: options.styles.font.normal,
    fontWeight: options.styles.weight.normal,
    fontStyle: 'normal',
    color: '#000000',
    whiteSpace: 'normal !important',
    overflow: 'auto'
  };

  if (false) {
    if (options.product === 'wsj') {
      data.fontSize = '15px';
      data.lineHeight = '18px';
      data.fontWeight = 300;
    }
  }

  return data;
}

function postRender(highchart, options) {}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preRender = preRender;
exports.postRender = postRender;

var _axesPrerender = __webpack_require__(280);

var _axesPrerender2 = _interopRequireDefault(_axesPrerender);

var _axesPostrender = __webpack_require__(284);

var _axesPostrender2 = _interopRequireDefault(_axesPostrender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = null;

function preRender(data, options) {
  styles = writeStyles(options);
  return (0, _axesPrerender2.default)(data, options, styles);
}

function postRender(highchart, options) {
  styles = writeStyles(options);
  return (0, _axesPostrender2.default)(highchart, options, styles);
}

// Writes styles constants used throughout axes processing.
function writeStyles(options) {
  // const isWSJOnline = !options.product === 'wsj' && options.print ? options.styles.get('normal') : 
  // options.styles.get('normal').fontFamily = '"Retina Narrow", sans-serif';
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  var normal = options.styles.get('normal');
  if (options.product === 'wsj' && !options.print) {
    if (options.categoriesAreDates || options.type !== 'column') normal.fontFamily = '"Retina Narrow", sans-serif';
    if (isVideoGroup) normal.fontWeight = 400;
    normal.lineHeight = 15;
  }
  var defaultOptions = {
    FONT_SIZE: parseFloat(options.styles.size.normal),
    NORMAL_STYLE: normal,
    LIGHT_STYLE: options.styles.get('normal', {
      fontFamily: options.styles.font.light,
      fontWeight: options.styles.weight.light
    }),
    BOLD_STYLE: options.styles.get('normal', {
      fontFamily: options.styles.font.bold,
      fontWeight: options.styles.weight.bold
    }),
    SHORT_TICK_LENGTH: 4,
    MEDIUM_TICK_LENGTH: 7,
    LONG_TICK_LENGTH: parseFloat(options.styles.size.normal) + 5,
    MARGIN: 3
  };

  if (false) {
    if (options.product === 'marketwatch') {
      return Object.assign({}, defaultOptions, {
        NORMAL_STYLE: options.styles.get('normal', {
          fontFamily: options.styles.font.semibold,
          fontWeight: options.styles.weight.semibold
        })
      });
    }
  }

  if (false) {
    if (options.product === 'wsj') {
      var hideTicks = !options.categoriesAreDates && options.type === 'column';
      return Object.assign({}, defaultOptions, {
        SHORT_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.shortSize,
        MEDIUM_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.mediumSize,
        FONT_SIZE: options.styles.axes.label.fontSize,
        LONG_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.longSize,
        AXES: options.styles.axes
      });
    }
  }

  if (options.product === 'knewz') {
    return Object.assign({}, defaultOptions, {
      NORMAL_STYLE: options.styles.get('normal', {
        fontWeight: 700,
        fontSize: options.styles.axes.label.fontSize,
        lineHeight: options.styles.axes.label.lineHeight
      })
    });
  }

  if (false) {
    if (options.product === 'mansionglobal') {
      return Object.assign({}, defaultOptions, {
        AXES: options.styles.axes
      });
    }
  }

  return defaultOptions;
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(202);

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = axesPreRender;
exports.formatterYAxisLabel = formatterYAxisLabel;

var _format = __webpack_require__(14);

var format = _interopRequireWildcard(_format);

var _constants = __webpack_require__(3);

var _axesCommon = __webpack_require__(49);

var _annotationsPrerender = __webpack_require__(209);

var _recessions = __webpack_require__(210);

var _zero = __webpack_require__(31);

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(211);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isPrint = void 0;

function axesPreRender(data, options, styles) {
  data = writeCommonOptions(data, options);
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  switch (options.type) {
    case 'pie':
      return data;
    case 'bar':
      data = writeHorizontalOptions(data, options, styles);
      break;
    default:
      data = writeVerticalOptions(data, options, styles);
      break;
  }
  if (options.product !== 'financialnews') {
    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#bfbfbf' : '#e6e6e6';
  } else {
    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#000000' : '#e6e6e6';
  }

  if (options.product === 'knewz') {
    data.yAxis.gridLineColor = '#fefefe';
  }

  if (isVideoGroup) {
    if (options.id === 'video') {
      data.xAxis.gridLineColor = '#CBCBCB';
      data.yAxis.gridLineColor = '#CBCBCB';
    }
    if (options.id === 'twitterVideo') {
      data.xAxis.gridLineColor = '#8B8B8B';
      data.yAxis.gridLineColor = '#8B8B8B';
    }
    data.xAxis.lineColor = '#656565';
    data.xAxis.lineWidth = options.id === 'video' ? 11 : 8;
  }

  data = writeMinMax(data, options);
  if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
    tickIntervalCalc(options, data, true);
  }
  if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
    tickIntervalCalc(options, data, false);
  }

  if (!options.yAxisMobileEnabled && options.yAxisMobileInterval !== '' && options.yAxisMobileInterval !== undefined && options.width < 620) {
    setTickIntervalForYAxis(options, data, true);
  }

  if (options.yAxisInterval !== '' && options.yAxisInterval !== undefined && (options.width >= 620 || options.yAxisMobileEnabled)) {
    setTickIntervalForYAxis(options, data, false);
  }

  data.xAxis.plotBands = options.plotBands ? getPlotBands(options) : [];

  data.yAxis.plotLines = options.plotLines[0].plotLineValue ? options.plotLines.reduce(function (accum, plotLine) {
    if (plotLine.plotLineValue) {
      var label = options.type === 'bar' ? {
        text: plotLine.plotLineLabel,
        verticalAlign: plotLine.plotLineLabelPosition.includes('top') ? 'top' : 'bottom',
        textAlign: plotLine.plotLineLabelPosition.includes('top') ? 'left' : 'right',
        x: plotLine.plotLineLabelPosition.includes('right') ? 6 : -13,
        y: 0,
        style: {
          color: '#323232',
          fontFamily: 'Retina Narrow'
        }
      } : {
        text: plotLine.plotLineLabel,
        align: plotLine.plotLineLabelPosition.includes('right') ? 'right' : 'left',
        x: plotLine.plotLineLabelPosition.includes('right') ? -10 : 0,
        y: plotLine.plotLineLabelPosition.includes('top') ? -6 : 15,
        style: {
          color: '#323232',
          fontFamily: 'Retina Narrow'
        }
      };
      accum.push({
        value: plotLine.plotLineValue,
        color: plotLine.plotLineColor,
        dashStyle: plotLine.plotLineDashStyle,
        width: plotLine.id === 'video' ? 11 : plotLine.id === 'twitterVideo' ? 8 : 2,
        zIndex: ['area', 'bar', 'column'].includes(options.type) ? 5 : 3,
        label: label
      });
    }
    return accum;
  }, []) : [];
  return data;
}

function getPlotBands(options) {
  var plotBands = options.plotBands,
      id = options.id;

  var isVideoGroup = id === 'video' || id === 'twitterVideo';

  return plotBands.map(function (band) {
    var offset = (0, _momentTimezone2.default)(band.to).tz('America/New_York').utcOffset();

    var _map = ['to', 'from'].map(function (prop) {
      return (0, _momentTimezone2.default)(band[prop]).add(offset, 'm').valueOf();
    }),
        _map2 = (0, _slicedToArray3.default)(_map, 2),
        to = _map2[0],
        from = _map2[1];

    return {
      to: to,
      from: from,
      color: isVideoGroup ? _recessions.VIDEO_COLOR_BAND : _recessions.COLOR_BAND
    };
  });
}

function setTickIntervalForYAxis(options, data, isMobile) {
  var typeOfInterval = isMobile ? 'yAxisMobileInterval' : 'yAxisInterval';
  var interval = options[typeOfInterval];
  if (interval !== '') {
    data.yAxis.tickInterval = Number(interval);
  }
}

function tickIntervalCalc(options, data, isMobile) {
  var typeOfInterval = isMobile ? 'mobileXAxisInterval' : 'xAxisInterval';
  var interval = options[typeOfInterval].split(' ')[0];
  var unit = options[typeOfInterval].split(' ')[1];
  if (unit === 'years' || unit === 'year') {
    data.xAxis.tickInterval = 24 * 3600 * 1000 * 365 * parseInt(interval);
  }
  if (unit === 'months' || unit === 'month') {
    data.xAxis.tickInterval = 24 * 3600 * 1000 * 30 * parseInt(interval);
  }
  if (unit === 'day') {
    data.xAxis.tickInterval = 24 * 3600 * 1000;
  }
  if (unit === 'week') {
    data.xAxis.tickInterval = 24 * 3600 * 1000 * 7;
  }
}

function checkForType(type) {
  return function () {
    for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
      types[_key] = arguments[_key];
    }

    return types.includes(type);
  };
}

// Options common to all charts with axes.
function writeCommonOptions(data, options) {
  var type = options.type,
      product = options.product;

  var checkChartTypes = checkForType(type);
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  var offsetVal = isVideoGroup ? 15 : 0;
  var oppositeVal = false;
  var horizontalGridLineStyle = 'solid';
  if (checkChartTypes('line', 'area')) {
    data.plotOptions.series.connectNulls = options.connectEmptyDataPoints !== 'none';
  }
  if (false) {
    if (product === 'marketwatch' && checkChartTypes('line', 'scatter')) {
      offsetVal = 4;
      oppositeVal = true;
    }
    if (product === 'marketwatch' && type === 'column') {
      horizontalGridLineStyle = 'dash';
      oppositeVal = true;
      offsetVal = 8;
    }
  }
  if (false) {
    if (product === 'financialnews' && checkChartTypes('line', 'column', 'scatter')) {
      oppositeVal = true;
      offsetVal = 4;
    }
  }

  var endOnTick = options.axes.maxYAxisValue ? false : true;
  var startOnTick = options.axes.minYAxisValue ? false : true;

  var endOnTickX = false;
  var startOnTickX = false;

  if (type === 'scatter') {
    endOnTickX = options.axes.maxXAxisValue ? false : true;
    startOnTickX = options.axes.minXAxisValue ? false : true;
  }

  if (product === 'marketwatch' && type === 'line') {
    endOnTickX = true;
    startOnTickX = true;
  }

  data.xAxis = {
    title: {
      text: options.headings.xaxisTitle.text.toUpperCase(),
      style: {
        fontSize: options.styles.title.fontSize,
        fontFamily: options.styles.title.fontFamily
      },
      offset: 20
    },
    tickColor: '#000000',
    startOnTick: startOnTickX,
    endOnTick: endOnTickX,
    overscroll: calculateOverscroll(options)
  };
  data.yAxis = {
    title: {
      text: options.headings.yaxisTitle.text.toUpperCase(),
      style: {
        fontSize: options.styles.title.fontSize,
        fontFamily: options.styles.title.fontFamily
      },
      offset: 40
    },
    tickColor: '#000000',
    offset: offsetVal,
    opposite: oppositeVal,
    gridLineDashStyle: horizontalGridLineStyle,
    startOnTick: startOnTick,
    endOnTick: type === 'scatter' || endOnTick,
    allowDecimals: options.allowDecimals
    // lineColor: options.type === 'scatter' ? '#e6e6e6' : '#ffffff',
    // lineWidth: options.type === 'scatter' ? 1 : 0
  };

  if (false) {
    if (product === 'wsj') {
      data.xAxis.tickColor = options.styles.tick.color;
    }
  }
  // data.yAxis.opposite = true;
  // if (options.stacking === 'normal') {
  // data.yAxis.max = 100;
  // }
  return data;
}

function calculateOverscroll(options) {
  var series = options.series,
      id = options.id,
      irregularDates = options.irregularDates,
      markedDataPoints = options.markedDataPoints;

  var isVideoGroup = id === 'video' || id === 'twitterVideo';
  var multiplier = isVideoGroup ? 25 : 5;
  return irregularDates && markedDataPoints ? (0, _annotationsPrerender.findMilliseconds)(options, series[0].data) * multiplier : 0;
}

// Writes chart options for bar charts (i.e., horizontal bars).
function writeHorizontalOptions(data, options, styles) {
  if (options.horizontalBarType === 'normal') {
    if (Array.isArray(options.categories)) {
      data.xAxis.categories = getCategoryLabels(options.categories[0]);
    }
    data.xAxis.tickLength = 0;
    data.xAxis.offset = -2;
    data.xAxis.lineWidth = 0;
    data.yAxis.gridLineWidth = 1;

    if (false) {
      if (options.size === 'print-wsj') {
        data.yAxis.gridLineWidth = 0.5;
      }
    }

    var lineHeight = styles.BOLD_STYLE.fontSize;
    data.xAxis.labels = {
      style: (0, _lodash2.default)({}, styles.BOLD_STYLE, {
        whiteSpace: 'wrap', textOverflow: 'visible', lineHeight: lineHeight
      }),
      // step: 1,
      x: -7,
      y: options.print ? 3 : undefined,
      align: 'left',
      reserveSpace: true
      // format: '{value}',
    };
    if (options.id === 'print-barrons') {
      data.xAxis.labels.style.fontSize = 7.5;
    }

    if (options.axes.shown) {
      data.yAxis.reversedStacks = false;
      data.yAxis.opposite = true;
      data.yAxis.reversed = !!options.axes.reversed;
      data.yAxis.labels = {
        y: -5,
        style: (0, _lodash2.default)({}, styles.NORMAL_STYLE, { whiteSpace: 'nowrap', textOverflow: 'visible`' }),
        autoRotation: false,
        formatter: function formatter() {

          var special = options.axes.reversed && this.isLast || !options.axes.reversed && this.isFirst;
          return formatterBarYAxisLabel(options.axes.units, this.value, special);
        }
      };
      if (options.id === 'print-barrons') {
        data.yAxis.labels.style.fontSize = 7.5;
      };
    }

    if (false) {
      if (options.product === 'wsj') {
        data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
          fontSize: options.styles.axes.label.bar.x.fontSize,
          fontWeight: options.styles.axes.label.bar.x.fontWeight,
          lineHeight: options.styles.axes.label.bar.x.lineHeight
        });

        data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
          fontSize: options.styles.axes.label.bar.y.fontSize,
          fontWeight: options.styles.axes.label.bar.y.fontWeight,
          lineHeight: options.styles.axes.label.bar.y.lineHeight
        });
      }
    }
    if (false) {
      if (options.product === 'mansionglobal') {
        data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
          color: options.styles.axes.color
        });

        data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
          color: options.styles.axes.color
        });
      }
    }
  } else {
    if (Array.isArray(options.categories)) {
      data.xAxis.categories = getCategoryLabels(options.categories[0]);
    }
    data.xAxis.tickLength = 0;
    data.xAxis.offset = -2;
    data.xAxis.lineWidth = 0;
    data.yAxis.gridLineWidth = options.horizontalBarType === 'aboveBar' ? 0 : 1;
    data.yAxis.visible = false;
    var _lineHeight = styles.BOLD_STYLE.fontSize;

    var numerator = 1;
    var denominator = 5;
    var seriesLength = data.series[0].data.length;
    var getNewDemoninator = (seriesLength - 1) * 2.5;
    denominator = denominator + getNewDemoninator;
    if (options.horizontalBarType === 'noScaleAndLeft') {
      data.xAxis.labels = {
        style: (0, _lodash2.default)({}, styles.BOLD_STYLE, {
          whiteSpace: 'wrap', textOverflow: 'visible', lineHeight: _lineHeight
        }),
        // step: 1,
        x: -7,
        y: options.print ? 3 : undefined,
        align: 'left',
        reserveSpace: true
        // format: '{value}',
      };
    } else {
      data.xAxis.labels = {
        style: (0, _lodash2.default)({}, styles.BOLD_STYLE, {
          whiteSpace: 'nowrap', textOverflow: 'visible', lineHeight: _lineHeight
        }),
        // step: 1,
        x: -2,
        align: 'left',
        y: -(options.height * numerator / denominator)
        // format: '{value}',
      };
    }

    if (options.id === 'print-barrons') {
      data.xAxis.labels.style.fontSize = 7.5;
    }

    if (options.axes.shown) {
      data.yAxis.reversedStacks = false;
      data.yAxis.opposite = true;
      data.yAxis.reversed = !!options.axes.reversed;
      data.yAxis.labels = {
        y: -5,
        style: (0, _lodash2.default)({}, styles.NORMAL_STYLE, { whiteSpace: 'nowrap', textOverflow: 'visible`' }),
        autoRotation: false,
        formatter: function formatter() {

          var special = options.axes.reversed && this.isLast || !options.axes.reversed && this.isFirst;
          return formatterBarYAxisLabel(options.axes.units, this.value, special);
        }
      };
      if (options.id === 'print-barrons') {
        data.yAxis.labels.style.fontSize = 7.5;
      };
    }

    if (false) {
      if (options.product === 'wsj') {
        data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
          fontSize: options.styles.axes.label.bar.x.fontSize,
          fontWeight: options.styles.axes.label.bar.x.fontWeight,
          lineHeight: options.styles.axes.label.bar.x.lineHeight
        });

        data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
          fontSize: options.styles.axes.label.bar.y.fontSize,
          fontWeight: options.styles.axes.label.bar.y.fontWeight,
          lineHeight: options.styles.axes.label.bar.y.lineHeight
        });
      }
    }
    if (false) {
      if (options.product === 'mansionglobal') {
        data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
          color: options.styles.axes.color
        });

        data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
          color: options.styles.axes.color
        });
      }
    }
  }
  return data;
}

function formatterBarYAxisLabel(units, value, special) {
  value = format.decimals(value, units);
  value = format.commas(value, units);
  var prefix = units.prefix || '';
  var suffix = units.suffix || '';
  if (prefix && value.charAt(0) === '-') {
    // If value is negative, put the negative sign *before* the prefix.
    value = '-' + prefix + value.substr(1);
  } else {
    value = '' + prefix + value;
  }
  if (special && suffix) {
    value += suffix;
  }
  return value;
}

// Writes chart options for column charts (i.e, vertical bars) and charts for
// which the axes are the same as for column charts (i.e., line charts).
function writeVerticalOptions(data, options, styles) {
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  var Q = options.quarterlyResults && options.series[0].data.length <= 44;
  isPrint = options.print;
  var defaultXGridWidth = 0;
  if (false) {
    if (options.type === 'line' && options.product === 'marketwatch') {
      data.xAxis.tickColor = 'rgba(0, 0, 0, 0)';
      defaultXGridWidth = 1;
    }
    if (options.type === 'column' && options.product === 'marketwatch') {
      data.xAxis.tickColor = 'rgba(0, 0, 0, 0)';
    }
  }
  if (false) {
    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
      data.xAxis.tickColor = 'rgba(0, 0, 0, 0)';
    }
  }

  if (options.type === 'scatter') {
    data.xAxis.tickColor = 'rgba(0, 0, 0, 0)';
  }

  data.xAxis.tickWidth = 1;
  data.xAxis.lineWidth = 0;
  data.xAxis.gridLineWidth = options.type === 'scatter' ? 1 : 0;
  if (options.product === 'marketwatch' && options.type === 'line') {
    data.xAxis.gridLineWidth = 1;
  }
  data.xAxis.minorGridLineWidth = defaultXGridWidth;
  data.yAxis.gridLineWidth = options.id === 'print-barrons' ? 0.4 : 1;
  data.yAxis.tickPixelInterval = isVideoGroup ? 90 : parseFloat(styles.NORMAL_STYLE.lineHeight) * 3;
  data.yAxis.reversed = !!options.axes.reversed;
  var alignYAxis = 'right';
  var yAxisXVal = -10;
  if (false) {
    if (options.size === 'print-wsj') {
      data.xAxis.tickWidth = 0.5;
      data.yAxis.gridLineWidth = 0.5;
    }
    if (isVideoGroup) {
      alignYAxis = 'left';
      yAxisXVal = 0;
    }
  }
  var yAxisYVal = -5;
  if (false) {
    if ((options.product === 'marketwatch' || options.product === 'financialnews') && (options.type === 'line' || options.type === 'column')) {
      alignYAxis = 'left';
      yAxisXVal = 0;
      yAxisYVal = -2.5;
    }
  }
  if (false) {
    if (options.product === 'financialnews') {
      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
        styles.LIGHT_STYLE.fontSize = 7.75;
      }
    }
  }
  if (options.print === true && options.product === 'financialnews') {
    styles.LIGHT_STYLE.color = '#000000';
  }
  if (options.id === 'print-barrons') {
    yAxisYVal = -2;
  }

  data.yAxis.labels = {
    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
    autoRotation: false,
    align: alignYAxis,
    x: yAxisXVal,
    reserveSpace: isVideoGroup ? true : undefined,
    y: calculateYAxesLabelY(options, yAxisYVal),
    formatter: function formatter() {
      var tp = this.axis.tickPositions;
      var decimalsDelta = Math.abs(tp[0] - tp[1]);
      var decimalPlaces = Number.isInteger(decimalsDelta) ? 0 : roundPlaces(decimalsDelta);
      // special = should have prefix and/or suffix:
      var special = options.axes.reversed && this.isFirst || !options.axes.reversed && this.isLast;
      return formatterYAxisLabel(options.axes.units, this.value, decimalPlaces, special);
    }
  };

  options.axes.tickStyle = options.axes.tickStyle || 'center';
  data.xAxis.labels = {
    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
    autoRotation: false,
    maxStaggerLines: 1
  };
  data.xAxis.labels.style.textOverflow = 'visible';
  if (!options.allowCategoriesLinebreak) {
    data.xAxis.labels.style.whiteSpace = 'nowrap';
  }
  data.xAxis.labels.align = 'center';
  data.xAxis.labels.y = styles.FONT_SIZE + 7;
  data.xAxis.tickLength = styles.MEDIUM_TICK_LENGTH;
  data.xAxis.labels.overflow = 'allow';

  if (false) {
    if (options.size === 'print-wsj') {
      data.xAxis.labels.y -= 4;
    }
    if (isVideoGroup) {
      if (options.id === 'video') data.xAxis.labels.y += 6;else data.xAxis.labels.y += 2;
    }
  }

  if (options.type === 'scatter') {
    data.xAxis.type = 'linear';
    // const maxNum = Match.ceil(Math.max.apply(null, xValues));
    // data.xAxis.max = Math.ceil(Math.max.apply(null, xValues));
    if (options.axes.minXAxisValue) data.xAxis.min = Number(options.axes.minXAxisValue);
    if (options.axes.maxXAxisValue) data.xAxis.max = Number(options.axes.maxXAxisValue);
    if (options.axes.xAxisIncrementsForScatter) data.xAxis.tickInterval = Number(options.axes.xAxisIncrementsForScatter);
  }

  if (Array.isArray(options.categories) && (Q || !options.categoriesAreDates) && options.type !== 'scatter') {
    var categoryLabels = getCategoryLabels(options.categories[0]);
    var isArticle = (0, _axesCommon.checkArticle)(options.size, options.product);
    var hiddenCategories = isArticle ? options.hiddenCategoriesArticle : options.hiddenCategoriesPromo;
    data.xAxis.categories = categoryLabels.map(function (label, i) {
      return hiddenCategories.includes(i) ? '' : label;
    });
    data.xAxis.tickWidth = 1;
    data.xAxis.tickmarkPlacement = 'on';
    data.xAxis.tickPositioner = function () {
      return this.tickPositions.filter(function (position) {
        return !hiddenCategories.includes(position);
      });
    };
    if (Q) {
      data.xAxis.labels.formatter = formatterQuarterlyResults(options);
    }
  }
  if (options.categoriesAreDates && !Q) {
    data.xAxis.labels.style.whiteSpace = 'nowrap';

    if (options.fiscalYears) {
      data.xAxis.tickInterval = _axesCommon.YEAR_MILLISECONDS;
    } else {
      var firstDate = new Date(options.originalCategories[0]);
      var lastDate = new Date(options.originalCategories[options.originalCategories.length - 1]);
      var diff = Math.abs((firstDate.getTime() - lastDate.getTime()) / (24 * 3600 * 1000));
      var hasMoreThanTwoDays = diff > 2;
    }
    if (data.xAxis.tickInterval) {
      data.xAxis.tickInterval = Math.round(data.xAxis.tickInterval);
    }

    data.xAxis.labels.formatter = function () {
      var label = options.xAxisTicks[this.value].label;

      return label || null;
    };
    data.xAxis.tickPositioner = function () {
      return Object.keys(options.xAxisTicks).map(function (value) {
        return +value;
      });
    };
    data.xAxis.type = 'datetime';
  }

  if (false) {
    if (options.product === 'wsj') {
      var isPrintColor = options.print ? 'rgb(0, 0, 0)' : options.styles.axes.label.color;
      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
        fontSize: options.styles.axes.label.fontSize,
        color: isPrintColor,
        fill: isPrintColor
      });

      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
        fontSize: options.styles.axes.label.fontSize,
        color: isPrintColor,
        fill: isPrintColor
      });

      if (options.type === 'column' && !options.categoriesAreDates) {
        data.xAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
          fontSize: options.styles.axes.label.seriesAreNotDates.fontSize,
          fontWeight: options.styles.axes.label.seriesAreNotDates.fontWeight,
          lineHeight: options.styles.axes.label.seriesAreNotDates.lineHeight
        });
      }

      if (options.type === 'area') {
        data.yAxis.gridZIndex = 4;
      }
    }
  }

  if (false) {
    if (options.product === 'mansionglobal') {
      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
        color: options.styles.axes.color
      });

      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
        color: options.styles.axes.color
      });
    }
  }

  if (options.id === 'print-barrons') {
    data.xAxis.labels.style.fontSize = 7.5;
    data.yAxis.labels.style.fontSize = 7.5;
  }
  return data;
}

function calculateYAxesLabelY(options, initialValue) {
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  if (false) {
    if (options.product === 'wsj') {
      if (options.size === 'print-wsj') {
        if (options.type === 'line') {
          return -2.5;
        }

        if (options.type === 'column') {
          return -1.5;
        }
      }
      if (options.type === 'scatter') {
        return 5;
      }
      if (isVideoGroup) {
        return -12;
      }
      return -2;
    }
  }

  if (options.product !== 'wsj' && options.type === 'scatter') {
    return 5;
  }

  return initialValue;
}

// Returns correct spacing between ticks on x-axis depending.
function getDatetimeTickInterval(context, options) {
  if (options.datesAll) {
    var currYear = void 0;
    var yearsTraversed = 0;
    var yearRepeated = false;

    var currMonth = void 0;
    var monthsTraversed = 0;
    var monthRepeated = false;

    var currDate = void 0;
    var datesTraversed = 0;
    var dateRepeated = false;

    if (options.datesAll.year && !options.datesAll.month) {
      var isYears = true;
      for (var i = 0; isYears && i < options.dates.length; i++) {
        if (currYear === undefined || options.dates[i].year !== currYear) {
          currYear = options.dates[i].year;
        } else if (options.dates[i].year === currYear) {
          isYears = false;
        }
      }
      return _axesCommon.YEAR_MILLISECONDS;
    }

    for (var _i = 0; _i < options.dates.length; _i++) {
      // If data passes through >= 3 years but data is spaced less than a year
      // apart, ensure that ticks are spaced by years.
      if (options.datesAll.year && options.datesAll.month) {
        if (currYear === undefined || options.dates[_i].year !== currYear) {
          currYear = options.dates[_i].year;
          yearsTraversed += 1;
        } else if (!yearRepeated && options.dates[_i].year === currYear) {
          yearRepeated = true;
        }
        if (yearRepeated && yearsTraversed >= 3) {
          return _axesCommon.YEAR_MILLISECONDS;
        }
      }
    }

    for (var _i2 = 0; _i2 < options.dates.length; _i2++) {
      // If data passes through >= 3 months but data is spaced less than a
      // month apart, ensure that ticks are spaced by months.
      if (options.datesAll.month && options.datesAll.date) {
        if (currMonth === undefined || options.dates[_i2].month !== currMonth) {
          currMonth = options.dates[_i2].month;
          monthsTraversed += 1;
        } else if (!monthRepeated && options.dates[_i2].month === currMonth) {
          monthRepeated = true;
        }
        if (monthRepeated && monthsTraversed >= 3) {
          return 1000 * 60 * 60 * 24 * 30;
        }
      }
    }

    for (var _i3 = 0; _i3 < options.dates.length; _i3++) {
      // If data passes through >= 3 dates but data is spaced less than a day
      // apart, ensure that ticks are spaced by days.
      if (options.datesAll.date) {
        if (currDate === undefined || options.dates[_i3].date !== currDate) {
          currDate = options.dates[_i3].date;
          datesTraversed += 1;
        } else if (!dateRepeated && options.dates[_i3].date === currDate) {
          dateRepeated = true;
        }
        if (dateRepeated && datesTraversed >= 3) {
          return 1000 * 60 * 60 * 24;
        }
      }
    }

    if (options.datesAll.hour && !options.datesAll.year && !options.datesAll.month) {
      var fd = options.dates[0];
      var ld = options.dates[options.dates.length - 1];
      var d1 = new Date();
      var d2 = new Date();
      var hour = 1000 * 60 * 60;
      d1.setUTCHours(fd.hour);
      d1.setUTCMinutes(fd.minute);
      d2.setUTCHours(ld.hour);
      d2.setUTCMinutes(ld.minute);
      if (d2.valueOf() - d1.valueOf() > hour) {
        return hour;
      }
    }
  }
  return null;
}

// A Highcharts `formatter` function to format x-axis dates.
function formatterDate(context, options, interval) {
  // INDEX = (INDEX >= options.series[0].data.length) ? 0 : INDEX;
  // const index = INDEX++;
  var index = getDataIndex(context.value, options.series[0].data, interval);

  // This gives some whack results...
  // const date = new Date(context.value);

  // ...therefore, track the index of this tick:
  // options.xAxisLabelIndex = options.xAxisLabelIndex || 0;
  // options.xAxisLabelIndex %= options.series[0].data.length;
  // const index = options.xAxisLabelIndex;
  // const date = new Date(options.series[0].data[index].x);
  var date = new Date(context.value);
  var momentDate = _momentTimezone2.default.utc(context.value);

  // options.xAxisLabelIndex += 1;

  options.dateTimeLabelFormat = context.dateTimeLabelFormat;
  var labelFormat = options.dateTimeLabelFormat;
  // if (labelFormat === '%H:%M') labelFormat = '%e. %b'

  // const dateObj = options.dates[index];
  switch (labelFormat) {
    case '%H:%M':
    case '%H:%M:%S':
      var incSecs = false; //context.dateTimeLabelFormat === '%H:%M:%S';
      options.series[0].data[index].xAxisLabel = formatHM( /*date*/momentDate, incSecs);
      return formatHM( /*date*/momentDate, incSecs);
    case '%e. %b':
      options.series[0].data[index].xAxisLabel = [_constants.MONTHS[date.getUTCMonth()], date.getUTCDate()].join(' ');
      return [_constants.MONTHS[date.getUTCMonth()], date.getUTCDate()].join(' ');
    case '%b \'%y':
      if (options.dates[index].yearIsProxy) {
        options.series[0].data[index].xAxisLabel = _constants.MONTHS[date.getUTCMonth()];
        return _constants.MONTHS[date.getUTCMonth()];
      } else {
        options.series[0].data[index].xAxisLabel = [_constants.MONTHS[date.getUTCMonth()], '’' + (date.getUTCFullYear() + '').substr(2)].join(' ');
        return [_constants.MONTHS[date.getUTCMonth()], '’' + (date.getUTCFullYear() + '').substr(2)].join(' ');
      }
    case '%Y':
      // console.log(index, date.getUTCFullYear(), date.getFullYear(), realDate.getFullYear());
      options.series[0].data[index].xAxisLabel = date.getUTCFullYear() + '';
      //(dateObj.year || realDate.getUTCFullYear()) + '';
      // return dateObj.year || (date.getFullYear() + '');
      return date.getUTCFullYear() + '';
  }
  options.series[0].data[index].xAxisLabel = '0';
  return '0';
}

function getDataIndex(value, data, interval) {
  var index = 0;
  for (var i = 0; i < data.length; i++) {
    index = i;
    if (value < data[i].x) {
      break;
    }
  }
  return index;
}

function formatHM(date, includeSeconds) {
  // const offset = date.utcOffset() / 60;
  var h = date.hours(); //date.getUTCHours();
  // console.log('in formatHM', date, h, date.utc().hours())
  //h += offset + 4;
  var a = h < 12 ? ' a.m.' : ' p.m.';
  var m = (0, _zero.addZeroes)(date.minutes() /*date.getUTCMinutes()*/, 2);
  var s = includeSeconds ? (0, _zero.addZeroes)(date.seconds() /*date.getUTCSeconds()*/, 2) : null;
  if (h === 12 && m == '00') {
    return 'noon';
  }
  if (h === 0 || h === 12) {
    h = 12;
  } else {
    h %= 12;
  }
  m = m === '00' ? '' : ':' + m;
  s = includeSeconds ? ':' + s : '';
  return [h, m, s, a].join('');
}

// Used as Highcharts `formatter` function (not directly).
function formatterYAxisLabel(units, value, minDecimals, special) {
  value += '';
  var decimalUnits = (0, _lodash2.default)({}, units);
  if (units.forceDecimals !== undefined) {
    decimalUnits.forceDecimals = Math.max(units.forceDecimals, minDecimals);
  }
  if (units.maxDecimals !== undefined) {
    decimalUnits.maxDecimals = Math.max(units.maxDecimals, minDecimals);
  }
  value = format.decimals(value, decimalUnits);
  value = format.commas(value, units.commas);
  if (special) {
    var neg = '';
    if (units.prefix && value.charAt(0) === '-') {
      neg = '-';
      value = value.substr(1);
    }
    value = [neg, units.prefix, value].join('');
  }
  return value;
}

// A Highcharts `formatter` function that returns 'nQ<br/>YYYY'.
function formatterQuarterlyResults(options) {
  var rows = options.series[0].data.length;
  var quarter = undefined;
  var year = undefined;
  return function () {
    var value = '';
    var parts = this.value.split(/\s/);
    var tmpQ = parts[0] || null;
    var tmpY = parts[1] || null;
    var FY = tmpY ? tmpY.indexOf('FY') === 0 : false;
    if (FY) {
      tmpY = tmpY.substr(2);
    }
    if (this.isFirst) {
      // Sometimes Highcharts runs through the date *twice*!
      quarter = year = undefined;
    }
    if (tmpQ && rows <= 9 && options.interactive) {
      value += tmpQ;
    }
    if (tmpY) {
      if (value !== '') {
        value += '<br>';
      }
      if (tmpY !== year) {
        if (year === undefined) {
          value += (FY ? 'FY' : '') + tmpY;
        } else {
          value += _constants.APOSTROPHE + tmpY.substr(2, 4);
        }
      }
    }
    quarter = tmpQ;
    year = tmpY;
    return value;
  };
}

// Returns an array of category objects as an array of strings for use as the
// value for `data[x|yAxis].categories`.
function getCategoryLabels(categories) {
  var strings = [];
  if (categories) {
    categories.forEach(function (cat, index) {
      if (typeof cat === 'string' || typeof cat === 'number') {
        strings[index] = cat + '';
      } else if (cat && (typeof cat === 'undefined' ? 'undefined' : (0, _typeof3.default)(cat)) === 'object') {
        strings[index] = cat.text;
      } else {
        strings[index] = '';
      }
    });
  }
  return strings;
}

// Attempts to allow manual tweaking of min and max axis values, but does not
// quite do what is requested: Set an *absolute* max and min, whereas
// Highcharts uses the values as a guide.
function writeMinMax(data, options) {
  if (options.type !== 'pie') {
    if (options.axes.minYAxisValue !== undefined) {
      data.yAxis.min = options.axes.minYAxisValue;
    }
    if (options.axes.maxYAxisValue !== undefined) {
      data.yAxis.max = options.axes.maxYAxisValue;
    }
  }
  return data;
}

// Finds if yAxis.min should be set automatically so as to ensure that
// a zero line is included.
function valuesBelowPositive2(options) {
  var found = false;
  for (var s = 0; s < options.series.length; s++) {
    for (var d = 0; d < options.series[s].data.length; d++) {
      if (options.series[s].data[d].y < 0) {
        return false;
      } else if (!found && options.series[s].data[d].y <= 2) {
        found = true;
      }
    }
  }
  return found;
}

// Finds if yAxis.max should be set automatically so as to ensure that
// a zero line is included.
function valuesAboveNegative2(options) {
  var found = false;
  for (var s = 0; s < options.series.length; s++) {
    for (var d = 0; d < options.series[s].data.length; d++) {
      if (options.series[s].data[d].y > 0) {
        return false;
      } else if (!found && options.series[s].data[d].y <= -2) {
        found = true;
      }
    }
  }
  return found;
}

// Sometimes decimals are 17 or something outrageous, but decimalsDelta is something like 0.20000000000000002
// which should be just 0.2. This fixes the issue.
function roundPlaces(float) {
  for (var places = 1; places < 19; places++) {
    if (float.toFixed(places) + '0' === float.toFixed(places + 1)) break;
  }
  return places;
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPoint;

// Returns a point by its original index, before sorting by date.
function getPoint(series, index) {
  return series[0].hasOwnProperty('index') ? series.find(function (item) {
    return item.index === index;
  }) : series[index];
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.31
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(0)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.31",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = {"version":"2020a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = axesPostRender;

var _transform = __webpack_require__(18);

var transform = _interopRequireWildcard(_transform);

var _axesPostrenderYAxis = __webpack_require__(285);

var _axesPostrenderYAxis2 = _interopRequireDefault(_axesPostrenderYAxis);

var _axesPostrenderXAxis = __webpack_require__(286);

var _axesPostrenderXAxis2 = _interopRequireDefault(_axesPostrenderXAxis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function axesPostRender(highchart, options, styles) {
  makeLinesCrisp(highchart, options);
  if (options.type !== 'pie' && options.horizontalBarType === 'normal') {
    (0, _axesPostrenderYAxis2.default)(highchart, options, styles);
    if (options.type === 'line' || options.type === 'column' || options.type === 'area') {
      if (options.categoriesAreDates && !options.quarterlyResults) {
        var ticks = highchart.xAxis[0].ticks;
        for (var key in ticks) {
          if (options.xAxisTicks[key].type === 'minor') {
            var tick = ticks[key].mark.element;
            var d = tick.getAttribute('d');
            var dArr = d.split(' ');
            dArr[5] = +dArr[5] - 2.5;
            var newD = dArr.join(' ');
            tick.setAttribute('d', newD);
          }
        }
        if ((0, _axesPostrenderXAxis.checkVideoGroup)(options.id)) {
          (0, _axesPostrenderXAxis.extendVideoAxisLine)(highchart);
        }
        var labels = highchart.xAxis[0].labelGroup.element.children;

        if (options.product === 'marketwatch') {
          var firstLabel = labels[0];
          var _x = +firstLabel.getAttribute('x');

          var _firstLabel$getBoundi = firstLabel.getBoundingClientRect(),
              _width = _firstLabel$getBoundi.width;

          if (_x < _width / 2) {
            if (_x < 0) firstLabel.setAttribute('x', 0);
            firstLabel.setAttribute('text-anchor', 'start');
          }
        }
        var lastLabel = labels[labels.length - 1];
        var x = +lastLabel.getAttribute('x');

        var _lastLabel$getBoundin = lastLabel.getBoundingClientRect(),
            width = _lastLabel$getBoundin.width;

        if (x + width / 2 > options.width) {
          lastLabel.setAttribute('text-anchor', 'end');
        }
      }
    } else {
      (0, _axesPostrenderXAxis2.default)(highchart, options, styles);
    }
  }

  if (options.type === 'bar' && (options.horizontalBarType === 'aboveBar' || options.horizontalBarType === 'noScaleAndLeft')) {
    // for first label sit inside bar
    var highchartContainer = highchart.container;
    var allDataLabels = highchartContainer.getElementsByClassName('highcharts-data-labels')[0];
    var firstDataLabel = highchartContainer.getElementsByClassName('highcharts-data-labels')[0].children[0];
    var firstDataLabelRight = firstDataLabel.getBoundingClientRect().right;
    var xAxisLabels = highchartContainer.getElementsByClassName('highcharts-xaxis-labels')[0];
    var arrayOfLabelWidths = [];
    for (var g = 0; g < xAxisLabels.children.length; g++) {
      var currentXAxisLabelWidth = xAxisLabels.children[g].getBoundingClientRect().width;
      arrayOfLabelWidths.push(currentXAxisLabelWidth);
    }
    for (var i = 0; i < allDataLabels.children.length; i++) {
      var currentDataLabel = allDataLabels.children[i];
      var currentDataLabelWidth = currentDataLabel.getBoundingClientRect().width;
      var correspondingBarHeight = highchartContainer.getElementsByClassName('highcharts-bar-series')[0].children[i].getAttribute('height');
      var highestXAxisLabelWidth = Math.max.apply(Math, arrayOfLabelWidths);
      var stringLengthOfLabel = currentDataLabel.children[0].innerHTML.length;
      var heightPlusTen = Number(correspondingBarHeight) + (10 - stringLengthOfLabel);

      if (options.horizontalBarType === 'aboveBar') {
        if (i !== 0) {
          transform.write(currentDataLabel, 'translate', heightPlusTen);
        }
      }

      if (options.horizontalBarType === 'noScaleAndLeft') {
        heightPlusTen += highestXAxisLabelWidth + 5;
        if (options.horizontalBarLabel && i === 0) {
          var additionalSpace = 10;
          if (stringLengthOfLabel > 5 && stringLengthOfLabel < 10) additionalSpace = 5;
          if (stringLengthOfLabel >= 10) additionalSpace = -10;
          heightPlusTen -= currentDataLabelWidth + additionalSpace;
        }
        transform.write(currentDataLabel, 'translate', heightPlusTen);
      }
    }
    if (options.horizontalBarType === 'noScaleAndLeft') {
      var axis = highchart.axes[0];
      var axisLeft = axis.chart.plotLeft;
      var axisSizeX = axis.chart.plotSizeX;
      var elementPathFirst = highchart.renderer.path().attr({
        stroke: '#333',
        fill: 'black',
        'stroke-width': 1,
        class: 'add-vertical-gridline',
        d: "M " + axisLeft + ' 10 L ' + axisLeft + ' ' + axisSizeX,
        opacity: 1
      });
      var root = highchartContainer.getElementsByClassName('highcharts-series-group')[0];
      root.appendChild(elementPathFirst.element);
    }
  }

  if (false) {
    if (options.product === 'wsj' && options.print && options.type !== 'bar' && options.type !== 'pie') {
      var suffix = highchart.container.getElementsByClassName('units y-axis-suffix')[0];
      suffix.style.fill = 'rgb(0, 0, 0)';
    }
  }

  if (options.print && options.type === 'bar') {
    var barCont = highchart.container.getElementsByClassName('highcharts-bar-series');
    for (var _i = 0; _i < barCont.length; _i++) {
      var highchartBarG = barCont[_i];
      var highchartBarGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartBarG.getAttribute('transform'));
      var xValTranslate = parseInt(highchartBarGTransformVal[1]) - 1.5;
      highchartBarG.transform.baseVal.getItem(0).setTranslate(xValTranslate, parseInt(highchartBarGTransformVal[2]));
    }
  }
  if (options.print && options.type === 'column') {
    if (options.product === 'wsj') {
      var seriesGroup = highchart.container.getElementsByClassName('highcharts-series-group')[0];
      var seriesGroupTransformVal = seriesGroup.transform.baseVal.getItem(0).matrix.f;
      var seriesGroupYVal = seriesGroupTransformVal - 1;
      seriesGroup.transform.baseVal.getItem(0).setTranslate(0, seriesGroupYVal);
    }
    var colCont = highchart.container.getElementsByClassName('highcharts-column-series');
    for (var _i2 = 0; _i2 < colCont.length; _i2++) {
      var highchartColumnG = colCont[_i2];
      var highchartColumnGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartColumnG.getAttribute('transform'));
      var yValTranslate = parseInt(highchartColumnGTransformVal[2]) + 1;
      highchartColumnG.transform.baseVal.getItem(0).setTranslate(parseInt(highchartColumnGTransformVal[1]), yValTranslate);
    }
    if (options.product === 'wsj') {
      var rectGroup = highchart.container.getElementsByClassName('highcharts-point');
      for (var h = 0; h < rectGroup.length; h++) {
        var rect = rectGroup[h];
        var rectHeight = parseInt(rect.getAttribute('height'));
        var rectY = parseInt(rect.getAttribute('y'));
        rect.setAttribute('height', rectHeight + 1);
        rect.setAttribute('y', rectY - 2);
      }
    }
  }

  if (false) {
    if (options.product === 'wsj' && options.type === 'bar' && options.horizontalChartType === 'normal') {
      var yAxis = highchart.container.getElementsByClassName('highcharts-yaxis-labels');
      yAxis[0].setAttribute('transform', 'translate(0, 2)');

      // align h-bar xAxis labels to the left
      var xAxis = highchart.container.getElementsByClassName('highcharts-xaxis-labels');
      var xLabels = xAxis[0].childNodes;

      xLabels.forEach(function (label) {
        label.setAttribute('x', '0');
        label.setAttribute('text-anchor', 'start');

        var tspans = label.childNodes;

        tspans.forEach(function (tspan) {
          tspan.setAttribute('x', '0');
        });
      });
    }
  }
}

// Ensures lines are offset by 0.5 to ensure crispness.
// TODO: If ever combining inner and outer charts, revisit this function!
function makeLinesCrisp(highchart, options) {
  var g = highchart.container.querySelectorAll('svg > g');

  for (var i = 0; i < g.length; i++) {
    var list = g[i].classList;

    if (!list.contains('highcharts-legend')) {
      g[i].setAttribute('transform', 'translate(0, 0.5)');
    }

    if (false) {
      if (options.product === 'wsj') {
        if (list.contains('highcharts-xaxis')) {
          g[i].setAttribute('transform', 'translate(0, ' + options.styles.tick.yOffset + ')');
        }
      }
    }
  }
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = axesPostRenderYAxis;

var _transform = __webpack_require__(18);

var transform = _interopRequireWildcard(_transform);

var _util = __webpack_require__(24);

var _constants = __webpack_require__(3);

var _element = __webpack_require__(15);

var element = _interopRequireWildcard(_element);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Manipulates the SVG drawn by Highcharts to update the scale (Y) axis.
 */
function axesPostRenderYAxis(highchart, options, styles) {
  // The scale axis is always the Y axis, even on bar charts where the scale
  // axis visually is the X axis:
  // for wsj yaxis labels, set to tabular-nums
  var notVideoGroup = options.id !== 'video' && options.id !== 'twitterVideo';

  if (!options.print && options.product === 'wsj' && notVideoGroup) {
    highchart.container.getElementsByClassName('highcharts-yaxis-labels')[0].setAttribute('style', 'font-variant-numeric: tabular-nums;');
  }

  if (options.type === 'scatter' && options.headings.yaxisTitle.text) {
    moveYAxisTitle(highchart, options);
  }

  var axis = highchart.axes[1];
  if ((0, _util.isVerticalType)(options.type)) {
    makeDecimalsConsistent(axis);
    extendTicks(axis, options);
  } else {
    if (options.type !== 'scatter') shiftLastHorizontalBarLine(highchart, options);
  }

  setZeroLineToBlack(axis, options, highchart);

  insertZeroesForEmptyBars(highchart.renderer, axis, options);
  if ((options.type === 'column' || options.type === 'bar') && options.id !== 'video' && options.id !== 'twitterVideo') {
    moveZeroLineToTop(highchart.container, axis, options);
  }
  if (notVideoGroup) {
    ensureLabelsFit(axis, options, highchart);
  }

  if (options.type === 'scatter' && (options.product === 'marketwatch' || options.product === 'financialnews')) {
    shiftYAxisLabelsScatter(options, highchart);
  }

  if (false) {
    if (options.product === 'wsj' && options.type !== 'bar') {
      // moveTopLabel(axis, options);
    }
  }

  addSuffix(highchart.renderer, axis, options, styles, highchart);

  if (options.id === 'print-barrons') {
    if (axis.ticks[0]) setZeroLineWidth(axis.ticks[0], 1);
  }

  if (options.id === 'video' || options.id === 'twitterVideo') {
    if (axis.ticks[0]) {
      setZeroLineWidth(axis.ticks[0], options.id === 'video' ? 11 : 8);
      //sets xAxis line width to 1
      setXAxisLineToOne(highchart.axes[0].axisLine);
    }
  }
}

function shiftYAxisLabelsScatter(options, highchart) {
  var container = highchart.container;
  var yAxisLabelsGroup = container.getElementsByClassName('highcharts-yaxis-labels')[0];
  var translateValue = 'translate(35, 0.5)';
  yAxisLabelsGroup.attributes.transform.nodeValue = translateValue;
}

function moveYAxisTitle(highchart, options) {
  var yAxisTitle = highchart.container.getElementsByClassName('highcharts-axis-title')[1];
  var yVal = Number(yAxisTitle.getAttribute('y'));
  if (options.product === 'wsj' || options.product === 'barrons') {
    yAxisTitle.setAttribute('y', yVal - yVal * 0.015);
  }
}

function setZeroLineWidth(line, num) {
  line.gridLine.element.setAttribute('stroke-width', num);
}

function setXAxisLineToOne(line) {
  line.element.setAttribute('stroke-width', 1);
}

// Set line representing the zero value to black.
function setZeroLineToBlack(axis, options, highchart) {
  var zeroTick = axis.ticks[0];

  if (false) {
    if (options.product === 'marketwatch' && options.type === 'column') {
      return;
    }
  }

  var zeroY = void 0;
  if (options.type === 'scatter') {
    (0, _util.forAxisTicks)(axis, function (ticks, i) {
      var label = ticks.label.textStr;
      if (label === '0' || label === '0<tspan fill-opacity="0">.0</tspan>') {
        zeroY = i;
      }
    });

    if (zeroY !== undefined) {
      var zeroTickScatter = axis.ticks[zeroY];
      zeroTickScatter.gridLine.element.setAttribute('stroke', options.styles.axes.zeroGridLine.color || '#333');
    }
  }
  if (zeroTick && options.type !== 'scatter') {
    zeroTick.gridLine.element.setAttribute('stroke', '#000');

    if (false) {
      if (options.product === 'wsj') {
        zeroTick.gridLine.element.setAttribute('stroke', options.styles.axes.zeroGridLine.color);
      }
    }
  }
}
function makeDecimalsConsistent(axis) {
  var zeroIndex = axis.tickPositions.indexOf(0);
  var maxDecimals = getMaxTicksDecimals(axis);
  if (maxDecimals > 0) {
    (0, _util.forAxisTicks)(axis, function (tick, key, index) {
      var textStr = tick.label.textStr;
      var indexDot = textStr.indexOf('.');
      var decimals = indexDot === -1 ? 0 : textStr.length - indexDot - 1;
      if (key === 0) {
        textStr += '<tspan fill-opacity="0">';
      }
      if (indexDot === -1) {
        indexDot = textStr.length;
        textStr += '.';
      }
      while (decimals++ < maxDecimals) {
        textStr += '0';
      }
      if (key === 0) {
        textStr += '</tspan>';
      }
      tick.label.textStr = textStr;
      tick.label.element.innerHTML = textStr;
    });
  }
}

// Extend grid lines under the label text on the y-axis (for "vertical" axes).
function extendTicks(axis, options) {
  if (options.type === 'scatter' || options.type === 'line' && options.product === 'marketwatch') {
    var firstTick = void 0;
    var lastTick = void 0;
    (0, _util.forAxisTicks)(axis, function (tick) {
      if (tick.isFirst) firstTick = tick;
      if (tick.isLast) lastTick = tick;
    });
    if (firstTick && lastTick) {
      var firstLine = firstTick.gridLine.element;
      var lastLine = lastTick.gridLine.element;
      var dFirst = transform.read(firstLine, 'd');
      var dLast = transform.read(lastLine, 'd');
      dFirst[0][0] = dFirst[0][0] - 1;
      dFirst[1][0] = dFirst[1][0] + 1;
      dLast[0][0] = dLast[0][0] - 1;
      dLast[1][0] = dLast[1][0] + 1;
      transform.write(firstLine, 'd', dFirst);
      transform.write(lastLine, 'd', dLast);
    }
  } else {
    (0, _util.forAxisTicks)(axis, function (tick) {
      var line = tick.gridLine.element;
      if (line.hasAttribute('d')) {
        var d = transform.read(line, 'd');
        d[0][0] = 0;
        if (options.spaceAddedForAnnotations) {
          d[1][0] += options.print ? _constants.ANNOTATIONS_SPACE_PRINT : _constants.ANNOTATIONS_SPACE;
        }
        transform.write(line, 'd', d);
        // const d = line.getAttribute('d').split(/\s/g);
        // d[1] = 0;
        // if (options.spaceAddedForAnnotations) {
        //   console.log('???');
        // }
        // line.setAttribute('d', d.join(' '));
      }
    });
  }
}

function getMaxTicksDecimals(axis) {
  var maxDecimals = 0;
  (0, _util.forAxisTicks)(axis, function (tick, pos) {
    var decimal = tick.label.textStr.split('.')[1];
    if (decimal !== undefined) {
      maxDecimals = Math.max(decimal.length, maxDecimals);
    }
  });
  return maxDecimals;
}

// Add units suffix string to the top tick label (`isLast`).
function addSuffix(renderer, axis, options, styles, highchart) {
  if (options.axes.units && (0, _util.isVerticalType)(options.type)) {
    for (var key in axis.ticks) {
      var ok1 = options.axes.reversed && axis.ticks[key].isFirst;
      var ok2 = !options.axes.reversed && axis.ticks[key].isLast;
      if (ok1 || ok2) {
        var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
        var label = axis.ticks[key].label.element;

        // To align the 0 properly with other labels without having
        // decimals, the decimals are made inivisible. But this means
        // any units suffix must be offset to not show up to the right
        // of these invisible decimals but instead right next to the 0.
        var tspan = label.querySelector('tspan');
        var xOffset = 0;
        if (isVideoGroup) {
          xOffset = label.getBoundingClientRect().width;
        }
        if (tspan && tspan.getAttribute('opacity') === '0') {
          var tspanInnerHTML = label.innerHTML + '';
          var labelFullWidth = label.getBoundingClientRect().width;
          label.innerHTML = '0';
          var labelTmpWidth = label.getBoundingClientRect().width;
          xOffset += labelTmpWidth - labelFullWidth;
          label.innerHTML = tspanInnerHTML;
        }
        var unitStr = options.product === 'financialnews' ? options.axes.units.suffix : options.axes.units.suffix.replace(/^\s+/, _constants.NBSP);
        if ((options.type === 'line' || options.type === 'column') && options.product === 'marketwatch') {
          label.innerHTML = label.innerHTML + '<tspan>' + ' ' + unitStr + '</tspan>';
          break;
        }
        if ((options.type === 'line' || options.type === 'column') && options.product === 'financialnews') {
          if (options.axes.units.suffix !== "%") {
            var labelYVal = label.getAttribute('y');
            var highChartContainer = highchart.container;
            var newLabelYVal = labelYVal - 7;
            styles.NORMAL_STYLE.fontSize = 10;
            styles.NORMAL_STYLE.color = '#555555';
            var firstYAxisLabel = highChartContainer.getElementsByClassName('highcharts-yaxis-labels')[0].lastElementChild.getBoundingClientRect().right;
            var suffix = renderer.text(unitStr, +label.getAttribute('x'), +newLabelYVal).css(styles.NORMAL_STYLE).add();
            suffix.element.setAttribute('class', 'units y-axis-suffix');
            var suffixRight = suffix.element.getBoundingClientRect().right;
            var currentSuffX = suffix.element.getAttribute('x');
            var diff = suffixRight - firstYAxisLabel;
            suffix.element.setAttribute('x', currentSuffX - diff);

            // suffix.element.setAttribute('x', currentSuffX - diff);
            break;
          } else {
            label.innerHTML = label.innerHTML + '<tspan>' + unitStr + '</tspan>';
            break;
          }
        } else {
          var css = styles.NORMAL_STYLE;

          if (false) {
            if (options.product === 'wsj') {
              css = Object.assign({}, css, {
                fontSize: styles.AXES.label.fontSize,
                color: styles.AXES.label.color,
                fill: styles.AXES.label.color
              });
            }
          }

          if (false) {
            if (options.product === 'mansionglobal') {
              css = Object.assign({}, css, {
                color: styles.AXES.color,
                fill: styles.AXES.color
              });
            }
          }

          var _suffix = renderer.text(unitStr, +label.getAttribute('x') + xOffset, +label.getAttribute('y')).css(css).add();
          var currentY = _suffix.element.getAttribute('y');
          _suffix.element.setAttribute('class', 'units y-axis-suffix');
          // aligns the suffix with the label
          if (!options.print) {
            _suffix.element.setAttribute('y', +currentY + .5);
          }
          break;
        }
      }
    }
  }
}

// On vertical bar / column charts, insert a small '0' in place of bars that
// have a zero value, so that it does not look like an error.
function insertZeroesForEmptyBars(renderer, axis, options) {
  var typeOk = options.type === 'column';
  var stackOk = !options.stacking || axis.series.length === 1;
  if (typeOk && stackOk) {
    var series = axis.series;
    var allLessThanZero = allValuesLessThanZero(axis);
    var g = [];
    axis.series.forEach(function (series) {
      series.data.forEach(function (item) {
        if (item.y === 0) {
          var el = item.graphic.element;
          var translate = transform.read(el.parentElement, 'translate');
          if (translate) {
            var x = +el.attributes.x.value + translate[0];
            var y = +el.attributes.y.value + translate[1];
            var smallStyle = options.styles.get('small');
            if (options.product === 'wsj') {
              smallStyle.color = '#555555';
            } else {
              smallStyle.color = item.color;
            }
            x += +el.attributes.width.value / 2;
            y += allLessThanZero ? parseFloat(options.styles.get('small').fontSize) : -4;
            var text = renderer.text('0', x, y).attr({ 'text-anchor': 'middle' }).css(smallStyle).add();
            g.push({ type: '0', el: text.element });
          }
        } else if (item.graphic) {
          g.push({ type: 'bar', el: item.graphic.element });
        }
      });
    });

    // Sort by `left` position.
    g.sort(function (a, b) {
      return a.el.getBoundingClientRect().left - b.el.getBoundingClientRect().left;
    });

    // Check if 0s overlap bars or other 0s and, if so, remove.
    for (var i = 0; i < g.length - 1; i++) {
      if (g[i].type === '0') {
        var r1 = g[i].el.getBoundingClientRect();
        var r2 = g[i + 1].el.getBoundingClientRect();
        if (r1.right + 2 > r2.left) {
          element.removeChild(g[i].el);
        }
      }
    }
  }
}

// Returns true if all values are <= 0.
function allValuesLessThanZero(axis) {
  return axis.series.every(function (series) {
    return series.data.every(function (item) {
      return item.y <= 0;
    });
  });
}

// In Highcharts, grid lines ares places under lines and columns, which is
// fine. But we want the 0 line to be above (as in z or depth).
function moveZeroLineToTop(container, axis, options) {
  var zero = axis.ticks[0];
  if (zero) {
    var el = zero.gridLine.element;
    if (false) {
      if (options.size === 'print-wsj') {
        var d = transform.read(el, 'd');
        if (options.type === 'bar') {
          d[0][0] = Math.floor(d[0][0]) - 0.5;
          d[1][0] = d[0][0];
        } else {
          d[0][1] = Math.ceil(d[0][1]);
          d[1][1] = d[0][1];
        }
        transform.write(el, 'd', d);
      }
    }
    container.querySelector('.highcharts-series-group').appendChild(el);
  }
}

// Sometimes Highcharts lets labels slip off the edge of chart, as if it
// measured the label width using a short label. Push the labels over so they
// all fit.
function ensureLabelsFit(axis, options, highchart) {
  // ensureHorizontalLabelsFit(axis);
  if (options.type === 'bar') {
    if (!options.axes.reversed) {
      ensureHorizontalLabelsFit(axis);
    }
  } else {
    if (!options.headings.yaxisTitle.text) {
      ensureVerticalLabelsFit(axis, options, highchart);
    }
  }
}

function ensureHorizontalLabelsFit(axis) {
  var key = axis.tickPositions[axis.tickPositions.length - 1];
  var tick = axis.ticks[key];
  var el = tick.label.element;
  var x2 = tick.label.xy.x + el.getBoundingClientRect().width / 2;
  var dif = axis.left + axis.width - x2;
  tick.label.xy.x += dif;
  if (dif < 0) {
    el.setAttribute('x', +el.getAttribute('x') + dif);
  }
}

function ensureVerticalLabelsFit(axis, options, highchart) {
  var maxWidth = 0;
  (0, _util.forAxisTicks)(axis, function (tick) {
    var width = tick.label.element.getBoundingClientRect().width;
    maxWidth = Math.max(maxWidth, width);
  });
  maxWidth = Math.ceil(maxWidth);
  if (options.product !== "marketwatch" && options.product !== 'financialnews') {
    (0, _util.forAxisTicks)(axis, function (tick) {
      tick.label.element.setAttribute('x', maxWidth);
    });
  } else {
    if (options.type !== 'scatter') {
      if (false) {
        if (options.product === 'financialnews') {
          if (options.type === 'line' || options.type === 'column') {
            var highChartContainer = highchart.container;
            var labelsG = highChartContainer.getElementsByClassName('highcharts-yaxis-labels');
            var translateValue = options.print === true ? 'translate(0, 5)' : 'translate(0, 6)';
            labelsG[0].attributes.transform.nodeValue = translateValue;
            var gElRectLabels = highChartContainer.getElementsByClassName('highcharts-yaxis-labels')[0];
            var gElRectRightLabels = gElRectLabels.getBoundingClientRect().right;
            var gElRectLabelsChildren = gElRectLabels.children;
            var horizontalGridLineArr = highChartContainer.getElementsByClassName('highcharts-yaxis-grid')[0].children;
            var gWidth = gElRectLabels.getBoundingClientRect().width;
            // if (options.type === 'line') {
            //   // translate the yaxis labels to the right based on width of surround g element
            //   gElRectLabels.setAttribute('transform', 'translate(' + gWidth + ',' + '6)' );
            //   for (let i = 0; i < gElRectLabelsChildren.length; i++) {
            //     gElRectLabelsChildren[i].setAttribute('text-anchor', 'end');
            //     // if there's a 0 in yaxis labels remove the extra space/zero
            //     const hasZero = gElRectLabels.children[i].innerHTML === '0' || gElRectLabels.children[i].innerHTML[1] === '<' ? true : false;
            //     if (hasZero) {
            //       gElRectLabels.children[i].children[0].innerHTML = '';
            //     }
            //     const currentXVal = Number(gElRectLabelsChildren[i].getAttribute('x'));
            //     const dValue = transform.read(horizontalGridLineArr[i], 'd');
            //     let lastHorizontalGridLineElD = horizontalGridLineArr[i].getAttribute('d').split(' ');
            //     const childWidth = gElRectLabelsChildren[i].getBoundingClientRect().width;
            //     // extend horizontal gridlines to match position of label, which is now right aligned. highcharts positions them to be left aligned and all horizontal gridlines end at some point, thereby having same length
            //     lastHorizontalGridLineElD[3] = ((currentXVal + (gWidth) - childWidth - 2)) + "," + dValue[1][1];
            //     // if first yaxis label has a percentage sign, decrease length of horizontal gridline to account for extra space that % creates
            //     lastHorizontalGridLineElD[3] = (options.axes.units.suffix === '%') && i === gElRectLabelsChildren.length - 1 ? ((currentXVal + (gWidth) - childWidth - 15)) + "," + dValue[1][1] : lastHorizontalGridLineElD[3];
            //     // make sure first gridline has proper length
            //     lastHorizontalGridLineElD[3] = options.axes.units.prefix !== "" && i === gElRectLabelsChildren.length - 1 ? (currentXVal - (gWidth * 0.125)) + "," + dValue[1][1] : lastHorizontalGridLineElD[3];
            //     lastHorizontalGridLineElD[2] = '';
            //     lastHorizontalGridLineElD = lastHorizontalGridLineElD.join(' ');
            //     horizontalGridLineArr[i].setAttribute('d', lastHorizontalGridLineElD);
            //   }
            // }
          }
          if (options.type !== 'line' && options.type !== 'column') {
            (0, _util.forAxisTicks)(axis, function (tick) {
              tick.label.element.setAttribute('x', maxWidth);
            });
          }
        }
      }
      if (false) {
        if (options.type === 'line' && options.product === 'marketwatch') {
          var _highChartContainer = highchart.container;

          var _labelsG = _highChartContainer.getElementsByClassName('highcharts-yaxis-labels');
          var _translateValue = 'translate(0, 6)';
          _labelsG[0].attributes.transform.nodeValue = _translateValue;
        }
        if (options.type === 'column' && options.product === 'marketwatch') {
          var _highChartContainer2 = highchart.container;
          var _labelsG2 = _highChartContainer2.getElementsByClassName('highcharts-yaxis-labels');
          var _translateValue2 = 'translate(0, 6)';
          _labelsG2[0].attributes.transform.nodeValue = _translateValue2;
        }

        if (options.type !== "line" && options.type !== 'column') {
          (0, _util.forAxisTicks)(axis, function (tick) {
            tick.label.element.setAttribute('x', maxWidth);
          });
        }
      }
    }
  }
}

function shiftLastHorizontalBarLine(highchart, options) {
  var axis = highchart.axes[1];
  (0, _util.forAxisTicksReverse)(axis, function (tick) {
    if (tick.isLast) {
      var d = transform.read(tick.gridLine.element, 'd');
      d[0][0] -= 1;
      d[1][0] = d[0][0];
      transform.write(tick.gridLine.element, 'd', d);
      // break:
      return false;
    }
  });
}

function moveTopLabel(axis, options) {
  var isColumn = options.type === 'column';
  var isPrint = options.size === 'print-wsj';
  var is8u = options.size === '8u';

  for (var tick in axis.ticks) {
    if (axis.ticks[tick].isLast) {
      var topTick = axis.ticks[tick];
      var label = axis.ticks[tick].label.element;
      var position = +label.getAttribute('y');
      var offset = -2;

      if (is8u) {
        offset = -1;
      }

      if (isColumn) {
        offset = -1;
      }

      if (isPrint) {
        offset = -.5;
      }

      var newPostition = position + offset;
      label.setAttribute('y', newPostition);
    }
  }
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = axesPostRenderXAxis;
exports.checkVideoGroup = checkVideoGroup;
exports.extendVideoAxisLine = extendVideoAxisLine;
exports.updateCategoryLabels = updateCategoryLabels;

var _util = __webpack_require__(24);

var _transform = __webpack_require__(18);

var transform = _interopRequireWildcard(_transform);

var _axesCommon = __webpack_require__(49);

var _constants = __webpack_require__(3);

var _element = __webpack_require__(15);

var element = _interopRequireWildcard(_element);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function axesPostRenderXAxis(highchart, options, style) {
  var id = options.id,
      type = options.type,
      print = options.print,
      product = options.product,
      categoriesAreDates = options.categoriesAreDates;

  var isVideoGroup = checkVideoGroup(options.id);
  if (id === 'print-barrons' && type !== 'bar') {
    updateBarronsTickLabels(highchart, options);
  }
  if (barronsNoBaseline(highchart, options) && type !== 'scatter' && type !== 'bar') {
    updateBarronsTicks(highchart, options);
  }
  if (product === 'wsj' && !print && !isVideoGroup) {
    highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0].setAttribute('style', 'font-variant-numeric: tabular-nums;');
  }
  if (product === 'knewz') {
    var xAxisContainerTicks = highchart.container.getElementsByClassName('highcharts-xaxis')[0].children;
    for (var x = 0; x < xAxisContainerTicks.length; x++) {
      xAxisContainerTicks[x].setAttribute('stroke', '#fefefe');
    }
  }
  if (type === 'bar') {
    formatBarChartLabels(highchart, options);
  } else {
    if (categoriesAreDates) {
      updateDateLabels(highchart, options, style);
    } else {
      updateCategoryLabels(highchart, options);
      if (false) {
        if (product === 'marketwatch' && type === 'line') {
          adjustFirstXAxisTick(highchart.axes[0], false, false);
        }
      }
      if (false) {
        if (product === 'financialnews' && type === 'line') {
          adjustFirstXAxisTick(highchart.axes[0], false, false);
        }
      }
    }
  }
  updateForMW(highchart, options);
  if (type === 'scatter') {
    var axis = highchart.axes[0];
    setZeroLineToBlack(highchart, options, axis);
  }

  if (isVideoGroup) {
    extendVideoAxisLine(highchart);
  }
}

function checkVideoGroup(id) {
  return id === 'video' || id === 'twitterVideo';
}

function extendVideoAxisLine(highchart) {
  var axisLine = highchart.axes[0].axisLine.element;
  var d = axisLine.getAttribute('d').split(' ');
  d[1] = '0';
  axisLine.setAttribute('d', d.join(' '));
}

function setZeroLineToBlack(highchart, options, axis) {
  var zeroX = void 0;

  (0, _util.forAxisTicks)(axis, function (ticks, i) {
    var label = ticks.label.textStr;
    if (label === '0') zeroX = i;
  });
  if (zeroX !== undefined) {
    var zeroTickScatter = axis.ticks[zeroX];
    zeroTickScatter.gridLine.element.setAttribute('stroke', options.styles.axes.zeroGridLine.color || '#333');
    var container = highchart.container;
    var xAxisGrid = container.getElementsByClassName('highcharts-yaxis-grid')[0];
    xAxisGrid.appendChild(zeroTickScatter.gridLine.element);
  }
}

function updateBarronsTickLabels(highchart, options) {
  var ticks = highchart.xAxis[0].ticks;
  for (var key in ticks) {
    var tick = ticks[key];
    var tickBottom = +tick.mark.d.split(' ')[5];
    tick.label.element.setAttribute('y', tickBottom + 7);
  }
}

function barronsNoBaseline(highchart, options) {
  var ticks = highchart.axes[1].tickPositions;
  return options.product === 'barrons' && (!highchart.axes[1].ticks[0] || ticks.some(function (tick) {
    return tick < 0;
  }) && ticks.some(function (tick) {
    return tick >= 0;
  }));
}

function updateBarronsTicks(highchart, options) {
  var ticks = highchart.axes[0].ticks;
  for (var key in ticks) {
    var el = ticks[key].mark.element;
    el.setAttribute('stroke', '#e6e6e6');
    if (options.print) el.setAttribute('stroke-width', 0.4);
  }
}

function updateForMW(highchart, options) {
  if (false) {
    if (options.product === 'marketwatch' && options.type === 'line') {
      var xAxisTicks = highchart.xAxis[0].ticks;
      var xAxisTicksAsArr = Object.keys(xAxisTicks);
      var firstTick = xAxisTicksAsArr[0];
      var lastTick = xAxisTicksAsArr[xAxisTicksAsArr.length - 1];
      for (var x in xAxisTicks) {
        var highchartXAxisGrid = highchart.container.getElementsByClassName('highcharts-xaxis-grid')[0];
        var highchartXAxisGridFirstEl = highchartXAxisGrid.firstElementChild.getAttribute('class');
        var highchartXAxisGridLastEl = highchartXAxisGrid.lastElementChild.getAttribute('class');
        var hasFirstAddedVerticalGridline = highchartXAxisGridFirstEl === 'add-vertical-gridline';
        var hasLastAddedVerticalGridline = highchartXAxisGridLastEl === 'add-vertical-gridline';
        var evalBoth = hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline;
        if (evalBoth) {
          if (xAxisTicks[x].label.element.parentElement) {} else {
            xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
          }
        } else {
          if (!hasFirstAddedVerticalGridline && !hasLastAddedVerticalGridline) {
            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst || xAxisTicks[x].isLast) {} else {
              if (!xAxisTicks[x].isFirst || !xAxisTicks[x].isLast) {
                xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
              }
            }
          }
          if (!hasFirstAddedVerticalGridline && hasLastAddedVerticalGridline) {
            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst) {} else {
              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
            }
          }
          if (!hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline) {

            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isLast) {} else {
              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
            }
          }
        }
      }
    }
  }
}

function formatBarChartLabels(highchart, options) {
  if (!options.allowCategoriesLinebreak) {
    (0, _util.forAxisTicks)(highchart.xAxis[0], function (tick) {
      var tspan = tick.label.element.querySelectorAll('tspan');
      if (tspan.length > 1) {
        // Move the top tspan down to center it vertically in its space:
        var labelY = +tick.label.element.getAttribute('y');
        var tspanY = +tspan[1].getAttribute('dy') / 2 * (tspan.length - 1);
        tick.label.element.setAttribute('y', labelY + tspanY);

        // Replace last 4 characters with an ellipsis (4 instead of 3 to be
        // ensure nothing is cut off at left):
        var textStr = tspan[0].textContent.substr(0, tspan[0].textContent.length - 4) + '...';
        tspan[0].innerHTML = textStr;

        // Remove the extra tspans:
        for (var i = 1; i < tspan.length; i++) {
          element.removeChild(tspan[i]);
        }
      }
    });
  }
}

// Remove category ticks and labels that are redudant or overlapping.
function updateCategoryLabels(highchart, options) {
  if (options.removeOverlappingCategories) {
    var maxWidth = 0;
    var ticksShown = [];
    (0, _util.forAxisTicks)(highchart.xAxis[0], function (tick, index) {
      if (tick.label.textStr === index) {
        removeTick(tick);
      } else {
        maxWidth = Math.max(maxWidth, tick.label.textPxLength);
        ticksShown.push(tick);
      }
    });
    var maxLabels = Math.floor(highchart.xAxis[0].width / maxWidth) || 0;
    var skip = Math.ceil(ticksShown.length / maxLabels);
    if (skip > 1) {
      var removeNum = 0;
      for (var i = 0; i < ticksShown.length; i++) {
        if (removeNum > 0 && removeNum < skip) {
          removeTick(ticksShown[i]);
        }
        if (++removeNum === skip) {
          removeNum = 0;
        }
      }
    }
  }
}

// Remove date ticks and labels that are redudant or overlapping.
function updateDateLabels(highchart, options, styles) {
  var axis = highchart.axes[0];
  if (options.type === 'column') {
    var categoriesLen = options.categories[0].length;
    if (options.quarterlyResults && categoriesLen > 9) {
      // centerCategoriesBetweenBars(axis, options);
    } else {
      if (axis.tickInterval < _axesCommon.YEAR_MILLISECONDS) {
        // TODO: Re-enable this but with long ticks, better rules.
        // centerCategoriesBetweenBars(axis, options);
        // centerLabelsBetweenBars(highchart, options);
      }
    }
  }
  if (options.quarterlyResults && options.series[0].data.length <= 44) {
    //   ensureMultipleLinesForQuarterlyResults(highchart, styles);
    removeOverlappingQuarterlyResults(axis, options, styles);
  } else {
    var skipNum = getDatesSkipNum(axis, styles.MARGIN);
    var startNum = formatDateLabels(axis, options, skipNum);
    removeAmPm(axis, options);
    var isMwOrFn = options.product === 'marketwatch' || options.product === 'financialnews' ? true : false;
    var tickArray = Object.keys(axis.ticks);
    if (options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
      var isAnIntervalOfOne = options.xAxisInterval.split(' ')[0] === '1' && options.xAxisInterval !== '1 week' ? true : false;
      if (isAnIntervalOfOne || options.xAxisInterval === 'auto') {
        removeOverlappingDates(axis, options, skipNum, startNum, styles);
        if (options.xAxisInterval === '1 day') {
          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
        }
      } else {
        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
          addMinorTick(axis, options, styles, highchart);
        }
        if (isMwOrFn) {
          if (options.xAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.xAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && options.type === 'column') {
          if (options.xAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.xAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && !options.showMinorTicks) {
          if (options.xAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.xAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
      }
    }

    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== undefined) {
      var isAnIntervalOfOneMob = options.mobileXAxisInterval.split(' ')[0] === '1' && options.mobileXAxisInterval !== '1 week' ? true : false;
      if (isAnIntervalOfOneMob || options.mobileXAxisInterval === 'auto') {
        removeOverlappingDates(axis, options, skipNum, startNum, styles);
        if (options.mobileXAxisInterval === '1 day') {
          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
        }
      } else {
        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
          addMinorTick(axis, options, styles, highchart);
        }
        if (isMwOrFn) {
          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && options.type === 'column') {
          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && !options.showMinorTicks) {
          if (options.mobileXAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.mobileXAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
      }
    }
  }
  if (options.fiscalYears && !options.quarterlyResults) {
    addFY(axis);
  }
  replaceApostrophes(axis);
  adjustLastXAxisTick(axis);
  ensureTickSpacing(axis, options, styles);
  if (false) {
    if (options.product === 'marketwatch' && options.type === 'line') {
      adjustFirstXAxisTick(axis, true, false);
    }
    if (options.product === 'marketwatch' && options.type === 'column' && options.quarterlyResults && options.size === 'marketwatch-4u-inset') {
      adjustFirstXAxisTick(axis, false, true);
    }
  }
  if (false) {
    if (options.product === 'financialnews' && options.type === 'line') {
      adjustFirstXAxisTick(axis, true, false);
    }
  }

  if (false) {
    if (options.product === 'wsj') {
      if (!options.showMinorTicks) {
        makeTickShorter(axis, options, styles, highchart);
      }
      var xGridTickGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
      var xGridLabelGroup = highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0];
      if (!options.print) {
        if (options.showMinorTicks) {
          xGridLabelGroup.setAttribute('transform', 'translate(0, -0.5)');
        } else {
          xGridLabelGroup.setAttribute('transform', 'translate(0, -2.5)');
        }
      }

      if (xGridTickGroup.children.length - 1 === xGridLabelGroup.children.length && options.showMinorTicks) {
        if (!options.print) xGridLabelGroup.setAttribute('transform', 'translate(0, -2.5)');
        makeTickShorter(axis, options, styles, highchart);
      }
    }
  }
}

// Moves ticks to between bars by shifting them to the left by half the space
// between ticks. For use when x-axis date labels are categories and not actual
// dates, such as quarterly data.
function centerCategoriesBetweenBars(axis, options) {
  var tickSpacing = Math.round(getTickSpacing(axis) * 0.5);
  var x = [];
  (0, _util.forAxisTicks)(axis, function (tick, tickPos, index) {
    var markD = transform.read(tick.mark.element, 'd');
    x[index] = markD[0][0] - tickSpacing; // + 0.5;
  });
  moveAxisLabels(axis, x);
}

// Move a series tick marks and labels to specific x positions.
function moveAxisLabels(axis, x) {
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    if (x[index] !== null && x[index] !== undefined) {
      var markD = transform.read(tick.mark.element, 'd');
      markD[0][0] = markD[1][0] = Math.round(x[index]) + 0.5;
      transform.write(tick.mark.element, 'd', markD[0], markD[1]);
      tick.label.element.setAttribute('x', x[index]);
      var tspan = tick.label.element.querySelectorAll('tspan');
      for (var i = 0; i < tspan.length; i++) {
        tspan[i].setAttribute('x', x[index]);
      }
    }
  });
}

// Get number of x-axis date labels that overlap and therefore must be removed.
function getDatesSkipNum(axis, margin) {
  // At least 2 points are needed if one is to overlap another.
  if (axis.tickPositions.length >= 2) {
    var widest = 0;
    var tickDistance = Math.max(2, getTickSpacing(axis) - margin);
    (0, _util.forAxisTicks)(axis, function (tick) {
      var width = tick.label.element.getBoundingClientRect().right + margin - tick.label.element.getBoundingClientRect().left;
      widest = Math.max(widest, width);
    });
    var skipNum = normalizeSkipNumber(Math.ceil(widest / tickDistance));
    var skipLabels = Math.floor(axis.tickPositions.length / skipNum);
    var maxLabels = Math.floor(axis.width / widest);
    while (skipLabels > maxLabels) {
      skipNum = normalizeSkipNumber(Math.ceil(widest / --tickDistance));
      skipLabels = Math.floor(axis.tickPositions.length / skipNum);
    }
    return skipNum;
  }
  return 0;
}

// When overlapping date labels are removed, this returns a number that is more
// normal to skip over: 10 instead of 9 or 5 instead of 3.
function normalizeSkipNumber(skip) {
  if (skip > 2 && skip < 5) {
    return 5;
  } else if (skip > 5 && skip < 10) {
    return 10;
  } else if (skip > 10 && skip < 15) {
    return 15;
  } else if (skip > 15 && skip < 20) {
    return 20;
  } else if (skip > 20 && skip < 25) {
    return 25;
  } else if (skip > 25 && skip < 50) {
    return 50;
  } else if (skip > 50 && skip < 100) {
    return 100;
  }
  return skip;
}

// Returns the distance/space between the first two ticks of an axis.
function getTickSpacing(axis) {
  var spacing = 0;
  if (axis.tickPositions.length > 1) {
    var t1 = axis.ticks[axis.tickPositions[0]];
    var t2 = axis.ticks[axis.tickPositions[1]];
    var d1 = transform.read(t1.mark.element, 'd');
    var d2 = transform.read(t2.mark.element, 'd');
    spacing = d2[0][0] - d1[0][0];
  }
  return spacing;
}

// Format x-axis dates that are not quarterly results nor fiscal years.
function formatDateLabels(axis, options, skipNum) {
  var dateType = null;
  var startNum = 0;
  skipNum = skipNum || 0;

  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    var str = tick.label.textStr;

    if (/^(\d{4})\b/.test(str)) {
      dateType = 'year';
    } else if (options.dateTimeLabelFormat === '%e. %b') {
      dateType = 'month-date';
    } else if (options.dateTimeLabelFormat === '%b \'%y') {
      dateType = 'month-year';
    }
    if (skipNum >= 2) {
      if (+str % skipNum === 0) {
        startNum = index;
        return false;
      }
    } else {
      return false;
    }
  });

  if (dateType === 'year') {
    formatYears(axis, startNum);
  } else if (dateType === 'month-year') {
    // This just removes duplicated years; we don't actually want to do this yet.
    // formatMonthYear(axis, startNum);
  } else if (dateType === 'month-date') {
    formatMonthDate(axis, startNum);
  }
  return startNum;
}

// Called from formatXAxisDates().
function formatYears(axis, startNum) {
  var century = void 0;
  var tmpCentury = void 0;
  var abbrYear = void 0;
  var prevStr = void 0;
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    if (index >= startNum) {
      var str = tick.label.textStr + '';
      if (str === prevStr) {
        prevStr = str;
        removeTick(tick);
      } else {
        prevStr = str;
        // Format: 1980 '90 2000 '10
        tmpCentury = str.substr(0, 2);
        if (tmpCentury === century) {
          str = tick.label.textStr = _constants.APOSTROPHE + str.substr(2);
          tick.label.element.innerHTML = str;
        } else {
          century = tmpCentury;
        }
        var apostMatch = str.match(/\u2019(\d\d)/);
        if (apostMatch) {
          if (abbrYear === undefined || abbrYear !== apostMatch[1]) {
            abbrYear = apostMatch[1];
          } else if (abbrYear === apostMatch[1]) {
            var apostIndex = str.indexOf(_constants.APOSTROPHE);
            if (apostIndex > 0) {
              str = str.substr(0, apostIndex - 1);
              tick.label.element.innerHTML = str;
            }
          }
        }
      }
    }
  });
}

// Called from formatXAxisDates().
function formatMonthYear(axis, startNum) {
  var year = undefined;
  (0, _util.forAxisTicks)(axis, function (tick) {
    if (tick.label.element.parentElement) {
      var label = tick.label.element.innerHTML.split(' ');
      if (label.length === 2) {
        if (label[1] === year) {
          tick.label.textStr = tick.label.element.innerHTML = label[0];
        } else {
          year = label[1];
        }
      }
    }
  });
}

// Called from formatXAxisDates().
function formatMonthDate(axis, startNum) {
  var month = undefined;
  (0, _util.forAxisTicks)(axis, function (tick) {
    if (tick.label.element.parentElement) {
      var label = tick.label.element.innerHTML.split(' ');
      if (label.length === 2 && _constants.MONTHS.indexOf(label[0]) !== -1) {
        if (label[0] === month) {
          tick.label.textStr = tick.label.element.innerHTML = label[1];
        } else {
          month = label[0];
        }
      }
    }
  });
}

// Remove superflous am/pm.
function removeAmPm(axis, options) {
  var am = void 0;
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    if (tick.label.element.parentElement) {
      var str = tick.label.textStr + '';
      if (index === 0) {
        if (str.indexOf(' a.m.') !== -1) {
          am = 'a';
        } else if (str.indexOf(' p.m.') !== -1) {
          am = 'p';
        } else if (str === 'noon') {
          am = null;
        } else {
          // Timescale is not hours.
          return;
        }
      } else if (str !== 'noon') {
        var amIndex = str.indexOf(' a.m.');
        var tmpAm = amIndex !== -1 ? 'a' : 'p';
        if (amIndex === -1) {
          amIndex = str.indexOf(' p.m.');
        }
        if (amIndex !== -1) {
          if (tmpAm === am) {
            tick.label.element.innerHTML = str.substr(0, amIndex);
          } else {
            am = tmpAm;
          }
        }
      }
    }
  });
}

// For overlapping quarterly results, remove labels that do not mention years.
function removeOverlappingQuarterlyResults(axis, options, styles) {
  var tick0 = axis.ticks[axis.tickPositions[0]];
  var rect0 = tick0.label.element.getBoundingClientRect();
  var totalSkips = 0;
  var skips = 1;
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    if (index > 0) {
      if (rect0 === null && totalSkips > 0) {
        if (tick.label.element.innerHTML) {
          if (skips > 0 && totalSkips > 1 && options.xAxisInterval === 'auto') {
            removeDateTick(tick, options, styles);
          }
          if (++skips >= totalSkips) {
            skips = 0;
          }
        }
      } else {
        if (tick.label.element.innerHTML) {
          var rect = tick.label.element.getBoundingClientRect();
          if (rect0.right + styles.MARGIN >= rect.left && options.xAxisInterval === 'auto') {
            removeDateTick(tick, options, styles);
          } else {
            rect0 = null;
          }
          ++totalSkips;
        }
      }
    }
  });
}

// Removes overlapping datetime labels, accounting for context of datetime
// labels before and after.
function removeOverlappingDates(axis, options, skipNum, startNum, styles) {
  var prevStr = null;
  var label = null;
  var isMY = options.dateTimeLabelFormat === '%b \'%y';
  var isHM = /^\%H\:\%M/.test(options.dateTimeLabelFormat);
  var axisTickLen = axis.tickPositions.length;
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    if (axisTickLen >= 2 && skipNum >= 2) {
      if (!(skipNum < 2 || (index - startNum) % skipNum === 0)) {
        removeDateTick(tick, options, styles);
      }
    }
    if (tick.label.element.parentElement) {
      if (isMY) {
        label = tick.label.textStr.split(' ');
        if (label[1] === prevStr) {
          tick.label.element.innerHTML = label[0];
        }
        prevStr = label[1];
      } else if (isHM) {
        label = tick.label.textStr;
        if (label === prevStr) {
          removeDateTick(tick, options, styles);
        }
        prevStr = label;
      }
    }
  });
}

// If fiscalYears, add 'FY' to first label.
function addFY(axis) {
  (0, _util.forAxisTicks)(axis, function (tick) {
    if (tick.label.element.parentElement) {
      tick.label.element.innerHTML = 'FY' + tick.label.textStr;
      return false;
    }
  });
}

// Ensures curly apostrophes render correctly.
function replaceApostrophes(axis) {
  (0, _util.forAxisTicks)(axis, function (tick) {
    var str = tick.label.element.innerHTML + '';
    tick.label.element.innerHTML = str.replace(_constants.APOSTROPHE, '&rsquo;');
  });
}

function adjustLastXAxisTick(axis) {
  var tick = axis.ticks[axis.tickPositions[axis.tickPositions.length - 1]];
  var markX = transform.read(tick.mark.element, 'd')[0][0];
  var labelWidth = tick.label.element.getBoundingClientRect().width;
  var offset = axis.left + axis.width - (markX + labelWidth / 2);
  tick.label.element.setAttribute('x', markX + Math.min(0, offset));
  tick.label.element.setAttribute('text-anchor', 'middle');
}

function adjustFirstXAxisTick(axis, isDateTime, isColQuarterly) {
  var tick = axis.ticks[axis.tickPositions[0]];
  var markX = transform.read(tick.mark.element, 'd')[0][0];
  var labelWidth = tick.label.element.getBoundingClientRect().width;
  if (labelWidth / 2 > markX && !isColQuarterly) {
    if (isDateTime) {
      tick.label.element.setAttribute('x', labelWidth / 2);
    } else {
      tick.label.element.setAttribute('text-anchor', 'left');
    }
  } else {
    tick.label.element.setAttribute('x', markX);
  }
  if (isColQuarterly) {
    var barContainerX = axis.chart.container.getElementsByClassName('highcharts-series-0')[0].firstElementChild.getAttribute('x');
    if (barContainerX <= 0) {
      tick.label.element.setAttribute('text-anchor', 'left');
      tick.label.element.setAttribute('x', 2);
      tick.label.element.children[1].setAttribute('x', 2);
    }
  }
}

// Ensures ticks are spaced adequately apart by removing ticks that are too
// close together.
function ensureTickSpacing(axis, options, styles) {
  var MIN = 4;
  var longs = [];
  var dx = void 0;
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    var markEl = tick.mark.element;
    if (markEl.parentElement && Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH) {
      longs.push(index);
    }
  });
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    var markEl = tick.mark.element;
    if (markEl.parentElement) {
      var d = transform.read(null, 'd', tick.mark.d);
      if (dx === undefined) {
        dx = d[0][0];
      }
      if (longs.indexOf(index) === -1) {
        if (d[0][0] - dx <= MIN) {
          element.removeChild(markEl);
        } else {
          var n = -1;
          var longFwd = longs.some(function (longIndex) {
            n = longIndex;
            return longIndex > index;
          });
          if (longFwd) {
            var longTickF = axis.ticks[axis.tickPositions[n]];
            var dlf = transform.read(null, 'd', longTickF.mark.d);
            if (dlf[0][0] - d[0][0] <= MIN) {
              element.removeChild(markEl);
            }
          }
          if (markEl.parentElement) {
            var longBck = longs.some(function (longIndex) {
              n = longIndex;
              return longIndex < index;
            });
            if (longBck) {
              var longTickB = axis.ticks[axis.tickPositions[n]];
              var dlb = transform.read(null, 'd', longTickB.mark.d);
              if (d[0][0] - dlb[0][0] <= MIN) {
                element.removeChild(markEl);
              }
            }
          }
          dx = d[0][0];
        }
      } else {
        dx = d[0][0];
      }
    }
  });
}

// Removes a date tick and label or replaces it with a short tick depending
// on the context.
function removeDateTick(tick, options, styles) {
  var labelEl = tick.label.element;
  var markEl = tick.mark.element;
  element.removeChild(labelEl);
  if (!options.showMinorTicks) {
    element.removeChild(markEl);
  }
  if (options.type === 'column') {
    element.removeChild(markEl);
  } else if (Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH && options.showMinorTicks) {
    var d = transform.read(null, 'd', tick.mark.d);
    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
    transform.write(markEl, 'd', d);
  }
}

function addMinorTick(axis, options, styles, highchart) {
  var xAxisGridGroup = axis.chart.axes[0].gridGroup.element;
  if (xAxisGridGroup.children.length > 1) {
    var firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
    var secondInGroupD = transform.read(null, 'd', xAxisGridGroup.children[1].getAttribute('d'));
    var interval = void 0;
    var unit = void 0;
    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
      interval = options.mobileXAxisInterval.split(' ')[0];
      unit = options.mobileXAxisInterval.split(' ')[1];
    }
    if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
      interval = options.xAxisInterval.split(' ')[0];
      unit = options.xAxisInterval.split(' ')[1];
    }
    interval = unit === 'week' ? 7 : interval;
    var diff = (secondInGroupD[0][0] - firstInGroupD[0][0]) / parseInt(interval);
    (0, _util.forAxisTicks)(axis, function (tick, key, index) {
      var labelEl = tick.label.element;
      var markEl = tick.mark.element;
      var d = transform.read(null, 'd', tick.mark.d);
      if (options.dates[0].year % interval !== 0 && options.dates[0].month === 1 || unit === 'months' || unit === 'week') {
        var backD = transform.read(null, 'd', tick.mark.d);
        var firstTick = void 0;
        if (unit === 'years') {
          firstTick = index === 0 ? parseInt(tick.label.element.children[0].innerHTML) : firstTick;
        }
        if (unit === 'months') {
          var label = tick.label.textStr.split(' ')[0];
          var labelMonthValue = findMonthValue(label);
          firstTick = index === 0 ? labelMonthValue : firstTick;
        }
        if (unit === 'week') {
          firstTick = index === 0 ? parseInt(tick.label.textStr.split(' ')[1]) : firstTick;
        }
        var benchmark = void 0;
        if (unit === 'years') {
          benchmark = firstTick - options.dates[0].year;
        }
        if (unit === 'months') {
          benchmark = firstTick - options.dates[0].month - 1;
        }
        if (unit === 'week') {
          benchmark = options.dates[0].date > firstTick ? firstTick + 30 - options.dates[0].date : firstTick - options.dates[0].date;
        }
        for (var w = 0; w < benchmark; w++) {
          appendToXGridGroup(highchart, diff, styles, backD, false);
        }
      }

      var tickArray = Object.keys(tick.axis.ticks);
      var lastTick = tickArray[tickArray.length - 1];
      var isLastTick = tick.pos === tick.axis.ticks[lastTick].pos ? true : false;
      if (!isLastTick) {
        for (var i = 0; i < interval - 1; i++) {
          appendToXGridGroup(highchart, diff, styles, d, true);
        }
      } else {
        var lastBenchmark = void 0;
        if (unit === 'years') {
          lastBenchmark = options.dates[options.dates.length - 1].year - parseInt(tick.label.textCache.split(',')[0]);
        }
        if (unit === 'months') {
          var _label = tick.label.textStr.split(' ')[0];
          var _labelMonthValue = findMonthValue(_label);
          lastBenchmark = options.dates[options.dates.length - 1].month - _labelMonthValue;
        }
        if (unit === 'week') {
          lastBenchmark = options.dates[options.dates.length - 1].month.date - parseInt(tick.label.textStr.split(' ')[1]);
        }
        for (var _i = 0; _i < lastBenchmark; _i++) {
          appendToXGridGroup(highchart, diff, styles, d, true);
        }
      }

      var isMonth = unit === 'months' ? true : false;
      if (unit === 'months' || unit === 'week') {
        styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth);
      }
    });
  }
  // if (xAxisGridGroup.children.length === 1) {
  //   const firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
  //   let interval;
  //   let unit;
  //   if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
  //     interval = options.mobileXAxisInterval.split(' ')[0];
  //     unit = options.mobileXAxisInterval.split(' ')[1];
  //   } 
  //   if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
  //     interval = options.xAxisInterval.split(' ')[0];
  //     unit = options.xAxisInterval.split(' ')[1];
  //   }
  //   let firstDate;
  //   let lastDate;
  //   if (unit === 'years') {
  //     firstDate = options.dates[0].year;
  //     lastDate = options.dates[options.dates.length - 1].year;
  //   }
  //   if (unit === 'months') {
  //     firstDate = options.dates[0].month;
  //     lastDate = options.dates[options.dates.length - 1].month;
  //   }
  //   if (unit === 'week') {
  //     firstDate = options.dates[0].date;
  //     lastDate = options.dates[options.dates.length - 1].date;
  //   }
  //   const axisTicksKey = Object.keys(axis.ticks);
  //   const xAxisGridLine = highchart.container.getElementsByClassName('highcharts-axis-line')[0];
  //   const xAxisGridLineD = xAxisGridLine.getAttribute('d');
  //   const gridLineD = transform.read(null, 'd', xAxisGridLineD);
  //   const d = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
  //   const secD = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
  //   const isWeekOrYear = unit === 'years' ? axis.ticks[axisTicksKey[0]].label.textStr : axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[1];
  //   let diff = unit !== 'months' ? parseInt(isWeekOrYear) - firstDate : 
  //     findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]) - firstDate;
  //   let diffLast = unit !== 'months' ? lastDate - parseInt(isWeekOrYear) : 
  //     lastDate - findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]);
  //   const diffBetweenFirstDataPoint = Math.round(d[0][0] / diff);
  //   for (let u = 0; u < diff; u++) {
  //     if (d[0][0] - diffBetweenFirstDataPoint >= gridLineD[0][0]) {
  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, d, false);
  //     }
  //   }
  //   for (let y = 0; y < diffLast; y++) {
  //     if (secD[1][0] + diffBetweenFirstDataPoint <= gridLineD[1][0]) {
  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, secD, true);
  //     }
  //   }
  // }
}

function appendToXGridGroup(highchart, diff, styles, d, isAfterFirstTick) {
  var newPath = highchart.renderer.path().attr({
    'opacity': 1
  });
  if (isAfterFirstTick) {
    d[0][0] = d[0][0] + diff;
    d[1][0] = d[1][0] + diff;
  } else {
    d[0][0] = d[0][0] - diff;
    d[1][0] = d[1][0] - diff;
  }
  d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
  newPath = transform.write(newPath.element, 'd', d);
  newPath.setAttribute('stroke-width', 1);
  newPath.setAttribute('stroke', '#333333');
  var gridGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
  gridGroup.appendChild(newPath);
}

// Removes a tick label and grid line.
function removeTick(tick) {
  element.removeChild(tick.label.element);
  element.removeChild((tick['gridLine'] || tick['mark']).element);
}

function styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth) {
  var firstTick = tickArray[0];
  var firstTickVal = isMonth ? axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[1] : axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[0];
  var landMarkTicks = [firstTickVal];
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    var tickVal = tick.label.textStr;
    var tickValUnit = isMonth ? tickVal.split(' ')[1] : tickVal.split(' ')[0];
    if (landMarkTicks.indexOf(tickValUnit) !== -1 && index !== 0) {
      var arrayVal = isMonth ? 0 : 1;
      if (tick.label.element.children.length > 0) {
        tick.label.element.children[0].innerHTML = tickVal.split(' ')[arrayVal];
      } else {
        tick.label.element.innerHTML = tickVal.split(' ')[arrayVal];
      }
    } else {
      landMarkTicks.push(tickValUnit);
    }
  });
}

function findMonthValue(label) {
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return months.indexOf(label);
}

function makeTickShorter(axis, options, styles, highchart) {
  (0, _util.forAxisTicks)(axis, function (tick, key, index) {
    // const labelEl = tick.label.element;
    var markEl = tick.mark.element;
    var d = transform.read(null, 'd', tick.mark.d);
    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
    transform.write(markEl, 'd', d);
  });
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.postRender = postRender;

var _defs = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLOR = '#333';
var VIDEO_COLOR = '#fff';
var MARGIN_ONLINE = 16;
var MARGIN_PRINT = 8;

function postRender(highchart, options) {
  var container = highchart.container;

  removeClipPath(container);

  var _getAnnotationEls = getAnnotationEls(container),
      _getAnnotationEls2 = (0, _slicedToArray3.default)(_getAnnotationEls, 2),
      labels = _getAnnotationEls2[0],
      shapes = _getAnnotationEls2[1];

  spaceOutAndDrawLines(highchart, options, labels, shapes);
}

function removeClipPath(container) {
  // prevents labels from being cut off
  var el = findEl(container, '.highcharts-annotation');
  el.setAttribute('clip-path', 'none');
}

function findEl(el, selector) {
  return el.querySelector(selector);
}

function getAnnotationEls(container) {
  var findByType = searchContainer(container);
  return ['label', 'shape'].map(findByType).map(sortEls);
}

function searchContainer(container) {
  return function (type) {
    var els = container.querySelectorAll('.highcharts-annotation-' + type + 's');
    return [].concat((0, _toConsumableArray3.default)(els[0].children));
  };
}

function sortEls(els) {
  // labels/shapes both sorted by x ascending
  return els.sort(function (a, b) {
    return findAttr(a) - findAttr(b);
  });
}

function findAttr(el) {
  var type = el.tagName;
  switch (type) {
    case 'g':
      // label
      var labelX = parseTransform(el).x;
      var labelWidth = getWidth(el);
      return labelX + labelWidth / 2;
    case 'circle':
      // circle/dot line ends
      return +el.getAttribute('cx');
    case 'path':
      // arrow line end
      return getArrowPosition(el).x;
  }
}

function parseTransform(label) {
  // get label's x, y
  var transform = label.getAttribute('transform');
  var start = transform.indexOf('(') + 1;
  var end = transform.indexOf(')');
  var nums = transform.slice(start, end).split(',');
  return { x: +nums[0], y: +nums[1] };
}

function getWidth(el) {
  return el.getBoundingClientRect().width;
}

function getArrowPosition(path) {
  // get arrow's x, y
  var d = path.getAttribute('d').split(' ');
  return { x: +d[4], y: +d[5] };
}

function spaceOutAndDrawLines(highchart, options, labels, shapes) {
  var _getEls = getEls(highchart),
      _getEls2 = (0, _slicedToArray3.default)(_getEls, 2),
      recession = _getEls2[0],
      suffix = _getEls2[1];

  var margin = options.print ? MARGIN_PRINT : MARGIN_ONLINE;
  var x = getLeftX(highchart, options, margin);
  var args = [labels, shapes, x, margin, suffix, recession];
  shiftLabelsRight.apply(undefined, args);
  shiftLabelsLeft.apply(undefined, [options, highchart].concat(args));
}

function getEls(highchart) {
  var el = getEl(highchart.container);
  var recessionEl = el('.label-recession');
  var suffixEl = el('.y-axis-suffix');
  var recession = recessionEl ? {
    type: 'recession',
    startX: getStartX(recessionEl),
    endX: getStartX(recessionEl) + getWidth(recessionEl),
    midpoint: getStartX(recessionEl) + getWidth(recessionEl) / 2
  } : null;
  var suffix = suffixEl ? {
    type: 'suffix',
    startX: getStartX(suffixEl),
    endX: getStartX(suffixEl) + getWidth(suffixEl)
  } : null;
  return [recession, suffix];
}

function getEl(container) {
  return function (tag) {
    return findEl(container, tag);
  };
}

function getStartX(el) {
  return +el.getAttribute('x');
}

function getLeftX(highchart, options, margin) {
  if (highchart.axes[1].opposite) return 0; // y axis on right
  var shortSuffix = options.axes.units.suffix && options.axes.units.suffix.length <= 2;
  if (shortSuffix) {
    var suffixEl = findEl(highchart.container, '.y-axis-suffix');
    return +suffixEl.getAttribute('x') + getWidth(suffixEl) + margin;
  }
  return topLabelX(highchart, options) + margin;
}

function topLabelX(highchart, options) {
  var reversed = options.axes.reversed;
  var yAxis = highchart.axes[1];
  var tickPositions = yAxis.tickPositions;
  var tickPosition = reversed ? tickPositions[0] : lastItem(tickPositions);
  return yAxis.ticks[tickPosition].label.xy.x;
}

function lastItem(arr) {
  return arr[arr.length - 1];
}

function shiftLabelsRight(labels, shapes, hardLeft, margin, suffix, recession) {
  // from left to right, ensure proper spacing between labels
  var startX = hardLeft;

  labels.forEach(function (label, i) {
    var shape = shapes[i];
    var labelWidth = getWidth(label);

    var _parseTransform = parseTransform(label),
        x = _parseTransform.x,
        needTransform = false;

    if (needTransform = x < startX) x = startX;

    if (suffix || recession) {
      var _getPositions = getPositions(x, shape, labelWidth),
          moveX = _getPositions.moveX,
          shapeX = _getPositions.shapeX;

      var _needShiftRight = needShiftRight(moveX, suffix, recession),
          _needShiftRight2 = (0, _slicedToArray3.default)(_needShiftRight, 2),
          shiftRight = _needShiftRight2[0],
          overlap = _needShiftRight2[1];

      if (shiftRight) {
        x = shiftRightX(overlap, shapeX, labelWidth);
        needTransform = true;
      }
    }

    if (needTransform) updateTransform(label, x);

    startX = x + labelWidth + margin; // farthest left next label can be
  });
}

function getPositions(x, shape, labelWidth) {
  var shapeX = getShapeX(shape);
  var labelX = x + labelWidth / 2; // label center
  var jointed = isJointed(labelX, shapeX, labelWidth);
  var moveX = jointed ? labelX : shapeX; // line top
  return { labelX: labelX, moveX: moveX, shapeX: shapeX, jointed: jointed };
}

function getShapeX(shape) {
  return shape.tagName === 'circle' ? +shape.getAttribute('cx') : getArrowPosition(shape).x;
}

function isJointed(labelX, shapeX, labelWidth) {
  // draw jointed line only if shapeX outside label width
  return Math.abs(labelX - shapeX) >= labelWidth / 2;
}

function needShiftRight(moveX, suffix, recession) {
  var overlap = checkOverlap(moveX, recession, suffix);
  var shiftRight = overlap.type === 'suffix' || overlap.type === 'recession' && moveX >= recession.midpoint;
  return [shiftRight, overlap];
}

function checkOverlap(moveX, recession, suffix) {
  // does line overlap with recession or suffix label
  if (recession && moveX >= recession.startX && moveX <= recession.endX) {
    return recession;
  } else if (suffix && moveX >= suffix.startX && moveX <= suffix.endX) {
    return suffix;
  } else {
    return { type: 'none' };
  }
}

function shiftRightX(overlap, shapeX, labelWidth) {
  // position label to ensure line wraps around recession/suffix
  var centeredOnOverlap = overlap.startX + 2 - labelWidth / 2;
  return shapeX >= centeredOnOverlap && shapeX <= overlap.endX ? shapeX + 1 : centeredOnOverlap;
}

function updateTransform(label, x) {
  // set new x for label
  var _parseTransform2 = parseTransform(label),
      y = _parseTransform2.y;

  var translate = 'translate(' + x + ',' + y + ')';
  label.setAttribute('transform', translate);
}

function shiftLabelsLeft(options, highchart, labels, shapes, hardLeft, margin, suffix, recession) {
  /*
   * From right to left, ensure proper spacing between labels
   * After positioning each label, draw its line
   * Hide annotations pushed off left of chart or into suffix label
  */
  var wsjPrint = options.print && options.product === 'wsj';
  var offset = wsjPrint ? 1 : 0;
  var hardRight = highchart.plotLeft + highchart.plotWidth - offset;

  var drawLine = lineRenderer(highchart, options, margin);

  var startX = hardRight,
      nextLabel = void 0,
      nextShape = void 0;
  var lastLabel = labels.length - 1;

  for (var i = lastLabel; i >= 0; i--) {

    var label = labels[i],
        shape = shapes[i];
    var labelWidth = getWidth(label);

    var _getProps = getProps(label),
        _getProps2 = (0, _slicedToArray3.default)(_getProps, 3),
        flushAlign = _getProps2[0],
        showLine = _getProps2[1],
        dotted = _getProps2[2];

    var _parseTransform3 = parseTransform(label),
        x = _parseTransform3.x,
        transformX = void 0;

    if (x + labelWidth >= startX) {
      x = startX - labelWidth;
      var itemFlush = i === lastLabel && flushAlign;
      // for right-most labels pushed off chart with flush alignment selected
      if (itemFlush) label.setAttribute('text-anchor', 'end');
      transformX = itemFlush ? hardRight : x;
    }

    if (recession || suffix) {
      var _getPositions2 = getPositions(x, shape, labelWidth),
          moveX = _getPositions2.moveX,
          shapeX = _getPositions2.shapeX;

      var overlap = checkOverlap(moveX, recession, suffix);
      if (overlap.type !== 'none') {
        x = shiftLeftX(overlap, shapeX, labelWidth);
        transformX = x;
      }
    }

    var positions = getPositions(x, shape, labelWidth);

    var hidden = x < hardLeft || options.product !== 'financialnews' && suffix && positions.moveX <= suffix.endX;
    if (hidden) {
      hideAnnotation(label, shape);
    } else {
      if (transformX) {
        updateTransform(label, transformX);
      }
      if (showLine) {
        drawLine(label, shape, nextLabel, nextShape, positions, dotted);
      }
    }

    // to determine whether jointed lines overlap
    var _ref = [positions.moveX, positions.shapeX];
    nextLabel = _ref[0];
    nextShape = _ref[1];
    startX = x - margin; // farthest right next label can be
  }
}

function lineRenderer(highchart, options, margin) {
  var cushion = margin / 2;
  var addPx = cushion;
  return function (label, shape, nextLabel, nextShape, positions, dotted) {
    var labelX = positions.labelX,
        moveX = positions.moveX,
        shapeX = positions.shapeX,
        jointed = positions.jointed;
    var _ref2 = [getLabelY(label), adjustShapeY(highchart, options, shape)],
        labelY = _ref2[0],
        shapeY = _ref2[1];

    // for highstocks charts, if shape cut off on left, re-render shape to force added space

    if (options.irregularDates) checkCutoff(highchart, options, shape, shapeX, shapeY);

    var _getPathStart = getPathStart(moveX, labelY, shapeX, shapeY),
        _getPathStart2 = (0, _slicedToArray3.default)(_getPathStart, 3),
        m = _getPathStart2[0],
        jointPath = _getPathStart2[1],
        lastL = _getPathStart2[2];

    if (jointed) {
      // draw jointed line
      var jointRight = labelX > shapeX;
      var jointY = initialJointY(highchart, margin, jointRight);
      // if jointed lines overlap, bump 2nd line down
      if (nextLabel) {
        if (shapeX >= nextLabel) {
          jointY += addPx;
          addPx += cushion; // keep increasing addPx if >2 consecutive jointed lines overlap
        } else if (moveX >= nextShape) {
          jointY -= addPx;
          addPx += cushion;
        } else {
          addPx = cushion; // reset addPx once consecutive jointed lines don't overlap
        }
      }
      jointPath.push.apply(jointPath, ['L', labelX, jointY, 'L', shapeX, jointY]);
    }
    var path = [].concat((0, _toConsumableArray3.default)(m), (0, _toConsumableArray3.default)(jointPath), (0, _toConsumableArray3.default)(lastL));
    renderPath(highchart, options, path, dotted);
  };
}

function getLabelY(label) {
  // line top positioned below label
  var _parseTransform4 = parseTransform(label),
      y = _parseTransform4.y;

  var labelHeight = label.getBoundingClientRect().height;
  return y + labelHeight;
}

function adjustShapeY(highchart, options, shape) {
  var shapeY = shape.tagName === 'circle' ? +shape.getAttribute('cy') : getArrowPosition(shape).y;
  if (!shapeY) {
    // check whether category enabled
    var xAxisPathPoints = highchart.axes[0].axisLine.d.split(' ');
    shapeY = +lastItem(xAxisPathPoints); // line extends to xAxis
  }
  return adjustLineEnd(options, shape, shapeY);
}

function adjustLineEnd(options, shape, shapeY) {
  // for arrow/circle line ends, shorten line for proper intersection with shape
  var isCircle = +shape.getAttribute('stroke-width') > 0;
  var offsetY = 0;
  if (isCircle) {
    offsetY = +shape.getAttribute('r');
  } else if (shape.tagName === 'path') {
    // arrow
    offsetY = (0, _defs.findOffset)(options);
  }
  return shapeY - offsetY;
}

function checkCutoff(highchart, options, shape, shapeX, shapeY) {
  if (+shape.getAttribute('stroke-width') === 0) {
    var isDot = shape.tagName === 'circle';
    var width = (0, _defs.arrowWidth)(options.print);
    var midpoint = width / 2;
    var r = isDot ? +shape.getAttribute('r') : midpoint;

    if (shapeX - r <= highchart.plotLeft) {
      shape.setAttribute('display', 'none');
      var fill = options.id === 'video' || options.id === 'twitterVideo' ? VIDEO_COLOR : COLOR;
      var attr = { fill: fill, zIndex: 4 };

      if (isDot) {
        highchart.renderer.circle(shapeX, shapeY, r).attr(attr).add();
      } else {
        // arrow
        var height = (0, _defs.getHeight)(width, midpoint);
        var path = ['M', shapeX, shapeY, 'L', shapeX + midpoint, shapeY, 'L', shapeX, shapeY + height, 'L', shapeX - midpoint, shapeY, 'z'];

        highchart.renderer.path(path).attr(attr).add();
      }
    }
  }
}

function getPathStart(moveX, labelY, shapeX, shapeY) {
  // top, bottom of line
  return [['M', moveX, labelY], [], ['L', shapeX, shapeY]];
}

function initialJointY(highchart, margin, jointRight) {
  var divisor = jointRight ? 1 : 2;
  return highchart.plotTop + margin / divisor;
}

function renderPath(highchart, options, path, dotted) {
  var print = options.print,
      id = options.id;

  var strokeWidth = getStrokeWidth(print, dotted);
  var gap = print ? 3 : 5;
  var dashArray = dotted ? '0.1,' + gap : undefined;
  highchart.renderer.path(path).attr({
    stroke: id === 'video' || id === 'twitterVideo' ? VIDEO_COLOR : COLOR,
    'stroke-width': strokeWidth,
    'stroke-dasharray': dashArray,
    'stroke-linecap': 'round',
    zIndex: 4
  }).add();
}

function getStrokeWidth(print, dotted) {
  if (print && dotted) return 1.5;else if (print && !dotted) return 0.5;else if (!print && dotted) return 2.5;else return 1;
}

function getProps(label) {
  // get properties set in prerender
  var styles = label.getAttribute('style').split(';');
  var flushAlign = styles[0];
  var showLine = styles[1];
  var lineType = styles[2];
  return [!flushAlign.includes('default'), showLine.includes('true') || showLine.includes('undefined'), lineType.includes('dotted')];
}

function shiftLeftX(overlap, shapeX, labelWidth) {
  // position label to ensure line wraps around recession/suffix
  var centeredOnOverlap = overlap.startX - 2 - labelWidth / 2;
  return shapeX <= centeredOnOverlap + labelWidth && shapeX >= overlap.startX ? shapeX - labelWidth - 1 : centeredOnOverlap;
}

function hideAnnotation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (arg) {
    return arg.setAttribute('display', 'none');
  });
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postRender = undefined;

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _util = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postRender = exports.postRender = function postRender(highchart, options) {
  var lineInFront = ['area', 'bar', 'column'].includes(options.type);
  var gPlotLines = [].concat((0, _toConsumableArray3.default)(highchart.container.querySelectorAll(lineInFront ? '.highcharts-plot-lines-5' : '.highcharts-plot-lines-3')))[0];
  var paths = gPlotLines.querySelectorAll('path');
  var isVideoGroup = options.id === 'video' || options.id === 'twitterVideo';
  paths.forEach(function (path) {
    (0, _util.dashStylesHelper)(path, options.size);
    (0, _util.roundLineJoinsHelper)(path, isVideoGroup);
  });
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDataParser = exports.fetchData = exports.createDataFormatter = exports.getMikeParams = undefined;

var _slicedToArray2 = __webpack_require__(4);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _marketdata = __webpack_require__(47);

var _marketdata2 = __webpack_require__(212);

var _constants = __webpack_require__(3);

var _helpers = __webpack_require__(290);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hstri = __webpack_require__(311);

// functions to export
function getMikeParams(query) {
  return ['instrument', 'start', 'end', 'frequency', 'format', 'dateRange', 'product', 'type'].map(function (prop) {
    return getParam(query, prop);
  });
}

function createDataFormatter(res, isPercent, isCustom, dateRange, frequency, end, instruments) {
  return function (data) {
    var series = formatForChartlos(data, isPercent, isCustom, dateRange, frequency, end, instruments);
    res.send({ series: series });
  };
}

function fetchData(instrument, start, end, frequency, isCustom, dateRange, isRolling, product, done) {
  var isIntraday = /\d+D/.test(dateRange) || isCustom && (0, _marketdata2.checkIntradayFrequency)(frequency);
  var formattedEnd = findEndDate(end, isRolling, isCustom, isIntraday);

  var token = getToken(product);

  queryHstri(start, instrument, frequency, formattedEnd, token, dateRange).then(function (data) {
    return done(data);
  });
}

function createDataParser(res, isPercent, isCustom, frequency, dateRange, end) {
  var isMultiple = res.length > 1;

  var showAsPercentProps = checkShowAsPercent(res, isPercent);
  var usePercent = isPercent || mustShowAsPercent(showAsPercentProps);

  var _res$0$raw = res[0].raw,
      TimeInfo = _res$0$raw.TimeInfo,
      Series = _res$0$raw.Series;
  var IsIntraday = TimeInfo.IsIntraday;


  var startDates = findStartDates(Series, dateRange);

  var needsLast = !isCustom || checkToday(isCustom, IsIntraday, end, (0, _moment2.default)());
  var allDates = buildDatesArr(res, [].concat((0, _toConsumableArray3.default)(startDates)), end, isCustom, frequency, needsLast);

  var lastIndex = getLastIdx(allDates);

  var lastQuoteDate = findLastQuoteDate(Series);
  var lastDate = IsIntraday ? allDates[lastIndex] : lastQuoteDate;

  var categories = createCategories(allDates, needsLast, lastIndex, IsIntraday, frequency, lastQuoteDate);

  var date = formatAsOfDate(lastDate, IsIntraday, frequency);

  var dataTemplate = buildDataTemplate(allDates);

  return function (series, index) {
    var data = series.data,
        raw = series.raw;
    var _raw$Series$index = raw.Series[index],
        InstrumentType = _raw$Series$index.InstrumentType,
        ExtraData = _raw$Series$index.ExtraData;

    var _findPriorClose = findPriorClose(ExtraData),
        Value = _findPriorClose.Value;

    var priorDate = startDates[index];

    var seriesArr = mapSeriesData(data, !usePercent, InstrumentType, priorDate, Value, dataTemplate);

    return [seriesArr, categories, date, showAsPercentProps];
  };
}

// getMikeParams helper function
function getParam(query, prop) {
  var param = query[prop];
  switch (prop) {
    case 'instrument':
      return (0, _helpers.checkArray)(param);
    case 'format':
      return param === 'percent';
    case 'type':
      return param === 'rolling';
    default:
      return param;
  }
}

// createDataFormatter helper functions
function formatForChartlos(res, isPercent, isCustom, dateRange, frequency, end, instruments) {
  var parseData = createDataParser(res, isPercent, isCustom, frequency, dateRange, end);
  return res.map(function (series, index) {
    var _parseData = parseData(series, index),
        _parseData2 = (0, _slicedToArray3.default)(_parseData, 4),
        seriesArr = _parseData2[0],
        categories = _parseData2[1],
        date = _parseData2[2],
        showAsPercentProps = _parseData2[3];

    var raw = series.raw,
        name = series.name,
        ticker = series.ticker;
    var TimeInfo = raw.TimeInfo,
        Series = raw.Series;
    var isIntraday = TimeInfo.IsIntraday;
    var _Series$index = Series[index],
        tickerType = _Series$index.InstrumentType,
        FormatHints = _Series$index.FormatHints;

    var instrument = instruments[index];
    var sourceInfo = getSourceInfo(tickerType, ticker, instrument);

    var _setFormatProps = setFormatProps(FormatHints, tickerType),
        _setFormatProps2 = (0, _slicedToArray3.default)(_setFormatProps, 3),
        prefix = _setFormatProps2[0],
        suffix = _setFormatProps2[1],
        decimals = _setFormatProps2[2];

    var needsCommas = tickerType !== 'Index';
    return {
      data: seriesArr,
      name: name,
      symbol: ticker,
      needsCommas: needsCommas,
      index: index,
      date: date,
      prefix: prefix,
      suffix: suffix,
      decimals: decimals,
      isIntraday: isIntraday,
      sourceInfo: sourceInfo,
      tickerType: tickerType,
      showAsPercentProps: showAsPercentProps,
      categories: categories
    };
  });
}

function getSourceInfo(type, symbol, fullSymbol) {
  return {
    source: getSource(type, symbol, fullSymbol),
    type: getPlural(type),
    symbol: symbol
  };
}

function getSource(type, symbol, fullSymbol) {
  switch (type) {
    case 'Bond':
    case 'Currency':
      return 'Tullett Prebon';
    case 'Index':
      return getIndexSource(symbol);
    case 'CryptoCurrency':
      return getCryptoSource(symbol, fullSymbol);
    default:
      return 'FactSet';
  }
}

function getIndexSource(symbol) {
  switch (symbol) {
    case 'BUXX':
    case 'NEXT50':
    case 'VCIPO':
      return 'Dow Jones Market Data';
    default:
      return 'FactSet';
  }
}

function getCryptoSource(symbol, fullSymbol) {
  var symbols = ['BTCEUR', 'BTCUSD', 'ETHEUR', 'ETHUSD', 'XRPEUR', 'XRPUSD', 'LTCEUR', 'LTCUSD', 'BCHEUR', 'BCHUSD', 'XMREUR', 'XMRUSD', 'ETCEUR', 'ETCUSD', 'DASHEUR', 'DASHUSD', 'ZECEUR', 'ZECUSD'];
  return symbols.includes(symbol) && fullSymbol.includes('KRAKEN') ? 'KRAKEN' : 'CoinDesk';
}

function getPlural(type) {
  switch (type) {
    case 'Index':
      return 'indexes';
    case 'Commodity':
      return 'commodities';
    case 'CryptoCurrency':
      return 'crypto currencies';
    case 'Currency':
      return 'currencies';
    case 'ExchangeTradedFund':
      return 'ETFs';
    case 'ExchangeTradedNote':
      return 'ETNs';
    case 'Adr':
      return 'ADRs';
    case 'PreferredStock':
      return 'preferred stocks';
    // case 'MutualFundClosed':
    //   return;
    // case 'MutualFundOpen':
    //   return;
    // case 'RealEstateInvestmentTrust':
    //   return;
    default:
      return type.toLowerCase() + 's';
  }
}

function setFormatProps(formatHints, tickerType) {
  var UnitSymbol = formatHints.UnitSymbol,
      DecimalPlaces = formatHints.DecimalPlaces,
      Suffix = formatHints.Suffix;

  var prefix = Suffix || !UnitSymbol ? '' : UnitSymbol;
  var suffix = Suffix ? UnitSymbol : '';
  var decimals = checkDecimals(tickerType, DecimalPlaces) ? DecimalPlaces : 2;
  return [prefix, suffix, decimals];
}

function checkDecimals(tickerType, places) {
  return tickerType === 'Bond' || tickerType === 'Currency' || places <= 2;
}

// fetchData helper functions
function findEndDate(end, isRolling, isCustom, isIntraday) {
  var currentTime = (0, _moment2.default)();
  /*
   * Use the current time for custom interday with an end date of today
  */
  var isCustomToday = checkToday(isCustom, isIntraday, end, currentTime);
  if (isCustomToday) return currentTime;
  /*
   * For other custom auto-updating charts, update only until specified end date
  */
  if (isRolling && isCustom) return _moment2.default.min((0, _moment2.default)(end), currentTime);
  /* 
   * Otherwise use specified end date
  */
  return end;
}

function checkToday(isCustom, isIntraday, end, currentTime) {
  return isCustom && !isIntraday && end.slice(0, 10) === currentTime.format('YYYY-MM-DD');
}

function getToken(product) {
  switch (product) {
    case 'wsj':
      return '57494d5ed7ad44af85bc59a51dd87c90';
    case 'barrons':
      return 'c1b7ca756343461b86565b61bbd2ac6f';
    case 'marketwatch':
      return 'cecc4267a0194af89ca343805a3e57af';
    case 'mansionglobal':
      return '45mb4gzz6uqrogv7xgv37k654z2e5d6q';
    case 'financialnews':
      return 'brewtbcvblmff8sb1kcdbj21c29j8lv5';
    default:
      return '57494d5ed7ad44af85bc59a51dd87c90';
  }
  // WSJ Pro: 'eb0af67ce7f24679a0e2d2c7c32e7d98'
}

function queryHstri(start, instrument, frequency, end, entitlementToken, timeFrame) {
  return hstri({
    start: getHstriDate(start),
    timeFrame: _marketdata.RANGE[timeFrame].value,
    instrument: instrument,
    frequency: frequency || 'P1D',
    end: getHstriDate(end),
    service: 'michelangelo',
    entitlementToken: entitlementToken
  });
}

function getHstriDate(date) {
  return date ? (0, _marketdata2.createETMoment)(date) : '';
}

// createDataParser helper functions
function checkShowAsPercent(series, isPercentProp) {
  // "Show as percent change" toggle should be locked into true or false in certain situations
  var hasBonds = series.some(checkBonds);
  var differentUnitSymbols = series.some(function (currentSeries, i) {
    return checkUnitSymbols(series[0], currentSeries, i);
  });
  var disabled = hasBonds || differentUnitSymbols;
  var isPercent = !hasBonds && (differentUnitSymbols || isPercentProp);
  return { isPercent: isPercent, disabled: disabled };
}

function checkBonds(series, i) {
  var instrumentType = getSeriesProp(series, i, 'InstrumentType');
  return instrumentType === 'Bond';
}

function getSeriesProp(series, i, prop) {
  return series.raw.Series[i][prop];
}

function checkUnitSymbols(firstSeries, currentSeries, i) {
  return getUnitSymbol(currentSeries, i) !== getUnitSymbol(firstSeries, 0);
}

function getUnitSymbol(series, i) {
  return getSeriesProp(series, i, 'FormatHints').UnitSymbol;
}

function mustShowAsPercent(showAsPercentProps) {
  var isPercent = showAsPercentProps.isPercent,
      disabled = showAsPercentProps.disabled;

  return isPercent && disabled;
}

function buildDatesArr(res, rawDateArr, end, isCustom, frequency, needsLast) {
  var compiledDates = compileDates(res, rawDateArr);
  var lastDate = compiledDates[getLastIdx(compiledDates)];

  var longerThanDaily = checkLongerThanDaily(frequency);

  var isBefore = longerThanDaily && checkBefore(frequency, lastDate, end);

  return isCustom && end && !needsLast && isBefore ? compiledDates.slice(0, -1) : compiledDates;
}

function compileDates(res, rawDateArr) {
  res.forEach(function (series) {
    return rawDateArr.push.apply(rawDateArr, (0, _toConsumableArray3.default)(series.ticks));
  });
  var uniqueDates = new Set(rawDateArr);
  return [].concat((0, _toConsumableArray3.default)(uniqueDates)).filter(function (date) {
    return date;
  }).sort(function (a, b) {
    return a - b;
  });
}

function getLastIdx(arr) {
  return arr.length - 1;
}

function checkLongerThanDaily(frequency) {
  return ['P7D', 'P1M', 'P3M', 'P1Y'].some(function (code) {
    return code === frequency;
  });
}

function checkBefore(frequency, lastDate, end) {
  var date = (0, _moment2.default)(lastDate);
  return convertDate(date, frequency).isAfter(end);
}

function convertDate(date, frequency) {
  switch (frequency) {
    case 'P7D':
      return date.add(5, 'd');
    case 'P1M':
      return date.utc().endOf('month');
    case 'P3M':
      return date.utc().add(2, 'M').endOf('month');
    case 'P1Y':
      return date.utc().endOf('year');
    default:
      return date;
  }
}

function findStartDates(series, dateRange) {
  return series.map(function (currentSeries) {
    var MarketSessions = currentSeries.MarketSessions,
        ExtraData = currentSeries.ExtraData,
        InstrumentType = currentSeries.InstrumentType;

    if (MarketSessions && dateRange !== 'Custom') {
      var priorClose = findPriorClose(ExtraData).Date;
      var closingTime = MarketSessions.reverse().find(function (session) {
        return session.Kind === 'Trading';
      }).End;
      var date = (0, _moment2.default)(priorClose).utc();
      var year = date.year();
      var month = date.month();
      var day = date.date();
      var time = (0, _moment2.default)(closingTime);
      var hour = time.hour();
      var minutes = time.minute();
      var seconds = time.second();
      return +(0, _moment2.default)().year(year).month(month).date(day).hour(hour).minute(minutes).second(seconds).format('x');
    }
    if (dateRange === 'YTD') {
      return findPriorClose(ExtraData).Date;
    }
  });
}

function findPriorClose(extraData) {
  return extraData.find(function (data) {
    return data.Name === 'PriorClose';
  });
}

function findLastQuoteDate(series) {
  var currentQuoteDates = series.map(function (currentSeries) {
    return currentSeries.CurrentQuote.DateUtc;
  });
  return Math.max.apply(Math, (0, _toConsumableArray3.default)(currentQuoteDates));
}

function createCategories(dates, needsLast, lastIndex, isIntraday, frequency, lastDate) {
  return dates.map(function (x, i) {
    var isLast = needsLast && i === lastIndex;
    return formatCategory(x, isIntraday, frequency, isLast, lastDate);
  });
}

function formatCategory(x, isIntraday, frequency, isLast, lastDate) {
  var date = getDate(x, isIntraday, frequency, isLast, lastDate);
  var dayFormat = 'MM/DD/YYYY';
  return isIntraday ? date.format(dayFormat + ' h:mm:ss a').slice(0, -1) : date.format(dayFormat);
}

function getDate(x, isIntraday, frequency, isLast, lastDate) {
  var needsToday = checkNeedsToday(frequency, isLast);
  var date = needsToday ? _moment2.default.tz(lastDate, 'America/New_York') : convertDate((0, _marketdata2.createETMoment)(x), frequency);
  return isIntraday || needsToday ? date : date.utc();
}

function checkNeedsToday(frequency, isLast) {
  return isLast && checkLongerThanDaily(frequency);
}

function formatAsOfDate(x, isIntraday, frequency) {
  var date = (0, _marketdata2.createETMoment)(x);
  var month = _constants.MONTHS[date.month()];
  var day = date.date();
  var formattedDate = month + ' ' + day;
  var time = date.format('h:mm a');
  var formattedTime = formatTime(time);
  return formattedDate + formattedTime;
}

function formatTime(time) {
  var zerosRemoved = time.replace(':00', '');
  return ', ' + zerosRemoved.slice(0, -1) + '.m. ET';
}

function buildDataTemplate(dates) {
  var dataTemplate = {};
  dates.forEach(function (date) {
    dataTemplate[date] = null;
  });
  return dataTemplate;
}

function mapSeriesData(data, notPercent, tickerType, firstDate, firstValue, dataTemplate) {
  var seriesData = Object.assign({}, dataTemplate);

  var value = notPercent ? firstValue : 0;
  if (firstDate) seriesData[firstDate] = value;

  var initialY = firstDate ? firstValue : findFirstY(data);

  data.forEach(function (item, index) {
    var x = item[0];
    var y = getY(item[1], initialY, notPercent);
    if (seriesData[x] === null) seriesData[x] = y;
  });

  return Object.values(seriesData).map(function (y) {
    return { y: y };
  });
}

function findFirstY(data) {
  // find first non-null Y value (needed to calculate percent change)
  return data.find(function (point) {
    return point[1];
  })[1];
}

function getY(y, initialY, notPercent) {
  if (y === undefined || y === null) return null;
  if (notPercent) return y;
  return getChange(initialY, y);
}

function getChange(initialY, y) {
  // percentage change from first Y value
  return (y - initialY) / initialY * 100;
}

exports.getMikeParams = getMikeParams;
exports.createDataFormatter = createDataFormatter;
exports.fetchData = fetchData;
exports.createDataParser = createDataParser;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMetadata = exports.checkArray = exports.convertSortObj = exports.convertQueryObj = exports.convertTime = exports.pullOutHeadlines = exports.findUniqueHeadlines = exports.simplifyCharts = exports.fail = exports.success = exports.epsRequest = exports.pngRequest = exports.updateChartData = undefined;

var _toConsumableArray2 = __webpack_require__(8);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(291);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(294);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var epsRequest = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data, environment) {
    var url;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = 'http://int.production.svg-converter.virginia.dj01.onservo.com/api/v1/eps/string/publish';
            _context.next = 3;
            return fetch(url, {
              method: 'POST',
              uri: url,
              headers: {
                'content-type': 'application/json'
              },
              body: JSON.stringify(data)
            });

          case 3:
            return _context.abrupt('return', _context.sent);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function epsRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _lodash = __webpack_require__(32);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _async = __webpack_require__(307);

var _async2 = _interopRequireDefault(_async);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetch = __webpack_require__(310);

function checkArray(prop) {
  return Array.isArray(prop) ? prop : [prop];
}

function convertTime(time) {
  var day = (0, _moment2.default)().format('YYYY-MM-DD');
  switch (time) {
    case 'day':
      return day;
    case 'week':
      return (0, _moment2.default)().subtract(7, 'd').format('YYYY-MM-DD');
    case 'month':
      return (0, _moment2.default)().subtract(1, 'months').format('YYYY-MM-DD');
    case '6months':
      return (0, _moment2.default)().subtract(6, 'months').format('YYYY-MM-DD');
    case 'year':
      return (0, _moment2.default)().subtract(1, 'years').format('YYYY-MM-DD');
  }
}

function convertQueryObj(query) {
  var obj = {
    headline: query.headline,
    slug: query.title,
    creator: query.creator,
    modifier: query.modifier,
    create_date: query.created,
    modify_date: query.modified,
    product: query.targets,
    source: query.source,
    chart_type: query.type,
    status: query.status
  };
  if (obj.create_date === 'anytime') {
    delete obj.create_date;
  }
  if (obj.modify_date === 'anytime') {
    delete obj.modify_date;
  }
  if (Array.isArray(obj.status)) {
    delete obj.status;
  }

  for (var key in obj) {
    if (obj[key] === '' || obj[key] === undefined) {
      delete obj[key];
    }
  }
  return obj;
}

function convertSortObj(prop, order) {
  var obj = {};
  switch (prop) {
    case 'DATE_CREATED':
      obj.prop = 'create_date';
      break;
    case 'DATE_MODIFIED':
      obj.prop = 'modify_date';
      break;
    case 'CREATED_BY':
      obj.prop = 'creator';
      break;
    case 'STATUS':
      obj.prop = 'status';
      break;
    case 'MODIFIED_BY':
      obj.prop = 'modifier';
      break;
    case 'TITLE':
      obj.prop = 'slug';
      break;
    default:
      obj.prop = 'modify_date';
      break;
  }
  switch (order) {
    case 'DESCENDING':
      obj.order = 'desc';
      break;
    case 'ASCENDING':
      obj.order = 'asc';
      break;
  }
  return obj;
}

function pullOutHeadlines(chart) {

  //if new way is used, function always returns an object, for the old way if no sizes were selected the function return false
  var textObj = findUniqueHeadlines(chart.chart, chart.id);
  //converting source into new way, to be able to search by source
  if (!chart.chart.source && chart.chart.data.source) {
    chart.source = chart.chart.data.source.text;
  }
  var textItemInsert = [];
  var defaultHeadline = [];
  var hasDefaultHeadline = chart.default_headline ? true : false;

  if (textObj) {
    var _loop = function _loop(key) {
      textObj[key].map(function (item) {
        item.text_type = key;
        if (item.content) {
          textItemInsert.push(item);
          if (item['size'] === 'default') {
            var obj = {
              content: item.content,
              type: item.text_type
            };
            defaultHeadline.push(obj);
          }
        }
      });
    };

    for (var key in textObj) {
      _loop(key);
    }
    if (defaultHeadline.length === 1) {
      chart.default_headline = defaultHeadline[0].content;
    }
    if (defaultHeadline.length > 1) {
      for (var x = 0; x < defaultHeadline.length; x++) {
        if (defaultHeadline[x].type === 'headline') {
          chart.default_headline = defaultHeadline[x].content;
        }
      }
    }
    if (!defaultHeadline.length) {
      chart.default_headline = 'Untitled';
    }
  }

  return { textObj: textObj, textItemInsert: textItemInsert, hasDefaultHeadline: hasDefaultHeadline, chart: chart };
}

function findUniqueHeadlines(chart, id) {
  var sizes = chart.sizes;
  var _chart$data = chart.data,
      title = _chart$data.title,
      dek = _chart$data.dek,
      subdek = _chart$data.subdek;


  var titleArr = [];
  var dekArr = [];
  var subdekArr = [];
  var helper = ['title', 'dek', 'subdek'];

  function check(heading, obj) {
    var titleCheck = heading === 'title';
    var dekCheck = heading === 'dek';
    var subdekCheck = heading === 'subdek';
    if (titleCheck) titleArr.push(obj);
    if (dekCheck) dekArr.push(obj);
    if (subdekCheck) subdekArr.push(obj);
  }

  //new way - no sizes
  if (title && dek && subdek) {
    helper.forEach(function (heading) {
      var obj = {
        content: chart.data[heading].text || '',
        chart_id: id };
      check(heading, obj);
    });
  } else {
    var filterHeadings = function filterHeadings(arr) {
      var contentSet = new Set();
      arr = arr.filter(function (elem) {
        if (contentSet.has(elem.content)) return false;
        contentSet.add(elem.content);
      });
    };

    var _loop2 = function _loop2(key) {
      helper.forEach(function (heading) {
        if (sizes[key].headings[heading]) {
          var _obj = {
            content: sizes[key].headings[heading].text || '',
            size: key,
            chart_id: id
          };
          check(heading, _obj);
        }
      });
    };

    //old way iterating over the sizes
    for (var key in sizes) {
      _loop2(key);
    }

    filterHeadings(titleArr);
    filterHeadings(dekArr);
    filterHeadings(subdekArr);
  }
  // adding(new way)/redefining(old way) size to default
  function addSize(arr) {
    if (arr.length) arr[0]['size'] = 'default';
  }

  addSize(titleArr);
  addSize(dekArr);
  addSize(subdekArr);

  var obj = {
    headline: titleArr,
    subheadline: dekArr,
    title: subdekArr

    //this check required only for old (size) way, because the new way will always have length 1 for each property.
  };if (obj.headline.length || obj.subheadline.length || obj.title.length) {
    return obj;
  } else {
    return false;
  }
}

function updateChartData(chart, data, action) {
  var now = new Date();
  chart.status = data.status || chart.status || 'draft';
  var prevGams = chart.urls ? chart.urls.gams : '';
  if (data.urls) {
    var urls = {};
    if (chart.urls) {
      Object.keys(chart.urls).forEach(function (key) {
        urls[key] = chart.urls[key];
      });
    }
    Object.keys(data.urls).forEach(function (key) {
      // chart['url_' + key] = data.urls[key];
      urls[key] = data.urls[key];
    });
    // if (chart.url_gams && chart.url_gamsError) {
    //   chart.url_gamsError = null;
    // }
    if (urls.gams && urls.gamsError) {
      urls.gamsError = null;
    }
    chart.urls = urls;
  }

  chart['chart_type'] = data.chart.type || chart.type;
  chart.chart = data.chart || chart.chart || {};
  chart.default_headline = data.default_headline || chart.default_headline;
  chart.slug = data.chart && data.chart.title ? data.chart.title : chart.slug || '';
  chart.modifier = data.modifier || chart.modifier;
  chart.product = data.chart.product || chart.product;
  chart.version = data.version || chart.version;
  var source = '';
  if (data.chart.data.source.text.length > 0) {
    source = data.chart.data.source.text;
    var writtenSource = 'Source: ';
    source = source.indexOf(writtenSource) === 0 ? source.replace(writtenSource, '') : source;
  }
  chart.source = source;
  var gamsId = 'draft';
  var imageUrl = '';
  if (data.urls) {
    if (data.urls.gams) {
      gamsId = data.urls.gams;
      // if new gamsId was not generated that means imageUrl wasn't produced
      if (gamsId === prevGams) imageUrl = '';else if (data.product === 'marketwatch') imageUrl = data.urls.gamsUrls[5];else {
        imageUrl = data.urls.gamsUrls[1] || data.urls.gamsUrls[0];
      }
    }
  }
  chart.gams = gamsId || chart.gams;

  chart['modify_date'] = now;
  if (data.chart && data.chart.approved) {
    chart['approved_graphics'] = data.chart.approved.graphics;
    chart['approved_editor'] = data.chart.approved.editor;
  }
  // if (data.chart && data.chart.sections) {
  //   chart.sections = data.chart.sections;
  // }

  chart.history = data.history || chart.history || [];

  chart.history.push({
    action: action,
    user: data.modifier,
    date: now,
    imageUrl: imageUrl
  });

  if (action === 'created') {
    chart.creator = data.modifier;
    chart.id = data.id;
    chart['create_date'] = now;
    chart.modify_date = now;
  }
  return chart;
}

function pngRequest(data, environment) {
  var uri = converterBaseUrl(environment) + 'api/v1/png/string/base64/';
  // var uri = 'http://int.prod.michelangelo-imaging.virginia.dj01.onservo.com/Rasterize/Svg?base64=true&type=png';
  // var uri = 'http://int.stg.michelangelo-imaging.virginia.dj01.onservo.com/Rasterize/Svg?base64=true&type=png'
  // const uri = `${converterBaseUrl(environment)}api/convert/base64`;
  var svgJSON = {
    "svg": sanitizeSVG(data)
  };
  return {
    method: 'POST',
    uri: uri,
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(svgJSON)
  };
}

function sanitizeSVG(data) {
  return data.replace(/\u00a0/g, " ").replace(/\u0003/g, "").replace('&nbsp;', " ").replace(/[\x00-\x1F\x7F-\x9F]/g, "");
}

function converterBaseUrl(env) {
  if (false) {
    return 'https://int-development-svg-converter.vir-dev.onservo.com/';
  } else {
    return 'https://int-wsj-svg-converter.vir.onservo.com/';
  }
}

// When returning multiple charts, returns only necessary data to display a
// table of charts and not all charts data.
function simplifyCharts(charts, query) {
  var filtered = charts;
  /* if (query.created && query.created !== 'anytime') {
    filtered = filtered.filter(chart => {
      return filterByDate(chart.createDate, query.created);
    });
  }
  if (query.modified && query.modified !== 'anytime') {
    filtered = filtered.filter(chart => {
      return filterByDate(chart.modifyDate, query.modified);
    });
  }
  if (query.title) {
    query.title = query.title.toLowerCase();
    filtered = filtered.filter(chart => {
      console.log(chart.chart.title);
      return chart.chart.title.indexOf(query.title) !== -1;
    });
  }
  if (query.text) {
    filtered = filtered.filter(chart => {
      return chartHasText(chart, query.text);
    });
  }
  if (query.creator) {
    query.creator = query.creator.toLowerCase();
    filtered = filtered.filter(chart => {
      return chart.creator.toLowerCase().indexOf(query.creator) !== -1;
    });
  }
  if (query.modifier) {
    query.modifier = query.modifier.toLowerCase();
    filtered = filtered.filter(chart => {
      return chart.modifier.toLowerCase().indexOf(query.modifier) !== -1;
    });
  }
  if (query.targets) {
    filtered = filtered.filter(chart => {
      const targets = chart.chart.targets || chart.targets;
      query.targets = Array.isArray(query.targets) ? query.targets : [query.targets];
      let found = false;
      query.targets.some(qt => {
         if (targets.indexOf(qt) !== -1) {
          console.log(qt, targets, targets.indexOf(qt) !== -1);
          return (found = true);
        }
      });
      return found;
    });
  }*/
  // const filtered = charts.filter(chart => {
  //   const targets = chart.targets || chart.chart.targets;
  //   if (query.targets && Array.isArray(targets)) {
  //     query.targets = Array.isArray(query.targets) ? query.targets : [query.targets];
  //     let found = false;
  //     // console.log(targets, query.targets);
  //     for (let i = 0; !found && i < query.targets.length; i++) {
  //       found = targets.some(target => {
  //         const targetStr = (target.indexOf('wsj') === 0) ? 'wsj' : target;
  //         return targetStr === query.targets[i];
  //       });
  //     }
  //     if (!found) {
  //       return false;
  //     }
  //   }
  //   return true;
  // });
  var simplified = filtered.map(function (chart) {
    var targets = chart.targets || chart.chart.targets;
    return {
      id: chart._id,
      title: chart.chart.title,
      createDate: chart.createDate,
      creator: chart.creator,
      modifyDate: chart.modifyDate || chart.createDate,
      modifier: chart.modifier || chart.creator,
      status: chart.status,
      sections: chart.chart.admin && chart.chart.admin.sections,
      targets: Array.isArray(targets) ? targets.sort(function (a, b) {
        a = Array.isArray(a) ? a : [a];
        b = Array.isArray(b) ? b : [b];
        return sortStrs(a.join(''), b.join(''), 'asc');
      }) : [],
      approvedEditor: chart.chart.admin && chart.chart.admin.approved.editor,
      approvedGraphics: chart.chart.admin && chart.chart.admin.approved.graphics
    };
  });
  return simplified;
  // return sortCharts(simplified, query.prop, query.order);
}

function chartHasText(chart, text) {
  text = text.toLowerCase();
  if (chart.chart.title.toLowerCase().indexOf(text) !== -1) {
    return true;
  }
  if (chart.chart.data) {
    var data = chart.chart.data;
    if (data.raw && data.raw.toLowerCase().indexOf(text) !== -1) {
      return true;
    }
    if (Array.isArray(data.series)) {
      for (var i = 0; i < data.series.length; i++) {
        var name = (data.series[i].name || '') + '';
        if (name && name.toLowerCase().indexOf(text) !== -1) {
          return true;
        }
      }
    }
  }
  var keys = chart.chart.sizes ? Object.keys(chart.chart.sizes) : [];
  for (var _i = 0; _i < keys.length; _i++) {
    var axes = chart.chart.sizes[keys[_i]].axes;
    if (axes && axes.units) {
      var units = chart.chart.sizes[keys[_i]].axes.units;
      if (units.prefix && units.prefix.toLowerCase().indexOf(text) !== -1) {
        return true;
      }
      if (units.suffix && units.suffix.toLowerCase().indexOf(text) !== -1) {
        return true;
      }
    }
  }
  return false;
}

function filterByDate(dateValue, relativeValue) {
  var minDate = Date.now() - getRelativeTime(relativeValue);
  return Date.parse(dateValue) >= minDate;
}

function sortStrs(a, b, order) {
  if (a < b) {
    return order === 'desc' ? -1 : 1;
  } else if (a > b) {
    return order === 'desc' ? 1 : -1;
  }
  return 0;
}

function buildMetadata(resp) {
  var status = '',
      hed = '',
      dek = '',
      chartTitle = '',
      inset = '',
      embed = '',
      image = '',
      publishDate = '',
      name = '',
      description = '';
  if (resp[0]) {
    var _resp$ = resp[0],
        urls = _resp$.urls,
        history = _resp$.history,
        chart = _resp$.chart,
        statusText = _resp$.status,
        slug = _resp$.slug;

    status = createStatus(statusText);
    var _chart$data2 = chart.data,
        hedObj = _chart$data2.title,
        dekObj = _chart$data2.dek,
        subdekObj = _chart$data2.subdek;

    if (urls) {
      inset = urls.inset;
      var iframe = urls.iframe || '';
      var startIdx = iframe.indexOf('src=');
      var endIdx = iframe.indexOf('.html');
      embed = iframe.slice(startIdx + 5, endIdx + 5);
    }
    image = findImage(urls);
    var lastPublishedItem = findLastPublished(history);
    if (lastPublishedItem) publishDate = lastPublishedItem.date;
    if (hedObj) hed = hedObj.text;
    if (dekObj) dek = dekObj.text;
    if (subdekObj) chartTitle = subdekObj.text;
    name = slug || hed || dek || chartTitle;
    description = slug ? hed || dek || chartTitle : dek || chartTitle;
  }
  return { status: status, hed: hed, dek: dek, chartTitle: chartTitle, inset: inset, embed: embed, image: image, publishDate: publishDate, name: name, description: description };
}

function findLastPublished(history) {
  return [].concat((0, _toConsumableArray3.default)(history)).reverse().map(JSON.parse).find(function (obj) {
    return obj.imageUrl;
  });
}

function createStatus(statusText) {
  return statusText[0].toUpperCase() + statusText.slice(1);
}

function findImage(urls) {
  var gamsUrls = setGamsUrls(urls) || [];
  var searchByCrop = searchGamsUrls(gamsUrls);
  return searchByCrop('4U') || searchByCrop('PREVIEW') || 'https://images.wsj.net/im-108184';
}

function setGamsUrls(urls) {
  if (urls && urls.gamsUrls) {
    var gamsUrls = urls.gamsUrls;

    return Array.isArray(gamsUrls) ? gamsUrls : [gamsUrls];
  }
}

function searchGamsUrls(gamsUrls) {
  return function (crop) {
    return gamsUrls.find(function (url) {
      return url.includes(crop);
    });
  };
}

function success(res, data) {
  data.status = 'success';
  res.json(data);
  // res.json(_.assign({ status: 'success' }, data ));
}

function fail(res, data) {
  data.status = 'fail';
  res.json(data);
  // res.json(_.assign({ status: 'fail'}, data ));
}

// function filterByArray(charts, prop, value) {
//   if (!value) {
//     return charts;
//   }
//   value = Array.isArray(value) ? value : [value];
//   let filtered = [];
//   charts.forEach(chart => {
//     const chartVal = chart[prop];
//     if (chartVal) {
//       let found = false;
//       for (let i = 0; i < value.length; i++) {
//         if (chartVal.indexOf(value[i]) !== -1) {
//           found = true;
//           break;
//         }
//       }
//       if (found) filtered.push(chart);
//     }
//   });
//   return filtered;
// }
//
//
// function filterByString(charts, prop, value) {
//   if (value) {
//     let filtered = [];
//     charts.forEach(chart => {
//       const chartVal = chart[prop];
//       if (chartVal) {
//         if (chartVal.indexOf(value) !== -1) {
//           filtered.push(chart);
//         }
//       }
//     });
//     return filtered;
//   }
//   return charts;
// }


// function filterByDate(charts, prop, value) {
//   if (value && value !== 'anytime') {
//     let filtered = [];
//     const minDate = Date.now() - getRelativeTime(value);
//     charts.forEach(chart => {
//       if (Date.parse(chart[prop]) >= minDate) {
//         filtered.push(chart);
//       }
//     });
//     return filtered;
//   }
//   return charts;
// }


exports.updateChartData = updateChartData;
exports.pngRequest = pngRequest;
exports.epsRequest = epsRequest;
exports.success = success;
exports.fail = fail;
exports.simplifyCharts = simplifyCharts;
exports.findUniqueHeadlines = findUniqueHeadlines;
exports.pullOutHeadlines = pullOutHeadlines;
exports.convertTime = convertTime;
exports.convertQueryObj = convertQueryObj;
exports.convertSortObj = convertSortObj;
exports.checkArray = checkArray;
exports.buildMetadata = buildMetadata;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(292);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(293);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(295);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(296), __esModule: true };

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205);
__webpack_require__(23);
__webpack_require__(25);
__webpack_require__(297);
__webpack_require__(305);
__webpack_require__(306);
module.exports = __webpack_require__(5).Promise;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(20);
var global = __webpack_require__(1);
var ctx = __webpack_require__(21);
var classof = __webpack_require__(45);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(12);
var aFunction = __webpack_require__(26);
var anInstance = __webpack_require__(298);
var forOf = __webpack_require__(299);
var speciesConstructor = __webpack_require__(213);
var task = __webpack_require__(214).set;
var microtask = __webpack_require__(301)();
var newPromiseCapabilityModule = __webpack_require__(55);
var perform = __webpack_require__(215);
var userAgent = __webpack_require__(302);
var promiseResolve = __webpack_require__(216);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(2)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(303)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(29)($Promise, PROMISE);
__webpack_require__(304)(PROMISE);
Wrapper = __webpack_require__(5)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(67)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(21);
var call = __webpack_require__(65);
var isArrayIter = __webpack_require__(66);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(39);
var getIterFn = __webpack_require__(46);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var macrotask = __webpack_require__(214).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(19)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(11);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(1);
var core = __webpack_require__(5);
var dP = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(9);
var SPECIES = __webpack_require__(2)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(10);
var core = __webpack_require__(5);
var global = __webpack_require__(1);
var speciesConstructor = __webpack_require__(213);
var promiseResolve = __webpack_require__(216);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(55);
var perform = __webpack_require__(215);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, process, global, module) {(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.async = global.async || {})));
}(this, (function (exports) { 'use strict';

function slice(arrayLike, start) {
    start = start|0;
    var newLen = Math.max(arrayLike.length - start, 0);
    var newArr = Array(newLen);
    for(var idx = 0; idx < newLen; idx++)  {
        newArr[idx] = arrayLike[start + idx];
    }
    return newArr;
}

/**
 * Creates a continuation function with some arguments already applied.
 *
 * Useful as a shorthand when combined with other control flow functions. Any
 * arguments passed to the returned function are added to the arguments
 * originally passed to apply.
 *
 * @name apply
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {Function} fn - The function you want to eventually apply all
 * arguments to. Invokes with (arguments...).
 * @param {...*} arguments... - Any number of arguments to automatically apply
 * when the continuation is called.
 * @returns {Function} the partially-applied function
 * @example
 *
 * // using apply
 * async.parallel([
 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
 *     async.apply(fs.writeFile, 'testfile2', 'test2')
 * ]);
 *
 *
 * // the same process without using apply
 * async.parallel([
 *     function(callback) {
 *         fs.writeFile('testfile1', 'test1', callback);
 *     },
 *     function(callback) {
 *         fs.writeFile('testfile2', 'test2', callback);
 *     }
 * ]);
 *
 * // It's possible to pass any number of additional arguments when calling the
 * // continuation:
 *
 * node> var fn = async.apply(sys.puts, 'one');
 * node> fn('two', 'three');
 * one
 * two
 * three
 */
var apply = function(fn/*, ...args*/) {
    var args = slice(arguments, 1);
    return function(/*callArgs*/) {
        var callArgs = slice(arguments);
        return fn.apply(null, args.concat(callArgs));
    };
};

var initialParams = function (fn) {
    return function (/*...args, callback*/) {
        var args = slice(arguments);
        var callback = args.pop();
        fn.call(this, args, callback);
    };
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

function fallback(fn) {
    setTimeout(fn, 0);
}

function wrap(defer) {
    return function (fn/*, ...args*/) {
        var args = slice(arguments, 1);
        defer(function () {
            fn.apply(null, args);
        });
    };
}

var _defer;

if (hasSetImmediate) {
    _defer = setImmediate;
} else if (hasNextTick) {
    _defer = process.nextTick;
} else {
    _defer = fallback;
}

var setImmediate$1 = wrap(_defer);

/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */
function asyncify(func) {
    return initialParams(function (args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (isObject(result) && typeof result.then === 'function') {
            result.then(function(value) {
                invokeCallback(callback, null, value);
            }, function(err) {
                invokeCallback(callback, err.message ? err : new Error(err));
            });
        } else {
            callback(null, result);
        }
    });
}

function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (e) {
        setImmediate$1(rethrow, e);
    }
}

function rethrow(error) {
    throw error;
}

var supportsSymbol = typeof Symbol === 'function';

function isAsync(fn) {
    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
}

function wrapAsync(asyncFn) {
    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
}

function applyEach$1(eachfn) {
    return function(fns/*, ...args*/) {
        var args = slice(arguments, 1);
        var go = initialParams(function(args, callback) {
            var that = this;
            return eachfn(fns, function (fn, cb) {
                wrapAsync(fn).apply(that, args.concat(cb));
            }, callback);
        });
        if (args.length) {
            return go.apply(this, args);
        }
        else {
            return go;
        }
    };
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]';
var funcTag = '[object Function]';
var genTag = '[object GeneratorFunction]';
var proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
var breakLoop = {};

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

function once(fn) {
    return function () {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}

var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;

var getIterator = function (coll) {
    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
};

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]';
var arrayTag = '[object Array]';
var boolTag = '[object Boolean]';
var dateTag = '[object Date]';
var errorTag = '[object Error]';
var funcTag$1 = '[object Function]';
var mapTag = '[object Map]';
var numberTag = '[object Number]';
var objectTag = '[object Object]';
var regexpTag = '[object RegExp]';
var setTag = '[object Set]';
var stringTag = '[object String]';
var weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]';
var dataViewTag = '[object DataView]';
var float32Tag = '[object Float32Array]';
var float64Tag = '[object Float64Array]';
var int8Tag = '[object Int8Array]';
var int16Tag = '[object Int16Array]';
var int32Tag = '[object Int32Array]';
var uint8Tag = '[object Uint8Array]';
var uint8ClampedTag = '[object Uint8ClampedArray]';
var uint16Tag = '[object Uint16Array]';
var uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$1.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? {value: coll[i], key: i} : null;
    }
}

function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done)
            return null;
        i++;
        return {value: item.value, key: i};
    }
}

function createObjectIterator(obj) {
    var okeys = keys(obj);
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        return i < len ? {value: obj[key], key: key} : null;
    };
}

function iterator(coll) {
    if (isArrayLike(coll)) {
        return createArrayIterator(coll);
    }

    var iterator = getIterator(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
}

function onlyOnce(fn) {
    return function() {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}

function _eachOfLimit(limit) {
    return function (obj, iteratee, callback) {
        callback = once(callback || noop);
        if (limit <= 0 || !obj) {
            return callback(null);
        }
        var nextElem = iterator(obj);
        var done = false;
        var running = 0;
        var looping = false;

        function iterateeCallback(err, value) {
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            }
            else if (value === breakLoop || (done && running <= 0)) {
                done = true;
                return callback(null);
            }
            else if (!looping) {
                replenish();
            }
        }

        function replenish () {
            looping = true;
            while (running < limit && !done) {
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) {
                        callback(null);
                    }
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
            }
            looping = false;
        }

        replenish();
    };
}

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
function eachOfLimit(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
}

function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}

// eachOf implementation optimized for array-likes
function eachOfArrayLike(coll, iteratee, callback) {
    callback = once(callback || noop);
    var index = 0,
        completed = 0,
        length = coll.length;
    if (length === 0) {
        callback(null);
    }

    function iteratorCallback(err, value) {
        if (err) {
            callback(err);
        } else if ((++completed === length) || value === breakLoop) {
            callback(null);
        }
    }

    for (; index < length; index++) {
        iteratee(coll[index], index, onlyOnce(iteratorCallback));
    }
}

// a generic version of eachOf which can handle array, object, and iterator cases.
var eachOfGeneric = doLimit(eachOfLimit, Infinity);

/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
 * var configs = {};
 *
 * async.forEachOf(obj, function (value, key, callback) {
 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
 *         if (err) return callback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }, function (err) {
 *     if (err) console.error(err.message);
 *     // configs is now a map of JSON data
 *     doSomethingWith(configs);
 * });
 */
var eachOf = function(coll, iteratee, callback) {
    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
    eachOfImplementation(coll, wrapAsync(iteratee), callback);
};

function doParallel(fn) {
    return function (obj, iteratee, callback) {
        return fn(eachOf, obj, wrapAsync(iteratee), callback);
    };
}

function _asyncMap(eachfn, arr, iteratee, callback) {
    callback = callback || noop;
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = wrapAsync(iteratee);

    eachfn(arr, function (value, _, callback) {
        var index = counter++;
        _iteratee(value, function (err, v) {
            results[index] = v;
            callback(err);
        });
    }, function (err) {
        callback(err, results);
    });
}

/**
 * Produces a new collection of values by mapping each value in `coll` through
 * the `iteratee` function. The `iteratee` is called with an item from `coll`
 * and a callback for when it has finished processing. Each of these callback
 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
 * `iteratee` passes an error to its callback, the main `callback` (for the
 * `map` function) is immediately called with the error.
 *
 * Note, that since this function applies the `iteratee` to each item in
 * parallel, there is no guarantee that the `iteratee` functions will complete
 * in order. However, the results array will be in the same order as the
 * original `coll`.
 *
 * If `map` is passed an Object, the results will be an Array.  The results
 * will roughly be in the order of the original Objects' keys (but this can
 * vary across JavaScript engines).
 *
 * @name map
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an Array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @example
 *
 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
 *     // results is now an array of stats for each file
 * });
 */
var map = doParallel(_asyncMap);

/**
 * Applies the provided arguments to each function in the array, calling
 * `callback` after all functions have completed. If you only provide the first
 * argument, `fns`, then it will return a function which lets you pass in the
 * arguments as if it were a single function call. If more arguments are
 * provided, `callback` is required while `args` is still optional.
 *
 * @name applyEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s
 * to all call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {Function} - If only the first argument, `fns`, is provided, it will
 * return a function which lets you pass in the arguments as if it were a single
 * function call. The signature is `(..args, callback)`. If invoked with any
 * arguments, `callback` is required.
 * @example
 *
 * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
 *
 * // partial application example:
 * async.each(
 *     buckets,
 *     async.applyEach([enableSearch, updateSchema]),
 *     callback
 * );
 */
var applyEach = applyEach$1(map);

function doParallelLimit(fn) {
    return function (obj, limit, iteratee, callback) {
        return fn(_eachOfLimit(limit), obj, wrapAsync(iteratee), callback);
    };
}

/**
 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
 *
 * @name mapLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 */
var mapLimit = doParallelLimit(_asyncMap);

/**
 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
 *
 * @name mapSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 */
var mapSeries = doLimit(mapLimit, 1);

/**
 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
 *
 * @name applyEachSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
 * @category Control Flow
 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s to all
 * call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {Function} - If only the first argument is provided, it will return
 * a function which lets you pass in the arguments as if it were a single
 * function call.
 */
var applyEachSeries = applyEach$1(mapSeries);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

/**
 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
 * their requirements. Each function can optionally depend on other functions
 * being completed first, and each function is run as soon as its requirements
 * are satisfied.
 *
 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
 * will stop. Further tasks will not execute (so any other functions depending
 * on it will not run), and the main `callback` is immediately called with the
 * error.
 *
 * {@link AsyncFunction}s also receive an object containing the results of functions which
 * have completed so far as the first argument, if they have dependencies. If a
 * task function has no dependencies, it will only be passed a callback.
 *
 * @name auto
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Object} tasks - An object. Each of its properties is either a
 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
 * in the array. The object's key of a property serves as the name of the task
 * defined by that property, i.e. can be used when specifying requirements for
 * other tasks. The function receives one or two arguments:
 * * a `results` object, containing the results of the previously executed
 *   functions, only passed if the task has any dependencies,
 * * a `callback(err, result)` function, which must be called when finished,
 *   passing an `error` (which can be `null`) and the result of the function's
 *   execution.
 * @param {number} [concurrency=Infinity] - An optional `integer` for
 * determining the maximum number of tasks that can be run in parallel. By
 * default, as many as possible.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback. Results are always returned; however, if an
 * error occurs, no further `tasks` will be performed, and the results object
 * will only contain partial results. Invoked with (err, results).
 * @returns undefined
 * @example
 *
 * async.auto({
 *     // this function will just be passed a callback
 *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
 *     showData: ['readData', function(results, cb) {
 *         // results.readData is the file's contents
 *         // ...
 *     }]
 * }, callback);
 *
 * async.auto({
 *     get_data: function(callback) {
 *         console.log('in get_data');
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         console.log('in make_folder');
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         console.log('in write_file', JSON.stringify(results));
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         console.log('in email_link', JSON.stringify(results));
 *         // once the file is written let's email a link to it...
 *         // results.write_file contains the filename returned by write_file.
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('results = ', results);
 * });
 */
var auto = function (tasks, concurrency, callback) {
    if (typeof concurrency === 'function') {
        // concurrency is optional, shift the args.
        callback = concurrency;
        concurrency = null;
    }
    callback = once(callback || noop);
    var keys$$1 = keys(tasks);
    var numTasks = keys$$1.length;
    if (!numTasks) {
        return callback(null);
    }
    if (!concurrency) {
        concurrency = numTasks;
    }

    var results = {};
    var runningTasks = 0;
    var hasError = false;

    var listeners = Object.create(null);

    var readyTasks = [];

    // for cycle detection:
    var readyToCheck = []; // tasks that have been identified as reachable
    // without the possibility of returning to an ancestor task
    var uncheckedDependencies = {};

    baseForOwn(tasks, function (task, key) {
        if (!isArray(task)) {
            // no dependencies
            enqueueTask(key, [task]);
            readyToCheck.push(key);
            return;
        }

        var dependencies = task.slice(0, task.length - 1);
        var remainingDependencies = dependencies.length;
        if (remainingDependencies === 0) {
            enqueueTask(key, task);
            readyToCheck.push(key);
            return;
        }
        uncheckedDependencies[key] = remainingDependencies;

        arrayEach(dependencies, function (dependencyName) {
            if (!tasks[dependencyName]) {
                throw new Error('async.auto task `' + key +
                    '` has a non-existent dependency `' +
                    dependencyName + '` in ' +
                    dependencies.join(', '));
            }
            addListener(dependencyName, function () {
                remainingDependencies--;
                if (remainingDependencies === 0) {
                    enqueueTask(key, task);
                }
            });
        });
    });

    checkForDeadlocks();
    processQueue();

    function enqueueTask(key, task) {
        readyTasks.push(function () {
            runTask(key, task);
        });
    }

    function processQueue() {
        if (readyTasks.length === 0 && runningTasks === 0) {
            return callback(null, results);
        }
        while(readyTasks.length && runningTasks < concurrency) {
            var run = readyTasks.shift();
            run();
        }

    }

    function addListener(taskName, fn) {
        var taskListeners = listeners[taskName];
        if (!taskListeners) {
            taskListeners = listeners[taskName] = [];
        }

        taskListeners.push(fn);
    }

    function taskComplete(taskName) {
        var taskListeners = listeners[taskName] || [];
        arrayEach(taskListeners, function (fn) {
            fn();
        });
        processQueue();
    }


    function runTask(key, task) {
        if (hasError) return;

        var taskCallback = onlyOnce(function(err, result) {
            runningTasks--;
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            }
            if (err) {
                var safeResults = {};
                baseForOwn(results, function(val, rkey) {
                    safeResults[rkey] = val;
                });
                safeResults[key] = result;
                hasError = true;
                listeners = Object.create(null);

                callback(err, safeResults);
            } else {
                results[key] = result;
                taskComplete(key);
            }
        });

        runningTasks++;
        var taskFn = wrapAsync(task[task.length - 1]);
        if (task.length > 1) {
            taskFn(results, taskCallback);
        } else {
            taskFn(taskCallback);
        }
    }

    function checkForDeadlocks() {
        // Kahn's algorithm
        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
        var currentTask;
        var counter = 0;
        while (readyToCheck.length) {
            currentTask = readyToCheck.pop();
            counter++;
            arrayEach(getDependents(currentTask), function (dependent) {
                if (--uncheckedDependencies[dependent] === 0) {
                    readyToCheck.push(dependent);
                }
            });
        }

        if (counter !== numTasks) {
            throw new Error(
                'async.auto cannot execute tasks due to a recursive dependency'
            );
        }
    }

    function getDependents(taskName) {
        var result = [];
        baseForOwn(tasks, function (task, key) {
            if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
                result.push(key);
            }
        });
        return result;
    }
};

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
var symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff';
var rsComboMarksRange = '\\u0300-\\u036f';
var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange = '\\u20d0-\\u20ff';
var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
var rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff';
var rsComboMarksRange$1 = '\\u0300-\\u036f';
var reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']';
var rsCombo = '[' + rsComboRange$1 + ']';
var rsFitz = '\\ud83c[\\udffb-\\udfff]';
var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
var rsNonAstral = '[^' + rsAstralRange$1 + ']';
var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
var rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?';
var rsOptVar = '[' + rsVarRange$1 + ']?';
var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
var rsSeq = rsOptVar + reOptMod + rsOptJoin;
var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

var FN_ARGS = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /(=.+)?(\s*)$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;

function parseParams(func) {
    func = func.toString().replace(STRIP_COMMENTS, '');
    func = func.match(FN_ARGS)[2].replace(' ', '');
    func = func ? func.split(FN_ARG_SPLIT) : [];
    func = func.map(function (arg){
        return trim(arg.replace(FN_ARG, ''));
    });
    return func;
}

/**
 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
 * tasks are specified as parameters to the function, after the usual callback
 * parameter, with the parameter names matching the names of the tasks it
 * depends on. This can provide even more readable task graphs which can be
 * easier to maintain.
 *
 * If a final callback is specified, the task results are similarly injected,
 * specified as named parameters after the initial error parameter.
 *
 * The autoInject function is purely syntactic sugar and its semantics are
 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
 *
 * @name autoInject
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.auto]{@link module:ControlFlow.auto}
 * @category Control Flow
 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
 * the form 'func([dependencies...], callback). The object's key of a property
 * serves as the name of the task defined by that property, i.e. can be used
 * when specifying requirements for other tasks.
 * * The `callback` parameter is a `callback(err, result)` which must be called
 *   when finished, passing an `error` (which can be `null`) and the result of
 *   the function's execution. The remaining parameters name other tasks on
 *   which the task is dependent, and the results from those tasks are the
 *   arguments of those parameters.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback, and a `results` object with any completed
 * task results, similar to `auto`.
 * @example
 *
 * //  The example from `auto` can be rewritten as follows:
 * async.autoInject({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: function(get_data, make_folder, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     },
 *     email_link: function(write_file, callback) {
 *         // once the file is written let's email a link to it...
 *         // write_file contains the filename returned by write_file.
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 *
 * // If you are using a JS minifier that mangles parameter names, `autoInject`
 * // will not work with plain functions, since the parameter names will be
 * // collapsed to a single letter identifier.  To work around this, you can
 * // explicitly specify the names of the parameters your task function needs
 * // in an array, similar to Angular.js dependency injection.
 *
 * // This still has an advantage over plain `auto`, since the results a task
 * // depends on are still spread into arguments.
 * async.autoInject({
 *     //...
 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(write_file, callback) {
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }]
 *     //...
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 */
function autoInject(tasks, callback) {
    var newTasks = {};

    baseForOwn(tasks, function (taskFn, key) {
        var params;
        var fnIsAsync = isAsync(taskFn);
        var hasNoDeps =
            (!fnIsAsync && taskFn.length === 1) ||
            (fnIsAsync && taskFn.length === 0);

        if (isArray(taskFn)) {
            params = taskFn.slice(0, -1);
            taskFn = taskFn[taskFn.length - 1];

            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
        } else if (hasNoDeps) {
            // no dependencies, use the function as-is
            newTasks[key] = taskFn;
        } else {
            params = parseParams(taskFn);
            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) {
                throw new Error("autoInject task functions require explicit parameters.");
            }

            // remove callback param
            if (!fnIsAsync) params.pop();

            newTasks[key] = params.concat(newTask);
        }

        function newTask(results, taskCb) {
            var newArgs = arrayMap(params, function (name) {
                return results[name];
            });
            newArgs.push(taskCb);
            wrapAsync(taskFn).apply(null, newArgs);
        }
    });

    auto(newTasks, callback);
}

// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
// used for queues. This implementation assumes that the node provided by the user can be modified
// to adjust the next and last properties. We implement only the minimal functionality
// for queue support.
function DLL() {
    this.head = this.tail = null;
    this.length = 0;
}

function setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
}

DLL.prototype.removeLink = function(node) {
    if (node.prev) node.prev.next = node.next;
    else this.head = node.next;
    if (node.next) node.next.prev = node.prev;
    else this.tail = node.prev;

    node.prev = node.next = null;
    this.length -= 1;
    return node;
};

DLL.prototype.empty = function () {
    while(this.head) this.shift();
    return this;
};

DLL.prototype.insertAfter = function(node, newNode) {
    newNode.prev = node;
    newNode.next = node.next;
    if (node.next) node.next.prev = newNode;
    else this.tail = newNode;
    node.next = newNode;
    this.length += 1;
};

DLL.prototype.insertBefore = function(node, newNode) {
    newNode.prev = node.prev;
    newNode.next = node;
    if (node.prev) node.prev.next = newNode;
    else this.head = newNode;
    node.prev = newNode;
    this.length += 1;
};

DLL.prototype.unshift = function(node) {
    if (this.head) this.insertBefore(this.head, node);
    else setInitial(this, node);
};

DLL.prototype.push = function(node) {
    if (this.tail) this.insertAfter(this.tail, node);
    else setInitial(this, node);
};

DLL.prototype.shift = function() {
    return this.head && this.removeLink(this.head);
};

DLL.prototype.pop = function() {
    return this.tail && this.removeLink(this.tail);
};

DLL.prototype.toArray = function () {
    var arr = Array(this.length);
    var curr = this.head;
    for(var idx = 0; idx < this.length; idx++) {
        arr[idx] = curr.data;
        curr = curr.next;
    }
    return arr;
};

DLL.prototype.remove = function (testFn) {
    var curr = this.head;
    while(!!curr) {
        var next = curr.next;
        if (testFn(curr)) {
            this.removeLink(curr);
        }
        curr = next;
    }
    return this;
};

function queue(worker, concurrency, payload) {
    if (concurrency == null) {
        concurrency = 1;
    }
    else if(concurrency === 0) {
        throw new Error('Concurrency must not be zero');
    }

    var _worker = wrapAsync(worker);
    var numRunning = 0;
    var workersList = [];

    var processingScheduled = false;
    function _insert(data, insertAtFront, callback) {
        if (callback != null && typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;
        if (!isArray(data)) {
            data = [data];
        }
        if (data.length === 0 && q.idle()) {
            // call drain immediately if there are no tasks
            return setImmediate$1(function() {
                q.drain();
            });
        }

        for (var i = 0, l = data.length; i < l; i++) {
            var item = {
                data: data[i],
                callback: callback || noop
            };

            if (insertAtFront) {
                q._tasks.unshift(item);
            } else {
                q._tasks.push(item);
            }
        }

        if (!processingScheduled) {
            processingScheduled = true;
            setImmediate$1(function() {
                processingScheduled = false;
                q.process();
            });
        }
    }

    function _next(tasks) {
        return function(err){
            numRunning -= 1;

            for (var i = 0, l = tasks.length; i < l; i++) {
                var task = tasks[i];

                var index = baseIndexOf(workersList, task, 0);
                if (index === 0) {
                    workersList.shift();
                } else if (index > 0) {
                    workersList.splice(index, 1);
                }

                task.callback.apply(task, arguments);

                if (err != null) {
                    q.error(err, task.data);
                }
            }

            if (numRunning <= (q.concurrency - q.buffer) ) {
                q.unsaturated();
            }

            if (q.idle()) {
                q.drain();
            }
            q.process();
        };
    }

    var isProcessing = false;
    var q = {
        _tasks: new DLL(),
        concurrency: concurrency,
        payload: payload,
        saturated: noop,
        unsaturated:noop,
        buffer: concurrency / 4,
        empty: noop,
        drain: noop,
        error: noop,
        started: false,
        paused: false,
        push: function (data, callback) {
            _insert(data, false, callback);
        },
        kill: function () {
            q.drain = noop;
            q._tasks.empty();
        },
        unshift: function (data, callback) {
            _insert(data, true, callback);
        },
        remove: function (testFn) {
            q._tasks.remove(testFn);
        },
        process: function () {
            // Avoid trying to start too many processing operations. This can occur
            // when callbacks resolve synchronously (#1267).
            if (isProcessing) {
                return;
            }
            isProcessing = true;
            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                var tasks = [], data = [];
                var l = q._tasks.length;
                if (q.payload) l = Math.min(l, q.payload);
                for (var i = 0; i < l; i++) {
                    var node = q._tasks.shift();
                    tasks.push(node);
                    workersList.push(node);
                    data.push(node.data);
                }

                numRunning += 1;

                if (q._tasks.length === 0) {
                    q.empty();
                }

                if (numRunning === q.concurrency) {
                    q.saturated();
                }

                var cb = onlyOnce(_next(tasks));
                _worker(data, cb);
            }
            isProcessing = false;
        },
        length: function () {
            return q._tasks.length;
        },
        running: function () {
            return numRunning;
        },
        workersList: function () {
            return workersList;
        },
        idle: function() {
            return q._tasks.length + numRunning === 0;
        },
        pause: function () {
            q.paused = true;
        },
        resume: function () {
            if (q.paused === false) { return; }
            q.paused = false;
            setImmediate$1(q.process);
        }
    };
    return q;
}

/**
 * A cargo of tasks for the worker function to complete. Cargo inherits all of
 * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
 * @typedef {Object} CargoObject
 * @memberOf module:ControlFlow
 * @property {Function} length - A function returning the number of items
 * waiting to be processed. Invoke like `cargo.length()`.
 * @property {number} payload - An `integer` for determining how many tasks
 * should be process per round. This property can be changed after a `cargo` is
 * created to alter the payload on-the-fly.
 * @property {Function} push - Adds `task` to the `queue`. The callback is
 * called once the `worker` has finished processing the task. Instead of a
 * single task, an array of `tasks` can be submitted. The respective callback is
 * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
 * @property {Function} saturated - A callback that is called when the
 * `queue.length()` hits the concurrency and further tasks will be queued.
 * @property {Function} empty - A callback that is called when the last item
 * from the `queue` is given to a `worker`.
 * @property {Function} drain - A callback that is called when the last item
 * from the `queue` has returned from the `worker`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke like `cargo.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
 */

/**
 * Creates a `cargo` object with the specified payload. Tasks added to the
 * cargo will be processed altogether (up to the `payload` limit). If the
 * `worker` is in progress, the task is queued until it becomes available. Once
 * the `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, cargo passes an array of tasks to a single worker, repeating
 * when the worker is finished.
 *
 * @name cargo
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargo and inner queue.
 * @example
 *
 * // create a cargo object with payload 2
 * var cargo = async.cargo(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2);
 *
 * // add some items
 * cargo.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargo.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * cargo.push({name: 'baz'}, function(err) {
 *     console.log('finished processing baz');
 * });
 */
function cargo(worker, payload) {
    return queue(worker, 1, payload);
}

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 */
var eachOfSeries = doLimit(eachOfLimit, 1);

/**
 * Reduces `coll` into a single value using an async `iteratee` to return each
 * successive step. `memo` is the initial state of the reduction. This function
 * only operates in series.
 *
 * For performance reasons, it may make sense to split a call to this function
 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
 * results. This function is for situations where each step in the reduction
 * needs to be async; if you can get the data before reducing it, then it's
 * probably a good idea to do so.
 *
 * @name reduce
 * @static
 * @memberOf module:Collections
 * @method
 * @alias inject
 * @alias foldl
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee complete with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @example
 *
 * async.reduce([1,2,3], 0, function(memo, item, callback) {
 *     // pointless async:
 *     process.nextTick(function() {
 *         callback(null, memo + item)
 *     });
 * }, function(err, result) {
 *     // result is now equal to the last value of memo, which is 6
 * });
 */
function reduce(coll, memo, iteratee, callback) {
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    eachOfSeries(coll, function(x, i, callback) {
        _iteratee(memo, x, function(err, v) {
            memo = v;
            callback(err);
        });
    }, function(err) {
        callback(err, memo);
    });
}

/**
 * Version of the compose function that is more natural to read. Each function
 * consumes the return value of the previous function. It is the equivalent of
 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name seq
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.compose]{@link module:ControlFlow.compose}
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} a function that composes the `functions` in order
 * @example
 *
 * // Requires lodash (or underscore), express3 and dresende's orm2.
 * // Part of an app, that fetches cats of the logged user.
 * // This example uses `seq` function to avoid overnesting and error
 * // handling clutter.
 * app.get('/cats', function(request, response) {
 *     var User = request.models.User;
 *     async.seq(
 *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
 *         function(user, fn) {
 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
 *         }
 *     )(req.session.user_id, function (err, cats) {
 *         if (err) {
 *             console.error(err);
 *             response.json({ status: 'error', message: err.message });
 *         } else {
 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
 *         }
 *     });
 * });
 */
function seq(/*...functions*/) {
    var _functions = arrayMap(arguments, wrapAsync);
    return function(/*...args*/) {
        var args = slice(arguments);
        var that = this;

        var cb = args[args.length - 1];
        if (typeof cb == 'function') {
            args.pop();
        } else {
            cb = noop;
        }

        reduce(_functions, args, function(newargs, fn, cb) {
            fn.apply(that, newargs.concat(function(err/*, ...nextargs*/) {
                var nextargs = slice(arguments, 1);
                cb(err, nextargs);
            }));
        },
        function(err, results) {
            cb.apply(that, [err].concat(results));
        });
    };
}

/**
 * Creates a function which is a composition of the passed asynchronous
 * functions. Each function consumes the return value of the function that
 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name compose
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} an asynchronous function that is the composed
 * asynchronous `functions`
 * @example
 *
 * function add1(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n + 1);
 *     }, 10);
 * }
 *
 * function mul3(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n * 3);
 *     }, 10);
 * }
 *
 * var add1mul3 = async.compose(mul3, add1);
 * add1mul3(4, function (err, result) {
 *     // result now equals 15
 * });
 */
var compose = function(/*...args*/) {
    return seq.apply(null, slice(arguments).reverse());
};

var _concat = Array.prototype.concat;

/**
 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
 *
 * @name concatLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 */
var concatLimit = function(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function(val, callback) {
        _iteratee(val, function(err /*, ...args*/) {
            if (err) return callback(err);
            return callback(null, slice(arguments, 1));
        });
    }, function(err, mapResults) {
        var result = [];
        for (var i = 0; i < mapResults.length; i++) {
            if (mapResults[i]) {
                result = _concat.apply(result, mapResults[i]);
            }
        }

        return callback(err, result);
    });
};

/**
 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
 * the concatenated list. The `iteratee`s are called in parallel, and the
 * results are concatenated as they return. There is no guarantee that the
 * results array will be returned in the original order of `coll` passed to the
 * `iteratee` function.
 *
 * @name concat
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback(err)] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @example
 *
 * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
 *     // files is now a list of filenames that exist in the 3 directories
 * });
 */
var concat = doLimit(concatLimit, Infinity);

/**
 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
 *
 * @name concatSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
 * The iteratee should complete with an array an array of results.
 * Invoked with (item, callback).
 * @param {Function} [callback(err)] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 */
var concatSeries = doLimit(concatLimit, 1);

/**
 * Returns a function that when called, calls-back with the values provided.
 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
 * [`auto`]{@link module:ControlFlow.auto}.
 *
 * @name constant
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {...*} arguments... - Any number of arguments to automatically invoke
 * callback with.
 * @returns {AsyncFunction} Returns a function that when invoked, automatically
 * invokes the callback with the previous given arguments.
 * @example
 *
 * async.waterfall([
 *     async.constant(42),
 *     function (value, next) {
 *         // value === 42
 *     },
 *     //...
 * ], callback);
 *
 * async.waterfall([
 *     async.constant(filename, "utf8"),
 *     fs.readFile,
 *     function (fileData, next) {
 *         //...
 *     }
 *     //...
 * ], callback);
 *
 * async.auto({
 *     hostname: async.constant("https://server.net/"),
 *     port: findFreePort,
 *     launchServer: ["hostname", "port", function (options, cb) {
 *         startServer(options, cb);
 *     }],
 *     //...
 * }, callback);
 */
var constant = function(/*...values*/) {
    var values = slice(arguments);
    var args = [null].concat(values);
    return function (/*...ignoredArgs, callback*/) {
        var callback = arguments[arguments.length - 1];
        return callback.apply(this, args);
    };
};

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

function _createTester(check, getResult) {
    return function(eachfn, arr, iteratee, cb) {
        cb = cb || noop;
        var testPassed = false;
        var testResult;
        eachfn(arr, function(value, _, callback) {
            iteratee(value, function(err, result) {
                if (err) {
                    callback(err);
                } else if (check(result) && !testResult) {
                    testPassed = true;
                    testResult = getResult(true, value);
                    callback(null, breakLoop);
                } else {
                    callback();
                }
            });
        }, function(err) {
            if (err) {
                cb(err);
            } else {
                cb(null, testPassed ? testResult : getResult(false));
            }
        });
    };
}

function _findGetResult(v, x) {
    return x;
}

/**
 * Returns the first value in `coll` that passes an async truth test. The
 * `iteratee` is applied in parallel, meaning the first iteratee to return
 * `true` will fire the detect `callback` with that result. That means the
 * result might not be the first item in the original `coll` (in terms of order)
 * that passes the test.

 * If order within the original `coll` is important, then look at
 * [`detectSeries`]{@link module:Collections.detectSeries}.
 *
 * @name detect
 * @static
 * @memberOf module:Collections
 * @method
 * @alias find
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @example
 *
 * async.detect(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // result now equals the first file in the list that exists
 * });
 */
var detect = doParallel(_createTester(identity, _findGetResult));

/**
 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name detectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findLimit
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 */
var detectLimit = doParallelLimit(_createTester(identity, _findGetResult));

/**
 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
 *
 * @name detectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findSeries
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 */
var detectSeries = doLimit(detectLimit, 1);

function consoleFunc(name) {
    return function (fn/*, ...args*/) {
        var args = slice(arguments, 1);
        args.push(function (err/*, ...args*/) {
            var args = slice(arguments, 1);
            if (typeof console === 'object') {
                if (err) {
                    if (console.error) {
                        console.error(err);
                    }
                } else if (console[name]) {
                    arrayEach(args, function (x) {
                        console[name](x);
                    });
                }
            }
        });
        wrapAsync(fn).apply(null, args);
    };
}

/**
 * Logs the result of an [`async` function]{@link AsyncFunction} to the
 * `console` using `console.dir` to display the properties of the resulting object.
 * Only works in Node.js or in browsers that support `console.dir` and
 * `console.error` (such as FF and Chrome).
 * If multiple arguments are returned from the async function,
 * `console.dir` is called on each argument in order.
 *
 * @name dir
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, {hello: name});
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.dir(hello, 'world');
 * {hello: 'world'}
 */
var dir = consoleFunc('dir');

/**
 * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
 * the order of operations, the arguments `test` and `fn` are switched.
 *
 * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
 * @name doDuring
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.during]{@link module:ControlFlow.during}
 * @category Control Flow
 * @param {AsyncFunction} fn - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `fn`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `fn`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `fn` has stopped. `callback`
 * will be passed an error if one occurred, otherwise `null`.
 */
function doDuring(fn, test, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);

    function next(err/*, ...args*/) {
        if (err) return callback(err);
        var args = slice(arguments, 1);
        args.push(check);
        _test.apply(this, args);
    }

    function check(err, truth) {
        if (err) return callback(err);
        if (!truth) return callback(null);
        _fn(next);
    }

    check(null, true);

}

/**
 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
 * the order of operations, the arguments `test` and `iteratee` are switched.
 *
 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
 *
 * @name doWhilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - A function which is called each time `test`
 * passes. Invoked with (callback).
 * @param {Function} test - synchronous truth test to perform after each
 * execution of `iteratee`. Invoked with any non-error callback results of
 * `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped.
 * `callback` will be passed an error and any arguments passed to the final
 * `iteratee`'s callback. Invoked with (err, [results]);
 */
function doWhilst(iteratee, test, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    var next = function(err/*, ...args*/) {
        if (err) return callback(err);
        var args = slice(arguments, 1);
        if (test.apply(this, args)) return _iteratee(next);
        callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
}

/**
 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
 * argument ordering differs from `until`.
 *
 * @name doUntil
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} test - synchronous truth test to perform after each
 * execution of `iteratee`. Invoked with any non-error callback results of
 * `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 */
function doUntil(iteratee, test, callback) {
    doWhilst(iteratee, function() {
        return !test.apply(this, arguments);
    }, callback);
}

/**
 * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
 * is passed a callback in the form of `function (err, truth)`. If error is
 * passed to `test` or `fn`, the main callback is immediately called with the
 * value of the error.
 *
 * @name during
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `fn`. Invoked with (callback).
 * @param {AsyncFunction} fn - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `fn` has stopped. `callback`
 * will be passed an error, if one occurred, otherwise `null`.
 * @example
 *
 * var count = 0;
 *
 * async.during(
 *     function (callback) {
 *         return callback(null, count < 5);
 *     },
 *     function (callback) {
 *         count++;
 *         setTimeout(callback, 1000);
 *     },
 *     function (err) {
 *         // 5 seconds have passed
 *     }
 * );
 */
function during(test, fn, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);

    function next(err) {
        if (err) return callback(err);
        _test(check);
    }

    function check(err, truth) {
        if (err) return callback(err);
        if (!truth) return callback(null);
        _fn(next);
    }

    _test(check);
}

function _withoutIndex(iteratee) {
    return function (value, index, callback) {
        return iteratee(value, callback);
    };
}

/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * // assuming openFiles is an array of file names and saveFile is a function
 * // to save the modified contents of that file:
 *
 * async.each(openFiles, saveFile, function(err){
 *   // if any of the saves produced an error, err would equal that error
 * });
 *
 * // assuming openFiles is an array of file names
 * async.each(openFiles, function(file, callback) {
 *
 *     // Perform operation on file here.
 *     console.log('Processing file ' + file);
 *
 *     if( file.length > 32 ) {
 *       console.log('This file name is too long');
 *       callback('File name too long');
 *     } else {
 *       // Do work to process file here
 *       console.log('File processed');
 *       callback();
 *     }
 * }, function(err) {
 *     // if any of the file processing produced an error, err would equal that error
 *     if( err ) {
 *       // One of the iterations produced an error.
 *       // All processing will now stop.
 *       console.log('A file failed to process');
 *     } else {
 *       console.log('All files have been processed successfully');
 *     }
 * });
 */
function eachLimit(coll, iteratee, callback) {
    eachOf(coll, _withoutIndex(wrapAsync(iteratee)), callback);
}

/**
 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
 *
 * @name eachLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfLimit`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
function eachLimit$1(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
}

/**
 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
 *
 * @name eachSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfSeries`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
var eachSeries = doLimit(eachLimit$1, 1);

/**
 * Wrap an async function and ensure it calls its callback on a later tick of
 * the event loop.  If the function already calls its callback on a next tick,
 * no extra deferral is added. This is useful for preventing stack overflows
 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
 * contained. ES2017 `async` functions are returned as-is -- they are immune
 * to Zalgo's corrupting influences, as they always resolve on a later tick.
 *
 * @name ensureAsync
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - an async function, one that expects a node-style
 * callback as its last argument.
 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
 * signature as the function passed in.
 * @example
 *
 * function sometimesAsync(arg, callback) {
 *     if (cache[arg]) {
 *         return callback(null, cache[arg]); // this would be synchronous!!
 *     } else {
 *         doSomeIO(arg, callback); // this IO would be asynchronous
 *     }
 * }
 *
 * // this has a risk of stack overflows if many results are cached in a row
 * async.mapSeries(args, sometimesAsync, done);
 *
 * // this will defer sometimesAsync's callback if necessary,
 * // preventing stack overflows
 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
 */
function ensureAsync(fn) {
    if (isAsync(fn)) return fn;
    return initialParams(function (args, callback) {
        var sync = true;
        args.push(function () {
            var innerArgs = arguments;
            if (sync) {
                setImmediate$1(function () {
                    callback.apply(null, innerArgs);
                });
            } else {
                callback.apply(null, innerArgs);
            }
        });
        fn.apply(this, args);
        sync = false;
    });
}

function notId(v) {
    return !v;
}

/**
 * Returns `true` if every element in `coll` satisfies an async test. If any
 * iteratee call returns `false`, the main `callback` is immediately called.
 *
 * @name every
 * @static
 * @memberOf module:Collections
 * @method
 * @alias all
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @example
 *
 * async.every(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // if result is true then every file exists
 * });
 */
var every = doParallel(_createTester(notId, notId));

/**
 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
 *
 * @name everyLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 */
var everyLimit = doParallelLimit(_createTester(notId, notId));

/**
 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
 *
 * @name everySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in series.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 */
var everySeries = doLimit(everyLimit, 1);

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

function filterArray(eachfn, arr, iteratee, callback) {
    var truthValues = new Array(arr.length);
    eachfn(arr, function (x, index, callback) {
        iteratee(x, function (err, v) {
            truthValues[index] = !!v;
            callback(err);
        });
    }, function (err) {
        if (err) return callback(err);
        var results = [];
        for (var i = 0; i < arr.length; i++) {
            if (truthValues[i]) results.push(arr[i]);
        }
        callback(null, results);
    });
}

function filterGeneric(eachfn, coll, iteratee, callback) {
    var results = [];
    eachfn(coll, function (x, index, callback) {
        iteratee(x, function (err, v) {
            if (err) {
                callback(err);
            } else {
                if (v) {
                    results.push({index: index, value: x});
                }
                callback();
            }
        });
    }, function (err) {
        if (err) {
            callback(err);
        } else {
            callback(null, arrayMap(results.sort(function (a, b) {
                return a.index - b.index;
            }), baseProperty('value')));
        }
    });
}

function _filter(eachfn, coll, iteratee, callback) {
    var filter = isArrayLike(coll) ? filterArray : filterGeneric;
    filter(eachfn, coll, wrapAsync(iteratee), callback || noop);
}

/**
 * Returns a new array of all the values in `coll` which pass an async truth
 * test. This operation is performed in parallel, but the results array will be
 * in the same order as the original.
 *
 * @name filter
 * @static
 * @memberOf module:Collections
 * @method
 * @alias select
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @example
 *
 * async.filter(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, results) {
 *     // results now equals an array of the existing files
 * });
 */
var filter = doParallel(_filter);

/**
 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name filterLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var filterLimit = doParallelLimit(_filter);

/**
 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
 *
 * @name filterSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results)
 */
var filterSeries = doLimit(filterLimit, 1);

/**
 * Calls the asynchronous function `fn` with a callback parameter that allows it
 * to call itself again, in series, indefinitely.

 * If an error is passed to the callback then `errback` is called with the
 * error, and execution stops, otherwise it will never be called.
 *
 * @name forever
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} fn - an async function to call repeatedly.
 * Invoked with (next).
 * @param {Function} [errback] - when `fn` passes an error to it's callback,
 * this function will be called, and execution stops. Invoked with (err).
 * @example
 *
 * async.forever(
 *     function(next) {
 *         // next is suitable for passing to things that need a callback(err [, whatever]);
 *         // it will result in this function being called again.
 *     },
 *     function(err) {
 *         // if next is called with a value in its first parameter, it will appear
 *         // in here as 'err', and execution will stop.
 *     }
 * );
 */
function forever(fn, errback) {
    var done = onlyOnce(errback || noop);
    var task = wrapAsync(ensureAsync(fn));

    function next(err) {
        if (err) return done(err);
        task(next);
    }
    next();
}

/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
 *
 * @name groupByLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 */
var groupByLimit = function(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function(val, callback) {
        _iteratee(val, function(err, key) {
            if (err) return callback(err);
            return callback(null, {key: key, val: val});
        });
    }, function(err, mapResults) {
        var result = {};
        // from MDN, handle object having an `hasOwnProperty` prop
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        for (var i = 0; i < mapResults.length; i++) {
            if (mapResults[i]) {
                var key = mapResults[i].key;
                var val = mapResults[i].val;

                if (hasOwnProperty.call(result, key)) {
                    result[key].push(val);
                } else {
                    result[key] = [val];
                }
            }
        }

        return callback(err, result);
    });
};

/**
 * Returns a new object, where each value corresponds to an array of items, from
 * `coll`, that returned the corresponding key. That is, the keys of the object
 * correspond to the values passed to the `iteratee` callback.
 *
 * Note: Since this function applies the `iteratee` to each item in parallel,
 * there is no guarantee that the `iteratee` functions will complete in order.
 * However, the values for each key in the `result` will be in the same order as
 * the original `coll`. For Objects, the values will roughly be in the order of
 * the original Objects' keys (but this can vary across JavaScript engines).
 *
 * @name groupBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @example
 *
 * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
 *     db.findById(userId, function(err, user) {
 *         if (err) return callback(err);
 *         return callback(null, user.age);
 *     });
 * }, function(err, result) {
 *     // result is object containing the userIds grouped by age
 *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
 * });
 */
var groupBy = doLimit(groupByLimit, Infinity);

/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
 *
 * @name groupBySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 */
var groupBySeries = doLimit(groupByLimit, 1);

/**
 * Logs the result of an `async` function to the `console`. Only works in
 * Node.js or in browsers that support `console.log` and `console.error` (such
 * as FF and Chrome). If multiple arguments are returned from the async
 * function, `console.log` is called on each argument in order.
 *
 * @name log
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, 'hello ' + name);
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.log(hello, 'world');
 * 'hello world'
 */
var log = consoleFunc('log');

/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name mapValuesLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 */
function mapValuesLimit(obj, limit, iteratee, callback) {
    callback = once(callback || noop);
    var newObj = {};
    var _iteratee = wrapAsync(iteratee);
    eachOfLimit(obj, limit, function(val, key, next) {
        _iteratee(val, key, function (err, result) {
            if (err) return next(err);
            newObj[key] = result;
            next();
        });
    }, function (err) {
        callback(err, newObj);
    });
}

/**
 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
 *
 * Produces a new Object by mapping each value of `obj` through the `iteratee`
 * function. The `iteratee` is called each `value` and `key` from `obj` and a
 * callback for when it has finished processing. Each of these callbacks takes
 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
 * passes an error to its callback, the main `callback` (for the `mapValues`
 * function) is immediately called with the error.
 *
 * Note, the order of the keys in the result is not guaranteed.  The keys will
 * be roughly in the order they complete, (but this is very engine-specific)
 *
 * @name mapValues
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @example
 *
 * async.mapValues({
 *     f1: 'file1',
 *     f2: 'file2',
 *     f3: 'file3'
 * }, function (file, key, callback) {
 *   fs.stat(file, callback);
 * }, function(err, result) {
 *     // result is now a map of stats for each file, e.g.
 *     // {
 *     //     f1: [stats for file1],
 *     //     f2: [stats for file2],
 *     //     f3: [stats for file3]
 *     // }
 * });
 */

var mapValues = doLimit(mapValuesLimit, Infinity);

/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
 *
 * @name mapValuesSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 */
var mapValuesSeries = doLimit(mapValuesLimit, 1);

function has(obj, key) {
    return key in obj;
}

/**
 * Caches the results of an async function. When creating a hash to store
 * function results against, the callback is omitted from the hash and an
 * optional hash function can be used.
 *
 * If no hash function is specified, the first argument is used as a hash key,
 * which may work reasonably if it is a string or a data type that converts to a
 * distinct string. Note that objects and arrays will not behave reasonably.
 * Neither will cases where the other arguments are significant. In such cases,
 * specify your own hash function.
 *
 * The cache of results is exposed as the `memo` property of the function
 * returned by `memoize`.
 *
 * @name memoize
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
 * @param {Function} hasher - An optional function for generating a custom hash
 * for storing results. It has all the arguments applied to it apart from the
 * callback, and must be synchronous.
 * @returns {AsyncFunction} a memoized version of `fn`
 * @example
 *
 * var slow_fn = function(name, callback) {
 *     // do something
 *     callback(null, result);
 * };
 * var fn = async.memoize(slow_fn);
 *
 * // fn can now be used as if it were slow_fn
 * fn('some name', function() {
 *     // callback
 * });
 */
function memoize(fn, hasher) {
    var memo = Object.create(null);
    var queues = Object.create(null);
    hasher = hasher || identity;
    var _fn = wrapAsync(fn);
    var memoized = initialParams(function memoized(args, callback) {
        var key = hasher.apply(null, args);
        if (has(memo, key)) {
            setImmediate$1(function() {
                callback.apply(null, memo[key]);
            });
        } else if (has(queues, key)) {
            queues[key].push(callback);
        } else {
            queues[key] = [callback];
            _fn.apply(null, args.concat(function(/*args*/) {
                var args = slice(arguments);
                memo[key] = args;
                var q = queues[key];
                delete queues[key];
                for (var i = 0, l = q.length; i < l; i++) {
                    q[i].apply(null, args);
                }
            }));
        }
    });
    memoized.memo = memo;
    memoized.unmemoized = fn;
    return memoized;
}

/**
 * Calls `callback` on a later loop around the event loop. In Node.js this just
 * calls `process.nextTick`.  In the browser it will use `setImmediate` if
 * available, otherwise `setTimeout(callback, 0)`, which means other higher
 * priority events may precede the execution of `callback`.
 *
 * This is used internally for browser-compatibility purposes.
 *
 * @name nextTick
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.setImmediate]{@link module:Utils.setImmediate}
 * @category Util
 * @param {Function} callback - The function to call on a later loop around
 * the event loop. Invoked with (args...).
 * @param {...*} args... - any number of additional arguments to pass to the
 * callback on the next tick.
 * @example
 *
 * var call_order = [];
 * async.nextTick(function() {
 *     call_order.push('two');
 *     // call_order now equals ['one','two']
 * });
 * call_order.push('one');
 *
 * async.setImmediate(function (a, b, c) {
 *     // a, b, and c equal 1, 2, and 3
 * }, 1, 2, 3);
 */
var _defer$1;

if (hasNextTick) {
    _defer$1 = process.nextTick;
} else if (hasSetImmediate) {
    _defer$1 = setImmediate;
} else {
    _defer$1 = fallback;
}

var nextTick = wrap(_defer$1);

function _parallel(eachfn, tasks, callback) {
    callback = callback || noop;
    var results = isArrayLike(tasks) ? [] : {};

    eachfn(tasks, function (task, key, callback) {
        wrapAsync(task)(function (err, result) {
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            }
            results[key] = result;
            callback(err);
        });
    }, function (err) {
        callback(err, results);
    });
}

/**
 * Run the `tasks` collection of functions in parallel, without waiting until
 * the previous function has completed. If any of the functions pass an error to
 * its callback, the main `callback` is immediately called with the value of the
 * error. Once the `tasks` have completed, the results are passed to the final
 * `callback` as an array.
 *
 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
 * parallel execution of code.  If your tasks do not use any timers or perform
 * any I/O, they will actually be executed in series.  Any synchronous setup
 * sections for each task will happen one after the other.  JavaScript remains
 * single-threaded.
 *
 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
 * execution of other tasks when a task fails.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 * results from {@link async.parallel}.
 *
 * @name parallel
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 *
 * @example
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // the results array will equal ['one','two'] even though
 *     // the second function had a shorter timeout.
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equals to: {one: 1, two: 2}
 * });
 */
function parallelLimit(tasks, callback) {
    _parallel(eachOf, tasks, callback);
}

/**
 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name parallelLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.parallel]{@link module:ControlFlow.parallel}
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 */
function parallelLimit$1(tasks, limit, callback) {
    _parallel(_eachOfLimit(limit), tasks, callback);
}

/**
 * A queue of tasks for the worker function to complete.
 * @typedef {Object} QueueObject
 * @memberOf module:ControlFlow
 * @property {Function} length - a function returning the number of items
 * waiting to be processed. Invoke with `queue.length()`.
 * @property {boolean} started - a boolean indicating whether or not any
 * items have been pushed and processed by the queue.
 * @property {Function} running - a function returning the number of items
 * currently being processed. Invoke with `queue.running()`.
 * @property {Function} workersList - a function returning the array of items
 * currently being processed. Invoke with `queue.workersList()`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
 * @property {number} concurrency - an integer for determining how many `worker`
 * functions should be run in parallel. This property can be changed after a
 * `queue` is created to alter the concurrency on-the-fly.
 * @property {Function} push - add a new task to the `queue`. Calls `callback`
 * once the `worker` has finished processing the task. Instead of a single task,
 * a `tasks` array can be submitted. The respective callback is used for every
 * task in the list. Invoke with `queue.push(task, [callback])`,
 * @property {Function} unshift - add a new task to the front of the `queue`.
 * Invoke with `queue.unshift(task, [callback])`.
 * @property {Function} remove - remove items from the queue that match a test
 * function.  The test function will be passed an object with a `data` property,
 * and a `priority` property, if this is a
 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
 * `function ({data, priority}) {}` and returns a Boolean.
 * @property {Function} saturated - a callback that is called when the number of
 * running workers hits the `concurrency` limit, and further tasks will be
 * queued.
 * @property {Function} unsaturated - a callback that is called when the number
 * of running workers is less than the `concurrency` & `buffer` limits, and
 * further tasks will not be queued.
 * @property {number} buffer - A minimum threshold buffer in order to say that
 * the `queue` is `unsaturated`.
 * @property {Function} empty - a callback that is called when the last item
 * from the `queue` is given to a `worker`.
 * @property {Function} drain - a callback that is called when the last item
 * from the `queue` has returned from the `worker`.
 * @property {Function} error - a callback that is called when a task errors.
 * Has the signature `function(error, task)`.
 * @property {boolean} paused - a boolean for determining whether the queue is
 * in a paused state.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke with `queue.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. No more tasks
 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
 */

/**
 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
 * `queue` are processed in parallel (up to the `concurrency` limit). If all
 * `worker`s are in progress, the task is queued until one becomes available.
 * Once a `worker` completes a `task`, that `task`'s callback is called.
 *
 * @name queue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`. Invoked with (task, callback).
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the queue.
 * @example
 *
 * // create a queue object with concurrency 2
 * var q = async.queue(function(task, callback) {
 *     console.log('hello ' + task.name);
 *     callback();
 * }, 2);
 *
 * // assign a callback
 * q.drain = function() {
 *     console.log('all items have been processed');
 * };
 *
 * // add some items to the queue
 * q.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * q.push({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 *
 * // add some items to the queue (batch-wise)
 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
 *     console.log('finished processing item');
 * });
 *
 * // add some items to the front of the queue
 * q.unshift({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 */
var queue$1 = function (worker, concurrency) {
    var _worker = wrapAsync(worker);
    return queue(function (items, cb) {
        _worker(items[0], cb);
    }, concurrency, 1);
};

/**
 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
 * completed in ascending priority order.
 *
 * @name priorityQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`.
 * Invoked with (task, callback).
 * @param {number} concurrency - An `integer` for determining how many `worker`
 * functions should be run in parallel.  If omitted, the concurrency defaults to
 * `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
 * differences between `queue` and `priorityQueue` objects:
 * * `push(task, priority, [callback])` - `priority` should be a number. If an
 *   array of `tasks` is given, all tasks will be assigned the same priority.
 * * The `unshift` method was removed.
 */
var priorityQueue = function(worker, concurrency) {
    // Start with a normal queue
    var q = queue$1(worker, concurrency);

    // Override push to accept second parameter representing priority
    q.push = function(data, priority, callback) {
        if (callback == null) callback = noop;
        if (typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;
        if (!isArray(data)) {
            data = [data];
        }
        if (data.length === 0) {
            // call drain immediately if there are no tasks
            return setImmediate$1(function() {
                q.drain();
            });
        }

        priority = priority || 0;
        var nextNode = q._tasks.head;
        while (nextNode && priority >= nextNode.priority) {
            nextNode = nextNode.next;
        }

        for (var i = 0, l = data.length; i < l; i++) {
            var item = {
                data: data[i],
                priority: priority,
                callback: callback
            };

            if (nextNode) {
                q._tasks.insertBefore(nextNode, item);
            } else {
                q._tasks.push(item);
            }
        }
        setImmediate$1(q.process);
    };

    // Remove unshift function
    delete q.unshift;

    return q;
};

/**
 * Runs the `tasks` array of functions in parallel, without waiting until the
 * previous function has completed. Once any of the `tasks` complete or pass an
 * error to its callback, the main `callback` is immediately called. It's
 * equivalent to `Promise.race()`.
 *
 * @name race
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
 * to run. Each function can complete with an optional `result` value.
 * @param {Function} callback - A callback to run once any of the functions have
 * completed. This function gets an error or result from the first function that
 * completed. Invoked with (err, result).
 * @returns undefined
 * @example
 *
 * async.race([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // main callback
 * function(err, result) {
 *     // the result will be equal to 'two' as it finishes earlier
 * });
 */
function race(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
    if (!tasks.length) return callback();
    for (var i = 0, l = tasks.length; i < l; i++) {
        wrapAsync(tasks[i])(callback);
    }
}

/**
 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
 *
 * @name reduceRight
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reduce]{@link module:Collections.reduce}
 * @alias foldr
 * @category Collection
 * @param {Array} array - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee complete with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 */
function reduceRight (array, memo, iteratee, callback) {
    var reversed = slice(array).reverse();
    reduce(reversed, memo, iteratee, callback);
}

/**
 * Wraps the async function in another function that always completes with a
 * result object, even when it errors.
 *
 * The result object has either the property `error` or `value`.
 *
 * @name reflect
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function you want to wrap
 * @returns {Function} - A function that always passes null to it's callback as
 * the error. The second argument to the callback will be an `object` with
 * either an `error` or a `value` property.
 * @example
 *
 * async.parallel([
 *     async.reflect(function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff but error ...
 *         callback('bad stuff happened');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     })
 * ],
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = 'bad stuff happened'
 *     // results[2].value = 'two'
 * });
 */
function reflect(fn) {
    var _fn = wrapAsync(fn);
    return initialParams(function reflectOn(args, reflectCallback) {
        args.push(function callback(error, cbArg) {
            if (error) {
                reflectCallback(null, { error: error });
            } else {
                var value;
                if (arguments.length <= 2) {
                    value = cbArg;
                } else {
                    value = slice(arguments, 1);
                }
                reflectCallback(null, { value: value });
            }
        });

        return _fn.apply(this, args);
    });
}

/**
 * A helper function that wraps an array or an object of functions with `reflect`.
 *
 * @name reflectAll
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.reflect]{@link module:Utils.reflect}
 * @category Util
 * @param {Array|Object|Iterable} tasks - The collection of
 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
 * @returns {Array} Returns an array of async functions, each wrapped in
 * `async.reflect`
 * @example
 *
 * let tasks = [
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         // do some more stuff but error ...
 *         callback(new Error('bad stuff happened'));
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ];
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = Error('bad stuff happened')
 *     // results[2].value = 'two'
 * });
 *
 * // an example using an object instead of an array
 * let tasks = {
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         callback('two');
 *     },
 *     three: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'three');
 *         }, 100);
 *     }
 * };
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results.one.value = 'one'
 *     // results.two.error = 'two'
 *     // results.three.value = 'three'
 * });
 */
function reflectAll(tasks) {
    var results;
    if (isArray(tasks)) {
        results = arrayMap(tasks, reflect);
    } else {
        results = {};
        baseForOwn(tasks, function(task, key) {
            results[key] = reflect.call(this, task);
        });
    }
    return results;
}

function reject$1(eachfn, arr, iteratee, callback) {
    _filter(eachfn, arr, function(value, cb) {
        iteratee(value, function(err, v) {
            cb(err, !v);
        });
    }, callback);
}

/**
 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
 *
 * @name reject
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @example
 *
 * async.reject(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, results) {
 *     // results now equals an array of missing files
 *     createFiles(results);
 * });
 */
var reject = doParallel(reject$1);

/**
 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name rejectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var rejectLimit = doParallelLimit(reject$1);

/**
 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
 *
 * @name rejectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var rejectSeries = doLimit(rejectLimit, 1);

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function() {
    return value;
  };
}

/**
 * Attempts to get a successful response from `task` no more than `times` times
 * before returning an error. If the task is successful, the `callback` will be
 * passed the result of the successful task. If all attempts fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name retry
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @see [async.retryable]{@link module:ControlFlow.retryable}
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
 * object with `times` and `interval` or a number.
 * * `times` - The number of attempts to make before giving up.  The default
 *   is `5`.
 * * `interval` - The time to wait between retries, in milliseconds.  The
 *   default is `0`. The interval may also be specified as a function of the
 *   retry count (see example).
 * * `errorFilter` - An optional synchronous function that is invoked on
 *   erroneous result. If it returns `true` the retry attempts will continue;
 *   if the function returns `false` the retry flow is aborted with the current
 *   attempt's error and result being returned to the final callback.
 *   Invoked with (err).
 * * If `opts` is a number, the number specifies the number of times to retry,
 *   with the default interval of `0`.
 * @param {AsyncFunction} task - An async function to retry.
 * Invoked with (callback).
 * @param {Function} [callback] - An optional callback which is called when the
 * task has succeeded, or after the final failed attempt. It receives the `err`
 * and `result` arguments of the last attempt at completing the `task`. Invoked
 * with (err, results).
 *
 * @example
 *
 * // The `retry` function can be used as a stand-alone control flow by passing
 * // a callback, as shown below:
 *
 * // try calling apiMethod 3 times
 * async.retry(3, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 3 times, waiting 200 ms between each retry
 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 10 times with exponential backoff
 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
 * async.retry({
 *   times: 10,
 *   interval: function(retryCount) {
 *     return 50 * Math.pow(2, retryCount);
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod the default 5 times no delay between each retry
 * async.retry(apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod only when error condition satisfies, all other
 * // errors will abort the retry control flow and return to final callback
 * async.retry({
 *   errorFilter: function(err) {
 *     return err.message === 'Temporary error'; // only retry on a specific error
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // to retry individual methods that are not as reliable within other
 * // control flow functions, use the `retryable` wrapper:
 * async.auto({
 *     users: api.getUsers.bind(api),
 *     payments: async.retryable(3, api.getPayments.bind(api))
 * }, function(err, results) {
 *     // do something with the results
 * });
 *
 */
function retry(opts, task, callback) {
    var DEFAULT_TIMES = 5;
    var DEFAULT_INTERVAL = 0;

    var options = {
        times: DEFAULT_TIMES,
        intervalFunc: constant$1(DEFAULT_INTERVAL)
    };

    function parseTimes(acc, t) {
        if (typeof t === 'object') {
            acc.times = +t.times || DEFAULT_TIMES;

            acc.intervalFunc = typeof t.interval === 'function' ?
                t.interval :
                constant$1(+t.interval || DEFAULT_INTERVAL);

            acc.errorFilter = t.errorFilter;
        } else if (typeof t === 'number' || typeof t === 'string') {
            acc.times = +t || DEFAULT_TIMES;
        } else {
            throw new Error("Invalid arguments for async.retry");
        }
    }

    if (arguments.length < 3 && typeof opts === 'function') {
        callback = task || noop;
        task = opts;
    } else {
        parseTimes(options, opts);
        callback = callback || noop;
    }

    if (typeof task !== 'function') {
        throw new Error("Invalid arguments for async.retry");
    }

    var _task = wrapAsync(task);

    var attempt = 1;
    function retryAttempt() {
        _task(function(err) {
            if (err && attempt++ < options.times &&
                (typeof options.errorFilter != 'function' ||
                    options.errorFilter(err))) {
                setTimeout(retryAttempt, options.intervalFunc(attempt));
            } else {
                callback.apply(null, arguments);
            }
        });
    }

    retryAttempt();
}

/**
 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
 * wraps a task and makes it retryable, rather than immediately calling it
 * with retries.
 *
 * @name retryable
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.retry]{@link module:ControlFlow.retry}
 * @category Control Flow
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
 * options, exactly the same as from `retry`
 * @param {AsyncFunction} task - the asynchronous function to wrap.
 * This function will be passed any arguments passed to the returned wrapper.
 * Invoked with (...args, callback).
 * @returns {AsyncFunction} The wrapped function, which when invoked, will
 * retry on an error, based on the parameters specified in `opts`.
 * This function will accept the same parameters as `task`.
 * @example
 *
 * async.auto({
 *     dep1: async.retryable(3, getFromFlakyService),
 *     process: ["dep1", async.retryable(3, function (results, cb) {
 *         maybeProcessData(results.dep1, cb);
 *     })]
 * }, callback);
 */
var retryable = function (opts, task) {
    if (!task) {
        task = opts;
        opts = null;
    }
    var _task = wrapAsync(task);
    return initialParams(function (args, callback) {
        function taskFn(cb) {
            _task.apply(null, args.concat(cb));
        }

        if (opts) retry(opts, taskFn, callback);
        else retry(taskFn, callback);

    });
};

/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @example
 * async.series([
 *     function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     },
 *     function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // results is now equal to ['one', 'two']
 * });
 *
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback){
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equal to: {one: 1, two: 2}
 * });
 */
function series(tasks, callback) {
    _parallel(eachOfSeries, tasks, callback);
}

/**
 * Returns `true` if at least one element in the `coll` satisfies an async test.
 * If any iteratee call returns `true`, the main `callback` is immediately
 * called.
 *
 * @name some
 * @static
 * @memberOf module:Collections
 * @method
 * @alias any
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @example
 *
 * async.some(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // if result is true then at least one of the files exists
 * });
 */
var some = doParallel(_createTester(Boolean, identity));

/**
 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
 *
 * @name someLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anyLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 */
var someLimit = doParallelLimit(_createTester(Boolean, identity));

/**
 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
 *
 * @name someSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anySeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in series.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 */
var someSeries = doLimit(someLimit, 1);

/**
 * Sorts a list by the results of running each `coll` value through an async
 * `iteratee`.
 *
 * @name sortBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a value to use as the sort criteria as
 * its `result`.
 * Invoked with (item, callback).
 * @param {Function} callback - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is the items
 * from the original `coll` sorted by the values returned by the `iteratee`
 * calls. Invoked with (err, results).
 * @example
 *
 * async.sortBy(['file1','file2','file3'], function(file, callback) {
 *     fs.stat(file, function(err, stats) {
 *         callback(err, stats.mtime);
 *     });
 * }, function(err, results) {
 *     // results is now the original array of files sorted by
 *     // modified date
 * });
 *
 * // By modifying the callback parameter the
 * // sorting order can be influenced:
 *
 * // ascending order
 * async.sortBy([1,9,3,5], function(x, callback) {
 *     callback(null, x);
 * }, function(err,result) {
 *     // result callback
 * });
 *
 * // descending order
 * async.sortBy([1,9,3,5], function(x, callback) {
 *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
 * }, function(err,result) {
 *     // result callback
 * });
 */
function sortBy (coll, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    map(coll, function (x, callback) {
        _iteratee(x, function (err, criteria) {
            if (err) return callback(err);
            callback(null, {value: x, criteria: criteria});
        });
    }, function (err, results) {
        if (err) return callback(err);
        callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
    });

    function comparator(left, right) {
        var a = left.criteria, b = right.criteria;
        return a < b ? -1 : a > b ? 1 : 0;
    }
}

/**
 * Sets a time limit on an asynchronous function. If the function does not call
 * its callback within the specified milliseconds, it will be called with a
 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
 *
 * @name timeout
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} asyncFn - The async function to limit in time.
 * @param {number} milliseconds - The specified time limit.
 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
 * to timeout Error for more information..
 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
 * of the control flow functions.
 * Invoke this function with the same parameters as you would `asyncFunc`.
 * @example
 *
 * function myFunction(foo, callback) {
 *     doAsyncTask(foo, function(err, data) {
 *         // handle errors
 *         if (err) return callback(err);
 *
 *         // do some stuff ...
 *
 *         // return processed data
 *         return callback(null, data);
 *     });
 * }
 *
 * var wrapped = async.timeout(myFunction, 1000);
 *
 * // call `wrapped` as you would `myFunction`
 * wrapped({ bar: 'bar' }, function(err, data) {
 *     // if `myFunction` takes < 1000 ms to execute, `err`
 *     // and `data` will have their expected values
 *
 *     // else `err` will be an Error with the code 'ETIMEDOUT'
 * });
 */
function timeout(asyncFn, milliseconds, info) {
    var fn = wrapAsync(asyncFn);

    return initialParams(function (args, callback) {
        var timedOut = false;
        var timer;

        function timeoutCallback() {
            var name = asyncFn.name || 'anonymous';
            var error  = new Error('Callback function "' + name + '" timed out.');
            error.code = 'ETIMEDOUT';
            if (info) {
                error.info = info;
            }
            timedOut = true;
            callback(error);
        }

        args.push(function () {
            if (!timedOut) {
                callback.apply(null, arguments);
                clearTimeout(timer);
            }
        });

        // setup timer and call original function
        timer = setTimeout(timeoutCallback, milliseconds);
        fn.apply(null, args);
    });
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;
var nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name timesLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} count - The number of times to run the function.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
 */
function timeLimit(count, limit, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    mapLimit(baseRange(0, count, 1), limit, _iteratee, callback);
}

/**
 * Calls the `iteratee` function `n` times, and accumulates results in the same
 * manner you would use with [map]{@link module:Collections.map}.
 *
 * @name times
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @example
 *
 * // Pretend this is some complicated async factory
 * var createUser = function(id, callback) {
 *     callback(null, {
 *         id: 'user' + id
 *     });
 * };
 *
 * // generate 5 users
 * async.times(5, function(n, next) {
 *     createUser(n, function(err, user) {
 *         next(err, user);
 *     });
 * }, function(err, users) {
 *     // we should now have 5 users
 * });
 */
var times = doLimit(timeLimit, Infinity);

/**
 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
 *
 * @name timesSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 */
var timesSeries = doLimit(timeLimit, 1);

/**
 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
 * element in series, each step potentially mutating an `accumulator` value.
 * The type of the accumulator defaults to the type of collection passed in.
 *
 * @name transform
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
 * it will default to an empty Object or Array, depending on the type of `coll`
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * collection that potentially modifies the accumulator.
 * Invoked with (accumulator, item, key, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the transformed accumulator.
 * Invoked with (err, result).
 * @example
 *
 * async.transform([1,2,3], function(acc, item, index, callback) {
 *     // pointless async:
 *     process.nextTick(function() {
 *         acc.push(item * 2)
 *         callback(null)
 *     });
 * }, function(err, result) {
 *     // result is now equal to [2, 4, 6]
 * });
 *
 * @example
 *
 * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
 *     setImmediate(function () {
 *         obj[key] = val * 2;
 *         callback();
 *     })
 * }, function (err, result) {
 *     // result is equal to {a: 2, b: 4, c: 6}
 * })
 */
function transform (coll, accumulator, iteratee, callback) {
    if (arguments.length <= 3) {
        callback = iteratee;
        iteratee = accumulator;
        accumulator = isArray(coll) ? [] : {};
    }
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);

    eachOf(coll, function(v, k, cb) {
        _iteratee(accumulator, v, k, cb);
    }, function(err) {
        callback(err, accumulator);
    });
}

/**
 * It runs each task in series but stops whenever any of the functions were
 * successful. If one of the tasks were successful, the `callback` will be
 * passed the result of the successful task. If all tasks fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name tryEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection containing functions to
 * run, each function is passed a `callback(err, result)` it must call on
 * completion with an error `err` (which can be `null`) and an optional `result`
 * value.
 * @param {Function} [callback] - An optional callback which is called when one
 * of the tasks has succeeded, or all have failed. It receives the `err` and
 * `result` arguments of the last attempt at completing the `task`. Invoked with
 * (err, results).
 * @example
 * async.tryEach([
 *     function getDataFromFirstWebsite(callback) {
 *         // Try getting the data from the first website
 *         callback(err, data);
 *     },
 *     function getDataFromSecondWebsite(callback) {
 *         // First website failed,
 *         // Try getting the data from the backup website
 *         callback(err, data);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     Now do something with the data.
 * });
 *
 */
function tryEach(tasks, callback) {
    var error = null;
    var result;
    callback = callback || noop;
    eachSeries(tasks, function(task, callback) {
        wrapAsync(task)(function (err, res/*, ...args*/) {
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            } else {
                result = res;
            }
            error = err;
            callback(!err);
        });
    }, function () {
        callback(error, result);
    });
}

/**
 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
 * unmemoized form. Handy for testing.
 *
 * @name unmemoize
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.memoize]{@link module:Utils.memoize}
 * @category Util
 * @param {AsyncFunction} fn - the memoized function
 * @returns {AsyncFunction} a function that calls the original unmemoized function
 */
function unmemoize(fn) {
    return function () {
        return (fn.unmemoized || fn).apply(null, arguments);
    };
}

/**
 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs.
 *
 * @name whilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Function} test - synchronous truth test to perform before each
 * execution of `iteratee`. Invoked with ().
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns undefined
 * @example
 *
 * var count = 0;
 * async.whilst(
 *     function() { return count < 5; },
 *     function(callback) {
 *         count++;
 *         setTimeout(function() {
 *             callback(null, count);
 *         }, 1000);
 *     },
 *     function (err, n) {
 *         // 5 seconds have passed, n = 5
 *     }
 * );
 */
function whilst(test, iteratee, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    if (!test()) return callback(null);
    var next = function(err/*, ...args*/) {
        if (err) return callback(err);
        if (test()) return _iteratee(next);
        var args = slice(arguments, 1);
        callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
}

/**
 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs. `callback` will be passed an error and any
 * arguments passed to the final `iteratee`'s callback.
 *
 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
 *
 * @name until
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {Function} test - synchronous truth test to perform before each
 * execution of `iteratee`. Invoked with ().
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 */
function until(test, iteratee, callback) {
    whilst(function() {
        return !test.apply(this, arguments);
    }, iteratee, callback);
}

/**
 * Runs the `tasks` array of functions in series, each passing their results to
 * the next in the array. However, if any of the `tasks` pass an error to their
 * own callback, the next function is not executed, and the main `callback` is
 * immediately called with the error.
 *
 * @name waterfall
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
 * to run.
 * Each function should complete with any number of `result` values.
 * The `result` values will be passed as arguments, in order, to the next task.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This will be passed the results of the last task's
 * callback. Invoked with (err, [results]).
 * @returns undefined
 * @example
 *
 * async.waterfall([
 *     function(callback) {
 *         callback(null, 'one', 'two');
 *     },
 *     function(arg1, arg2, callback) {
 *         // arg1 now equals 'one' and arg2 now equals 'two'
 *         callback(null, 'three');
 *     },
 *     function(arg1, callback) {
 *         // arg1 now equals 'three'
 *         callback(null, 'done');
 *     }
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 *
 * // Or, with named functions:
 * async.waterfall([
 *     myFirstFunction,
 *     mySecondFunction,
 *     myLastFunction,
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 * function myFirstFunction(callback) {
 *     callback(null, 'one', 'two');
 * }
 * function mySecondFunction(arg1, arg2, callback) {
 *     // arg1 now equals 'one' and arg2 now equals 'two'
 *     callback(null, 'three');
 * }
 * function myLastFunction(arg1, callback) {
 *     // arg1 now equals 'three'
 *     callback(null, 'done');
 * }
 */
var waterfall = function(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return callback();
    var taskIndex = 0;

    function nextTask(args) {
        var task = wrapAsync(tasks[taskIndex++]);
        args.push(onlyOnce(next));
        task.apply(null, args);
    }

    function next(err/*, ...args*/) {
        if (err || taskIndex === tasks.length) {
            return callback.apply(null, arguments);
        }
        nextTask(slice(arguments, 1));
    }

    nextTask([]);
};

/**
 * An "async function" in the context of Async is an asynchronous function with
 * a variable number of parameters, with the final parameter being a callback.
 * (`function (arg1, arg2, ..., callback) {}`)
 * The final callback is of the form `callback(err, results...)`, which must be
 * called once the function is completed.  The callback should be called with a
 * Error as its first argument to signal that an error occurred.
 * Otherwise, if no error occurred, it should be called with `null` as the first
 * argument, and any additional `result` arguments that may apply, to signal
 * successful completion.
 * The callback must be called exactly once, ideally on a later tick of the
 * JavaScript event loop.
 *
 * This type of function is also referred to as a "Node-style async function",
 * or a "continuation passing-style function" (CPS). Most of the methods of this
 * library are themselves CPS/Node-style async functions, or functions that
 * return CPS/Node-style async functions.
 *
 * Wherever we accept a Node-style async function, we also directly accept an
 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
 * In this case, the `async` function will not be passed a final callback
 * argument, and any thrown error will be used as the `err` argument of the
 * implicit callback, and the return value will be used as the `result` value.
 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
 * argument, and a `resolved` value becomes the `result`.)
 *
 * Note, due to JavaScript limitations, we can only detect native `async`
 * functions and not transpilied implementations.
 * Your environment must have `async`/`await` support for this to work.
 * (e.g. Node > v7.6, or a recent version of a modern browser).
 * If you are using `async` functions through a transpiler (e.g. Babel), you
 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
 * because the `async function` will be compiled to an ordinary function that
 * returns a promise.
 *
 * @typedef {Function} AsyncFunction
 * @static
 */

/**
 * Async is a utility module which provides straight-forward, powerful functions
 * for working with asynchronous JavaScript. Although originally designed for
 * use with [Node.js](http://nodejs.org) and installable via
 * `npm install --save async`, it can also be used directly in the browser.
 * @module async
 * @see AsyncFunction
 */


/**
 * A collection of `async` functions for manipulating collections, such as
 * arrays and objects.
 * @module Collections
 */

/**
 * A collection of `async` functions for controlling the flow through a script.
 * @module ControlFlow
 */

/**
 * A collection of `async` utility functions.
 * @module Utils
 */

var index = {
    apply: apply,
    applyEach: applyEach,
    applyEachSeries: applyEachSeries,
    asyncify: asyncify,
    auto: auto,
    autoInject: autoInject,
    cargo: cargo,
    compose: compose,
    concat: concat,
    concatLimit: concatLimit,
    concatSeries: concatSeries,
    constant: constant,
    detect: detect,
    detectLimit: detectLimit,
    detectSeries: detectSeries,
    dir: dir,
    doDuring: doDuring,
    doUntil: doUntil,
    doWhilst: doWhilst,
    during: during,
    each: eachLimit,
    eachLimit: eachLimit$1,
    eachOf: eachOf,
    eachOfLimit: eachOfLimit,
    eachOfSeries: eachOfSeries,
    eachSeries: eachSeries,
    ensureAsync: ensureAsync,
    every: every,
    everyLimit: everyLimit,
    everySeries: everySeries,
    filter: filter,
    filterLimit: filterLimit,
    filterSeries: filterSeries,
    forever: forever,
    groupBy: groupBy,
    groupByLimit: groupByLimit,
    groupBySeries: groupBySeries,
    log: log,
    map: map,
    mapLimit: mapLimit,
    mapSeries: mapSeries,
    mapValues: mapValues,
    mapValuesLimit: mapValuesLimit,
    mapValuesSeries: mapValuesSeries,
    memoize: memoize,
    nextTick: nextTick,
    parallel: parallelLimit,
    parallelLimit: parallelLimit$1,
    priorityQueue: priorityQueue,
    queue: queue$1,
    race: race,
    reduce: reduce,
    reduceRight: reduceRight,
    reflect: reflect,
    reflectAll: reflectAll,
    reject: reject,
    rejectLimit: rejectLimit,
    rejectSeries: rejectSeries,
    retry: retry,
    retryable: retryable,
    seq: seq,
    series: series,
    setImmediate: setImmediate$1,
    some: some,
    someLimit: someLimit,
    someSeries: someSeries,
    sortBy: sortBy,
    timeout: timeout,
    times: times,
    timesLimit: timeLimit,
    timesSeries: timesSeries,
    transform: transform,
    tryEach: tryEach,
    unmemoize: unmemoize,
    until: until,
    waterfall: waterfall,
    whilst: whilst,

    // aliases
    all: every,
    allLimit: everyLimit,
    allSeries: everySeries,
    any: some,
    anyLimit: someLimit,
    anySeries: someSeries,
    find: detect,
    findLimit: detectLimit,
    findSeries: detectSeries,
    forEach: eachLimit,
    forEachSeries: eachSeries,
    forEachLimit: eachLimit$1,
    forEachOf: eachOf,
    forEachOfSeries: eachOfSeries,
    forEachOfLimit: eachOfLimit,
    inject: reduce,
    foldl: reduce,
    foldr: reduceRight,
    select: filter,
    selectLimit: filterLimit,
    selectSeries: filterSeries,
    wrapSync: asyncify
};

exports['default'] = index;
exports.apply = apply;
exports.applyEach = applyEach;
exports.applyEachSeries = applyEachSeries;
exports.asyncify = asyncify;
exports.auto = auto;
exports.autoInject = autoInject;
exports.cargo = cargo;
exports.compose = compose;
exports.concat = concat;
exports.concatLimit = concatLimit;
exports.concatSeries = concatSeries;
exports.constant = constant;
exports.detect = detect;
exports.detectLimit = detectLimit;
exports.detectSeries = detectSeries;
exports.dir = dir;
exports.doDuring = doDuring;
exports.doUntil = doUntil;
exports.doWhilst = doWhilst;
exports.during = during;
exports.each = eachLimit;
exports.eachLimit = eachLimit$1;
exports.eachOf = eachOf;
exports.eachOfLimit = eachOfLimit;
exports.eachOfSeries = eachOfSeries;
exports.eachSeries = eachSeries;
exports.ensureAsync = ensureAsync;
exports.every = every;
exports.everyLimit = everyLimit;
exports.everySeries = everySeries;
exports.filter = filter;
exports.filterLimit = filterLimit;
exports.filterSeries = filterSeries;
exports.forever = forever;
exports.groupBy = groupBy;
exports.groupByLimit = groupByLimit;
exports.groupBySeries = groupBySeries;
exports.log = log;
exports.map = map;
exports.mapLimit = mapLimit;
exports.mapSeries = mapSeries;
exports.mapValues = mapValues;
exports.mapValuesLimit = mapValuesLimit;
exports.mapValuesSeries = mapValuesSeries;
exports.memoize = memoize;
exports.nextTick = nextTick;
exports.parallel = parallelLimit;
exports.parallelLimit = parallelLimit$1;
exports.priorityQueue = priorityQueue;
exports.queue = queue$1;
exports.race = race;
exports.reduce = reduce;
exports.reduceRight = reduceRight;
exports.reflect = reflect;
exports.reflectAll = reflectAll;
exports.reject = reject;
exports.rejectLimit = rejectLimit;
exports.rejectSeries = rejectSeries;
exports.retry = retry;
exports.retryable = retryable;
exports.seq = seq;
exports.series = series;
exports.setImmediate = setImmediate$1;
exports.some = some;
exports.someLimit = someLimit;
exports.someSeries = someSeries;
exports.sortBy = sortBy;
exports.timeout = timeout;
exports.times = times;
exports.timesLimit = timeLimit;
exports.timesSeries = timesSeries;
exports.transform = transform;
exports.tryEach = tryEach;
exports.unmemoize = unmemoize;
exports.until = until;
exports.waterfall = waterfall;
exports.whilst = whilst;
exports.all = every;
exports.allLimit = everyLimit;
exports.allSeries = everySeries;
exports.any = some;
exports.anyLimit = someLimit;
exports.anySeries = someSeries;
exports.find = detect;
exports.findLimit = detectLimit;
exports.findSeries = detectSeries;
exports.forEach = eachLimit;
exports.forEachSeries = eachSeries;
exports.forEachLimit = eachLimit$1;
exports.forEachOf = eachOf;
exports.forEachOfSeries = eachOfSeries;
exports.forEachOfLimit = eachOfLimit;
exports.inject = reduce;
exports.foldl = reduce;
exports.foldr = reduceRight;
exports.select = filter;
exports.selectLimit = filterLimit;
exports.selectSeries = filterSeries;
exports.wrapSync = asyncify;

Object.defineProperty(exports, '__esModule', { value: true });

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(308).setImmediate, __webpack_require__(217), __webpack_require__(33), __webpack_require__(48)(module)))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(309);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(217)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof global !== 'undefined') { return global; }
	throw new Error('unable to locate global object');
}

var global = getGlobal();

module.exports = exports = global.fetch;

// Needed for TypeScript and Webpack.
exports.default = global.fetch.bind(global);

exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(0);
var $ = __webpack_require__(312);

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hstri = factory());
}(this, (function () { 'use strict';

var queryMichelangelo = function (opts, ajax) {
    var data = buildQuery({
        timeFrame: opts.timeFrame,
        start: opts.start,
        end: opts.end,
        series: opts.instrument,
        frequency: opts.frequency,
        entitlementToken: opts.entitlementToken,
        volume: opts.volume
    });
    var promise = sendQuery(data, ajax).fail(function (err) {
        if (err.responseJSON && err.responseJSON.Message) {
            throw 'Message from API: ' + err.responseJSON.Message;
        }
        throw err.statusText;
    });

    if (opts.raw !== true) {
        promise = promise.then(extractValues).then(combineValues).then(extractMetadata).fail(function (err) {
            console.error(err);
            throw 'Error parsing data';
        });

        // .then(fillBlanks);
    }

    if (opts.callback) {
        promise.done(opts.callback);
    }

    return promise;
};

function extractValues(data) {
    return data.Series.map(function (d, i) {
        return {
            points: d.DataPoints.map(function (p, j) {
                var points = {};
                d.DesiredDataPoints.forEach(function (dataPointType, k) {
                    points[dataPointType] = p[k];
                });
                return points;
            }),
            ticks: data.TimeInfo.Ticks,
            raw: data
        };
    });
}

function combineValues(data) {
    return data.map(function (d, i) {
        var combined = d.points.map(function (p, j) {
            p.date = d.ticks[j];
            return p;
        });
        d.data = combined.map(function (p) {
            return [p.date, p.Last ? p.Last : p.Volume];
        });
        d.fullData = combined;
        return d;
    });
}

function extractMetadata(data) {
    return data.map(function (d, i) {
        var raw = d.raw.Series[i];
        d.ticker = raw.Ticker;
        d.name = raw.CommonName;
        return d;
    });
}

/*
opts:
- start (date)
- end (date)
- series (array of instrument keys)
*/
function buildQuery(opts) {
    var series = opts.series.map(function (symbol) {
        var props = {
            "Key": symbol,
            "Dialect": "Charting",
            "Kind": "Ticker",
            "SeriesId": "s1",
            "DataTypes": ["Open", "High", "Low", "Last", "PercentChange"]
        };
        if (opts.volume) {
            props["Indicators"] = [{ "Parameters": [], "Kind": "Volume", "SeriesId": "i2" }];
        }
        return props;
    });
    return {
        "Series": series,
        "StartDate": opts.start ? opts.start.valueOf() : null,
        "EndDate": opts.end ? opts.end.valueOf() : null,
        "Step": opts.frequency,
        // "TimeFrame":"D1",
        "EntitlementToken": opts.entitlementToken,
        "IncludeMockTick": true,
        "FilterNullSlots": true,
        "FilterClosedPoints": true,
        "IncludeClosedSlots": false,
        "IncludeOfficialClose": true,
        "InjectOpen": false,
        "ShowPreMarket": false,
        "ShowAfterHours": false,
        "UseExtendedTimeFrame": true,
        "WantPriorClose": true,
        "IncludeCurrentQuotes": true,
        "ResetTodaysAfterHoursPercentChange": false,
        "TimeFrame": opts.timeFrame
    };
}

function sendQuery(data, ajax) {
    var request = ajax({
        url: "https://api.wsj.net/api/michelangelo/timeseries/history?ckey=" + data.EntitlementToken.slice(0, 10),
        type: "POST",
        dataType: "json",
        data: JSON.stringify(data),
        beforeSend: function beforeSend(request) {
            request.setRequestHeader("Dylan2010.EntitlementToken", data.EntitlementToken);
            request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
        }
    });
    return request;
}

var queryDylan = function (opts, ajax) {

    var query = buildQuery(opts);
    var url = 'https://api.wsj.net/api/dylan/dataseries/v2/pricing?id=' + query + '&ckey=57494d5ed7&Dylan2010.EntitlementToken=57494d5ed7ad44af85bc59a51dd87c90&json=true';

    var promise = ajax({
        url: url,
        type: "GET",
        crossDomain: true,
        headers: {
            "Accept": "application/json",
            "Dylan2010.EntitlementToken": '57494d5ed7ad44af85bc59a51dd87c90'
        },
        dataType: 'json'
    }).fail(function (err) {
        console.error(err);
        if (typeof $ !== 'undefined') {
            var message = $(err.responseText).find('p:eq(1)').text().split("'")[1];
            throw 'Message from API: ' + message;
        } else {
            throw err.responseText;
        }
    });

    if (opts.raw !== true) {
        promise = promise.then(extractValues).then(processValues).then(extractMetadata$1).fail(function (err) {
            console.error(err);
            throw 'Problem parsing data';
        });
    }

    if (opts.callback) {
        promise.done(opts.callback);
    }

    return promise;

    function extractValues(d) {
        var metadata = d.GetDataSeriesResponse.DataSeriesResponses[0].SeriesMatches[0];
        var values = metadata.DataPoints;
        if (values.length === 0) {
            throw 'Live data is empty.';
        }
        return { metadata: metadata, values: values };
    }

    function processValues(_ref) {
        var metadata = _ref.metadata,
            values = _ref.values;

        var processed = values.map(function (d, i) {
            var date = Date.parse(d.Trading.Last.Time);
            var value = d.Trading.Last.Price.Value;
            return [date, value];
        });
        return [{
            raw: metadata,
            data: processed
        }];
    }

    function buildQuery(opts) {
        /*
        Instruments --> comma separated list of instruments to request formated as follows 
        Ticker|CountryCode|ExchangeIsoCode|InstrumentType
        
        Needed --> pipe separated list of what you want returned possibilities
        AfterHoursTrading, BeforeHourseTrading, Financials, FinancialStatusIndicator, Offers, Trading, TradingStatistics, RealtimeTrading, RealtimeBeforeHoursTrading, RealTimeAfterHoursTrading, CompositeTrading, CompositeBeforeHoursTrading, CompositeAfterHoursTrading, IndustryClassification, BluegrassChannels, TimeZoneInfo, BondSpecific, CurrencySpecific)
        */

        var query = '';

        query += opts.instrument[0] + '|'; // Ticker|CountryCode|ExchangeIsoCode|InstrumentType
        query += opts.start.format('YYYY-MM-DD[T]HH:mm:ss') + '|';
        query += opts.end.format('YYYY-MM-DD[T]HH:mm:ss') + '|';
        query += opts.frequency + '||True';

        return query;

        // EURUSD|US||Currency|'+range[0]+ '|' +range[1] + '|PT1M||True
    }
};

function extractMetadata$1(data) {
    var raw = data[0].raw.Instrument;
    data[0].name = raw.CommonName;
    data[0].ticker = raw.Ticker;
    return data;
}

var fillBlanksWith = function (_ref, moment) {
    var frequency = _ref.frequency,
        fillBlanksWithPrevious = _ref.fillBlanksWithPrevious,
        start = _ref.start,
        end = _ref.end;

    return function (arr) {
        var precisions = {
            P1D: 'day',
            P1Y: 'year',
            P1W: 'week',
            PT1M: 'minute',
            PT1H: 'hour'
        };
        var intervals = {};
        Object.keys(precisions).forEach(function (k) {
            intervals[k] = moment() - moment().subtract(1, precisions[k]);
        });
        var interval = intervals[frequency];

        arr.forEach(function (instr) {

            var data = JSON.parse(JSON.stringify(instr.data));
            var lengthOfTime = end - start;
            var expectedNumberOfTicks = lengthOfTime / interval;
            var expectedTicks = [];
            for (var i = 0; i < expectedNumberOfTicks; i++) {
                expectedTicks.push([start + interval * i, null]);
            }

            var fullTicks = [].concat(data, expectedTicks);
            fullTicks.sort(function (a, b) {
                return a[0] - b[0];
            });
            fullTicks.forEach(function (d) {
                d[0] = moment.utc(d[0]).startOf(precisions[frequency]).valueOf();
            });
            var uniqueTicks = fullTicks.reduce(function (accum, curr, i) {
                var existingIndex = -1;
                var existing = accum.filter(function (d, i) {
                    if (d[0] === curr[0]) {
                        existingIndex = i;
                    }
                    return d[0] === curr[0];
                });
                if (existing.length === 0) {
                    accum.push([curr[0], curr[1]]);
                } else if (existingIndex > -1 && existing[0][1] === null) {
                    accum[existingIndex] = curr;
                }
                return accum;
            }, []);

            var fillWithPreviousValue = createFillerBackTo(instr.ticks[instr.ticks.length - 1]);
            if (fillBlanksWithPrevious) {
                uniqueTicks = uniqueTicks.map(fillWithPreviousValue);
            }

            instr.data = uniqueTicks;
            instr.ticks = uniqueTicks.map(function (d) {
                return d[0];
            });
            instr.points = uniqueTicks.map(function (d) {
                return d[1];
            });
        });

        return arr;
    };

    function createFillerBackTo(d) {
        var date = moment(d);
        return function (d, i, arr) {
            var notFirst = i > 0;
            var isNull = d[1] === null;
            var inPast = moment.utc(d[0]).isBefore(date);
            if (notFirst && isNull && inPast) {
                d[1] = arr[i - 1][1];
            }
            return d;
        };
    }
};

var hstri$2 = function hstri$2(opts, deps) {

    opts = processOpts(opts, deps.moment);

    var promise = void 0;

    if (opts.service === 'dylan') {
        promise = queryDylan(opts, deps.ajax);
    } else {
        promise = queryMichelangelo(opts, deps.ajax);
    }

    if (opts.fillBlanks || opts.fillBlanksWithPrevious) {
        var fillBlanks = fillBlanksWith(opts, deps.moment);
        promise = promise.then(fillBlanks);
    }

    if (opts.raw !== true) {
        promise = promise.then(addSource(opts));
    }

    return promise;
};

function validateFrequency(frequency) {
    // regex from moment.js
    // https://github.com/moment/moment/blob/develop/src/lib/duration/create.js#L14
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
    var match = frequency.match(isoRegex);
    if (match === null || !frequency) {
        throw '"' + frequency + '" option is not valid. Here are some example time codes:\
P1D  | daily\
P1Y  | yearly\
P1W  | weekly\
PT1M | every minute\
PT1H | every hour\
';
    }
}

function processOpts(opts, moment) {
    var checkDate = createDateChecker(moment);
    var roundToNearestMinute = createMinuteRounder(moment);

    if (!opts.instrument) {
        throw 'No symbol specified';
    }
    if (Array.isArray(opts.instrument) === false) {
        opts.instrument = [opts.instrument];
    }
    if (opts.timeFrame === 'custom' || !opts.timeFrame) {
        if (!opts.start) {
            throw 'Must specify start date or time frame code';
        } else {
            checkDate(opts.start, 'Start date');
        }
        if (opts.end) {
            checkDate(opts.end, 'End date');
        } else {
            opts.end = moment();
        }

        if (opts.start.isSame(opts.end)) {
            if (opts.start.format('HH:mm:ss') === '00:00:00') {
                // if both dates are midnight, assume user wants that full day
                opts.end.endOf('day');
            } else {
                throw 'Start and end dates are exactly the same day and time.';
            }
        }

        opts.start = roundToNearestMinute(opts.start);
        opts.end = roundToNearestMinute(opts.end, true);
        opts.timeFrame = 'custom';
    } else {
        opts.start = '';
        opts.end = '';
    }
    validateFrequency(opts.frequency);

    opts.entitlementToken = opts.entitlementToken || '57494d5ed7ad44af85bc59a51dd87c90';

    return opts;
}

function createDateChecker(moment) {
    return function checkDate(date, name) {
        if (date instanceof moment === false) {
            throw name + ' is not a Moment.js date object. It also needs a timezone explicitly set using the Moment Timezone plugin. Downloads and documentation here: http://momentjs.com/timezone/';
            return false;
        }
        if (date.tz() === undefined) {
            throw name + ' needs a timezone explicitly set using the Moment Timezone plugin. Downloads and documentation here: http://momentjs.com/timezone/';
            return false;
        }
        return true;
    };
}

function createMinuteRounder(moment) {
    return function roundToNearestMinute(date) {
        var roundUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var roundToNearest = 60000; // 1 minutes
        if (roundUp) {
            return moment(Math.ceil(date / roundToNearest) * roundToNearest);
        }
        return moment(Math.floor(date / roundToNearest) * roundToNearest);
    };
}

function addSource(opts) {
    return function (data) {
        data.forEach(function (d) {
            d.source = {
                entitlementToken: opts.entitlementToken
            };
        });
        return data;
    };
}

// NOTE: this.moment is set in the entry script

function log(data) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';

    var fmt = format.toLowerCase();
    var output = '';

    console.log(this);

    if (fmt === 'raw') {
        output = JSON.stringify(data);
    } else if (fmt === 'csv') {
        console.log(arrayToCSV(data.data, this.moment));
    } else {
        output = JSON.stringify(data.data);
    }
    console.log(output);
    return output;
}

function arrayToCSV(data, moment) {
    var newArr = data.map(function (d, i) {
        d[0] = moment.tz(d[0], 'America/New_York').format('DD-MM-YY HH:mm:ss');
        return d.join(",");
    });
    newArr.unshift('date,value');
    return newArr.join("\n");
}

/*
TODO: check moment-timezone and jQuery are present
*/

var hstri = function hstri(opts) {
    return hstri$2(opts, {
        moment: moment,
        ajax: $.ajax
    });
};
hstri.moment = moment;
hstri.log = log;

return hstri;

})));
//# sourceMappingURL=hstri.js.map


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.5.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( _i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px";
				tr.style.height = "1px";
				trChild.style.height = "9px";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = (
					dataPriv.get( cur, "events" ) || Object.create( null )
				)[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script
			if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			if ( typeof props.top === "number" ) {
				props.top += "px";
			}
			if ( typeof props.left === "number" ) {
				props.left += "px";
			}
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v8.1.0 (2020-05-05)

 Annotations module

 (c) 2009-2019 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(c){"object"===typeof module&&module.exports?(c["default"]=c,module.exports=c): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(p){c(p);c.Highcharts=p;return c}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):c("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(c){function p(c,a,m,t){c.hasOwnProperty(a)||(c[a]=t.apply(null,m))}c=c?c._modules:{};p(c,"annotations/eventEmitterMixin.js",[c["parts/Globals.js"],c["parts/Utilities.js"]],function(c,a){var k=a.addEvent,t=a.fireEvent,
f=a.inArray,d=a.objectEach,B=a.pick,r=a.removeEvent;return{addEvents:function(){var b=this,g=function(g){k(g,"mousedown",function(e){b.onMouseDown(e)})};g(this.graphic.element);(b.labels||[]).forEach(function(b){b.options.useHTML&&b.graphic.text&&g(b.graphic.text.element)});d(b.options.events,function(g,e){var h=function(h){"click"===e&&b.cancelClick||g.call(b,b.chart.pointer.normalize(h),b.target)};if(-1===f(e,b.nonDOMEvents||[]))b.graphic.on(e,h);else k(b,e,h)});if(b.options.draggable&&(k(b,"drag",
b.onDrag),!b.graphic.renderer.styledMode)){var a={cursor:{x:"ew-resize",y:"ns-resize",xy:"move"}[b.options.draggable]};b.graphic.css(a);(b.labels||[]).forEach(function(b){b.options.useHTML&&b.graphic.text&&b.graphic.text.css(a)})}b.isUpdating||t(b,"add")},removeDocEvents:function(){this.removeDrag&&(this.removeDrag=this.removeDrag());this.removeMouseUp&&(this.removeMouseUp=this.removeMouseUp())},onMouseDown:function(b){var g=this,d=g.chart.pointer;b.preventDefault&&b.preventDefault();if(2!==b.button){b=
d.normalize(b);var a=b.chartX;var e=b.chartY;g.cancelClick=!1;g.chart.hasDraggedAnnotation=!0;g.removeDrag=k(c.doc,"mousemove",function(b){g.hasDragged=!0;b=d.normalize(b);b.prevChartX=a;b.prevChartY=e;t(g,"drag",b);a=b.chartX;e=b.chartY});g.removeMouseUp=k(c.doc,"mouseup",function(b){g.cancelClick=g.hasDragged;g.hasDragged=!1;g.chart.hasDraggedAnnotation=!1;t(B(g.target,g),"afterUpdate");g.onMouseUp(b)})}},onMouseUp:function(b){var g=this.chart;b=this.target||this;var d=g.options.annotations;g=g.annotations.indexOf(b);
this.removeDocEvents();d[g]=b.options},onDrag:function(b){if(this.chart.isInsidePlot(b.chartX-this.chart.plotLeft,b.chartY-this.chart.plotTop)){var g=this.mouseMoveToTranslation(b);"x"===this.options.draggable&&(g.y=0);"y"===this.options.draggable&&(g.x=0);this.points.length?this.translate(g.x,g.y):(this.shapes.forEach(function(b){b.translate(g.x,g.y)}),this.labels.forEach(function(b){b.translate(g.x,g.y)}));this.redraw(!1)}},mouseMoveToRadians:function(b,g,d){var a=b.prevChartY-d,e=b.prevChartX-
g;d=b.chartY-d;b=b.chartX-g;this.chart.inverted&&(g=e,e=a,a=g,g=b,b=d,d=g);return Math.atan2(d,b)-Math.atan2(a,e)},mouseMoveToTranslation:function(b){var g=b.chartX-b.prevChartX;b=b.chartY-b.prevChartY;if(this.chart.inverted){var d=b;b=g;g=d}return{x:g,y:b}},mouseMoveToScale:function(b,g,d){g=(b.chartX-g||1)/(b.prevChartX-g||1);b=(b.chartY-d||1)/(b.prevChartY-d||1);this.chart.inverted&&(d=b,b=g,g=d);return{x:g,y:b}},destroy:function(){this.removeDocEvents();r(this);this.hcEvents=null}}});p(c,"annotations/ControlPoint.js",
[c["parts/Utilities.js"],c["annotations/eventEmitterMixin.js"]],function(c,a){var k=c.merge,t=c.pick;return function(){function f(d,f,c,b){this.addEvents=a.addEvents;this.graphic=void 0;this.mouseMoveToRadians=a.mouseMoveToRadians;this.mouseMoveToScale=a.mouseMoveToScale;this.mouseMoveToTranslation=a.mouseMoveToTranslation;this.onDrag=a.onDrag;this.onMouseDown=a.onMouseDown;this.onMouseUp=a.onMouseUp;this.removeDocEvents=a.removeDocEvents;this.nonDOMEvents=["drag"];this.chart=d;this.target=f;this.options=
c;this.index=t(c.index,b)}f.prototype.setVisibility=function(d){this.graphic.attr("visibility",d?"visible":"hidden");this.options.visible=d};f.prototype.render=function(){var d=this.chart,a=this.options;this.graphic=d.renderer.symbol(a.symbol,0,0,a.width,a.height).add(d.controlPointsGroup).css(a.style);this.setVisibility(a.visible);this.addEvents()};f.prototype.redraw=function(d){this.graphic[d?"animate":"attr"](this.options.positioner.call(this,this.target))};f.prototype.destroy=function(){a.destroy.call(this);
this.graphic&&(this.graphic=this.graphic.destroy());this.options=this.target=this.chart=null};f.prototype.update=function(d){var a=this.chart,f=this.target,b=this.index;d=k(!0,this.options,d);this.destroy();this.constructor(a,f,d,b);this.render(a.controlPointsGroup);this.redraw()};return f}()});p(c,"annotations/MockPoint.js",[c["parts/Globals.js"],c["parts/Utilities.js"]],function(c,a){var k=a.defined,t=a.fireEvent;return function(){function a(d,a,f){this.y=this.x=this.plotY=this.plotX=this.isInside=
void 0;this.mock=!0;this.series={visible:!0,chart:d,getPlotBox:c.Series.prototype.getPlotBox};this.target=a||null;this.options=f;this.applyOptions(this.getOptions())}a.fromPoint=function(d){return new a(d.series.chart,null,{x:d.x,y:d.y,xAxis:d.series.xAxis,yAxis:d.series.yAxis})};a.pointToPixels=function(d,a){var c=d.series,b=c.chart,g=d.plotX,f=d.plotY;b.inverted&&(d.mock?(g=d.plotY,f=d.plotX):(g=b.plotWidth-d.plotY,f=b.plotHeight-d.plotX));c&&!a&&(d=c.getPlotBox(),g+=d.translateX,f+=d.translateY);
return{x:g,y:f}};a.pointToOptions=function(d){return{x:d.x,y:d.y,xAxis:d.series.xAxis,yAxis:d.series.yAxis}};a.prototype.hasDynamicOptions=function(){return"function"===typeof this.options};a.prototype.getOptions=function(){return this.hasDynamicOptions()?this.options(this.target):this.options};a.prototype.applyOptions=function(d){this.command=d.command;this.setAxis(d,"x");this.setAxis(d,"y");this.refresh()};a.prototype.setAxis=function(d,a){a+="Axis";d=d[a];var f=this.series.chart;this.series[a]=
d instanceof c.Axis?d:k(d)?f[a][d]||f.get(d):null};a.prototype.toAnchor=function(){var a=[this.plotX,this.plotY,0,0];this.series.chart.inverted&&(a[0]=this.plotY,a[1]=this.plotX);return a};a.prototype.getLabelConfig=function(){return{x:this.x,y:this.y,point:this}};a.prototype.isInsidePlot=function(){var a=this.plotX,c=this.plotY,f=this.series.xAxis,b=this.series.yAxis,g={x:a,y:c,isInsidePlot:!0};f&&(g.isInsidePlot=k(a)&&0<=a&&a<=f.len);b&&(g.isInsidePlot=g.isInsidePlot&&k(c)&&0<=c&&c<=b.len);t(this.series.chart,
"afterIsInsidePlot",g);return g.isInsidePlot};a.prototype.refresh=function(){var a=this.series,c=a.xAxis;a=a.yAxis;var f=this.getOptions();c?(this.x=f.x,this.plotX=c.toPixels(f.x,!0)):(this.x=null,this.plotX=f.x);a?(this.y=f.y,this.plotY=a.toPixels(f.y,!0)):(this.y=null,this.plotY=f.y);this.isInside=this.isInsidePlot()};a.prototype.translate=function(a,f,c,b){this.hasDynamicOptions()||(this.plotX+=c,this.plotY+=b,this.refreshOptions())};a.prototype.scale=function(a,c,f,b){if(!this.hasDynamicOptions()){var g=
this.plotY*b;this.plotX=(1-f)*a+this.plotX*f;this.plotY=(1-b)*c+g;this.refreshOptions()}};a.prototype.rotate=function(a,f,c){if(!this.hasDynamicOptions()){var b=Math.cos(c);c=Math.sin(c);var g=this.plotX,d=this.plotY;g-=a;d-=f;this.plotX=g*b-d*c+a;this.plotY=g*c+d*b+f;this.refreshOptions()}};a.prototype.refreshOptions=function(){var a=this.series,c=a.xAxis;a=a.yAxis;this.x=this.options.x=c?this.options.x=c.toValue(this.plotX,!0):this.plotX;this.y=this.options.y=a?a.toValue(this.plotY,!0):this.plotY};
return a}()});p(c,"annotations/controllable/controllableMixin.js",[c["parts/Utilities.js"],c["annotations/ControlPoint.js"],c["annotations/MockPoint.js"],c["parts/Tooltip.js"]],function(c,a,m,t){var f=c.isObject,d=c.isString,k=c.merge,r=c.splat;return{init:function(b,a,c){this.annotation=b;this.chart=b.chart;this.options=a;this.points=[];this.controlPoints=[];this.index=c;this.linkPoints();this.addControlPoints()},attr:function(){this.graphic.attr.apply(this.graphic,arguments)},getPointsOptions:function(){var b=
this.options;return b.points||b.point&&r(b.point)},attrsFromOptions:function(b){var a=this.constructor.attrsMap,c={},d,e=this.chart.styledMode;for(d in b){var h=a[d];!h||e&&-1!==["fill","stroke","stroke-width"].indexOf(h)||(c[h]=b[d])}return c},anchor:function(b){var a=b.series.getPlotBox();b=b.mock?b.toAnchor():t.prototype.getAnchor.call({chart:b.series.chart},b);b={x:b[0]+(this.options.x||0),y:b[1]+(this.options.y||0),height:b[2]||0,width:b[3]||0};return{relativePosition:b,absolutePosition:k(b,
{x:b.x+a.translateX,y:b.y+a.translateY})}},point:function(b,a){if(b&&b.series)return b;a&&null!==a.series||(f(b)?a=new m(this.chart,this,b):d(b)?a=this.chart.get(b)||null:"function"===typeof b&&(a=b.call(a,this),a=a.series?a:new m(this.chart,this,b)));return a},linkPoints:function(){var b=this.getPointsOptions(),a=this.points,c=b&&b.length||0,d;for(d=0;d<c;d++){var e=this.point(b[d],a[d]);if(!e){a.length=0;return}e.mock&&e.refresh();a[d]=e}return a},addControlPoints:function(){var b=this.options.controlPoints;
(b||[]).forEach(function(g,d){g=k(this.options.controlPointOptions,g);g.index||(g.index=d);b[d]=g;this.controlPoints.push(new a(this.chart,this,g))},this)},shouldBeDrawn:function(){return!!this.points.length},render:function(b){this.controlPoints.forEach(function(b){b.render()})},redraw:function(b){this.controlPoints.forEach(function(a){a.redraw(b)})},transform:function(b,a,d,c,e){if(this.chart.inverted){var h=a;a=d;d=h}this.points.forEach(function(h,g){this.transformPoint(b,a,d,c,e,g)},this)},transformPoint:function(b,
a,d,c,e,h){var l=this.points[h];l.mock||(l=this.points[h]=m.fromPoint(l));l[b](a,d,c,e)},translate:function(b,a){this.transform("translate",null,null,b,a)},translatePoint:function(b,a,d){this.transformPoint("translate",null,null,b,a,d)},translateShape:function(b,a){var d=this.annotation.chart,c=this.annotation.userOptions,e=d.annotations.indexOf(this.annotation);d=d.options.annotations[e];this.translatePoint(b,a,0);d[this.collection][this.index].point=this.options.point;c[this.collection][this.index].point=
this.options.point},rotate:function(b,a,d){this.transform("rotate",b,a,d)},scale:function(b,a,d,c){this.transform("scale",b,a,d,c)},setControlPointsVisibility:function(b){this.controlPoints.forEach(function(a){a.setVisibility(b)})},destroy:function(){this.graphic&&(this.graphic=this.graphic.destroy());this.tracker&&(this.tracker=this.tracker.destroy());this.controlPoints.forEach(function(b){b.destroy()});this.options=this.controlPoints=this.points=this.chart=null;this.annotation&&(this.annotation=
null)},update:function(b){var a=this.annotation;b=k(!0,this.options,b);var d=this.graphic.parentGroup;this.destroy();this.constructor(a,b);this.render(d);this.redraw()}}});p(c,"annotations/controllable/markerMixin.js",[c["parts/Globals.js"],c["parts/Utilities.js"]],function(c,a){var k=a.addEvent,t=a.defined,f=a.merge,d=a.objectEach,B=a.uniqueKey,r={arrow:{tagName:"marker",render:!1,id:"arrow",refY:5,refX:9,markerWidth:10,markerHeight:10,children:[{tagName:"path",d:"M 0 0 L 10 5 L 0 10 Z",strokeWidth:0}]},
"reverse-arrow":{tagName:"marker",render:!1,id:"reverse-arrow",refY:5,refX:1,markerWidth:10,markerHeight:10,children:[{tagName:"path",d:"M 0 5 L 10 0 L 10 10 Z",strokeWidth:0}]}};c.SVGRenderer.prototype.addMarker=function(b,a){var d={id:b},c={stroke:a.color||"none",fill:a.color||"rgba(0, 0, 0, 0.75)"};d.children=a.children.map(function(a){return f(c,a)});a=this.definition(f(!0,{markerWidth:20,markerHeight:20,refX:0,refY:0,orient:"auto"},a,d));a.id=b;return a};a=function(a){return function(b){this.attr(a,
"url(#"+b+")")}};a={markerEndSetter:a("marker-end"),markerStartSetter:a("marker-start"),setItemMarkers:function(a){var b=a.options,d=a.chart,c=d.options.defs,e=b.fill,h=t(e)&&"none"!==e?e:b.stroke;["markerStart","markerEnd"].forEach(function(e){var l=b[e],g;if(l){for(g in c){var v=c[g];if(l===v.id&&"marker"===v.tagName){var n=v;break}}n&&(l=a[e]=d.renderer.addMarker((b.id||B())+"-"+n.id,f(n,{color:h})),a.attr(e,l.attr("id")))}})}};k(c.Chart,"afterGetContainer",function(){this.options.defs=f(r,this.options.defs||
{});d(this.options.defs,function(a){"marker"===a.tagName&&!1!==a.render&&this.renderer.addMarker(a.id,a)},this)});return a});p(c,"annotations/controllable/ControllablePath.js",[c["parts/Globals.js"],c["parts/Utilities.js"],c["annotations/controllable/controllableMixin.js"],c["annotations/controllable/markerMixin.js"]],function(c,a,m,t){var f=a.extend;a=a.merge;var d="rgba(192,192,192,"+(c.svg?.0001:.002)+")";c=function(a,d,b){this.init(a,d,b);this.collection="shapes"};c.attrsMap={dashStyle:"dashstyle",
strokeWidth:"stroke-width",stroke:"stroke",fill:"fill",zIndex:"zIndex"};a(!0,c.prototype,m,{type:"path",setMarkers:t.setItemMarkers,toD:function(){var a=this.options.d;if(a)return"function"===typeof a?a.call(this):a;a=this.points;var d=a.length,b=d,c=a[0],f=b&&this.anchor(c).absolutePosition,x=0,e=[];if(f)for(e.push(["M",f.x,f.y]);++x<d&&b;)c=a[x],b=c.command||"L",f=this.anchor(c).absolutePosition,"M"===b?e.push([b,f.x,f.y]):"L"===b?e.push([b,f.x,f.y]):"Z"===b&&e.push([b]),b=c.series.visible;return b?
this.chart.renderer.crispLine(e,this.graphic.strokeWidth()):null},shouldBeDrawn:function(){return m.shouldBeDrawn.call(this)||!!this.options.d},render:function(a){var c=this.options,b=this.attrsFromOptions(c);this.graphic=this.annotation.chart.renderer.path([["M",0,0]]).attr(b).add(a);c.className&&this.graphic.addClass(c.className);this.tracker=this.annotation.chart.renderer.path([["M",0,0]]).addClass("highcharts-tracker-line").attr({zIndex:2}).add(a);this.annotation.chart.styledMode||this.tracker.attr({"stroke-linejoin":"round",
stroke:d,fill:d,"stroke-width":this.graphic.strokeWidth()+2*c.snap});m.render.call(this);f(this.graphic,{markerStartSetter:t.markerStartSetter,markerEndSetter:t.markerEndSetter});this.setMarkers(this)},redraw:function(a){var d=this.toD(),b=a?"animate":"attr";d?(this.graphic[b]({d:d}),this.tracker[b]({d:d})):(this.graphic.attr({d:"M 0 -9000000000"}),this.tracker.attr({d:"M 0 -9000000000"}));this.graphic.placed=this.tracker.placed=!!d;m.redraw.call(this,a)}});return c});p(c,"annotations/controllable/ControllableRect.js",
[c["parts/Utilities.js"],c["annotations/controllable/controllableMixin.js"],c["annotations/controllable/ControllablePath.js"]],function(c,a,m){c=c.merge;var k=function(a,d,c){this.init(a,d,c);this.collection="shapes"};k.attrsMap=c(m.attrsMap,{width:"width",height:"height"});c(!0,k.prototype,a,{type:"rect",translate:a.translateShape,render:function(c){var d=this.attrsFromOptions(this.options);this.graphic=this.annotation.chart.renderer.rect(0,-9E9,0,0).attr(d).add(c);a.render.call(this)},redraw:function(c){var d=
this.anchor(this.points[0]).absolutePosition;if(d)this.graphic[c?"animate":"attr"]({x:d.x,y:d.y,width:this.options.width,height:this.options.height});else this.attr({x:0,y:-9E9});this.graphic.placed=!!d;a.redraw.call(this,c)}});return k});p(c,"annotations/controllable/ControllableCircle.js",[c["parts/Utilities.js"],c["annotations/controllable/controllableMixin.js"],c["annotations/controllable/ControllablePath.js"]],function(c,a,m){c=c.merge;var k=function(a,c,k){this.init(a,c,k);this.collection="shapes"};
k.attrsMap=c(m.attrsMap,{r:"r"});c(!0,k.prototype,a,{type:"circle",translate:a.translateShape,render:function(c){var d=this.attrsFromOptions(this.options);this.graphic=this.annotation.chart.renderer.circle(0,-9E9,0).attr(d).add(c);a.render.call(this)},redraw:function(c){var d=this.anchor(this.points[0]).absolutePosition;if(d)this.graphic[c?"animate":"attr"]({x:d.x,y:d.y,r:this.options.r});else this.graphic.attr({x:0,y:-9E9});this.graphic.placed=!!d;a.redraw.call(this,c)},setRadius:function(a){this.options.r=
a}});return k});p(c,"annotations/controllable/ControllableLabel.js",[c["parts/Globals.js"],c["parts/Utilities.js"],c["annotations/controllable/controllableMixin.js"],c["annotations/MockPoint.js"],c["parts/Tooltip.js"]],function(c,a,m,t,f){var d=a.extend,k=a.format,r=a.isNumber,b=a.merge,g=a.pick,p=function(a,b,c){this.init(a,b,c);this.collection="labels"};p.shapesWithoutBackground=["connector"];p.alignedPosition=function(a,b){var e=a.align,c=a.verticalAlign,d=(b.x||0)+(a.x||0),f=(b.y||0)+(a.y||0),
g,n;"right"===e?g=1:"center"===e&&(g=2);g&&(d+=(b.width-(a.width||0))/g);"bottom"===c?n=1:"middle"===c&&(n=2);n&&(f+=(b.height-(a.height||0))/n);return{x:Math.round(d),y:Math.round(f)}};p.justifiedOptions=function(a,b,c,d){var e=c.align,h=c.verticalAlign,l=b.box?0:b.padding||0,n=b.getBBox();b={align:e,verticalAlign:h,x:c.x,y:c.y,width:b.width,height:b.height};c=d.x-a.plotLeft;var u=d.y-a.plotTop;d=c+l;0>d&&("right"===e?b.align="left":b.x=-d);d=c+n.width-l;d>a.plotWidth&&("left"===e?b.align="right":
b.x=a.plotWidth-d);d=u+l;0>d&&("bottom"===h?b.verticalAlign="top":b.y=-d);d=u+n.height-l;d>a.plotHeight&&("top"===h?b.verticalAlign="bottom":b.y=a.plotHeight-d);return b};p.attrsMap={backgroundColor:"fill",borderColor:"stroke",borderWidth:"stroke-width",zIndex:"zIndex",borderRadius:"r",padding:"padding"};b(!0,p.prototype,m,{translatePoint:function(a,b){m.translatePoint.call(this,a,b,0)},translate:function(a,b){var c=this.annotation.chart,e=this.annotation.userOptions,d=c.annotations.indexOf(this.annotation);
d=c.options.annotations[d];c.inverted&&(c=a,a=b,b=c);this.options.x+=a;this.options.y+=b;d[this.collection][this.index].x=this.options.x;d[this.collection][this.index].y=this.options.y;e[this.collection][this.index].x=this.options.x;e[this.collection][this.index].y=this.options.y},render:function(a){var b=this.options,c=this.attrsFromOptions(b),d=b.style;this.graphic=this.annotation.chart.renderer.label("",0,-9999,b.shape,null,null,b.useHTML,null,"annotation-label").attr(c).add(a);this.annotation.chart.styledMode||
("contrast"===d.color&&(d.color=this.annotation.chart.renderer.getContrast(-1<p.shapesWithoutBackground.indexOf(b.shape)?"#FFFFFF":b.backgroundColor)),this.graphic.css(b.style).shadow(b.shadow));b.className&&this.graphic.addClass(b.className);this.graphic.labelrank=b.labelrank;m.render.call(this)},redraw:function(a){var b=this.options,c=this.text||b.format||b.text,d=this.graphic,f=this.points[0];d.attr({text:c?k(c,f.getLabelConfig(),this.annotation.chart):b.formatter.call(f,this)});b=this.anchor(f);
(c=this.position(b))?(d.alignAttr=c,c.anchorX=b.absolutePosition.x,c.anchorY=b.absolutePosition.y,d[a?"animate":"attr"](c)):d.attr({x:0,y:-9999});d.placed=!!c;m.redraw.call(this,a)},anchor:function(){var a=m.anchor.apply(this,arguments),b=this.options.x||0,c=this.options.y||0;a.absolutePosition.x-=b;a.absolutePosition.y-=c;a.relativePosition.x-=b;a.relativePosition.y-=c;return a},position:function(a){var b=this.graphic,c=this.annotation.chart,l=this.points[0],q=this.options,k=a.absolutePosition,v=
a.relativePosition;if(a=l.series.visible&&t.prototype.isInsidePlot.call(l)){if(q.distance)var n=f.prototype.getPosition.call({chart:c,distance:g(q.distance,16)},b.width,b.height,{plotX:v.x,plotY:v.y,negative:l.negative,ttBelow:l.ttBelow,h:v.height||v.width});else q.positioner?n=q.positioner.call(this):(l={x:k.x,y:k.y,width:0,height:0},n=p.alignedPosition(d(q,{width:b.width,height:b.height}),l),"justify"===this.options.overflow&&(n=p.alignedPosition(p.justifiedOptions(c,b,q,n),l)));q.crop&&(q=n.x-
c.plotLeft,l=n.y-c.plotTop,a=c.isInsidePlot(q,l)&&c.isInsidePlot(q+b.width,l+b.height))}return a?n:null}});c.SVGRenderer.prototype.symbols.connector=function(a,b,c,d,f){var e=f&&f.anchorX;f=f&&f.anchorY;var h=c/2;if(r(e)&&r(f)){var n=[["M",e,f]];var u=b-f;0>u&&(u=-d-u);u<c&&(h=e<a+c/2?u:c-u);f>b+d?n.push(["L",a+h,b+d]):f<b?n.push(["L",a+h,b]):e<a?n.push(["L",a,b+d/2]):e>a+c&&n.push(["L",a+c,b+d/2])}return n||[]};return p});p(c,"annotations/controllable/ControllableImage.js",[c["parts/Utilities.js"],
c["annotations/controllable/controllableMixin.js"],c["annotations/controllable/ControllableLabel.js"]],function(c,a,m){c=c.merge;var k=function(a,c,k){this.init(a,c,k);this.collection="shapes"};k.attrsMap={width:"width",height:"height",zIndex:"zIndex"};c(!0,k.prototype,a,{type:"image",translate:a.translateShape,render:function(c){var d=this.attrsFromOptions(this.options),f=this.options;this.graphic=this.annotation.chart.renderer.image(f.src,0,-9E9,f.width,f.height).attr(d).add(c);this.graphic.width=
f.width;this.graphic.height=f.height;a.render.call(this)},redraw:function(c){var d=this.anchor(this.points[0]);if(d=m.prototype.position.call(this,d))this.graphic[c?"animate":"attr"]({x:d.x,y:d.y});else this.graphic.attr({x:0,y:-9E9});this.graphic.placed=!!d;a.redraw.call(this,c)}});return k});p(c,"annotations/annotations.src.js",[c["parts/Globals.js"],c["parts/Utilities.js"],c["annotations/controllable/controllableMixin.js"],c["annotations/controllable/ControllableRect.js"],c["annotations/controllable/ControllableCircle.js"],
c["annotations/controllable/ControllablePath.js"],c["annotations/controllable/ControllableImage.js"],c["annotations/controllable/ControllableLabel.js"],c["annotations/eventEmitterMixin.js"],c["annotations/MockPoint.js"],c["annotations/ControlPoint.js"]],function(c,a,m,t,f,d,p,r,b,g,z){var k=a.addEvent,e=a.defined,h=a.destroyObjectProperties,l=a.erase,q=a.extend,y=a.find,v=a.fireEvent,n=a.merge,u=a.pick,C=a.splat;a=a.wrap;var A=c.Chart.prototype,w=c.Annotation=function(a,b){this.chart=a;this.points=
[];this.controlPoints=[];this.coll="annotations";this.labels=[];this.shapes=[];this.options=n(this.defaultOptions,b);this.userOptions=b;b=this.getLabelsAndShapesOptions(this.options,b);this.options.labels=b.labels;this.options.shapes=b.shapes;this.init(a,this.options)};n(!0,w.prototype,m,b,{nonDOMEvents:["add","afterUpdate","drag","remove"],defaultOptions:{visible:!0,draggable:"xy",labelOptions:{align:"center",allowOverlap:!1,backgroundColor:"rgba(0, 0, 0, 0.75)",borderColor:"black",borderRadius:3,
borderWidth:1,className:"",crop:!1,formatter:function(){return e(this.y)?this.y:"Annotation label"},overflow:"justify",padding:5,shadow:!1,shape:"callout",style:{fontSize:"11px",fontWeight:"normal",color:"contrast"},useHTML:!1,verticalAlign:"bottom",x:0,y:-16},shapeOptions:{stroke:"rgba(0, 0, 0, 0.75)",strokeWidth:1,fill:"rgba(0, 0, 0, 0.75)",r:0,snap:2},controlPointOptions:{symbol:"circle",width:10,height:10,style:{stroke:"black","stroke-width":2,fill:"white"},visible:!1,events:{}},events:{},zIndex:6},
init:function(){this.linkPoints();this.addControlPoints();this.addShapes();this.addLabels();this.setLabelCollector()},getLabelsAndShapesOptions:function(a,b){var c={};["labels","shapes"].forEach(function(d){a[d]&&(c[d]=C(b[d]).map(function(b,c){return n(a[d][c],b)}))});return c},addShapes:function(){(this.options.shapes||[]).forEach(function(a,b){a=this.initShape(a,b);n(!0,this.options.shapes[b],a.options)},this)},addLabels:function(){(this.options.labels||[]).forEach(function(a,b){a=this.initLabel(a,
b);n(!0,this.options.labels[b],a.options)},this)},addClipPaths:function(){this.setClipAxes();this.clipXAxis&&this.clipYAxis&&(this.clipRect=this.chart.renderer.clipRect(this.getClipBox()))},setClipAxes:function(){var a=this.chart.xAxis,b=this.chart.yAxis,c=(this.options.labels||[]).concat(this.options.shapes||[]).reduce(function(c,d){return[a[d&&d.point&&d.point.xAxis]||c[0],b[d&&d.point&&d.point.yAxis]||c[1]]},[]);this.clipXAxis=c[0];this.clipYAxis=c[1]},getClipBox:function(){if(this.clipXAxis&&
this.clipYAxis)return{x:this.clipXAxis.left,y:this.clipYAxis.top,width:this.clipXAxis.width,height:this.clipYAxis.height}},setLabelCollector:function(){var a=this;a.labelCollector=function(){return a.labels.reduce(function(a,b){b.options.allowOverlap||a.push(b.graphic);return a},[])};a.chart.labelCollectors.push(a.labelCollector)},setOptions:function(a){this.options=n(this.defaultOptions,a)},redraw:function(a){this.linkPoints();this.graphic||this.render();this.clipRect&&this.clipRect.animate(this.getClipBox());
this.redrawItems(this.shapes,a);this.redrawItems(this.labels,a);m.redraw.call(this,a)},redrawItems:function(a,b){for(var c=a.length;c--;)this.redrawItem(a[c],b)},renderItems:function(a){for(var b=a.length;b--;)this.renderItem(a[b])},render:function(){var a=this.chart.renderer;this.graphic=a.g("annotation").attr({zIndex:this.options.zIndex,visibility:this.options.visible?"visible":"hidden"}).add();this.shapesGroup=a.g("annotation-shapes").add(this.graphic).clip(this.chart.plotBoxClip);this.labelsGroup=
a.g("annotation-labels").attr({translateX:0,translateY:0}).add(this.graphic);this.addClipPaths();this.clipRect&&this.graphic.clip(this.clipRect);this.renderItems(this.shapes);this.renderItems(this.labels);this.addEvents();m.render.call(this)},setVisibility:function(a){var b=this.options;a=u(a,!b.visible);this.graphic.attr("visibility",a?"visible":"hidden");a||this.setControlPointsVisibility(!1);b.visible=a},setControlPointsVisibility:function(a){var b=function(b){b.setControlPointsVisibility(a)};
m.setControlPointsVisibility.call(this,a);this.shapes.forEach(b);this.labels.forEach(b)},destroy:function(){var a=this.chart,c=function(a){a.destroy()};this.labels.forEach(c);this.shapes.forEach(c);this.clipYAxis=this.clipXAxis=null;l(a.labelCollectors,this.labelCollector);b.destroy.call(this);m.destroy.call(this);h(this,a)},remove:function(){return this.chart.removeAnnotation(this)},update:function(a,b){var c=this.chart,d=this.getLabelsAndShapesOptions(this.userOptions,a),e=c.annotations.indexOf(this);
a=n(!0,this.userOptions,a);a.labels=d.labels;a.shapes=d.shapes;this.destroy();this.constructor(c,a);c.options.annotations[e]=a;this.isUpdating=!0;u(b,!0)&&c.redraw();v(this,"afterUpdate");this.isUpdating=!1},initShape:function(a,b){a=n(this.options.shapeOptions,{controlPointOptions:this.options.controlPointOptions},a);b=new w.shapesMap[a.type](this,a,b);b.itemType="shape";this.shapes.push(b);return b},initLabel:function(a,b){a=n(this.options.labelOptions,{controlPointOptions:this.options.controlPointOptions},
a);b=new r(this,a,b);b.itemType="label";this.labels.push(b);return b},redrawItem:function(a,b){a.linkPoints();a.shouldBeDrawn()?(a.graphic||this.renderItem(a),a.redraw(u(b,!0)&&a.graphic.placed),a.points.length&&this.adjustVisibility(a)):this.destroyItem(a)},adjustVisibility:function(a){var b=!1,c=a.graphic;a.points.forEach(function(a){!1!==a.series.visible&&!1!==a.visible&&(b=!0)});b?"hidden"===c.visibility&&c.show():c.hide()},destroyItem:function(a){l(this[a.itemType+"s"],a);a.destroy()},renderItem:function(a){a.render("label"===
a.itemType?this.labelsGroup:this.shapesGroup)}});w.shapesMap={rect:t,circle:f,path:d,image:p};w.types={};w.MockPoint=g;w.ControlPoint=z;c.extendAnnotation=function(a,b,c,d){b=b||w;n(!0,a.prototype,b.prototype,c);a.prototype.defaultOptions=n(a.prototype.defaultOptions,d||{})};q(A,{initAnnotation:function(a){a=new (w.types[a.type]||w)(this,a);this.annotations.push(a);return a},addAnnotation:function(a,b){a=this.initAnnotation(a);this.options.annotations.push(a.options);u(b,!0)&&a.redraw();return a},
removeAnnotation:function(a){var b=this.annotations,c="annotations"===a.coll?a:y(b,function(b){return b.options.id===a});c&&(v(c,"remove"),l(this.options.annotations,c.options),l(b,c),c.destroy())},drawAnnotations:function(){this.plotBoxClip.attr(this.plotBox);this.annotations.forEach(function(a){a.redraw()})}});A.collectionsWithUpdate.push("annotations");A.collectionsWithInit.annotations=[A.addAnnotation];A.callbacks.push(function(a){a.annotations=[];a.options.annotations||(a.options.annotations=
[]);a.plotBoxClip=this.renderer.clipRect(this.plotBox);a.controlPointsGroup=a.renderer.g("control-points").attr({zIndex:99}).clip(a.plotBoxClip).add();a.options.annotations.forEach(function(b,c){b=a.initAnnotation(b);a.options.annotations[c]=b.options});a.drawAnnotations();k(a,"redraw",a.drawAnnotations);k(a,"destroy",function(){a.plotBoxClip.destroy();a.controlPointsGroup.destroy()})});a(c.Pointer.prototype,"onContainerMouseDown",function(a){this.chart.hasDraggedAnnotation||a.apply(this,Array.prototype.slice.call(arguments,
1))})});p(c,"mixins/navigation.js",[],function(){return{initUpdate:function(c){c.navigation||(c.navigation={updates:[],update:function(a,c){this.updates.forEach(function(k){k.update.call(k.context,a,c)})}})},addUpdate:function(c,a){a.navigation||this.initUpdate(a);a.navigation.updates.push({update:c,context:a})}}});p(c,"annotations/navigationBindings.js",[c["parts/Globals.js"],c["parts/Utilities.js"],c["mixins/navigation.js"]],function(c,a,m){function k(a){var b=a.prototype.defaultOptions.events&&
a.prototype.defaultOptions.events.click;e(!0,a.prototype.defaultOptions.events,{click:function(a){var c=this,d=c.chart.navigationBindings,e=d.activeAnnotation;b&&b.click.call(c,a);e!==c?(d.deselectAnnotation(),d.activeAnnotation=c,c.setControlPointsVisibility(!0),r(d,"showPopup",{annotation:c,formType:"annotation-toolbar",options:d.annotationToFields(c),onSubmit:function(a){var b={};"remove"===a.actionType?(d.activeAnnotation=!1,d.chart.removeAnnotation(c)):(d.fieldsToOptions(a.fields,b),d.deselectAnnotation(),
a=b.typeOptions,"measure"===c.options.type&&(a.crosshairY.enabled=0!==a.crosshairY.strokeWidth,a.crosshairX.enabled=0!==a.crosshairX.strokeWidth),c.update(b))}})):(d.deselectAnnotation(),r(d,"closePopup"));a.activeAnnotation=!0}})}var f=a.addEvent,d=a.attr,p=a.format,r=a.fireEvent,b=a.isArray,g=a.isFunction,z=a.isNumber,x=a.isObject,e=a.merge,h=a.objectEach,l=a.pick,q=c.doc,y=c.win,v=function(){function a(a,b){this.selectedButton=this.boundClassNames=void 0;this.chart=a;this.options=b;this.eventsToUnbind=
[];this.container=q.getElementsByClassName(this.options.bindingsClassName||"")}a.prototype.initEvents=function(){var a=this,b=a.chart,c=a.container,d=a.options;a.boundClassNames={};h(d.bindings||{},function(b){a.boundClassNames[b.className]=b});[].forEach.call(c,function(b){a.eventsToUnbind.push(f(b,"click",function(c){var d=a.getButtonEvents(b,c);d&&a.bindingsButtonClick(d.button,d.events,c)}))});h(d.events||{},function(b,c){g(b)&&a.eventsToUnbind.push(f(a,c,b))});a.eventsToUnbind.push(f(b.container,
"click",function(c){!b.cancelClick&&b.isInsidePlot(c.chartX-b.plotLeft,c.chartY-b.plotTop)&&a.bindingsChartClick(this,c)}));a.eventsToUnbind.push(f(b.container,"mousemove",function(b){a.bindingsContainerMouseMove(this,b)}))};a.prototype.initUpdate=function(){var a=this;m.addUpdate(function(b){a.update(b)},this.chart)};a.prototype.bindingsButtonClick=function(a,b,c){var d=this.chart;this.selectedButtonElement&&(r(this,"deselectButton",{button:this.selectedButtonElement}),this.nextEvent&&(this.currentUserDetails&&
"annotations"===this.currentUserDetails.coll&&d.removeAnnotation(this.currentUserDetails),this.mouseMoveEvent=this.nextEvent=!1));this.selectedButton=b;this.selectedButtonElement=a;r(this,"selectButton",{button:a});b.init&&b.init.call(this,a,c);(b.start||b.steps)&&d.renderer.boxWrapper.addClass("highcharts-draw-mode")};a.prototype.bindingsChartClick=function(a,b){a=this.chart;var c=this.selectedButton;a=a.renderer.boxWrapper;var d;if(d=this.activeAnnotation&&!b.activeAnnotation&&b.target.parentNode){a:{d=
b.target;var e=y.Element.prototype,h=e.matches||e.msMatchesSelector||e.webkitMatchesSelector,f=null;if(e.closest)f=e.closest.call(d,".highcharts-popup");else{do{if(h.call(d,".highcharts-popup"))break a;d=d.parentElement||d.parentNode}while(null!==d&&1===d.nodeType)}d=f}d=!d}d&&(r(this,"closePopup"),this.deselectAnnotation());c&&c.start&&(this.nextEvent?(this.nextEvent(b,this.currentUserDetails),this.steps&&(this.stepIndex++,c.steps[this.stepIndex]?this.mouseMoveEvent=this.nextEvent=c.steps[this.stepIndex]:
(r(this,"deselectButton",{button:this.selectedButtonElement}),a.removeClass("highcharts-draw-mode"),c.end&&c.end.call(this,b,this.currentUserDetails),this.mouseMoveEvent=this.nextEvent=!1,this.selectedButton=null))):(this.currentUserDetails=c.start.call(this,b),c.steps?(this.stepIndex=0,this.steps=!0,this.mouseMoveEvent=this.nextEvent=c.steps[this.stepIndex]):(r(this,"deselectButton",{button:this.selectedButtonElement}),a.removeClass("highcharts-draw-mode"),this.steps=!1,this.selectedButton=null,
c.end&&c.end.call(this,b,this.currentUserDetails))))};a.prototype.bindingsContainerMouseMove=function(a,b){this.mouseMoveEvent&&this.mouseMoveEvent(b,this.currentUserDetails)};a.prototype.fieldsToOptions=function(a,b){h(a,function(a,c){var d=parseFloat(a),e=c.split("."),h=b,f=e.length-1;!z(d)||a.match(/px/g)||c.match(/format/g)||(a=d);""!==a&&"undefined"!==a&&e.forEach(function(b,c){var d=l(e[c+1],"");f===c?h[b]=a:(h[b]||(h[b]=d.match(/\d/g)?[]:{}),h=h[b])})});return b};a.prototype.deselectAnnotation=
function(){this.activeAnnotation&&(this.activeAnnotation.setControlPointsVisibility(!1),this.activeAnnotation=!1)};a.prototype.annotationToFields=function(c){function d(a,e,f,l){if(f&&-1===v.indexOf(e)&&(0<=(f.indexOf&&f.indexOf(e))||f[e]||!0===f))if(b(a))l[e]=[],a.forEach(function(a,b){x(a)?(l[e][b]={},h(a,function(a,c){d(a,c,n[e],l[e][b])})):d(a,0,n[e],l[e])});else if(x(a)){var u={};b(l)?(l.push(u),u[e]={},u=u[e]):l[e]=u;h(a,function(a,b){d(a,b,0===e?f:n[e],u)})}else"format"===e?l[e]=[p(a,c.labels[0].points[0]).toString(),
"text"]:b(l)?l.push([a,g(a)]):l[e]=[a,g(a)]}var e=c.options,f=a.annotationsEditable,n=f.nestedOptions,g=this.utils.getFieldType,u=l(e.type,e.shapes&&e.shapes[0]&&e.shapes[0].type,e.labels&&e.labels[0]&&e.labels[0].itemType,"label"),v=a.annotationsNonEditable[e.langKey]||[],q={langKey:e.langKey,type:u};h(e,function(a,b){"typeOptions"===b?(q[b]={},h(e[b],function(a,c){d(a,c,n,q[b],!0)})):d(a,b,f[u],q)});return q};a.prototype.getClickedClassNames=function(a,b){var c=b.target;b=[];for(var e;c&&((e=d(c,
"class"))&&(b=b.concat(e.split(" ").map(function(a){return[a,c]}))),c=c.parentNode,c!==a););return b};a.prototype.getButtonEvents=function(a,b){var c=this,d;this.getClickedClassNames(a,b).forEach(function(a){c.boundClassNames[a[0]]&&!d&&(d={events:c.boundClassNames[a[0]],button:a[1]})});return d};a.prototype.update=function(a){this.options=e(!0,this.options,a);this.removeEvents();this.initEvents()};a.prototype.removeEvents=function(){this.eventsToUnbind.forEach(function(a){a()})};a.prototype.destroy=
function(){this.removeEvents()};a.annotationsEditable={nestedOptions:{labelOptions:["style","format","backgroundColor"],labels:["style"],label:["style"],style:["fontSize","color"],background:["fill","strokeWidth","stroke"],innerBackground:["fill","strokeWidth","stroke"],outerBackground:["fill","strokeWidth","stroke"],shapeOptions:["fill","strokeWidth","stroke"],shapes:["fill","strokeWidth","stroke"],line:["strokeWidth","stroke"],backgroundColors:[!0],connector:["fill","strokeWidth","stroke"],crosshairX:["strokeWidth",
"stroke"],crosshairY:["strokeWidth","stroke"]},circle:["shapes"],verticalLine:[],label:["labelOptions"],measure:["background","crosshairY","crosshairX"],fibonacci:[],tunnel:["background","line","height"],pitchfork:["innerBackground","outerBackground"],rect:["shapes"],crookedLine:[],basicAnnotation:[]};a.annotationsNonEditable={rectangle:["crosshairX","crosshairY","label"]};return a}();v.prototype.utils={updateRectSize:function(a,b){var c=b.chart,d=b.options.typeOptions,e=c.pointer.getCoordinates(a);
a=e.xAxis[0].value-d.point.x;d=d.point.y-e.yAxis[0].value;b.update({typeOptions:{background:{width:c.inverted?d:a,height:c.inverted?a:d}}})},getFieldType:function(a){return{string:"text",number:"number","boolean":"checkbox"}[typeof a]}};c.Chart.prototype.initNavigationBindings=function(){var a=this.options;a&&a.navigation&&a.navigation.bindings&&(this.navigationBindings=new v(this,a.navigation),this.navigationBindings.initEvents(),this.navigationBindings.initUpdate())};f(c.Chart,"load",function(){this.initNavigationBindings()});
f(c.Chart,"destroy",function(){this.navigationBindings&&this.navigationBindings.destroy()});f(v,"deselectButton",function(){this.selectedButtonElement=null});f(c.Annotation,"remove",function(){this.chart.navigationBindings&&this.chart.navigationBindings.deselectAnnotation()});c.Annotation&&(k(c.Annotation),h(c.Annotation.types,function(a){k(a)}));c.setOptions({lang:{navigation:{popup:{simpleShapes:"Simple shapes",lines:"Lines",circle:"Circle",rectangle:"Rectangle",label:"Label",shapeOptions:"Shape options",
typeOptions:"Details",fill:"Fill",format:"Text",strokeWidth:"Line width",stroke:"Line color",title:"Title",name:"Name",labelOptions:"Label options",labels:"Labels",backgroundColor:"Background color",backgroundColors:"Background colors",borderColor:"Border color",borderRadius:"Border radius",borderWidth:"Border width",style:"Style",padding:"Padding",fontSize:"Font size",color:"Color",height:"Height",shapes:"Shape options"}}},navigation:{bindingsClassName:"highcharts-bindings-container",bindings:{circleAnnotation:{className:"highcharts-circle-annotation",
start:function(a){a=this.chart.pointer.getCoordinates(a);var b=this.chart.options.navigation;return this.chart.addAnnotation(e({langKey:"circle",type:"basicAnnotation",shapes:[{type:"circle",point:{xAxis:0,yAxis:0,x:a.xAxis[0].value,y:a.yAxis[0].value},r:5}]},b.annotationsOptions,b.bindings.circleAnnotation.annotationsOptions))},steps:[function(a,b){var c=b.options.shapes[0].point,d=this.chart.xAxis[0].toPixels(c.x);c=this.chart.yAxis[0].toPixels(c.y);var e=this.chart.inverted;b.update({shapes:[{r:Math.max(Math.sqrt(Math.pow(e?
c-a.chartX:d-a.chartX,2)+Math.pow(e?d-a.chartY:c-a.chartY,2)),5)}]})}]},rectangleAnnotation:{className:"highcharts-rectangle-annotation",start:function(a){var b=this.chart.pointer.getCoordinates(a);a=this.chart.options.navigation;var c=b.xAxis[0].value;b=b.yAxis[0].value;return this.chart.addAnnotation(e({langKey:"rectangle",type:"basicAnnotation",shapes:[{type:"path",points:[{xAxis:0,yAxis:0,x:c,y:b},{xAxis:0,yAxis:0,x:c,y:b},{xAxis:0,yAxis:0,x:c,y:b},{xAxis:0,yAxis:0,x:c,y:b}]}]},a.annotationsOptions,
a.bindings.rectangleAnnotation.annotationsOptions))},steps:[function(a,b){var c=b.options.shapes[0].points,d=this.chart.pointer.getCoordinates(a);a=d.xAxis[0].value;d=d.yAxis[0].value;c[1].x=a;c[2].x=a;c[2].y=d;c[3].y=d;b.update({shapes:[{points:c}]})}]},labelAnnotation:{className:"highcharts-label-annotation",start:function(a){a=this.chart.pointer.getCoordinates(a);var b=this.chart.options.navigation;return this.chart.addAnnotation(e({langKey:"label",type:"basicAnnotation",labelOptions:{format:"{y:.2f}"},
labels:[{point:{xAxis:0,yAxis:0,x:a.xAxis[0].value,y:a.yAxis[0].value},overflow:"none",crop:!0}]},b.annotationsOptions,b.bindings.labelAnnotation.annotationsOptions))}}},events:{},annotationsOptions:{}}});return v});p(c,"annotations/popup.js",[c["parts/Globals.js"],c["annotations/navigationBindings.js"],c["parts/Utilities.js"]],function(c,a,m){var k=m.addEvent,f=m.createElement,d=m.defined,p=m.isArray,r=m.isObject,b=m.isString,g=m.objectEach,z=m.pick;m=m.wrap;var x=/\d/g;m(c.Pointer.prototype,"onContainerMouseDown",
function(a,c){var d=c.target&&c.target.className;b(d)&&0<=d.indexOf("highcharts-popup-field")||a.apply(this,Array.prototype.slice.call(arguments,1))});c.Popup=function(a,b){this.init(a,b)};c.Popup.prototype={init:function(a,b){this.container=f("div",{className:"highcharts-popup"},null,a);this.lang=this.getLangpack();this.iconsURL=b;this.addCloseBtn()},addCloseBtn:function(){var a=this;var b=f("div",{className:"highcharts-popup-close"},null,this.container);b.style["background-image"]="url("+this.iconsURL+
"close.svg)";["click","touchstart"].forEach(function(c){k(b,c,function(){a.closePopup()})})},addColsContainer:function(a){var b=f("div",{className:"highcharts-popup-lhs-col"},null,a);a=f("div",{className:"highcharts-popup-rhs-col"},null,a);f("div",{className:"highcharts-popup-rhs-col-wrapper"},null,a);return{lhsCol:b,rhsCol:a}},addInput:function(a,b,c,d){var e=a.split(".");e=e[e.length-1];var h=this.lang;b="highcharts-"+b+"-"+e;b.match(x)||f("label",{innerHTML:h[e]||e,htmlFor:b},null,c);f("input",
{name:b,value:d[0],type:d[1],className:"highcharts-popup-field"},null,c).setAttribute("highcharts-data-name",a)},addButton:function(a,b,c,d,g){var e=this,h=this.closePopup,l=this.getFields;var q=f("button",{innerHTML:b},null,a);["click","touchstart"].forEach(function(a){k(q,a,function(){h.call(e);return d(l(g,c))})});return q},getFields:function(a,b){var c=a.querySelectorAll("input"),d=a.querySelectorAll("#highcharts-select-series > option:checked")[0];a=a.querySelectorAll("#highcharts-select-volume > option:checked")[0];
var e,f;var h={actionType:b,linkedTo:d&&d.getAttribute("value"),fields:{}};[].forEach.call(c,function(a){f=a.getAttribute("highcharts-data-name");(e=a.getAttribute("highcharts-data-series-id"))?h.seriesId=a.value:f?h.fields[f]=a.value:h.type=a.value});a&&(h.fields["params.volumeSeriesID"]=a.getAttribute("value"));return h},showPopup:function(){var a=this.container,b=a.querySelectorAll(".highcharts-popup-close")[0];a.innerHTML="";0<=a.className.indexOf("highcharts-annotation-toolbar")&&(a.classList.remove("highcharts-annotation-toolbar"),
a.removeAttribute("style"));a.appendChild(b);a.style.display="block"},closePopup:function(){this.popup.container.style.display="none"},showForm:function(a,b,c,d){this.popup=b.navigationBindings.popup;this.showPopup();"indicators"===a&&this.indicators.addForm.call(this,b,c,d);"annotation-toolbar"===a&&this.annotations.addToolbar.call(this,b,c,d);"annotation-edit"===a&&this.annotations.addForm.call(this,b,c,d);"flag"===a&&this.annotations.addForm.call(this,b,c,d,!0)},getLangpack:function(){return c.getOptions().lang.navigation.popup},
annotations:{addToolbar:function(a,b,c){var d=this,e=this.lang,h=this.popup.container,g=this.showForm;-1===h.className.indexOf("highcharts-annotation-toolbar")&&(h.className+=" highcharts-annotation-toolbar");h.style.top=a.plotTop+10+"px";f("span",{innerHTML:z(e[b.langKey]||b.langKey,b.shapes&&b.shapes[0].type)},null,h);var l=this.addButton(h,e.removeButton||"remove","remove",c,h);l.className+=" highcharts-annotation-remove-button";l.style["background-image"]="url("+this.iconsURL+"destroy.svg)";l=
this.addButton(h,e.editButton||"edit","edit",function(){g.call(d,"annotation-edit",a,b,c)},h);l.className+=" highcharts-annotation-edit-button";l.style["background-image"]="url("+this.iconsURL+"edit.svg)"},addForm:function(a,b,c,d){var e=this.popup.container,h=this.lang;f("h2",{innerHTML:h[b.langKey]||b.langKey,className:"highcharts-popup-main-title"},null,e);var g=f("div",{className:"highcharts-popup-lhs-col highcharts-popup-lhs-full"},null,e);var l=f("div",{className:"highcharts-popup-bottom-row"},
null,e);this.annotations.addFormFields.call(this,g,a,"",b,[],!0);this.addButton(l,d?h.addButton||"add":h.saveButton||"save",d?"add":"save",c,e)},addFormFields:function(a,b,c,d,k,v){var e=this,h=this.annotations.addFormFields,l=this.addInput,q=this.lang,m,y;g(d,function(d,f){m=""!==c?c+"."+f:f;r(d)&&(!p(d)||p(d)&&r(d[0])?(y=q[f]||f,y.match(x)||k.push([!0,y,a]),h.call(e,a,b,m,d,k,!1)):k.push([e,m,"annotation",a,d]))});v&&(k=k.sort(function(a){return a[1].match(/format/g)?-1:1}),k.forEach(function(a){!0===
a[0]?f("span",{className:"highcharts-annotation-title",innerHTML:a[1]},null,a[2]):l.apply(a[0],a.splice(1))}))}},indicators:{addForm:function(a,b,c){var d=this.indicators,e=this.lang;this.tabs.init.call(this,a);b=this.popup.container.querySelectorAll(".highcharts-tab-item-content");this.addColsContainer(b[0]);d.addIndicatorList.call(this,a,b[0],"add");var f=b[0].querySelectorAll(".highcharts-popup-rhs-col")[0];this.addButton(f,e.addButton||"add","add",c,f);this.addColsContainer(b[1]);d.addIndicatorList.call(this,
a,b[1],"edit");f=b[1].querySelectorAll(".highcharts-popup-rhs-col")[0];this.addButton(f,e.saveButton||"save","edit",c,f);this.addButton(f,e.removeButton||"remove","remove",c,f)},addIndicatorList:function(a,b,c){var d=this,e=b.querySelectorAll(".highcharts-popup-lhs-col")[0];b=b.querySelectorAll(".highcharts-popup-rhs-col")[0];var h="edit"===c,l=h?a.series:a.options.plotOptions,m=this.indicators.addFormFields,p;var r=f("ul",{className:"highcharts-indicator-list"},null,e);var t=b.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];
g(l,function(b,c){var e=b.options;if(b.params||e&&e.params){var g=d.indicators.getNameType(b,c),q=g.type;p=f("li",{className:"highcharts-indicator-list",innerHTML:g.name},null,r);["click","touchstart"].forEach(function(c){k(p,c,function(){m.call(d,a,h?b:l[q],g.type,t);h&&b.options&&f("input",{type:"hidden",name:"highcharts-id-"+q,value:b.options.id},null,t).setAttribute("highcharts-data-series-id",b.options.id)})})}});0<r.childNodes.length&&r.childNodes[0].click()},getNameType:function(a,b){var d=
a.options,e=c.seriesTypes;e=e[b]&&e[b].prototype.nameBase||b.toUpperCase();d&&d.type&&(b=a.options.type,e=a.name);return{name:e,type:b}},listAllSeries:function(a,b,c,g,k){a="highcharts-"+b+"-type-"+a;var e;f("label",{innerHTML:this.lang[b]||b,htmlFor:a},null,g);var h=f("select",{name:a,className:"highcharts-popup-field"},null,g);h.setAttribute("id","highcharts-select-"+b);c.series.forEach(function(a){e=a.options;!e.params&&e.id&&"highcharts-navigator-series"!==e.id&&f("option",{innerHTML:e.name||
e.id,value:e.id},null,h)});d(k)&&(h.value=k)},addFormFields:function(a,b,c,d){var e=b.params||b.options.params,g=this.indicators.getNameType;d.innerHTML="";f("h3",{className:"highcharts-indicator-title",innerHTML:g(b,c).name},null,d);f("input",{type:"hidden",name:"highcharts-type-"+c,value:c},null,d);this.indicators.listAllSeries.call(this,c,"series",a,d,b.linkedParent&&e.volumeSeriesID);e.volumeSeriesID&&this.indicators.listAllSeries.call(this,c,"volume",a,d,b.linkedParent&&b.linkedParent.options.id);
this.indicators.addParamInputs.call(this,a,"params",e,c,d)},addParamInputs:function(a,b,c,d,f){var e=this,h=this.indicators.addParamInputs,l=this.addInput,k;g(c,function(c,g){k=b+"."+g;r(c)?h.call(e,a,k,c,d,f):"params.volumeSeriesID"!==k&&l.call(e,k,d,f,[c,"text"])})},getAmount:function(){var a=0;g(this.series,function(b){var c=b.options;(b.params||c&&c.params)&&a++});return a}},tabs:{init:function(a){var b=this.tabs;a=this.indicators.getAmount.call(a);var c=b.addMenuItem.call(this,"add");b.addMenuItem.call(this,
"edit",a);b.addContentItem.call(this,"add");b.addContentItem.call(this,"edit");b.switchTabs.call(this,a);b.selectTab.call(this,c,0)},addMenuItem:function(a,b){var c=this.popup.container,d="highcharts-tab-item",e=this.lang;0===b&&(d+=" highcharts-tab-disabled");b=f("span",{innerHTML:e[a+"Button"]||a,className:d},null,c);b.setAttribute("highcharts-data-tab-type",a);return b},addContentItem:function(){return f("div",{className:"highcharts-tab-item-content"},null,this.popup.container)},switchTabs:function(a){var b=
this,c;this.popup.container.querySelectorAll(".highcharts-tab-item").forEach(function(d,e){c=d.getAttribute("highcharts-data-tab-type");"edit"===c&&0===a||["click","touchstart"].forEach(function(a){k(d,a,function(){b.tabs.deselectAll.call(b);b.tabs.selectTab.call(b,this,e)})})})},selectTab:function(a,b){var c=this.popup.container.querySelectorAll(".highcharts-tab-item-content");a.className+=" highcharts-tab-item-active";c[b].className+=" highcharts-tab-item-show"},deselectAll:function(){var a=this.popup.container,
b=a.querySelectorAll(".highcharts-tab-item");a=a.querySelectorAll(".highcharts-tab-item-content");var c;for(c=0;c<b.length;c++)b[c].classList.remove("highcharts-tab-item-active"),a[c].classList.remove("highcharts-tab-item-show")}}};k(a,"showPopup",function(a){this.popup||(this.popup=new c.Popup(this.chart.container,this.chart.options.navigation.iconsURL||this.chart.options.stockTools&&this.chart.options.stockTools.gui.iconsURL||"https://code.highcharts.com/8.1.0/gfx/stock-icons/"));this.popup.showForm(a.formType,
this.chart,a.options,a.onSubmit)});k(a,"closePopup",function(){this.popup&&this.popup.closePopup()})});p(c,"masters/modules/annotations.src.js",[],function(){})});
//# sourceMappingURL=annotations.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v8.1.0 (2020-05-05)

 Exporting module

 (c) 2010-2019 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(g){"object"===typeof module&&module.exports?(g["default"]=g,module.exports=g): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(n){g(n);g.Highcharts=n;return g}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):g("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(g){function n(e,f,g,l){e.hasOwnProperty(f)||(e[f]=l.apply(null,g))}g=g?g._modules:{};n(g,"modules/full-screen.src.js",[g["parts/Globals.js"],g["parts/Utilities.js"]],function(e,f){var g=f.addEvent;f=e.Chart;var l=function(){function e(k){this.chart=
k;this.isOpen=!1;k=k.renderTo;this.browserProps||("function"===typeof k.requestFullscreen?this.browserProps={fullscreenChange:"fullscreenchange",requestFullscreen:"requestFullscreen",exitFullscreen:"exitFullscreen"}:k.mozRequestFullScreen?this.browserProps={fullscreenChange:"mozfullscreenchange",requestFullscreen:"mozRequestFullScreen",exitFullscreen:"mozCancelFullScreen"}:k.webkitRequestFullScreen?this.browserProps={fullscreenChange:"webkitfullscreenchange",requestFullscreen:"webkitRequestFullScreen",
exitFullscreen:"webkitExitFullscreen"}:k.msRequestFullscreen&&(this.browserProps={fullscreenChange:"MSFullscreenChange",requestFullscreen:"msRequestFullscreen",exitFullscreen:"msExitFullscreen"}))}e.prototype.close=function(){var k=this.chart;if(this.isOpen&&this.browserProps&&k.container.ownerDocument instanceof Document)k.container.ownerDocument[this.browserProps.exitFullscreen]();this.unbindFullscreenEvent&&this.unbindFullscreenEvent();this.isOpen=!1;this.setButtonText()};e.prototype.open=function(){var k=
this,e=k.chart;if(k.browserProps){k.unbindFullscreenEvent=g(e.container.ownerDocument,k.browserProps.fullscreenChange,function(){k.isOpen?(k.isOpen=!1,k.close()):(k.isOpen=!0,k.setButtonText())});var f=e.renderTo[k.browserProps.requestFullscreen]();if(f)f["catch"](function(){alert("Full screen is not supported inside a frame.")});g(e,"destroy",k.unbindFullscreenEvent)}};e.prototype.setButtonText=function(){var e,f=this.chart,g=f.exportDivElements,l=f.options.exporting,q=null===(e=null===l||void 0===
l?void 0:l.buttons)||void 0===e?void 0:e.contextButton.menuItems;e=f.options.lang;(null===l||void 0===l?0:l.menuItemDefinitions)&&(null===e||void 0===e?0:e.exitFullscreen)&&e.viewFullscreen&&q&&g&&g.length&&(g[q.indexOf("viewFullscreen")].innerHTML=this.isOpen?e.exitFullscreen:l.menuItemDefinitions.viewFullscreen.text||e.viewFullscreen)};e.prototype.toggle=function(){this.isOpen?this.close():this.open()};return e}();e.Fullscreen=l;g(f,"beforeRender",function(){this.fullscreen=new e.Fullscreen(this)});
return e.Fullscreen});n(g,"mixins/navigation.js",[],function(){return{initUpdate:function(e){e.navigation||(e.navigation={updates:[],update:function(e,g){this.updates.forEach(function(f){f.update.call(f.context,e,g)})}})},addUpdate:function(e,f){f.navigation||this.initUpdate(f);f.navigation.updates.push({update:e,context:f})}}});n(g,"modules/exporting.src.js",[g["parts/Globals.js"],g["parts/Utilities.js"],g["mixins/navigation.js"]],function(e,f,g){var l=f.addEvent,q=f.css,k=f.createElement,n=f.discardElement,
w=f.extend,I=f.find,A=f.fireEvent,J=f.isObject,r=f.merge,E=f.objectEach,t=f.pick,K=f.removeEvent,L=f.uniqueKey,v=e.defaultOptions,x=e.doc,B=e.Chart,M=e.isTouchDevice,y=e.win,G=y.navigator.userAgent,F=e.SVGRenderer,H=e.Renderer.prototype.symbols,N=/Edge\/|Trident\/|MSIE /.test(G),O=/firefox/i.test(G);w(v.lang,{viewFullscreen:"View in full screen",exitFullscreen:"Exit from full screen",printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",
downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});v.navigation||(v.navigation={});r(!0,v.navigation,{buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}});r(!0,v.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",color:"#333333",background:"none",fontSize:M?"14px":"11px",transition:"background 250ms, color 250ms"},
menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{padding:5}}});v.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",titleKey:"contextButtonTitle",menuItems:"viewFullscreen printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},
menuItemDefinitions:{viewFullscreen:{textKey:"viewFullscreen",onclick:function(){this.fullscreen.toggle()}},printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",
onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};e.post=function(a,b,c){var d=k("form",r({method:"post",action:a,enctype:"multipart/form-data"},c),{display:"none"},x.body);E(b,function(a,b){k("input",{type:"hidden",name:b,value:a},null,d)});d.submit();n(d)};e.isSafari&&e.win.matchMedia("print").addListener(function(a){e.printingChart&&(a.matches?e.printingChart.beforePrint():e.printingChart.afterPrint())});w(B.prototype,{sanitizeSVG:function(a,b){var c=a.indexOf("</svg>")+6,d=a.substr(c);
a=a.substr(0,c);b&&b.exporting&&b.exporting.allowHTML&&d&&(d='<foreignObject x="0" y="0" width="'+b.chart.width+'" height="'+b.chart.height+'"><body xmlns="http://www.w3.org/1999/xhtml">'+d+"</body></foreignObject>",a=a.replace("</svg>",d+"</svg>"));a=a.replace(/zIndex="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(.*?)("|&quot;);?\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+:)href=/g,
" xlink:href=").replace(/\n/," ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(a=this.ieSanitizeSVG(a));return a},getChartHTML:function(){this.styledMode&&this.inlineStyles();return this.container.innerHTML},getSVG:function(a){var b,c=r(this.options,a);c.plotOptions=r(this.userOptions.plotOptions,a&&a.plotOptions);c.time=r(this.userOptions.time,a&&a.time);var d=k("div",
null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},x.body);var f=this.renderTo.style.width;var g=this.renderTo.style.height;f=c.exporting.sourceWidth||c.chart.width||/px$/.test(f)&&parseInt(f,10)||(c.isGantt?800:600);g=c.exporting.sourceHeight||c.chart.height||/px$/.test(g)&&parseInt(g,10)||400;w(c.chart,{animation:!1,renderTo:d,forExport:!0,renderer:"SVGRenderer",width:f,height:g});c.exporting.enabled=!1;delete c.data;c.series=[];this.series.forEach(function(a){b=
r(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});b.isInternal||c.series.push(b)});this.axes.forEach(function(a){a.userOptions.internalKey||(a.userOptions.internalKey=L())});var u=new e.Chart(c,this.callback);a&&["xAxis","yAxis","series"].forEach(function(b){var d={};a[b]&&(d[b]=a[b],u.update(d))});this.axes.forEach(function(a){var b=I(u.axes,function(b){return b.options.internalKey===a.userOptions.internalKey}),d=a.getExtremes(),c=d.userMin;d=d.userMax;b&&("undefined"!==
typeof c&&c!==b.min||"undefined"!==typeof d&&d!==b.max)&&b.setExtremes(c,d,!0,!1)});f=u.getChartHTML();A(this,"getSVG",{chartCopy:u});f=this.sanitizeSVG(f,c);c=null;u.destroy();n(d);return f},getSVGForExport:function(a,b){var c=this.options.exporting;return this.getSVG(r({chart:{borderRadius:0}},c.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||c.sourceWidth,sourceHeight:a&&a.sourceHeight||c.sourceHeight}}))},getFilename:function(){var a=this.userOptions.title&&this.userOptions.title.text,
b=this.options.exporting.filename;if(b)return b.replace(/\//g,"-");"string"===typeof a&&(b=a.toLowerCase().replace(/<\/?[^>]+(>|$)/g,"").replace(/[\s_]+/g,"-").replace(/[^a-z0-9\-]/g,"").replace(/^[\-]+/g,"").replace(/[\-]+/g,"-").substr(0,24).replace(/[\-]+$/g,""));if(!b||5>b.length)b="chart";return b},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=r(this.options.exporting,a);e.post(a.url,{filename:a.filename?a.filename.replace(/\//g,"-"):this.getFilename(),type:a.type,width:a.width||0,
scale:a.scale,svg:b},a.formAttributes)},moveContainers:function(a){(this.fixedDiv?[this.fixedDiv,this.scrollingContainer]:[this.container]).forEach(function(b){a.appendChild(b)})},beforePrint:function(){var a=x.body,b=this.options.exporting.printMaxWidth,c={childNodes:a.childNodes,origDisplay:[],resetParams:void 0};this.isPrinting=!0;this.pointer.reset(null,0);A(this,"beforePrint");b&&this.chartWidth>b&&(c.resetParams=[this.options.chart.width,void 0,!1],this.setSize(b,void 0,!1));[].forEach.call(c.childNodes,
function(a,b){1===a.nodeType&&(c.origDisplay[b]=a.style.display,a.style.display="none")});this.moveContainers(a);this.printReverseInfo=c},afterPrint:function(){if(this.printReverseInfo){var a=this.printReverseInfo.childNodes,b=this.printReverseInfo.origDisplay,c=this.printReverseInfo.resetParams;this.moveContainers(this.renderTo);[].forEach.call(a,function(a,c){1===a.nodeType&&(a.style.display=b[c]||"")});this.isPrinting=!1;c&&this.setSize.apply(this,c);delete this.printReverseInfo;delete e.printingChart;
A(this,"afterPrint")}},print:function(){var a=this;a.isPrinting||(e.printingChart=a,e.isSafari||a.beforePrint(),setTimeout(function(){y.focus();y.print();e.isSafari||setTimeout(function(){a.afterPrint()},1E3)},1))},contextMenu:function(a,b,c,d,e,g,u){var h=this,D=h.options.navigation,r=h.chartWidth,z=h.chartHeight,p="cache-"+a,m=h[p],C=Math.max(e,g);if(!m){h.exportContextMenu=h[p]=m=k("div",{className:a},{position:"absolute",zIndex:1E3,padding:C+"px",pointerEvents:"auto"},h.fixedDiv||h.container);
var n=k("ul",{className:"highcharts-menu"},{listStyle:"none",margin:0,padding:0},m);h.styledMode||q(n,w({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},D.menuStyle));m.hideMenu=function(){q(m,{display:"none"});u&&u.setState(0);h.openMenu=!1;q(h.renderTo,{overflow:"hidden"});f.clearTimeout(m.hideTimer);A(h,"exportMenuHidden")};h.exportEvents.push(l(m,"mouseleave",function(){m.hideTimer=y.setTimeout(m.hideMenu,500)}),l(m,"mouseenter",function(){f.clearTimeout(m.hideTimer)}),
l(x,"mouseup",function(b){h.pointer.inClass(b.target,a)||m.hideMenu()}),l(m,"click",function(){h.openMenu&&m.hideMenu()}));b.forEach(function(a){"string"===typeof a&&(a=h.options.exporting.menuItemDefinitions[a]);if(J(a,!0)){if(a.separator)var b=k("hr",null,null,n);else b=k("li",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();m.hideMenu();a.onclick&&a.onclick.apply(h,arguments)},innerHTML:a.text||h.options.lang[a.textKey]},null,n),h.styledMode||(b.onmouseover=function(){q(this,
D.menuItemHoverStyle)},b.onmouseout=function(){q(this,D.menuItemStyle)},q(b,w({cursor:"pointer"},D.menuItemStyle)));h.exportDivElements.push(b)}});h.exportDivElements.push(n,m);h.exportMenuWidth=m.offsetWidth;h.exportMenuHeight=m.offsetHeight}b={display:"block"};c+h.exportMenuWidth>r?b.right=r-c-e-C+"px":b.left=c-C+"px";d+g+h.exportMenuHeight>z&&"top"!==u.alignOptions.verticalAlign?b.bottom=z-d-C+"px":b.top=d+g-C+"px";q(m,b);q(h.renderTo,{overflow:""});h.openMenu=!0;A(h,"exportMenuShown")},addButton:function(a){var b=
this,c=b.renderer,d=r(b.options.navigation.buttonOptions,a),e=d.onclick,f=d.menuItems,g=d.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==d.enabled){var h=d.theme,k=h.states,l=k&&k.hover;k=k&&k.select;var z;b.styledMode||(h.fill=t(h.fill,"#ffffff"),h.stroke=t(h.stroke,"none"));delete h.states;e?z=function(a){a&&a.stopPropagation();e.call(b,a)}:f&&(z=function(a){a&&a.stopPropagation();b.contextMenu(p.menuClassName,f,p.translateX,
p.translateY,p.width,p.height,p);p.setState(2)});d.text&&d.symbol?h.paddingLeft=t(h.paddingLeft,25):d.text||w(h,{width:d.width,height:d.height,padding:0});b.styledMode||(h["stroke-linecap"]="round",h.fill=t(h.fill,"#ffffff"),h.stroke=t(h.stroke,"none"));var p=c.button(d.text,0,0,z,h,l,k).addClass(a.className).attr({title:t(b.options.lang[d._titleKey||d.titleKey],"")});p.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;if(d.symbol){var m=c.symbol(d.symbol,d.symbolX-g/2,d.symbolY-g/2,
g,g,{width:g,height:g}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(p);b.styledMode||m.attr({stroke:d.symbolStroke,fill:d.symbolFill,"stroke-width":d.symbolStrokeWidth||1})}p.add(b.exportingGroup).align(w(d,{width:p.width,x:t(d.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(p.width+d.buttonSpacing)*("right"===d.align?-1:1);b.exportSVGElements.push(p,m)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var c=b.exportDivElements,d=b.exportEvents,e;a&&(a.forEach(function(a,
d){a&&(a.onclick=a.ontouchstart=null,e="cache-"+a.menuClassName,b[e]&&delete b[e],b.exportSVGElements[d]=a.destroy())}),a.length=0);b.exportingGroup&&(b.exportingGroup.destroy(),delete b.exportingGroup);c&&(c.forEach(function(a,d){f.clearTimeout(a.hideTimer);K(a,"mouseleave");b.exportDivElements[d]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;n(a)}),c.length=0);d&&(d.forEach(function(a){a()}),d.length=0)}});F.prototype.inlineToAttributes="fill stroke strokeLinecap strokeLinejoin strokeWidth textAnchor x y".split(" ");
F.prototype.inlineBlacklist=[/-/,/^(clipPath|cssText|d|height|width)$/,/^font$/,/[lL]ogical(Width|Height)$/,/perspective/,/TapHighlightColor/,/^transition/,/^length$/];F.prototype.unstyledElements=["clipPath","defs","desc"];B.prototype.inlineStyles=function(){function a(a){return a.replace(/([A-Z])/g,function(a,b){return"-"+b.toLowerCase()})}function b(c){function p(b,f){n=q=!1;if(g){for(t=g.length;t--&&!q;)q=g[t].test(f);n=!q}"transform"===f&&"none"===b&&(n=!0);for(t=e.length;t--&&!n;)n=e[t].test(f)||
"function"===typeof b;n||w[f]===b&&"svg"!==c.nodeName||h[c.nodeName][f]===b||(-1!==d.indexOf(f)?c.setAttribute(a(f),b):m+=a(f)+":"+b+";")}var m="",n,q,t;if(1===c.nodeType&&-1===f.indexOf(c.nodeName)){var u=y.getComputedStyle(c,null);var w="svg"===c.nodeName?{}:y.getComputedStyle(c.parentNode,null);if(!h[c.nodeName]){k=l.getElementsByTagName("svg")[0];var v=l.createElementNS(c.namespaceURI,c.nodeName);k.appendChild(v);h[c.nodeName]=r(y.getComputedStyle(v,null));"text"===c.nodeName&&delete h.text.fill;
k.removeChild(v)}if(O||N)for(var x in u)p(u[x],x);else E(u,p);m&&(u=c.getAttribute("style"),c.setAttribute("style",(u?u+";":"")+m));"svg"===c.nodeName&&c.setAttribute("stroke-width","1px");"text"!==c.nodeName&&[].forEach.call(c.children||c.childNodes,b)}}var c=this.renderer,d=c.inlineToAttributes,e=c.inlineBlacklist,g=c.inlineWhitelist,f=c.unstyledElements,h={},k;c=x.createElement("iframe");q(c,{width:"1px",height:"1px",visibility:"hidden"});x.body.appendChild(c);var l=c.contentWindow.document;l.open();
l.write('<svg xmlns="http://www.w3.org/2000/svg"></svg>');l.close();b(this.container.querySelector("svg"));k.parentNode.removeChild(k)};H.menu=function(a,b,c,d){return[["M",a,b+2.5],["L",a+c,b+2.5],["M",a,b+d/2+.5],["L",a+c,b+d/2+.5],["M",a,b+d-1.5],["L",a+c,b+d-1.5]]};H.menuball=function(a,b,c,d){a=[];d=d/3-2;return a=a.concat(this.circle(c-d,b,d,d),this.circle(c-d,b+d+4,d,d),this.circle(c-d,b+2*(d+4),d,d))};B.prototype.renderExporting=function(){var a=this,b=a.options.exporting,c=b.buttons,d=a.isDirtyExporting||
!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();d&&!1!==b.enabled&&(a.exportEvents=[],a.exportingGroup=a.exportingGroup||a.renderer.g("exporting-group").attr({zIndex:3}).add(),E(c,function(b){a.addButton(b)}),a.isDirtyExporting=!1);l(a,"destroy",a.destroyExport)};l(B,"init",function(){var a=this;a.exporting={update:function(b,c){a.isDirtyExporting=!0;r(!0,a.options.exporting,b);t(c,!0)&&a.redraw()}};g.addUpdate(function(b,c){a.isDirtyExporting=!0;r(!0,a.options.navigation,
b);t(c,!0)&&a.redraw()},a)});B.prototype.callbacks.push(function(a){a.renderExporting();l(a,"redraw",a.renderExporting)})});n(g,"masters/modules/exporting.src.js",[],function(){})});
//# sourceMappingURL=exporting.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highstock JS v8.1.0 (2020-05-05)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(S,P){"object"===typeof module&&module.exports?(P["default"]=P,module.exports=S.document?P(S):P): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return P(S)}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(S.Highcharts&&S.Highcharts.error(16,!0),S.Highcharts=P(S))})("undefined"!==typeof window?window:this,function(S){function P(k,g,H,v){k.hasOwnProperty(g)||(k[g]=v.apply(null,H))}var A={};P(A,"parts/Globals.js",[],function(){var k="undefined"!==typeof S?S:"undefined"!==typeof window?window:{},g=k.document,
H=k.navigator&&k.navigator.userAgent||"",v=g&&g.createElementNS&&!!g.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,K=/(edge|msie|trident)/i.test(H)&&!k.opera,G=-1!==H.indexOf("Firefox"),N=-1!==H.indexOf("Chrome"),M=G&&4>parseInt(H.split("Firefox/")[1],10);return{product:"Highcharts",version:"8.1.0",deg2rad:2*Math.PI/360,doc:g,hasBidiBug:M,hasTouch:!!k.TouchEvent,isMS:K,isWebKit:-1!==H.indexOf("AppleWebKit"),isFirefox:G,isChrome:N,isSafari:!N&&-1!==H.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(H),
SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:v,win:k,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});P(A,"parts/Utilities.js",[A["parts/Globals.js"]],function(k){function g(){var b,d=arguments,n={},x=function(b,d){"object"!==typeof b&&(b={});T(d,function(n,a){!H(n,!0)||q(n)||t(n)?b[a]=d[a]:b[a]=x(b[a]||{},n)});return b};!0===d[0]&&(n=d[1],d=Array.prototype.slice.call(d,2));var a=d.length;for(b=0;b<
a;b++)n=x(n,d[b]);return n}function H(b,d){return!!b&&"object"===typeof b&&(!d||!z(b))}function v(b,d,n){var x;D(d)?f(n)?b.setAttribute(d,n):b&&b.getAttribute&&((x=b.getAttribute(d))||"class"!==d||(x=b.getAttribute(d+"Name"))):T(d,function(d,n){b.setAttribute(n,d)});return x}function K(){for(var b=arguments,d=b.length,n=0;n<d;n++){var x=b[n];if("undefined"!==typeof x&&null!==x)return x}}function G(b,d){if(!b)return d;var n=b.split(".").reverse();if(1===n.length)return d[b];for(b=n.pop();"undefined"!==
typeof b&&"undefined"!==typeof d&&null!==d;)d=d[b],b=n.pop();return d}k.timers=[];var N=k.charts,M=k.doc,y=k.win,I=k.error=function(b,d,n,x){var a=r(b),c=a?"Highcharts error #"+b+": www.highcharts.com/errors/"+b+"/":b.toString(),e=function(){if(d)throw Error(c);y.console&&console.log(c)};if("undefined"!==typeof x){var f="";a&&(c+="?");T(x,function(b,d){f+="\n"+d+": "+b;a&&(c+=encodeURI(d)+"="+encodeURI(b))});c+=f}n?Z(n,"displayError",{code:b,message:c,params:x},e):e()},J=function(){function b(b,d,
n){this.options=d;this.elem=b;this.prop=n}b.prototype.dSetter=function(){var b=this.paths,d=b&&b[0];b=b&&b[1];var n=[],x=this.now||0;if(1!==x&&d&&b)if(d.length===b.length&&1>x)for(var a=0;a<b.length;a++){for(var c=d[a],e=b[a],f=[],m=0;m<e.length;m++){var u=c[m],p=e[m];f[m]="number"===typeof u&&"number"===typeof p&&("A"!==e[0]||4!==m&&5!==m)?u+x*(p-u):p}n.push(f)}else n=b;else n=this.toD||[];this.elem.attr("d",n,void 0,!0)};b.prototype.update=function(){var b=this.elem,d=this.prop,n=this.now,x=this.options.step;
if(this[d+"Setter"])this[d+"Setter"]();else b.attr?b.element&&b.attr(d,n,null,!0):b.style[d]=n+this.unit;x&&x.call(b,n,this)};b.prototype.run=function(b,d,n){var x=this,a=x.options,c=function(b){return c.stopped?!1:x.step(b)},e=y.requestAnimationFrame||function(b){setTimeout(b,13)},f=function(){for(var b=0;b<k.timers.length;b++)k.timers[b]()||k.timers.splice(b--,1);k.timers.length&&e(f)};b!==d||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=b,this.end=d,this.unit=n,this.now=
this.start,this.pos=0,c.elem=this.elem,c.prop=this.prop,c()&&1===k.timers.push(c)&&e(f)):(delete a.curAnim[this.prop],a.complete&&0===Object.keys(a.curAnim).length&&a.complete.call(this.elem))};b.prototype.step=function(b){var d=+new Date,n=this.options,x=this.elem,a=n.complete,c=n.duration,e=n.curAnim;if(x.attr&&!x.element)b=!1;else if(b||d>=c+this.startTime){this.now=this.end;this.pos=1;this.update();var f=e[this.prop]=!0;T(e,function(b){!0!==b&&(f=!1)});f&&a&&a.call(x);b=!1}else this.pos=n.easing((d-
this.startTime)/c),this.now=this.start+(this.end-this.start)*this.pos,this.update(),b=!0;return b};b.prototype.initPath=function(b,d,n){function x(b,d){for(;b.length<h;){var n=b[0],x=d[h-b.length];x&&"M"===n[0]&&(b[0]="C"===x[0]?["C",n[1],n[2],n[1],n[2],n[1],n[2]]:["L",n[1],n[2]]);b.unshift(n);f&&b.push(b[b.length-1])}}function a(b,d){for(;b.length<h;)if(d=b[b.length/m-1].slice(),"C"===d[0]&&(d[1]=d[5],d[2]=d[6]),f){var n=b[b.length/m].slice();b.splice(b.length/2,0,d,n)}else b.push(d)}var c=b.startX,
e=b.endX;d=d&&d.slice();n=n.slice();var f=b.isArea,m=f?2:1;if(!d)return[n,n];if(c&&e){for(b=0;b<c.length;b++)if(c[b]===e[0]){var u=b;break}else if(c[0]===e[e.length-c.length+b]){u=b;var p=!0;break}else if(c[c.length-1]===e[e.length-c.length+b]){u=c.length-b;break}"undefined"===typeof u&&(d=[])}if(d.length&&r(u)){var h=n.length+u*m;p?(x(d,n),a(n,d)):(x(n,d),a(d,n))}return[d,n]};b.prototype.fillSetter=function(){b.prototype.strokeSetter.apply(this,arguments)};b.prototype.strokeSetter=function(){this.elem.attr(this.prop,
k.color(this.start).tweenTo(k.color(this.end),this.pos),null,!0)};return b}();k.Fx=J;k.merge=g;var E=k.pInt=function(b,d){return parseInt(b,d||10)},D=k.isString=function(b){return"string"===typeof b},z=k.isArray=function(b){b=Object.prototype.toString.call(b);return"[object Array]"===b||"[object Array Iterator]"===b};k.isObject=H;var t=k.isDOMElement=function(b){return H(b)&&"number"===typeof b.nodeType},q=k.isClass=function(b){var d=b&&b.constructor;return!(!H(b,!0)||t(b)||!d||!d.name||"Object"===
d.name)},r=k.isNumber=function(b){return"number"===typeof b&&!isNaN(b)&&Infinity>b&&-Infinity<b},h=k.erase=function(b,d){for(var n=b.length;n--;)if(b[n]===d){b.splice(n,1);break}},f=k.defined=function(b){return"undefined"!==typeof b&&null!==b};k.attr=v;var a=k.splat=function(b){return z(b)?b:[b]},l=k.syncTimeout=function(b,d,n){if(0<d)return setTimeout(b,d,n);b.call(0,n);return-1},e=k.clearTimeout=function(b){f(b)&&clearTimeout(b)},c=k.extend=function(b,d){var n;b||(b={});for(n in d)b[n]=d[n];return b};
k.pick=K;var m=k.css=function(b,d){k.isMS&&!k.svg&&d&&"undefined"!==typeof d.opacity&&(d.filter="alpha(opacity="+100*d.opacity+")");c(b.style,d)},u=k.createElement=function(b,d,n,x,a){b=M.createElement(b);d&&c(b,d);a&&m(b,{padding:"0",border:"none",margin:"0"});n&&m(b,n);x&&x.appendChild(b);return b},L=k.extendClass=function(b,d){var n=function(){};n.prototype=new b;c(n.prototype,d);return n},F=k.pad=function(b,d,n){return Array((d||2)+1-String(b).replace("-","").length).join(n||"0")+b},w=k.relativeLength=
function(b,d,n){return/%$/.test(b)?d*parseFloat(b)/100+(n||0):parseFloat(b)},p=k.wrap=function(b,d,n){var x=b[d];b[d]=function(){var b=Array.prototype.slice.call(arguments),d=arguments,a=this;a.proceed=function(){x.apply(a,arguments.length?arguments:d)};b.unshift(x);b=n.apply(this,b);a.proceed=null;return b}},C=k.format=function(b,d,n){var x="{",a=!1,c=[],e=/f$/,f=/\.([0-9])/,m=k.defaultOptions.lang,u=n&&n.time||k.time;for(n=n&&n.numberFormatter||W;b;){var p=b.indexOf(x);if(-1===p)break;var h=b.slice(0,
p);if(a){h=h.split(":");x=G(h.shift()||"",d);if(h.length&&"number"===typeof x)if(h=h.join(":"),e.test(h)){var Q=parseInt((h.match(f)||["","-1"])[1],10);null!==x&&(x=n(x,Q,m.decimalPoint,-1<h.indexOf(",")?m.thousandsSep:""))}else x=u.dateFormat(h,x);c.push(x)}else c.push(h);b=b.slice(p+1);x=(a=!a)?"}":"{"}c.push(b);return c.join("")},O=k.getMagnitude=function(b){return Math.pow(10,Math.floor(Math.log(b)/Math.LN10))},B=k.normalizeTickInterval=function(b,d,n,x,a){var c=b;n=K(n,1);var e=b/n;d||(d=a?[1,
1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===x&&(1===n?d=d.filter(function(b){return 0===b%1}):.1>=n&&(d=[1/n])));for(x=0;x<d.length&&!(c=d[x],a&&c*n>=b||!a&&e<=(d[x]+(d[x+1]||d[x]))/2);x++);return c=R(c*n,-Math.round(Math.log(.001)/Math.LN10))},d=k.stableSort=function(b,d){var n=b.length,x,a;for(a=0;a<n;a++)b[a].safeI=a;b.sort(function(b,n){x=d(b,n);return 0===x?b.safeI-n.safeI:x});for(a=0;a<n;a++)delete b[a].safeI},b=k.arrayMin=function(b){for(var d=b.length,n=b[0];d--;)b[d]<n&&(n=b[d]);return n},
n=k.arrayMax=function(b){for(var d=b.length,n=b[0];d--;)b[d]>n&&(n=b[d]);return n},x=k.destroyObjectProperties=function(b,d){T(b,function(n,x){n&&n!==d&&n.destroy&&n.destroy();delete b[x]})},Q=k.discardElement=function(b){var d=k.garbageBin;d||(d=u("div"));b&&d.appendChild(b);d.innerHTML=""},R=k.correctFloat=function(b,d){return parseFloat(b.toPrecision(d||14))},X=k.setAnimation=function(b,d){d.renderer.globalAnimation=K(b,d.options.chart.animation,!0)},U=k.animObject=function(b){return H(b)?g(b):
{duration:b?500:0}},V=k.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5},W=k.numberFormat=function(b,d,n,x){b=+b||0;d=+d;var a=k.defaultOptions.lang,c=(b.toString().split(".")[1]||"").split("e")[0].length,e=b.toString().split("e");if(-1===d)d=Math.min(c,20);else if(!r(d))d=2;else if(d&&e[1]&&0>e[1]){var f=d+ +e[1];0<=f?(e[0]=(+e[0]).toExponential(f).split("e")[0],d=f):(e[0]=e[0].split(".")[0]||0,b=20>d?(e[0]*Math.pow(10,e[1])).toFixed(d):
0,e[1]=0)}var m=(Math.abs(e[1]?e[0]:b)+Math.pow(10,-Math.max(d,c)-1)).toFixed(d);c=String(E(m));f=3<c.length?c.length%3:0;n=K(n,a.decimalPoint);x=K(x,a.thousandsSep);b=(0>b?"-":"")+(f?c.substr(0,f)+x:"");b+=c.substr(f).replace(/(\d{3})(?=\d)/g,"$1"+x);d&&(b+=n+m.slice(-d));e[1]&&0!==+b&&(b+="e"+e[1]);return b};Math.easeInOutSine=function(b){return-.5*(Math.cos(Math.PI*b)-1)};var aa=k.getStyle=function(b,d,n){if("width"===d)return d=Math.min(b.offsetWidth,b.scrollWidth),n=b.getBoundingClientRect&&
b.getBoundingClientRect().width,n<d&&n>=d-1&&(d=Math.floor(n)),Math.max(0,d-k.getStyle(b,"padding-left")-k.getStyle(b,"padding-right"));if("height"===d)return Math.max(0,Math.min(b.offsetHeight,b.scrollHeight)-k.getStyle(b,"padding-top")-k.getStyle(b,"padding-bottom"));y.getComputedStyle||I(27,!0);if(b=y.getComputedStyle(b,void 0))b=b.getPropertyValue(d),K(n,"opacity"!==d)&&(b=E(b));return b},Y=k.inArray=function(b,d,n){return d.indexOf(b,n)},fa=k.find=Array.prototype.find?function(b,d){return b.find(d)}:
function(b,d){var n,x=b.length;for(n=0;n<x;n++)if(d(b[n],n))return b[n]};k.keys=Object.keys;var ba=k.offset=function(b){var d=M.documentElement;b=b.parentElement||b.parentNode?b.getBoundingClientRect():{top:0,left:0};return{top:b.top+(y.pageYOffset||d.scrollTop)-(d.clientTop||0),left:b.left+(y.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}},ca=k.stop=function(b,d){for(var n=k.timers.length;n--;)k.timers[n].elem!==b||d&&d!==k.timers[n].prop||(k.timers[n].stopped=!0)},T=k.objectEach=function(b,d,n){for(var x in b)Object.hasOwnProperty.call(b,
x)&&d.call(n||b[x],b[x],x,b)};T({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(b,d){k[d]=function(d){return Array.prototype[b].apply(d,[].slice.call(arguments,1))}});var ha=k.addEvent=function(b,d,n,x){void 0===x&&(x={});var a=b.addEventListener||k.addEventListenerPolyfill;var c="function"===typeof b&&b.prototype?b.prototype.protoEvents=b.prototype.protoEvents||{}:b.hcEvents=b.hcEvents||{};k.Point&&b instanceof k.Point&&b.series&&b.series.chart&&(b.series.chart.runTrackerClick=
!0);a&&a.call(b,d,n,!1);c[d]||(c[d]=[]);c[d].push({fn:n,order:"number"===typeof x.order?x.order:Infinity});c[d].sort(function(b,d){return b.order-d.order});return function(){A(b,d,n)}},A=k.removeEvent=function(b,d,n){function x(d,n){var x=b.removeEventListener||k.removeEventListenerPolyfill;x&&x.call(b,d,n,!1)}function a(n){var a;if(b.nodeName){if(d){var c={};c[d]=!0}else c=n;T(c,function(b,d){if(n[d])for(a=n[d].length;a--;)x(d,n[d][a].fn)})}}var c;["protoEvents","hcEvents"].forEach(function(e,f){var m=
(f=f?b:b.prototype)&&f[e];m&&(d?(c=m[d]||[],n?(m[d]=c.filter(function(b){return n!==b.fn}),x(d,n)):(a(m),m[d]=[])):(a(m),f[e]={}))})},Z=k.fireEvent=function(b,d,n,x){var a;n=n||{};if(M.createEvent&&(b.dispatchEvent||b.fireEvent)){var e=M.createEvent("Events");e.initEvent(d,!0,!0);c(e,n);b.dispatchEvent?b.dispatchEvent(e):b.fireEvent(d,e)}else n.target||c(n,{preventDefault:function(){n.defaultPrevented=!0},target:b,type:d}),function(d,x){void 0===d&&(d=[]);void 0===x&&(x=[]);var c=0,e=0,f=d.length+
x.length;for(a=0;a<f;a++)!1===(d[c]?x[e]?d[c].order<=x[e].order?d[c++]:x[e++]:d[c++]:x[e++]).fn.call(b,n)&&n.preventDefault()}(b.protoEvents&&b.protoEvents[d],b.hcEvents&&b.hcEvents[d]);x&&!n.defaultPrevented&&x.call(b,n)},ia=k.animate=function(b,d,n){var x,a="",c,e;if(!H(n)){var f=arguments;n={duration:f[2],easing:f[3],complete:f[4]}}r(n.duration)||(n.duration=400);n.easing="function"===typeof n.easing?n.easing:Math[n.easing]||Math.easeInOutSine;n.curAnim=g(d);T(d,function(f,m){ca(b,m);e=new J(b,
n,m);c=null;"d"===m&&z(d.d)?(e.paths=e.initPath(b,b.pathArray,d.d),e.toD=d.d,x=0,c=1):b.attr?x=b.attr(m):(x=parseFloat(aa(b,m))||0,"opacity"!==m&&(a="px"));c||(c=f);c&&c.match&&c.match("px")&&(c=c.replace(/px/g,""));e.run(x,c,a)})},ja=k.seriesType=function(b,d,n,x,a){var c=k.getOptions(),e=k.seriesTypes;c.plotOptions[b]=g(c.plotOptions[d],n);e[b]=L(e[d]||function(){},x);e[b].prototype.type=b;a&&(e[b].prototype.pointClass=L(k.Point,a));return e[b]},ea=k.uniqueKey=function(){var b=Math.random().toString(36).substring(2,
9),d=0;return function(){return"highcharts-"+b+"-"+d++}}(),P=k.isFunction=function(b){return"function"===typeof b};y.jQuery&&(y.jQuery.fn.highcharts=function(){var b=[].slice.call(arguments);if(this[0])return b[0]?(new (k[D(b[0])?b.shift():"Chart"])(this[0],b[0],b[1]),this):N[v(this[0],"data-highcharts-chart")]});return{Fx:k.Fx,addEvent:ha,animate:ia,animObject:U,arrayMax:n,arrayMin:b,attr:v,clamp:function(b,d,n){return b>d?b<n?b:n:d},clearTimeout:e,correctFloat:R,createElement:u,css:m,defined:f,
destroyObjectProperties:x,discardElement:Q,erase:h,error:I,extend:c,extendClass:L,find:fa,fireEvent:Z,format:C,getMagnitude:O,getNestedProperty:G,getStyle:aa,inArray:Y,isArray:z,isClass:q,isDOMElement:t,isFunction:P,isNumber:r,isObject:H,isString:D,merge:g,normalizeTickInterval:B,numberFormat:W,objectEach:T,offset:ba,pad:F,pick:K,pInt:E,relativeLength:w,removeEvent:A,seriesType:ja,setAnimation:X,splat:a,stableSort:d,stop:ca,syncTimeout:l,timeUnits:V,uniqueKey:ea,wrap:p}});P(A,"parts/Color.js",[A["parts/Globals.js"],
A["parts/Utilities.js"]],function(k,g){var H=g.isNumber,v=g.merge,K=g.pInt;g=function(){function g(k){this.parsers=[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(g){return[K(g[1]),K(g[2]),K(g[3]),parseFloat(g[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(g){return[K(g[1]),K(g[2]),K(g[3]),1]}}];this.rgba=[];if(!(this instanceof g))return new g(k);this.init(k)}g.parse=function(k){return new g(k)};
g.prototype.init=function(k){var v,y;if((this.input=k=g.names[k&&k.toLowerCase?k.toLowerCase():""]||k)&&k.stops)this.stops=k.stops.map(function(y){return new g(y[1])});else{if(k&&k.charAt&&"#"===k.charAt()){var I=k.length;k=parseInt(k.substr(1),16);7===I?v=[(k&16711680)>>16,(k&65280)>>8,k&255,1]:4===I&&(v=[(k&3840)>>4|(k&3840)>>8,(k&240)>>4|k&240,(k&15)<<4|k&15,1])}if(!v)for(y=this.parsers.length;y--&&!v;){var J=this.parsers[y];(I=J.regex.exec(k))&&(v=J.parse(I))}}this.rgba=v||[]};g.prototype.get=
function(k){var g=this.input,y=this.rgba;if("undefined"!==typeof this.stops){var I=v(g);I.stops=[].concat(I.stops);this.stops.forEach(function(y,g){I.stops[g]=[I.stops[g][0],y.get(k)]})}else I=y&&H(y[0])?"rgb"===k||!k&&1===y[3]?"rgb("+y[0]+","+y[1]+","+y[2]+")":"a"===k?y[3]:"rgba("+y.join(",")+")":g;return I};g.prototype.brighten=function(k){var g,y=this.rgba;if(this.stops)this.stops.forEach(function(y){y.brighten(k)});else if(H(k)&&0!==k)for(g=0;3>g;g++)y[g]+=K(255*k),0>y[g]&&(y[g]=0),255<y[g]&&
(y[g]=255);return this};g.prototype.setOpacity=function(g){this.rgba[3]=g;return this};g.prototype.tweenTo=function(g,k){var y=this.rgba,v=g.rgba;v.length&&y&&y.length?(g=1!==v[3]||1!==y[3],k=(g?"rgba(":"rgb(")+Math.round(v[0]+(y[0]-v[0])*(1-k))+","+Math.round(v[1]+(y[1]-v[1])*(1-k))+","+Math.round(v[2]+(y[2]-v[2])*(1-k))+(g?","+(v[3]+(y[3]-v[3])*(1-k)):"")+")"):k=g.input||"none";return k};g.names={white:"#ffffff",black:"#000000"};return g}();k.Color=g;k.color=g.parse;return k.Color});P(A,"parts/SVGElement.js",
[A["parts/Color.js"],A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g,H){var v=g.deg2rad,K=g.doc,G=g.hasTouch,N=g.isFirefox,M=g.noop,y=g.svg,I=g.SVG_NS,J=g.win,E=H.animate,D=H.animObject,z=H.attr,t=H.createElement,q=H.css,r=H.defined,h=H.erase,f=H.extend,a=H.fireEvent,l=H.inArray,e=H.isArray,c=H.isFunction,m=H.isNumber,u=H.isString,L=H.merge,F=H.objectEach,w=H.pick,p=H.pInt,C=H.stop,O=H.uniqueKey;H=function(){function B(){this.height=this.element=void 0;this.opacity=1;this.renderer=void 0;
this.SVG_NS=I;this.symbolCustomAttribs="x y width height r start end innerR anchorX anchorY rounded".split(" ");this.textProps="color cursor direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" ");this.width=void 0}B.prototype._defaultGetter=function(d){d=w(this[d+"Value"],this[d],this.element?this.element.getAttribute(d):null,0);/^[\-0-9\.]+$/.test(d)&&(d=parseFloat(d));return d};B.prototype._defaultSetter=function(d,b,n){n.setAttribute(b,
d)};B.prototype.add=function(d){var b=this.renderer,n=this.element;d&&(this.parentGroup=d);this.parentInverted=d&&d.inverted;"undefined"!==typeof this.textStr&&b.buildText(this);this.added=!0;if(!d||d.handleZ||this.zIndex)var x=this.zIndexSetter();x||(d?d.element:b.box).appendChild(n);if(this.onAdd)this.onAdd();return this};B.prototype.addClass=function(d,b){var n=b?"":this.attr("class")||"";d=(d||"").split(/ /g).reduce(function(b,d){-1===n.indexOf(d)&&b.push(d);return b},n?[n]:[]).join(" ");d!==
n&&this.attr("class",d);return this};B.prototype.afterSetters=function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)};B.prototype.align=function(d,b,n){var x,a={};var c=this.renderer;var e=c.alignedObjects;var f,m;if(d){if(this.alignOptions=d,this.alignByTranslate=b,!n||u(n))this.alignTo=x=n||"renderer",h(e,this),e.push(this),n=void 0}else d=this.alignOptions,b=this.alignByTranslate,x=this.alignTo;n=w(n,c[x],c);x=d.align;c=d.verticalAlign;e=(n.x||0)+(d.x||0);var p=(n.y||0)+(d.y||
0);"right"===x?f=1:"center"===x&&(f=2);f&&(e+=(n.width-(d.width||0))/f);a[b?"translateX":"x"]=Math.round(e);"bottom"===c?m=1:"middle"===c&&(m=2);m&&(p+=(n.height-(d.height||0))/m);a[b?"translateY":"y"]=Math.round(p);this[this.placed?"animate":"attr"](a);this.placed=!0;this.alignAttr=a;return this};B.prototype.alignSetter=function(d){var b={left:"start",center:"middle",right:"end"};b[d]&&(this.alignValue=d,this.element.setAttribute("text-anchor",b[d]))};B.prototype.animate=function(d,b,n){var x=D(w(b,
this.renderer.globalAnimation,!0));w(K.hidden,K.msHidden,K.webkitHidden,!1)&&(x.duration=0);0!==x.duration?(n&&(x.complete=n),E(this,d,x)):(this.attr(d,void 0,n),F(d,function(b,d){x.step&&x.step.call(this,b,{prop:d,pos:1})},this));return this};B.prototype.applyTextOutline=function(d){var b=this.element,n;-1!==d.indexOf("contrast")&&(d=d.replace(/contrast/g,this.renderer.getContrast(b.style.fill)));d=d.split(" ");var x=d[d.length-1];if((n=d[0])&&"none"!==n&&g.svg){this.fakeTS=!0;d=[].slice.call(b.getElementsByTagName("tspan"));
this.ySetter=this.xSetter;n=n.replace(/(^[\d\.]+)(.*?)$/g,function(b,d,n){return 2*d+n});this.removeTextOutline(d);var a=b.textContent?/^[\u0591-\u065F\u066A-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(b.textContent):!1;var c=b.firstChild;d.forEach(function(d,e){0===e&&(d.setAttribute("x",b.getAttribute("x")),e=b.getAttribute("y"),d.setAttribute("y",e||0),null===e&&b.setAttribute("y",0));e=d.cloneNode(!0);z(a&&!N?d:e,{"class":"highcharts-text-outline",fill:x,stroke:x,"stroke-width":n,"stroke-linejoin":"round"});
b.insertBefore(e,c)});a&&N&&d[0]&&(d=d[0].cloneNode(!0),d.textContent=" ",b.insertBefore(d,c))}};B.prototype.attr=function(d,b,n,x){var a=this.element,c,e=this,f,m,u=this.symbolCustomAttribs;if("string"===typeof d&&"undefined"!==typeof b){var p=d;d={};d[p]=b}"string"===typeof d?e=(this[d+"Getter"]||this._defaultGetter).call(this,d,a):(F(d,function(b,n){f=!1;x||C(this,n);this.symbolName&&-1!==l(n,u)&&(c||(this.symbolAttr(d),c=!0),f=!0);!this.rotation||"x"!==n&&"y"!==n||(this.doTransform=!0);f||(m=
this[n+"Setter"]||this._defaultSetter,m.call(this,b,n,a),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(n)&&this.updateShadows(n,b,m))},this),this.afterSetters());n&&n.call(this);return e};B.prototype.clip=function(d){return this.attr("clip-path",d?"url("+this.renderer.url+"#"+d.id+")":"none")};B.prototype.crisp=function(d,b){b=b||d.strokeWidth||0;var n=Math.round(b)%2/2;d.x=Math.floor(d.x||this.x||0)+n;d.y=Math.floor(d.y||this.y||0)+n;d.width=Math.floor((d.width||
this.width||0)-2*n);d.height=Math.floor((d.height||this.height||0)-2*n);r(d.strokeWidth)&&(d.strokeWidth=b);return d};B.prototype.complexColor=function(d,b,n){var x=this.renderer,c,f,m,u,p,h,w,l,C,B,t=[],q;a(this.renderer,"complexColor",{args:arguments},function(){d.radialGradient?f="radialGradient":d.linearGradient&&(f="linearGradient");if(f){m=d[f];p=x.gradients;h=d.stops;C=n.radialReference;e(m)&&(d[f]=m={x1:m[0],y1:m[1],x2:m[2],y2:m[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===f&&C&&
!r(m.gradientUnits)&&(u=m,m=L(m,x.getRadialAttr(C,u),{gradientUnits:"userSpaceOnUse"}));F(m,function(b,d){"id"!==d&&t.push(d,b)});F(h,function(b){t.push(b)});t=t.join(",");if(p[t])B=p[t].attr("id");else{m.id=B=O();var a=p[t]=x.createElement(f).attr(m).add(x.defs);a.radAttr=u;a.stops=[];h.forEach(function(b){0===b[1].indexOf("rgba")?(c=k.parse(b[1]),w=c.get("rgb"),l=c.get("a")):(w=b[1],l=1);b=x.createElement("stop").attr({offset:b[0],"stop-color":w,"stop-opacity":l}).add(a);a.stops.push(b)})}q="url("+
x.url+"#"+B+")";n.setAttribute(b,q);n.gradient=t;d.toString=function(){return q}}})};B.prototype.css=function(d){var b=this.styles,n={},x=this.element,a="",c=!b,e=["textOutline","textOverflow","width"];d&&d.color&&(d.fill=d.color);b&&F(d,function(d,x){b&&b[x]!==d&&(n[x]=d,c=!0)});if(c){b&&(d=f(b,n));if(d)if(null===d.width||"auto"===d.width)delete this.textWidth;else if("text"===x.nodeName.toLowerCase()&&d.width)var m=this.textWidth=p(d.width);this.styles=d;m&&!y&&this.renderer.forExport&&delete d.width;
if(x.namespaceURI===this.SVG_NS){var u=function(b,d){return"-"+d.toLowerCase()};F(d,function(b,d){-1===e.indexOf(d)&&(a+=d.replace(/([A-Z])/g,u)+":"+b+";")});a&&z(x,"style",a)}else q(x,d);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),d&&d.textOutline&&this.applyTextOutline(d.textOutline))}return this};B.prototype.dashstyleSetter=function(d){var b=this["stroke-width"];"inherit"===b&&(b=1);if(d=d&&d.toLowerCase()){var n=d.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot",
"3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(d=n.length;d--;)n[d]=""+p(n[d])*w(b,NaN);d=n.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",d)}};B.prototype.destroy=function(){var d=this,b=d.element||{},n=d.renderer,x=n.isSVG&&"SPAN"===b.nodeName&&d.parentGroup||void 0,a=b.ownerSVGElement;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=
null;C(d);if(d.clipPath&&a){var c=d.clipPath;[].forEach.call(a.querySelectorAll("[clip-path],[CLIP-PATH]"),function(b){-1<b.getAttribute("clip-path").indexOf(c.element.id)&&b.removeAttribute("clip-path")});d.clipPath=c.destroy()}if(d.stops){for(a=0;a<d.stops.length;a++)d.stops[a].destroy();d.stops.length=0;d.stops=void 0}d.safeRemoveChild(b);for(n.styledMode||d.destroyShadows();x&&x.div&&0===x.div.childNodes.length;)b=x.parentGroup,d.safeRemoveChild(x.div),delete x.div,x=b;d.alignTo&&h(n.alignedObjects,
d);F(d,function(b,n){d[n]&&d[n].parentGroup===d&&d[n].destroy&&d[n].destroy();delete d[n]})};B.prototype.destroyShadows=function(){(this.shadows||[]).forEach(function(d){this.safeRemoveChild(d)},this);this.shadows=void 0};B.prototype.destroyTextPath=function(d,b){var n=d.getElementsByTagName("text")[0];if(n){if(n.removeAttribute("dx"),n.removeAttribute("dy"),b.element.setAttribute("id",""),this.textPathWrapper&&n.getElementsByTagName("textPath").length){for(d=this.textPathWrapper.element.childNodes;d.length;)n.appendChild(d[0]);
n.removeChild(this.textPathWrapper.element)}}else if(d.getAttribute("dx")||d.getAttribute("dy"))d.removeAttribute("dx"),d.removeAttribute("dy");this.textPathWrapper&&(this.textPathWrapper=this.textPathWrapper.destroy())};B.prototype.dSetter=function(d,b,n){e(d)&&("string"===typeof d[0]&&(d=this.renderer.pathToSegments(d)),this.pathArray=d,d=d.reduce(function(b,d,n){return d&&d.join?(n?b+" ":"")+d.join(" "):(d||"").toString()},""));/(NaN| {2}|^$)/.test(d)&&(d="M 0 0");this[b]!==d&&(n.setAttribute(b,
d),this[b]=d)};B.prototype.fadeOut=function(d){var b=this;b.animate({opacity:0},{duration:w(d,150),complete:function(){b.attr({y:-9999}).hide()}})};B.prototype.fillSetter=function(d,b,n){"string"===typeof d?n.setAttribute(b,d):d&&this.complexColor(d,b,n)};B.prototype.getBBox=function(d,b){var n,x=this.renderer,a=this.element,e=this.styles,m=this.textStr,u=x.cache,p=x.cacheKeys,h=a.namespaceURI===this.SVG_NS;b=w(b,this.rotation,0);var l=x.styledMode?a&&B.prototype.getStyle.call(a,"font-size"):e&&e.fontSize;
if(r(m)){var C=m.toString();-1===C.indexOf("<")&&(C=C.replace(/[0-9]/g,"0"));C+=["",b,l,this.textWidth,e&&e.textOverflow,e&&e.fontWeight].join()}C&&!d&&(n=u[C]);if(!n){if(h||x.forExport){try{var F=this.fakeTS&&function(b){[].forEach.call(a.querySelectorAll(".highcharts-text-outline"),function(d){d.style.display=b})};c(F)&&F("none");n=a.getBBox?f({},a.getBBox()):{width:a.offsetWidth,height:a.offsetHeight};c(F)&&F("")}catch(ba){""}if(!n||0>n.width)n={width:0,height:0}}else n=this.htmlGetBBox();x.isSVG&&
(d=n.width,x=n.height,h&&(n.height=x={"11px,17":14,"13px,20":16}[e&&e.fontSize+","+Math.round(x)]||x),b&&(e=b*v,n.width=Math.abs(x*Math.sin(e))+Math.abs(d*Math.cos(e)),n.height=Math.abs(x*Math.cos(e))+Math.abs(d*Math.sin(e))));if(C&&0<n.height){for(;250<p.length;)delete u[p.shift()];u[C]||p.push(C);u[C]=n}}return n};B.prototype.getStyle=function(d){return J.getComputedStyle(this.element||this,"").getPropertyValue(d)};B.prototype.hasClass=function(d){return-1!==(""+this.attr("class")).split(" ").indexOf(d)};
B.prototype.hide=function(d){d?this.attr({y:-9999}):this.attr({visibility:"hidden"});return this};B.prototype.htmlGetBBox=function(){return{height:0,width:0,x:0,y:0}};B.prototype.init=function(d,b){this.element="span"===b?t(b):K.createElementNS(this.SVG_NS,b);this.renderer=d;a(this,"afterInit")};B.prototype.invert=function(d){this.inverted=d;this.updateTransform();return this};B.prototype.on=function(d,b){var n,x,a=this.element,c;G&&"click"===d?(a.ontouchstart=function(b){n=b.touches[0].clientX;x=
b.touches[0].clientY},a.ontouchend=function(d){n&&4<=Math.sqrt(Math.pow(n-d.changedTouches[0].clientX,2)+Math.pow(x-d.changedTouches[0].clientY,2))||b.call(a,d);c=!0;d.preventDefault()},a.onclick=function(d){c||b.call(a,d)}):a["on"+d]=b;return this};B.prototype.opacitySetter=function(d,b,n){this[b]=d;n.setAttribute(b,d)};B.prototype.removeClass=function(d){return this.attr("class",(""+this.attr("class")).replace(u(d)?new RegExp(" ?"+d+" ?"):d,""))};B.prototype.removeTextOutline=function(d){for(var b=
d.length,n;b--;)n=d[b],"highcharts-text-outline"===n.getAttribute("class")&&h(d,this.element.removeChild(n))};B.prototype.safeRemoveChild=function(d){var b=d.parentNode;b&&b.removeChild(d)};B.prototype.setRadialReference=function(d){var b=this.element.gradient&&this.renderer.gradients[this.element.gradient];this.element.radialReference=d;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(d,b.radAttr));return this};B.prototype.setTextPath=function(d,b){var n=this.element,x={textAnchor:"text-anchor"},
a=!1,c=this.textPathWrapper,e=!c;b=L(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);var f=b.attributes;if(d&&b&&b.enabled){c&&null===c.element.parentNode?(e=!0,c=c.destroy()):c&&this.removeTextOutline.call(c.parentGroup,[].slice.call(n.getElementsByTagName("tspan")));this.options&&this.options.padding&&(f.dx=-this.options.padding);c||(this.textPathWrapper=c=this.renderer.createElement("textPath"),a=!0);var u=c.element;(b=d.element.getAttribute("id"))||d.element.setAttribute("id",
b=O());if(e)for(d=n.getElementsByTagName("tspan");d.length;)d[0].setAttribute("y",0),m(f.dx)&&d[0].setAttribute("x",-f.dx),u.appendChild(d[0]);a&&c&&c.add({element:this.text?this.text.element:n});u.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);r(f.dy)&&(u.parentNode.setAttribute("dy",f.dy),delete f.dy);r(f.dx)&&(u.parentNode.setAttribute("dx",f.dx),delete f.dx);F(f,function(b,d){u.setAttribute(x[d]||d,b)});n.removeAttribute("transform");this.removeTextOutline.call(c,
[].slice.call(n.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=this.updateTransform=M}else c&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(n,d),this.updateTransform(),this.options&&this.options.rotation&&this.applyTextOutline(this.options.style.textOutline));return this};B.prototype.shadow=function(d,b,n){var x=[],a=this.element,c=!1,e=this.oldShadowOptions;var m={color:"#000000",
offsetX:1,offsetY:1,opacity:.15,width:3};var u;!0===d?u=m:"object"===typeof d&&(u=f(m,d));u&&(u&&e&&F(u,function(b,d){b!==e[d]&&(c=!0)}),c&&this.destroyShadows(),this.oldShadowOptions=u);if(!u)this.destroyShadows();else if(!this.shadows){var p=u.opacity/u.width;var h=this.parentInverted?"translate(-1,-1)":"translate("+u.offsetX+", "+u.offsetY+")";for(m=1;m<=u.width;m++){var w=a.cloneNode(!1);var l=2*u.width+1-2*m;z(w,{stroke:d.color||"#000000","stroke-opacity":p*m,"stroke-width":l,transform:h,fill:"none"});
w.setAttribute("class",(w.getAttribute("class")||"")+" highcharts-shadow");n&&(z(w,"height",Math.max(z(w,"height")-l,0)),w.cutHeight=l);b?b.element.appendChild(w):a.parentNode&&a.parentNode.insertBefore(w,a);x.push(w)}this.shadows=x}return this};B.prototype.show=function(d){return this.attr({visibility:d?"inherit":"visible"})};B.prototype.strokeSetter=function(d,b,n){this[b]=d;this.stroke&&this["stroke-width"]?(B.prototype.fillSetter.call(this,this.stroke,"stroke",n),n.setAttribute("stroke-width",
this["stroke-width"]),this.hasStroke=!0):"stroke-width"===b&&0===d&&this.hasStroke?(n.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&(n.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};B.prototype.strokeWidth=function(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var d=this.getStyle("stroke-width"),b=0;if(d.indexOf("px")===d.length-2)b=p(d);else if(""!==d){var n=K.createElementNS(I,"rect");z(n,{width:d,"stroke-width":0});
this.element.parentNode.appendChild(n);b=n.getBBox().width;n.parentNode.removeChild(n)}return b};B.prototype.symbolAttr=function(d){var b=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(n){b[n]=w(d[n],b[n])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})};B.prototype.textSetter=function(d){d!==this.textStr&&(delete this.textPxLength,this.textStr=d,this.added&&this.renderer.buildText(this))};B.prototype.titleSetter=function(d){var b=
this.element.getElementsByTagName("title")[0];b||(b=K.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(K.createTextNode(String(w(d,"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")))};B.prototype.toFront=function(){var d=this.element;d.parentNode.appendChild(d);return this};B.prototype.translate=function(d,b){return this.attr({translateX:d,translateY:b})};B.prototype.updateShadows=function(d,b,n){var x=this.shadows;
if(x)for(var a=x.length;a--;)n.call(x[a],"height"===d?Math.max(b-(x[a].cutHeight||0),0):"d"===d?this.d:b,d,x[a])};B.prototype.updateTransform=function(){var d=this.translateX||0,b=this.translateY||0,n=this.scaleX,x=this.scaleY,a=this.inverted,c=this.rotation,e=this.matrix,f=this.element;a&&(d+=this.width,b+=this.height);d=["translate("+d+","+b+")"];r(e)&&d.push("matrix("+e.join(",")+")");a?d.push("rotate(90) scale(-1,1)"):c&&d.push("rotate("+c+" "+w(this.rotationOriginX,f.getAttribute("x"),0)+" "+
w(this.rotationOriginY,f.getAttribute("y")||0)+")");(r(n)||r(x))&&d.push("scale("+w(n,1)+" "+w(x,1)+")");d.length&&f.setAttribute("transform",d.join(" "))};B.prototype.visibilitySetter=function(d,b,n){"inherit"===d?n.removeAttribute(b):this[b]!==d&&n.setAttribute(b,d);this[b]=d};B.prototype.xGetter=function(d){"circle"===this.element.nodeName&&("x"===d?d="cx":"y"===d&&(d="cy"));return this._defaultGetter(d)};B.prototype.zIndexSetter=function(d,b){var n=this.renderer,x=this.parentGroup,a=(x||n).element||
n.box,c=this.element,e=!1;n=a===n.box;var f=this.added;var m;r(d)?(c.setAttribute("data-z-index",d),d=+d,this[b]===d&&(f=!1)):r(this[b])&&c.removeAttribute("data-z-index");this[b]=d;if(f){(d=this.zIndex)&&x&&(x.handleZ=!0);b=a.childNodes;for(m=b.length-1;0<=m&&!e;m--){x=b[m];f=x.getAttribute("data-z-index");var u=!r(f);if(x!==c)if(0>d&&u&&!n&&!m)a.insertBefore(c,b[m]),e=!0;else if(p(f)<=d||u&&(!r(d)||0<=d))a.insertBefore(c,b[m+1]||null),e=!0}e||(a.insertBefore(c,b[n?3:0]||null),e=!0)}return e};return B}();
H.prototype["stroke-widthSetter"]=H.prototype.strokeSetter;H.prototype.yGetter=H.prototype.xGetter;H.prototype.matrixSetter=H.prototype.rotationOriginXSetter=H.prototype.rotationOriginYSetter=H.prototype.rotationSetter=H.prototype.scaleXSetter=H.prototype.scaleYSetter=H.prototype.translateXSetter=H.prototype.translateYSetter=H.prototype.verticalAlignSetter=function(a,d){this[d]=a;this.doTransform=!0};g.SVGElement=H;return g.SVGElement});P(A,"parts/SvgRenderer.js",[A["parts/Color.js"],A["parts/Globals.js"],
A["parts/SVGElement.js"],A["parts/Utilities.js"]],function(k,g,H,v){var K=k.parse,G=v.addEvent,N=v.attr,M=v.createElement,y=v.css,I=v.defined,J=v.destroyObjectProperties,E=v.extend,D=v.isArray,z=v.isNumber,t=v.isObject,q=v.isString,r=v.merge,h=v.objectEach,f=v.pick,a=v.pInt,l=v.removeEvent,e=v.splat,c=v.uniqueKey,m=g.charts,u=g.deg2rad,L=g.doc,F=g.isFirefox,w=g.isMS,p=g.isWebKit;v=g.noop;var C=g.svg,O=g.SVG_NS,B=g.symbolSizes,d=g.win;k=g.SVGRenderer=function(){this.init.apply(this,arguments)};E(k.prototype,
{Element:H,SVG_NS:O,init:function(b,n,x,a,c,e,f){var m=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});f||m.css(this.getStyle(a));a=m.element;b.appendChild(a);N(b,"dir","ltr");-1===b.innerHTML.indexOf("xmlns")&&N(a,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=a;this.boxWrapper=m;this.alignedObjects=[];this.url=(F||p)&&L.getElementsByTagName("base").length?d.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(L.createTextNode("Created with Highcharts 8.1.0"));
this.defs=this.createElement("defs").add();this.allowHTML=e;this.forExport=c;this.styledMode=f;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(n,x,!1);var u;F&&b.getBoundingClientRect&&(n=function(){y(b,{left:0,top:0});u=b.getBoundingClientRect();y(b,{left:Math.ceil(u.left)-u.left+"px",top:Math.ceil(u.top)-u.top+"px"})},n(),this.unSubPixelFix=G(d,"resize",n))},definition:function(b){function d(b,n){var x;e(b).forEach(function(b){var c=a.createElement(b.tagName),e={};
h(b,function(b,d){"tagName"!==d&&"children"!==d&&"textContent"!==d&&(e[d]=b)});c.attr(e);c.add(n||a.defs);b.textContent&&c.element.appendChild(L.createTextNode(b.textContent));d(b.children||[],c);x=c});return x}var a=this;return d(b)},getStyle:function(b){return this.style=E({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},b)},setStyle:function(b){this.boxWrapper.css(this.getStyle(b))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var b=
this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();J(this.gradients||{});this.gradients=null;b&&(this.defs=b.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(b){var d=new this.Element;d.init(this,b);return d},draw:v,getRadialAttr:function(b,d){return{cx:b[0]-b[2]/2+d.cx*b[2],cy:b[1]-b[2]/2+d.cy*b[2],r:d.r*b[2]}},truncate:function(b,d,a,c,e,f,m){var n=this,x=b.rotation,u,p=c?1:0,h=(a||c).length,w=h,l=[],C=function(b){d.firstChild&&
d.removeChild(d.firstChild);b&&d.appendChild(L.createTextNode(b))},F=function(x,f){f=f||x;if("undefined"===typeof l[f])if(d.getSubStringLength)try{l[f]=e+d.getSubStringLength(0,c?f+1:f)}catch(ea){""}else n.getSpanWidth&&(C(m(a||c,x)),l[f]=e+n.getSpanWidth(b,d));return l[f]},Q;b.rotation=0;var R=F(d.textContent.length);if(Q=e+R>f){for(;p<=h;)w=Math.ceil((p+h)/2),c&&(u=m(c,w)),R=F(w,u&&u.length-1),p===h?p=h+1:R>f?h=w-1:p=w;0===h?C(""):a&&h===a.length-1||C(u||m(a||c,w))}c&&c.splice(0,w);b.actualWidth=
R;b.rotation=x;return Q},escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},buildText:function(b){var d=b.element,x=this,c=x.forExport,e=f(b.textStr,"").toString(),m=-1!==e.indexOf("<"),u=d.childNodes,p,w=N(d,"x"),l=b.styles,F=b.textWidth,B=l&&l.lineHeight,r=l&&l.textOutline,t=l&&"ellipsis"===l.textOverflow,q=l&&"nowrap"===l.whiteSpace,z=l&&l.fontSize,g,k=u.length;l=F&&!b.added&&this.box;var D=function(b){var n;x.styledMode||(n=/(px|em)$/.test(b&&b.style.fontSize)?b.style.fontSize:
z||x.style.fontSize||12);return B?a(B):x.fontMetrics(n,b.getAttribute("style")?b:d).h},E=function(b,d){h(x.escapes,function(n,a){d&&-1!==d.indexOf(n)||(b=b.toString().replace(new RegExp(n,"g"),a))});return b},v=function(b,d){var n=b.indexOf("<");b=b.substring(n,b.indexOf(">")-n);n=b.indexOf(d+"=");if(-1!==n&&(n=n+d.length+1,d=b.charAt(n),'"'===d||"'"===d))return b=b.substring(n+1),b.substring(0,b.indexOf(d))},I=/<br.*?>/g;var J=[e,t,q,B,r,z,F].join();if(J!==b.textCache){for(b.textCache=J;k--;)d.removeChild(u[k]);
m||r||t||F||-1!==e.indexOf(" ")&&(!q||I.test(e))?(l&&l.appendChild(d),m?(e=x.styledMode?e.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):e.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),e=e.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(I)):e=[e],e=e.filter(function(b){return""!==b}),e.forEach(function(n,a){var e=0,f=0;n=n.replace(/^\s+|\s+$/g,
"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var m=n.split("|||");m.forEach(function(n){if(""!==n||1===m.length){var u={},h=L.createElementNS(x.SVG_NS,"tspan"),l,Q;(l=v(n,"class"))&&N(h,"class",l);if(l=v(n,"style"))l=l.replace(/(;| |^)color([ :])/,"$1fill$2"),N(h,"style",l);(Q=v(n,"href"))&&!c&&(N(h,"onclick",'location.href="'+Q+'"'),N(h,"class","highcharts-anchor"),x.styledMode||y(h,{cursor:"pointer"}));n=E(n.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==n){h.appendChild(L.createTextNode(n));
e?u.dx=0:a&&null!==w&&(u.x=w);N(h,u);d.appendChild(h);!e&&g&&(!C&&c&&y(h,{display:"block"}),N(h,"dy",D(h)));if(F){var R=n.replace(/([^\^])-/g,"$1- ").split(" ");u=!q&&(1<m.length||a||1<R.length);Q=0;var B=D(h);if(t)p=x.truncate(b,h,n,void 0,0,Math.max(0,F-parseInt(z||12,10)),function(b,d){return b.substring(0,d)+"\u2026"});else if(u)for(;R.length;)R.length&&!q&&0<Q&&(h=L.createElementNS(O,"tspan"),N(h,{dy:B,x:w}),l&&N(h,"style",l),h.appendChild(L.createTextNode(R.join(" ").replace(/- /g,"-"))),d.appendChild(h)),
x.truncate(b,h,null,R,0===Q?f:0,F,function(b,d){return R.slice(0,d).join(" ").replace(/- /g,"-")}),f=b.actualWidth,Q++}e++}}});g=g||d.childNodes.length}),t&&p&&b.attr("title",E(b.textStr,["&lt;","&gt;"])),l&&l.removeChild(d),r&&b.applyTextOutline&&b.applyTextOutline(r)):d.appendChild(L.createTextNode(E(e)))}},getContrast:function(b){b=K(b).rgba;b[0]*=1;b[1]*=1.2;b[2]*=.5;return 459<b[0]+b[1]+b[2]?"#000000":"#FFFFFF"},button:function(b,d,a,c,e,f,m,u,h,p){var n=this.label(b,d,a,h,void 0,void 0,p,void 0,
"button"),x=0,l=this.styledMode;n.attr(r({padding:8,r:2},e));if(!l){e=r({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},e);var C=e.style;delete e.style;f=r(e,{fill:"#e6e6e6"},f);var F=f.style;delete f.style;m=r(e,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},m);var Q=m.style;delete m.style;u=r(e,{style:{color:"#cccccc"}},u);var R=u.style;delete u.style}G(n.element,w?"mouseover":"mouseenter",function(){3!==x&&n.setState(1)});
G(n.element,w?"mouseout":"mouseleave",function(){3!==x&&n.setState(x)});n.setState=function(b){1!==b&&(n.state=x=b);n.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][b||0]);l||n.attr([e,f,m,u][b||0]).css([C,F,Q,R][b||0])};l||n.attr(e).css(E({cursor:"default"},C));return n.on("click",function(b){3!==x&&c.call(n,b)})},crispLine:function(b,d,a){void 0===a&&(a="round");var n=b[0],x=b[1];n[1]===x[1]&&(n[1]=x[1]=Math[a](n[1])-
d%2/2);n[2]===x[2]&&(n[2]=x[2]=Math[a](n[2])+d%2/2);return b},path:function(b){var d=this.styledMode?{}:{fill:"none"};D(b)?d.d=b:t(b)&&E(d,b);return this.createElement("path").attr(d)},circle:function(b,d,a){b=t(b)?b:"undefined"===typeof b?{}:{x:b,y:d,r:a};d=this.createElement("circle");d.xSetter=d.ySetter=function(b,d,n){n.setAttribute("c"+d,b)};return d.attr(b)},arc:function(b,d,a,c,e,f){t(b)?(c=b,d=c.y,a=c.r,b=c.x):c={innerR:c,start:e,end:f};b=this.symbol("arc",b,d,a,a,c);b.r=a;return b},rect:function(b,
d,a,c,e,f){e=t(b)?b.r:e;var n=this.createElement("rect");b=t(b)?b:"undefined"===typeof b?{}:{x:b,y:d,width:Math.max(a,0),height:Math.max(c,0)};this.styledMode||("undefined"!==typeof f&&(b.strokeWidth=f,b=n.crisp(b)),b.fill="none");e&&(b.r=e);n.rSetter=function(b,d,a){n.r=b;N(a,{rx:b,ry:b})};n.rGetter=function(){return n.r};return n.attr(b)},setSize:function(b,d,a){var n=this.alignedObjects,c=n.length;this.width=b;this.height=d;for(this.boxWrapper.animate({width:b,height:d},{step:function(){this.attr({viewBox:"0 0 "+
this.attr("width")+" "+this.attr("height")})},duration:f(a,!0)?void 0:0});c--;)n[c].align()},g:function(b){var d=this.createElement("g");return b?d.attr({"class":"highcharts-"+b}):d},image:function(b,n,a,c,e,f){var x={preserveAspectRatio:"none"},m=function(b,d){b.setAttributeNS?b.setAttributeNS("http://www.w3.org/1999/xlink","href",d):b.setAttribute("hc-svg-href",d)},u=function(d){m(h.element,b);f.call(h,d)};1<arguments.length&&E(x,{x:n,y:a,width:c,height:e});var h=this.createElement("image").attr(x);
f?(m(h.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),x=new d.Image,G(x,"load",u),x.src=b,x.complete&&u({})):m(h.element,b);return h},symbol:function(b,d,a,c,e,u){var n=this,x=/^url\((.*?)\)$/,h=x.test(b),p=!h&&(this.symbols[b]?b:"circle"),w=p&&this.symbols[p],l;if(w){"number"===typeof d&&(l=w.call(this.symbols,Math.round(d||0),Math.round(a||0),c,e,u));var C=this.path(l);n.styledMode||C.attr("fill","none");E(C,{symbolName:p,x:d,y:a,width:c,height:e});u&&E(C,
u)}else if(h){var F=b.match(x)[1];C=this.image(F);C.imgwidth=f(B[F]&&B[F].width,u&&u.width);C.imgheight=f(B[F]&&B[F].height,u&&u.height);var Q=function(){C.attr({width:C.width,height:C.height})};["width","height"].forEach(function(b){C[b+"Setter"]=function(b,d){var n={},a=this["img"+d],c="width"===d?"translateX":"translateY";this[d]=b;I(a)&&(u&&"within"===u.backgroundSize&&this.width&&this.height&&(a=Math.round(a*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&this.element.setAttribute(d,
a),this.alignByTranslate||(n[c]=((this[d]||0)-a)/2,this.attr(n)))}});I(d)&&C.attr({x:d,y:a});C.isImg=!0;I(C.imgwidth)&&I(C.imgheight)?Q():(C.attr({width:0,height:0}),M("img",{onload:function(){var b=m[n.chartIndex];0===this.width&&(y(this,{position:"absolute",top:"-999em"}),L.body.appendChild(this));B[F]={width:this.width,height:this.height};C.imgwidth=this.width;C.imgheight=this.height;C.element&&Q();this.parentNode&&this.parentNode.removeChild(this);n.imgCount--;if(!n.imgCount&&b&&!b.hasLoaded)b.onload()},
src:F}),this.imgCount++)}return C},symbols:{circle:function(b,d,a,c){return this.arc(b+a/2,d+c/2,a/2,c/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(b,d,a,c){return[["M",b,d],["L",b+a,d],["L",b+a,d+c],["L",b,d+c],["Z"]]},triangle:function(b,d,a,c){return[["M",b+a/2,d],["L",b+a,d+c],["L",b,d+c],["Z"]]},"triangle-down":function(b,d,a,c){return[["M",b,d],["L",b+a,d],["L",b+a/2,d+c],["Z"]]},diamond:function(b,d,a,c){return[["M",b+a/2,d],["L",b+a,d+c/2],["L",b+a/2,d+c],["L",b,d+c/2],["Z"]]},
arc:function(b,d,a,c,e){var n=e.start,x=e.r||a,m=e.r||c||a,u=e.end-.001;a=e.innerR;c=f(e.open,.001>Math.abs(e.end-e.start-2*Math.PI));var h=Math.cos(n),p=Math.sin(n),w=Math.cos(u);u=Math.sin(u);n=f(e.longArc,.001>e.end-n-Math.PI?0:1);x=[["M",b+x*h,d+m*p],["A",x,m,0,n,f(e.clockwise,1),b+x*w,d+m*u]];I(a)&&x.push(c?["M",b+a*w,d+a*u]:["L",b+a*w,d+a*u],["A",a,a,0,n,I(e.clockwise)?1-e.clockwise:0,b+a*h,d+a*p]);c||x.push(["Z"]);return x},callout:function(b,d,a,c,e){var n=Math.min(e&&e.r||0,a,c),x=n+6,f=
e&&e.anchorX;e=e&&e.anchorY;var m=[["M",b+n,d],["L",b+a-n,d],["C",b+a,d,b+a,d,b+a,d+n],["L",b+a,d+c-n],["C",b+a,d+c,b+a,d+c,b+a-n,d+c],["L",b+n,d+c],["C",b,d+c,b,d+c,b,d+c-n],["L",b,d+n],["C",b,d,b,d,b+n,d]];f&&f>a?e>d+x&&e<d+c-x?m.splice(3,1,["L",b+a,e-6],["L",b+a+6,e],["L",b+a,e+6],["L",b+a,d+c-n]):m.splice(3,1,["L",b+a,c/2],["L",f,e],["L",b+a,c/2],["L",b+a,d+c-n]):f&&0>f?e>d+x&&e<d+c-x?m.splice(7,1,["L",b,e+6],["L",b-6,e],["L",b,e-6],["L",b,d+n]):m.splice(7,1,["L",b,c/2],["L",f,e],["L",b,c/2],
["L",b,d+n]):e&&e>c&&f>b+x&&f<b+a-x?m.splice(5,1,["L",f+6,d+c],["L",f,d+c+6],["L",f-6,d+c],["L",b+n,d+c]):e&&0>e&&f>b+x&&f<b+a-x&&m.splice(1,1,["L",f-6,d],["L",f,d-6],["L",f+6,d],["L",a-n,d]);return m}},clipRect:function(b,d,a,e){var n=c()+"-",x=this.createElement("clipPath").attr({id:n}).add(this.defs);b=this.rect(b,d,a,e,0).add(x);b.id=n;b.clipPath=x;b.count=0;return b},text:function(b,d,a,c){var n={};if(c&&(this.allowHTML||!this.forExport))return this.html(b,d,a);n.x=Math.round(d||0);a&&(n.y=Math.round(a));
I(b)&&(n.text=b);b=this.createElement("text").attr(n);c||(b.xSetter=function(b,d,n){var a=n.getElementsByTagName("tspan"),c=n.getAttribute(d),e;for(e=0;e<a.length;e++){var x=a[e];x.getAttribute(d)===c&&x.setAttribute(d,b)}n.setAttribute(d,b)});return b},fontMetrics:function(b,n){b=!this.styledMode&&/px/.test(b)||!d.getComputedStyle?b||n&&n.style&&n.style.fontSize||this.style&&this.style.fontSize:n&&H.prototype.getStyle.call(n,"font-size");b=/px/.test(b)?a(b):12;n=24>b?b+3:Math.round(1.2*b);return{h:n,
b:Math.round(.8*n),f:b}},rotCorr:function(b,d,a){var n=b;d&&a&&(n=Math.max(n*Math.cos(d*u),4));return{x:-b/3*Math.sin(d*u),y:n}},pathToSegments:function(b){for(var d=[],a=[],c={A:8,C:7,H:2,L:3,M:3,Q:5,S:5,T:3,V:2},e=0;e<b.length;e++)q(a[0])&&z(b[e])&&a.length===c[a[0].toUpperCase()]&&b.splice(e,0,a[0].replace("M","L").replace("m","l")),"string"===typeof b[e]&&(a.length&&d.push(a.slice(0)),a.length=0),a.push(b[e]);d.push(a.slice(0));return d},label:function(b,d,a,c,e,f,m,u,h){var n=this,x=n.styledMode,
p=n.g("button"!==h&&"label"),w=p.text=n.text("",0,0,m).attr({zIndex:1}),C,F={width:0,height:0,x:0,y:0},Q=F,B=0,L=3,t=0,O,q,R,X,g,k={},y,D,U=/^url\((.*?)\)$/.test(c),v=x||U,W=function(){return x?C.strokeWidth()%2/2:(y?parseInt(y,10):0)%2/2};h&&p.addClass("highcharts-"+h);var V=function(){var b=w.element.style,d={};Q=z(O)&&z(q)&&!g||!I(w.textStr)?F:w.getBBox();p.width=(O||Q.width||0)+2*L+t;p.height=(q||Q.height||0)+2*L;D=L+Math.min(n.fontMetrics(b&&b.fontSize,w).b,Q.height||Infinity);v&&(C||(p.box=
C=n.symbols[c]||U?n.symbol(c):n.rect(),C.addClass(("button"===h?"":"highcharts-label-box")+(h?" highcharts-"+h+"-box":"")),C.add(p),b=W(),d.x=b,d.y=(u?-D:0)+b),d.width=Math.round(p.width),d.height=Math.round(p.height),C.attr(E(d,k)),k={})};var J=function(){var b=t+L;var d=u?0:D;I(O)&&Q&&("center"===g||"right"===g)&&(b+={center:.5,right:1}[g]*(O-Q.width));if(b!==w.x||d!==w.y)w.attr("x",b),w.hasBoxWidthChanged&&(Q=w.getBBox(!0),V()),"undefined"!==typeof d&&w.attr("y",d);w.x=b;w.y=d};var M=function(b,
d){C?C.attr(b,d):k[b]=d};p.onAdd=function(){w.add(p);p.attr({text:b||0===b?b:"",x:d,y:a});C&&I(e)&&p.attr({anchorX:e,anchorY:f})};p.widthSetter=function(b){O=z(b)?b:null};p.heightSetter=function(b){q=b};p["text-alignSetter"]=function(b){g=b};p.paddingSetter=function(b){I(b)&&b!==L&&(L=p.padding=b,J())};p.paddingLeftSetter=function(b){I(b)&&b!==t&&(t=b,J())};p.alignSetter=function(b){b={left:0,center:.5,right:1}[b];b!==B&&(B=b,Q&&p.attr({x:R}))};p.textSetter=function(b){"undefined"!==typeof b&&w.attr({text:b});
V();J()};p["stroke-widthSetter"]=function(b,d){b&&(v=!0);y=this["stroke-width"]=b;M(d,b)};x?p.rSetter=function(b,d){M(d,b)}:p.strokeSetter=p.fillSetter=p.rSetter=function(b,d){"r"!==d&&("fill"===d&&b&&(v=!0),p[d]=b);M(d,b)};p.anchorXSetter=function(b,d){e=p.anchorX=b;M(d,Math.round(b)-W()-R)};p.anchorYSetter=function(b,d){f=p.anchorY=b;M(d,b-X)};p.xSetter=function(b){p.x=b;B&&(b-=B*((O||Q.width)+2*L),p["forceAnimate:x"]=!0);R=Math.round(b);p.attr("translateX",R)};p.ySetter=function(b){X=p.y=Math.round(b);
p.attr("translateY",X)};p.isLabel=!0;var G=p.css;m={css:function(b){if(b){var d={};b=r(b);p.textProps.forEach(function(n){"undefined"!==typeof b[n]&&(d[n]=b[n],delete b[n])});w.css(d);var n="fontSize"in d||"fontWeight"in d;if("width"in d||n)V(),n&&J()}return G.call(p,b)},getBBox:function(){return{width:Q.width+2*L,height:Q.height+2*L,x:Q.x-L,y:Q.y-L}},destroy:function(){l(p.element,"mouseenter");l(p.element,"mouseleave");w&&w.destroy();C&&(C=C.destroy());H.prototype.destroy.call(p);p=n=w=V=J=M=null}};
p.on=function(b,d){var n=w&&"SPAN"===w.element.tagName?w:void 0;if(n){var a=function(a){("mouseenter"===b||"mouseleave"===b)&&a.relatedTarget instanceof Element&&(p.element.contains(a.relatedTarget)||n.element.contains(a.relatedTarget))||d.call(p.element,a)};n.on(b,a)}H.prototype.on.call(p,b,a||d);return p};x||(m.shadow=function(b){b&&(V(),C&&C.shadow(b));return p});return E(p,m)}});g.Renderer=k});P(A,"parts/Html.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.attr,v=g.createElement,
K=g.css,G=g.defined,N=g.extend,M=g.pick,y=g.pInt,I=k.isFirefox,J=k.isMS,E=k.isWebKit,D=k.SVGElement;g=k.SVGRenderer;var z=k.win;N(D.prototype,{htmlCss:function(t){var q="SPAN"===this.element.tagName&&t&&"width"in t,r=M(q&&t.width,void 0);if(q){delete t.width;this.textWidth=r;var h=!0}t&&"ellipsis"===t.textOverflow&&(t.whiteSpace="nowrap",t.overflow="hidden");this.styles=N(this.styles,t);K(this.element,t);h&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var t=this.element;return{x:t.offsetLeft,
y:t.offsetTop,width:t.offsetWidth,height:t.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var t=this.renderer,q=this.element,r=this.translateX||0,h=this.translateY||0,f=this.x||0,a=this.y||0,l=this.textAlign||"left",e={left:0,center:.5,right:1}[l],c=this.styles,m=c&&c.whiteSpace;K(q,{marginLeft:r,marginTop:h});!t.styledMode&&this.shadows&&this.shadows.forEach(function(a){K(a,{marginLeft:r+1,marginTop:h+1})});this.inverted&&[].forEach.call(q.childNodes,function(a){t.invertChild(a,q)});
if("SPAN"===q.tagName){c=this.rotation;var u=this.textWidth&&y(this.textWidth),L=[c,l,q.innerHTML,this.textWidth,this.textAlign].join(),F;(F=u!==this.oldTextWidth)&&!(F=u>this.oldTextWidth)&&((F=this.textPxLength)||(K(q,{width:"",whiteSpace:m||"nowrap"}),F=q.offsetWidth),F=F>u);F&&(/[ \-]/.test(q.textContent||q.innerText)||"ellipsis"===q.style.textOverflow)?(K(q,{width:u+"px",display:"block",whiteSpace:m||"normal"}),this.oldTextWidth=u,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;L!==this.cTT&&
(m=t.fontMetrics(q.style.fontSize,q).b,!G(c)||c===(this.oldRotation||0)&&l===this.oldAlign||this.setSpanRotation(c,e,m),this.getSpanCorrection(!G(c)&&this.textPxLength||q.offsetWidth,m,e,c,l));K(q,{left:f+(this.xCorr||0)+"px",top:a+(this.yCorr||0)+"px"});this.cTT=L;this.oldRotation=c;this.oldAlign=l}}else this.alignOnAdd=!0},setSpanRotation:function(t,q,r){var h={},f=this.renderer.getTransformKey();h[f]=h.transform="rotate("+t+"deg)";h[f+(I?"Origin":"-origin")]=h.transformOrigin=100*q+"% "+r+"px";
K(this.element,h)},getSpanCorrection:function(t,q,r){this.xCorr=-t*r;this.yCorr=-q}});N(g.prototype,{getTransformKey:function(){return J&&!/Edge/.test(z.navigator.userAgent)?"-ms-transform":E?"-webkit-transform":I?"MozTransform":z.opera?"-o-transform":""},html:function(t,q,r){var h=this.createElement("span"),f=h.element,a=h.renderer,l=a.isSVG,e=function(a,e){["opacity","visibility"].forEach(function(c){a[c+"Setter"]=function(f,m,u){var p=a.div?a.div.style:e;D.prototype[c+"Setter"].call(this,f,m,u);
p&&(p[m]=f)}});a.addedSetters=!0};h.textSetter=function(a){a!==f.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=a;f.innerHTML=M(a,"");h.doTransform=!0};l&&e(h,h.element.style);h.xSetter=h.ySetter=h.alignSetter=h.rotationSetter=function(a,e){"align"===e&&(e="textAlign");h[e]=a;h.doTransform=!0};h.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};h.attr({text:t,x:Math.round(q),y:Math.round(r)}).css({position:"absolute"});a.styledMode||h.css({fontFamily:this.style.fontFamily,
fontSize:this.style.fontSize});f.style.whiteSpace="nowrap";h.css=h.htmlCss;l&&(h.add=function(c){var m=a.box.parentNode,u=[];if(this.parentGroup=c){var l=c.div;if(!l){for(;c;)u.push(c),c=c.parentGroup;u.reverse().forEach(function(a){function c(c,e){a[e]=c;"translateX"===e?C.left=c+"px":C.top=c+"px";a.doTransform=!0}var f=H(a.element,"class");l=a.div=a.div||v("div",f?{className:f}:void 0,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,
pointerEvents:a.styles&&a.styles.pointerEvents},l||m);var C=l.style;N(a,{classSetter:function(a){return function(c){this.element.setAttribute("class",c);a.className=c}}(l),on:function(){u[0].div&&h.on.apply({element:u[0].div},arguments);return a},translateXSetter:c,translateYSetter:c});a.addedSetters||e(a)})}}else l=m;l.appendChild(f);h.added=!0;h.alignOnAdd&&h.htmlUpdateTransform();return h});return h}})});P(A,"parts/Tick.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.clamp,
v=g.correctFloat,K=g.defined,G=g.destroyObjectProperties,N=g.extend,M=g.fireEvent,y=g.isNumber,I=g.merge,J=g.objectEach,E=g.pick,D=k.deg2rad;g=function(){function z(t,q,r,h,f){this.isNewLabel=this.isNew=!0;this.axis=t;this.pos=q;this.type=r||"";this.parameters=f||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;M(this,"init");r||h||this.addLabel()}z.prototype.addLabel=function(){var t=this,q=t.axis,r=q.options,h=q.chart,f=q.categories,a=q.logarithmic,l=q.names,
e=t.pos,c=E(t.options&&t.options.labels,r.labels),m=q.tickPositions,u=e===m[0],L=e===m[m.length-1];l=this.parameters.category||(f?E(f[e],l[e],e):e);var F=t.label;f=(!c.step||1===c.step)&&1===q.tickInterval;m=m.info;var w,p;if(q.dateTime&&m){var C=h.time.resolveDTLFormat(r.dateTimeLabelFormats[!r.grid&&m.higherRanks[e]||m.unitName]);var O=C.main}t.isFirst=u;t.isLast=L;t.formatCtx={axis:q,chart:h,isFirst:u,isLast:L,dateTimeLabelFormat:O,tickPositionInfo:m,value:a?v(a.lin2log(l)):l,pos:e};r=q.labelFormatter.call(t.formatCtx,
this.formatCtx);if(p=C&&C.list)t.shortenLabel=function(){for(w=0;w<p.length;w++)if(F.attr({text:q.labelFormatter.call(N(t.formatCtx,{dateTimeLabelFormat:p[w]}))}),F.getBBox().width<q.getSlotWidth(t)-2*E(c.padding,5))return;F.attr({text:""})};f&&q._addedPlotLB&&q.isXAxis&&t.moveLabel(r,c);K(F)||t.movedLabel?F&&F.textStr!==r&&!f&&(!F.textWidth||c.style&&c.style.width||F.styles.width||F.css({width:null}),F.attr({text:r}),F.textPxLength=F.getBBox().width):(t.label=F=t.createLabel({x:0,y:0},r,c),t.rotation=
0)};z.prototype.createLabel=function(t,q,r){var h=this.axis,f=h.chart;if(t=K(q)&&r.enabled?f.renderer.text(q,t.x,t.y,r.useHTML).add(h.labelGroup):null)f.styledMode||t.css(I(r.style)),t.textPxLength=t.getBBox().width;return t};z.prototype.destroy=function(){G(this,this.axis)};z.prototype.getPosition=function(t,q,r,h){var f=this.axis,a=f.chart,l=h&&a.oldChartHeight||a.chartHeight;t={x:t?v(f.translate(q+r,null,null,h)+f.transB):f.left+f.offset+(f.opposite?(h&&a.oldChartWidth||a.chartWidth)-f.right-f.left:
0),y:t?l-f.bottom+f.offset-(f.opposite?f.height:0):v(l-f.translate(q+r,null,null,h)-f.transB)};t.y=H(t.y,-1E5,1E5);M(this,"afterGetPosition",{pos:t});return t};z.prototype.getLabelPosition=function(t,q,r,h,f,a,l,e){var c=this.axis,m=c.transA,u=c.isLinked&&c.linkedParent?c.linkedParent.reversed:c.reversed,L=c.staggerLines,F=c.tickRotCorr||{x:0,y:0},w=f.y,p=h||c.reserveSpaceDefault?0:-c.labelOffset*("center"===c.labelAlign?.5:1),C={};K(w)||(w=0===c.side?r.rotation?-8:-r.getBBox().height:2===c.side?
F.y+8:Math.cos(r.rotation*D)*(F.y-r.getBBox(!1,0).height/2));t=t+f.x+p+F.x-(a&&h?a*m*(u?-1:1):0);q=q+w-(a&&!h?a*m*(u?1:-1):0);L&&(r=l/(e||1)%L,c.opposite&&(r=L-r-1),q+=c.labelOffset/L*r);C.x=t;C.y=Math.round(q);M(this,"afterGetLabelPosition",{pos:C,tickmarkOffset:a,index:l});return C};z.prototype.getLabelSize=function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0};z.prototype.getMarkPath=function(t,q,r,h,f,a){return a.crispLine([["M",t,q],["L",t+(f?0:-r),q+(f?r:0)]],
h)};z.prototype.handleOverflow=function(t){var q=this.axis,r=q.options.labels,h=t.x,f=q.chart.chartWidth,a=q.chart.spacing,l=E(q.labelLeft,Math.min(q.pos,a[3]));a=E(q.labelRight,Math.max(q.isRadial?0:q.pos+q.len,f-a[1]));var e=this.label,c=this.rotation,m={left:0,center:.5,right:1}[q.labelAlign||e.attr("align")],u=e.getBBox().width,L=q.getSlotWidth(this),F=L,w=1,p,C={};if(c||"justify"!==E(r.overflow,"justify"))0>c&&h-m*u<l?p=Math.round(h/Math.cos(c*D)-l):0<c&&h+m*u>a&&(p=Math.round((f-h)/Math.cos(c*
D)));else if(f=h+(1-m)*u,h-m*u<l?F=t.x+F*(1-m)-l:f>a&&(F=a-t.x+F*m,w=-1),F=Math.min(L,F),F<L&&"center"===q.labelAlign&&(t.x+=w*(L-F-m*(L-Math.min(u,F)))),u>F||q.autoRotation&&(e.styles||{}).width)p=F;p&&(this.shortenLabel?this.shortenLabel():(C.width=Math.floor(p)+"px",(r.style||{}).textOverflow||(C.textOverflow="ellipsis"),e.css(C)))};z.prototype.moveLabel=function(t,q){var r=this,h=r.label,f=!1,a=r.axis,l=a.reversed,e=a.chart.inverted;h&&h.textStr===t?(r.movedLabel=h,f=!0,delete r.label):J(a.ticks,
function(a){f||a.isNew||a===r||!a.label||a.label.textStr!==t||(r.movedLabel=a.label,f=!0,a.labelPos=r.movedLabel.xy,delete a.label)});if(!f&&(r.labelPos||h)){var c=r.labelPos||h.xy;h=e?c.x:l?0:a.width+a.left;a=e?l?a.width+a.left:0:c.y;r.movedLabel=r.createLabel({x:h,y:a},t,q);r.movedLabel&&r.movedLabel.attr({opacity:0})}};z.prototype.render=function(t,q,r){var h=this.axis,f=h.horiz,a=this.pos,l=E(this.tickmarkOffset,h.tickmarkOffset);a=this.getPosition(f,a,l,q);l=a.x;var e=a.y;h=f&&l===h.pos+h.len||
!f&&e===h.pos?-1:1;r=E(r,1);this.isActive=!0;this.renderGridLine(q,r,h);this.renderMark(a,r,h);this.renderLabel(a,q,r,t);this.isNew=!1;M(this,"afterRender")};z.prototype.renderGridLine=function(t,q,r){var h=this.axis,f=h.options,a=this.gridLine,l={},e=this.pos,c=this.type,m=E(this.tickmarkOffset,h.tickmarkOffset),u=h.chart.renderer,L=c?c+"Grid":"grid",F=f[L+"LineWidth"],w=f[L+"LineColor"];f=f[L+"LineDashStyle"];a||(h.chart.styledMode||(l.stroke=w,l["stroke-width"]=F,f&&(l.dashstyle=f)),c||(l.zIndex=
1),t&&(q=0),this.gridLine=a=u.path().attr(l).addClass("highcharts-"+(c?c+"-":"")+"grid-line").add(h.gridGroup));if(a&&(r=h.getPlotLinePath({value:e+m,lineWidth:a.strokeWidth()*r,force:"pass",old:t})))a[t||this.isNew?"attr":"animate"]({d:r,opacity:q})};z.prototype.renderMark=function(t,q,r){var h=this.axis,f=h.options,a=h.chart.renderer,l=this.type,e=l?l+"Tick":"tick",c=h.tickSize(e),m=this.mark,u=!m,L=t.x;t=t.y;var F=E(f[e+"Width"],!l&&h.isXAxis?1:0);f=f[e+"Color"];c&&(h.opposite&&(c[0]=-c[0]),u&&
(this.mark=m=a.path().addClass("highcharts-"+(l?l+"-":"")+"tick").add(h.axisGroup),h.chart.styledMode||m.attr({stroke:f,"stroke-width":F})),m[u?"attr":"animate"]({d:this.getMarkPath(L,t,c[0],m.strokeWidth()*r,h.horiz,a),opacity:q}))};z.prototype.renderLabel=function(t,q,r,h){var f=this.axis,a=f.horiz,l=f.options,e=this.label,c=l.labels,m=c.step;f=E(this.tickmarkOffset,f.tickmarkOffset);var u=!0,L=t.x;t=t.y;e&&y(L)&&(e.xy=t=this.getLabelPosition(L,t,e,a,c,f,h,m),this.isFirst&&!this.isLast&&!E(l.showFirstLabel,
1)||this.isLast&&!this.isFirst&&!E(l.showLastLabel,1)?u=!1:!a||c.step||c.rotation||q||0===r||this.handleOverflow(t),m&&h%m&&(u=!1),u&&y(t.y)?(t.opacity=r,e[this.isNewLabel?"attr":"animate"](t),this.isNewLabel=!1):(e.attr("y",-9999),this.isNewLabel=!0))};z.prototype.replaceMovedLabel=function(){var t=this.label,q=this.axis,r=q.reversed,h=this.axis.chart.inverted;if(t&&!this.isNew){var f=h?t.xy.x:r?q.left:q.width+q.left;r=h?r?q.width+q.top:q.top:t.xy.y;t.animate({x:f,y:r,opacity:0},void 0,t.destroy);
delete this.label}q.isDirty=!0;this.label=this.movedLabel;delete this.movedLabel};return z}();k.Tick=g;return k.Tick});P(A,"parts/Time.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.defined,v=g.error,K=g.extend,G=g.isObject,N=g.merge,M=g.objectEach,y=g.pad,I=g.pick,J=g.splat,E=g.timeUnits,D=k.win;g=function(){function z(t){this.options={};this.variableTimezone=this.useUTC=!1;this.Date=D.Date;this.getTimezoneOffset=this.timezoneOffsetFunction();this.update(t)}z.prototype.get=
function(t,q){if(this.variableTimezone||this.timezoneOffset){var r=q.getTime(),h=r-this.getTimezoneOffset(q);q.setTime(h);t=q["getUTC"+t]();q.setTime(r);return t}return this.useUTC?q["getUTC"+t]():q["get"+t]()};z.prototype.set=function(t,q,r){if(this.variableTimezone||this.timezoneOffset){if("Milliseconds"===t||"Seconds"===t||"Minutes"===t)return q["setUTC"+t](r);var h=this.getTimezoneOffset(q);h=q.getTime()-h;q.setTime(h);q["setUTC"+t](r);t=this.getTimezoneOffset(q);h=q.getTime()+t;return q.setTime(h)}return this.useUTC?
q["setUTC"+t](r):q["set"+t](r)};z.prototype.update=function(t){var q=I(t&&t.useUTC,!0);this.options=t=N(!0,this.options||{},t);this.Date=t.Date||D.Date||Date;this.timezoneOffset=(this.useUTC=q)&&t.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();this.variableTimezone=!(q&&!t.getTimezoneOffset&&!t.timezone)};z.prototype.makeTime=function(t,q,r,h,f,a){if(this.useUTC){var l=this.Date.UTC.apply(0,arguments);var e=this.getTimezoneOffset(l);l+=e;var c=this.getTimezoneOffset(l);e!==c?
l+=c-e:e-36E5!==this.getTimezoneOffset(l-36E5)||k.isSafari||(l-=36E5)}else l=(new this.Date(t,q,I(r,1),I(h,0),I(f,0),I(a,0))).getTime();return l};z.prototype.timezoneOffsetFunction=function(){var t=this,q=this.options,r=D.moment;if(!this.useUTC)return function(h){return 6E4*(new Date(h.toString())).getTimezoneOffset()};if(q.timezone){if(r)return function(h){return 6E4*-r.tz(h,q.timezone).utcOffset()};v(25)}return this.useUTC&&q.getTimezoneOffset?function(h){return 6E4*q.getTimezoneOffset(h.valueOf())}:
function(){return 6E4*(t.timezoneOffset||0)}};z.prototype.dateFormat=function(t,q,r){var h;if(!H(q)||isNaN(q))return(null===(h=k.defaultOptions.lang)||void 0===h?void 0:h.invalidDate)||"";t=I(t,"%Y-%m-%d %H:%M:%S");var f=this;h=new this.Date(q);var a=this.get("Hours",h),l=this.get("Day",h),e=this.get("Date",h),c=this.get("Month",h),m=this.get("FullYear",h),u=k.defaultOptions.lang,L=null===u||void 0===u?void 0:u.weekdays,F=null===u||void 0===u?void 0:u.shortWeekdays;h=K({a:F?F[l]:L[l].substr(0,3),
A:L[l],d:y(e),e:y(e,2," "),w:l,b:u.shortMonths[c],B:u.months[c],m:y(c+1),o:c+1,y:m.toString().substr(2,2),Y:m,H:y(a),k:a,I:y(a%12||12),l:a%12||12,M:y(this.get("Minutes",h)),p:12>a?"AM":"PM",P:12>a?"am":"pm",S:y(h.getSeconds()),L:y(Math.floor(q%1E3),3)},k.dateFormats);M(h,function(a,c){for(;-1!==t.indexOf("%"+c);)t=t.replace("%"+c,"function"===typeof a?a.call(f,q):a)});return r?t.substr(0,1).toUpperCase()+t.substr(1):t};z.prototype.resolveDTLFormat=function(t){return G(t,!0)?t:(t=J(t),{main:t[0],from:t[1],
to:t[2]})};z.prototype.getTimeTicks=function(t,q,r,h){var f=this,a=[],l={};var e=new f.Date(q);var c=t.unitRange,m=t.count||1,u;h=I(h,1);if(H(q)){f.set("Milliseconds",e,c>=E.second?0:m*Math.floor(f.get("Milliseconds",e)/m));c>=E.second&&f.set("Seconds",e,c>=E.minute?0:m*Math.floor(f.get("Seconds",e)/m));c>=E.minute&&f.set("Minutes",e,c>=E.hour?0:m*Math.floor(f.get("Minutes",e)/m));c>=E.hour&&f.set("Hours",e,c>=E.day?0:m*Math.floor(f.get("Hours",e)/m));c>=E.day&&f.set("Date",e,c>=E.month?1:Math.max(1,
m*Math.floor(f.get("Date",e)/m)));if(c>=E.month){f.set("Month",e,c>=E.year?0:m*Math.floor(f.get("Month",e)/m));var L=f.get("FullYear",e)}c>=E.year&&f.set("FullYear",e,L-L%m);c===E.week&&(L=f.get("Day",e),f.set("Date",e,f.get("Date",e)-L+h+(L<h?-7:0)));L=f.get("FullYear",e);h=f.get("Month",e);var F=f.get("Date",e),w=f.get("Hours",e);q=e.getTime();f.variableTimezone&&(u=r-q>4*E.month||f.getTimezoneOffset(q)!==f.getTimezoneOffset(r));q=e.getTime();for(e=1;q<r;)a.push(q),q=c===E.year?f.makeTime(L+e*m,
0):c===E.month?f.makeTime(L,h+e*m):!u||c!==E.day&&c!==E.week?u&&c===E.hour&&1<m?f.makeTime(L,h,F,w+e*m):q+c*m:f.makeTime(L,h,F+e*m*(c===E.day?1:7)),e++;a.push(q);c<=E.hour&&1E4>a.length&&a.forEach(function(a){0===a%18E5&&"000000000"===f.dateFormat("%H%M%S%L",a)&&(l[a]="day")})}a.info=K(t,{higherRanks:l,totalRange:c*m});return a};z.defaultOptions={Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0};return z}();k.Time=g;return k.Time});P(A,"parts/Options.js",[A["parts/Globals.js"],
A["parts/Time.js"],A["parts/Color.js"],A["parts/Utilities.js"]],function(k,g,H,v){H=H.parse;var K=v.merge;k.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:g.defaultOptions,chart:{styledMode:!1,borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,
widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},
itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:k.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",
second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:k.isTouchDevice?25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:H("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",
whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};k.setOptions=function(g){k.defaultOptions=K(!0,k.defaultOptions,g);(g.time||g.global)&&k.time.update(K(k.defaultOptions.global,k.defaultOptions.time,g.global,g.time));return k.defaultOptions};k.getOptions=function(){return k.defaultOptions};k.defaultPlotOptions=k.defaultOptions.plotOptions;
k.time=new g(K(k.defaultOptions.global,k.defaultOptions.time));k.dateFormat=function(g,v,M){return k.time.dateFormat(g,v,M)};""});P(A,"parts/Axis.js",[A["parts/Color.js"],A["parts/Globals.js"],A["parts/Tick.js"],A["parts/Utilities.js"]],function(k,g,H,v){var K=v.addEvent,G=v.animObject,N=v.arrayMax,M=v.arrayMin,y=v.clamp,I=v.correctFloat,J=v.defined,E=v.destroyObjectProperties,D=v.error,z=v.extend,t=v.fireEvent,q=v.format,r=v.getMagnitude,h=v.isArray,f=v.isFunction,a=v.isNumber,l=v.isString,e=v.merge,
c=v.normalizeTickInterval,m=v.objectEach,u=v.pick,L=v.relativeLength,F=v.removeEvent,w=v.splat,p=v.syncTimeout,C=g.defaultOptions,O=g.deg2rad;v=function(){function B(d,b){this.zoomEnabled=this.width=this.visible=this.userOptions=this.translationSlope=this.transB=this.transA=this.top=this.ticks=this.tickRotCorr=this.tickPositions=this.tickmarkOffset=this.tickInterval=this.tickAmount=this.side=this.series=this.right=this.positiveValuesOnly=this.pos=this.pointRangePadding=this.pointRange=this.plotLinesAndBandsGroups=
this.plotLinesAndBands=this.paddedTicks=this.overlap=this.options=this.oldMin=this.oldMax=this.offset=this.names=this.minPixelPadding=this.minorTicks=this.minorTickInterval=this.min=this.maxLabelLength=this.max=this.len=this.left=this.labelFormatter=this.labelEdge=this.isLinked=this.height=this.hasVisibleSeries=this.hasNames=this.coll=this.closestPointRange=this.chart=this.categories=this.bottom=this.alternateBands=void 0;this.init(d,b)}B.prototype.init=function(d,b){var a=b.isX,c=this;c.chart=d;
c.horiz=d.inverted&&!c.isZAxis?!a:a;c.isXAxis=a;c.coll=c.coll||(a?"xAxis":"yAxis");t(this,"init",{userOptions:b});c.opposite=b.opposite;c.side=b.side||(c.horiz?c.opposite?0:2:c.opposite?1:3);c.setOptions(b);var e=this.options,p=e.type;c.labelFormatter=e.labels.formatter||c.defaultLabelFormatter;c.userOptions=b;c.minPixelPadding=0;c.reversed=e.reversed;c.visible=!1!==e.visible;c.zoomEnabled=!1!==e.zoomEnabled;c.hasNames="category"===p||!0===e.categories;c.categories=e.categories||c.hasNames;c.names||
(c.names=[],c.names.keys={});c.plotLinesAndBandsGroups={};c.positiveValuesOnly=!(!c.logarithmic||e.allowNegativeLog);c.isLinked=J(e.linkedTo);c.ticks={};c.labelEdge=[];c.minorTicks={};c.plotLinesAndBands=[];c.alternateBands={};c.len=0;c.minRange=c.userMinRange=e.minRange||e.maxZoom;c.range=e.range;c.offset=e.offset||0;c.max=null;c.min=null;c.crosshair=u(e.crosshair,w(d.options.tooltip.crosshairs)[a?0:1],!1);b=c.options.events;-1===d.axes.indexOf(c)&&(a?d.axes.splice(d.xAxis.length,0,c):d.axes.push(c),
d[c.coll].push(c));c.series=c.series||[];d.inverted&&!c.isZAxis&&a&&"undefined"===typeof c.reversed&&(c.reversed=!0);c.labelRotation=c.options.labels.rotation;m(b,function(b,d){f(b)&&K(c,d,b)});t(this,"afterInit")};B.prototype.setOptions=function(d){this.options=e(B.defaultOptions,"yAxis"===this.coll&&B.defaultYAxisOptions,[B.defaultTopAxisOptions,B.defaultRightAxisOptions,B.defaultBottomAxisOptions,B.defaultLeftAxisOptions][this.side],e(C[this.coll],d));t(this,"afterSetOptions",{userOptions:d})};
B.prototype.defaultLabelFormatter=function(){var d=this.axis,b=this.value,a=d.chart.time,c=d.categories,e=this.dateTimeLabelFormat,f=C.lang,m=f.numericSymbols;f=f.numericSymbolMagnitude||1E3;var u=m&&m.length,p=d.options.labels.format;d=d.logarithmic?Math.abs(b):d.tickInterval;var h=this.chart,w=h.numberFormatter;if(p)var l=q(p,this,h);else if(c)l=b;else if(e)l=a.dateFormat(e,b);else if(u&&1E3<=d)for(;u--&&"undefined"===typeof l;)a=Math.pow(f,u+1),d>=a&&0===10*b%a&&null!==m[u]&&0!==b&&(l=w(b/a,-1)+
m[u]);"undefined"===typeof l&&(l=1E4<=Math.abs(b)?w(b,-1):w(b,-1,void 0,""));return l};B.prototype.getSeriesExtremes=function(){var d=this,b=d.chart,n;t(this,"getSeriesExtremes",null,function(){d.hasVisibleSeries=!1;d.dataMin=d.dataMax=d.threshold=null;d.softThreshold=!d.isXAxis;d.stacking&&d.stacking.buildStacks();d.series.forEach(function(c){if(c.visible||!b.options.chart.ignoreHiddenSeries){var e=c.options,f=e.threshold;d.hasVisibleSeries=!0;d.positiveValuesOnly&&0>=f&&(f=null);if(d.isXAxis){if(e=
c.xData,e.length){n=c.getXExtremes(e);var x=n.min;var m=n.max;a(x)||x instanceof Date||(e=e.filter(a),n=c.getXExtremes(e),x=n.min,m=n.max);e.length&&(d.dataMin=Math.min(u(d.dataMin,x),x),d.dataMax=Math.max(u(d.dataMax,m),m))}}else if(c=c.applyExtremes(),a(c.dataMin)&&(x=c.dataMin,d.dataMin=Math.min(u(d.dataMin,x),x)),a(c.dataMax)&&(m=c.dataMax,d.dataMax=Math.max(u(d.dataMax,m),m)),J(f)&&(d.threshold=f),!e.softThreshold||d.positiveValuesOnly)d.softThreshold=!1}})});t(this,"afterGetSeriesExtremes")};
B.prototype.translate=function(d,b,n,c,e,f){var x=this.linkedParent||this,m=1,u=0,p=c?x.oldTransA:x.transA;c=c?x.oldMin:x.min;var h=x.minPixelPadding;e=(x.isOrdinal||x.brokenAxis&&x.brokenAxis.hasBreaks||x.logarithmic&&e)&&x.lin2val;p||(p=x.transA);n&&(m*=-1,u=x.len);x.reversed&&(m*=-1,u-=m*(x.sector||x.len));b?(d=(d*m+u-h)/p+c,e&&(d=x.lin2val(d))):(e&&(d=x.val2lin(d)),d=a(c)?m*(d-c)*p+u+m*h+(a(f)?p*f:0):void 0);return d};B.prototype.toPixels=function(d,b){return this.translate(d,!1,!this.horiz,null,
!0)+(b?0:this.pos)};B.prototype.toValue=function(d,b){return this.translate(d-(b?0:this.pos),!0,!this.horiz,null,!0)};B.prototype.getPlotLinePath=function(d){function b(b,d,a){if("pass"!==l&&b<d||b>a)l?b=y(b,d,a):q=!0;return b}var n=this,c=n.chart,e=n.left,f=n.top,m=d.old,p=d.value,h=d.translatedValue,w=d.lineWidth,l=d.force,C,F,B,L,r=m&&c.oldChartHeight||c.chartHeight,O=m&&c.oldChartWidth||c.chartWidth,q,z=n.transB;d={value:p,lineWidth:w,old:m,force:l,acrossPanes:d.acrossPanes,translatedValue:h};
t(this,"getPlotLinePath",d,function(d){h=u(h,n.translate(p,null,null,m));h=y(h,-1E5,1E5);C=B=Math.round(h+z);F=L=Math.round(r-h-z);a(h)?n.horiz?(F=f,L=r-n.bottom,C=B=b(C,e,e+n.width)):(C=e,B=O-n.right,F=L=b(F,f,f+n.height)):(q=!0,l=!1);d.path=q&&!l?null:c.renderer.crispLine([["M",C,F],["L",B,L]],w||1)});return d.path};B.prototype.getLinearTickPositions=function(d,b,a){var n=I(Math.floor(b/d)*d);a=I(Math.ceil(a/d)*d);var c=[],e;I(n+d)===n&&(e=20);if(this.single)return[b];for(b=n;b<=a;){c.push(b);b=
I(b+d,e);if(b===f)break;var f=b}return c};B.prototype.getMinorTickInterval=function(){var d=this.options;return!0===d.minorTicks?u(d.minorTickInterval,"auto"):!1===d.minorTicks?null:d.minorTickInterval};B.prototype.getMinorTickPositions=function(){var d=this.options,b=this.tickPositions,a=this.minorTickInterval,c=[],e=this.pointRangePadding||0,f=this.min-e;e=this.max+e;var m=e-f;if(m&&m/a<this.len/3){var u=this.logarithmic;if(u)this.paddedTicks.forEach(function(b,d,n){d&&c.push.apply(c,u.getLogTickPositions(a,
n[d-1],n[d],!0))});else if(this.dateTime&&"auto"===this.getMinorTickInterval())c=c.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(a),f,e,d.startOfWeek));else for(d=f+(b[0]-f)%a;d<=e&&d!==c[0];d+=a)c.push(d)}0!==c.length&&this.trimTicks(c);return c};B.prototype.adjustForMinRange=function(){var d=this.options,b=this.min,a=this.max,c=this.logarithmic,e,f,m,p,h;this.isXAxis&&"undefined"===typeof this.minRange&&!c&&(J(d.min)||J(d.max)?this.minRange=null:(this.series.forEach(function(b){p=
b.xData;for(f=h=b.xIncrement?1:p.length-1;0<f;f--)if(m=p[f]-p[f-1],"undefined"===typeof e||m<e)e=m}),this.minRange=Math.min(5*e,this.dataMax-this.dataMin)));if(a-b<this.minRange){var w=this.dataMax-this.dataMin>=this.minRange;var l=this.minRange;var C=(l-a+b)/2;C=[b-C,u(d.min,b-C)];w&&(C[2]=this.logarithmic?this.logarithmic.log2lin(this.dataMin):this.dataMin);b=N(C);a=[b+l,u(d.max,b+l)];w&&(a[2]=c?c.log2lin(this.dataMax):this.dataMax);a=M(a);a-b<l&&(C[0]=a-l,C[1]=u(d.min,a-l),b=N(C))}this.min=b;this.max=
a};B.prototype.getClosest=function(){var d;this.categories?d=1:this.series.forEach(function(b){var a=b.closestPointRange,c=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&J(a)&&c&&(d=J(d)?Math.min(d,a):a)});return d};B.prototype.nameToX=function(d){var b=h(this.categories),a=b?this.categories:this.names,c=d.options.x;d.series.requireSorting=!1;J(c)||(c=!1===this.options.uniqueNames?d.series.autoIncrement():b?a.indexOf(d.name):u(a.keys[d.name],-1));if(-1===c){if(!b)var e=a.length}else e=
c;"undefined"!==typeof e&&(this.names[e]=d.name,this.names.keys[d.name]=e);return e};B.prototype.updateNames=function(){var d=this,b=this.names;0<b.length&&(Object.keys(b.keys).forEach(function(d){delete b.keys[d]}),b.length=0,this.minRange=this.userMinRange,(this.series||[]).forEach(function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)d.max=Math.max(d.max,b.xData.length-1),b.processData(),b.generatePoints();b.data.forEach(function(a,c){if(a&&a.options&&"undefined"!==typeof a.name){var n=d.nameToX(a);
"undefined"!==typeof n&&n!==a.x&&(a.x=n,b.xData[c]=n)}})}))};B.prototype.setAxisTranslation=function(d){var b=this,a=b.max-b.min,c=b.axisPointRange||0,e=0,f=0,m=b.linkedParent,p=!!b.categories,h=b.transA,w=b.isXAxis;if(w||p||c){var C=b.getClosest();m?(e=m.minPointOffset,f=m.pointRangePadding):b.series.forEach(function(d){var a=p?1:w?u(d.options.pointRange,C,0):b.axisPointRange||0,n=d.options.pointPlacement;c=Math.max(c,a);if(!b.single||p)d=d.is("xrange")?!w:w,e=Math.max(e,d&&l(n)?0:a/2),f=Math.max(f,
d&&"on"===n?0:a)});m=b.ordinal&&b.ordinal.slope&&C?b.ordinal.slope/C:1;b.minPointOffset=e*=m;b.pointRangePadding=f*=m;b.pointRange=Math.min(c,b.single&&p?1:a);w&&(b.closestPointRange=C)}d&&(b.oldTransA=h);b.translationSlope=b.transA=h=b.staticScale||b.len/(a+f||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=h*e;t(this,"afterSetAxisTranslation")};B.prototype.minFromRange=function(){return this.max-this.range};B.prototype.setTickInterval=function(d){var b=this,n=b.chart,e=b.logarithmic,f=b.options,
m=b.isXAxis,p=b.isLinked,h=f.maxPadding,w=f.minPadding,l=f.tickInterval,C=f.tickPixelInterval,F=b.categories,B=a(b.threshold)?b.threshold:null,L=b.softThreshold;b.dateTime||F||p||this.getTickAmount();var O=u(b.userMin,f.min);var q=u(b.userMax,f.max);if(p){b.linkedParent=n[b.coll][f.linkedTo];var z=b.linkedParent.getExtremes();b.min=u(z.min,z.dataMin);b.max=u(z.max,z.dataMax);f.type!==b.linkedParent.options.type&&D(11,1,n)}else{if(!L&&J(B))if(b.dataMin>=B)z=B,w=0;else if(b.dataMax<=B){var g=B;h=0}b.min=
u(O,z,b.dataMin);b.max=u(q,g,b.dataMax)}e&&(b.positiveValuesOnly&&!d&&0>=Math.min(b.min,u(b.dataMin,b.min))&&D(10,1,n),b.min=I(e.log2lin(b.min),16),b.max=I(e.log2lin(b.max),16));b.range&&J(b.max)&&(b.userMin=b.min=O=Math.max(b.dataMin,b.minFromRange()),b.userMax=q=b.max,b.range=null);t(b,"foundExtremes");b.beforePadding&&b.beforePadding();b.adjustForMinRange();!(F||b.axisPointRange||b.stacking&&b.stacking.usePercentage||p)&&J(b.min)&&J(b.max)&&(n=b.max-b.min)&&(!J(O)&&w&&(b.min-=n*w),!J(q)&&h&&(b.max+=
n*h));a(b.userMin)||(a(f.softMin)&&f.softMin<b.min&&(b.min=O=f.softMin),a(f.floor)&&(b.min=Math.max(b.min,f.floor)));a(b.userMax)||(a(f.softMax)&&f.softMax>b.max&&(b.max=q=f.softMax),a(f.ceiling)&&(b.max=Math.min(b.max,f.ceiling)));L&&J(b.dataMin)&&(B=B||0,!J(O)&&b.min<B&&b.dataMin>=B?b.min=b.options.minRange?Math.min(B,b.max-b.minRange):B:!J(q)&&b.max>B&&b.dataMax<=B&&(b.max=b.options.minRange?Math.max(B,b.min+b.minRange):B));b.tickInterval=b.min===b.max||"undefined"===typeof b.min||"undefined"===
typeof b.max?1:p&&!l&&C===b.linkedParent.options.tickPixelInterval?l=b.linkedParent.tickInterval:u(l,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,F?1:(b.max-b.min)*C/Math.max(b.len,C));m&&!d&&b.series.forEach(function(d){d.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.ordinal&&(b.tickInterval=b.ordinal.postProcessTickInterval(b.tickInterval));b.pointRange&&!l&&(b.tickInterval=Math.max(b.pointRange,
b.tickInterval));d=u(f.minTickInterval,b.dateTime&&b.closestPointRange);!l&&b.tickInterval<d&&(b.tickInterval=d);b.dateTime||b.logarithmic||l||(b.tickInterval=c(b.tickInterval,void 0,r(b.tickInterval),u(f.allowDecimals,.5>b.tickInterval||void 0!==this.tickAmount),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()};B.prototype.setTickPositions=function(){var d=this.options,b=d.tickPositions;var a=this.getMinorTickInterval();var c=d.tickPositioner,e=this.hasVerticalPanning(),
f="colorAxis"===this.coll,m=(f||!e)&&d.startOnTick;e=(f||!e)&&d.endOnTick;this.tickmarkOffset=this.categories&&"between"===d.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===a&&this.tickInterval?this.tickInterval/5:a;this.single=this.min===this.max&&J(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==d.allowDecimals);this.tickPositions=a=b&&b.slice();!a&&(this.ordinal&&this.ordinal.positions||!((this.max-this.min)/this.tickInterval>Math.max(2*this.len,
200))?a=this.dateTime?this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval,d.units),this.min,this.max,d.startOfWeek,this.ordinal&&this.ordinal.positions,this.closestPointRange,!0):this.logarithmic?this.logarithmic.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max):(a=[this.min,this.max],D(19,!1,this.chart)),a.length>this.len&&(a=[a[0],a.pop()],a[0]===a[1]&&(a.length=1)),this.tickPositions=a,c&&(c=c.apply(this,
[this.min,this.max])))&&(this.tickPositions=a=c);this.paddedTicks=a.slice(0);this.trimTicks(a,m,e);this.isLinked||(this.single&&2>a.length&&!this.categories&&!this.series.some(function(b){return b.is("heatmap")&&"between"===b.options.pointPlacement})&&(this.min-=.5,this.max+=.5),b||c||this.adjustTickAmount());t(this,"afterSetTickPositions")};B.prototype.trimTicks=function(d,b,a){var c=d[0],n=d[d.length-1],e=!this.isOrdinal&&this.minPointOffset||0;t(this,"trimTicks");if(!this.isLinked){if(b&&-Infinity!==
c)this.min=c;else for(;this.min-e>d[0];)d.shift();if(a)this.max=n;else for(;this.max+e<d[d.length-1];)d.pop();0===d.length&&J(c)&&!this.options.tickPositions&&d.push((n+c)/2)}};B.prototype.alignToOthers=function(){var d={},b,a=this.options;!1===this.chart.options.chart.alignTicks||!1===a.alignTicks||!1===a.startOnTick||!1===a.endOnTick||this.logarithmic||this.chart[this.coll].forEach(function(a){var c=a.options;c=[a.horiz?c.left:c.top,c.width,c.height,c.pane].join();a.series.length&&(d[c]?b=!0:d[c]=
1)});return b};B.prototype.getTickAmount=function(){var d=this.options,b=d.tickAmount,a=d.tickPixelInterval;!J(d.tickInterval)&&!b&&this.len<a&&!this.isRadial&&!this.logarithmic&&d.startOnTick&&d.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/a)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b};B.prototype.adjustTickAmount=function(){var d=this.options,b=this.tickInterval,a=this.tickPositions,c=this.tickAmount,e=this.finalTickAmt,f=a&&a.length,m=u(this.threshold,this.softThreshold?
0:null),p;if(this.hasData()){if(f<c){for(p=this.min;a.length<c;)a.length%2||p===m?a.push(I(a[a.length-1]+b)):a.unshift(I(a[0]-b));this.transA*=(f-1)/(c-1);this.min=d.startOnTick?a[0]:Math.min(this.min,a[0]);this.max=d.endOnTick?a[a.length-1]:Math.max(this.max,a[a.length-1])}else f>c&&(this.tickInterval*=2,this.setTickPositions());if(J(e)){for(b=d=a.length;b--;)(3===e&&1===b%2||2>=e&&0<b&&b<d-1)&&a.splice(b,1);this.finalTickAmt=void 0}}};B.prototype.setScale=function(){var d,b=!1,a=!1;this.series.forEach(function(d){var c;
b=b||d.isDirtyData||d.isDirty;a=a||(null===(c=d.xAxis)||void 0===c?void 0:c.isDirty)||!1});this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();(d=this.len!==this.oldAxisLength)||b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.stacking&&this.stacking.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,
this.isDirty||(this.isDirty=d||this.min!==this.oldMin||this.max!==this.oldMax)):this.stacking&&this.stacking.cleanStacks();b&&this.panningState&&(this.panningState.isDirty=!0);t(this,"afterSetScale")};B.prototype.setExtremes=function(d,b,a,c,e){var n=this,f=n.chart;a=u(a,!0);n.series.forEach(function(b){delete b.kdTree});e=z(e,{min:d,max:b});t(n,"setExtremes",e,function(){n.userMin=d;n.userMax=b;n.eventArgs=e;a&&f.redraw(c)})};B.prototype.zoom=function(d,b){var a=this,c=this.dataMin,e=this.dataMax,
f=this.options,m=Math.min(c,u(f.min,c)),p=Math.max(e,u(f.max,e));d={newMin:d,newMax:b};t(this,"zoom",d,function(b){var d=b.newMin,n=b.newMax;if(d!==a.min||n!==a.max)a.allowZoomOutside||(J(c)&&(d<m&&(d=m),d>p&&(d=p)),J(e)&&(n<m&&(n=m),n>p&&(n=p))),a.displayBtn="undefined"!==typeof d||"undefined"!==typeof n,a.setExtremes(d,n,!1,void 0,{trigger:"zoom"});b.zoomed=!0});return d.zoomed};B.prototype.setAxisSize=function(){var d=this.chart,b=this.options,a=b.offsets||[0,0,0,0],c=this.horiz,e=this.width=Math.round(L(u(b.width,
d.plotWidth-a[3]+a[1]),d.plotWidth)),f=this.height=Math.round(L(u(b.height,d.plotHeight-a[0]+a[2]),d.plotHeight)),m=this.top=Math.round(L(u(b.top,d.plotTop+a[0]),d.plotHeight,d.plotTop));b=this.left=Math.round(L(u(b.left,d.plotLeft+a[3]),d.plotWidth,d.plotLeft));this.bottom=d.chartHeight-f-m;this.right=d.chartWidth-e-b;this.len=Math.max(c?e:f,0);this.pos=c?b:m};B.prototype.getExtremes=function(){var d=this.logarithmic;return{min:d?I(d.lin2log(this.min)):this.min,max:d?I(d.lin2log(this.max)):this.max,
dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}};B.prototype.getThreshold=function(d){var b=this.logarithmic,a=b?b.lin2log(this.min):this.min;b=b?b.lin2log(this.max):this.max;null===d||-Infinity===d?d=a:Infinity===d?d=b:a>d?d=a:b<d&&(d=b);return this.translate(d,0,1,0,1)};B.prototype.autoLabelAlign=function(d){var b=(u(d,0)-90*this.side+720)%360;d={align:"center"};t(this,"autoLabelAlign",d,function(d){15<b&&165>b?d.align="right":195<b&&345>b&&(d.align="left")});
return d.align};B.prototype.tickSize=function(d){var b=this.options,a=b["tick"===d?"tickLength":"minorTickLength"],c=u(b["tick"===d?"tickWidth":"minorTickWidth"],"tick"===d&&this.isXAxis&&!this.categories?1:0);if(c&&a){"inside"===b[d+"Position"]&&(a=-a);var e=[a,c]}d={tickSize:e};t(this,"afterTickSize",d);return d.tickSize};B.prototype.labelMetrics=function(){var d=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,
this.ticks[d]&&this.ticks[d].label)};B.prototype.unsquish=function(){var d=this.options.labels,b=this.horiz,a=this.tickInterval,c=a,e=this.len/(((this.categories?1:0)+this.max-this.min)/a),f,m=d.rotation,p=this.labelMetrics(),h,w=Number.MAX_VALUE,l,C=this.max-this.min,F=function(b){var d=b/(e||1);d=1<d?Math.ceil(d):1;d*a>C&&Infinity!==b&&Infinity!==e&&C&&(d=Math.ceil(C/a));return I(d*a)};b?(l=!d.staggerLines&&!d.step&&(J(m)?[m]:e<u(d.autoRotationLimit,80)&&d.autoRotation))&&l.forEach(function(b){if(b===
m||b&&-90<=b&&90>=b){h=F(Math.abs(p.h/Math.sin(O*b)));var d=h+Math.abs(b/360);d<w&&(w=d,f=b,c=h)}}):d.step||(c=F(p.h));this.autoRotation=l;this.labelRotation=u(f,m);return c};B.prototype.getSlotWidth=function(d){var b,c=this.chart,e=this.horiz,f=this.options.labels,m=Math.max(this.tickPositions.length-(this.categories?0:1),1),u=c.margin[3];if(d&&a(d.slotWidth))return d.slotWidth;if(e&&f&&2>(f.step||0))return f.rotation?0:(this.staggerLines||1)*this.len/m;if(!e){d=null===(b=null===f||void 0===f?void 0:
f.style)||void 0===b?void 0:b.width;if(void 0!==d)return parseInt(d,10);if(u)return u-c.spacing[3]}return.33*c.chartWidth};B.prototype.renderUnsquish=function(){var d=this.chart,b=d.renderer,a=this.tickPositions,c=this.ticks,e=this.options.labels,f=e&&e.style||{},m=this.horiz,u=this.getSlotWidth(),p=Math.max(1,Math.round(u-2*(e.padding||5))),h={},w=this.labelMetrics(),C=e.style&&e.style.textOverflow,F=0;l(e.rotation)||(h.rotation=e.rotation||0);a.forEach(function(b){b=c[b];b.movedLabel&&b.replaceMovedLabel();
b&&b.label&&b.label.textPxLength>F&&(F=b.label.textPxLength)});this.maxLabelLength=F;if(this.autoRotation)F>p&&F>w.h?h.rotation=this.labelRotation:this.labelRotation=0;else if(u){var B=p;if(!C){var L="clip";for(p=a.length;!m&&p--;){var r=a[p];if(r=c[r].label)r.styles&&"ellipsis"===r.styles.textOverflow?r.css({textOverflow:"clip"}):r.textPxLength>u&&r.css({width:u+"px"}),r.getBBox().height>this.len/a.length-(w.h-w.f)&&(r.specificTextOverflow="ellipsis")}}}h.rotation&&(B=F>.5*d.chartHeight?.33*d.chartHeight:
F,C||(L="ellipsis"));if(this.labelAlign=e.align||this.autoLabelAlign(this.labelRotation))h.align=this.labelAlign;a.forEach(function(b){var d=(b=c[b])&&b.label,a=f.width,e={};d&&(d.attr(h),b.shortenLabel?b.shortenLabel():B&&!a&&"nowrap"!==f.whiteSpace&&(B<d.textPxLength||"SPAN"===d.element.tagName)?(e.width=B+"px",C||(e.textOverflow=d.specificTextOverflow||L),d.css(e)):d.styles&&d.styles.width&&!e.width&&!a&&d.css({width:null}),delete d.specificTextOverflow,b.rotation=h.rotation)},this);this.tickRotCorr=
b.rotCorr(w.b,this.labelRotation||0,0!==this.side)};B.prototype.hasData=function(){return this.series.some(function(d){return d.hasData()})||this.options.showEmpty&&J(this.min)&&J(this.max)};B.prototype.addTitle=function(d){var b=this.chart.renderer,a=this.horiz,c=this.opposite,f=this.options.title,m,u=this.chart.styledMode;this.axisTitle||((m=f.textAlign)||(m=(a?{low:"left",middle:"center",high:"right"}:{low:c?"right":"left",middle:"center",high:c?"left":"right"})[f.align]),this.axisTitle=b.text(f.text,
0,0,f.useHTML).attr({zIndex:7,rotation:f.rotation||0,align:m}).addClass("highcharts-axis-title"),u||this.axisTitle.css(e(f.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);u||f.style.width||this.isRadial||this.axisTitle.css({width:this.len+"px"});this.axisTitle[d?"show":"hide"](d)};B.prototype.generateTick=function(d){var b=this.ticks;b[d]?b[d].addLabel():b[d]=new H(this,d)};B.prototype.getOffset=function(){var d=this,b=d.chart,a=b.renderer,c=d.options,e=d.tickPositions,f=d.ticks,
p=d.horiz,h=d.side,w=b.inverted&&!d.isZAxis?[1,0,3,2][h]:h,l,C=0,F=0,B=c.title,r=c.labels,L=0,O=b.axisOffset;b=b.clipOffset;var q=[-1,1,1,-1][h],z=c.className,g=d.axisParent;var k=d.hasData();d.showAxis=l=k||u(c.showEmpty,!0);d.staggerLines=d.horiz&&r.staggerLines;d.axisGroup||(d.gridGroup=a.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(z||"")).add(g),d.axisGroup=a.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+
" "+(z||"")).add(g),d.labelGroup=a.g("axis-labels").attr({zIndex:r.zIndex||7}).addClass("highcharts-"+d.coll.toLowerCase()+"-labels "+(z||"")).add(g));k||d.isLinked?(e.forEach(function(b,a){d.generateTick(b,a)}),d.renderUnsquish(),d.reserveSpaceDefault=0===h||2===h||{1:"left",3:"right"}[h]===d.labelAlign,u(r.reserveSpace,"center"===d.labelAlign?!0:null,d.reserveSpaceDefault)&&e.forEach(function(b){L=Math.max(f[b].getLabelSize(),L)}),d.staggerLines&&(L*=d.staggerLines),d.labelOffset=L*(d.opposite?
-1:1)):m(f,function(b,d){b.destroy();delete f[d]});if(B&&B.text&&!1!==B.enabled&&(d.addTitle(l),l&&!1!==B.reserveSpace)){d.titleOffset=C=d.axisTitle.getBBox()[p?"height":"width"];var y=B.offset;F=J(y)?0:u(B.margin,p?5:10)}d.renderLine();d.offset=q*u(c.offset,O[h]?O[h]+(c.margin||0):0);d.tickRotCorr=d.tickRotCorr||{x:0,y:0};a=0===h?-d.labelMetrics().h:2===h?d.tickRotCorr.y:0;F=Math.abs(L)+F;L&&(F=F-a+q*(p?u(r.y,d.tickRotCorr.y+8*q):r.x));d.axisTitleMargin=u(y,F);d.getMaxLabelDimensions&&(d.maxLabelDimensions=
d.getMaxLabelDimensions(f,e));p=this.tickSize("tick");O[h]=Math.max(O[h],d.axisTitleMargin+C+q*d.offset,F,e&&e.length&&p?p[0]+q*d.offset:0);c=c.offset?0:2*Math.floor(d.axisLine.strokeWidth()/2);b[w]=Math.max(b[w],c);t(this,"afterGetOffset")};B.prototype.getLinePath=function(d){var b=this.chart,a=this.opposite,c=this.offset,e=this.horiz,f=this.left+(a?this.width:0)+c;c=b.chartHeight-this.bottom-(a?this.height:0)+c;a&&(d*=-1);return b.renderer.crispLine([["M",e?this.left:f,e?c:this.top],["L",e?b.chartWidth-
this.right:f,e?c:b.chartHeight-this.bottom]],d)};B.prototype.renderLine=function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))};B.prototype.getTitlePosition=function(){var d=this.horiz,b=this.left,a=this.top,c=this.len,e=this.options.title,f=d?b:a,m=this.opposite,u=this.offset,p=e.x||0,h=e.y||0,w=this.axisTitle,
l=this.chart.renderer.fontMetrics(e.style&&e.style.fontSize,w);w=Math.max(w.getBBox(null,0).height-l.h-1,0);c={low:f+(d?0:c),middle:f+c/2,high:f+(d?c:0)}[e.align];b=(d?a+this.height:b)+(d?1:-1)*(m?-1:1)*this.axisTitleMargin+[-w,w,l.f,-w][this.side];d={x:d?c+p:b+(m?this.width:0)+u+p,y:d?b+h-(m?this.height:0)+u:c+h};t(this,"afterGetTitlePosition",{titlePosition:d});return d};B.prototype.renderMinorTick=function(d){var b=this.chart.hasRendered&&a(this.oldMin),c=this.minorTicks;c[d]||(c[d]=new H(this,
d,"minor"));b&&c[d].isNew&&c[d].render(null,!0);c[d].render(null,!1,1)};B.prototype.renderTick=function(d,b){var c=this.isLinked,e=this.ticks,f=this.chart.hasRendered&&a(this.oldMin);if(!c||d>=this.min&&d<=this.max)e[d]||(e[d]=new H(this,d)),f&&e[d].isNew&&e[d].render(b,!0,-1),e[d].render(b)};B.prototype.render=function(){var d=this,b=d.chart,c=d.logarithmic,e=d.options,f=d.isLinked,u=d.tickPositions,h=d.axisTitle,w=d.ticks,l=d.minorTicks,C=d.alternateBands,F=e.stackLabels,B=e.alternateGridColor,
L=d.tickmarkOffset,r=d.axisLine,O=d.showAxis,q=G(b.renderer.globalAnimation),z,k;d.labelEdge.length=0;d.overlap=!1;[w,l,C].forEach(function(b){m(b,function(b){b.isActive=!1})});if(d.hasData()||f)d.minorTickInterval&&!d.categories&&d.getMinorTickPositions().forEach(function(b){d.renderMinorTick(b)}),u.length&&(u.forEach(function(b,a){d.renderTick(b,a)}),L&&(0===d.min||d.single)&&(w[-1]||(w[-1]=new H(d,-1,null,!0)),w[-1].render(-1))),B&&u.forEach(function(a,e){k="undefined"!==typeof u[e+1]?u[e+1]+L:
d.max-L;0===e%2&&a<d.max&&k<=d.max+(b.polar?-L:L)&&(C[a]||(C[a]=new g.PlotLineOrBand(d)),z=a+L,C[a].options={from:c?c.lin2log(z):z,to:c?c.lin2log(k):k,color:B},C[a].render(),C[a].isActive=!0)}),d._addedPlotLB||((e.plotLines||[]).concat(e.plotBands||[]).forEach(function(b){d.addPlotBandOrLine(b)}),d._addedPlotLB=!0);[w,l,C].forEach(function(d){var a,c=[],e=q.duration;m(d,function(b,d){b.isActive||(b.render(d,!1,0),b.isActive=!1,c.push(d))});p(function(){for(a=c.length;a--;)d[c[a]]&&!d[c[a]].isActive&&
(d[c[a]].destroy(),delete d[c[a]])},d!==C&&b.hasRendered&&e?e:0)});r&&(r[r.isPlaced?"animate":"attr"]({d:this.getLinePath(r.strokeWidth())}),r.isPlaced=!0,r[O?"show":"hide"](O));h&&O&&(e=d.getTitlePosition(),a(e.y)?(h[h.isNew?"attr":"animate"](e),h.isNew=!1):(h.attr("y",-9999),h.isNew=!0));F&&F.enabled&&d.stacking&&d.stacking.renderStackTotals();d.isDirty=!1;t(this,"afterRender")};B.prototype.redraw=function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(d){d.render()}));this.series.forEach(function(d){d.isDirty=
!0})};B.prototype.getKeepProps=function(){return this.keepProps||B.keepProps};B.prototype.destroy=function(d){var b=this,a=b.plotLinesAndBands,c;t(this,"destroy",{keepEvents:d});d||F(b);[b.ticks,b.minorTicks,b.alternateBands].forEach(function(b){E(b)});if(a)for(d=a.length;d--;)a[d].destroy();"axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(d){b[d]&&(b[d]=b[d].destroy())});for(c in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[c]=b.plotLinesAndBandsGroups[c].destroy();
m(b,function(d,a){-1===b.getKeepProps().indexOf(a)&&delete b[a]})};B.prototype.drawCrosshair=function(d,b){var a=this.crosshair,c=u(a.snap,!0),e,f=this.cross,m=this.chart;t(this,"drawCrosshair",{e:d,point:b});d||(d=this.cross&&this.cross.e);if(this.crosshair&&!1!==(J(b)||!c)){c?J(b)&&(e=u("colorAxis"!==this.coll?b.crosshairPos:null,this.isXAxis?b.plotX:this.len-b.plotY)):e=d&&(this.horiz?d.chartX-this.pos:this.len-d.chartY+this.pos);if(J(e)){var p={value:b&&(this.isXAxis?b.x:u(b.stackY,b.y)),translatedValue:e};
m.polar&&z(p,{isCrosshair:!0,chartX:d&&d.chartX,chartY:d&&d.chartY,point:b});p=this.getPlotLinePath(p)||null}if(!J(p)){this.hideCrosshair();return}c=this.categories&&!this.isRadial;f||(this.cross=f=m.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(c?"category ":"thin ")+a.className).attr({zIndex:u(a.zIndex,2)}).add(),m.styledMode||(f.attr({stroke:a.color||(c?k.parse("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":u(a.width,1)}).css({"pointer-events":"none"}),a.dashStyle&&
f.attr({dashstyle:a.dashStyle})));f.show().attr({d:p});c&&!a.width&&f.attr({"stroke-width":this.transA});this.cross.e=d}else this.hideCrosshair();t(this,"afterDrawCrosshair",{e:d,point:b})};B.prototype.hideCrosshair=function(){this.cross&&this.cross.hide();t(this,"afterHideCrosshair")};B.prototype.hasVerticalPanning=function(){var d,b;return/y/.test((null===(b=null===(d=this.chart.options.chart)||void 0===d?void 0:d.panning)||void 0===b?void 0:b.type)||"")};B.defaultOptions={dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"};B.defaultYAxisOptions={endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){var d=this.axis.chart.numberFormatter;return d(this.total,
-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0};B.defaultLeftAxisOptions={labels:{x:-15},title:{rotation:270}};B.defaultRightAxisOptions={labels:{x:15},title:{rotation:90}};B.defaultBottomAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};B.defaultTopAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};B.keepProps="extKey hcEvents names series userMax userMin".split(" ");return B}();
g.Axis=v;return g.Axis});P(A,"parts/DateTimeAxis.js",[A["parts/Axis.js"],A["parts/Utilities.js"]],function(k,g){var H=g.addEvent,v=g.getMagnitude,K=g.normalizeTickInterval,G=g.timeUnits,N=function(){function g(g){this.axis=g}g.prototype.normalizeTimeTickInterval=function(g,k){var y=k||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];k=y[y.length-1];var E=
G[k[0]],D=k[1],z;for(z=0;z<y.length&&!(k=y[z],E=G[k[0]],D=k[1],y[z+1]&&g<=(E*D[D.length-1]+G[y[z+1][0]])/2);z++);E===G.year&&g<5*E&&(D=[1,2,5]);g=K(g/E,D,"year"===k[0]?Math.max(v(g/E),1):1);return{unitRange:E,count:g,unitName:k[0]}};return g}();g=function(){function g(){}g.compose=function(g){g.keepProps.push("dateTime");g.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};H(g,"init",function(g){"datetime"!==g.userOptions.type?this.dateTime=void 0:
this.dateTime||(this.dateTime=new N(this))})};g.AdditionsClass=N;return g}();g.compose(k);return g});P(A,"parts/LogarithmicAxis.js",[A["parts/Axis.js"],A["parts/Utilities.js"]],function(k,g){var H=g.addEvent,v=g.getMagnitude,K=g.normalizeTickInterval,G=g.pick,N=function(){function g(g){this.axis=g}g.prototype.getLogTickPositions=function(g,k,J,E){var y=this.axis,z=y.len,t=y.options,q=[];E||(this.minorAutoInterval=void 0);if(.5<=g)g=Math.round(g),q=y.getLinearTickPositions(g,k,J);else if(.08<=g){t=
Math.floor(k);var r,h;for(z=.3<g?[1,2,4]:.15<g?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];t<J+1&&!h;t++){var f=z.length;for(r=0;r<f&&!h;r++){var a=this.log2lin(this.lin2log(t)*z[r]);a>k&&(!E||l<=J)&&"undefined"!==typeof l&&q.push(l);l>J&&(h=!0);var l=a}}}else k=this.lin2log(k),J=this.lin2log(J),g=E?y.getMinorTickInterval():t.tickInterval,g=G("auto"===g?null:g,this.minorAutoInterval,t.tickPixelInterval/(E?5:1)*(J-k)/((E?z/y.tickPositions.length:z)||1)),g=K(g,void 0,v(g)),q=y.getLinearTickPositions(g,k,J).map(this.log2lin),
E||(this.minorAutoInterval=g/5);E||(y.tickInterval=g);return q};g.prototype.lin2log=function(g){return Math.pow(10,g)};g.prototype.log2lin=function(g){return Math.log(g)/Math.LN10};return g}();g=function(){function g(){}g.compose=function(g){g.keepProps.push("logarithmic");var k=g.prototype,y=N.prototype;k.log2lin=y.log2lin;k.lin2log=y.lin2log;H(g,"init",function(g){var k=this.logarithmic;"logarithmic"!==g.userOptions.type?this.logarithmic=void 0:(k||(k=this.logarithmic=new N(this)),this.log2lin!==
k.log2lin&&(k.log2lin=this.log2lin.bind(this)),this.lin2log!==k.lin2log&&(k.lin2log=this.lin2log.bind(this)))});H(g,"afterInit",function(){var g=this.logarithmic;g&&(this.lin2val=function(k){return g.lin2log(k)},this.val2lin=function(k){return g.log2lin(k)})})};return g}();g.compose(k);return g});P(A,"parts/PlotLineOrBand.js",[A["parts/Globals.js"],A["parts/Axis.js"],A["parts/Utilities.js"]],function(k,g,H){var v=H.arrayMax,K=H.arrayMin,G=H.defined,N=H.destroyObjectProperties,M=H.erase,y=H.extend,
I=H.merge,J=H.objectEach,E=H.pick,D=function(){function g(t,q){this.axis=t;q&&(this.options=q,this.id=q.id)}g.prototype.render=function(){k.fireEvent(this,"render");var t=this,q=t.axis,r=q.horiz,h=q.logarithmic,f=t.options,a=f.label,l=t.label,e=f.to,c=f.from,m=f.value,u=G(c)&&G(e),L=G(m),F=t.svgElem,w=!F,p=[],C=f.color,O=E(f.zIndex,0),B=f.events;p={"class":"highcharts-plot-"+(u?"band ":"line ")+(f.className||"")};var d={},b=q.chart.renderer,n=u?"bands":"lines";h&&(c=h.log2lin(c),e=h.log2lin(e),m=
h.log2lin(m));q.chart.styledMode||(L?(p.stroke=C||"#999999",p["stroke-width"]=E(f.width,1),f.dashStyle&&(p.dashstyle=f.dashStyle)):u&&(p.fill=C||"#e6ebf5",f.borderWidth&&(p.stroke=f.borderColor,p["stroke-width"]=f.borderWidth)));d.zIndex=O;n+="-"+O;(h=q.plotLinesAndBandsGroups[n])||(q.plotLinesAndBandsGroups[n]=h=b.g("plot-"+n).attr(d).add());w&&(t.svgElem=F=b.path().attr(p).add(h));if(L)p=q.getPlotLinePath({value:m,lineWidth:F.strokeWidth(),acrossPanes:f.acrossPanes});else if(u)p=q.getPlotBandPath(c,
e,f);else return;(w||!F.d)&&p&&p.length?(F.attr({d:p}),B&&J(B,function(b,d){F.on(d,function(b){B[d].apply(t,[b])})})):F&&(p?(F.show(!0),F.animate({d:p})):F.d&&(F.hide(),l&&(t.label=l=l.destroy())));a&&(G(a.text)||G(a.formatter))&&p&&p.length&&0<q.width&&0<q.height&&!p.isFlat?(a=I({align:r&&u&&"center",x:r?!u&&4:10,verticalAlign:!r&&u&&"middle",y:r?u?16:10:u?6:-4,rotation:r&&!u&&90},a),this.renderLabel(a,p,u,O)):l&&l.hide();return t};g.prototype.renderLabel=function(t,q,r,h){var f=this.label,a=this.axis.chart.renderer;
f||(f={align:t.textAlign||t.align,rotation:t.rotation,"class":"highcharts-plot-"+(r?"band":"line")+"-label "+(t.className||"")},f.zIndex=h,h=this.getLabelText(t),this.label=f=a.text(h,0,0,t.useHTML).attr(f).add(),this.axis.chart.styledMode||f.css(t.style));a=q.xBounds||[q[0][1],q[1][1],r?q[2][1]:q[0][1]];q=q.yBounds||[q[0][2],q[1][2],r?q[2][2]:q[0][2]];r=K(a);h=K(q);f.align(t,!1,{x:r,y:h,width:v(a)-r,height:v(q)-h});f.show(!0)};g.prototype.getLabelText=function(t){return G(t.formatter)?t.formatter.call(this):
t.text};g.prototype.destroy=function(){M(this.axis.plotLinesAndBands,this);delete this.axis;N(this)};return g}();y(g.prototype,{getPlotBandPath:function(g,t){var q=this.getPlotLinePath({value:t,force:!0,acrossPanes:this.options.acrossPanes}),r=this.getPlotLinePath({value:g,force:!0,acrossPanes:this.options.acrossPanes}),h=[],f=this.horiz,a=1;g=g<this.min&&t<this.min||g>this.max&&t>this.max;if(r&&q){if(g){var l=r.toString()===q.toString();a=0}for(g=0;g<r.length;g+=2){t=r[g];var e=r[g+1],c=q[g],m=q[g+
1];"M"!==t[0]&&"L"!==t[0]||"M"!==e[0]&&"L"!==e[0]||"M"!==c[0]&&"L"!==c[0]||"M"!==m[0]&&"L"!==m[0]||(f&&c[1]===t[1]?(c[1]+=a,m[1]+=a):f||c[2]!==t[2]||(c[2]+=a,m[2]+=a),h.push(["M",t[1],t[2]],["L",e[1],e[2]],["L",m[1],m[2]],["L",c[1],c[2]],["Z"]));h.isFlat=l}}return h},addPlotBand:function(g){return this.addPlotBandOrLine(g,"plotBands")},addPlotLine:function(g){return this.addPlotBandOrLine(g,"plotLines")},addPlotBandOrLine:function(g,t){var q=(new D(this,g)).render(),r=this.userOptions;if(q){if(t){var h=
r[t]||[];h.push(g);r[t]=h}this.plotLinesAndBands.push(q)}return q},removePlotBandOrLine:function(g){for(var t=this.plotLinesAndBands,q=this.options,r=this.userOptions,h=t.length;h--;)t[h].id===g&&t[h].destroy();[q.plotLines||[],r.plotLines||[],q.plotBands||[],r.plotBands||[]].forEach(function(f){for(h=f.length;h--;)(f[h]||{}).id===g&&M(f,f[h])})},removePlotBand:function(g){this.removePlotBandOrLine(g)},removePlotLine:function(g){this.removePlotBandOrLine(g)}});k.PlotLineOrBand=D;return k.PlotLineOrBand});
P(A,"parts/Tooltip.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.clamp,v=g.css,K=g.defined,G=g.discardElement,N=g.extend,M=g.fireEvent,y=g.format,I=g.isNumber,J=g.isString,E=g.merge,D=g.pick,z=g.splat,t=g.syncTimeout,q=g.timeUnits;"";var r=k.doc,h=function(){function f(a,f){this.crosshairs=[];this.distance=0;this.isHidden=!0;this.isSticky=!1;this.now={};this.options={};this.outside=!1;this.chart=a;this.init(a,f)}f.prototype.applyFilter=function(){var a=this.chart;a.renderer.definition({tagName:"filter",
id:"drop-shadow-"+a.index,opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});a.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+a.index+"{filter:url(#drop-shadow-"+a.index+")}"})};f.prototype.bodyFormatter=function(a){return a.map(function(a){var e=
a.series.tooltipOptions;return(e[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,e[(a.point.formatPrefix||"point")+"Format"]||"")})};f.prototype.cleanSplit=function(a){this.chart.series.forEach(function(f){var e=f&&f.tt;e&&(!e.isActive||a?f.tt=e.destroy():e.isActive=!1)})};f.prototype.defaultFormatter=function(a){var f=this.points||z(this);var e=[a.tooltipFooterHeaderFormatter(f[0])];e=e.concat(a.bodyFormatter(f));e.push(a.tooltipFooterHeaderFormatter(f[0],!0));
return e};f.prototype.destroy=function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),G(this.container));g.clearTimeout(this.hideTimer);g.clearTimeout(this.tooltipTimeout)};f.prototype.getAnchor=function(a,f){var e=this.chart,c=e.pointer,m=e.inverted,u=e.plotTop,h=e.plotLeft,l=0,w=0,p,C;a=z(a);this.followPointer&&f?("undefined"===typeof f.chartX&&(f=c.normalize(f)),
a=[f.chartX-h,f.chartY-u]):a[0].tooltipPos?a=a[0].tooltipPos:(a.forEach(function(a){p=a.series.yAxis;C=a.series.xAxis;l+=a.plotX+(!m&&C?C.left-h:0);w+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!m&&p?p.top-u:0)}),l/=a.length,w/=a.length,a=[m?e.plotWidth-w:l,this.shared&&!m&&1<a.length&&f?f.chartY-u:m?e.plotHeight-l:w]);return a.map(Math.round)};f.prototype.getDateFormat=function(a,f,e,c){var m=this.chart.time,u=m.dateFormat("%m-%d %H:%M:%S.%L",f),h={millisecond:15,second:12,minute:9,hour:6,day:3},
l="millisecond";for(w in q){if(a===q.week&&+m.dateFormat("%w",f)===e&&"00:00:00.000"===u.substr(6)){var w="week";break}if(q[w]>a){w=l;break}if(h[w]&&u.substr(h[w])!=="01-01 00:00:00.000".substr(h[w]))break;"week"!==w&&(l=w)}if(w)var p=m.resolveDTLFormat(c[w]).main;return p};f.prototype.getLabel=function(){var a,f,e=this,c=this.chart.renderer,m=this.chart.styledMode,u=this.options,h="tooltip"+(K(u.className)?" "+u.className:""),F=(null===(a=u.style)||void 0===a?void 0:a.pointerEvents)||(!this.followPointer&&
u.stickOnContact?"auto":"none"),w;a=function(){e.inContact=!0};var p=function(){var a=e.chart.hoverSeries;e.inContact=!1;if(a&&a.onMouseOut)a.onMouseOut()};if(!this.label){this.outside&&(this.container=w=k.doc.createElement("div"),w.className="highcharts-tooltip-container",v(w,{position:"absolute",top:"1px",pointerEvents:F,zIndex:3}),k.doc.body.appendChild(w),this.renderer=c=new k.Renderer(w,0,0,null===(f=this.chart.options.chart)||void 0===f?void 0:f.style,void 0,void 0,c.styledMode));this.split?
this.label=c.g(h):(this.label=c.label("",0,0,u.shape||"callout",null,null,u.useHTML,null,h).attr({padding:u.padding,r:u.borderRadius}),m||this.label.attr({fill:u.backgroundColor,"stroke-width":u.borderWidth}).css(u.style).css({pointerEvents:F}).shadow(u.shadow));m&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index));if(e.outside&&!e.split){var C={x:this.label.xSetter,y:this.label.ySetter};this.label.xSetter=function(a,c){C[c].call(this.label,e.distance);w.style.left=a+
"px"};this.label.ySetter=function(a,c){C[c].call(this.label,e.distance);w.style.top=a+"px"}}this.label.on("mouseenter",a).on("mouseleave",p).attr({zIndex:8}).add()}return this.label};f.prototype.getPosition=function(a,f,e){var c=this.chart,m=this.distance,u={},h=c.inverted&&e.h||0,l,w=this.outside,p=w?r.documentElement.clientWidth-2*m:c.chartWidth,C=w?Math.max(r.body.scrollHeight,r.documentElement.scrollHeight,r.body.offsetHeight,r.documentElement.offsetHeight,r.documentElement.clientHeight):c.chartHeight,
t=c.pointer.getChartPosition(),B=c.containerScaling,d=function(b){return B?b*B.scaleX:b},b=function(b){return B?b*B.scaleY:b},n=function(n){var u="x"===n;return[n,u?p:C,u?a:f].concat(w?[u?d(a):b(f),u?t.left-m+d(e.plotX+c.plotLeft):t.top-m+b(e.plotY+c.plotTop),0,u?p:C]:[u?a:f,u?e.plotX+c.plotLeft:e.plotY+c.plotTop,u?c.plotLeft:c.plotTop,u?c.plotLeft+c.plotWidth:c.plotTop+c.plotHeight])},x=n("y"),q=n("x"),g=!this.followPointer&&D(e.ttBelow,!c.inverted===!!e.negative),z=function(a,c,e,f,n,p,w){var x=
"y"===a?b(m):d(m),l=(e-f)/2,C=f<n-m,F=n+m+f<c,B=n-x-e+l;n=n+x-l;if(g&&F)u[a]=n;else if(!g&&C)u[a]=B;else if(C)u[a]=Math.min(w-f,0>B-h?B:B-h);else if(F)u[a]=Math.max(p,n+h+e>c?n:n+h);else return!1},k=function(b,d,a,c,e){var f;e<m||e>d-m?f=!1:u[b]=e<a/2?1:e>d-c/2?d-c-2:e-a/2;return f},y=function(b){var d=x;x=q;q=d;l=b},E=function(){!1!==z.apply(0,x)?!1!==k.apply(0,q)||l||(y(!0),E()):l?u.x=u.y=0:(y(!0),E())};(c.inverted||1<this.len)&&y();E();return u};f.prototype.getXDateFormat=function(a,f,e){f=f.dateTimeLabelFormats;
var c=e&&e.closestPointRange;return(c?this.getDateFormat(c,a.x,e.options.startOfWeek,f):f.day)||f.year};f.prototype.hide=function(a){var f=this;g.clearTimeout(this.hideTimer);a=D(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=t(function(){f.getLabel().fadeOut(a?void 0:a);f.isHidden=!0},a))};f.prototype.init=function(a,f){this.chart=a;this.options=f;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=f.split&&!a.inverted&&!a.polar;this.shared=f.shared||this.split;this.outside=
D(f.outside,!(!a.scrollablePixelsX&&!a.scrollablePixelsY))};f.prototype.isStickyOnContact=function(){return!(this.followPointer||!this.options.stickOnContact||!this.inContact)};f.prototype.move=function(a,f,e,c){var m=this,u=m.now,h=!1!==m.options.animation&&!m.isHidden&&(1<Math.abs(a-u.x)||1<Math.abs(f-u.y)),l=m.followPointer||1<m.len;N(u,{x:h?(2*u.x+a)/3:a,y:h?(u.y+f)/2:f,anchorX:l?void 0:h?(2*u.anchorX+e)/3:e,anchorY:l?void 0:h?(u.anchorY+c)/2:c});m.getLabel().attr(u);m.drawTracker();h&&(g.clearTimeout(this.tooltipTimeout),
this.tooltipTimeout=setTimeout(function(){m&&m.move(a,f,e,c)},32))};f.prototype.refresh=function(a,f){var e=this.chart,c=this.options,m=a,u={},h=[],l=c.formatter||this.defaultFormatter;u=this.shared;var w=e.styledMode;if(c.enabled){g.clearTimeout(this.hideTimer);this.followPointer=z(m)[0].series.tooltipOptions.followPointer;var p=this.getAnchor(m,f);f=p[0];var C=p[1];!u||m.series&&m.series.noSharedTooltip?u=m.getLabelConfig():(e.pointer.applyInactiveState(m),m.forEach(function(a){a.setState("hover");
h.push(a.getLabelConfig())}),u={x:m[0].category,y:m[0].y},u.points=h,m=m[0]);this.len=h.length;e=l.call(u,this);l=m.series;this.distance=D(l.tooltipOptions.distance,16);!1===e?this.hide():(this.split?this.renderSplit(e,z(a)):(a=this.getLabel(),c.style.width&&!w||a.css({width:this.chart.spacingBox.width+"px"}),a.attr({text:e&&e.join?e.join(""):e}),a.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+D(m.colorIndex,l.colorIndex)),w||a.attr({stroke:c.borderColor||m.color||l.color||"#666666"}),
this.updatePosition({plotX:f,plotY:C,negative:m.negative,ttBelow:m.ttBelow,h:p[2]||0})),this.isHidden&&this.label&&this.label.attr({opacity:1}).show(),this.isHidden=!1);M(this,"refresh")}};f.prototype.renderSplit=function(a,f){function e(b,d,a,c,e){void 0===e&&(e=!0);a?(d=y?0:I,b=H(b-c/2,g.left,g.right-c)):(d-=E,b=e?b-c-x:b+x,b=H(b,e?b:g.left,g.right));return{x:b,y:d}}var c=this,m=c.chart,u=c.chart,h=u.plotHeight,l=u.plotLeft,w=u.plotTop,p=u.pointer,C=u.renderer,r=u.scrollablePixelsY,B=void 0===r?
0:r;r=u.scrollingContainer;r=void 0===r?{scrollLeft:0,scrollTop:0}:r;var d=r.scrollLeft,b=r.scrollTop,n=u.styledMode,x=c.distance,q=c.options,t=c.options.positioner,g={left:d,right:d+u.chartWidth,top:b,bottom:b+u.chartHeight},z=c.getLabel(),y=!(!m.xAxis[0]||!m.xAxis[0].opposite),E=w+b,v=0,I=h-B;J(a)&&(a=[!1,a]);a=a.slice(0,f.length+1).reduce(function(d,a,m){if(!1!==a&&""!==a){m=f[m-1]||{isHeader:!0,plotX:f[0].plotX,plotY:h,series:{}};var u=m.isHeader,p=u?c:m.series,F=p.tt,r=m.isHeader;var L=m.series;
var O="highcharts-color-"+D(m.colorIndex,L.colorIndex,"none");F||(F={padding:q.padding,r:q.borderRadius},n||(F.fill=q.backgroundColor,F["stroke-width"]=q.borderWidth),F=C.label("",0,0,q[r?"headerShape":"shape"]||"callout",void 0,void 0,q.useHTML).addClass((r?"highcharts-tooltip-header ":"")+"highcharts-tooltip-box "+O).attr(F).add(z));F.isActive=!0;F.attr({text:a});n||F.css(q.style).shadow(q.shadow).attr({stroke:q.borderColor||m.color||L.color||"#333333"});a=p.tt=F;r=a.getBBox();p=r.width+a.strokeWidth();
u&&(v=r.height,I+=v,y&&(E-=v));L=m.plotX;L=void 0===L?0:L;O=m.plotY;O=void 0===O?0:O;var k=m.series;if(m.isHeader){L=l+L;var Q=w+h/2}else F=k.xAxis,k=k.yAxis,L=F.pos+H(L,-x,F.len+x),k.pos+O>=b+w&&k.pos+O<=b+w+h-B&&(Q=k.pos+O);L=H(L,g.left-x,g.right+x);"number"===typeof Q?(r=r.height+1,O=t?t.call(c,p,r,m):e(L,Q,u,p),d.push({align:t?0:void 0,anchorX:L,anchorY:Q,boxWidth:p,point:m,rank:D(O.rank,u?1:0),size:r,target:O.y,tt:a,x:O.x})):a.isActive=!1}return d},[]);!t&&a.some(function(b){return b.x<g.left})&&
(a=a.map(function(b){var d=e(b.anchorX,b.anchorY,b.point.isHeader,b.boxWidth,!1);return N(b,{target:d.y,x:d.x})}));c.cleanSplit();k.distribute(a,I);a.forEach(function(b){var d=b.pos;b.tt.attr({visibility:"undefined"===typeof d?"hidden":"inherit",x:b.x,y:d+E,anchorX:b.anchorX,anchorY:b.anchorY})});a=c.container;m=c.renderer;c.outside&&a&&m&&(u=z.getBBox(),m.setSize(u.width+u.x,u.height+u.y,!1),p=p.getChartPosition(),a.style.left=p.left+"px",a.style.top=p.top+"px")};f.prototype.drawTracker=function(){if(this.followPointer||
!this.options.stickOnContact)this.tracker&&this.tracker.destroy();else{var a=this.chart,f=this.label,e=a.hoverPoint;if(f&&e){var c={x:0,y:0,width:0,height:0};e=this.getAnchor(e);var m=f.getBBox();e[0]+=a.plotLeft-f.translateX;e[1]+=a.plotTop-f.translateY;c.x=Math.min(0,e[0]);c.y=Math.min(0,e[1]);c.width=0>e[0]?Math.max(Math.abs(e[0]),m.width-e[0]):Math.max(Math.abs(e[0]),m.width);c.height=0>e[1]?Math.max(Math.abs(e[1]),m.height-Math.abs(e[1])):Math.max(Math.abs(e[1]),m.height);this.tracker?this.tracker.attr(c):
(this.tracker=f.renderer.rect(c).addClass("highcharts-tracker").add(f),a.styledMode||this.tracker.attr({fill:"rgba(0,0,0,0)"}))}}};f.prototype.styledModeFormat=function(a){return a.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')};f.prototype.tooltipFooterHeaderFormatter=function(a,f){var e=f?"footer":"header",c=a.series,m=c.tooltipOptions,u=m.xDateFormat,h=c.xAxis,l=h&&"datetime"===h.options.type&&
I(a.key),w=m[e+"Format"];f={isFooter:f,labelConfig:a};M(this,"headerFormatter",f,function(e){l&&!u&&(u=this.getXDateFormat(a,m,h));l&&u&&(a.point&&a.point.tooltipDateKeys||["key"]).forEach(function(a){w=w.replace("{point."+a+"}","{point."+a+":"+u+"}")});c.chart.styledMode&&(w=this.styledModeFormat(w));e.text=y(w,{point:a,series:c},this.chart)});return f.text};f.prototype.update=function(a){this.destroy();E(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,E(!0,this.options,a))};f.prototype.updatePosition=
function(a){var f=this.chart,e=f.pointer,c=this.getLabel(),m=a.plotX+f.plotLeft,u=a.plotY+f.plotTop;e=e.getChartPosition();a=(this.options.positioner||this.getPosition).call(this,c.width,c.height,a);if(this.outside){var h=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(c.width+h,c.height+h,!1);if(f=f.containerScaling)v(this.container,{transform:"scale("+f.scaleX+", "+f.scaleY+")"}),m*=f.scaleX,u*=f.scaleY;m+=e.left-a.x;u+=e.top-a.y}this.move(Math.round(a.x),Math.round(a.y||0),
m,u)};return f}();k.Tooltip=h;return k.Tooltip});P(A,"parts/Pointer.js",[A["parts/Globals.js"],A["parts/Utilities.js"],A["parts/Tooltip.js"],A["parts/Color.js"]],function(k,g,H,v){var K=g.addEvent,G=g.attr,N=g.css,M=g.defined,y=g.extend,I=g.find,J=g.fireEvent,E=g.isNumber,D=g.isObject,z=g.objectEach,t=g.offset,q=g.pick,r=g.splat,h=v.parse,f=k.charts,a=k.noop;g=function(){function l(a,c){this.lastValidTouch={};this.pinchDown=[];this.runChartClick=!1;this.chart=a;this.hasDragged=!1;this.options=c;this.unbindContainerMouseLeave=
function(){};this.init(a,c)}l.prototype.applyInactiveState=function(a){var c=[],e;(a||[]).forEach(function(a){e=a.series;c.push(e);e.linkedParent&&c.push(e.linkedParent);e.linkedSeries&&(c=c.concat(e.linkedSeries));e.navigatorSeries&&c.push(e.navigatorSeries)});this.chart.series.forEach(function(a){-1===c.indexOf(a)?a.setState("inactive",!0):a.options.inactiveOtherPoints&&a.setAllPointsToState("inactive")})};l.prototype.destroy=function(){var a=this;"undefined"!==typeof a.unDocMouseMove&&a.unDocMouseMove();
this.unbindContainerMouseLeave();k.chartCount||(k.unbindDocumentMouseUp&&(k.unbindDocumentMouseUp=k.unbindDocumentMouseUp()),k.unbindDocumentTouchEnd&&(k.unbindDocumentTouchEnd=k.unbindDocumentTouchEnd()));clearInterval(a.tooltipTimeout);z(a,function(c,e){a[e]=null})};l.prototype.drag=function(a){var c=this.chart,e=c.options.chart,f=a.chartX,l=a.chartY,F=this.zoomHor,w=this.zoomVert,p=c.plotLeft,C=c.plotTop,r=c.plotWidth,B=c.plotHeight,d=this.selectionMarker,b=this.mouseDownX||0,n=this.mouseDownY||
0,x=D(e.panning)?e.panning&&e.panning.enabled:e.panning,q=e.panKey&&a[e.panKey+"Key"];if(!d||!d.touch)if(f<p?f=p:f>p+r&&(f=p+r),l<C?l=C:l>C+B&&(l=C+B),this.hasDragged=Math.sqrt(Math.pow(b-f,2)+Math.pow(n-l,2)),10<this.hasDragged){var t=c.isInsidePlot(b-p,n-C);c.hasCartesianSeries&&(this.zoomX||this.zoomY)&&t&&!q&&!d&&(this.selectionMarker=d=c.renderer.rect(p,C,F?1:r,w?1:B,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),c.styledMode||d.attr({fill:e.selectionMarkerFill||h("#335cad").setOpacity(.25).get()}));
d&&F&&(f-=b,d.attr({width:Math.abs(f),x:(0<f?0:f)+b}));d&&w&&(f=l-n,d.attr({height:Math.abs(f),y:(0<f?0:f)+n}));t&&!d&&x&&c.pan(a,e.panning)}};l.prototype.dragStart=function(a){var c=this.chart;c.mouseIsDown=a.type;c.cancelClick=!1;c.mouseDownX=this.mouseDownX=a.chartX;c.mouseDownY=this.mouseDownY=a.chartY};l.prototype.drop=function(a){var c=this,e=this.chart,f=this.hasPinched;if(this.selectionMarker){var h={originalEvent:a,xAxis:[],yAxis:[]},l=this.selectionMarker,w=l.attr?l.attr("x"):l.x,p=l.attr?
l.attr("y"):l.y,C=l.attr?l.attr("width"):l.width,r=l.attr?l.attr("height"):l.height,B;if(this.hasDragged||f)e.axes.forEach(function(d){if(d.zoomEnabled&&M(d.min)&&(f||c[{xAxis:"zoomX",yAxis:"zoomY"}[d.coll]])){var b=d.horiz,e="touchend"===a.type?d.minPixelPadding:0,m=d.toValue((b?w:p)+e);b=d.toValue((b?w+C:p+r)-e);h[d.coll].push({axis:d,min:Math.min(m,b),max:Math.max(m,b)});B=!0}}),B&&J(e,"selection",h,function(d){e.zoom(y(d,f?{animation:!1}:null))});E(e.index)&&(this.selectionMarker=this.selectionMarker.destroy());
f&&this.scaleGroups()}e&&E(e.index)&&(N(e.container,{cursor:e._cursor}),e.cancelClick=10<this.hasDragged,e.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])};l.prototype.findNearestKDPoint=function(a,c,f){var e=this.chart,m=e.hoverPoint;e=e.tooltip;if(m&&e&&e.isStickyOnContact())return m;var h;a.forEach(function(a){var e=!(a.noSharedTooltip&&c)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(f,e);if((e=D(a,!0))&&!(e=!D(h,!0))){e=h.distX-a.distX;var m=h.dist-a.dist,u=(a.series.group&&
a.series.group.zIndex)-(h.series.group&&h.series.group.zIndex);e=0<(0!==e&&c?e:0!==m?m:0!==u?u:h.series.index>a.series.index?-1:1)}e&&(h=a)});return h};l.prototype.getChartCoordinatesFromPoint=function(a,c){var e=a.series,f=e.xAxis;e=e.yAxis;var h=q(a.clientX,a.plotX),l=a.shapeArgs;if(f&&e)return c?{chartX:f.len+f.pos-h,chartY:e.len+e.pos-a.plotY}:{chartX:h+f.pos,chartY:a.plotY+e.pos};if(l&&l.x&&l.y)return{chartX:l.x,chartY:l.y}};l.prototype.getChartPosition=function(){return this.chartPosition||
(this.chartPosition=t(this.chart.container))};l.prototype.getCoordinates=function(a){var c={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(e){c[e.isXAxis?"xAxis":"yAxis"].push({axis:e,value:e.toValue(a[e.horiz?"chartX":"chartY"])})});return c};l.prototype.getHoverData=function(a,c,f,h,l,F){var e,m=[];h=!(!h||!a);var u=c&&!c.stickyTracking,r={chartX:F?F.chartX:void 0,chartY:F?F.chartY:void 0,shared:l};J(this,"beforeGetHoverData",r);u=u?[c]:f.filter(function(a){return r.filter?r.filter(a):a.visible&&
!(!l&&a.directTouch)&&q(a.options.enableMouseTracking,!0)&&a.stickyTracking});c=(e=h||!F?a:this.findNearestKDPoint(u,l,F))&&e.series;e&&(l&&!c.noSharedTooltip?(u=f.filter(function(a){return r.filter?r.filter(a):a.visible&&!(!l&&a.directTouch)&&q(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),u.forEach(function(a){var d=I(a.points,function(b){return b.x===e.x&&!b.isNull});D(d)&&(a.chart.isBoosting&&(d=a.getPoint(d)),m.push(d))})):m.push(e));r={hoverPoint:e};J(this,"afterGetHoverData",r);return{hoverPoint:r.hoverPoint,
hoverSeries:c,hoverPoints:m}};l.prototype.getPointFromEvent=function(a){a=a.target;for(var c;a&&!c;)c=a.point,a=a.parentNode;return c};l.prototype.onTrackerMouseOut=function(a){a=a.relatedTarget||a.toElement;var c=this.chart.hoverSeries;this.isDirectTouch=!1;if(!(!c||!a||c.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+c.index)&&this.inClass(a,"highcharts-tracker")))c.onMouseOut()};l.prototype.inClass=function(a,c){for(var e;a;){if(e=G(a,"class")){if(-1!==
e.indexOf(c))return!0;if(-1!==e.indexOf("highcharts-container"))return!1}a=a.parentNode}};l.prototype.init=function(a,c){this.options=c;this.chart=a;this.runChartClick=c.chart.events&&!!c.chart.events.click;this.pinchDown=[];this.lastValidTouch={};H&&(a.tooltip=new H(a,c.tooltip),this.followTouchMove=q(c.tooltip.followTouchMove,!0));this.setDOMEvents()};l.prototype.normalize=function(a,c){var e=a.touches,f=e?e.length?e.item(0):e.changedTouches[0]:a;c||(c=this.getChartPosition());e=f.pageX-c.left;
c=f.pageY-c.top;if(f=this.chart.containerScaling)e/=f.scaleX,c/=f.scaleY;return y(a,{chartX:Math.round(e),chartY:Math.round(c)})};l.prototype.onContainerClick=function(a){var c=this.chart,e=c.hoverPoint;a=this.normalize(a);var f=c.plotLeft,h=c.plotTop;c.cancelClick||(e&&this.inClass(a.target,"highcharts-tracker")?(J(e.series,"click",y(a,{point:e})),c.hoverPoint&&e.firePointEvent("click",a)):(y(a,this.getCoordinates(a)),c.isInsidePlot(a.chartX-f,a.chartY-h)&&J(c,"click",a)))};l.prototype.onContainerMouseDown=
function(a){a=this.normalize(a);if(k.isFirefox&&0!==a.button)this.onContainerMouseMove(a);if("undefined"===typeof a.button||1===((a.buttons||a.button)&1))this.zoomOption(a),this.dragStart(a)};l.prototype.onContainerMouseLeave=function(a){var c=f[q(k.hoverChartIndex,-1)],e=this.chart.tooltip;a=this.normalize(a);c&&(a.relatedTarget||a.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=void 0);e&&!e.isHidden&&this.reset()};l.prototype.onContainerMouseMove=function(a){var c=this.chart;a=this.normalize(a);
this.setHoverChartIndex();a.preventDefault||(a.returnValue=!1);"mousedown"===c.mouseIsDown&&this.drag(a);c.openMenu||!this.inClass(a.target,"highcharts-tracker")&&!c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop)||this.runPointActions(a)};l.prototype.onDocumentTouchEnd=function(a){f[k.hoverChartIndex]&&f[k.hoverChartIndex].pointer.drop(a)};l.prototype.onContainerTouchMove=function(a){this.touch(a)};l.prototype.onContainerTouchStart=function(a){this.zoomOption(a);this.touch(a,!0)};l.prototype.onDocumentMouseMove=
function(a){var c=this.chart,e=this.chartPosition;a=this.normalize(a,e);var f=c.tooltip;!e||f&&f.isStickyOnContact()||c.isInsidePlot(a.chartX-c.plotLeft,a.chartY-c.plotTop)||this.inClass(a.target,"highcharts-tracker")||this.reset()};l.prototype.onDocumentMouseUp=function(a){var c=f[q(k.hoverChartIndex,-1)];c&&c.pointer.drop(a)};l.prototype.pinch=function(e){var c=this,f=c.chart,h=c.pinchDown,l=e.touches||[],F=l.length,w=c.lastValidTouch,p=c.hasZoom,C=c.selectionMarker,r={},B=1===F&&(c.inClass(e.target,
"highcharts-tracker")&&f.runTrackerClick||c.runChartClick),d={};1<F&&(c.initiated=!0);p&&c.initiated&&!B&&e.preventDefault();[].map.call(l,function(b){return c.normalize(b)});"touchstart"===e.type?([].forEach.call(l,function(b,d){h[d]={chartX:b.chartX,chartY:b.chartY}}),w.x=[h[0].chartX,h[1]&&h[1].chartX],w.y=[h[0].chartY,h[1]&&h[1].chartY],f.axes.forEach(function(b){if(b.zoomEnabled){var d=f.bounds[b.horiz?"h":"v"],a=b.minPixelPadding,c=b.toPixels(Math.min(q(b.options.min,b.dataMin),b.dataMin)),
e=b.toPixels(Math.max(q(b.options.max,b.dataMax),b.dataMax)),h=Math.max(c,e);d.min=Math.min(b.pos,Math.min(c,e)-a);d.max=Math.max(b.pos+b.len,h+a)}}),c.res=!0):c.followTouchMove&&1===F?this.runPointActions(c.normalize(e)):h.length&&(C||(c.selectionMarker=C=y({destroy:a,touch:!0},f.plotBox)),c.pinchTranslate(h,l,r,C,d,w),c.hasPinched=p,c.scaleGroups(r,d),c.res&&(c.res=!1,this.reset(!1,0)))};l.prototype.pinchTranslate=function(a,c,f,h,l,F){this.zoomHor&&this.pinchTranslateDirection(!0,a,c,f,h,l,F);
this.zoomVert&&this.pinchTranslateDirection(!1,a,c,f,h,l,F)};l.prototype.pinchTranslateDirection=function(a,c,f,h,l,F,w,p){var e=this.chart,m=a?"x":"y",u=a?"X":"Y",d="chart"+u,b=a?"width":"height",n=e["plot"+(a?"Left":"Top")],x,r,q=p||1,t=e.inverted,g=e.bounds[a?"h":"v"],L=1===c.length,k=c[0][d],z=f[0][d],y=!L&&c[1][d],D=!L&&f[1][d];f=function(){"number"===typeof D&&20<Math.abs(k-y)&&(q=p||Math.abs(z-D)/Math.abs(k-y));r=(n-z)/q+k;x=e["plot"+(a?"Width":"Height")]/q};f();c=r;if(c<g.min){c=g.min;var E=
!0}else c+x>g.max&&(c=g.max-x,E=!0);E?(z-=.8*(z-w[m][0]),"number"===typeof D&&(D-=.8*(D-w[m][1])),f()):w[m]=[z,D];t||(F[m]=r-n,F[b]=x);F=t?1/q:q;l[b]=x;l[m]=c;h[t?a?"scaleY":"scaleX":"scale"+u]=q;h["translate"+u]=F*n+(z-F*k)};l.prototype.reset=function(a,c){var e=this.chart,f=e.hoverSeries,h=e.hoverPoint,l=e.hoverPoints,w=e.tooltip,p=w&&w.shared?l:h;a&&p&&r(p).forEach(function(c){c.series.isCartesian&&"undefined"===typeof c.plotX&&(a=!1)});if(a)w&&p&&r(p).length&&(w.refresh(p),w.shared&&l?l.forEach(function(a){a.setState(a.state,
!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):h&&(h.setState(h.state,!0),e.axes.forEach(function(a){a.crosshair&&h.series[a.coll]===a&&a.drawCrosshair(null,h)})));else{if(h)h.onMouseOut();l&&l.forEach(function(a){a.setState()});if(f)f.onMouseOut();w&&w.hide(c);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());e.axes.forEach(function(a){a.hideCrosshair()});this.hoverX=e.hoverPoints=
e.hoverPoint=null}};l.prototype.runPointActions=function(a,c){var e=this.chart,h=e.tooltip&&e.tooltip.options.enabled?e.tooltip:void 0,l=h?h.shared:!1,F=c||e.hoverPoint,w=F&&F.series||e.hoverSeries;w=this.getHoverData(F,w,e.series,(!a||"touchmove"!==a.type)&&(!!c||w&&w.directTouch&&this.isDirectTouch),l,a);F=w.hoverPoint;var p=w.hoverPoints;c=(w=w.hoverSeries)&&w.tooltipOptions.followPointer;l=l&&w&&!w.noSharedTooltip;if(F&&(F!==e.hoverPoint||h&&h.isHidden)){(e.hoverPoints||[]).forEach(function(a){-1===
p.indexOf(a)&&a.setState()});if(e.hoverSeries!==w)w.onMouseOver();this.applyInactiveState(p);(p||[]).forEach(function(a){a.setState("hover")});e.hoverPoint&&e.hoverPoint.firePointEvent("mouseOut");if(!F.series)return;F.firePointEvent("mouseOver");e.hoverPoints=p;e.hoverPoint=F;h&&h.refresh(l?p:F,a)}else c&&h&&!h.isHidden&&(F=h.getAnchor([{}],a),h.updatePosition({plotX:F[0],plotY:F[1]}));this.unDocMouseMove||(this.unDocMouseMove=K(e.container.ownerDocument,"mousemove",function(a){var c=f[k.hoverChartIndex];
if(c)c.pointer.onDocumentMouseMove(a)}));e.axes.forEach(function(c){var f=q((c.crosshair||{}).snap,!0),h;f&&((h=e.hoverPoint)&&h.series[c.coll]===c||(h=I(p,function(d){return d.series[c.coll]===c})));h||!f?c.drawCrosshair(a,h):c.hideCrosshair()})};l.prototype.scaleGroups=function(a,c){var e=this.chart,f;e.series.forEach(function(h){f=a||h.getPlotBox();h.xAxis&&h.xAxis.zoomEnabled&&h.group&&(h.group.attr(f),h.markerGroup&&(h.markerGroup.attr(f),h.markerGroup.clip(c?e.clipRect:null)),h.dataLabelsGroup&&
h.dataLabelsGroup.attr(f))});e.clipRect.attr(c||e.clipBox)};l.prototype.setDOMEvents=function(){var a=this.chart.container,c=a.ownerDocument;a.onmousedown=this.onContainerMouseDown.bind(this);a.onmousemove=this.onContainerMouseMove.bind(this);a.onclick=this.onContainerClick.bind(this);this.unbindContainerMouseLeave=K(a,"mouseleave",this.onContainerMouseLeave.bind(this));k.unbindDocumentMouseUp||(k.unbindDocumentMouseUp=K(c,"mouseup",this.onDocumentMouseUp.bind(this)));k.hasTouch&&(K(a,"touchstart",
this.onContainerTouchStart.bind(this)),K(a,"touchmove",this.onContainerTouchMove.bind(this)),k.unbindDocumentTouchEnd||(k.unbindDocumentTouchEnd=K(c,"touchend",this.onDocumentTouchEnd.bind(this))))};l.prototype.setHoverChartIndex=function(){var a=this.chart,c=k.charts[q(k.hoverChartIndex,-1)];if(c&&c!==a)c.pointer.onContainerMouseLeave({relatedTarget:!0});c&&c.mouseIsDown||(k.hoverChartIndex=a.index)};l.prototype.touch=function(a,c){var e=this.chart,f;this.setHoverChartIndex();if(1===a.touches.length)if(a=
this.normalize(a),(f=e.isInsidePlot(a.chartX-e.plotLeft,a.chartY-e.plotTop))&&!e.openMenu){c&&this.runPointActions(a);if("touchmove"===a.type){c=this.pinchDown;var h=c[0]?4<=Math.sqrt(Math.pow(c[0].chartX-a.chartX,2)+Math.pow(c[0].chartY-a.chartY,2)):!1}q(h,!0)&&this.pinch(a)}else c&&this.reset();else 2===a.touches.length&&this.pinch(a)};l.prototype.zoomOption=function(a){var c=this.chart,f=c.options.chart,e=f.zoomType||"";c=c.inverted;/touch/.test(a.type)&&(e=q(f.pinchType,e));this.zoomX=a=/x/.test(e);
this.zoomY=e=/y/.test(e);this.zoomHor=a&&!c||e&&c;this.zoomVert=e&&!c||a&&c;this.hasZoom=a||e};return l}();k.Pointer=g;return k.Pointer});P(A,"parts/MSPointer.js",[A["parts/Globals.js"],A["parts/Pointer.js"],A["parts/Utilities.js"]],function(k,g,H){function v(){var q=[];q.item=function(r){return this[r]};y(z,function(r){q.push({pageX:r.pageX,pageY:r.pageY,target:r.target})});return q}function K(q,r,h,f){"touch"!==q.pointerType&&q.pointerType!==q.MSPOINTER_TYPE_TOUCH||!J[k.hoverChartIndex]||(f(q),
f=J[k.hoverChartIndex].pointer,f[r]({type:h,target:q.currentTarget,preventDefault:D,touches:v()}))}var G=this&&this.__extends||function(){var q=function(r,h){q=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(f,a){f.__proto__=a}||function(f,a){for(var h in a)a.hasOwnProperty(h)&&(f[h]=a[h])};return q(r,h)};return function(r,h){function f(){this.constructor=r}q(r,h);r.prototype=null===h?Object.create(h):(f.prototype=h.prototype,new f)}}(),N=H.addEvent,M=H.css,y=H.objectEach,I=H.removeEvent,
J=k.charts,E=k.doc,D=k.noop,z={},t=!!k.win.PointerEvent;return function(q){function r(){return null!==q&&q.apply(this,arguments)||this}G(r,q);r.prototype.batchMSEvents=function(h){h(this.chart.container,t?"pointerdown":"MSPointerDown",this.onContainerPointerDown);h(this.chart.container,t?"pointermove":"MSPointerMove",this.onContainerPointerMove);h(E,t?"pointerup":"MSPointerUp",this.onDocumentPointerUp)};r.prototype.destroy=function(){this.batchMSEvents(I);q.prototype.destroy.call(this)};r.prototype.init=
function(h,f){q.prototype.init.call(this,h,f);this.hasZoom&&M(h.container,{"-ms-touch-action":"none","touch-action":"none"})};r.prototype.onContainerPointerDown=function(h){K(h,"onContainerTouchStart","touchstart",function(f){z[f.pointerId]={pageX:f.pageX,pageY:f.pageY,target:f.currentTarget}})};r.prototype.onContainerPointerMove=function(h){K(h,"onContainerTouchMove","touchmove",function(f){z[f.pointerId]={pageX:f.pageX,pageY:f.pageY};z[f.pointerId].target||(z[f.pointerId].target=f.currentTarget)})};
r.prototype.onDocumentPointerUp=function(h){K(h,"onDocumentTouchEnd","touchend",function(f){delete z[f.pointerId]})};r.prototype.setDOMEvents=function(){q.prototype.setDOMEvents.call(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(N)};return r}(g)});P(A,"parts/Legend.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.addEvent,v=g.animObject,K=g.css,G=g.defined,N=g.discardElement,M=g.find,y=g.fireEvent,I=g.format,J=g.isNumber,E=g.merge,D=g.pick,z=g.relativeLength,
t=g.setAnimation,q=g.stableSort,r=g.syncTimeout;g=g.wrap;var h=k.isFirefox,f=k.marginNames,a=k.win,l=function(){function a(a,f){this.allItems=[];this.contentGroup=this.box=void 0;this.display=!1;this.group=void 0;this.offsetWidth=this.maxLegendWidth=this.maxItemWidth=this.legendWidth=this.legendHeight=this.lastLineHeight=this.lastItemY=this.itemY=this.itemX=this.itemMarginTop=this.itemMarginBottom=this.itemHeight=this.initialItemY=0;this.options={};this.padding=0;this.pages=[];this.proximate=!1;this.scrollGroup=
void 0;this.widthOption=this.totalItemWidth=this.titleHeight=this.symbolWidth=this.symbolHeight=0;this.chart=a;this.init(a,f)}a.prototype.init=function(a,f){this.chart=a;this.setOptions(f);f.enabled&&(this.render(),H(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=H(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())};a.prototype.setOptions=function(a){var c=D(a.padding,
8);this.options=a;this.chart.styledMode||(this.itemStyle=a.itemStyle,this.itemHiddenStyle=E(this.itemStyle,a.itemHiddenStyle));this.itemMarginTop=a.itemMarginTop||0;this.itemMarginBottom=a.itemMarginBottom||0;this.padding=c;this.initialItemY=c-5;this.symbolWidth=D(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted;this.baseline=void 0};a.prototype.update=function(a,f){var c=this.chart;this.setOptions(E(!0,this.options,a));this.destroy();c.isDirtyLegend=c.isDirtyBox=
!0;D(f,!0)&&c.redraw();y(this,"afterUpdate")};a.prototype.colorizeItem=function(a,f){a.legendGroup[f?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var c=this.options,e=a.legendItem,h=a.legendLine,m=a.legendSymbol,p=this.itemHiddenStyle.color;c=f?c.itemStyle.color:p;var l=f?a.color||p:p,r=a.options&&a.options.marker,q={fill:l};e&&e.css({fill:c,color:c});h&&h.attr({stroke:l});m&&(r&&m.isMarker&&(q=a.pointAttribs(),f||(q.stroke=q.fill=p)),m.attr(q))}y(this,"afterColorizeItem",
{item:a,visible:f})};a.prototype.positionItems=function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()};a.prototype.positionItem=function(a){var c=this.options,f=c.symbolPadding;c=!c.rtl;var e=a._legendItemPos,h=e[0];e=e[1];var w=a.checkbox;if((a=a.legendGroup)&&a.element)a[G(a.translateY)?"animate":"attr"]({translateX:c?h:this.legendWidth-h-2*f-4,translateY:e});w&&(w.x=h,w.y=e)};a.prototype.destroyItem=function(a){var c=a.checkbox;["legendItem","legendLine",
"legendSymbol","legendGroup"].forEach(function(c){a[c]&&(a[c]=a[c].destroy())});c&&N(a.checkbox)};a.prototype.destroy=function(){function a(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(c){["legendItem","legendGroup"].forEach(a,c)});"clipRect up down pager nav box title group".split(" ").forEach(a,this);this.display=null};a.prototype.positionCheckboxes=function(){var a=this.group&&this.group.alignAttr,f=this.clipHeight||this.legendHeight,e=this.titleHeight;if(a){var h=
a.translateY;this.allItems.forEach(function(c){var m=c.checkbox;if(m){var p=h+e+m.y+(this.scrollOffset||0)+3;K(m,{left:a.translateX+c.checkboxOffset+m.x-20+"px",top:p+"px",display:this.proximate||p>h-6&&p<h+f-6?"":"none"})}},this)}};a.prototype.renderTitle=function(){var a=this.options,f=this.padding,e=a.title,h=0;e.text&&(this.title||(this.title=this.chart.renderer.label(e.text,f-3,f-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(e.style),this.title.add(this.group)),
e.width||this.title.css({width:this.maxLegendWidth+"px"}),a=this.title.getBBox(),h=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:h}));this.titleHeight=h};a.prototype.setText=function(a){var c=this.options;a.legendItem.attr({text:c.labelFormat?I(c.labelFormat,a,this.chart):c.labelFormatter.call(a)})};a.prototype.renderItem=function(a){var c=this.chart,f=c.renderer,e=this.options,h=this.symbolWidth,w=e.symbolPadding,p=this.itemStyle,l=this.itemHiddenStyle,r="horizontal"===e.layout?
D(e.itemDistance,20):0,q=!e.rtl,d=a.legendItem,b=!a.series,n=!b&&a.series.drawLegendSymbol?a.series:a,x=n.options;x=this.createCheckboxForItem&&x&&x.showCheckbox;r=h+w+r+(x?20:0);var t=e.useHTML,g=a.options.className;d||(a.legendGroup=f.g("legend-item").addClass("highcharts-"+n.type+"-series highcharts-color-"+a.colorIndex+(g?" "+g:"")+(b?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=d=f.text("",q?h+w:-w,this.baseline||0,t),c.styledMode||d.css(E(a.visible?
p:l)),d.attr({align:q?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(this.fontMetrics=f.fontMetrics(c.styledMode?12:p.fontSize,d),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,d.attr("y",this.baseline)),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,n.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,d,t));x&&!a.checkbox&&this.createCheckboxForItem&&this.createCheckboxForItem(a);this.colorizeItem(a,a.visible);!c.styledMode&&p.width||d.css({width:(e.itemWidth||
this.widthOption||c.spacingBox.width)-r+"px"});this.setText(a);c=d.getBBox();a.itemWidth=a.checkboxOffset=e.itemWidth||a.legendItemWidth||c.width+r;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||c.height||this.symbolHeight)};a.prototype.layoutItem=function(a){var c=this.options,f=this.padding,e="horizontal"===c.layout,h=a.itemHeight,w=this.itemMarginBottom,p=this.itemMarginTop,l=e?D(c.itemDistance,
20):0,r=this.maxLegendWidth;c=c.alignColumns&&this.totalItemWidth>r?this.maxItemWidth:a.itemWidth;e&&this.itemX-f+c>r&&(this.itemX=f,this.lastLineHeight&&(this.itemY+=p+this.lastLineHeight+w),this.lastLineHeight=0);this.lastItemY=p+this.itemY+w;this.lastLineHeight=Math.max(h,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=c:(this.itemY+=p+h+w,this.lastLineHeight=h);this.offsetWidth=this.widthOption||Math.max((e?this.itemX-f-(a.checkbox?0:l):c)+f,this.offsetWidth)};a.prototype.getAllItems=
function(){var a=[];this.chart.series.forEach(function(c){var f=c&&c.options;c&&D(f.showInLegend,G(f.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===f.legendType?c.data:c)))});y(this,"afterGetAllItems",{allItems:a});return a};a.prototype.getAlignment=function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)};a.prototype.adjustMargins=function(a,e){var c=this.chart,h=this.options,m=this.getAlignment();
m&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(u,p){u.test(m)&&!G(a[p])&&(c[f[p]]=Math.max(c[f[p]],c.legend[(p+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][p]*h[p%2?"x":"y"]+D(h.margin,12)+e[p]+(c.titleOffset[p]||0)))})};a.prototype.proximatePositions=function(){var a=this.chart,f=[],e="left"===this.options.align;this.allItems.forEach(function(c){var h=e;if(c.yAxis&&c.points){c.xAxis.options.reversed&&(h=!h);var m=M(h?c.points:c.points.slice(0).reverse(),function(a){return J(a.plotY)});
h=this.itemMarginTop+c.legendItem.getBBox().height+this.itemMarginBottom;var p=c.yAxis.top-a.plotTop;c.visible?(m=m?m.plotY:c.yAxis.height,m+=p-.3*h):m=p+c.yAxis.height;f.push({target:m,size:h,item:c})}},this);k.distribute(f,a.plotHeight);f.forEach(function(c){c.item._legendItemPos[1]=a.plotTop-a.spacing[0]+c.pos})};a.prototype.render=function(){var a=this.chart,f=a.renderer,e=this.group,h=this.box,l=this.options,w=this.padding;this.itemX=w;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=
0;this.widthOption=z(l.width,a.spacingBox.width-w);var p=a.spacingBox.width-2*w-l.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(p/=2);this.maxLegendWidth=this.widthOption||p;e||(this.group=e=f.g("legend").attr({zIndex:7}).add(),this.contentGroup=f.g().attr({zIndex:1}).add(e),this.scrollGroup=f.g().add(this.contentGroup));this.renderTitle();var C=this.getAllItems();q(C,function(a,d){return(a.options&&a.options.legendIndex||0)-(d.options&&d.options.legendIndex||0)});l.reversed&&C.reverse();
this.allItems=C;this.display=p=!!C.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;C.forEach(this.renderItem,this);C.forEach(this.layoutItem,this);C=(this.widthOption||this.offsetWidth)+w;var r=this.lastItemY+this.lastLineHeight+this.titleHeight;r=this.handleOverflow(r);r+=w;h||(this.box=h=f.rect().addClass("highcharts-legend-box").attr({r:l.borderRadius}).add(e),h.isNew=!0);a.styledMode||h.attr({stroke:l.borderColor,"stroke-width":l.borderWidth||0,fill:l.backgroundColor||
"none"}).shadow(l.shadow);0<C&&0<r&&(h[h.isNew?"attr":"animate"](h.crisp.call({},{x:0,y:0,width:C,height:r},h.strokeWidth())),h.isNew=!1);h[p?"show":"hide"]();a.styledMode&&"none"===e.getStyle("display")&&(C=r=0);this.legendWidth=C;this.legendHeight=r;p&&this.align();this.proximate||this.positionItems();y(this,"afterRender")};a.prototype.align=function(a){void 0===a&&(a=this.chart.spacingBox);var c=this.chart,f=this.options,e=a.y;/(lth|ct|rth)/.test(this.getAlignment())&&0<c.titleOffset[0]?e+=c.titleOffset[0]:
/(lbh|cb|rbh)/.test(this.getAlignment())&&0<c.titleOffset[2]&&(e-=c.titleOffset[2]);e!==a.y&&(a=E(a,{y:e}));this.group.align(E(f,{width:this.legendWidth,height:this.legendHeight,verticalAlign:this.proximate?"top":f.verticalAlign}),!0,a)};a.prototype.handleOverflow=function(a){var c=this,f=this.chart,e=f.renderer,h=this.options,l=h.y,p=this.padding;l=f.spacingBox.height+("top"===h.verticalAlign?-l:l)-p;var C=h.maxHeight,r,q=this.clipRect,d=h.navigation,b=D(d.animation,!0),n=d.arrowSize||12,x=this.nav,
t=this.pages,g,k=this.allItems,z=function(b){"number"===typeof b?q.attr({height:b}):q&&(c.clipRect=q.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=b?"rect("+p+"px,9999px,"+(p+b)+"px,0)":"auto")},y=function(b){c[b]=e.circle(0,0,1.3*n).translate(n/2,n/2).add(x);f.styledMode||c[b].attr("fill","rgba(0,0,0,0.0001)");return c[b]};"horizontal"!==h.layout||"middle"===h.verticalAlign||h.floating||(l/=2);C&&(l=Math.min(l,C));t.length=0;a>l&&!1!==d.enabled?(this.clipHeight=
r=Math.max(l-20-this.titleHeight-p,0),this.currentPage=D(this.currentPage,1),this.fullHeight=a,k.forEach(function(b,a){var d=b._legendItemPos[1],c=Math.round(b.legendItem.getBBox().height),f=t.length;if(!f||d-t[f-1]>r&&(g||d)!==t[f-1])t.push(g||d),f++;b.pageIx=f-1;g&&(k[a-1].pageIx=f-1);a===k.length-1&&d+c-t[f-1]>r&&d!==g&&(t.push(d),b.pageIx=f);d!==g&&(g=d)}),q||(q=c.clipRect=e.clipRect(0,p,9999,0),c.contentGroup.clip(q)),z(r),x||(this.nav=x=e.g().attr({zIndex:1}).add(this.group),this.up=e.symbol("triangle",
0,0,n,n).add(x),y("upTracker").on("click",function(){c.scroll(-1,b)}),this.pager=e.text("",15,10).addClass("highcharts-legend-navigation"),f.styledMode||this.pager.css(d.style),this.pager.add(x),this.down=e.symbol("triangle-down",0,0,n,n).add(x),y("downTracker").on("click",function(){c.scroll(1,b)})),c.scroll(0),a=l):x&&(z(),this.nav=x.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a};a.prototype.scroll=function(a,f){var c=this,e=this.chart,h=this.pages,m=h.length,p=this.currentPage+
a;a=this.clipHeight;var l=this.options.navigation,q=this.pager,g=this.padding;p>m&&(p=m);0<p&&("undefined"!==typeof f&&t(f,e),this.nav.attr({translateX:g,translateY:a+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===p?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),q.attr({text:p+"/"+m}),[this.down,this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":p===m?"highcharts-legend-nav-inactive":
"highcharts-legend-nav-active"})},this),e.styledMode||(this.up.attr({fill:1===p?l.inactiveColor:l.activeColor}),this.upTracker.css({cursor:1===p?"default":"pointer"}),this.down.attr({fill:p===m?l.inactiveColor:l.activeColor}),this.downTracker.css({cursor:p===m?"default":"pointer"})),this.scrollOffset=-h[p-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=p,this.positionCheckboxes(),f=v(D(f,e.renderer.globalAnimation,!0)),r(function(){y(c,"afterScroll",
{currentPage:p})},f.duration||0))};return a}();(/Trident\/7\.0/.test(a.navigator&&a.navigator.userAgent)||h)&&g(l.prototype,"positionItem",function(a,c){var f=this,e=function(){c._legendItemPos&&a.call(f,c)};e();f.bubbleLegend||setTimeout(e)});k.Legend=l;return k.Legend});P(A,"parts/Chart.js",[A["parts/Globals.js"],A["parts/Legend.js"],A["parts/MSPointer.js"],A["parts/Pointer.js"],A["parts/Time.js"],A["parts/Utilities.js"]],function(k,g,H,v,K,G){var N=G.addEvent,M=G.animate,y=G.animObject,I=G.attr,
J=G.createElement,E=G.css,D=G.defined,z=G.discardElement,t=G.erase,q=G.error,r=G.extend,h=G.find,f=G.fireEvent,a=G.getStyle,l=G.isArray,e=G.isFunction,c=G.isNumber,m=G.isObject,u=G.isString,L=G.merge,F=G.numberFormat,w=G.objectEach,p=G.pick,C=G.pInt,O=G.relativeLength,B=G.removeEvent,d=G.setAnimation,b=G.splat,n=G.syncTimeout,x=G.uniqueKey,Q=k.doc,R=k.Axis,X=k.defaultOptions,U=k.charts,V=k.marginNames,W=k.seriesTypes,A=k.win,Y=k.Chart=function(){this.getArgs.apply(this,arguments)};k.chart=function(b,
a,d){return new Y(b,a,d)};r(Y.prototype,{callbacks:[],getArgs:function(){var b=[].slice.call(arguments);if(u(b[0])||b[0].nodeName)this.renderTo=b.shift();this.init(b[0],b[1])},init:function(b,a){var d,c=b.series,n=b.plotOptions||{};f(this,"init",{args:arguments},function(){b.series=null;d=L(X,b);var h=d.chart||{};w(d.plotOptions,function(b,a){m(b)&&(b.tooltip=n[a]&&L(n[a].tooltip)||void 0)});d.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;d.series=b.series=c;this.userOptions=
b;var p=h.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=a;this.isResizing=0;this.options=d;this.axes=[];this.series=[];this.time=b.time&&Object.keys(b.time).length?new K(b.time):k.time;this.numberFormatter=h.numberFormatter||F;this.styledMode=h.styledMode;this.hasCartesianSeries=h.showAxes;var l=this;l.index=U.length;U.push(l);k.chartCount++;p&&w(p,function(b,a){e(b)&&N(l,a,b)});l.xAxis=[];l.yAxis=[];l.pointCount=l.colorCounter=l.symbolCounter=
0;f(l,"afterInit");l.firstRender()})},initSeries:function(b){var a=this.options.chart;a=b.type||a.type||a.defaultSeriesType;var d=W[a];d||q(17,!0,this,{missingModuleFor:a});a=new d;a.init(this,b);return a},setSeriesData:function(){this.getSeriesOrderByLinks().forEach(function(b){b.points||b.data||!b.enabledDataSorting||b.setData(b.options.data,!1)})},getSeriesOrderByLinks:function(){return this.series.concat().sort(function(b,a){return b.linkedSeries.length||a.linkedSeries.length?a.linkedSeries.length-
b.linkedSeries.length:0})},orderSeries:function(b){var a=this.series;for(b=b||0;b<a.length;b++)a[b]&&(a[b].index=b,a[b].name=a[b].getName())},isInsidePlot:function(b,a,d){var c=d?a:b;b=d?b:a;c={x:c,y:b,isInsidePlot:0<=c&&c<=this.plotWidth&&0<=b&&b<=this.plotHeight};f(this,"afterIsInsidePlot",c);return c.isInsidePlot},redraw:function(b){f(this,"beforeRedraw");var a=this.axes,c=this.series,e=this.pointer,n=this.legend,h=this.userOptions.legend,p=this.isDirtyLegend,l=this.hasCartesianSeries,m=this.isDirtyBox,
x=this.renderer,u=x.isHidden(),w=[];this.setResponsive&&this.setResponsive(!1);d(this.hasRendered?b:!1,this);u&&this.temporaryDisplay();this.layOutTitles();for(b=c.length;b--;){var C=c[b];if(C.options.stacking){var F=!0;if(C.isDirty){var q=!0;break}}}if(q)for(b=c.length;b--;)C=c[b],C.options.stacking&&(C.isDirty=!0);c.forEach(function(b){b.isDirty&&("point"===b.options.legendType?(b.updateTotals&&b.updateTotals(),p=!0):h&&(h.labelFormatter||h.labelFormat)&&(p=!0));b.isDirtyData&&f(b,"updatedData")});
p&&n&&n.options.enabled&&(n.render(),this.isDirtyLegend=!1);F&&this.getStacks();l&&a.forEach(function(b){b.updateNames();b.setScale()});this.getMargins();l&&(a.forEach(function(b){b.isDirty&&(m=!0)}),a.forEach(function(b){var a=b.min+","+b.max;b.extKey!==a&&(b.extKey=a,w.push(function(){f(b,"afterSetExtremes",r(b.eventArgs,b.getExtremes()));delete b.eventArgs}));(m||F)&&b.redraw()}));m&&this.drawChartBox();f(this,"predraw");c.forEach(function(b){(m||b.isDirty)&&b.visible&&b.redraw();b.isDirtyData=
!1});e&&e.reset(!0);x.draw();f(this,"redraw");f(this,"render");u&&this.temporaryDisplay(!0);w.forEach(function(b){b.call()})},get:function(b){function a(a){return a.id===b||a.options&&a.options.id===b}var d=this.series,c;var f=h(this.axes,a)||h(this.series,a);for(c=0;!f&&c<d.length;c++)f=h(d[c].points||[],a);return f},getAxes:function(){var a=this,d=this.options,c=d.xAxis=b(d.xAxis||{});d=d.yAxis=b(d.yAxis||{});f(this,"getAxes");c.forEach(function(b,a){b.index=a;b.isX=!0});d.forEach(function(b,a){b.index=
a});c.concat(d).forEach(function(b){new R(a,b)});f(this,"afterGetAxes")},getSelectedPoints:function(){var b=[];this.series.forEach(function(a){b=b.concat(a.getPointsCollection().filter(function(b){return p(b.selectedStaging,b.selected)}))});return b},getSelectedSeries:function(){return this.series.filter(function(b){return b.selected})},setTitle:function(b,a,d){this.applyDescription("title",b);this.applyDescription("subtitle",a);this.applyDescription("caption",void 0);this.layOutTitles(d)},applyDescription:function(b,
a){var d=this,c="title"===b?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:{color:"#666666"};c=this.options[b]=L(!this.styledMode&&{style:c},this.options[b],a);var f=this[b];f&&a&&(this[b]=f=f.destroy());c&&!f&&(f=this.renderer.text(c.text,0,0,c.useHTML).attr({align:c.align,"class":"highcharts-"+b,zIndex:c.zIndex||4}).add(),f.update=function(a){d[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[b]](a)},this.styledMode||f.css(c.style),this[b]=f)},layOutTitles:function(b){var a=
[0,0,0],d=this.renderer,c=this.spacingBox;["title","subtitle","caption"].forEach(function(b){var f=this[b],e=this.options[b],n=e.verticalAlign||"top";b="title"===b?-3:"top"===n?a[0]+2:0;if(f){if(!this.styledMode)var h=e.style.fontSize;h=d.fontMetrics(h,f).b;f.css({width:(e.width||c.width+(e.widthAdjust||0))+"px"});var p=Math.round(f.getBBox(e.useHTML).height);f.align(r({y:"bottom"===n?h:b+h,height:p},e),!1,"spacingBox");e.floating||("top"===n?a[0]=Math.ceil(a[0]+p):"bottom"===n&&(a[2]=Math.ceil(a[2]+
p)))}},this);a[0]&&"top"===(this.options.title.verticalAlign||"top")&&(a[0]+=this.options.title.margin);a[2]&&"bottom"===this.options.caption.verticalAlign&&(a[2]+=this.options.caption.margin);var e=!this.titleOffset||this.titleOffset.join(",")!==a.join(",");this.titleOffset=a;f(this,"afterLayOutTitles");!this.isDirtyBox&&e&&(this.isDirtyBox=this.isDirtyLegend=e,this.hasRendered&&p(b,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,d=b.width;b=b.height;var c=
this.renderTo;D(d)||(this.containerWidth=a(c,"width"));D(b)||(this.containerHeight=a(c,"height"));this.chartWidth=Math.max(0,d||this.containerWidth||600);this.chartHeight=Math.max(0,O(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var d=this.renderTo;if(b)for(;d&&d.style;)d.hcOrigStyle&&(E(d,d.hcOrigStyle),delete d.hcOrigStyle),d.hcOrigDetached&&(Q.body.removeChild(d),d.hcOrigDetached=!1),d=d.parentNode;else for(;d&&d.style;){Q.body.contains(d)||
d.parentNode||(d.hcOrigDetached=!0,Q.body.appendChild(d));if("none"===a(d,"display",!1)||d.hcOricDetached)d.hcOrigStyle={display:d.style.display,height:d.style.height,overflow:d.style.overflow},b={display:"block",overflow:"hidden"},d!==this.renderTo&&(b.height=0),E(d,b),d.offsetWidth||d.style.setProperty("display","block","important");d=d.parentNode;if(d===Q.body)break}},setClassName:function(b){this.container.className="highcharts-container "+(b||"")},getContainer:function(){var b=this.options,a=
b.chart;var e=this.renderTo;var n=x(),h,p;e||(this.renderTo=e=a.renderTo);u(e)&&(this.renderTo=e=Q.getElementById(e));e||q(13,!0,this);var m=C(I(e,"data-highcharts-chart"));c(m)&&U[m]&&U[m].hasRendered&&U[m].destroy();I(e,"data-highcharts-chart",this.index);e.innerHTML="";a.skipClone||e.offsetWidth||this.temporaryDisplay();this.getChartSize();m=this.chartWidth;var l=this.chartHeight;E(e,{overflow:"hidden"});this.styledMode||(h=r({position:"relative",overflow:"hidden",width:m+"px",height:l+"px",textAlign:"left",
lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},a.style));this.container=e=J("div",{id:n},h,e);this._cursor=e.style.cursor;this.renderer=new (k[a.renderer]||k.Renderer)(e,m,l,null,a.forExport,b.exporting&&b.exporting.allowHTML,this.styledMode);d(void 0,this);this.setClassName(a.className);if(this.styledMode)for(p in b.defs)this.renderer.definition(b.defs[p]);else this.renderer.setStyle(a.style);this.renderer.chartIndex=this.index;f(this,"afterGetContainer")},getMargins:function(b){var a=
this.spacing,d=this.margin,c=this.titleOffset;this.resetMargins();c[0]&&!D(d[0])&&(this.plotTop=Math.max(this.plotTop,c[0]+a[0]));c[2]&&!D(d[2])&&(this.marginBottom=Math.max(this.marginBottom,c[2]+a[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(d,a);f(this,"getMargins");b||this.getAxisMargins()},getAxisMargins:function(){var b=this,a=b.axisOffset=[0,0,0,0],d=b.colorAxis,c=b.margin,f=function(b){b.forEach(function(b){b.visible&&b.getOffset()})};b.hasCartesianSeries?f(b.axes):d&&
d.length&&f(d);V.forEach(function(d,f){D(c[f])||(b[d]+=a[f])});b.setChartSize()},reflow:function(b){var d=this,c=d.options.chart,f=d.renderTo,e=D(c.width)&&D(c.height),h=c.width||a(f,"width");c=c.height||a(f,"height");f=b?b.target:A;if(!e&&!d.isPrinting&&h&&c&&(f===A||f===Q)){if(h!==d.containerWidth||c!==d.containerHeight)G.clearTimeout(d.reflowTimeout),d.reflowTimeout=n(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:0);d.containerWidth=h;d.containerHeight=c}},setReflow:function(b){var a=
this;!1===b||this.unbindReflow?!1===b&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=N(A,"resize",function(b){a.options&&a.reflow(b)}),N(this,"destroy",this.unbindReflow))},setSize:function(b,a,c){var e=this,h=e.renderer;e.isResizing+=1;d(c,e);c=h.globalAnimation;e.oldChartHeight=e.chartHeight;e.oldChartWidth=e.chartWidth;"undefined"!==typeof b&&(e.options.chart.width=b);"undefined"!==typeof a&&(e.options.chart.height=a);e.getChartSize();e.styledMode||(c?M:E)(e.container,
{width:e.chartWidth+"px",height:e.chartHeight+"px"},c);e.setChartSize(!0);h.setSize(e.chartWidth,e.chartHeight,c);e.axes.forEach(function(b){b.isDirty=!0;b.setScale()});e.isDirtyLegend=!0;e.isDirtyBox=!0;e.layOutTitles();e.getMargins();e.redraw(c);e.oldChartHeight=null;f(e,"resize");n(function(){e&&f(e,"endResize",null,function(){--e.isResizing})},y(c).duration||0)},setChartSize:function(b){var a=this.inverted,d=this.renderer,c=this.chartWidth,e=this.chartHeight,n=this.options.chart,h=this.spacing,
p=this.clipOffset,m,l,x,u;this.plotLeft=m=Math.round(this.plotLeft);this.plotTop=l=Math.round(this.plotTop);this.plotWidth=x=Math.max(0,Math.round(c-m-this.marginRight));this.plotHeight=u=Math.max(0,Math.round(e-l-this.marginBottom));this.plotSizeX=a?u:x;this.plotSizeY=a?x:u;this.plotBorderWidth=n.plotBorderWidth||0;this.spacingBox=d.spacingBox={x:h[3],y:h[0],width:c-h[3]-h[1],height:e-h[0]-h[2]};this.plotBox=d.plotBox={x:m,y:l,width:x,height:u};c=2*Math.floor(this.plotBorderWidth/2);a=Math.ceil(Math.max(c,
p[3])/2);d=Math.ceil(Math.max(c,p[0])/2);this.clipBox={x:a,y:d,width:Math.floor(this.plotSizeX-Math.max(c,p[1])/2-a),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(c,p[2])/2-d))};b||this.axes.forEach(function(b){b.setAxisSize();b.setAxisTranslation()});f(this,"afterSetChartSize",{skipAxes:b})},resetMargins:function(){f(this,"resetMargins");var b=this,a=b.options.chart;["margin","spacing"].forEach(function(d){var c=a[d],e=m(c)?c:[c,c,c,c];["Top","Right","Bottom","Left"].forEach(function(c,f){b[d][f]=
p(a[d+c],e[f])})});V.forEach(function(a,d){b[a]=p(b.margin[d],b.spacing[d])});b.axisOffset=[0,0,0,0];b.clipOffset=[0,0,0,0]},drawChartBox:function(){var b=this.options.chart,a=this.renderer,d=this.chartWidth,c=this.chartHeight,e=this.chartBackground,h=this.plotBackground,n=this.plotBorder,p=this.styledMode,m=this.plotBGImage,l=b.backgroundColor,x=b.plotBackgroundColor,u=b.plotBackgroundImage,w,C=this.plotLeft,r=this.plotTop,F=this.plotWidth,q=this.plotHeight,t=this.plotBox,g=this.clipRect,B=this.clipBox,
O="animate";e||(this.chartBackground=e=a.rect().addClass("highcharts-background").add(),O="attr");if(p)var k=w=e.strokeWidth();else{k=b.borderWidth||0;w=k+(b.shadow?8:0);l={fill:l||"none"};if(k||e["stroke-width"])l.stroke=b.borderColor,l["stroke-width"]=k;e.attr(l).shadow(b.shadow)}e[O]({x:w/2,y:w/2,width:d-w-k%2,height:c-w-k%2,r:b.borderRadius});O="animate";h||(O="attr",this.plotBackground=h=a.rect().addClass("highcharts-plot-background").add());h[O](t);p||(h.attr({fill:x||"none"}).shadow(b.plotShadow),
u&&(m?(u!==m.attr("href")&&m.attr("href",u),m.animate(t)):this.plotBGImage=a.image(u,C,r,F,q).add()));g?g.animate({width:B.width,height:B.height}):this.clipRect=a.clipRect(B);O="animate";n||(O="attr",this.plotBorder=n=a.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());p||n.attr({stroke:b.plotBorderColor,"stroke-width":b.plotBorderWidth||0,fill:"none"});n[O](n.crisp({x:C,y:r,width:F,height:q},-n.strokeWidth()));this.isDirtyBox=!1;f(this,"afterDrawChartBox")},propFromSeries:function(){var b=
this,a=b.options.chart,d,c=b.options.series,e,f;["inverted","angular","polar"].forEach(function(h){d=W[a.type||a.defaultSeriesType];f=a[h]||d&&d.prototype[h];for(e=c&&c.length;!f&&e--;)(d=W[c[e].type])&&d.prototype[h]&&(f=!0);b[h]=f})},linkSeries:function(){var b=this,a=b.series;a.forEach(function(b){b.linkedSeries.length=0});a.forEach(function(a){var d=a.options.linkedTo;u(d)&&(d=":previous"===d?b.series[a.index-1]:b.get(d))&&d.linkedParent!==a&&(d.linkedSeries.push(a),a.linkedParent=d,d.enabledDataSorting&&
a.setDataSortingOptions(),a.visible=p(a.options.visible,d.options.visible,a.visible))});f(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(b){b.translate();b.render()})},renderLabels:function(){var b=this,a=b.options.labels;a.items&&a.items.forEach(function(d){var c=r(a.style,d.style),e=C(c.left)+b.plotLeft,f=C(c.top)+b.plotTop+12;delete c.left;delete c.top;b.renderer.text(d.html,e,f).attr({zIndex:2}).css(c).add()})},render:function(){var b=this.axes,a=this.colorAxis,
d=this.renderer,c=this.options,e=0,f=function(b){b.forEach(function(b){b.visible&&b.render()})};this.setTitle();this.legend=new g(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;b.some(function(b){if(b.horiz&&b.visible&&b.options.labels.enabled&&b.series.length)return e=21,!0});var h=this.plotHeight=Math.max(this.plotHeight-e,0);b.forEach(function(b){b.setScale()});this.getAxisMargins();var n=1.1<c/this.plotWidth;var p=1.05<h/this.plotHeight;
if(n||p)b.forEach(function(b){(b.horiz&&n||!b.horiz&&p)&&b.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?f(b):a&&a.length&&f(a);this.seriesGroup||(this.seriesGroup=d.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();this.hasRendered=!0},addCredits:function(b){var a=this;b=L(!0,this.options.credits,b);b.enabled&&!this.credits&&(this.credits=
this.renderer.text(b.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){b.href&&(A.location.href=b.href)}).attr({align:b.position.align,zIndex:8}),a.styledMode||this.credits.css(b.style),this.credits.add().align(b.position),this.credits.update=function(b){a.credits=a.credits.destroy();a.addCredits(b)})},updateContainerScaling:function(){var b=this.container;if(b.offsetWidth&&b.offsetHeight&&b.getBoundingClientRect){var a=b.getBoundingClientRect(),d=a.width/b.offsetWidth;
b=a.height/b.offsetHeight;1!==d||1!==b?this.containerScaling={scaleX:d,scaleY:b}:delete this.containerScaling}},destroy:function(){var b=this,a=b.axes,d=b.series,c=b.container,e,h=c&&c.parentNode;f(b,"destroy");b.renderer.forExport?t(U,b):U[b.index]=void 0;k.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");B(b);for(e=a.length;e--;)a[e]=a[e].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(e=d.length;e--;)d[e]=d[e].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(a){var d=
b[a];d&&d.destroy&&(b[a]=d.destroy())});c&&(c.innerHTML="",B(c),h&&z(c));w(b,function(a,d){delete b[d]})},firstRender:function(){var b=this,a=b.options;if(!b.isReadyToRender||b.isReadyToRender()){b.getContainer();b.resetMargins();b.setChartSize();b.propFromSeries();b.getAxes();(l(a.series)?a.series:[]).forEach(function(a){b.initSeries(a)});b.linkSeries();b.setSeriesData();f(b,"beforeRender");v&&(b.pointer=k.hasTouch||!A.PointerEvent&&!A.MSPointerEvent?new v(b,a):new H(b,a));b.render();if(!b.renderer.imgCount&&
!b.hasLoaded)b.onload();b.temporaryDisplay(!0)}},onload:function(){this.callbacks.concat([this.callback]).forEach(function(b){b&&"undefined"!==typeof this.index&&b.apply(this,[this])},this);f(this,"load");f(this,"render");D(this.index)&&this.setReflow(this.options.chart.reflow);this.hasLoaded=!0}})});P(A,"parts/ScrollablePlotArea.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.addEvent,v=g.createElement,K=g.pick,G=g.stop;g=k.Chart;"";H(g,"afterSetChartSize",function(g){var v=
this.options.chart.scrollablePlotArea,y=v&&v.minWidth;v=v&&v.minHeight;if(!this.renderer.forExport){if(y){if(this.scrollablePixelsX=y=Math.max(0,y-this.chartWidth)){this.plotWidth+=y;this.inverted?(this.clipBox.height+=y,this.plotBox.height+=y):(this.clipBox.width+=y,this.plotBox.width+=y);var I={1:{name:"right",value:y}}}}else v&&(this.scrollablePixelsY=y=Math.max(0,v-this.chartHeight))&&(this.plotHeight+=y,this.inverted?(this.clipBox.width+=y,this.plotBox.width+=y):(this.clipBox.height+=y,this.plotBox.height+=
y),I={2:{name:"bottom",value:y}});I&&!g.skipAxes&&this.axes.forEach(function(g){I[g.side]?g.getPlotLinePath=function(){var y=I[g.side].name,D=this[y];this[y]=D-I[g.side].value;var z=k.Axis.prototype.getPlotLinePath.apply(this,arguments);this[y]=D;return z}:(g.setAxisSize(),g.setAxisTranslation())})}});H(g,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});g.prototype.setUpScrolling=function(){var g=
this,k={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(k.overflowX="auto");this.scrollablePixelsY&&(k.overflowY="auto");this.scrollingContainer=v("div",{className:"highcharts-scrolling"},k,this.renderTo);H(this.scrollingContainer,"scroll",function(){g.pointer&&delete g.pointer.chartPosition});this.innerContainer=v("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=
null};g.prototype.moveFixedElements=function(){var g=this.container,k=this.fixedRenderer,y=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),v;this.scrollablePixelsX&&!this.inverted?v=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?v=".highcharts-xaxis":
this.scrollablePixelsY&&!this.inverted?v=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(v=".highcharts-yaxis");y.push(v,v+"-labels");y.forEach(function(y){[].forEach.call(g.querySelectorAll(y),function(g){(g.namespaceURI===k.SVG_NS?k.box:k.box.parentNode).appendChild(g);g.style.pointerEvents="auto"})})};g.prototype.applyFixed=function(){var g,M,y=!this.fixedDiv,I=this.options.chart.scrollablePlotArea;y?(this.fixedDiv=v("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",
pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=M=new k.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight,null===(g=this.options.chart)||void 0===g?void 0:g.style),this.scrollableMask=M.path().attr({fill:this.options.chart.backgroundColor||"#fff","fill-opacity":K(I.opacity,.85),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),this.moveFixedElements(),H(this,"afterShowResetZoom",
this.moveFixedElements),H(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);g=this.chartWidth+(this.scrollablePixelsX||0);M=this.chartHeight+(this.scrollablePixelsY||0);G(this.container);this.container.style.width=g+"px";this.container.style.height=M+"px";this.renderer.boxWrapper.attr({width:g,height:M,viewBox:[0,0,g,M].join(" ")});this.chartBackground.attr({width:g,height:M});this.scrollingContainer.style.height=this.chartHeight+"px";y&&
(I.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*I.scrollPositionX),I.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*I.scrollPositionY));M=this.axisOffset;y=this.plotTop-M[0]-1;I=this.plotLeft-M[3]-1;g=this.plotTop+this.plotHeight+M[2]+1;M=this.plotLeft+this.plotWidth+M[1]+1;var J=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),E=this.plotTop+this.plotHeight-(this.scrollablePixelsY||0);y=this.scrollablePixelsX?[["M",0,y],["L",this.plotLeft-
1,y],["L",this.plotLeft-1,g],["L",0,g],["Z"],["M",J,y],["L",this.chartWidth,y],["L",this.chartWidth,g],["L",J,g],["Z"]]:this.scrollablePixelsY?[["M",I,0],["L",I,this.plotTop-1],["L",M,this.plotTop-1],["L",M,0],["Z"],["M",I,E],["L",I,this.chartHeight],["L",M,this.chartHeight],["L",M,E],["Z"]]:[["M",0,0]];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:y})}});P(A,"parts/StackingAxis.js",[A["parts/Utilities.js"]],function(k){var g=k.addEvent,H=k.destroyObjectProperties,v=k.fireEvent,
K=k.objectEach,G=k.pick,N=function(){function g(g){this.oldStacks={};this.stacks={};this.stacksTouched=0;this.axis=g}g.prototype.buildStacks=function(){var g=this.axis,k=g.series,J=G(g.options.reversedStacks,!0),E=k.length,D;if(!g.isXAxis){this.usePercentage=!1;for(D=E;D--;){var z=k[J?D:E-D-1];z.setStackedPoints()}for(D=0;D<E;D++)k[D].modifyStacks();v(g,"afterBuildStacks")}};g.prototype.cleanStacks=function(){if(!this.axis.isXAxis){if(this.oldStacks)var g=this.stacks=this.oldStacks;K(g,function(g){K(g,
function(g){g.cumulative=g.total})})}};g.prototype.resetStacks=function(){var g=this,k=g.stacks;g.axis.isXAxis||K(k,function(k){K(k,function(y,D){y.touched<g.stacksTouched?(y.destroy(),delete k[D]):(y.total=null,y.cumulative=null)})})};g.prototype.renderStackTotals=function(){var g=this.axis.chart,k=g.renderer,v=this.stacks,E=this.stackTotalGroup=this.stackTotalGroup||k.g("stack-labels").attr({visibility:"visible",zIndex:6}).add();E.translate(g.plotLeft,g.plotTop);K(v,function(g){K(g,function(g){g.render(E)})})};
return g}();return function(){function k(){}k.compose=function(y){g(y,"init",k.onInit);g(y,"destroy",k.onDestroy)};k.onDestroy=function(){var g=this.stacking;if(g){var k=g.stacks;K(k,function(g,y){H(g);k[y]=null});g&&g.stackTotalGroup&&g.stackTotalGroup.destroy()}};k.onInit=function(){this.stacking||(this.stacking=new N(this))};return k}()});P(A,"mixins/legend-symbol.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.merge,v=g.pick;k.LegendSymbolMixin={drawRectangle:function(g,
k){var G=g.symbolHeight,M=g.options.squareSymbol;k.legendSymbol=this.chart.renderer.rect(M?(g.symbolWidth-G)/2:0,g.baseline-G+1,M?G:g.symbolWidth,G,v(g.options.symbolRadius,G/2)).addClass("highcharts-point").attr({zIndex:3}).add(k.legendGroup)},drawLineMarker:function(g){var k=this.options,N=k.marker,M=g.symbolWidth,y=g.symbolHeight,I=y/2,J=this.chart.renderer,E=this.legendGroup;g=g.baseline-Math.round(.3*g.fontMetrics.b);var D={};this.chart.styledMode||(D={"stroke-width":k.lineWidth||0},k.dashStyle&&
(D.dashstyle=k.dashStyle));this.legendLine=J.path(["M",0,g,"L",M,g]).addClass("highcharts-graph").attr(D).add(E);N&&!1!==N.enabled&&M&&(k=Math.min(v(N.radius,I),I),0===this.symbol.indexOf("url")&&(N=H(N,{width:y,height:y}),k=0),this.legendSymbol=N=J.symbol(this.symbol,M/2-k,g-k,2*k,2*k,N).addClass("highcharts-point").add(E),N.isMarker=!0)}};return k.LegendSymbolMixin});P(A,"parts/Point.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){"";var H=g.animObject,v=g.defined,K=g.erase,G=
g.extend,N=g.fireEvent,M=g.format,y=g.getNestedProperty,I=g.isArray,J=g.isNumber,E=g.isObject,D=g.syncTimeout,z=g.pick,t=g.removeEvent,q=g.uniqueKey;g=function(){function g(){this.colorIndex=this.category=void 0;this.formatPrefix="point";this.id=void 0;this.isNull=!1;this.percentage=this.options=this.name=void 0;this.selected=!1;this.total=this.series=void 0;this.visible=!0;this.x=void 0}g.prototype.animateBeforeDestroy=function(){var h=this,f={x:h.startXPos,opacity:0},a,l=h.getGraphicalProps();l.singular.forEach(function(e){a=
"dataLabel"===e;h[e]=h[e].animate(a?{x:h[e].startXPos,y:h[e].startYPos,opacity:0}:f)});l.plural.forEach(function(a){h[a].forEach(function(a){a.element&&a.animate(G({x:h.startXPos},a.startYPos?{x:a.startXPos,y:a.startYPos}:{}))})})};g.prototype.applyOptions=function(h,f){var a=this.series,l=a.options.pointValKey||a.pointValKey;h=g.prototype.optionsToObject.call(this,h);G(this,h);this.options=this.options?G(this.options,h):h;h.group&&delete this.group;h.dataLabels&&delete this.dataLabels;l&&(this.y=
g.prototype.getNestedProperty.call(this,l));this.formatPrefix=(this.isNull=z(this.isValid&&!this.isValid(),null===this.x||!J(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&"undefined"===typeof f&&a.xAxis&&a.xAxis.hasNames&&(this.x=a.xAxis.nameToX(this));"undefined"===typeof this.x&&a&&(this.x="undefined"===typeof f?a.autoIncrement(this):f);return this};g.prototype.destroy=function(){function h(){if(f.graphic||f.dataLabel||f.dataLabels)t(f),f.destroyElements();for(m in f)f[m]=
null}var f=this,a=f.series,l=a.chart;a=a.options.dataSorting;var e=l.hoverPoints,c=H(f.series.chart.renderer.globalAnimation),m;f.legendItem&&l.legend.destroyItem(f);e&&(f.setState(),K(e,f),e.length||(l.hoverPoints=null));if(f===l.hoverPoint)f.onMouseOut();a&&a.enabled?(this.animateBeforeDestroy(),D(h,c.duration)):h();l.pointCount--};g.prototype.destroyElements=function(h){var f=this;h=f.getGraphicalProps(h);h.singular.forEach(function(a){f[a]=f[a].destroy()});h.plural.forEach(function(a){f[a].forEach(function(a){a.element&&
a.destroy()});delete f[a]})};g.prototype.firePointEvent=function(h,f,a){var l=this,e=this.series.options;(e.point.events[h]||l.options&&l.options.events&&l.options.events[h])&&l.importEvents();"click"===h&&e.allowPointSelect&&(a=function(a){l.select&&l.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});N(l,h,f,a)};g.prototype.getClassName=function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+
("undefined"!==typeof this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")};g.prototype.getGraphicalProps=function(h){var f=this,a=[],l,e={singular:[],plural:[]};h=h||{graphic:1,dataLabel:1};h.graphic&&a.push("graphic","shadowGroup");h.dataLabel&&a.push("dataLabel","dataLabelUpper","connector");for(l=a.length;l--;){var c=a[l];f[c]&&e.singular.push(c)}["dataLabel",
"connector"].forEach(function(a){var c=a+"s";h[a]&&f[c]&&e.plural.push(c)});return e};g.prototype.getLabelConfig=function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}};g.prototype.getNestedProperty=function(h){if(h)return 0===h.indexOf("custom.")?y(h,this.options):this[h]};g.prototype.getZone=function(){var h=this.series,f=h.zones;h=h.zoneAxis||
"y";var a=0,l;for(l=f[a];this[h]>=l.value;)l=f[++a];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=l&&l.color&&!this.options.color?l.color:this.nonZonedColor;return l};g.prototype.hasNewShapeType=function(){return(this.graphic&&(this.graphic.symbolName||this.graphic.element.nodeName))!==this.shapeType};g.prototype.init=function(h,f,a){this.series=h;this.applyOptions(f,a);this.id=v(this.id)?this.id:q();this.resolveColor();h.chart.pointCount++;N(this,"afterInit");return this};g.prototype.optionsToObject=
function(h){var f={},a=this.series,l=a.options.keys,e=l||a.pointArrayMap||["y"],c=e.length,m=0,u=0;if(J(h)||null===h)f[e[0]]=h;else if(I(h))for(!l&&h.length>c&&(a=typeof h[0],"string"===a?f.name=h[0]:"number"===a&&(f.x=h[0]),m++);u<c;)l&&"undefined"===typeof h[m]||(0<e[u].indexOf(".")?g.prototype.setNestedProperty(f,h[m],e[u]):f[e[u]]=h[m]),m++,u++;else"object"===typeof h&&(f=h,h.dataLabels&&(a._hasPointLabels=!0),h.marker&&(a._hasPointMarkers=!0));return f};g.prototype.resolveColor=function(){var h=
this.series;var f=h.chart.options.chart.colorCount;var a=h.chart.styledMode;delete this.nonZonedColor;a||this.options.color||(this.color=h.color);h.options.colorByPoint?(a||(f=h.options.colors||h.chart.options.colors,this.color=this.color||f[h.colorCounter],f=f.length),a=h.colorCounter,h.colorCounter++,h.colorCounter===f&&(h.colorCounter=0)):a=h.colorIndex;this.colorIndex=z(this.colorIndex,a)};g.prototype.setNestedProperty=function(h,f,a){a.split(".").reduce(function(a,e,c,h){a[e]=h.length-1===c?
f:E(a[e],!0)?a[e]:{};return a[e]},h);return h};g.prototype.tooltipFormatter=function(h){var f=this.series,a=f.tooltipOptions,l=z(a.valueDecimals,""),e=a.valuePrefix||"",c=a.valueSuffix||"";f.chart.styledMode&&(h=f.chart.tooltip.styledModeFormat(h));(f.pointArrayMap||["y"]).forEach(function(a){a="{point."+a;if(e||c)h=h.replace(RegExp(a+"}","g"),e+a+"}"+c);h=h.replace(RegExp(a+"}","g"),a+":,."+l+"f}")});return M(h,{point:this,series:this.series},f.chart)};return g}();k.Point=g;return k.Point});P(A,
"parts/Series.js",[A["mixins/legend-symbol.js"],A["parts/Globals.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(k,g,H,v){"";var K=v.addEvent,G=v.animObject,N=v.arrayMax,M=v.arrayMin,y=v.clamp,I=v.correctFloat,J=v.defined,E=v.erase,D=v.error,z=v.extend,t=v.find,q=v.fireEvent,r=v.getNestedProperty,h=v.isArray,f=v.isFunction,a=v.isNumber,l=v.isString,e=v.merge,c=v.objectEach,m=v.pick,u=v.removeEvent,L=v.seriesType,F=v.splat,w=v.syncTimeout,p=g.defaultOptions,C=g.defaultPlotOptions,O=g.seriesTypes,
B=g.SVGElement,d=g.win;g.Series=L("line",null,{lineWidth:2,allowPointSelect:!1,crisp:!0,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{enabledThreshold:2,lineColor:"#ffffff",lineWidth:0,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){var b=this.series.chart.numberFormatter;return"number"!==typeof this.y?
"":b(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],coll:"series",
colorCounter:0,cropShoulder:1,directTouch:!1,eventsToUnbind:[],isCartesian:!0,parallelArrays:["x","y"],pointClass:H,requireSorting:!0,sorted:!0,init:function(b,a){q(this,"init",{options:a});var d=this,e=b.series,h;this.eventOptions=this.eventOptions||{};d.chart=b;d.options=a=d.setOptions(a);d.linkedSeries=[];d.bindAxes();z(d,{name:a.name,state:"",visible:!1!==a.visible,selected:!0===a.selected});var n=a.events;c(n,function(b,a){f(b)&&d.eventOptions[a]!==b&&(f(d.eventOptions[a])&&u(d,a,d.eventOptions[a]),
d.eventOptions[a]=b,K(d,a,b))});if(n&&n.click||a.point&&a.point.events&&a.point.events.click||a.allowPointSelect)b.runTrackerClick=!0;d.getColor();d.getSymbol();d.parallelArrays.forEach(function(b){d[b+"Data"]||(d[b+"Data"]=[])});d.isCartesian&&(b.hasCartesianSeries=!0);e.length&&(h=e[e.length-1]);d._i=m(h&&h._i,-1)+1;b.orderSeries(this.insert(e));a.dataSorting&&a.dataSorting.enabled?d.setDataSortingOptions():d.points||d.data||d.setData(a.data,!1);q(this,"afterInit")},is:function(b){return O[b]&&
this instanceof O[b]},insert:function(b){var d=this.options.index,c;if(a(d)){for(c=b.length;c--;)if(d>=m(b[c].options.index,b[c]._i)){b.splice(c+1,0,this);break}-1===c&&b.unshift(this);c+=1}else b.push(this);return m(c,b.length-1)},bindAxes:function(){var b=this,a=b.options,d=b.chart,c;q(this,"bindAxes",null,function(){(b.axisTypes||[]).forEach(function(e){d[e].forEach(function(d){c=d.options;if(a[e]===c.index||"undefined"!==typeof a[e]&&a[e]===c.id||"undefined"===typeof a[e]&&0===c.index)b.insert(d.series),
b[e]=d,d.isDirty=!0});b[e]||b.optionalAxis===e||D(18,!0,d)})});q(this,"afterBindAxes")},updateParallelArrays:function(b,d){var c=b.series,e=arguments,f=a(d)?function(a){var e="y"===a&&c.toYData?c.toYData(b):b[a];c[a+"Data"][d]=e}:function(b){Array.prototype[d].apply(c[b+"Data"],Array.prototype.slice.call(e,2))};c.parallelArrays.forEach(f)},hasData:function(){return this.visible&&"undefined"!==typeof this.dataMax&&"undefined"!==typeof this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var b=
this.options,a=this.xIncrement,d,c=b.pointIntervalUnit,e=this.chart.time;a=m(a,b.pointStart,0);this.pointInterval=d=m(this.pointInterval,b.pointInterval,1);c&&(b=new e.Date(a),"day"===c?e.set("Date",b,e.get("Date",b)+d):"month"===c?e.set("Month",b,e.get("Month",b)+d):"year"===c&&e.set("FullYear",b,e.get("FullYear",b)+d),d=b.getTime()-a);this.xIncrement=a+d;return a},setDataSortingOptions:function(){var b=this.options;z(this,{requireSorting:!1,sorted:!1,enabledDataSorting:!0,allowDG:!1});J(b.pointRange)||
(b.pointRange=1)},setOptions:function(b){var a=this.chart,d=a.options,c=d.plotOptions,f=a.userOptions||{};b=e(b);a=a.styledMode;var h={plotOptions:c,userOptions:b};q(this,"setOptions",h);var l=h.plotOptions[this.type],u=f.plotOptions||{};this.userOptions=h.userOptions;f=e(l,c.series,f.plotOptions&&f.plotOptions[this.type],b);this.tooltipOptions=e(p.tooltip,p.plotOptions.series&&p.plotOptions.series.tooltip,p.plotOptions[this.type].tooltip,d.tooltip.userOptions,c.series&&c.series.tooltip,c[this.type].tooltip,
b.tooltip);this.stickyTracking=m(b.stickyTracking,u[this.type]&&u[this.type].stickyTracking,u.series&&u.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:f.stickyTracking);null===l.marker&&delete f.marker;this.zoneAxis=f.zoneAxis;d=this.zones=(f.zones||[]).slice();!f.negativeColor&&!f.negativeFillColor||f.zones||(c={value:f[this.zoneAxis+"Threshold"]||f.threshold||0,className:"highcharts-negative"},a||(c.color=f.negativeColor,c.fillColor=f.negativeFillColor),d.push(c));d.length&&
J(d[d.length-1].value)&&d.push(a?{}:{color:this.color,fillColor:this.fillColor});q(this,"afterSetOptions",{options:f});return f},getName:function(){return m(this.options.name,"Series "+(this.index+1))},getCyclic:function(b,a,d){var c=this.chart,e=this.userOptions,f=b+"Index",h=b+"Counter",n=d?d.length:m(c.options.chart[b+"Count"],c[b+"Count"]);if(!a){var p=m(e[f],e["_"+f]);J(p)||(c.series.length||(c[h]=0),e["_"+f]=p=c[h]%n,c[h]+=1);d&&(a=d[p])}"undefined"!==typeof p&&(this[f]=p);this[b]=a},getColor:function(){this.chart.styledMode?
this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||C[this.type].color,this.chart.options.colors)},getPointsCollection:function(){return(this.hasGroupedData?this.points:this.data)||[]},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(b,d){var c=b.id,e=b.x,f=this.points,h,n=this.options.dataSorting;if(c)var p=this.chart.get(c);else if(this.linkedParent||this.enabledDataSorting){var l=
n&&n.matchByName?"name":"index";p=t(f,function(a){return!a.touched&&a[l]===b[l]});if(!p)return}if(p){var m=p&&p.index;"undefined"!==typeof m&&(h=!0)}"undefined"===typeof m&&a(e)&&(m=this.xData.indexOf(e,d));-1!==m&&"undefined"!==typeof m&&this.cropped&&(m=m>=this.cropStart?m-this.cropStart:m);!h&&f[m]&&f[m].touched&&(m=void 0);return m},drawLegendSymbol:k.drawLineMarker,updateData:function(b,d){var c=this.options,e=c.dataSorting,f=this.points,h=[],n,p,m,l=this.requireSorting,u=b.length===f.length,
w=!0;this.xIncrement=null;b.forEach(function(b,d){var p=J(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b)||{};var w=p.x;if(p.id||a(w)){if(w=this.findPointIndex(p,m),-1===w||"undefined"===typeof w?h.push(b):f[w]&&b!==c.data[w]?(f[w].update(b,!1,null,!1),f[w].touched=!0,l&&(m=w+1)):f[w]&&(f[w].touched=!0),!u||d!==w||e&&e.enabled||this.hasDerivedData)n=!0}else h.push(b)},this);if(n)for(b=f.length;b--;)(p=f[b])&&!p.touched&&p.remove&&p.remove(!1,d);else!u||e&&e.enabled?w=!1:(b.forEach(function(b,
a){f[a].update&&b!==f[a].y&&f[a].update(b,!1,null,!1)}),h.length=0);f.forEach(function(b){b&&(b.touched=!1)});if(!w)return!1;h.forEach(function(b){this.addPoint(b,!1,null,null,!1)},this);null===this.xIncrement&&this.xData&&this.xData.length&&(this.xIncrement=N(this.xData),this.autoIncrement());return!0},setData:function(b,d,c,e){var f=this,n=f.points,p=n&&n.length||0,u,w=f.options,x=f.chart,C=w.dataSorting,g=null,r=f.xAxis;g=w.turboThreshold;var F=this.xData,q=this.yData,t=(u=f.pointArrayMap)&&u.length,
B=w.keys,k=0,O=1,z;b=b||[];u=b.length;d=m(d,!0);C&&C.enabled&&(b=this.sortData(b));!1!==e&&u&&p&&!f.cropped&&!f.hasGroupedData&&f.visible&&!f.isSeriesBoosting&&(z=this.updateData(b,c));if(!z){f.xIncrement=null;f.colorCounter=0;this.parallelArrays.forEach(function(b){f[b+"Data"].length=0});if(g&&u>g)if(g=f.getFirstValidPoint(b),a(g))for(c=0;c<u;c++)F[c]=this.autoIncrement(),q[c]=b[c];else if(h(g))if(t)for(c=0;c<u;c++)e=b[c],F[c]=e[0],q[c]=e.slice(1,t+1);else for(B&&(k=B.indexOf("x"),O=B.indexOf("y"),
k=0<=k?k:0,O=0<=O?O:1),c=0;c<u;c++)e=b[c],F[c]=e[k],q[c]=e[O];else D(12,!1,x);else for(c=0;c<u;c++)"undefined"!==typeof b[c]&&(e={series:f},f.pointClass.prototype.applyOptions.apply(e,[b[c]]),f.updateParallelArrays(e,c));q&&l(q[0])&&D(14,!0,x);f.data=[];f.options.data=f.userOptions.data=b;for(c=p;c--;)n[c]&&n[c].destroy&&n[c].destroy();r&&(r.minRange=r.userMinRange);f.isDirty=x.isDirtyBox=!0;f.isDirtyData=!!n;c=!1}"point"===w.legendType&&(this.processData(),this.generatePoints());d&&x.redraw(c)},
sortData:function(b){var a=this,d=a.options.dataSorting.sortKey||"y",c=function(b,a){return J(a)&&b.pointClass.prototype.optionsToObject.call({series:b},a)||{}};b.forEach(function(d,e){b[e]=c(a,d);b[e].index=e},this);b.concat().sort(function(b,a){b=r(d,b);a=r(d,a);return a<b?-1:a>b?1:0}).forEach(function(b,a){b.x=a},this);a.linkedSeries&&a.linkedSeries.forEach(function(a){var d=a.options,e=d.data;d.dataSorting&&d.dataSorting.enabled||!e||(e.forEach(function(d,f){e[f]=c(a,d);b[f]&&(e[f].x=b[f].x,e[f].index=
f)}),a.setData(e,!1))});return b},getProcessedData:function(b){var a=this.xData,d=this.yData,c=a.length;var e=0;var f=this.xAxis,h=this.options;var p=h.cropThreshold;var m=b||this.getExtremesFromAll||h.getExtremesFromAll,l=this.isCartesian;b=f&&f.val2lin;h=!(!f||!f.logarithmic);var u=this.requireSorting;if(f){f=f.getExtremes();var w=f.min;var C=f.max}if(l&&this.sorted&&!m&&(!p||c>p||this.forceCrop))if(a[c-1]<w||a[0]>C)a=[],d=[];else if(this.yData&&(a[0]<w||a[c-1]>C)){e=this.cropData(this.xData,this.yData,
w,C);a=e.xData;d=e.yData;e=e.start;var g=!0}for(p=a.length||1;--p;)if(c=h?b(a[p])-b(a[p-1]):a[p]-a[p-1],0<c&&("undefined"===typeof r||c<r))var r=c;else 0>c&&u&&(D(15,!1,this.chart),u=!1);return{xData:a,yData:d,cropped:g,cropStart:e,closestPointRange:r}},processData:function(b){var a=this.xAxis;if(this.isCartesian&&!this.isDirty&&!a.isDirty&&!this.yAxis.isDirty&&!b)return!1;b=this.getProcessedData();this.cropped=b.cropped;this.cropStart=b.cropStart;this.processedXData=b.xData;this.processedYData=b.yData;
this.closestPointRange=this.basePointRange=b.closestPointRange},cropData:function(b,a,d,c,e){var f=b.length,h=0,n=f,p;e=m(e,this.cropShoulder);for(p=0;p<f;p++)if(b[p]>=d){h=Math.max(0,p-e);break}for(d=p;d<f;d++)if(b[d]>c){n=d+e;break}return{xData:b.slice(h,n),yData:a.slice(h,n),start:h,end:n}},generatePoints:function(){var b=this.options,a=b.data,d=this.data,c,e=this.processedXData,f=this.processedYData,h=this.pointClass,p=e.length,m=this.cropStart||0,l=this.hasGroupedData;b=b.keys;var u=[],w;d||
l||(d=[],d.length=a.length,d=this.data=d);b&&l&&(this.options.keys=!1);for(w=0;w<p;w++){var C=m+w;if(l){var g=(new h).init(this,[e[w]].concat(F(f[w])));g.dataGroup=this.groupMap[w];g.dataGroup.options&&(g.options=g.dataGroup.options,z(g,g.dataGroup.options),delete g.dataLabels)}else(g=d[C])||"undefined"===typeof a[C]||(d[C]=g=(new h).init(this,a[C],e[w]));g&&(g.index=C,u[w]=g)}this.options.keys=b;if(d&&(p!==(c=d.length)||l))for(w=0;w<c;w++)w!==m||l||(w+=p),d[w]&&(d[w].destroyElements(),d[w].plotX=
void 0);this.data=d;this.points=u;q(this,"afterGeneratePoints")},getXExtremes:function(b){return{min:M(b),max:N(b)}},getExtremes:function(b,d){var c=this.xAxis,e=this.yAxis,f=this.processedXData||this.xData,n=[],p=0,m=0;var l=0;var u=this.requireSorting?this.cropShoulder:0,w=e?e.positiveValuesOnly:!1,C;b=b||this.stackedYData||this.processedYData||[];e=b.length;c&&(l=c.getExtremes(),m=l.min,l=l.max);for(C=0;C<e;C++){var g=f[C];var r=b[C];var F=(a(r)||h(r))&&(r.length||0<r||!w);g=d||this.getExtremesFromAll||
this.options.getExtremesFromAll||this.cropped||!c||(f[C+u]||g)>=m&&(f[C-u]||g)<=l;if(F&&g)if(F=r.length)for(;F--;)a(r[F])&&(n[p++]=r[F]);else n[p++]=r}b={dataMin:M(n),dataMax:N(n)};q(this,"afterGetExtremes",{dataExtremes:b});return b},applyExtremes:function(){var b=this.getExtremes();this.dataMin=b.dataMin;this.dataMax=b.dataMax;return b},getFirstValidPoint:function(b){for(var a=null,d=b.length,c=0;null===a&&c<d;)a=b[c],c++;return a},translate:function(){this.processedXData||this.processData();this.generatePoints();
var b=this.options,d=b.stacking,c=this.xAxis,e=c.categories,f=this.enabledDataSorting,p=this.yAxis,l=this.points,u=l.length,w=!!this.modifyValue,C,g=this.pointPlacementToXValue(),r=!!g,F=b.threshold,t=b.startFromThreshold?F:0,B,k=this.zoneAxis||"y",O=Number.MAX_VALUE;for(C=0;C<u;C++){var z=l[C],L=z.x,D=z.y,v=z.low,E=d&&p.stacking&&p.stacking.stacks[(this.negStacks&&D<(t?0:F)?"-":"")+this.stackKey];p.positiveValuesOnly&&null!==D&&0>=D&&(z.isNull=!0);z.plotX=B=I(y(c.translate(L,0,0,0,1,g,"flags"===
this.type),-1E5,1E5));if(d&&this.visible&&E&&E[L]){var G=this.getStackIndicator(G,L,this.index);if(!z.isNull){var M=E[L];var H=M.points[G.key]}}h(H)&&(v=H[0],D=H[1],v===t&&G.key===E[L].base&&(v=m(a(F)&&F,p.min)),p.positiveValuesOnly&&0>=v&&(v=null),z.total=z.stackTotal=M.total,z.percentage=M.total&&z.y/M.total*100,z.stackY=D,this.irregularWidths||M.setOffset(this.pointXOffset||0,this.barW||0));z.yBottom=J(v)?y(p.translate(v,0,1,0,1),-1E5,1E5):null;w&&(D=this.modifyValue(D,z));z.plotY="number"===typeof D&&
Infinity!==D?y(p.translate(D,0,1,0,1),-1E5,1E5):void 0;z.isInside=this.isPointInside(z);z.clientX=r?I(c.translate(L,0,0,0,1,g)):B;z.negative=z[k]<(b[k+"Threshold"]||F||0);z.category=e&&"undefined"!==typeof e[z.x]?e[z.x]:z.x;if(!z.isNull&&!1!==z.visible){"undefined"!==typeof N&&(O=Math.min(O,Math.abs(B-N)));var N=B}z.zone=this.zones.length&&z.getZone();!z.graphic&&this.group&&f&&(z.isNew=!0)}this.closestPointRangePx=O;q(this,"afterTranslate")},getValidPoints:function(b,a,d){var c=this.chart;return(b||
this.points||[]).filter(function(b){return a&&!c.isInsidePlot(b.plotX,b.plotY,c.inverted)?!1:!1!==b.visible&&(d||!b.isNull)})},getClipBox:function(b,a){var d=this.options,c=this.chart,e=c.inverted,f=this.xAxis,h=f&&this.yAxis;b&&!1===d.clip&&h?b=e?{y:-c.chartWidth+h.len+h.pos,height:c.chartWidth,width:c.chartHeight,x:-c.chartHeight+f.len+f.pos}:{y:-h.pos,height:c.chartHeight,width:c.chartWidth,x:-f.pos}:(b=this.clipBox||c.clipBox,a&&(b.width=c.plotSizeX,b.x=0));return a?{width:b.width,x:b.x}:b},setClip:function(b){var a=
this.chart,d=this.options,c=a.renderer,e=a.inverted,f=this.clipBox,h=this.getClipBox(b),p=this.sharedClipKey||["_sharedClip",b&&b.duration,b&&b.easing,h.height,d.xAxis,d.yAxis].join(),m=a[p],l=a[p+"m"];b&&(h.width=0,e&&(h.x=a.plotHeight+(!1!==d.clip?0:a.plotTop)));m?a.hasLoaded||m.attr(h):(b&&(a[p+"m"]=l=c.clipRect(e?a.plotSizeX+99:-99,e?-a.plotLeft:-a.plotTop,99,e?a.chartWidth:a.chartHeight)),a[p]=m=c.clipRect(h),m.count={length:0});b&&!m.count[this.index]&&(m.count[this.index]=!0,m.count.length+=
1);if(!1!==d.clip||b)this.group.clip(b||f?m:a.clipRect),this.markerGroup.clip(l),this.sharedClipKey=p;b||(m.count[this.index]&&(delete m.count[this.index],--m.count.length),0===m.count.length&&p&&a[p]&&(f||(a[p]=a[p].destroy()),a[p+"m"]&&(a[p+"m"]=a[p+"m"].destroy())))},animate:function(b){var a=this.chart,d=G(this.options.animation);if(!a.hasRendered)if(b)this.setClip(d);else{var c=this.sharedClipKey;b=a[c];var e=this.getClipBox(d,!0);b&&b.animate(e,d);a[c+"m"]&&a[c+"m"].animate({width:e.width+99,
x:e.x-(a.inverted?0:99)},d)}},afterAnimate:function(){this.setClip();q(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var b=this.points,a=this.chart,d,c,e=this.options.marker,f=this[this.specialGroup]||this.markerGroup,h=this.xAxis,p=m(e.enabled,!h||h.isRadial?!0:null,this.closestPointRangePx>=e.enabledThreshold*e.radius);if(!1!==e.enabled||this._hasPointMarkers)for(d=0;d<b.length;d++){var l=b[d];var u=(c=l.graphic)?"animate":"attr";var w=l.marker||{};var C=!!l.marker;if((p&&
"undefined"===typeof w.enabled||w.enabled)&&!l.isNull&&!1!==l.visible){var g=m(w.symbol,this.symbol);var r=this.markerAttribs(l,l.selected&&"select");this.enabledDataSorting&&(l.startXPos=h.reversed?-r.width:h.width);var F=!1!==l.isInside;c?c[F?"show":"hide"](F).animate(r):F&&(0<r.width||l.hasImage)&&(l.graphic=c=a.renderer.symbol(g,r.x,r.y,r.width,r.height,C?w:e).add(f),this.enabledDataSorting&&a.hasRendered&&(c.attr({x:l.startXPos}),u="animate"));c&&"animate"===u&&c[F?"show":"hide"](F).animate(r);
if(c&&!a.styledMode)c[u](this.pointAttribs(l,l.selected&&"select"));c&&c.addClass(l.getClassName(),!0)}else c&&(l.graphic=c.destroy())}},markerAttribs:function(b,a){var d=this.options,c=d.marker,e=b.marker||{},f=e.symbol||c.symbol,h=m(e.radius,c.radius);a&&(c=c.states[a],a=e.states&&e.states[a],h=m(a&&a.radius,c&&c.radius,h+(c&&c.radiusPlus||0)));b.hasImage=f&&0===f.indexOf("url");b.hasImage&&(h=0);b={x:d.crisp?Math.floor(b.plotX)-h:b.plotX-h,y:b.plotY-h};h&&(b.width=b.height=2*h);return b},pointAttribs:function(b,
a){var d=this.options.marker,c=b&&b.options,e=c&&c.marker||{},f=this.color,h=c&&c.color,p=b&&b.color;c=m(e.lineWidth,d.lineWidth);var n=b&&b.zone&&b.zone.color;b=1;f=h||n||p||f;h=e.fillColor||d.fillColor||f;f=e.lineColor||d.lineColor||f;a=a||"normal";d=d.states[a];a=e.states&&e.states[a]||{};c=m(a.lineWidth,d.lineWidth,c+m(a.lineWidthPlus,d.lineWidthPlus,0));h=a.fillColor||d.fillColor||h;f=a.lineColor||d.lineColor||f;b=m(a.opacity,d.opacity,b);return{stroke:f,"stroke-width":c,fill:h,opacity:b}},destroy:function(b){var a=
this,e=a.chart,f=/AppleWebKit\/533/.test(d.navigator.userAgent),h,p,l=a.data||[],m,u;q(a,"destroy");this.removeEvents(b);(a.axisTypes||[]).forEach(function(b){(u=a[b])&&u.series&&(E(u.series,a),u.isDirty=u.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(p=l.length;p--;)(m=l[p])&&m.destroy&&m.destroy();a.points=null;v.clearTimeout(a.animationTimeout);c(a,function(b,a){b instanceof B&&!b.survive&&(h=f&&"group"===a?"hide":"destroy",b[h]())});e.hoverSeries===a&&(e.hoverSeries=null);
E(e.series,a);e.orderSeries();c(a,function(d,c){b&&"hcEvents"===c||delete a[c]})},getGraphPath:function(b,a,d){var c=this,e=c.options,f=e.step,h,p=[],n=[],l;b=b||c.points;(h=b.reversed)&&b.reverse();(f={right:1,center:2}[f]||f&&3)&&h&&(f=4-f);b=this.getValidPoints(b,!1,!(e.connectNulls&&!a&&!d));b.forEach(function(h,m){var u=h.plotX,w=h.plotY,C=b[m-1];(h.leftCliff||C&&C.rightCliff)&&!d&&(l=!0);h.isNull&&!J(a)&&0<m?l=!e.connectNulls:h.isNull&&!a?l=!0:(0===m||l?m=[["M",h.plotX,h.plotY]]:c.getPointSpline?
m=[c.getPointSpline(b,h,m)]:f?(m=1===f?[["L",C.plotX,w]]:2===f?[["L",(C.plotX+u)/2,C.plotY],["L",(C.plotX+u)/2,w]]:[["L",u,C.plotY]],m.push(["L",u,w])):m=[["L",u,w]],n.push(h.x),f&&(n.push(h.x),2===f&&n.push(h.x)),p.push.apply(p,m),l=!1)});p.xMap=n;return c.graphPath=p},drawGraph:function(){var b=this,a=this.options,d=(this.gappedPath||this.getGraphPath).call(this),c=this.chart.styledMode,e=[["graph","highcharts-graph"]];c||e[0].push(a.lineColor||this.color||"#cccccc",a.dashStyle);e=b.getZonesGraphs(e);
e.forEach(function(e,f){var h=e[0],p=b[h],n=p?"animate":"attr";p?(p.endX=b.preventGraphAnimation?null:d.xMap,p.animate({d:d})):d.length&&(b[h]=p=b.chart.renderer.path(d).addClass(e[1]).attr({zIndex:1}).add(b.group));p&&!c&&(h={stroke:e[2],"stroke-width":a.lineWidth,fill:b.fillGraph&&b.color||"none"},e[3]?h.dashstyle=e[3]:"square"!==a.linecap&&(h["stroke-linecap"]=h["stroke-linejoin"]="round"),p[n](h).shadow(2>f&&a.shadow));p&&(p.startX=d.xMap,p.isArea=d.isArea)})},getZonesGraphs:function(b){this.zones.forEach(function(a,
d){d=["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(a.className||"")];this.chart.styledMode||d.push(a.color||this.color,a.dashStyle||this.options.dashStyle);b.push(d)},this);return b},applyZones:function(){var b=this,a=this.chart,d=a.renderer,c=this.zones,e,f,h=this.clips||[],p,l=this.graph,u=this.area,w=Math.max(a.chartWidth,a.chartHeight),C=this[(this.zoneAxis||"y")+"Axis"],g=a.inverted,r,F,q,t=!1,B,k;if(c.length&&(l||u)&&C&&"undefined"!==typeof C.min){var z=C.reversed;var O=
C.horiz;l&&!this.showLine&&l.hide();u&&u.hide();var L=C.getExtremes();c.forEach(function(c,n){e=z?O?a.plotWidth:0:O?0:C.toPixels(L.min)||0;e=y(m(f,e),0,w);f=y(Math.round(C.toPixels(m(c.value,L.max),!0)||0),0,w);t&&(e=f=C.toPixels(L.max));r=Math.abs(e-f);F=Math.min(e,f);q=Math.max(e,f);C.isXAxis?(p={x:g?q:F,y:0,width:r,height:w},O||(p.x=a.plotHeight-p.x)):(p={x:0,y:g?q:F,width:w,height:r},O&&(p.y=a.plotWidth-p.y));g&&d.isVML&&(p=C.isXAxis?{x:0,y:z?F:q,height:p.width,width:a.chartWidth}:{x:p.y-a.plotLeft-
a.spacingBox.x,y:0,width:p.height,height:a.chartHeight});h[n]?h[n].animate(p):h[n]=d.clipRect(p);B=b["zone-area-"+n];k=b["zone-graph-"+n];l&&k&&k.clip(h[n]);u&&B&&B.clip(h[n]);t=c.value>L.max;b.resetZones&&0===f&&(f=void 0)});this.clips=h}else b.visible&&(l&&l.show(!0),u&&u.show(!0))},invertGroups:function(b){function a(){["group","markerGroup"].forEach(function(a){d[a]&&(c.renderer.isVML&&d[a].attr({width:d.yAxis.len,height:d.xAxis.len}),d[a].width=d.yAxis.len,d[a].height=d.xAxis.len,d[a].invert(d.isRadialSeries?
!1:b))})}var d=this,c=d.chart;d.xAxis&&(d.eventsToUnbind.push(K(c,"resize",a)),a(),d.invertGroups=a)},plotGroup:function(b,a,d,c,e){var f=this[b],h=!f;h&&(this[b]=f=this.chart.renderer.g().attr({zIndex:c||.1}).add(e));f.addClass("highcharts-"+a+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(J(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(f.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);f.attr({visibility:d})[h?"attr":
"animate"](this.getPlotBox());return f},getPlotBox:function(){var b=this.chart,a=this.xAxis,d=this.yAxis;b.inverted&&(a=d,d=this.xAxis);return{translateX:a?a.left:b.plotLeft,translateY:d?d.top:b.plotTop,scaleX:1,scaleY:1}},removeEvents:function(b){b?this.eventsToUnbind.length&&(this.eventsToUnbind.forEach(function(b){b()}),this.eventsToUnbind.length=0):u(this)},render:function(){var b=this,a=b.chart,d=b.options,c=!b.finishedAnimating&&a.renderer.isSVG&&G(d.animation).duration,e=b.visible?"inherit":
"hidden",f=d.zIndex,h=b.hasRendered,p=a.seriesGroup,l=a.inverted;q(this,"render");var m=b.plotGroup("group","series",e,f,p);b.markerGroup=b.plotGroup("markerGroup","markers",e,f,p);c&&b.animate&&b.animate(!0);m.inverted=b.isCartesian||b.invertable?l:!1;b.drawGraph&&(b.drawGraph(),b.applyZones());b.visible&&b.drawPoints();b.drawDataLabels&&b.drawDataLabels();b.redrawPoints&&b.redrawPoints();b.drawTracker&&!1!==b.options.enableMouseTracking&&b.drawTracker();b.invertGroups(l);!1===d.clip||b.sharedClipKey||
h||m.clip(a.clipRect);c&&b.animate&&b.animate();h||(b.animationTimeout=w(function(){b.afterAnimate()},c||0));b.isDirty=!1;b.hasRendered=!0;q(b,"afterRender")},redraw:function(){var b=this.chart,a=this.isDirty||this.isDirtyData,d=this.group,c=this.xAxis,e=this.yAxis;d&&(b.inverted&&d.attr({width:b.plotWidth,height:b.plotHeight}),d.animate({translateX:m(c&&c.left,b.plotLeft),translateY:m(e&&e.top,b.plotTop)}));this.translate();this.render();a&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(b,
a){var d=this.xAxis,c=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?d.len-b.chartY+d.pos:b.chartX-d.pos,plotY:e?c.len-b.chartX+c.pos:b.chartY-c.pos},a,b)},buildKDTree:function(b){function a(b,c,e){var f;if(f=b&&b.length){var h=d.kdAxisArray[c%e];b.sort(function(b,a){return b[h]-a[h]});f=Math.floor(f/2);return{point:b[f],left:a(b.slice(0,f),c+1,e),right:a(b.slice(f+1),c+1,e)}}}this.buildingKdTree=!0;var d=this,c=-1<d.options.findNearestPointBy.indexOf("y")?2:1;delete d.kdTree;
w(function(){d.kdTree=a(d.getValidPoints(null,!d.directTouch),c,c);d.buildingKdTree=!1},d.options.kdNow||b&&"touchstart"===b.type?0:1)},searchKDTree:function(b,a,d){function c(b,a,d,n){var l=a.point,m=e.kdAxisArray[d%n],u=l;var w=J(b[f])&&J(l[f])?Math.pow(b[f]-l[f],2):null;var C=J(b[h])&&J(l[h])?Math.pow(b[h]-l[h],2):null;C=(w||0)+(C||0);l.dist=J(C)?Math.sqrt(C):Number.MAX_VALUE;l.distX=J(w)?Math.sqrt(w):Number.MAX_VALUE;m=b[m]-l[m];C=0>m?"left":"right";w=0>m?"right":"left";a[C]&&(C=c(b,a[C],d+1,
n),u=C[p]<u[p]?C:l);a[w]&&Math.sqrt(m*m)<u[p]&&(b=c(b,a[w],d+1,n),u=b[p]<u[p]?b:u);return u}var e=this,f=this.kdAxisArray[0],h=this.kdAxisArray[1],p=a?"distX":"dist";a=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree(d);if(this.kdTree)return c(b,this.kdTree,a,a)},pointPlacementToXValue:function(){var b=this.options,d=b.pointRange,c=this.xAxis;b=b.pointPlacement;"between"===b&&(b=c.reversed?-.5:.5);return a(b)?b*m(d,c.pointRange):0},isPointInside:function(b){return"undefined"!==
typeof b.plotY&&"undefined"!==typeof b.plotX&&0<=b.plotY&&b.plotY<=this.yAxis.len&&0<=b.plotX&&b.plotX<=this.xAxis.len}});""});P(A,"parts/Stacking.js",[A["parts/Axis.js"],A["parts/Globals.js"],A["parts/StackingAxis.js"],A["parts/Utilities.js"]],function(k,g,H,v){var K=v.correctFloat,G=v.defined,N=v.destroyObjectProperties,M=v.format,y=v.pick;"";v=g.Chart;var I=g.Series,J=function(){function g(g,k,t,q,r){var h=g.chart.inverted;this.axis=g;this.isNegative=t;this.options=k=k||{};this.x=q;this.total=
null;this.points={};this.stack=r;this.rightCliff=this.leftCliff=0;this.alignOptions={align:k.align||(h?t?"left":"right":"center"),verticalAlign:k.verticalAlign||(h?"middle":t?"bottom":"top"),y:k.y,x:k.x};this.textAlign=k.textAlign||(h?t?"right":"left":"center")}g.prototype.destroy=function(){N(this,this.axis)};g.prototype.render=function(g){var k=this.axis.chart,t=this.options,q=t.format;q=q?M(q,this,k):t.formatter.call(this);this.label?this.label.attr({text:q,visibility:"hidden"}):(this.label=k.renderer.label(q,
null,null,t.shape,null,null,t.useHTML,!1,"stack-labels"),q={r:t.borderRadius||0,text:q,rotation:t.rotation,padding:y(t.padding,5),visibility:"hidden"},k.styledMode||(q.fill=t.backgroundColor,q.stroke=t.borderColor,q["stroke-width"]=t.borderWidth,this.label.css(t.style)),this.label.attr(q),this.label.added||this.label.add(g));this.label.labelrank=k.plotHeight};g.prototype.setOffset=function(g,k,t,q,r){var h=this.axis,f=h.chart;q=h.translate(h.stacking.usePercentage?100:q?q:this.total,0,0,0,1);t=h.translate(t?
t:0);t=G(q)&&Math.abs(q-t);g=y(r,f.xAxis[0].translate(this.x))+g;h=G(q)&&this.getStackBox(f,this,g,q,k,t,h);k=this.label;t=this.isNegative;g="justify"===y(this.options.overflow,"justify");var a=this.textAlign;k&&h&&(r=k.getBBox(),q=k.padding,a="left"===a?f.inverted?-q:q:"right"===a?r.width:f.inverted&&"center"===a?r.width/2:f.inverted?t?r.width+q:-q:r.width/2,t=f.inverted?r.height/2:t?-q:r.height,this.alignOptions.x=y(this.options.x,0),this.alignOptions.y=y(this.options.y,0),h.x-=a,h.y-=t,k.align(this.alignOptions,
null,h),f.isInsidePlot(k.alignAttr.x+a-this.alignOptions.x,k.alignAttr.y+t-this.alignOptions.y)?k.show():(k.alignAttr.y=-9999,g=!1),g&&I.prototype.justifyDataLabel.call(this.axis,k,this.alignOptions,k.alignAttr,r,h),k.attr({x:k.alignAttr.x,y:k.alignAttr.y}),y(!g&&this.options.crop,!0)&&((f=f.isInsidePlot(k.x-q+k.width,k.y)&&f.isInsidePlot(k.x+q,k.y))||k.hide()))};g.prototype.getStackBox=function(g,k,t,q,r,h,f){var a=k.axis.reversed,l=g.inverted,e=f.height+f.pos-(l?g.plotLeft:g.plotTop);k=k.isNegative&&
!a||!k.isNegative&&a;return{x:l?k?q-f.right:q-h+f.pos-g.plotLeft:t+g.xAxis[0].transB-g.plotLeft,y:l?f.height-t-r:k?e-q-h:e-q,width:l?h:r,height:l?r:h}};return g}();v.prototype.getStacks=function(){var g=this,k=g.inverted;g.yAxis.forEach(function(g){g.stacking&&g.stacking.stacks&&g.hasVisibleSeries&&(g.stacking.oldStacks=g.stacking.stacks)});g.series.forEach(function(z){var t=z.xAxis&&z.xAxis.options||{};!z.options.stacking||!0!==z.visible&&!1!==g.options.chart.ignoreHiddenSeries||(z.stackKey=[z.type,
y(z.options.stack,""),k?t.top:t.left,k?t.height:t.width].join())})};H.compose(k);I.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var g=this.processedXData,k=this.processedYData,z=[],t=k.length,q=this.options,r=q.threshold,h=y(q.startFromThreshold&&r,0),f=q.stack;q=q.stacking;var a=this.stackKey,l="-"+a,e=this.negStacks,c=this.yAxis,m=c.stacking.stacks,u=c.stacking.oldStacks,L,F;c.stacking.stacksTouched+=1;for(F=
0;F<t;F++){var w=g[F];var p=k[F];var C=this.getStackIndicator(C,w,this.index);var O=C.key;var B=(L=e&&p<(h?0:r))?l:a;m[B]||(m[B]={});m[B][w]||(u[B]&&u[B][w]?(m[B][w]=u[B][w],m[B][w].total=null):m[B][w]=new J(c,c.options.stackLabels,L,w,f));B=m[B][w];null!==p?(B.points[O]=B.points[this.index]=[y(B.cumulative,h)],G(B.cumulative)||(B.base=O),B.touched=c.stacking.stacksTouched,0<C.index&&!1===this.singleStacks&&(B.points[O][0]=B.points[this.index+","+w+",0"][0])):B.points[O]=B.points[this.index]=null;
"percent"===q?(L=L?a:l,e&&m[L]&&m[L][w]?(L=m[L][w],B.total=L.total=Math.max(L.total,B.total)+Math.abs(p)||0):B.total=K(B.total+(Math.abs(p)||0))):B.total=K(B.total+(p||0));B.cumulative=y(B.cumulative,h)+(p||0);null!==p&&(B.points[O].push(B.cumulative),z[F]=B.cumulative)}"percent"===q&&(c.stacking.usePercentage=!0);this.stackedYData=z;c.stacking.oldStacks={}}};I.prototype.modifyStacks=function(){var g=this,k=g.stackKey,z=g.yAxis.stacking.stacks,t=g.processedXData,q,r=g.options.stacking;g[r+"Stacker"]&&
[k,"-"+k].forEach(function(h){for(var f=t.length,a,l;f--;)if(a=t[f],q=g.getStackIndicator(q,a,g.index,h),l=(a=z[h]&&z[h][a])&&a.points[q.key])g[r+"Stacker"](l,a,f)})};I.prototype.percentStacker=function(g,k,z){k=k.total?100/k.total:0;g[0]=K(g[0]*k);g[1]=K(g[1]*k);this.stackedYData[z]=g[1]};I.prototype.getStackIndicator=function(g,k,z,t){!G(g)||g.x!==k||t&&g.key!==t?g={x:k,index:0,key:t}:g.index++;g.key=[z,k,g.index].join();return g};g.StackItem=J;return g.StackItem});P(A,"parts/Dynamics.js",[A["parts/Globals.js"],
A["parts/Point.js"],A["parts/Time.js"],A["parts/Utilities.js"]],function(k,g,H,v){var K=v.addEvent,G=v.animate,N=v.createElement,M=v.css,y=v.defined,I=v.erase,J=v.error,E=v.extend,D=v.fireEvent,z=v.isArray,t=v.isNumber,q=v.isObject,r=v.isString,h=v.merge,f=v.objectEach,a=v.pick,l=v.relativeLength,e=v.setAnimation,c=v.splat,m=k.Axis;v=k.Chart;var u=k.Series,L=k.seriesTypes;k.cleanRecursively=function(a,c){var e={};f(a,function(f,h){if(q(a[h],!0)&&!a.nodeType&&c[h])f=k.cleanRecursively(a[h],c[h]),Object.keys(f).length&&
(e[h]=f);else if(q(a[h])||a[h]!==c[h])e[h]=a[h]});return e};E(v.prototype,{addSeries:function(c,e,f){var h,p=this;c&&(e=a(e,!0),D(p,"addSeries",{options:c},function(){h=p.initSeries(c);p.isDirtyLegend=!0;p.linkSeries();h.enabledDataSorting&&h.setData(c.data,!1);D(p,"afterAddSeries",{series:h});e&&p.redraw(f)}));return h},addAxis:function(a,c,e,f){return this.createAxis(c?"xAxis":"yAxis",{axis:a,redraw:e,animation:f})},addColorAxis:function(a,c,e){return this.createAxis("colorAxis",{axis:a,redraw:c,
animation:e})},createAxis:function(e,f){var p=this.options,l="colorAxis"===e,u=f.redraw,w=f.animation;f=h(f.axis,{index:this[e].length,isX:"xAxis"===e});var d=l?new k.ColorAxis(this,f):new m(this,f);p[e]=c(p[e]||{});p[e].push(f);l&&(this.isDirtyLegend=!0,this.axes.forEach(function(b){b.series=[]}),this.series.forEach(function(b){b.bindAxes();b.isDirtyData=!0}));a(u,!0)&&this.redraw(w);return d},showLoading:function(c){var e=this,f=e.options,h=e.loadingDiv,l=f.loading,m=function(){h&&M(h,{left:e.plotLeft+
"px",top:e.plotTop+"px",width:e.plotWidth+"px",height:e.plotHeight+"px"})};h||(e.loadingDiv=h=N("div",{className:"highcharts-loading highcharts-loading-hidden"},null,e.container),e.loadingSpan=N("span",{className:"highcharts-loading-inner"},null,h),K(e,"redraw",m));h.className="highcharts-loading";e.loadingSpan.innerHTML=a(c,f.lang.loading,"");e.styledMode||(M(h,E(l.style,{zIndex:10})),M(e.loadingSpan,l.labelStyle),e.loadingShown||(M(h,{opacity:0,display:""}),G(h,{opacity:l.style.opacity||.5},{duration:l.showDuration||
0})));e.loadingShown=!0;m()},hideLoading:function(){var a=this.options,c=this.loadingDiv;c&&(c.className="highcharts-loading highcharts-loading-hidden",this.styledMode||G(c,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){M(c,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),collectionsWithUpdate:["xAxis","yAxis","zAxis","series"],update:function(e,m,p,u){var w=this,g={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},d,b,n,C=e.isResponsiveOptions,q=[];D(w,"update",{options:e});C||w.setResponsive(!1,!0);e=k.cleanRecursively(e,w.options);h(!0,w.userOptions,e);if(d=e.chart){h(!0,w.options.chart,d);"className"in
d&&w.setClassName(d.className);"reflow"in d&&w.setReflow(d.reflow);if("inverted"in d||"polar"in d||"type"in d){w.propFromSeries();var F=!0}"alignTicks"in d&&(F=!0);f(d,function(a,d){-1!==w.propsRequireUpdateSeries.indexOf("chart."+d)&&(b=!0);-1!==w.propsRequireDirtyBox.indexOf(d)&&(w.isDirtyBox=!0);C||-1===w.propsRequireReflow.indexOf(d)||(n=!0)});!w.styledMode&&"style"in d&&w.renderer.setStyle(d.style)}!w.styledMode&&e.colors&&(this.options.colors=e.colors);e.plotOptions&&h(!0,this.options.plotOptions,
e.plotOptions);e.time&&this.time===k.time&&(this.time=new H(e.time));f(e,function(a,d){if(w[d]&&"function"===typeof w[d].update)w[d].update(a,!1);else if("function"===typeof w[g[d]])w[g[d]](a);"chart"!==d&&-1!==w.propsRequireUpdateSeries.indexOf(d)&&(b=!0)});this.collectionsWithUpdate.forEach(function(b){if(e[b]){if("series"===b){var d=[];w[b].forEach(function(b,c){b.options.isInternal||d.push(a(b.options.index,c))})}c(e[b]).forEach(function(a,c){(c=y(a.id)&&w.get(a.id)||w[b][d?d[c]:c])&&c.coll===
b&&(c.update(a,!1),p&&(c.touched=!0));!c&&p&&w.collectionsWithInit[b]&&(w.collectionsWithInit[b][0].apply(w,[a].concat(w.collectionsWithInit[b][1]||[]).concat([!1])).touched=!0)});p&&w[b].forEach(function(b){b.touched||b.options.isInternal?delete b.touched:q.push(b)})}});q.forEach(function(b){b.remove&&b.remove(!1)});F&&w.axes.forEach(function(b){b.update({},!1)});b&&w.getSeriesOrderByLinks().forEach(function(b){b.chart&&b.update({},!1)},this);e.loading&&h(!0,w.options.loading,e.loading);F=d&&d.width;
d=d&&d.height;r(d)&&(d=l(d,F||w.chartWidth));n||t(F)&&F!==w.chartWidth||t(d)&&d!==w.chartHeight?w.setSize(F,d,u):a(m,!0)&&w.redraw(u);D(w,"afterUpdate",{options:e,redraw:m,animation:u})},setSubtitle:function(a,c){this.applyDescription("subtitle",a);this.layOutTitles(c)},setCaption:function(a,c){this.applyDescription("caption",a);this.layOutTitles(c)}});v.prototype.collectionsWithInit={xAxis:[v.prototype.addAxis,[!0]],yAxis:[v.prototype.addAxis,[!1]],series:[v.prototype.addSeries]};E(g.prototype,{update:function(c,
e,f,h){function p(){l.applyOptions(c);var h=b&&l.hasDummyGraphic;h=null===l.y?!h:h;b&&h&&(l.graphic=b.destroy(),delete l.hasDummyGraphic);q(c,!0)&&(b&&b.element&&c&&c.marker&&"undefined"!==typeof c.marker.symbol&&(l.graphic=b.destroy()),c&&c.dataLabels&&l.dataLabel&&(l.dataLabel=l.dataLabel.destroy()),l.connector&&(l.connector=l.connector.destroy()));n=l.index;d.updateParallelArrays(l,n);u.data[n]=q(u.data[n],!0)||q(c,!0)?l.options:a(c,u.data[n]);d.isDirty=d.isDirtyData=!0;!d.fixedBox&&d.hasCartesianSeries&&
(m.isDirtyBox=!0);"point"===u.legendType&&(m.isDirtyLegend=!0);e&&m.redraw(f)}var l=this,d=l.series,b=l.graphic,n,m=d.chart,u=d.options;e=a(e,!0);!1===h?p():l.firePointEvent("update",{options:c},p)},remove:function(a,c){this.series.removePoint(this.series.data.indexOf(this),a,c)}});E(u.prototype,{addPoint:function(c,e,f,h,l){var p=this.options,d=this.data,b=this.chart,n=this.xAxis;n=n&&n.hasNames&&n.names;var m=p.data,u=this.xData,w;e=a(e,!0);var g={series:this};this.pointClass.prototype.applyOptions.apply(g,
[c]);var C=g.x;var r=u.length;if(this.requireSorting&&C<u[r-1])for(w=!0;r&&u[r-1]>C;)r--;this.updateParallelArrays(g,"splice",r,0,0);this.updateParallelArrays(g,r);n&&g.name&&(n[C]=g.name);m.splice(r,0,c);w&&(this.data.splice(r,0,null),this.processData());"point"===p.legendType&&this.generatePoints();f&&(d[0]&&d[0].remove?d[0].remove(!1):(d.shift(),this.updateParallelArrays(g,"shift"),m.shift()));!1!==l&&D(this,"addPoint",{point:g});this.isDirtyData=this.isDirty=!0;e&&b.redraw(h)},removePoint:function(c,
f,h){var p=this,l=p.data,m=l[c],d=p.points,b=p.chart,n=function(){d&&d.length===l.length&&d.splice(c,1);l.splice(c,1);p.options.data.splice(c,1);p.updateParallelArrays(m||{series:p},"splice",c,1);m&&m.destroy();p.isDirty=!0;p.isDirtyData=!0;f&&b.redraw()};e(h,b);f=a(f,!0);m?m.firePointEvent("remove",null,n):n()},remove:function(c,e,f,h){function p(){l.destroy(h);l.remove=null;d.isDirtyLegend=d.isDirtyBox=!0;d.linkSeries();a(c,!0)&&d.redraw(e)}var l=this,d=l.chart;!1!==f?D(l,"remove",null,p):p()},
update:function(c,e){c=k.cleanRecursively(c,this.userOptions);D(this,"update",{options:c});var f=this,l=f.chart,m=f.userOptions,u=f.initialType||f.type,d=c.type||m.type||l.options.chart.type,b=!(this.hasDerivedData||c.dataGrouping||d&&d!==this.type||"undefined"!==typeof c.pointStart||c.pointInterval||c.pointIntervalUnit||c.keys),n=L[u].prototype,w,g=["group","markerGroup","dataLabelsGroup","transformGroup"],r=["eventOptions","navigatorSeries","baseSeries"],q=f.finishedAnimating&&{animation:!1},t=
{};b&&(r.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==c.visible&&r.push("area","graph"),f.parallelArrays.forEach(function(b){r.push(b+"Data")}),c.data&&(c.dataSorting&&E(f.options.dataSorting,c.dataSorting),this.setData(c.data,!1)));c=h(m,q,{index:"undefined"===typeof m.index?f.index:m.index,pointStart:a(m.pointStart,f.xData[0])},!b&&{data:f.options.data},c);b&&c.data&&(c.data=
f.options.data);r=g.concat(r);r.forEach(function(b){r[b]=f[b];delete f[b]});f.remove(!1,null,!1,!0);for(w in n)f[w]=void 0;L[d||u]?E(f,L[d||u].prototype):J(17,!0,l,{missingModuleFor:d||u});r.forEach(function(b){f[b]=r[b]});f.init(l,c);if(b&&this.points){var F=f.options;!1===F.visible?(t.graphic=1,t.dataLabel=1):f._hasPointLabels||(d=F.marker,n=F.dataLabels,d&&(!1===d.enabled||"symbol"in d)&&(t.graphic=1),n&&!1===n.enabled&&(t.dataLabel=1));this.points.forEach(function(b){b&&b.series&&(b.resolveColor(),
Object.keys(t).length&&b.destroyElements(t),!1===F.showInLegend&&b.legendItem&&l.legend.destroyItem(b))},this)}c.zIndex!==m.zIndex&&g.forEach(function(b){f[b]&&f[b].attr({zIndex:c.zIndex})});f.initialType=u;l.linkSeries();D(this,"afterUpdate");a(e,!0)&&l.redraw(b?void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});E(m.prototype,{update:function(c,e){var p=this.chart,l=c&&c.events||{};c=h(this.userOptions,c);p.options[this.coll].indexOf&&
(p.options[this.coll][p.options[this.coll].indexOf(this.userOptions)]=c);f(p.options[this.coll].events,function(a,c){"undefined"===typeof l[c]&&(l[c]=void 0)});this.destroy(!0);this.init(p,E(c,{events:l}));p.isDirtyBox=!0;a(e,!0)&&p.redraw()},remove:function(c){for(var e=this.chart,f=this.coll,h=this.series,l=h.length;l--;)h[l]&&h[l].remove(!1);I(e.axes,this);I(e[f],this);z(e.options[f])?e.options[f].splice(this.options.index,1):delete e.options[f];e[f].forEach(function(a,d){a.options.index=a.userOptions.index=
d});this.destroy();e.isDirtyBox=!0;a(c,!0)&&e.redraw()},setTitle:function(a,c){this.update({title:a},c)},setCategories:function(a,c){this.update({categories:a},c)}})});P(A,"parts/AreaSeries.js",[A["parts/Globals.js"],A["parts/Color.js"],A["mixins/legend-symbol.js"],A["parts/Utilities.js"]],function(k,g,H,v){var K=g.parse,G=v.objectEach,N=v.pick;g=v.seriesType;var M=k.Series;g("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(g){var k=[],y=[],v=this.xAxis,D=this.yAxis,
z=D.stacking.stacks[this.stackKey],t={},q=this.index,r=D.series,h=r.length,f=N(D.options.reversedStacks,!0)?1:-1,a;g=g||this.points;if(this.options.stacking){for(a=0;a<g.length;a++)g[a].leftNull=g[a].rightNull=void 0,t[g[a].x]=g[a];G(z,function(a,c){null!==a.total&&y.push(c)});y.sort(function(a,c){return a-c});var l=r.map(function(a){return a.visible});y.forEach(function(e,c){var m=0,u,g;if(t[e]&&!t[e].isNull)k.push(t[e]),[-1,1].forEach(function(m){var w=1===m?"rightNull":"leftNull",p=0,C=z[y[c+m]];
if(C)for(a=q;0<=a&&a<h;)u=C.points[a],u||(a===q?t[e][w]=!0:l[a]&&(g=z[e].points[a])&&(p-=g[1]-g[0])),a+=f;t[e][1===m?"rightCliff":"leftCliff"]=p});else{for(a=q;0<=a&&a<h;){if(u=z[e].points[a]){m=u[1];break}a+=f}m=D.translate(m,0,1,0,1);k.push({isNull:!0,plotX:v.translate(e,0,0,0,1),x:e,plotY:m,yBottom:m})}})}return k},getGraphPath:function(g){var k=M.prototype.getGraphPath,y=this.options,v=y.stacking,D=this.yAxis,z,t=[],q=[],r=this.index,h=D.stacking.stacks[this.stackKey],f=y.threshold,a=Math.round(D.getThreshold(y.threshold));
y=N(y.connectNulls,"percent"===v);var l=function(e,l,m){var u=g[e];e=v&&h[u.x].points[r];var p=u[m+"Null"]||0;m=u[m+"Cliff"]||0;u=!0;if(m||p){var C=(p?e[0]:e[1])+m;var k=e[0]+m;u=!!p}else!v&&g[l]&&g[l].isNull&&(C=k=f);"undefined"!==typeof C&&(q.push({plotX:c,plotY:null===C?a:D.getThreshold(C),isNull:u,isCliff:!0}),t.push({plotX:c,plotY:null===k?a:D.getThreshold(k),doCurve:!1}))};g=g||this.points;v&&(g=this.getStackPoints(g));for(z=0;z<g.length;z++){v||(g[z].leftCliff=g[z].rightCliff=g[z].leftNull=
g[z].rightNull=void 0);var e=g[z].isNull;var c=N(g[z].rectPlotX,g[z].plotX);var m=N(g[z].yBottom,a);if(!e||y)y||l(z,z-1,"left"),e&&!v&&y||(q.push(g[z]),t.push({x:z,plotX:c,plotY:m})),y||l(z,z+1,"right")}z=k.call(this,q,!0,!0);t.reversed=!0;e=k.call(this,t,!0,!0);(m=e[0])&&"M"===m[0]&&(e[0]=["L",m[1],m[2]]);e=z.concat(e);k=k.call(this,q,!1,y);e.xMap=z.xMap;this.areaPath=e;return k},drawGraph:function(){this.areaPath=[];M.prototype.drawGraph.apply(this);var g=this,k=this.areaPath,v=this.options,E=[["area",
"highcharts-area",this.color,v.fillColor]];this.zones.forEach(function(k,z){E.push(["zone-area-"+z,"highcharts-area highcharts-zone-area-"+z+" "+k.className,k.color||g.color,k.fillColor||v.fillColor])});E.forEach(function(y){var z=y[0],t=g[z],q=t?"animate":"attr",r={};t?(t.endX=g.preventGraphAnimation?null:k.xMap,t.animate({d:k})):(r.zIndex=0,t=g[z]=g.chart.renderer.path(k).addClass(y[1]).add(g.group),t.isArea=!0);g.chart.styledMode||(r.fill=N(y[3],K(y[2]).setOpacity(N(v.fillOpacity,.75)).get()));
t[q](r);t.startX=k.xMap;t.shiftUnit=v.step?2:1})},drawLegendSymbol:H.drawRectangle});""});P(A,"parts/SplineSeries.js",[A["parts/Utilities.js"]],function(k){var g=k.pick;k=k.seriesType;k("spline","line",{},{getPointSpline:function(k,v,K){var G=v.plotX||0,N=v.plotY||0,M=k[K-1];K=k[K+1];if(M&&!M.isNull&&!1!==M.doCurve&&!v.isCliff&&K&&!K.isNull&&!1!==K.doCurve&&!v.isCliff){k=M.plotY||0;var y=K.plotX||0;K=K.plotY||0;var I=0;var J=(1.5*G+(M.plotX||0))/2.5;var E=(1.5*N+k)/2.5;y=(1.5*G+y)/2.5;var D=(1.5*
N+K)/2.5;y!==J&&(I=(D-E)*(y-G)/(y-J)+N-D);E+=I;D+=I;E>k&&E>N?(E=Math.max(k,N),D=2*N-E):E<k&&E<N&&(E=Math.min(k,N),D=2*N-E);D>K&&D>N?(D=Math.max(K,N),E=2*N-D):D<K&&D<N&&(D=Math.min(K,N),E=2*N-D);v.rightContX=y;v.rightContY=D}v=["C",g(M.rightContX,M.plotX,0),g(M.rightContY,M.plotY,0),g(J,G,0),g(E,N,0),G,N];M.rightContX=M.rightContY=void 0;return v}});""});P(A,"parts/AreaSplineSeries.js",[A["parts/Globals.js"],A["mixins/legend-symbol.js"],A["parts/Utilities.js"]],function(k,g,H){H=H.seriesType;var v=
k.seriesTypes.area.prototype;H("areaspline","spline",k.defaultPlotOptions.area,{getStackPoints:v.getStackPoints,getGraphPath:v.getGraphPath,drawGraph:v.drawGraph,drawLegendSymbol:g.drawRectangle});""});P(A,"parts/ColumnSeries.js",[A["parts/Globals.js"],A["parts/Color.js"],A["mixins/legend-symbol.js"],A["parts/Utilities.js"]],function(k,g,H,v){"";var K=g.parse,G=v.animObject,N=v.clamp,M=v.defined,y=v.extend,I=v.isNumber,J=v.merge,E=v.pick;g=v.seriesType;var D=k.Series;g("column","line",{borderRadius:0,
groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){D.prototype.init.apply(this,arguments);var g=this,k=g.chart;
k.hasRendered&&k.series.forEach(function(k){k.type===g.type&&(k.isDirty=!0)})},getColumnMetrics:function(){var g=this,k=g.options,q=g.xAxis,r=g.yAxis,h=q.options.reversedStacks;h=q.reversed&&!h||!q.reversed&&h;var f,a={},l=0;!1===k.grouping?l=1:g.chart.series.forEach(function(c){var e=c.yAxis,h=c.options;if(c.type===g.type&&(c.visible||!g.chart.options.chart.ignoreHiddenSeries)&&r.len===e.len&&r.pos===e.pos){if(h.stacking){f=c.stackKey;"undefined"===typeof a[f]&&(a[f]=l++);var m=a[f]}else!1!==h.grouping&&
(m=l++);c.columnIndex=m}});var e=Math.min(Math.abs(q.transA)*(q.ordinal&&q.ordinal.slope||k.pointRange||q.closestPointRange||q.tickInterval||1),q.len),c=e*k.groupPadding,m=(e-2*c)/(l||1);k=Math.min(k.maxPointWidth||q.len,E(k.pointWidth,m*(1-2*k.pointPadding)));g.columnMetrics={width:k,offset:(m-k)/2+(c+((g.columnIndex||0)+(h?1:0))*m-e/2)*(h?-1:1)};return g.columnMetrics},crispCol:function(g,k,q,r){var h=this.chart,f=this.borderWidth,a=-(f%2?.5:0);f=f%2?.5:1;h.inverted&&h.renderer.isVML&&(f+=1);this.options.crisp&&
(q=Math.round(g+q)+a,g=Math.round(g)+a,q-=g);r=Math.round(k+r)+f;a=.5>=Math.abs(k)&&.5<r;k=Math.round(k)+f;r-=k;a&&r&&(--k,r+=1);return{x:g,y:k,width:q,height:r}},translate:function(){var g=this,k=g.chart,q=g.options,r=g.dense=2>g.closestPointRange*g.xAxis.transA;r=g.borderWidth=E(q.borderWidth,r?0:1);var h=g.xAxis,f=g.yAxis,a=q.threshold,l=g.translatedThreshold=f.getThreshold(a),e=E(q.minPointLength,5),c=g.getColumnMetrics(),m=c.width,u=g.barW=Math.max(m,1+2*r),L=g.pointXOffset=c.offset,F=g.dataMin,
w=g.dataMax;k.inverted&&(l-=.5);q.pointPadding&&(u=Math.ceil(u));D.prototype.translate.apply(g);g.points.forEach(function(c){var p=E(c.yBottom,l),r=999+Math.abs(p),q=m,d=c.plotX;r=N(c.plotY,-r,f.len+r);var b=c.plotX+L,n=u,x=Math.min(r,p),t=Math.max(r,p)-x;if(e&&Math.abs(t)<e){t=e;var z=!f.reversed&&!c.negative||f.reversed&&c.negative;I(a)&&I(w)&&c.y===a&&w<=a&&(f.min||0)<a&&F!==w&&(z=!z);x=Math.abs(x-l)>e?p-e:l-(z?e:0)}M(c.options.pointWidth)&&(q=n=Math.ceil(c.options.pointWidth),b-=Math.round((q-
m)/2));c.barX=b;c.pointWidth=q;c.tooltipPos=k.inverted?[f.len+f.pos-k.plotLeft-r,h.len+h.pos-k.plotTop-(d||0)-L-n/2,t]:[b+n/2,r+f.pos-k.plotTop,t];c.shapeType=g.pointClass.prototype.shapeType||"rect";c.shapeArgs=g.crispCol.apply(g,c.isNull?[b,l,n,0]:[b,x,n,t])})},getSymbol:k.noop,drawLegendSymbol:H.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(g,k){var q=this.options,r=this.pointAttrToOptions||{};var h=r.stroke||
"borderColor";var f=r["stroke-width"]||"borderWidth",a=g&&g.color||this.color,l=g&&g[h]||q[h]||this.color||a,e=g&&g[f]||q[f]||this[f]||0;r=g&&g.options.dashStyle||q.dashStyle;var c=E(g&&g.opacity,q.opacity,1);if(g&&this.zones.length){var m=g.getZone();a=g.options.color||m&&(m.color||g.nonZonedColor)||this.color;m&&(l=m.borderColor||l,r=m.dashStyle||r,e=m.borderWidth||e)}k&&g&&(g=J(q.states[k],g.options.states&&g.options.states[k]||{}),k=g.brightness,a=g.color||"undefined"!==typeof k&&K(a).brighten(g.brightness).get()||
a,l=g[h]||l,e=g[f]||e,r=g.dashStyle||r,c=E(g.opacity,c));h={fill:a,stroke:l,"stroke-width":e,opacity:c};r&&(h.dashstyle=r);return h},drawPoints:function(){var g=this,k=this.chart,q=g.options,r=k.renderer,h=q.animationLimit||250,f;g.points.forEach(function(a){var l=a.graphic,e=!!l,c=l&&k.pointCount<h?"animate":"attr";if(I(a.plotY)&&null!==a.y){f=a.shapeArgs;l&&a.hasNewShapeType()&&(l=l.destroy());g.enabledDataSorting&&(a.startXPos=g.xAxis.reversed?-(f?f.width:0):g.xAxis.width);l||(a.graphic=l=r[a.shapeType](f).add(a.group||
g.group))&&g.enabledDataSorting&&k.hasRendered&&k.pointCount<h&&(l.attr({x:a.startXPos}),e=!0,c="animate");if(l&&e)l[c](J(f));if(q.borderRadius)l[c]({r:q.borderRadius});k.styledMode||l[c](g.pointAttribs(a,a.selected&&"select")).shadow(!1!==a.allowShadow&&q.shadow,null,q.stacking&&!q.borderRadius);l.addClass(a.getClassName(),!0)}else l&&(a.graphic=l.destroy())})},animate:function(g){var k=this,q=this.yAxis,r=k.options,h=this.chart.inverted,f={},a=h?"translateX":"translateY";if(g)f.scaleY=.001,g=N(q.toPixels(r.threshold),
q.pos,q.pos+q.len),h?f.translateX=g-q.len:f.translateY=g,k.clipBox&&k.setClip(),k.group.attr(f);else{var l=k.group.attr(a);k.group.animate({scaleY:1},y(G(k.options.animation),{step:function(e,c){k.group&&(f[a]=l+c.pos*(q.pos-l),k.group.attr(f))}}))}},remove:function(){var g=this,k=g.chart;k.hasRendered&&k.series.forEach(function(k){k.type===g.type&&(k.isDirty=!0)});D.prototype.remove.apply(g,arguments)}});""});P(A,"parts/BarSeries.js",[A["parts/Utilities.js"]],function(k){k=k.seriesType;k("bar","column",
null,{inverted:!0});""});P(A,"parts/ScatterSeries.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.addEvent;g=g.seriesType;var v=k.Series;g("scatter","line",{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group",
"markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&v.prototype.drawGraph.call(this)},applyJitter:function(){var g=this,k=this.options.jitter,v=this.points.length;k&&this.points.forEach(function(G,y){["x","y"].forEach(function(I,J){var E="plot"+I.toUpperCase();if(k[I]&&!G.isNull){var D=g[I+"Axis"];var z=k[I]*D.transA;if(D&&!D.isLog){var t=Math.max(0,G[E]-z);D=Math.min(D.len,G[E]+z);J=1E4*Math.sin(y+J*v);G[E]=t+(D-t)*(J-Math.floor(J));"x"===I&&(G.clientX=
G.plotX)}}})})}});H(v,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});P(A,"mixins/centered-series.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.isNumber,v=g.pick,K=g.relativeLength,G=k.deg2rad;k.CenteredSeriesMixin={getCenter:function(){var g=this.options,k=this.chart,y=2*(g.slicedOffset||0),G=k.plotWidth-2*y,J=k.plotHeight-2*y,E=g.center,D=Math.min(G,J),z=g.size,t=g.innerSize||0;"string"===typeof z&&(z=parseFloat(z));"string"===typeof t&&(t=parseFloat(t));
g=[v(E[0],"50%"),v(E[1],"50%"),v(z&&0>z?void 0:g.size,"100%"),v(t&&0>t?void 0:g.innerSize||0,"0%")];k.angular&&(g[3]=0);for(E=0;4>E;++E)z=g[E],k=2>E||2===E&&/%$/.test(z),g[E]=K(z,[G,J,D,g[2]][E])+(k?y:0);g[3]>g[2]&&(g[3]=g[2]);return g},getStartAndEndRadians:function(g,k){g=H(g)?g:0;k=H(k)&&k>g&&360>k-g?k:g+360;return{start:G*(g+-90),end:G*(k+-90)}}}});P(A,"parts/PieSeries.js",[A["parts/Globals.js"],A["mixins/legend-symbol.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(k,g,H,v){var K=
v.addEvent,G=v.clamp,A=v.defined,M=v.fireEvent,y=v.isNumber,I=v.merge,J=v.pick,E=v.relativeLength,D=v.seriesType,z=v.setAnimation;v=k.CenteredSeriesMixin;var t=v.getStartAndEndRadians,q=k.noop,r=k.Series;D("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,connectorShape:"fixedOffset",crookDistance:"70%",distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},softConnector:!0,x:0},fillColor:void 0,ignoreHiddenPoint:!0,
inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:k.seriesTypes.column.prototype.pointAttribs,animate:function(h){var f=this,a=f.points,l=f.startAngleRad;h||a.forEach(function(a){var c=a.graphic,
e=a.shapeArgs;c&&e&&(c.attr({r:J(a.startR,f.center&&f.center[3]/2),start:l,end:l}),c.animate({r:e.r,start:e.start,end:e.end},f.options.animation))})},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var h,f=0,a=this.points,l=a.length,e=this.options.ignoreHiddenPoint;for(h=0;h<l;h++){var c=a[h];f+=e&&!c.visible?0:c.isNull?0:c.y}this.total=f;for(h=0;h<l;h++)c=a[h],c.percentage=0<f&&(c.visible||!e)?c.y/f*100:0,c.total=f},generatePoints:function(){r.prototype.generatePoints.call(this);
this.updateTotals()},getX:function(h,f,a){var l=this.center,e=this.radii?this.radii[a.index]:l[2]/2;h=Math.asin(G((h-l[1])/(e+a.labelDistance),-1,1));return l[0]+(f?-1:1)*Math.cos(h)*(e+a.labelDistance)+(0<a.labelDistance?(f?-1:1)*this.options.dataLabels.padding:0)},translate:function(h){this.generatePoints();var f=0,a=this.options,l=a.slicedOffset,e=l+(a.borderWidth||0),c=t(a.startAngle,a.endAngle),g=this.startAngleRad=c.start;c=(this.endAngleRad=c.end)-g;var u=this.points,k=a.dataLabels.distance;
a=a.ignoreHiddenPoint;var r,w=u.length;h||(this.center=h=this.getCenter());for(r=0;r<w;r++){var p=u[r];var C=g+f*c;if(!a||p.visible)f+=p.percentage/100;var q=g+f*c;p.shapeType="arc";p.shapeArgs={x:h[0],y:h[1],r:h[2]/2,innerR:h[3]/2,start:Math.round(1E3*C)/1E3,end:Math.round(1E3*q)/1E3};p.labelDistance=J(p.options.dataLabels&&p.options.dataLabels.distance,k);p.labelDistance=E(p.labelDistance,p.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,p.labelDistance);q=(q+C)/2;q>1.5*Math.PI?
q-=2*Math.PI:q<-Math.PI/2&&(q+=2*Math.PI);p.slicedTranslation={translateX:Math.round(Math.cos(q)*l),translateY:Math.round(Math.sin(q)*l)};var B=Math.cos(q)*h[2]/2;var d=Math.sin(q)*h[2]/2;p.tooltipPos=[h[0]+.7*B,h[1]+.7*d];p.half=q<-Math.PI/2||q>Math.PI/2?1:0;p.angle=q;C=Math.min(e,p.labelDistance/5);p.labelPosition={natural:{x:h[0]+B+Math.cos(q)*p.labelDistance,y:h[1]+d+Math.sin(q)*p.labelDistance},"final":{},alignment:0>p.labelDistance?"center":p.half?"right":"left",connectorPosition:{breakAt:{x:h[0]+
B+Math.cos(q)*C,y:h[1]+d+Math.sin(q)*C},touchingSliceAt:{x:h[0]+B,y:h[1]+d}}}}M(this,"afterTranslate")},drawEmpty:function(){var h=this.options;if(0===this.total){var f=this.center[0];var a=this.center[1];this.graph||(this.graph=this.chart.renderer.circle(f,a,0).addClass("highcharts-graph").add(this.group));this.graph.animate({"stroke-width":h.borderWidth,cx:f,cy:a,r:this.center[2]/2,fill:h.fillColor||"none",stroke:h.color||"#cccccc"},this.options.animation)}else this.graph&&(this.graph=this.graph.destroy())},
redrawPoints:function(){var h=this,f=h.chart,a=f.renderer,l,e,c,g,u=h.options.shadow;this.drawEmpty();!u||h.shadowGroup||f.styledMode||(h.shadowGroup=a.g("shadow").attr({zIndex:-1}).add(h.group));h.points.forEach(function(m){var k={};e=m.graphic;if(!m.isNull&&e){g=m.shapeArgs;l=m.getTranslate();if(!f.styledMode){var w=m.shadowGroup;u&&!w&&(w=m.shadowGroup=a.g("shadow").add(h.shadowGroup));w&&w.attr(l);c=h.pointAttribs(m,m.selected&&"select")}m.delayedRendering?(e.setRadialReference(h.center).attr(g).attr(l),
f.styledMode||e.attr(c).attr({"stroke-linejoin":"round"}).shadow(u,w),m.delayedRendering=!1):(e.setRadialReference(h.center),f.styledMode||I(!0,k,c),I(!0,k,g,l),e.animate(k));e.attr({visibility:m.visible?"inherit":"hidden"});e.addClass(m.getClassName())}else e&&(m.graphic=e.destroy())})},drawPoints:function(){var h=this.chart.renderer;this.points.forEach(function(f){f.graphic&&f.hasNewShapeType()&&(f.graphic=f.graphic.destroy());f.graphic||(f.graphic=h[f.shapeType](f.shapeArgs).add(f.series.group),
f.delayedRendering=!0)})},searchPoint:q,sortByAngle:function(h,f){h.sort(function(a,h){return"undefined"!==typeof a.angle&&(h.angle-a.angle)*f})},drawLegendSymbol:g.drawRectangle,getCenter:v.getCenter,getSymbol:q,drawGraph:null},{init:function(){H.prototype.init.apply(this,arguments);var h=this;h.name=J(h.name,"Slice");var f=function(a){h.slice("select"===a.type)};K(h,"select",f);K(h,"unselect",f);return h},isValid:function(){return y(this.y)&&0<=this.y},setVisible:function(h,f){var a=this,l=a.series,
e=l.chart,c=l.options.ignoreHiddenPoint;f=J(f,c);h!==a.visible&&(a.visible=a.options.visible=h="undefined"===typeof h?!a.visible:h,l.options.data[l.data.indexOf(a)]=a.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(c){if(a[c])a[c][h?"show":"hide"](!0)}),a.legendItem&&e.legend.colorizeItem(a,h),h||"hover"!==a.state||a.setState(""),c&&(l.isDirty=!0),f&&e.redraw())},slice:function(h,f,a){var l=this.series;z(a,l.chart);J(f,!0);this.sliced=this.options.sliced=A(h)?h:!this.sliced;
l.options.data[l.data.indexOf(this)]=this.options;this.graphic&&this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(h){var f=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(f.x,f.y,f.r+h,f.r+h,{innerR:f.r-1,start:f.start,end:f.end})},connectorShapes:{fixedOffset:function(h,f,a){var l=f.breakAt;
f=f.touchingSliceAt;return[["M",h.x,h.y],a.softConnector?["C",h.x+("left"===h.alignment?-5:5),h.y,2*l.x-f.x,2*l.y-f.y,l.x,l.y]:["L",l.x,l.y],["L",f.x,f.y]]},straight:function(h,f){f=f.touchingSliceAt;return[["M",h.x,h.y],["L",f.x,f.y]]},crookedLine:function(h,f,a){f=f.touchingSliceAt;var l=this.series,e=l.center[0],c=l.chart.plotWidth,g=l.chart.plotLeft;l=h.alignment;var u=this.shapeArgs.r;a=E(a.crookDistance,1);c="left"===l?e+u+(c+g-e-u)*(1-a):g+(e-u)*a;a=["L",c,h.y];e=!0;if("left"===l?c>h.x||c<
f.x:c<h.x||c>f.x)e=!1;h=[["M",h.x,h.y]];e&&h.push(a);h.push(["L",f.x,f.y]);return h}},getConnectorPath:function(){var h=this.labelPosition,f=this.series.options.dataLabels,a=f.connectorShape,l=this.connectorShapes;l[a]&&(a=l[a]);return a.call(this,{x:h.final.x,y:h.final.y,alignment:h.alignment},h.connectorPosition,f)}});""});P(A,"parts/DataLabels.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.animObject,v=g.arrayMax,A=g.clamp,G=g.defined,N=g.extend,M=g.fireEvent,y=g.format,
I=g.isArray,J=g.merge,E=g.objectEach,D=g.pick,z=g.relativeLength,t=g.splat,q=g.stableSort;g=k.noop;var r=k.Series,h=k.seriesTypes;k.distribute=function(f,a,h){function e(a,c){return a.target-c.target}var c,l=!0,g=f,r=[];var t=0;var w=g.reducedLen||a;for(c=f.length;c--;)t+=f[c].size;if(t>w){q(f,function(a,c){return(c.rank||0)-(a.rank||0)});for(t=c=0;t<=w;)t+=f[c].size,c++;r=f.splice(c-1,f.length)}q(f,e);for(f=f.map(function(a){return{size:a.size,targets:[a.target],align:D(a.align,.5)}});l;){for(c=
f.length;c--;)l=f[c],t=(Math.min.apply(0,l.targets)+Math.max.apply(0,l.targets))/2,l.pos=A(t-l.size*l.align,0,a-l.size);c=f.length;for(l=!1;c--;)0<c&&f[c-1].pos+f[c-1].size>f[c].pos&&(f[c-1].size+=f[c].size,f[c-1].targets=f[c-1].targets.concat(f[c].targets),f[c-1].align=.5,f[c-1].pos+f[c-1].size>a&&(f[c-1].pos=a-f[c-1].size),f.splice(c,1),l=!0)}g.push.apply(g,r);c=0;f.some(function(e){var f=0;if(e.targets.some(function(){g[c].pos=e.pos+f;if("undefined"!==typeof h&&Math.abs(g[c].pos-g[c].target)>h)return g.slice(0,
c+1).forEach(function(a){delete a.pos}),g.reducedLen=(g.reducedLen||a)-.1*a,g.reducedLen>.1*a&&k.distribute(g,a,h),!0;f+=g[c].size;c++}))return!0});q(g,e)};r.prototype.drawDataLabels=function(){function f(a,b){var d=b.filter;return d?(b=d.operator,a=a[d.property],d=d.value,">"===b&&a>d||"<"===b&&a<d||">="===b&&a>=d||"<="===b&&a<=d||"=="===b&&a==d||"==="===b&&a===d?!0:!1):!0}function a(a,b){var d=[],c;if(I(a)&&!I(b))d=a.map(function(a){return J(a,b)});else if(I(b)&&!I(a))d=b.map(function(b){return J(a,
b)});else if(I(a)||I(b))for(c=Math.max(a.length,b.length);c--;)d[c]=J(a[c],b[c]);else d=J(a,b);return d}var h=this,e=h.chart,c=h.options,g=c.dataLabels,u=h.points,k,r=h.hasRendered||0,w=H(c.animation).duration,p=Math.min(w,200),C=!e.renderer.forExport&&D(g.defer,0<p),q=e.renderer;g=a(a(e.options.plotOptions&&e.options.plotOptions.series&&e.options.plotOptions.series.dataLabels,e.options.plotOptions&&e.options.plotOptions[h.type]&&e.options.plotOptions[h.type].dataLabels),g);M(this,"drawDataLabels");
if(I(g)||g.enabled||h._hasPointLabels){var B=h.plotGroup("dataLabelsGroup","data-labels",C&&!r?"hidden":"inherit",g.zIndex||6);C&&(B.attr({opacity:+r}),r||setTimeout(function(){var a=h.dataLabelsGroup;a&&(h.visible&&B.show(!0),a[c.animation?"animate":"attr"]({opacity:1},{duration:p}))},w-p));u.forEach(function(d){k=t(a(g,d.dlOptions||d.options&&d.options.dataLabels));k.forEach(function(b,a){var p=b.enabled&&(!d.isNull||d.dataLabelOnNull)&&f(d,b),g=d.dataLabels?d.dataLabels[a]:d.dataLabel,l=d.connectors?
d.connectors[a]:d.connector,m=D(b.distance,d.labelDistance),n=!g;if(p){var u=d.getLabelConfig();var w=D(b[d.formatPrefix+"Format"],b.format);u=G(w)?y(w,u,e):(b[d.formatPrefix+"Formatter"]||b.formatter).call(u,b);w=b.style;var k=b.rotation;e.styledMode||(w.color=D(b.color,w.color,h.color,"#000000"),"contrast"===w.color?(d.contrastColor=q.getContrast(d.color||h.color),w.color=!G(m)&&b.inside||0>m||c.stacking?d.contrastColor:"#000000"):delete d.contrastColor,c.cursor&&(w.cursor=c.cursor));var r={r:b.borderRadius||
0,rotation:k,padding:b.padding,zIndex:1};e.styledMode||(r.fill=b.backgroundColor,r.stroke=b.borderColor,r["stroke-width"]=b.borderWidth);E(r,function(b,a){"undefined"===typeof b&&delete r[a]})}!g||p&&G(u)?p&&G(u)&&(g?r.text=u:(d.dataLabels=d.dataLabels||[],g=d.dataLabels[a]=k?q.text(u,0,-9999,b.useHTML).addClass("highcharts-data-label"):q.label(u,0,-9999,b.shape,null,null,b.useHTML,null,"data-label"),a||(d.dataLabel=g),g.addClass(" highcharts-data-label-color-"+d.colorIndex+" "+(b.className||"")+
(b.useHTML?" highcharts-tracker":""))),g.options=b,g.attr(r),e.styledMode||g.css(w).shadow(b.shadow),g.added||g.add(B),b.textPath&&!b.useHTML&&(g.setTextPath(d.getDataLabelPath&&d.getDataLabelPath(g)||d.graphic,b.textPath),d.dataLabelPath&&!b.textPath.enabled&&(d.dataLabelPath=d.dataLabelPath.destroy())),h.alignDataLabel(d,g,b,null,n)):(d.dataLabel=d.dataLabel&&d.dataLabel.destroy(),d.dataLabels&&(1===d.dataLabels.length?delete d.dataLabels:delete d.dataLabels[a]),a||delete d.dataLabel,l&&(d.connector=
d.connector.destroy(),d.connectors&&(1===d.connectors.length?delete d.connectors:delete d.connectors[a])))})})}M(this,"afterDrawDataLabels")};r.prototype.alignDataLabel=function(f,a,h,e,c){var g=this,l=this.chart,k=this.isCartesian&&l.inverted,r=this.enabledDataSorting,w=D(f.dlBox&&f.dlBox.centerX,f.plotX,-9999),p=D(f.plotY,-9999),C=a.getBBox(),q=h.rotation,t=h.align,d=l.isInsidePlot(w,Math.round(p),k),b="justify"===D(h.overflow,r?"none":"justify"),n=this.visible&&!1!==f.visible&&(f.series.forceDL||
r&&!b||d||h.inside&&e&&l.isInsidePlot(w,k?e.x+1:e.y+e.height-1,k));var x=function(e){r&&g.xAxis&&!b&&g.setDataLabelStartPos(f,a,c,d,e)};if(n){var v=l.renderer.fontMetrics(l.styledMode?void 0:h.style.fontSize,a).b;e=N({x:k?this.yAxis.len-p:w,y:Math.round(k?this.xAxis.len-w:p),width:0,height:0},e);N(h,{width:C.width,height:C.height});q?(b=!1,w=l.renderer.rotCorr(v,q),w={x:e.x+h.x+e.width/2+w.x,y:e.y+h.y+{top:0,middle:.5,bottom:1}[h.verticalAlign]*e.height},x(w),a[c?"attr":"animate"](w).attr({align:t}),
x=(q+720)%360,x=180<x&&360>x,"left"===t?w.y-=x?C.height:0:"center"===t?(w.x-=C.width/2,w.y-=C.height/2):"right"===t&&(w.x-=C.width,w.y-=x?0:C.height),a.placed=!0,a.alignAttr=w):(x(e),a.align(h,null,e),w=a.alignAttr);b&&0<=e.height?this.justifyDataLabel(a,h,w,C,e,c):D(h.crop,!0)&&(n=l.isInsidePlot(w.x,w.y)&&l.isInsidePlot(w.x+C.width,w.y+C.height));if(h.shape&&!q)a[c?"attr":"animate"]({anchorX:k?l.plotWidth-f.plotY:f.plotX,anchorY:k?l.plotHeight-f.plotX:f.plotY})}c&&r&&(a.placed=!1);n||r&&!b||(a.hide(!0),
a.placed=!1)};r.prototype.setDataLabelStartPos=function(f,a,h,e,c){var g=this.chart,l=g.inverted,k=this.xAxis,r=k.reversed,w=l?a.height/2:a.width/2;f=(f=f.pointWidth)?f/2:0;k=l?c.x:r?-w-f:k.width-w+f;c=l?r?this.yAxis.height-w+f:-w-f:c.y;a.startXPos=k;a.startYPos=c;e?"hidden"===a.visibility&&(a.show(),a.attr({opacity:0}).animate({opacity:1})):a.attr({opacity:1}).animate({opacity:0},void 0,a.hide);g.hasRendered&&(h&&a.attr({x:a.startXPos,y:a.startYPos}),a.placed=!0)};r.prototype.justifyDataLabel=function(f,
a,h,e,c,g){var l=this.chart,m=a.align,k=a.verticalAlign,w=f.box?0:f.padding||0;var p=h.x+w;if(0>p){"right"===m?(a.align="left",a.inside=!0):a.x=-p;var r=!0}p=h.x+e.width-w;p>l.plotWidth&&("left"===m?(a.align="right",a.inside=!0):a.x=l.plotWidth-p,r=!0);p=h.y+w;0>p&&("bottom"===k?(a.verticalAlign="top",a.inside=!0):a.y=-p,r=!0);p=h.y+e.height-w;p>l.plotHeight&&("top"===k?(a.verticalAlign="bottom",a.inside=!0):a.y=l.plotHeight-p,r=!0);r&&(f.placed=!g,f.align(a,null,c));return r};h.pie&&(h.pie.prototype.dataLabelPositioners=
{radialDistributionY:function(f){return f.top+f.distributeBox.pos},radialDistributionX:function(f,a,h,e){return f.getX(h<a.top+2||h>a.bottom-2?e:h,a.half,a)},justify:function(f,a,h){return h[0]+(f.half?-1:1)*(a+f.labelDistance)},alignToPlotEdges:function(f,a,h,e){f=f.getBBox().width;return a?f+e:h-f-e},alignToConnectors:function(f,a,h,e){var c=0,g;f.forEach(function(a){g=a.dataLabel.getBBox().width;g>c&&(c=g)});return a?c+e:h-c-e}},h.pie.prototype.drawDataLabels=function(){var f=this,a=f.data,h,e=
f.chart,c=f.options.dataLabels||{},g=c.connectorPadding,u,q=e.plotWidth,t=e.plotHeight,w=e.plotLeft,p=Math.round(e.chartWidth/3),C,y=f.center,B=y[2]/2,d=y[1],b,n,x,z,E=[[],[]],I,H,A,M,K=[0,0,0,0],N=f.dataLabelPositioners,P;f.visible&&(c.enabled||f._hasPointLabels)&&(a.forEach(function(b){b.dataLabel&&b.visible&&b.dataLabel.shortened&&(b.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),b.dataLabel.shortened=!1)}),r.prototype.drawDataLabels.apply(f),a.forEach(function(b){b.dataLabel&&
(b.visible?(E[b.half].push(b),b.dataLabel._pos=null,!G(c.style.width)&&!G(b.options.dataLabels&&b.options.dataLabels.style&&b.options.dataLabels.style.width)&&b.dataLabel.getBBox().width>p&&(b.dataLabel.css({width:Math.round(.7*p)+"px"}),b.dataLabel.shortened=!0)):(b.dataLabel=b.dataLabel.destroy(),b.dataLabels&&1===b.dataLabels.length&&delete b.dataLabels))}),E.forEach(function(a,p){var l=a.length,m=[],u;if(l){f.sortByAngle(a,p-.5);if(0<f.maxLabelDistance){var r=Math.max(0,d-B-f.maxLabelDistance);
var C=Math.min(d+B+f.maxLabelDistance,e.plotHeight);a.forEach(function(b){0<b.labelDistance&&b.dataLabel&&(b.top=Math.max(0,d-B-b.labelDistance),b.bottom=Math.min(d+B+b.labelDistance,e.plotHeight),u=b.dataLabel.getBBox().height||21,b.distributeBox={target:b.labelPosition.natural.y-b.top+u/2,size:u,rank:b.y},m.push(b.distributeBox))});r=C+u-r;k.distribute(m,r,r/5)}for(M=0;M<l;M++){h=a[M];x=h.labelPosition;b=h.dataLabel;A=!1===h.visible?"hidden":"inherit";H=r=x.natural.y;m&&G(h.distributeBox)&&("undefined"===
typeof h.distributeBox.pos?A="hidden":(z=h.distributeBox.size,H=N.radialDistributionY(h)));delete h.positionIndex;if(c.justify)I=N.justify(h,B,y);else switch(c.alignTo){case "connectors":I=N.alignToConnectors(a,p,q,w);break;case "plotEdges":I=N.alignToPlotEdges(b,p,q,w);break;default:I=N.radialDistributionX(f,h,H,r)}b._attr={visibility:A,align:x.alignment};P=h.options.dataLabels||{};b._pos={x:I+D(P.x,c.x)+({left:g,right:-g}[x.alignment]||0),y:H+D(P.y,c.y)-10};x.final.x=I;x.final.y=H;D(c.crop,!0)&&
(n=b.getBBox().width,r=null,I-n<g&&1===p?(r=Math.round(n-I+g),K[3]=Math.max(r,K[3])):I+n>q-g&&0===p&&(r=Math.round(I+n-q+g),K[1]=Math.max(r,K[1])),0>H-z/2?K[0]=Math.max(Math.round(-H+z/2),K[0]):H+z/2>t&&(K[2]=Math.max(Math.round(H+z/2-t),K[2])),b.sideOverflow=r)}}}),0===v(K)||this.verifyDataLabelOverflow(K))&&(this.placeDataLabels(),this.points.forEach(function(a){P=J(c,a.options.dataLabels);if(u=D(P.connectorWidth,1)){var d;C=a.connector;if((b=a.dataLabel)&&b._pos&&a.visible&&0<a.labelDistance){A=
b._attr.visibility;if(d=!C)a.connector=C=e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(f.dataLabelsGroup),e.styledMode||C.attr({"stroke-width":u,stroke:P.connectorColor||a.color||"#666666"});C[d?"attr":"animate"]({d:a.getConnectorPath()});C.attr("visibility",A)}else C&&(a.connector=C.destroy())}}))},h.pie.prototype.placeDataLabels=function(){this.points.forEach(function(f){var a=f.dataLabel,h;a&&f.visible&&((h=a._pos)?
(a.sideOverflow&&(a._attr.width=Math.max(a.getBBox().width-a.sideOverflow,0),a.css({width:a._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),a.shortened=!0),a.attr(a._attr),a[a.moved?"animate":"attr"](h),a.moved=!0):a&&a.attr({y:-9999}));delete f.distributeBox},this)},h.pie.prototype.alignDataLabel=g,h.pie.prototype.verifyDataLabelOverflow=function(f){var a=this.center,h=this.options,e=h.center,c=h.minSize||80,g=null!==h.size;if(!g){if(null!==e[0])var u=
Math.max(a[2]-Math.max(f[1],f[3]),c);else u=Math.max(a[2]-f[1]-f[3],c),a[0]+=(f[3]-f[1])/2;null!==e[1]?u=A(u,c,a[2]-Math.max(f[0],f[2])):(u=A(u,c,a[2]-f[0]-f[2]),a[1]+=(f[0]-f[2])/2);u<a[2]?(a[2]=u,a[3]=Math.min(z(h.innerSize||0,u),u),this.translate(a),this.drawDataLabels&&this.drawDataLabels()):g=!0}return g});h.column&&(h.column.prototype.alignDataLabel=function(f,a,h,e,c){var g=this.chart.inverted,l=f.series,k=f.dlBox||f.shapeArgs,q=D(f.below,f.plotY>D(this.translatedThreshold,l.yAxis.len)),w=
D(h.inside,!!this.options.stacking);k&&(e=J(k),0>e.y&&(e.height+=e.y,e.y=0),k=e.y+e.height-l.yAxis.len,0<k&&k<e.height&&(e.height-=k),g&&(e={x:l.yAxis.len-e.y-e.height,y:l.xAxis.len-e.x-e.width,width:e.height,height:e.width}),w||(g?(e.x+=q?0:e.width,e.width=0):(e.y+=q?e.height:0,e.height=0)));h.align=D(h.align,!g||w?"center":q?"right":"left");h.verticalAlign=D(h.verticalAlign,g||w?"middle":q?"top":"bottom");r.prototype.alignDataLabel.call(this,f,a,h,e,c);h.inside&&f.contrastColor&&a.css({color:f.contrastColor})})});
P(A,"modules/overlapping-datalabels.src.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var H=g.addEvent,v=g.fireEvent,A=g.isArray,G=g.objectEach,N=g.pick;k=k.Chart;H(k,"render",function(){var g=[];(this.labelCollectors||[]).forEach(function(k){g=g.concat(k())});(this.yAxis||[]).forEach(function(k){k.stacking&&k.options.stackLabels&&!k.options.stackLabels.allowOverlap&&G(k.stacking.stacks,function(k){G(k,function(k){g.push(k.label)})})});(this.series||[]).forEach(function(k){var v=
k.options.dataLabels;k.visible&&(!1!==v.enabled||k._hasPointLabels)&&(k.nodes||k.points).forEach(function(k){k.visible&&(A(k.dataLabels)?k.dataLabels:k.dataLabel?[k.dataLabel]:[]).forEach(function(v){var y=v.options;v.labelrank=N(y.labelrank,k.labelrank,k.shapeArgs&&k.shapeArgs.height);y.allowOverlap||g.push(v)})})});this.hideOverlappingLabels(g)});k.prototype.hideOverlappingLabels=function(g){var k=this,G=g.length,J=k.renderer,E,D,z,t=!1;var q=function(f){var a,h=f.box?0:f.padding||0,e=a=0,c;if(f&&
(!f.alignAttr||f.placed)){var g=f.alignAttr||{x:f.attr("x"),y:f.attr("y")};var u=f.parentGroup;f.width||(a=f.getBBox(),f.width=a.width,f.height=a.height,a=J.fontMetrics(null,f.element).h);var k=f.width-2*h;(c={left:"0",center:"0.5",right:"1"}[f.alignValue])?e=+c*k:Math.round(f.x)!==f.translateX&&(e=f.x-f.translateX);return{x:g.x+(u.translateX||0)+h-e,y:g.y+(u.translateY||0)+h-a,width:f.width-2*h,height:f.height-2*h}}};for(D=0;D<G;D++)if(E=g[D])E.oldOpacity=E.opacity,E.newOpacity=1,E.absoluteBox=q(E);
g.sort(function(f,a){return(a.labelrank||0)-(f.labelrank||0)});for(D=0;D<G;D++){var r=(q=g[D])&&q.absoluteBox;for(E=D+1;E<G;++E){var h=(z=g[E])&&z.absoluteBox;!r||!h||q===z||0===q.newOpacity||0===z.newOpacity||h.x>r.x+r.width||h.x+h.width<r.x||h.y>r.y+r.height||h.y+h.height<r.y||((q.labelrank<z.labelrank?q:z).newOpacity=0)}}g.forEach(function(f){if(f){var a=f.newOpacity;f.oldOpacity!==a&&(f.alignAttr&&f.placed?(f[a?"removeClass":"addClass"]("highcharts-data-label-hidden"),t=!0,f.alignAttr.opacity=
a,f[f.isOld?"animate":"attr"](f.alignAttr,null,function(){k.styledMode||f.css({pointerEvents:a?"auto":"none"});f.visibility=a?"inherit":"hidden";f.placed=!!a}),v(k,"afterHideOverlappingLabel")):f.attr({opacity:a}));f.isOld=!0}});t&&v(k,"afterHideAllOverlappingLabels")}});P(A,"parts/Interaction.js",[A["parts/Globals.js"],A["parts/Legend.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(k,g,H,v){var A=v.addEvent,G=v.createElement,N=v.css,M=v.defined,y=v.extend,I=v.fireEvent,J=v.isArray,E=v.isFunction,
D=v.isNumber,z=v.isObject,t=v.merge,q=v.objectEach,r=v.pick;v=k.Chart;var h=k.defaultOptions,f=k.defaultPlotOptions,a=k.hasTouch,l=k.Series,e=k.seriesTypes,c=k.svg;var m=k.TrackerMixin={drawTrackerPoint:function(){var c=this,e=c.chart,f=e.pointer,h=function(a){var c=f.getPointFromEvent(a);"undefined"!==typeof c&&(f.isDirectTouch=!0,c.onMouseOver(a))},g;c.points.forEach(function(a){g=J(a.dataLabels)?a.dataLabels:a.dataLabel?[a.dataLabel]:[];a.graphic&&(a.graphic.element.point=a);g.forEach(function(c){c.div?
c.div.point=a:c.element.point=a})});c._hasTracking||(c.trackerGroups.forEach(function(g){if(c[g]){c[g].addClass("highcharts-tracker").on("mouseover",h).on("mouseout",function(a){f.onTrackerMouseOut(a)});if(a)c[g].on("touchstart",h);!e.styledMode&&c.options.cursor&&c[g].css(N).css({cursor:c.options.cursor})}}),c._hasTracking=!0);I(this,"afterDrawTracker")},drawTrackerGraph:function(){var e=this,f=e.options,h=f.trackByArea,g=[].concat(h?e.areaPath:e.graphPath),p=e.chart,l=p.pointer,m=p.renderer,k=p.options.tooltip.snap,
d=e.tracker,b=function(b){if(p.hoverSeries!==e)e.onMouseOver()},n="rgba(192,192,192,"+(c?.0001:.002)+")";d?d.attr({d:g}):e.graph&&(e.tracker=m.path(g).attr({visibility:e.visible?"visible":"hidden",zIndex:2}).addClass(h?"highcharts-tracker-area":"highcharts-tracker-line").add(e.group),p.styledMode||e.tracker.attr({"stroke-linecap":"round","stroke-linejoin":"round",stroke:n,fill:h?n:"none","stroke-width":e.graph.strokeWidth()+(h?0:2*k)}),[e.tracker,e.markerGroup].forEach(function(d){d.addClass("highcharts-tracker").on("mouseover",
b).on("mouseout",function(b){l.onTrackerMouseOut(b)});f.cursor&&!p.styledMode&&d.css({cursor:f.cursor});if(a)d.on("touchstart",b)}));I(this,"afterDrawTracker")}};e.column&&(e.column.prototype.drawTracker=m.drawTrackerPoint);e.pie&&(e.pie.prototype.drawTracker=m.drawTrackerPoint);e.scatter&&(e.scatter.prototype.drawTracker=m.drawTrackerPoint);y(g.prototype,{setItemEvents:function(a,c,e){var f=this,h=f.chart.renderer.boxWrapper,g=a instanceof H,l="highcharts-legend-"+(g?"point":"series")+"-active",
m=f.chart.styledMode;(e?[c,a.legendSymbol]:[a.legendGroup]).forEach(function(d){if(d)d.on("mouseover",function(){a.visible&&f.allItems.forEach(function(b){a!==b&&b.setState("inactive",!g)});a.setState("hover");a.visible&&h.addClass(l);m||c.css(f.options.itemHoverStyle)}).on("mouseout",function(){f.chart.styledMode||c.css(t(a.visible?f.itemStyle:f.itemHiddenStyle));f.allItems.forEach(function(b){a!==b&&b.setState("",!g)});h.removeClass(l);a.setState()}).on("click",function(b){var d=function(){a.setVisible&&
a.setVisible();f.allItems.forEach(function(b){a!==b&&b.setState(a.visible?"inactive":"",!g)})};h.removeClass(l);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,d):I(a,"legendItemClick",b,d)})})},createCheckboxForItem:function(a){a.checkbox=G("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);A(a.checkbox,"click",function(c){I(a.series||a,"checkboxClick",{checked:c.target.checked,
item:a},function(){a.select()})})}});y(v.prototype,{showResetZoom:function(){function a(){c.zoomOut()}var c=this,e=h.lang,f=c.options.chart.resetZoomButton,g=f.theme,l=g.states,m="chart"===f.relativeTo||"spaceBox"===f.relativeTo?null:"plotBox";I(this,"beforeShowResetZoom",null,function(){c.resetZoomButton=c.renderer.button(e.resetZoom,null,null,a,g,l&&l.hover).attr({align:f.position.align,title:e.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(f.position,!1,m)});I(this,"afterShowResetZoom")},
zoomOut:function(){I(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var c=this,e,f=c.pointer,h=!1,g=c.inverted?f.mouseDownX:f.mouseDownY;!a||a.resetSelection?(c.axes.forEach(function(a){e=a.zoom()}),f.initiated=!1):a.xAxis.concat(a.yAxis).forEach(function(a){var d=a.axis,b=c.inverted?d.left:d.top,p=c.inverted?b+d.width:b+d.height,l=d.isXAxis,m=!1;if(!l&&g>=b&&g<=p||l||!M(g))m=!0;f[l?"zoomX":"zoomY"]&&m&&(e=d.zoom(a.min,a.max),d.displayBtn&&(h=!0))});var l=c.resetZoomButton;h&&!l?
c.showResetZoom():!h&&z(l)&&(c.resetZoomButton=l.destroy());e&&c.redraw(r(c.options.chart.animation,a&&a.animation,100>c.pointCount))},pan:function(a,c){var e=this,f=e.hoverPoints,h=e.options.chart,g=e.options.mapNavigation&&e.options.mapNavigation.enabled,l;c="object"===typeof c?c:{enabled:c,type:"x"};h&&h.panning&&(h.panning=c);var m=c.type;I(this,"pan",{originalEvent:a},function(){f&&f.forEach(function(b){b.setState()});var d=[1];"xy"===m?d=[1,0]:"y"===m&&(d=[0]);d.forEach(function(b){var d=e[b?
"xAxis":"yAxis"][0],c=d.options,f=d.horiz,h=a[f?"chartX":"chartY"];f=f?"mouseDownX":"mouseDownY";var p=e[f],u=(d.pointRange||0)/2,w=d.reversed&&!e.inverted||!d.reversed&&e.inverted?-1:1,r=d.getExtremes(),C=d.toValue(p-h,!0)+u*w;w=d.toValue(p+d.len-h,!0)-u*w;var q=w<C;p=q?w:C;C=q?C:w;var t=d.hasVerticalPanning(),B=d.panningState;d.series.forEach(function(a){if(t&&!b&&(!B||B.isDirty)){var d=a.getProcessedData(!0);a=a.getExtremes(d.yData,!0);B||(B={startMin:Number.MAX_VALUE,startMax:-Number.MAX_VALUE});
D(a.dataMin)&&D(a.dataMax)&&(B.startMin=Math.min(a.dataMin,B.startMin),B.startMax=Math.max(a.dataMax,B.startMax))}});w=Math.min(k.pick(null===B||void 0===B?void 0:B.startMin,r.dataMin),u?r.min:d.toValue(d.toPixels(r.min)-d.minPixelPadding));u=Math.max(k.pick(null===B||void 0===B?void 0:B.startMax,r.dataMax),u?r.max:d.toValue(d.toPixels(r.max)+d.minPixelPadding));d.panningState=B;if(!c.ordinal){c=w-p;0<c&&(C+=c,p=w);c=C-u;0<c&&(C=u,p-=c);if(d.series.length&&p!==r.min&&C!==r.max&&b||B&&p>=w&&C<=u)d.setExtremes(p,
C,!1,!1,{trigger:"pan"}),e.resetZoomButton||g||!m.match("y")||(e.showResetZoom(),d.displayBtn=!1),l=!0;e[f]=h}});l&&e.redraw(!1);N(e.container,{cursor:"move"})})}});y(H.prototype,{select:function(a,c){var e=this,f=e.series,h=f.chart;this.selectedStaging=a=r(a,!e.selected);e.firePointEvent(a?"select":"unselect",{accumulate:c},function(){e.selected=e.options.selected=a;f.options.data[f.data.indexOf(e)]=e.options;e.setState(a&&"select");c||h.getSelectedPoints().forEach(function(a){var c=a.series;a.selected&&
a!==e&&(a.selected=a.options.selected=!1,c.options.data[c.data.indexOf(a)]=a.options,a.setState(h.hoverPoints&&c.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(a){var c=this.series.chart,e=c.pointer;a=a?e.normalize(a):e.getChartCoordinatesFromPoint(this,c.inverted);e.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(a.hoverPoints||
[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var a=this,c=t(a.series.options.point,a.options).events;a.events=c;q(c,function(c,e){E(c)&&A(a,e,c)});this.hasImportedEvents=!0}},setState:function(a,c){var e=this.series,h=this.state,g=e.options.states[a||"normal"]||{},l=f[e.type].marker&&e.options.marker,m=l&&!1===l.enabled,k=l&&l.states&&l.states[a||"normal"]||{},d=!1===k.enabled,b=e.stateMarkerGraphic,n=this.marker||{},u=
e.chart,q=e.halo,t,v=l&&e.markerAttribs;a=a||"";if(!(a===this.state&&!c||this.selected&&"select"!==a||!1===g.enabled||a&&(d||m&&!1===k.enabled)||a&&n.states&&n.states[a]&&!1===n.states[a].enabled)){this.state=a;v&&(t=e.markerAttribs(this,a));if(this.graphic){h&&this.graphic.removeClass("highcharts-point-"+h);a&&this.graphic.addClass("highcharts-point-"+a);if(!u.styledMode){var z=e.pointAttribs(this,a);var D=r(u.options.chart.animation,g.animation);e.options.inactiveOtherPoints&&z.opacity&&((this.dataLabels||
[]).forEach(function(a){a&&a.animate({opacity:z.opacity},D)}),this.connector&&this.connector.animate({opacity:z.opacity},D));this.graphic.animate(z,D)}t&&this.graphic.animate(t,r(u.options.chart.animation,k.animation,l.animation));b&&b.hide()}else{if(a&&k){h=n.symbol||e.symbol;b&&b.currentSymbol!==h&&(b=b.destroy());if(t)if(b)b[c?"animate":"attr"]({x:t.x,y:t.y});else h&&(e.stateMarkerGraphic=b=u.renderer.symbol(h,t.x,t.y,t.width,t.height).add(e.markerGroup),b.currentSymbol=h);!u.styledMode&&b&&b.attr(e.pointAttribs(this,
a))}b&&(b[a&&this.isInside?"show":"hide"](),b.element.point=this)}a=g.halo;g=(b=this.graphic||b)&&b.visibility||"inherit";a&&a.size&&b&&"hidden"!==g&&!this.isCluster?(q||(e.halo=q=u.renderer.path().add(b.parentGroup)),q.show()[c?"animate":"attr"]({d:this.haloPath(a.size)}),q.attr({"class":"highcharts-halo highcharts-color-"+r(this.colorIndex,e.colorIndex)+(this.className?" "+this.className:""),visibility:g,zIndex:-1}),q.point=this,u.styledMode||q.attr(y({fill:this.color||e.color,"fill-opacity":a.opacity},
a.attributes))):q&&q.point&&q.point.haloPath&&q.animate({d:q.point.haloPath(0)},null,q.hide);I(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});y(l.prototype,{onMouseOver:function(){var a=this.chart,c=a.hoverSeries;a.pointer.setHoverChartIndex();if(c&&c!==this)c.onMouseOut();this.options.events.mouseOver&&I(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,
c=this.chart,e=c.tooltip,f=c.hoverPoint;c.hoverSeries=null;if(f)f.onMouseOut();this&&a.events.mouseOut&&I(this,"mouseOut");!e||this.stickyTracking||e.shared&&!this.noSharedTooltip||e.hide();c.series.forEach(function(a){a.setState("",!0)})},setState:function(a,c){var e=this,f=e.options,h=e.graph,g=f.inactiveOtherPoints,l=f.states,m=f.lineWidth,d=f.opacity,b=r(l[a||"normal"]&&l[a||"normal"].animation,e.chart.options.chart.animation);f=0;a=a||"";if(e.state!==a&&([e.group,e.markerGroup,e.dataLabelsGroup].forEach(function(b){b&&
(e.state&&b.removeClass("highcharts-series-"+e.state),a&&b.addClass("highcharts-series-"+a))}),e.state=a,!e.chart.styledMode)){if(l[a]&&!1===l[a].enabled)return;a&&(m=l[a].lineWidth||m+(l[a].lineWidthPlus||0),d=r(l[a].opacity,d));if(h&&!h.dashstyle)for(l={"stroke-width":m},h.animate(l,b);e["zone-graph-"+f];)e["zone-graph-"+f].attr(l),f+=1;g||[e.group,e.markerGroup,e.dataLabelsGroup,e.labelBySeries].forEach(function(a){a&&a.animate({opacity:d},b)})}c&&g&&e.points&&e.setAllPointsToState(a)},setAllPointsToState:function(a){this.points.forEach(function(c){c.setState&&
c.setState(a)})},setVisible:function(a,c){var e=this,f=e.chart,h=e.legendItem,g=f.options.chart.ignoreHiddenSeries,l=e.visible;var m=(e.visible=a=e.options.visible=e.userOptions.visible="undefined"===typeof a?!l:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(e[a])e[a][m]()});if(f.hoverSeries===e||(f.hoverPoint&&f.hoverPoint.series)===e)e.onMouseOut();h&&f.legend.colorizeItem(e,a);e.isDirty=!0;e.options.stacking&&f.series.forEach(function(a){a.options.stacking&&
a.visible&&(a.isDirty=!0)});e.linkedSeries.forEach(function(d){d.setVisible(a,!1)});g&&(f.isDirtyBox=!0);I(e,m);!1!==c&&f.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected="undefined"===typeof a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);I(this,a?"select":"unselect")},drawTracker:m.drawTrackerGraph})});P(A,"parts/Responsive.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var A=
g.find,v=g.isArray,K=g.isObject,G=g.merge,N=g.objectEach,M=g.pick,y=g.splat,I=g.uniqueKey;k=k.Chart;k.prototype.setResponsive=function(g,k){var v=this.options.responsive,z=[],t=this.currentResponsive;!k&&v&&v.rules&&v.rules.forEach(function(g){"undefined"===typeof g._id&&(g._id=I());this.matchResponsiveRule(g,z)},this);k=G.apply(0,z.map(function(g){return A(v.rules,function(k){return k._id===g}).chartOptions}));k.isResponsiveOptions=!0;z=z.toString()||void 0;z!==(t&&t.ruleIds)&&(t&&this.update(t.undoOptions,
g,!0),z?(t=this.currentOptions(k),t.isResponsiveOptions=!0,this.currentResponsive={ruleIds:z,mergedOptions:k,undoOptions:t},this.update(k,g,!0)):this.currentResponsive=void 0)};k.prototype.matchResponsiveRule=function(g,k){var v=g.condition;(v.callback||function(){return this.chartWidth<=M(v.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=M(v.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=M(v.minWidth,0)&&this.chartHeight>=M(v.minHeight,0)}).call(this)&&k.push(g._id)};k.prototype.currentOptions=function(g){function k(g,
q,r,h){var f;N(g,function(a,g){if(!h&&-1<D.collectionsWithUpdate.indexOf(g))for(a=y(a),r[g]=[],f=0;f<a.length;f++)q[g][f]&&(r[g][f]={},k(a[f],q[g][f],r[g][f],h+1));else K(a)?(r[g]=v(a)?[]:{},k(a,q[g]||{},r[g],h+1)):r[g]="undefined"===typeof q[g]?null:q[g]})}var D=this,z={};k(g,this.options,z,0);return z}});P(A,"masters/highcharts.src.js",[A["parts/Globals.js"]],function(k){return k});P(A,"parts/NavigatorAxis.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var A=k.isTouchDevice,v=
g.addEvent,K=g.correctFloat,G=g.defined,N=g.isNumber,M=g.pick,y=function(){function g(g){this.axis=g}g.prototype.destroy=function(){this.axis=void 0};g.prototype.toFixedRange=function(g,k,v,z){var t=this.axis,q=t.chart;q=q&&q.fixedRange;var r=(t.pointRange||0)/2;g=M(v,t.translate(g,!0,!t.horiz));k=M(z,t.translate(k,!0,!t.horiz));t=q&&(k-g)/q;G(v)||(g=K(g+r));G(z)||(k=K(k-r));.7<t&&1.3>t&&(z?g=k-q:k=g+q);N(g)&&N(k)||(g=k=void 0);return{min:g,max:k}};return g}();return function(){function g(){}g.compose=
function(g){g.keepProps.push("navigatorAxis");v(g,"init",function(){this.navigatorAxis||(this.navigatorAxis=new y(this))});v(g,"zoom",function(g){var k=this.chart.options,v=k.navigator,t=this.navigatorAxis,q=k.chart.pinchType,r=k.rangeSelector;k=k.chart.zoomType;this.isXAxis&&(v&&v.enabled||r&&r.enabled)&&("y"===k?g.zoomed=!1:(!A&&"xy"===k||A&&"xy"===q)&&this.options.range&&(v=t.previousZoom,G(g.newMin)?t.previousZoom=[this.min,this.max]:v&&(g.newMin=v[0],g.newMax=v[1],t.previousZoom=void 0)));"undefined"!==
typeof g.zoomed&&g.preventDefault()})};g.AdditionsClass=y;return g}()});P(A,"parts/ScrollbarAxis.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var A=g.addEvent,v=g.defined,K=g.pick;return function(){function g(){}g.compose=function(g,G){A(g,"afterInit",function(){var g=this;g.options&&g.options.scrollbar&&g.options.scrollbar.enabled&&(g.options.scrollbar.vertical=!g.horiz,g.options.startOnTick=g.options.endOnTick=!1,g.scrollbar=new G(g.chart.renderer,g.options.scrollbar,g.chart),
A(g.scrollbar,"changed",function(y){var G=K(g.options&&g.options.min,g.min),E=K(g.options&&g.options.max,g.max),D=v(g.dataMin)?Math.min(G,g.min,g.dataMin):G,z=(v(g.dataMax)?Math.max(E,g.max,g.dataMax):E)-D;v(G)&&v(E)&&(g.horiz&&!g.reversed||!g.horiz&&g.reversed?(G=D+z*this.to,D+=z*this.from):(G=D+z*(1-this.from),D+=z*(1-this.to)),K(this.options.liveRedraw,k.svg&&!k.isTouchDevice&&!this.chart.isBoosting)||"mouseup"===y.DOMType||!v(y.DOMType)?g.setExtremes(D,G,!0,"mousemove"!==y.DOMType,y):this.setRange(this.from,
this.to))}))});A(g,"afterRender",function(){var g=Math.min(K(this.options.min,this.min),this.min,K(this.dataMin,this.min)),k=Math.max(K(this.options.max,this.max),this.max,K(this.dataMax,this.max)),G=this.scrollbar,E=this.axisTitleMargin+(this.titleOffset||0),D=this.chart.scrollbarsOffsets,z=this.options.margin||0;G&&(this.horiz?(this.opposite||(D[1]+=E),G.position(this.left,this.top+this.height+2+D[1]-(this.opposite?z:0),this.width,this.height),this.opposite||(D[1]+=z),E=1):(this.opposite&&(D[0]+=
E),G.position(this.left+this.width+2+D[0]-(this.opposite?0:z),this.top,this.width,this.height),this.opposite&&(D[0]+=z),E=0),D[E]+=G.size+G.options.margin,isNaN(g)||isNaN(k)||!v(this.min)||!v(this.max)||this.min===this.max?G.setRange(0,1):(D=(this.min-g)/(k-g),g=(this.max-g)/(k-g),this.horiz&&!this.reversed||!this.horiz&&this.reversed?G.setRange(D,g):G.setRange(1-g,1-D)))});A(g,"afterGetOffset",function(){var g=this.horiz?2:1,k=this.scrollbar;k&&(this.chart.scrollbarsOffsets=[0,0],this.chart.axisOffset[g]+=
k.size+k.options.margin)})};return g}()});P(A,"parts/Scrollbar.js",[A["parts/Axis.js"],A["parts/Globals.js"],A["parts/ScrollbarAxis.js"],A["parts/Utilities.js"]],function(k,g,A,v){var H=v.addEvent,G=v.correctFloat,N=v.defined,M=v.destroyObjectProperties,y=v.fireEvent,I=v.merge,J=v.pick,E=v.removeEvent;v=g.defaultOptions;var D=g.hasTouch,z=g.isTouchDevice,t=g.swapXY=function(g,h){h&&g.forEach(function(f){for(var a=f.length,h,e=0;e<a;e+=2)h=f[e+1],"number"===typeof h&&(f[e+1]=f[e+2],f[e+2]=h)});return g},
q=function(){function g(h,f,a){this._events=[];this.from=this.chartY=this.chartX=0;this.scrollbar=this.group=void 0;this.scrollbarButtons=[];this.scrollbarGroup=void 0;this.scrollbarLeft=0;this.scrollbarRifles=void 0;this.scrollbarStrokeWidth=1;this.to=this.size=this.scrollbarTop=0;this.track=void 0;this.trackBorderWidth=1;this.userOptions={};this.y=this.x=0;this.chart=a;this.options=f;this.renderer=a.renderer;this.init(h,f,a)}g.prototype.addEvents=function(){var h=this.options.inverted?[1,0]:[0,
1],f=this.scrollbarButtons,a=this.scrollbarGroup.element,g=this.track.element,e=this.mouseDownHandler.bind(this),c=this.mouseMoveHandler.bind(this),m=this.mouseUpHandler.bind(this);h=[[f[h[0]].element,"click",this.buttonToMinClick.bind(this)],[f[h[1]].element,"click",this.buttonToMaxClick.bind(this)],[g,"click",this.trackClick.bind(this)],[a,"mousedown",e],[a.ownerDocument,"mousemove",c],[a.ownerDocument,"mouseup",m]];D&&h.push([a,"touchstart",e],[a.ownerDocument,"touchmove",c],[a.ownerDocument,"touchend",
m]);h.forEach(function(a){H.apply(null,a)});this._events=h};g.prototype.buttonToMaxClick=function(h){var f=(this.to-this.from)*J(this.options.step,.2);this.updatePosition(this.from+f,this.to+f);y(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:h})};g.prototype.buttonToMinClick=function(h){var f=G(this.to-this.from)*J(this.options.step,.2);this.updatePosition(G(this.from-f),G(this.to-f));y(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:h})};g.prototype.cursorToScrollbarPosition=
function(h){var f=this.options;f=f.minWidth>this.calculatedWidth?f.minWidth:0;return{chartX:(h.chartX-this.x-this.xOffset)/(this.barWidth-f),chartY:(h.chartY-this.y-this.yOffset)/(this.barWidth-f)}};g.prototype.destroy=function(){var h=this.chart.scroller;this.removeEvents();["track","scrollbarRifles","scrollbar","scrollbarGroup","group"].forEach(function(f){this[f]&&this[f].destroy&&(this[f]=this[f].destroy())},this);h&&this===h.scrollbar&&(h.scrollbar=null,M(h.scrollbarButtons))};g.prototype.drawScrollbarButton=
function(h){var f=this.renderer,a=this.scrollbarButtons,g=this.options,e=this.size;var c=f.g().add(this.group);a.push(c);c=f.rect().addClass("highcharts-scrollbar-button").add(c);this.chart.styledMode||c.attr({stroke:g.buttonBorderColor,"stroke-width":g.buttonBorderWidth,fill:g.buttonBackgroundColor});c.attr(c.crisp({x:-.5,y:-.5,width:e+1,height:e+1,r:g.buttonBorderRadius},c.strokeWidth()));c=f.path(t([["M",e/2+(h?-1:1),e/2-3],["L",e/2+(h?-1:1),e/2+3],["L",e/2+(h?2:-2),e/2]],g.vertical)).addClass("highcharts-scrollbar-arrow").add(a[h]);
this.chart.styledMode||c.attr({fill:g.buttonArrowColor})};g.prototype.init=function(h,f,a){this.scrollbarButtons=[];this.renderer=h;this.userOptions=f;this.options=I(g.defaultOptions,f);this.chart=a;this.size=J(this.options.size,this.options.height);f.enabled&&(this.render(),this.addEvents())};g.prototype.mouseDownHandler=function(h){h=this.chart.pointer.normalize(h);h=this.cursorToScrollbarPosition(h);this.chartX=h.chartX;this.chartY=h.chartY;this.initPositions=[this.from,this.to];this.grabbedCenter=
!0};g.prototype.mouseMoveHandler=function(h){var f=this.chart.pointer.normalize(h),a=this.options.vertical?"chartY":"chartX",g=this.initPositions||[];!this.grabbedCenter||h.touches&&0===h.touches[0][a]||(f=this.cursorToScrollbarPosition(f)[a],a=this[a],a=f-a,this.hasDragged=!0,this.updatePosition(g[0]+a,g[1]+a),this.hasDragged&&y(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMType:h.type,DOMEvent:h}))};g.prototype.mouseUpHandler=function(h){this.hasDragged&&y(this,"changed",{from:this.from,
to:this.to,trigger:"scrollbar",DOMType:h.type,DOMEvent:h});this.grabbedCenter=this.hasDragged=this.chartX=this.chartY=null};g.prototype.position=function(h,f,a,g){var e=this.options.vertical,c=0,l=this.rendered?"animate":"attr";this.x=h;this.y=f+this.trackBorderWidth;this.width=a;this.xOffset=this.height=g;this.yOffset=c;e?(this.width=this.yOffset=a=c=this.size,this.xOffset=f=0,this.barWidth=g-2*a,this.x=h+=this.options.margin):(this.height=this.xOffset=g=f=this.size,this.barWidth=a-2*g,this.y+=this.options.margin);
this.group[l]({translateX:h,translateY:this.y});this.track[l]({width:a,height:g});this.scrollbarButtons[1][l]({translateX:e?0:a-f,translateY:e?g-c:0})};g.prototype.removeEvents=function(){this._events.forEach(function(h){E.apply(null,h)});this._events.length=0};g.prototype.render=function(){var h=this.renderer,f=this.options,a=this.size,g=this.chart.styledMode,e;this.group=e=h.g("scrollbar").attr({zIndex:f.zIndex,translateY:-99999}).add();this.track=h.rect().addClass("highcharts-scrollbar-track").attr({x:0,
r:f.trackBorderRadius||0,height:a,width:a}).add(e);g||this.track.attr({fill:f.trackBackgroundColor,stroke:f.trackBorderColor,"stroke-width":f.trackBorderWidth});this.trackBorderWidth=this.track.strokeWidth();this.track.attr({y:-this.trackBorderWidth%2/2});this.scrollbarGroup=h.g().add(e);this.scrollbar=h.rect().addClass("highcharts-scrollbar-thumb").attr({height:a,width:a,r:f.barBorderRadius||0}).add(this.scrollbarGroup);this.scrollbarRifles=h.path(t([["M",-3,a/4],["L",-3,2*a/3],["M",0,a/4],["L",
0,2*a/3],["M",3,a/4],["L",3,2*a/3]],f.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);g||(this.scrollbar.attr({fill:f.barBackgroundColor,stroke:f.barBorderColor,"stroke-width":f.barBorderWidth}),this.scrollbarRifles.attr({stroke:f.rifleColor,"stroke-width":1}));this.scrollbarStrokeWidth=this.scrollbar.strokeWidth();this.scrollbarGroup.translate(-this.scrollbarStrokeWidth%2/2,-this.scrollbarStrokeWidth%2/2);this.drawScrollbarButton(0);this.drawScrollbarButton(1)};g.prototype.setRange=
function(h,f){var a=this.options,g=a.vertical,e=a.minWidth,c=this.barWidth,m,k=!this.rendered||this.hasDragged||this.chart.navigator&&this.chart.navigator.hasDragged?"attr":"animate";if(N(c)){h=Math.max(h,0);var r=Math.ceil(c*h);this.calculatedWidth=m=G(c*Math.min(f,1)-r);m<e&&(r=(c-e+m)*h,m=e);e=Math.floor(r+this.xOffset+this.yOffset);c=m/2-.5;this.from=h;this.to=f;g?(this.scrollbarGroup[k]({translateY:e}),this.scrollbar[k]({height:m}),this.scrollbarRifles[k]({translateY:c}),this.scrollbarTop=e,
this.scrollbarLeft=0):(this.scrollbarGroup[k]({translateX:e}),this.scrollbar[k]({width:m}),this.scrollbarRifles[k]({translateX:c}),this.scrollbarLeft=e,this.scrollbarTop=0);12>=m?this.scrollbarRifles.hide():this.scrollbarRifles.show(!0);!1===a.showFull&&(0>=h&&1<=f?this.group.hide():this.group.show());this.rendered=!0}};g.prototype.trackClick=function(h){var f=this.chart.pointer.normalize(h),a=this.to-this.from,g=this.y+this.scrollbarTop,e=this.x+this.scrollbarLeft;this.options.vertical&&f.chartY>
g||!this.options.vertical&&f.chartX>e?this.updatePosition(this.from+a,this.to+a):this.updatePosition(this.from-a,this.to-a);y(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:h})};g.prototype.update=function(h){this.destroy();this.init(this.chart.renderer,I(!0,this.options,h),this.chart)};g.prototype.updatePosition=function(h,f){1<f&&(h=G(1-G(f-h)),f=1);0>h&&(f=G(f-h),h=0);this.from=h;this.to=f};g.defaultOptions={height:z?20:14,barBorderRadius:0,buttonBorderRadius:0,liveRedraw:void 0,
margin:10,minWidth:6,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:1,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"#333333",trackBackgroundColor:"#f2f2f2",trackBorderColor:"#f2f2f2",trackBorderWidth:1};return g}();g.Scrollbar||(v.scrollbar=I(!0,q.defaultOptions,v.scrollbar),g.Scrollbar=q,A.compose(k,q));return g.Scrollbar});P(A,"parts/Navigator.js",[A["parts/Axis.js"],A["parts/Color.js"],
A["parts/Globals.js"],A["parts/NavigatorAxis.js"],A["parts/Scrollbar.js"],A["parts/Utilities.js"]],function(k,g,A,v,K,G){g=g.parse;var H=G.addEvent,M=G.clamp,y=G.correctFloat,I=G.defined,J=G.destroyObjectProperties,E=G.erase,D=G.extend,z=G.find,t=G.isArray,q=G.isNumber,r=G.merge,h=G.pick,f=G.removeEvent,a=G.splat;G=A.Chart;var l=A.defaultOptions,e=A.hasTouch,c=A.isTouchDevice,m=A.Series,u=function(a){for(var c=[],e=1;e<arguments.length;e++)c[e-1]=arguments[e];c=[].filter.call(c,q);if(c.length)return Math[a].apply(0,
c)};var L="undefined"===typeof A.seriesTypes.areaspline?"line":"areaspline";D(l,{navigator:{height:40,margin:25,maskInside:!0,handles:{width:7,height:15,symbols:["navigator-handle","navigator-handle"],enabled:!0,lineWidth:1,backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:g("#6685c2").setOpacity(.3).get(),outlineColor:"#cccccc",outlineWidth:1,series:{type:L,fillOpacity:.05,lineWidth:1,compare:null,dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,smoothed:!0,units:[["millisecond",
[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2,3,4]],["week",[1,2,3]],["month",[1,3,6]],["year",null]]},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},threshold:null},xAxis:{overscroll:0,className:"highcharts-navigator-xaxis",tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",
style:{color:"#999999"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}});A.Renderer.prototype.symbols["navigator-handle"]=function(a,c,e,f,h){a=h.width/2;c=Math.round(a/3)+.5;h=h.height||0;return[["M",-a-1,.5],["L",a,.5],["L",a,h+.5],["L",-a-1,h+.5],["L",-a-1,.5],["M",-c,4],["L",-c,h-3],["M",c-1,4],["L",c-1,h-3]]};var F=function(){function g(a){this.zoomedMin=
this.zoomedMax=this.yAxis=this.xAxis=this.top=this.size=this.shades=this.rendered=this.range=this.outlineHeight=this.outline=this.opposite=this.navigatorSize=this.navigatorSeries=this.navigatorOptions=this.navigatorGroup=this.navigatorEnabled=this.left=this.height=this.handles=this.chart=this.baseSeries=void 0;this.init(a)}g.prototype.drawHandle=function(a,c,e,f){var d=this.navigatorOptions.handles.height;this.handles[c][f](e?{translateX:Math.round(this.left+this.height/2),translateY:Math.round(this.top+
parseInt(a,10)+.5-d)}:{translateX:Math.round(this.left+parseInt(a,10)),translateY:Math.round(this.top+this.height/2-d/2-1)})};g.prototype.drawOutline=function(a,c,e,f){var d=this.navigatorOptions.maskInside,b=this.outline.strokeWidth(),h=b/2,g=b%2/2;b=this.outlineHeight;var p=this.scrollbarHeight||0,l=this.size,m=this.left-p,k=this.top;e?(m-=h,e=k+c+g,c=k+a+g,g=[["M",m+b,k-p-g],["L",m+b,e],["L",m,e],["L",m,c],["L",m+b,c],["L",m+b,k+l+p]],d&&g.push(["M",m+b,e-h],["L",m+b,c+h])):(a+=m+p-g,c+=m+p-g,
k+=h,g=[["M",m,k],["L",a,k],["L",a,k+b],["L",c,k+b],["L",c,k],["L",m+l+2*p,k]],d&&g.push(["M",a-h,k],["L",c+h,k]));this.outline[f]({d:g})};g.prototype.drawMasks=function(a,c,e,f){var d=this.left,b=this.top,h=this.height;if(e){var g=[d,d,d];var p=[b,b+a,b+c];var m=[h,h,h];var l=[a,c-a,this.size-c]}else g=[d,d+a,d+c],p=[b,b,b],m=[a,c-a,this.size-c],l=[h,h,h];this.shades.forEach(function(a,b){a[f]({x:g[b],y:p[b],width:m[b],height:l[b]})})};g.prototype.renderElements=function(){var a=this,c=a.navigatorOptions,
e=c.maskInside,f=a.chart,d=f.renderer,b,h={cursor:f.inverted?"ns-resize":"ew-resize"};a.navigatorGroup=b=d.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();[!e,e,!e].forEach(function(e,g){a.shades[g]=d.rect().addClass("highcharts-navigator-mask"+(1===g?"-inside":"-outside")).add(b);f.styledMode||a.shades[g].attr({fill:e?c.maskFill:"rgba(0,0,0,0)"}).css(1===g&&h)});a.outline=d.path().addClass("highcharts-navigator-outline").add(b);f.styledMode||a.outline.attr({"stroke-width":c.outlineWidth,
stroke:c.outlineColor});c.handles.enabled&&[0,1].forEach(function(e){c.handles.inverted=f.inverted;a.handles[e]=d.symbol(c.handles.symbols[e],-c.handles.width/2-1,0,c.handles.width,c.handles.height,c.handles);a.handles[e].attr({zIndex:7-e}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][e]).add(b);if(!f.styledMode){var g=c.handles;a.handles[e].attr({fill:g.backgroundColor,stroke:g.borderColor,"stroke-width":g.lineWidth}).css(h)}})};g.prototype.update=function(a){(this.series||
[]).forEach(function(a){a.baseSeries&&delete a.baseSeries.navigatorSeries});this.destroy();r(!0,this.chart.options.navigator,this.options,a);this.init(this.chart)};g.prototype.render=function(a,c,e,f){var d=this.chart,b=this.scrollbarHeight,g,p=this.xAxis,m=p.pointRange||0;var l=p.navigatorAxis.fake?d.xAxis[0]:p;var k=this.navigatorEnabled,r,w=this.rendered;var u=d.inverted;var C=d.xAxis[0].minRange,t=d.xAxis[0].options.maxRange;if(!this.hasDragged||I(e)){a=y(a-m/2);c=y(c+m/2);if(!q(a)||!q(c))if(w)e=
0,f=h(p.width,l.width);else return;this.left=h(p.left,d.plotLeft+b+(u?d.plotWidth:0));this.size=r=g=h(p.len,(u?d.plotHeight:d.plotWidth)-2*b);d=u?b:g+2*b;e=h(e,p.toPixels(a,!0));f=h(f,p.toPixels(c,!0));q(e)&&Infinity!==Math.abs(e)||(e=0,f=d);a=p.toValue(e,!0);c=p.toValue(f,!0);var B=Math.abs(y(c-a));B<C?this.grabbedLeft?e=p.toPixels(c-C-m,!0):this.grabbedRight&&(f=p.toPixels(a+C+m,!0)):I(t)&&y(B-m)>t&&(this.grabbedLeft?e=p.toPixels(c-t-m,!0):this.grabbedRight&&(f=p.toPixels(a+t+m,!0)));this.zoomedMax=
M(Math.max(e,f),0,r);this.zoomedMin=M(this.fixedWidth?this.zoomedMax-this.fixedWidth:Math.min(e,f),0,r);this.range=this.zoomedMax-this.zoomedMin;r=Math.round(this.zoomedMax);e=Math.round(this.zoomedMin);k&&(this.navigatorGroup.attr({visibility:"visible"}),w=w&&!this.hasDragged?"animate":"attr",this.drawMasks(e,r,u,w),this.drawOutline(e,r,u,w),this.navigatorOptions.handles.enabled&&(this.drawHandle(e,0,u,w),this.drawHandle(r,1,u,w)));this.scrollbar&&(u?(u=this.top-b,l=this.left-b+(k||!l.opposite?0:
(l.titleOffset||0)+l.axisTitleMargin),b=g+2*b):(u=this.top+(k?this.height:-b),l=this.left-b),this.scrollbar.position(l,u,d,b),this.scrollbar.setRange(this.zoomedMin/(g||1),this.zoomedMax/(g||1)));this.rendered=!0}};g.prototype.addMouseEvents=function(){var a=this,c=a.chart,f=c.container,h=[],d,b;a.mouseMoveHandler=d=function(b){a.onMouseMove(b)};a.mouseUpHandler=b=function(b){a.onMouseUp(b)};h=a.getPartsEvents("mousedown");h.push(H(c.renderTo,"mousemove",d),H(f.ownerDocument,"mouseup",b));e&&(h.push(H(c.renderTo,
"touchmove",d),H(f.ownerDocument,"touchend",b)),h.concat(a.getPartsEvents("touchstart")));a.eventsToUnbind=h;a.series&&a.series[0]&&h.push(H(a.series[0].xAxis,"foundExtremes",function(){c.navigator.modifyNavigatorAxisExtremes()}))};g.prototype.getPartsEvents=function(a){var c=this,e=[];["shades","handles"].forEach(function(f){c[f].forEach(function(d,b){e.push(H(d.element,a,function(a){c[f+"Mousedown"](a,b)}))})});return e};g.prototype.shadesMousedown=function(a,c){a=this.chart.pointer.normalize(a);
var e=this.chart,f=this.xAxis,d=this.zoomedMin,b=this.left,h=this.size,g=this.range,m=a.chartX;e.inverted&&(m=a.chartY,b=this.top);if(1===c)this.grabbedCenter=m,this.fixedWidth=g,this.dragOffset=m-d;else{a=m-b-g/2;if(0===c)a=Math.max(0,a);else if(2===c&&a+g>=h)if(a=h-g,this.reversedExtremes){a-=g;var p=this.getUnionExtremes().dataMin}else var l=this.getUnionExtremes().dataMax;a!==d&&(this.fixedWidth=g,c=f.navigatorAxis.toFixedRange(a,a+g,p,l),I(c.min)&&e.xAxis[0].setExtremes(Math.min(c.min,c.max),
Math.max(c.min,c.max),!0,null,{trigger:"navigator"}))}};g.prototype.handlesMousedown=function(a,c){this.chart.pointer.normalize(a);a=this.chart;var e=a.xAxis[0],f=this.reversedExtremes;0===c?(this.grabbedLeft=!0,this.otherHandlePos=this.zoomedMax,this.fixedExtreme=f?e.min:e.max):(this.grabbedRight=!0,this.otherHandlePos=this.zoomedMin,this.fixedExtreme=f?e.max:e.min);a.fixedRange=null};g.prototype.onMouseMove=function(a){var e=this,f=e.chart,g=e.left,d=e.navigatorSize,b=e.range,m=e.dragOffset,l=f.inverted;
a.touches&&0===a.touches[0].pageX||(a=f.pointer.normalize(a),f=a.chartX,l&&(g=e.top,f=a.chartY),e.grabbedLeft?(e.hasDragged=!0,e.render(0,0,f-g,e.otherHandlePos)):e.grabbedRight?(e.hasDragged=!0,e.render(0,0,e.otherHandlePos,f-g)):e.grabbedCenter&&(e.hasDragged=!0,f<m?f=m:f>d+m-b&&(f=d+m-b),e.render(0,0,f-m,f-m+b)),e.hasDragged&&e.scrollbar&&h(e.scrollbar.options.liveRedraw,A.svg&&!c&&!this.chart.isBoosting)&&(a.DOMType=a.type,setTimeout(function(){e.onMouseUp(a)},0)))};g.prototype.onMouseUp=function(a){var c=
this.chart,e=this.xAxis,f=this.scrollbar,d=a.DOMEvent||a,b=c.inverted,h=this.rendered&&!this.hasDragged?"animate":"attr",g=Math.round(this.zoomedMax),m=Math.round(this.zoomedMin);if(this.hasDragged&&(!f||!f.hasDragged)||"scrollbar"===a.trigger){f=this.getUnionExtremes();if(this.zoomedMin===this.otherHandlePos)var l=this.fixedExtreme;else if(this.zoomedMax===this.otherHandlePos)var p=this.fixedExtreme;this.zoomedMax===this.size&&(p=this.reversedExtremes?f.dataMin:f.dataMax);0===this.zoomedMin&&(l=
this.reversedExtremes?f.dataMax:f.dataMin);e=e.navigatorAxis.toFixedRange(this.zoomedMin,this.zoomedMax,l,p);I(e.min)&&c.xAxis[0].setExtremes(Math.min(e.min,e.max),Math.max(e.min,e.max),!0,this.hasDragged?!1:null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:d})}"mousemove"!==a.DOMType&&"touchmove"!==a.DOMType&&(this.grabbedLeft=this.grabbedRight=this.grabbedCenter=this.fixedWidth=this.fixedExtreme=this.otherHandlePos=this.hasDragged=this.dragOffset=null);this.navigatorEnabled&&(this.shades&&
this.drawMasks(m,g,b,h),this.outline&&this.drawOutline(m,g,b,h),this.navigatorOptions.handles.enabled&&Object.keys(this.handles).length===this.handles.length&&(this.drawHandle(m,0,b,h),this.drawHandle(g,1,b,h)))};g.prototype.removeEvents=function(){this.eventsToUnbind&&(this.eventsToUnbind.forEach(function(a){a()}),this.eventsToUnbind=void 0);this.removeBaseSeriesEvents()};g.prototype.removeBaseSeriesEvents=function(){var a=this.baseSeries||[];this.navigatorEnabled&&a[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&
a.forEach(function(a){f(a,"updatedData",this.updatedDataHandler)},this),a[0].xAxis&&f(a[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes))};g.prototype.init=function(a){var c=a.options,e=c.navigator,f=e.enabled,d=c.scrollbar,b=d.enabled;c=f?e.height:0;var g=b?d.height:0;this.handles=[];this.shades=[];this.chart=a;this.setBaseSeries();this.height=c;this.scrollbarHeight=g;this.scrollbarEnabled=b;this.navigatorEnabled=f;this.navigatorOptions=e;this.scrollbarOptions=d;this.outlineHeight=c+g;this.opposite=
h(e.opposite,!(f||!a.inverted));var m=this;f=m.baseSeries;d=a.xAxis.length;b=a.yAxis.length;var l=f&&f[0]&&f[0].xAxis||a.xAxis[0]||{options:{}};a.isDirtyBox=!0;m.navigatorEnabled?(m.xAxis=new k(a,r({breaks:l.options.breaks,ordinal:l.options.ordinal},e.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",isX:!0,type:"datetime",index:d,isInternal:!0,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},a.inverted?{offsets:[g,0,-g,0],width:c}:{offsets:[0,
-g,0,g],height:c})),m.yAxis=new k(a,r(e.yAxis,{id:"navigator-y-axis",alignTicks:!1,offset:0,index:b,isInternal:!0,zoomEnabled:!1},a.inverted?{width:c}:{height:c})),f||e.series.data?m.updateNavigatorSeries(!1):0===a.series.length&&(m.unbindRedraw=H(a,"beforeRedraw",function(){0<a.series.length&&!m.series&&(m.setBaseSeries(),m.unbindRedraw())})),m.reversedExtremes=a.inverted&&!m.xAxis.reversed||!a.inverted&&m.xAxis.reversed,m.renderElements(),m.addMouseEvents()):(m.xAxis={chart:a,navigatorAxis:{fake:!0},
translate:function(b,d){var c=a.xAxis[0],e=c.getExtremes(),f=c.len-2*g,h=u("min",c.options.min,e.dataMin);c=u("max",c.options.max,e.dataMax)-h;return d?b*c/f+h:f*(b-h)/c},toPixels:function(a){return this.translate(a)},toValue:function(a){return this.translate(a,!0)}},m.xAxis.navigatorAxis.axis=m.xAxis,m.xAxis.navigatorAxis.toFixedRange=v.AdditionsClass.prototype.toFixedRange.bind(m.xAxis.navigatorAxis));a.options.scrollbar.enabled&&(a.scrollbar=m.scrollbar=new K(a.renderer,r(a.options.scrollbar,{margin:m.navigatorEnabled?
0:10,vertical:a.inverted}),a),H(m.scrollbar,"changed",function(b){var d=m.size,c=d*this.to;d*=this.from;m.hasDragged=m.scrollbar.hasDragged;m.render(0,0,d,c);(a.options.scrollbar.liveRedraw||"mousemove"!==b.DOMType&&"touchmove"!==b.DOMType)&&setTimeout(function(){m.onMouseUp(b)})}));m.addBaseSeriesEvents();m.addChartEvents()};g.prototype.getUnionExtremes=function(a){var c=this.chart.xAxis[0],e=this.xAxis,f=e.options,d=c.options,b;a&&null===c.dataMin||(b={dataMin:h(f&&f.min,u("min",d.min,c.dataMin,
e.dataMin,e.min)),dataMax:h(f&&f.max,u("max",d.max,c.dataMax,e.dataMax,e.max))});return b};g.prototype.setBaseSeries=function(a,c){var e=this.chart,f=this.baseSeries=[];a=a||e.options&&e.options.navigator.baseSeries||(e.series.length?z(e.series,function(a){return!a.options.isInternal}).index:0);(e.series||[]).forEach(function(d,b){d.options.isInternal||!d.options.showInNavigator&&(b!==a&&d.options.id!==a||!1===d.options.showInNavigator)||f.push(d)});this.xAxis&&!this.xAxis.navigatorAxis.fake&&this.updateNavigatorSeries(!0,
c)};g.prototype.updateNavigatorSeries=function(c,e){var g=this,m=g.chart,d=g.baseSeries,b,p,k=g.navigatorOptions.series,u,w={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:void 0,isInternal:!0,states:{inactive:{opacity:1}}},q=g.series=(g.series||[]).filter(function(a){var b=a.baseSeries;return 0>d.indexOf(b)?(b&&(f(b,"updatedData",g.updatedDataHandler),delete b.navigatorSeries),a.chart&&a.destroy(),
!1):!0});d&&d.length&&d.forEach(function(a){var c=a.navigatorSeries,f=D({color:a.color,visible:a.visible},t(k)?l.navigator.series:k);c&&!1===g.navigatorOptions.adaptToUpdatedData||(w.name="Navigator "+d.length,b=a.options||{},u=b.navigatorOptions||{},p=r(b,w,f,u),p.pointRange=h(f.pointRange,u.pointRange,l.plotOptions[p.type||"line"].pointRange),f=u.data||f.data,g.hasNavigatorData=g.hasNavigatorData||!!f,p.data=f||b.data&&b.data.slice(0),c&&c.options?c.update(p,e):(a.navigatorSeries=m.initSeries(p),
a.navigatorSeries.baseSeries=a,q.push(a.navigatorSeries)))});if(k.data&&(!d||!d.length)||t(k))g.hasNavigatorData=!1,k=a(k),k.forEach(function(a,b){w.name="Navigator "+(q.length+1);p=r(l.navigator.series,{color:m.series[b]&&!m.series[b].options.isInternal&&m.series[b].color||m.options.colors[b]||m.options.colors[0]},w,a);p.data=a.data;p.data&&(g.hasNavigatorData=!0,q.push(m.initSeries(p)))});c&&this.addBaseSeriesEvents()};g.prototype.addBaseSeriesEvents=function(){var a=this,c=a.baseSeries||[];c[0]&&
c[0].xAxis&&H(c[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes);c.forEach(function(c){H(c,"show",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!0,!1)});H(c,"hide",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!1,!1)});!1!==this.navigatorOptions.adaptToUpdatedData&&c.xAxis&&H(c,"updatedData",this.updatedDataHandler);H(c,"remove",function(){this.navigatorSeries&&(E(a.series,this.navigatorSeries),I(this.navigatorSeries.options)&&this.navigatorSeries.remove(!1),
delete this.navigatorSeries)})},this)};g.prototype.getBaseSeriesMin=function(a){return this.baseSeries.reduce(function(a,c){return Math.min(a,c.xData?c.xData[0]:a)},a)};g.prototype.modifyNavigatorAxisExtremes=function(){var a=this.xAxis,c;"undefined"!==typeof a.getExtremes&&(!(c=this.getUnionExtremes(!0))||c.dataMin===a.min&&c.dataMax===a.max||(a.min=c.dataMin,a.max=c.dataMax))};g.prototype.modifyBaseAxisExtremes=function(){var a=this.chart.navigator,c=this.getExtremes(),e=c.dataMin,f=c.dataMax;c=
c.max-c.min;var d=a.stickToMin,b=a.stickToMax,g=h(this.options.overscroll,0),m=a.series&&a.series[0],l=!!this.setExtremes;if(!this.eventArgs||"rangeSelectorButton"!==this.eventArgs.trigger){if(d){var k=e;var u=k+c}b&&(u=f+g,d||(k=Math.max(e,u-c,a.getBaseSeriesMin(m&&m.xData?m.xData[0]:-Number.MAX_VALUE))));l&&(d||b)&&q(k)&&(this.min=this.userMin=k,this.max=this.userMax=u)}a.stickToMin=a.stickToMax=null};g.prototype.updatedDataHandler=function(){var a=this.chart.navigator,c=this.navigatorSeries,e=
a.getBaseSeriesMin(this.xData[0]);a.stickToMax=a.reversedExtremes?0===Math.round(a.zoomedMin):Math.round(a.zoomedMax)>=Math.round(a.size);a.stickToMin=q(this.xAxis.min)&&this.xAxis.min<=e&&(!this.chart.fixedRange||!a.stickToMax);c&&!a.hasNavigatorData&&(c.options.pointStart=this.xData[0],c.setData(this.options.data,!1,null,!1))};g.prototype.addChartEvents=function(){this.eventsToUnbind||(this.eventsToUnbind=[]);this.eventsToUnbind.push(H(this.chart,"redraw",function(){var a=this.navigator,c=a&&(a.baseSeries&&
a.baseSeries[0]&&a.baseSeries[0].xAxis||this.xAxis[0]);c&&a.render(c.min,c.max)}),H(this.chart,"getMargins",function(){var a=this.navigator,c=a.opposite?"plotTop":"marginBottom";this.inverted&&(c=a.opposite?"marginRight":"plotLeft");this[c]=(this[c]||0)+(a.navigatorEnabled||!this.inverted?a.outlineHeight:0)+a.navigatorOptions.margin}))};g.prototype.destroy=function(){this.removeEvents();this.xAxis&&(E(this.chart.xAxis,this.xAxis),E(this.chart.axes,this.xAxis));this.yAxis&&(E(this.chart.yAxis,this.yAxis),
E(this.chart.axes,this.yAxis));(this.series||[]).forEach(function(a){a.destroy&&a.destroy()});"series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" ").forEach(function(a){this[a]&&this[a].destroy&&this[a].destroy();this[a]=null},this);[this.handles].forEach(function(a){J(a)},this)};return g}();A.Navigator||(A.Navigator=F,v.compose(k),H(G,"beforeShowResetZoom",function(){var a=this.options,e=a.navigator,f=a.rangeSelector;if((e&&
e.enabled||f&&f.enabled)&&(!c&&"x"===a.chart.zoomType||c&&"x"===a.chart.pinchType))return!1}),H(G,"beforeRender",function(){var a=this.options;if(a.navigator.enabled||a.scrollbar.enabled)this.scroller=this.navigator=new F(this)}),H(G,"afterSetChartSize",function(){var a=this.legend,c=this.navigator;if(c){var e=a&&a.options;var f=c.xAxis;var g=c.yAxis;var d=c.scrollbarHeight;this.inverted?(c.left=c.opposite?this.chartWidth-d-c.height:this.spacing[3]+d,c.top=this.plotTop+d):(c.left=this.plotLeft+d,
c.top=c.navigatorOptions.top||this.chartHeight-c.height-d-this.spacing[2]-(this.rangeSelector&&this.extraBottomMargin?this.rangeSelector.getHeight():0)-(e&&"bottom"===e.verticalAlign&&e.enabled&&!e.floating?a.legendHeight+h(e.margin,10):0)-(this.titleOffset?this.titleOffset[2]:0));f&&g&&(this.inverted?f.options.left=g.options.left=c.left:f.options.top=g.options.top=c.top,f.setAxisSize(),g.setAxisSize())}}),H(G,"update",function(a){var c=a.options.navigator||{},e=a.options.scrollbar||{};this.navigator||
this.scroller||!c.enabled&&!e.enabled||(r(!0,this.options.navigator,c),r(!0,this.options.scrollbar,e),delete a.options.navigator,delete a.options.scrollbar)}),H(G,"afterUpdate",function(a){this.navigator||this.scroller||!this.options.navigator.enabled&&!this.options.scrollbar.enabled||(this.scroller=this.navigator=new F(this),h(a.redraw,!0)&&this.redraw(a.animation))}),H(G,"afterAddSeries",function(){this.navigator&&this.navigator.setBaseSeries(null,!1)}),H(m,"afterUpdate",function(){this.chart.navigator&&
!this.options.isInternal&&this.chart.navigator.setBaseSeries(null,!1)}),G.prototype.callbacks.push(function(a){var c=a.navigator;c&&a.xAxis[0]&&(a=a.xAxis[0].getExtremes(),c.render(a.min,a.max))}));A.Navigator=F;return A.Navigator});P(A,"parts/OrdinalAxis.js",[A["parts/Axis.js"],A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g,A){var v=A.addEvent,H=A.css,G=A.defined,N=A.pick,M=A.timeUnits;A=g.Chart;var y=g.Series,I=function(){function k(g){this.index={};this.axis=g}k.prototype.getExtendedPositions=
function(){var k=this,v=k.axis,t=v.constructor.prototype,q=v.chart,r=v.series[0].currentDataGrouping,h=k.index,f=r?r.count+r.unitName:"raw",a=v.options.overscroll,l=v.getExtremes(),e;h||(h=k.index={});if(!h[f]){var c={series:[],chart:q,getExtremes:function(){return{min:l.dataMin,max:l.dataMax+a}},options:{ordinal:!0},ordinal:{},ordinal2lin:t.ordinal2lin,val2lin:t.val2lin};c.ordinal.axis=c;v.series.forEach(function(a){e={xAxis:c,xData:a.xData.slice(),chart:q,destroyGroupedData:g.noop,getProcessedData:g.Series.prototype.getProcessedData};
e.xData=e.xData.concat(k.getOverscrollPositions());e.options={dataGrouping:r?{enabled:!0,forced:!0,approximation:"open",units:[[r.unitName,[r.count]]]}:{enabled:!1}};a.processData.apply(e);c.series.push(e)});v.beforeSetTickPositions.apply(c);h[f]=c.ordinal.positions}return h[f]};k.prototype.getGroupIntervalFactor=function(g,k,t){t=t.processedXData;var q=t.length,r=[];var h=this.groupIntervalFactor;if(!h){for(h=0;h<q-1;h++)r[h]=t[h+1]-t[h];r.sort(function(f,a){return f-a});r=r[Math.floor(q/2)];g=Math.max(g,
t[0]);k=Math.min(k,t[q-1]);this.groupIntervalFactor=h=q*r/(k-g)}return h};k.prototype.getOverscrollPositions=function(){var g=this.axis,k=g.options.overscroll,t=this.overscrollPointsRange,q=[],r=g.dataMax;if(G(t))for(q.push(r);r<=g.dataMax+k;)r+=t,q.push(r);return q};k.prototype.postProcessTickInterval=function(g){var k=this.axis,t=this.slope;return t?k.options.breaks?k.closestPointRange||g:g/(t/k.closestPointRange):g};return k}(),J=function(){function g(){}g.compose=function(g,k,t){g.keepProps.push("ordinal");
var q=g.prototype;q.beforeSetTickPositions=function(){var g=this.ordinal,h=[],f,a=!1,l=this.getExtremes(),e=l.min,c=l.max,m,k=this.isXAxis&&!!this.options.breaks;l=this.options.ordinal;var q=Number.MAX_VALUE,t=this.chart.options.chart.ignoreHiddenSeries,w;if(l||k){this.series.forEach(function(a,c){f=[];if(!(t&&!1===a.visible||!1===a.takeOrdinalPosition&&!k)&&(h=h.concat(a.processedXData),p=h.length,h.sort(function(a,b){return a-b}),q=Math.min(q,N(a.closestPointRange,q)),p)){for(c=0;c<p-1;)h[c]!==
h[c+1]&&f.push(h[c+1]),c++;f[0]!==h[0]&&f.unshift(h[0]);h=f}a.isSeriesBoosting&&(w=!0)});w&&(h.length=0);var p=h.length;if(2<p){var C=h[1]-h[0];for(m=p-1;m--&&!a;)h[m+1]-h[m]!==C&&(a=!0);!this.options.keepOrdinalPadding&&(h[0]-e>C||c-h[h.length-1]>C)&&(a=!0)}else this.options.overscroll&&(2===p?q=h[1]-h[0]:1===p?(q=this.options.overscroll,h=[h[0],h[0]+q]):q=g.overscrollPointsRange);a?(this.options.overscroll&&(g.overscrollPointsRange=q,h=h.concat(g.getOverscrollPositions())),g.positions=h,C=this.ordinal2lin(Math.max(e,
h[0]),!0),m=Math.max(this.ordinal2lin(Math.min(c,h[h.length-1]),!0),1),g.slope=c=(c-e)/(m-C),g.offset=e-C*c):(g.overscrollPointsRange=N(this.closestPointRange,g.overscrollPointsRange),g.positions=this.ordinal.slope=g.offset=void 0)}this.isOrdinal=l&&a;g.groupIntervalFactor=null};g.prototype.getTimeTicks=function(g,h,f,a,l,e,c){void 0===l&&(l=[]);void 0===e&&(e=0);var m=0,k,r,q={},w=[],p=-Number.MAX_VALUE,t=this.options.tickPixelInterval,v=this.chart.time,B=[];if(!this.options.ordinal&&!this.options.breaks||
!l||3>l.length||"undefined"===typeof h)return v.getTimeTicks.apply(v,arguments);var d=l.length;for(k=0;k<d;k++){var b=k&&l[k-1]>f;l[k]<h&&(m=k);if(k===d-1||l[k+1]-l[k]>5*e||b){if(l[k]>p){for(r=v.getTimeTicks(g,l[m],l[k],a);r.length&&r[0]<=p;)r.shift();r.length&&(p=r[r.length-1]);B.push(w.length);w=w.concat(r)}m=k+1}if(b)break}r=r.info;if(c&&r.unitRange<=M.hour){k=w.length-1;for(m=1;m<k;m++)if(v.dateFormat("%d",w[m])!==v.dateFormat("%d",w[m-1])){q[w[m]]="day";var n=!0}n&&(q[w[0]]="day");r.higherRanks=
q}r.segmentStarts=B;w.info=r;if(c&&G(t)){m=B=w.length;n=[];var x;for(v=[];m--;)k=this.translate(w[m]),x&&(v[m]=x-k),n[m]=x=k;v.sort();v=v[Math.floor(v.length/2)];v<.6*t&&(v=null);m=w[B-1]>f?B-1:B;for(x=void 0;m--;)k=n[m],B=Math.abs(x-k),x&&B<.8*t&&(null===v||B<.8*v)?(q[w[m]]&&!q[w[m+1]]?(B=m+1,x=k):B=m,w.splice(B,1)):x=k}return w};q.lin2val=function(g,h){var f=this.ordinal,a=f.positions;if(a){var l=f.slope,e=f.offset;f=a.length-1;if(h)if(0>g)g=a[0];else if(g>f)g=a[f];else{f=Math.floor(g);var c=g-
f}else for(;f--;)if(h=l*f+e,g>=h){l=l*(f+1)+e;c=(g-h)/(l-h);break}return"undefined"!==typeof c&&"undefined"!==typeof a[f]?a[f]+(c?c*(a[f+1]-a[f]):0):g}return g};q.val2lin=function(g,h){var f=this.ordinal,a=f.positions;if(a){var l=a.length,e;for(e=l;e--;)if(a[e]===g){var c=e;break}for(e=l-1;e--;)if(g>a[e]||0===e){g=(g-a[e])/(a[e+1]-a[e]);c=e+g;break}h=h?c:f.slope*(c||0)+f.offset}else h=g;return h};q.ordinal2lin=q.val2lin;v(g,"afterInit",function(){this.ordinal||(this.ordinal=new I(this))});v(g,"foundExtremes",
function(){this.isXAxis&&G(this.options.overscroll)&&this.max===this.dataMax&&(!this.chart.mouseIsDown||this.isInternal)&&(!this.eventArgs||this.eventArgs&&"navigator"!==this.eventArgs.trigger)&&(this.max+=this.options.overscroll,!this.isInternal&&G(this.userMin)&&(this.min+=this.options.overscroll))});v(g,"afterSetScale",function(){this.horiz&&!this.isDirty&&(this.isDirty=this.isOrdinal&&this.chart.navigator&&!this.chart.navigator.adaptToUpdatedData)});v(k,"pan",function(g){var h=this.xAxis[0],f=
h.options.overscroll,a=g.originalEvent.chartX,l=this.options.chart&&this.options.chart.panning,e=!1;if(l&&"y"!==l.type&&h.options.ordinal&&h.series.length){var c=this.mouseDownX,m=h.getExtremes(),k=m.dataMax,r=m.min,q=m.max,w=this.hoverPoints,p=h.closestPointRange||h.ordinal&&h.ordinal.overscrollPointsRange;c=(c-a)/(h.translationSlope*(h.ordinal.slope||p));var t={ordinal:{positions:h.ordinal.getExtendedPositions()}};p=h.lin2val;var v=h.val2lin;if(!t.ordinal.positions)e=!0;else if(1<Math.abs(c)){w&&
w.forEach(function(a){a.setState()});if(0>c){w=t;var B=h.ordinal.positions?h:t}else w=h.ordinal.positions?h:t,B=t;t=B.ordinal.positions;k>t[t.length-1]&&t.push(k);this.fixedRange=q-r;c=h.navigatorAxis.toFixedRange(null,null,p.apply(w,[v.apply(w,[r,!0])+c,!0]),p.apply(B,[v.apply(B,[q,!0])+c,!0]));c.min>=Math.min(m.dataMin,r)&&c.max<=Math.max(k,q)+f&&h.setExtremes(c.min,c.max,!0,!1,{trigger:"pan"});this.mouseDownX=a;H(this.container,{cursor:"move"})}}else e=!0;e||l&&/y/.test(l.type)?f&&(h.max=h.dataMax+
f):g.preventDefault()});v(t,"updatedData",function(){var g=this.xAxis;g&&g.options.ordinal&&delete g.ordinal.index})};return g}();J.compose(k,A,y);return J});P(A,"modules/broken-axis.src.js",[A["parts/Axis.js"],A["parts/Globals.js"],A["parts/Utilities.js"],A["parts/Stacking.js"]],function(k,g,A,v){var H=A.addEvent,G=A.find,N=A.fireEvent,M=A.isArray,y=A.isNumber,I=A.pick,J=g.Series,E=function(){function g(g){this.hasBreaks=!1;this.axis=g}g.isInBreak=function(g,k){var q=g.repeat||Infinity,r=g.from,
h=g.to-g.from;k=k>=r?(k-r)%q:q-(r-k)%q;return g.inclusive?k<=h:k<h&&0!==k};g.lin2Val=function(k){var t=this.brokenAxis;t=t&&t.breakArray;if(!t)return k;var q;for(q=0;q<t.length;q++){var r=t[q];if(r.from>=k)break;else r.to<k?k+=r.len:g.isInBreak(r,k)&&(k+=r.len)}return k};g.val2Lin=function(k){var t=this.brokenAxis;t=t&&t.breakArray;if(!t)return k;var q=k,r;for(r=0;r<t.length;r++){var h=t[r];if(h.to<=k)q-=h.len;else if(h.from>=k)break;else if(g.isInBreak(h,k)){q-=k-h.from;break}}return q};g.prototype.findBreakAt=
function(g,k){return G(k,function(k){return k.from<g&&g<k.to})};g.prototype.isInAnyBreak=function(k,t){var q=this.axis,r=q.options.breaks,h=r&&r.length,f;if(h){for(;h--;)if(g.isInBreak(r[h],k)){var a=!0;f||(f=I(r[h].showPoints,!q.isXAxis))}var l=a&&t?a&&!f:a}return l};g.prototype.setBreaks=function(v,t){var q=this,r=q.axis,h=M(v)&&!!v.length;r.isDirty=q.hasBreaks!==h;q.hasBreaks=h;r.options.breaks=r.userOptions.breaks=v;r.forceRedraw=!0;r.series.forEach(function(f){f.isDirty=!0});h||r.val2lin!==g.val2Lin||
(delete r.val2lin,delete r.lin2val);h&&(r.userOptions.ordinal=!1,r.lin2val=g.lin2Val,r.val2lin=g.val2Lin,r.setExtremes=function(f,a,h,e,c){if(q.hasBreaks){for(var g,l=this.options.breaks;g=q.findBreakAt(f,l);)f=g.to;for(;g=q.findBreakAt(a,l);)a=g.from;a<f&&(a=f)}k.prototype.setExtremes.call(this,f,a,h,e,c)},r.setAxisTranslation=function(f){k.prototype.setAxisTranslation.call(this,f);q.unitLength=null;if(q.hasBreaks){f=r.options.breaks||[];var a=[],h=[],e=0,c,m=r.userMin||r.min,u=r.userMax||r.max,
t=I(r.pointRangePadding,0),v;f.forEach(function(a){c=a.repeat||Infinity;g.isInBreak(a,m)&&(m+=a.to%c-m%c);g.isInBreak(a,u)&&(u-=u%c-a.from%c)});f.forEach(function(e){p=e.from;for(c=e.repeat||Infinity;p-c>m;)p-=c;for(;p<m;)p+=c;for(v=p;v<u;v+=c)a.push({value:v,move:"in"}),a.push({value:v+(e.to-e.from),move:"out",size:e.breakSize})});a.sort(function(a,c){return a.value===c.value?("in"===a.move?0:1)-("in"===c.move?0:1):a.value-c.value});var w=0;var p=m;a.forEach(function(a){w+="in"===a.move?1:-1;1===
w&&"in"===a.move&&(p=a.value);0===w&&(h.push({from:p,to:a.value,len:a.value-p-(a.size||0)}),e+=a.value-p-(a.size||0))});r.breakArray=q.breakArray=h;q.unitLength=u-m-e+t;N(r,"afterBreaks");r.staticScale?r.transA=r.staticScale:q.unitLength&&(r.transA*=(u-r.min+t)/q.unitLength);t&&(r.minPixelPadding=r.transA*r.minPointOffset);r.min=m;r.max=u}});I(t,!0)&&r.chart.redraw()};return g}();g=function(){function g(){}g.compose=function(g,k){g.keepProps.push("brokenAxis");var q=J.prototype;q.drawBreaks=function(g,
h){var f=this,a=f.points,k,e,c,m;if(g&&g.brokenAxis&&g.brokenAxis.hasBreaks){var u=g.brokenAxis;h.forEach(function(h){k=u&&u.breakArray||[];e=g.isXAxis?g.min:I(f.options.threshold,g.min);a.forEach(function(a){m=I(a["stack"+h.toUpperCase()],a[h]);k.forEach(function(f){if(y(e)&&y(m)){c=!1;if(e<f.from&&m>f.to||e>f.from&&m<f.from)c="pointBreak";else if(e<f.from&&m>f.from&&m<f.to||e>f.from&&m>f.to&&m<f.from)c="pointInBreak";c&&N(g,c,{point:a,brk:f})}})})})}};q.gappedPath=function(){var g=this.currentDataGrouping,
h=g&&g.gapSize;g=this.options.gapSize;var f=this.points.slice(),a=f.length-1,k=this.yAxis,e;if(g&&0<a)for("value"!==this.options.gapUnit&&(g*=this.basePointRange),h&&h>g&&h>=this.basePointRange&&(g=h),e=void 0;a--;)e&&!1!==e.visible||(e=f[a+1]),h=f[a],!1!==e.visible&&!1!==h.visible&&(e.x-h.x>g&&(e=(h.x+e.x)/2,f.splice(a+1,0,{isNull:!0,x:e}),k.stacking&&this.options.stacking&&(e=k.stacking.stacks[this.stackKey][e]=new v(k,k.options.stackLabels,!1,e,this.stack),e.total=0)),e=h);return this.getGraphPath(f)};
H(g,"init",function(){this.brokenAxis||(this.brokenAxis=new E(this))});H(g,"afterInit",function(){"undefined"!==typeof this.brokenAxis&&this.brokenAxis.setBreaks(this.options.breaks,!1)});H(g,"afterSetTickPositions",function(){var g=this.brokenAxis;if(g&&g.hasBreaks){var h=this.tickPositions,f=this.tickPositions.info,a=[],k;for(k=0;k<h.length;k++)g.isInAnyBreak(h[k])||a.push(h[k]);this.tickPositions=a;this.tickPositions.info=f}});H(g,"afterSetOptions",function(){this.brokenAxis&&this.brokenAxis.hasBreaks&&
(this.options.ordinal=!1)});H(k,"afterGeneratePoints",function(){var g=this.options.connectNulls,h=this.points,f=this.xAxis,a=this.yAxis;if(this.isDirty)for(var k=h.length;k--;){var e=h[k],c=!(null===e.y&&!1===g)&&(f&&f.brokenAxis&&f.brokenAxis.isInAnyBreak(e.x,!0)||a&&a.brokenAxis&&a.brokenAxis.isInAnyBreak(e.y,!0));e.visible=c?!1:!1!==e.options.visible}});H(k,"afterRender",function(){this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,I(this.pointArrayMap,["y"]))})};return g}();g.compose(k,
J);return g});P(A,"masters/modules/broken-axis.src.js",[],function(){});P(A,"parts/DataGrouping.js",[A["parts/DateTimeAxis.js"],A["parts/Globals.js"],A["parts/Point.js"],A["parts/Tooltip.js"],A["parts/Utilities.js"]],function(k,g,A,v,K){"";var G=K.addEvent,H=K.arrayMax,M=K.arrayMin,y=K.correctFloat,I=K.defined,J=K.error,E=K.extend,D=K.format,z=K.isNumber,t=K.merge,q=K.pick,r=g.Axis,h=g.defaultPlotOptions;K=g.Series;var f=g.approximations={sum:function(a){var c=a.length;if(!c&&a.hasNulls)var e=null;
else if(c)for(e=0;c--;)e+=a[c];return e},average:function(a){var c=a.length;a=f.sum(a);z(a)&&c&&(a=y(a/c));return a},averages:function(){var a=[];[].forEach.call(arguments,function(c){a.push(f.average(c))});return"undefined"===typeof a[0]?void 0:a},open:function(a){return a.length?a[0]:a.hasNulls?null:void 0},high:function(a){return a.length?H(a):a.hasNulls?null:void 0},low:function(a){return a.length?M(a):a.hasNulls?null:void 0},close:function(a){return a.length?a[a.length-1]:a.hasNulls?null:void 0},
ohlc:function(a,c,e,g){a=f.open(a);c=f.high(c);e=f.low(e);g=f.close(g);if(z(a)||z(c)||z(e)||z(g))return[a,c,e,g]},range:function(a,c){a=f.low(a);c=f.high(c);if(z(a)||z(c))return[a,c];if(null===a&&null===c)return null}},a=function(a,c,e,g){var h=this,d=h.data,b=h.options&&h.options.data,m=[],k=[],l=[],p=a.length,u=!!c,r=[],q=h.pointArrayMap,w=q&&q.length,v=["x"].concat(q||["y"]),C=0,F=0,y;g="function"===typeof g?g:f[g]?f[g]:f[h.getDGApproximation&&h.getDGApproximation()||"average"];w?q.forEach(function(){r.push([])}):
r.push([]);var A=w||1;for(y=0;y<=p&&!(a[y]>=e[0]);y++);for(y;y<=p;y++){for(;"undefined"!==typeof e[C+1]&&a[y]>=e[C+1]||y===p;){var D=e[C];h.dataGroupInfo={start:h.cropStart+F,length:r[0].length};var G=g.apply(h,r);h.pointClass&&!I(h.dataGroupInfo.options)&&(h.dataGroupInfo.options=t(h.pointClass.prototype.optionsToObject.call({series:h},h.options.data[h.cropStart+F])),v.forEach(function(a){delete h.dataGroupInfo.options[a]}));"undefined"!==typeof G&&(m.push(D),k.push(G),l.push(h.dataGroupInfo));F=
y;for(D=0;D<A;D++)r[D].length=0,r[D].hasNulls=!1;C+=1;if(y===p)break}if(y===p)break;if(q)for(D=h.cropStart+y,G=d&&d[D]||h.pointClass.prototype.applyOptions.apply({series:h},[b[D]]),D=0;D<w;D++){var L=G[q[D]];z(L)?r[D].push(L):null===L&&(r[D].hasNulls=!0)}else D=u?c[y]:null,z(D)?r[0].push(D):null===D&&(r[0].hasNulls=!0)}return{groupedXData:m,groupedYData:k,groupMap:l}},l={approximations:f,groupData:a},e=K.prototype,c=e.processData,m=e.generatePoints,u={groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %b %e, %H:%M:%S.%L",
"%A, %b %e, %H:%M:%S.%L","-%H:%M:%S.%L"],second:["%A, %b %e, %H:%M:%S","%A, %b %e, %H:%M:%S","-%H:%M:%S"],minute:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],hour:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],day:["%A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],week:["Week from %A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],month:["%B %Y","%B","-%B %Y"],year:["%Y","%Y","-%Y"]}},L={line:{},spline:{},area:{},areaspline:{},arearange:{},column:{groupPixelWidth:10},columnrange:{groupPixelWidth:10},
candlestick:{groupPixelWidth:10},ohlc:{groupPixelWidth:5}},F=g.defaultDataGroupingUnits=[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1]],["week",[1]],["month",[1,3,6]],["year",null]];e.getDGApproximation=function(){return this.is("arearange")?"range":this.is("ohlc")?"ohlc":this.is("column")?"sum":"average"};e.groupData=a;e.processData=function(){var a=this.chart,f=this.options.dataGrouping,h=!1!==this.allowDG&&
f&&q(f.enabled,a.options.isStock),g=this.visible||!a.options.chart.ignoreHiddenSeries,m,d=this.currentDataGrouping,b=!1;this.forceCrop=h;this.groupPixelWidth=null;this.hasProcessed=!0;h&&!this.requireSorting&&(this.requireSorting=b=!0);h=!1===c.apply(this,arguments)||!h;b&&(this.requireSorting=!1);if(!h){this.destroyGroupedData();h=f.groupAll?this.xData:this.processedXData;var l=f.groupAll?this.yData:this.processedYData,u=a.plotSizeX;a=this.xAxis;var r=a.options.ordinal,t=this.groupPixelWidth=a.getGroupPixelWidth&&
a.getGroupPixelWidth();if(t){this.isDirty=m=!0;this.points=null;b=a.getExtremes();var v=b.min;b=b.max;r=r&&a.ordinal&&a.ordinal.getGroupIntervalFactor(v,b,this)||1;t=t*(b-v)/u*r;u=a.getTimeTicks(k.AdditionsClass.prototype.normalizeTimeTickInterval(t,f.units||F),Math.min(v,h[0]),Math.max(b,h[h.length-1]),a.options.startOfWeek,h,this.closestPointRange);l=e.groupData.apply(this,[h,l,u,f.approximation]);h=l.groupedXData;r=l.groupedYData;var y=0;if(f.smoothed&&h.length){var z=h.length-1;for(h[z]=Math.min(h[z],
b);z--&&0<z;)h[z]+=t/2;h[0]=Math.max(h[0],v)}for(z=1;z<u.length;z++)u.info.segmentStarts&&-1!==u.info.segmentStarts.indexOf(z)||(y=Math.max(u[z]-u[z-1],y));v=u.info;v.gapSize=y;this.closestPointRange=u.info.totalRange;this.groupMap=l.groupMap;if(I(h[0])&&h[0]<a.min&&g){if(!I(a.options.min)&&a.min<=a.dataMin||a.min===a.dataMin)a.min=Math.min(h[0],a.min);a.dataMin=Math.min(h[0],a.dataMin)}f.groupAll&&(f=this.cropData(h,r,a.min,a.max,1),h=f.xData,r=f.yData);this.processedXData=h;this.processedYData=
r}else this.groupMap=null;this.hasGroupedData=m;this.currentDataGrouping=v;this.preventGraphAnimation=(d&&d.totalRange)!==(v&&v.totalRange)}};e.destroyGroupedData=function(){this.groupedData&&(this.groupedData.forEach(function(a,c){a&&(this.groupedData[c]=a.destroy?a.destroy():null)},this),this.groupedData.length=0)};e.generatePoints=function(){m.apply(this);this.destroyGroupedData();this.groupedData=this.hasGroupedData?this.points:null};G(A,"update",function(){if(this.dataGroup)return J(24,!1,this.series.chart),
!1});G(v,"headerFormatter",function(a){var c=this.chart,e=c.time,f=a.labelConfig,h=f.series,d=h.tooltipOptions,b=h.options.dataGrouping,g=d.xDateFormat,m=h.xAxis,k=d[(a.isFooter?"footer":"header")+"Format"];if(m&&"datetime"===m.options.type&&b&&z(f.key)){var l=h.currentDataGrouping;b=b.dateTimeLabelFormats||u.dateTimeLabelFormats;if(l)if(d=b[l.unitName],1===l.count)g=d[0];else{g=d[1];var r=d[2]}else!g&&b&&(g=this.getXDateFormat(f,d,m));g=e.dateFormat(g,f.key);r&&(g+=e.dateFormat(r,f.key+l.totalRange-
1));h.chart.styledMode&&(k=this.styledModeFormat(k));a.text=D(k,{point:E(f.point,{key:g}),series:h},c);a.preventDefault()}});G(K,"destroy",e.destroyGroupedData);G(K,"afterSetOptions",function(a){a=a.options;var c=this.type,e=this.chart.options.plotOptions,f=h[c].dataGrouping,g=this.useCommonDataGrouping&&u;if(L[c]||g)f||(f=t(u,L[c])),a.dataGrouping=t(g,f,e.series&&e.series.dataGrouping,e[c].dataGrouping,this.userOptions.dataGrouping)});G(r,"afterSetScale",function(){this.series.forEach(function(a){a.hasProcessed=
!1})});r.prototype.getGroupPixelWidth=function(){var a=this.series,c=a.length,e,f=0,h=!1,d;for(e=c;e--;)(d=a[e].options.dataGrouping)&&(f=Math.max(f,q(d.groupPixelWidth,u.groupPixelWidth)));for(e=c;e--;)(d=a[e].options.dataGrouping)&&a[e].hasProcessed&&(c=(a[e].processedXData||a[e].data).length,a[e].groupPixelWidth||c>this.chart.plotSizeX/f||c&&d.forced)&&(h=!0);return h?f:0};r.prototype.setDataGrouping=function(a,c){var e;c=q(c,!0);a||(a={forced:!1,units:null});if(this instanceof r)for(e=this.series.length;e--;)this.series[e].update({dataGrouping:a},
!1);else this.chart.options.series.forEach(function(c){c.dataGrouping=a},!1);this.ordinal&&(this.ordinal.slope=void 0);c&&this.chart.redraw()};g.dataGrouping=l;"";return l});P(A,"parts/OHLCSeries.js",[A["parts/Globals.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(k,g,A){A=A.seriesType;var v=k.seriesTypes;A("ohlc","column",{lineWidth:1,tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'},
threshold:null,states:{hover:{lineWidth:3}},stickyTracking:!0},{directTouch:!1,pointArrayMap:["open","high","low","close"],toYData:function(g){return[g.open,g.high,g.low,g.close]},pointValKey:"close",pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},init:function(){v.column.prototype.init.apply(this,arguments);this.options.stacking=void 0},pointAttribs:function(g,k){k=v.column.prototype.pointAttribs.call(this,g,k);var A=this.options;delete k.fill;!g.options.color&&A.upColor&&g.open<g.close&&
(k.stroke=A.upColor);return k},translate:function(){var g=this,k=g.yAxis,A=!!g.modifyValue,H=["plotOpen","plotHigh","plotLow","plotClose","yBottom"];v.column.prototype.translate.apply(g);g.points.forEach(function(v){[v.open,v.high,v.low,v.close,v.low].forEach(function(y,G){null!==y&&(A&&(y=g.modifyValue(y)),v[H[G]]=k.toPixels(y,!0))});v.tooltipPos[1]=v.plotHigh+k.pos-g.chart.plotTop})},drawPoints:function(){var g=this,k=g.chart,v=function(g,k,v){var y=g[0];g=g[1];"number"===typeof y[2]&&(y[2]=Math.max(v+
k,y[2]));"number"===typeof g[2]&&(g[2]=Math.min(v-k,g[2]))};g.points.forEach(function(A){var y=A.graphic,G=!y;if("undefined"!==typeof A.plotY){y||(A.graphic=y=k.renderer.path().add(g.group));k.styledMode||y.attr(g.pointAttribs(A,A.selected&&"select"));var H=y.strokeWidth();var E=H%2/2;var D=Math.round(A.plotX)-E;var z=Math.round(A.shapeArgs.width/2);var t=[["M",D,Math.round(A.yBottom)],["L",D,Math.round(A.plotHigh)]];if(null!==A.open){var q=Math.round(A.plotOpen)+E;t.push(["M",D,q],["L",D-z,q]);v(t,
H/2,q)}null!==A.close&&(q=Math.round(A.plotClose)+E,t.push(["M",D,q],["L",D+z,q]),v(t,H/2,q));y[G?"attr":"animate"]({d:t}).addClass(A.getClassName(),!0)}})},animate:null},{getClassName:function(){return g.prototype.getClassName.call(this)+(this.open<this.close?" highcharts-point-up":" highcharts-point-down")}});""});P(A,"parts/CandlestickSeries.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var A=g.merge;g=g.seriesType;var v=k.defaultPlotOptions,K=k.seriesTypes;g("candlestick",
"ohlc",A(v.column,{states:{hover:{lineWidth:2}},tooltip:v.ohlc.tooltip,threshold:null,lineColor:"#000000",lineWidth:1,upColor:"#ffffff",stickyTracking:!0}),{pointAttribs:function(g,k){var v=K.column.prototype.pointAttribs.call(this,g,k),y=this.options,A=g.open<g.close,G=y.lineColor||this.color;v["stroke-width"]=y.lineWidth;v.fill=g.options.color||(A?y.upColor||this.color:this.color);v.stroke=g.options.lineColor||(A?y.upLineColor||G:G);k&&(g=y.states[k],v.fill=g.color||v.fill,v.stroke=g.lineColor||
v.stroke,v["stroke-width"]=g.lineWidth||v["stroke-width"]);return v},drawPoints:function(){var g=this,k=g.chart,v=g.yAxis.reversed;g.points.forEach(function(y){var A=y.graphic,G=!A;if("undefined"!==typeof y.plotY){A||(y.graphic=A=k.renderer.path().add(g.group));g.chart.styledMode||A.attr(g.pointAttribs(y,y.selected&&"select")).shadow(g.options.shadow);var E=A.strokeWidth()%2/2;var D=Math.round(y.plotX)-E;var z=y.plotOpen;var t=y.plotClose;var q=Math.min(z,t);z=Math.max(z,t);var r=Math.round(y.shapeArgs.width/
2);t=v?z!==y.yBottom:Math.round(q)!==Math.round(y.plotHigh);var h=v?Math.round(q)!==Math.round(y.plotHigh):z!==y.yBottom;q=Math.round(q)+E;z=Math.round(z)+E;E=[];E.push(["M",D-r,z],["L",D-r,q],["L",D+r,q],["L",D+r,z],["Z"],["M",D,q],["L",D,t?Math.round(v?y.yBottom:y.plotHigh):q],["M",D,z],["L",D,h?Math.round(v?y.plotHigh:y.yBottom):z]);A[G?"attr":"animate"]({d:E}).addClass(y.getClassName(),!0)}})}});""});P(A,"mixins/on-series.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){var A=
g.defined,v=g.stableSort,K=k.seriesTypes;return{getPlotBox:function(){return k.Series.prototype.getPlotBox.call(this.options.onSeries&&this.chart.get(this.options.onSeries)||this)},translate:function(){K.column.prototype.translate.apply(this);var g=this,k=g.options,H=g.chart,y=g.points,I=y.length-1,J,E=k.onSeries;E=E&&H.get(E);k=k.onKey||"y";var D=E&&E.options.step,z=E&&E.points,t=z&&z.length,q=H.inverted,r=g.xAxis,h=g.yAxis,f=0,a;if(E&&E.visible&&t){f=(E.pointXOffset||0)+(E.barW||0)/2;H=E.currentDataGrouping;
var l=z[t-1].x+(H?H.totalRange:0);v(y,function(a,c){return a.x-c.x});for(k="plot"+k[0].toUpperCase()+k.substr(1);t--&&y[I];){var e=z[t];H=y[I];H.y=e.y;if(e.x<=H.x&&"undefined"!==typeof e[k]){if(H.x<=l&&(H.plotY=e[k],e.x<H.x&&!D&&(a=z[t+1])&&"undefined"!==typeof a[k])){var c=(H.x-e.x)/(a.x-e.x);H.plotY+=c*(a[k]-e[k]);H.y+=c*(a.y-e.y)}I--;t++;if(0>I)break}}}y.forEach(function(a,c){a.plotX+=f;if("undefined"===typeof a.plotY||q)0<=a.plotX&&a.plotX<=r.len?q?(a.plotY=r.translate(a.x,0,1,0,1),a.plotX=A(a.y)?
h.translate(a.y,0,0,0,1):0):a.plotY=(r.opposite?0:g.yAxis.len)+r.offset:a.shapeArgs={};if((J=y[c-1])&&J.plotX===a.plotX){"undefined"===typeof J.stackIndex&&(J.stackIndex=0);var e=J.stackIndex+1}a.stackIndex=e});this.onSeries=E}}});P(A,"parts/FlagsSeries.js",[A["parts/Globals.js"],A["parts/Utilities.js"],A["mixins/on-series.js"]],function(k,g,A){function v(g){q[g+"pin"]=function(h,f,a,k,e){var c=e&&e.anchorX;e=e&&e.anchorY;"circle"===g&&k>a&&(h-=Math.round((k-a)/2),a=k);var m=q[g](h,f,a,k);if(c&&e){var l=
c;"circle"===g?l=h+a/2:(h=m[0],a=m[1],"M"===h[0]&&"L"===a[0]&&(l=(h[1]+a[1])/2));m.push(["M",l,f>e?f:f+k],["L",c,e]);m=m.concat(q.circle(c-1,e-1,2,2))}return m}}var H=g.addEvent,G=g.defined,N=g.isNumber,M=g.merge,y=g.objectEach,I=g.seriesType,J=g.wrap;g=k.noop;var E=k.Renderer,D=k.Series,z=k.TrackerMixin,t=k.VMLRenderer,q=k.SVGRenderer.prototype.symbols;I("flags","column",{pointRange:0,allowOverlapX:!1,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}<br/>"},threshold:null,
y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd6eb"}},style:{fontSize:"11px",fontWeight:"bold"}},{sorted:!1,noSharedTooltip:!0,allowDG:!1,takeOrdinalPosition:!1,trackerGroups:["markerGroup"],forceCrop:!0,init:D.prototype.init,pointAttribs:function(g,h){var f=this.options,a=g&&g.color||this.color,k=f.lineColor,e=g&&g.lineWidth;g=g&&g.fillColor||f.fillColor;h&&(g=f.states[h].fillColor,k=f.states[h].lineColor,e=f.states[h].lineWidth);return{fill:g||a,stroke:k||
a,"stroke-width":e||f.lineWidth||0}},translate:A.translate,getPlotBox:A.getPlotBox,drawPoints:function(){var g=this.points,h=this.chart,f=h.renderer,a=h.inverted,l=this.options,e=l.y,c,m=this.yAxis,u={},q=[];for(c=g.length;c--;){var t=g[c];var w=(a?t.plotY:t.plotX)>this.xAxis.len;var p=t.plotX;var v=t.stackIndex;var z=t.options.shape||l.shape;var B=t.plotY;"undefined"!==typeof B&&(B=t.plotY+e-("undefined"!==typeof v&&v*l.stackDistance));t.anchorX=v?void 0:t.plotX;var d=v?void 0:t.plotY;var b="flag"!==
z;v=t.graphic;"undefined"!==typeof B&&0<=p&&!w?(v||(v=t.graphic=f.label("",null,null,z,null,null,l.useHTML),h.styledMode||v.attr(this.pointAttribs(t)).css(M(l.style,t.style)),v.attr({align:b?"center":"left",width:l.width,height:l.height,"text-align":l.textAlign}).addClass("highcharts-point").add(this.markerGroup),t.graphic.div&&(t.graphic.div.point=t),h.styledMode||v.shadow(l.shadow),v.isNew=!0),0<p&&(p-=v.strokeWidth()%2),z={y:B,anchorY:d},l.allowOverlapX&&(z.x=p,z.anchorX=t.anchorX),v.attr({text:t.options.title||
l.title||"A"})[v.isNew?"attr":"animate"](z),l.allowOverlapX||(u[t.plotX]?u[t.plotX].size=Math.max(u[t.plotX].size,v.width):u[t.plotX]={align:b?.5:0,size:v.width,target:p,anchorX:p}),t.tooltipPos=[p,B+m.pos-h.plotTop]):v&&(t.graphic=v.destroy())}l.allowOverlapX||(y(u,function(a){a.plotX=a.anchorX;q.push(a)}),k.distribute(q,a?m.len:this.xAxis.len,100),g.forEach(function(a){var b=a.graphic&&u[a.plotX];b&&(a.graphic[a.graphic.isNew?"attr":"animate"]({x:b.pos+b.align*b.size,anchorX:a.anchorX}),G(b.pos)?
a.graphic.isNew=!1:(a.graphic.attr({x:-9999,anchorX:-9999}),a.graphic.isNew=!0))}));l.useHTML&&J(this.markerGroup,"on",function(a){return k.SVGElement.prototype.on.apply(a.apply(this,[].slice.call(arguments,1)),[].slice.call(arguments,1))})},drawTracker:function(){var g=this.points;z.drawTrackerPoint.apply(this);g.forEach(function(h){var f=h.graphic;f&&H(f.element,"mouseover",function(){0<h.stackIndex&&!h.raised&&(h._y=f.y,f.attr({y:h._y-8}),h.raised=!0);g.forEach(function(a){a!==h&&a.raised&&a.graphic&&
(a.graphic.attr({y:a._y}),a.raised=!1)})})})},animate:function(g){g&&this.setClip()},setClip:function(){D.prototype.setClip.apply(this,arguments);!1!==this.options.clip&&this.sharedClipKey&&this.markerGroup.clip(this.chart[this.sharedClipKey])},buildKDTree:g,invertGroups:g},{isValid:function(){return N(this.y)||"undefined"===typeof this.y}});q.flag=function(g,h,f,a,k){var e=k&&k.anchorX||g;k=k&&k.anchorY||h;var c=q.circle(e-1,k-1,2,2);c.push(["M",e,k],["L",g,h+a],["L",g,h],["L",g+f,h],["L",g+f,h+
a],["L",g,h+a],["Z"]);return c};v("circle");v("square");E===t&&["circlepin","flag","squarepin"].forEach(function(g){t.prototype.symbols[g]=q[g]});""});P(A,"parts/RangeSelector.js",[A["parts/Globals.js"],A["parts/Utilities.js"]],function(k,g){function A(a){this.init(a)}var v=g.addEvent,K=g.createElement,G=g.css,N=g.defined,M=g.destroyObjectProperties,y=g.discardElement,I=g.extend,J=g.fireEvent,E=g.isNumber,D=g.merge,z=g.objectEach,t=g.pick,q=g.pInt,r=g.splat,h=k.Axis;g=k.Chart;var f=k.defaultOptions;
I(f,{rangeSelector:{verticalAlign:"top",buttonTheme:{width:28,height:18,padding:2,zIndex:7},floating:!1,x:0,y:0,height:void 0,inputPosition:{align:"right",x:0,y:0},buttonPosition:{align:"left",x:0,y:0},labelStyle:{color:"#666666"}}});f.lang=D(f.lang,{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"From",rangeSelectorTo:"To"});A.prototype={clickButton:function(a,f){var e=this.chart,c=this.buttonOptions[a],g=e.xAxis[0],k=e.scroller&&e.scroller.getUnionExtremes()||g||{},l=k.dataMin,q=k.dataMax,w=g&&Math.round(Math.min(g.max,
t(q,g.max))),p=c.type;k=c._range;var C,y=c.dataGrouping;if(null!==l&&null!==q){e.fixedRange=k;y&&(this.forcedDataGrouping=!0,h.prototype.setDataGrouping.call(g||{chart:this.chart},y,!1),this.frozenStates=c.preserveDataGrouping);if("month"===p||"year"===p)if(g){p={range:c,max:w,chart:e,dataMin:l,dataMax:q};var B=g.minFromRange.call(p);E(p.newMax)&&(w=p.newMax)}else k=c;else if(k)B=Math.max(w-k,l),w=Math.min(B+k,q);else if("ytd"===p)if(g)"undefined"===typeof q&&(l=Number.MAX_VALUE,q=Number.MIN_VALUE,
e.series.forEach(function(a){a=a.xData;l=Math.min(a[0],l);q=Math.max(a[a.length-1],q)}),f=!1),w=this.getYTDExtremes(q,l,e.time.useUTC),B=C=w.min,w=w.max;else{this.deferredYTDClick=a;return}else"all"===p&&g&&(B=l,w=q);B+=c._offsetMin;w+=c._offsetMax;this.setSelected(a);if(g)g.setExtremes(B,w,t(f,1),null,{trigger:"rangeSelectorButton",rangeSelectorButton:c});else{var d=r(e.options.xAxis)[0];var b=d.range;d.range=k;var n=d.min;d.min=C;v(e,"load",function(){d.range=b;d.min=n})}}},setSelected:function(a){this.selected=
this.options.selected=a},defaultButtons:[{type:"month",count:1,text:"1m"},{type:"month",count:3,text:"3m"},{type:"month",count:6,text:"6m"},{type:"ytd",text:"YTD"},{type:"year",count:1,text:"1y"},{type:"all",text:"All"}],init:function(a){var f=this,e=a.options.rangeSelector,c=e.buttons||[].concat(f.defaultButtons),g=e.selected,h=function(){var a=f.minInput,c=f.maxInput;a&&a.blur&&J(a,"blur");c&&c.blur&&J(c,"blur")};f.chart=a;f.options=e;f.buttons=[];f.buttonOptions=c;this.unMouseDown=v(a.container,
"mousedown",h);this.unResize=v(a,"resize",h);c.forEach(f.computeButtonRange);"undefined"!==typeof g&&c[g]&&this.clickButton(g,!1);v(a,"load",function(){a.xAxis&&a.xAxis[0]&&v(a.xAxis[0],"setExtremes",function(c){this.max-this.min!==a.fixedRange&&"rangeSelectorButton"!==c.trigger&&"updatedData"!==c.trigger&&f.forcedDataGrouping&&!f.frozenStates&&this.setDataGrouping(!1,!1)})})},updateButtonStates:function(){var a=this,f=this.chart,e=f.xAxis[0],c=Math.round(e.max-e.min),g=!e.hasVisibleSeries,h=f.scroller&&
f.scroller.getUnionExtremes()||e,k=h.dataMin,q=h.dataMax;f=a.getYTDExtremes(q,k,f.time.useUTC);var r=f.min,p=f.max,t=a.selected,v=E(t),B=a.options.allButtonsEnabled,d=a.buttons;a.buttonOptions.forEach(function(b,f){var h=b._range,m=b.type,l=b.count||1,n=d[f],u=0,w=b._offsetMax-b._offsetMin;b=f===t;var C=h>q-k,y=h<e.minRange,z=!1,A=!1;h=h===c;("month"===m||"year"===m)&&c+36E5>=864E5*{month:28,year:365}[m]*l-w&&c-36E5<=864E5*{month:31,year:366}[m]*l+w?h=!0:"ytd"===m?(h=p-r+w===c,z=!b):"all"===m&&(h=
e.max-e.min>=q-k,A=!b&&v&&h);m=!B&&(C||y||A||g);l=b&&h||h&&!v&&!z||b&&a.frozenStates;m?u=3:l&&(v=!0,u=2);n.state!==u&&(n.setState(u),0===u&&t===f&&a.setSelected(null))})},computeButtonRange:function(a){var f=a.type,e=a.count||1,c={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5};if(c[f])a._range=c[f]*e;else if("month"===f||"year"===f)a._range=864E5*{month:30,year:365}[f]*e;a._offsetMin=t(a.offsetMin,0);a._offsetMax=t(a.offsetMax,0);a._range+=a._offsetMax-a._offsetMin},setInputValue:function(a,
f){var e=this.chart.options.rangeSelector,c=this.chart.time,g=this[a+"Input"];N(f)&&(g.previousValue=g.HCTime,g.HCTime=f);g.value=c.dateFormat(e.inputEditDateFormat||"%Y-%m-%d",g.HCTime);this[a+"DateBox"].attr({text:c.dateFormat(e.inputDateFormat||"%b %e, %Y",g.HCTime)})},showInput:function(a){var f=this.inputGroup,e=this[a+"DateBox"];G(this[a+"Input"],{left:f.translateX+e.x+"px",top:f.translateY+"px",width:e.width-2+"px",height:e.height-2+"px",border:"2px solid silver"})},hideInput:function(a){G(this[a+
"Input"],{border:0,width:"1px",height:"1px"});this.setInputValue(a)},drawInput:function(a){function g(){var a=p.value,d=(r.inputDateParser||Date.parse)(a),b=c.xAxis[0],f=c.scroller&&c.scroller.xAxis?c.scroller.xAxis:b,g=f.dataMin;f=f.dataMax;d!==p.previousValue&&(p.previousValue=d,E(d)||(d=a.split("-"),d=Date.UTC(q(d[0]),q(d[1])-1,q(d[2]))),E(d)&&(c.time.useUTC||(d+=6E4*(new Date).getTimezoneOffset()),w?d>e.maxInput.HCTime?d=void 0:d<g&&(d=g):d<e.minInput.HCTime?d=void 0:d>f&&(d=f),"undefined"!==
typeof d&&b.setExtremes(w?d:b.min,w?b.max:d,void 0,void 0,{trigger:"rangeSelectorInput"})))}var e=this,c=e.chart,h=c.renderer.style||{},u=c.renderer,r=c.options.rangeSelector,t=e.div,w="min"===a,p,v,y=this.inputGroup;this[a+"Label"]=v=u.label(f.lang[w?"rangeSelectorFrom":"rangeSelectorTo"],this.inputGroup.offset).addClass("highcharts-range-label").attr({padding:2}).add(y);y.offset+=v.width+5;this[a+"DateBox"]=u=u.label("",y.offset).addClass("highcharts-range-input").attr({padding:2,width:r.inputBoxWidth||
90,height:r.inputBoxHeight||17,"text-align":"center"}).on("click",function(){e.showInput(a);e[a+"Input"].focus()});c.styledMode||u.attr({stroke:r.inputBoxBorderColor||"#cccccc","stroke-width":1});u.add(y);y.offset+=u.width+(w?10:0);this[a+"Input"]=p=K("input",{name:a,className:"highcharts-range-selector",type:"text"},{top:c.plotTop+"px"},t);c.styledMode||(v.css(D(h,r.labelStyle)),u.css(D({color:"#333333"},h,r.inputStyle)),G(p,I({position:"absolute",border:0,width:"1px",height:"1px",padding:0,textAlign:"center",
fontSize:h.fontSize,fontFamily:h.fontFamily,top:"-9999em"},r.inputStyle)));p.onfocus=function(){e.showInput(a)};p.onblur=function(){p===k.doc.activeElement&&g();e.hideInput(a);p.blur()};p.onchange=g;p.onkeypress=function(a){13===a.keyCode&&g()}},getPosition:function(){var a=this.chart,f=a.options.rangeSelector;a="top"===f.verticalAlign?a.plotTop-a.axisOffset[0]:0;return{buttonTop:a+f.buttonPosition.y,inputTop:a+f.inputPosition.y-10}},getYTDExtremes:function(a,f,e){var c=this.chart.time,g=new c.Date(a),
h=c.get("FullYear",g);e=e?c.Date.UTC(h,0,1):+new c.Date(h,0,1);f=Math.max(f||0,e);g=g.getTime();return{max:Math.min(a||g,g),min:f}},render:function(a,g){var e=this,c=e.chart,h=c.renderer,k=c.container,l=c.options,q=l.exporting&&!1!==l.exporting.enabled&&l.navigation&&l.navigation.buttonOptions,r=f.lang,p=e.div,v=l.rangeSelector,y=t(l.chart.style&&l.chart.style.zIndex,0)+1;l=v.floating;var B=e.buttons;p=e.inputGroup;var d=v.buttonTheme,b=v.buttonPosition,n=v.inputPosition,x=v.inputEnabled,z=d&&d.states,
A=c.plotLeft,D=e.buttonGroup,E,G=e.options.verticalAlign,H=c.legend,I=H&&H.options,J=b.y,M=n.y,N=c.hasLoaded,P=N?"animate":"attr",T=0,S=0;if(!1!==v.enabled){e.rendered||(e.group=E=h.g("range-selector-group").attr({zIndex:7}).add(),e.buttonGroup=D=h.g("range-selector-buttons").add(E),e.zoomText=h.text(r.rangeSelectorZoom,0,15).add(D),c.styledMode||(e.zoomText.css(v.labelStyle),d["stroke-width"]=t(d["stroke-width"],0)),e.buttonOptions.forEach(function(a,b){B[b]=h.button(a.text,0,0,function(c){var d=
a.events&&a.events.click,f;d&&(f=d.call(a,c));!1!==f&&e.clickButton(b);e.isActive=!0},d,z&&z.hover,z&&z.select,z&&z.disabled).attr({"text-align":"center"}).add(D)}),!1!==x&&(e.div=p=K("div",null,{position:"relative",height:0,zIndex:y}),k.parentNode.insertBefore(p,k),e.inputGroup=p=h.g("input-group").add(E),p.offset=0,e.drawInput("min"),e.drawInput("max")));e.zoomText[P]({x:t(A+b.x,A)});var da=t(A+b.x,A)+e.zoomText.getBBox().width+5;e.buttonOptions.forEach(function(a,b){B[b][P]({x:da});da+=B[b].width+
t(v.buttonSpacing,5)});A=c.plotLeft-c.spacing[3];e.updateButtonStates();q&&this.titleCollision(c)&&"top"===G&&"right"===b.align&&b.y+D.getBBox().height-12<(q.y||0)+q.height&&(T=-40);k=b.x-c.spacing[3];"right"===b.align?k+=T-A:"center"===b.align&&(k-=A/2);D.align({y:b.y,width:D.getBBox().width,align:b.align,x:k},!0,c.spacingBox);e.group.placed=N;e.buttonGroup.placed=N;!1!==x&&(T=q&&this.titleCollision(c)&&"top"===G&&"right"===n.align&&n.y-p.getBBox().height-12<(q.y||0)+q.height+c.spacing[0]?-40:0,
"left"===n.align?k=A:"right"===n.align&&(k=-Math.max(c.axisOffset[1],-T)),p.align({y:n.y,width:p.getBBox().width,align:n.align,x:n.x+k-2},!0,c.spacingBox),q=p.alignAttr.translateX+p.alignOptions.x-T+p.getBBox().x+2,k=p.alignOptions.width,r=D.alignAttr.translateX+D.getBBox().x,A=D.getBBox().width+20,(n.align===b.align||r+A>q&&q+k>r&&J<M+p.getBBox().height)&&p.attr({translateX:p.alignAttr.translateX+(c.axisOffset[1]>=-T?0:-T),translateY:p.alignAttr.translateY+D.getBBox().height+10}),e.setInputValue("min",
a),e.setInputValue("max",g),e.inputGroup.placed=N);e.group.align({verticalAlign:G},!0,c.spacingBox);a=e.group.getBBox().height+20;g=e.group.alignAttr.translateY;"bottom"===G&&(H=I&&"bottom"===I.verticalAlign&&I.enabled&&!I.floating?H.legendHeight+t(I.margin,10):0,a=a+H-20,S=g-a-(l?0:v.y)-(c.titleOffset?c.titleOffset[2]:0)-10);if("top"===G)l&&(S=0),c.titleOffset&&c.titleOffset[0]&&(S=c.titleOffset[0]),S+=c.margin[0]-c.spacing[0]||0;else if("middle"===G)if(M===J)S=0>M?g+void 0:g;else if(M||J)S=0>M||
0>J?S-Math.min(M,J):g-a+NaN;e.group.translate(v.x,v.y+Math.floor(S));!1!==x&&(e.minInput.style.marginTop=e.group.translateY+"px",e.maxInput.style.marginTop=e.group.translateY+"px");e.rendered=!0}},getHeight:function(){var a=this.options,f=this.group,e=a.y,c=a.buttonPosition.y,g=a.inputPosition.y;if(a.height)return a.height;a=f?f.getBBox(!0).height+13+e:0;f=Math.min(g,c);if(0>g&&0>c||0<g&&0<c)a+=Math.abs(f);return a},titleCollision:function(a){return!(a.options.title.text||a.options.subtitle.text)},
update:function(a){var f=this.chart;D(!0,f.options.rangeSelector,a);this.destroy();this.init(f);f.rangeSelector.render()},destroy:function(){var a=this,f=a.minInput,e=a.maxInput;a.unMouseDown();a.unResize();M(a.buttons);f&&(f.onfocus=f.onblur=f.onchange=null);e&&(e.onfocus=e.onblur=e.onchange=null);z(a,function(c,e){c&&"chart"!==e&&(c.destroy?c.destroy():c.nodeType&&y(this[e]));c!==A.prototype[e]&&(a[e]=null)},this)}};h.prototype.minFromRange=function(){var a=this.range,f=a.type,e=this.max,c=this.chart.time,
g=function(a,e){var g="year"===f?"FullYear":"Month",h=new c.Date(a),k=c.get(g,h);c.set(g,h,k+e);k===c.get(g,h)&&c.set("Date",h,0);return h.getTime()-a};if(E(a)){var h=e-a;var k=a}else h=e+g(e,-a.count),this.chart&&(this.chart.fixedRange=e-h);var q=t(this.dataMin,Number.MIN_VALUE);E(h)||(h=q);h<=q&&(h=q,"undefined"===typeof k&&(k=g(h,a.count)),this.newMax=Math.min(h+k,this.dataMax));E(e)||(h=void 0);return h};k.RangeSelector||(v(g,"afterGetContainer",function(){this.options.rangeSelector.enabled&&
(this.rangeSelector=new A(this))}),v(g,"beforeRender",function(){var a=this.axes,f=this.rangeSelector;f&&(E(f.deferredYTDClick)&&(f.clickButton(f.deferredYTDClick),delete f.deferredYTDClick),a.forEach(function(a){a.updateNames();a.setScale()}),this.getAxisMargins(),f.render(),a=f.options.verticalAlign,f.options.floating||("bottom"===a?this.extraBottomMargin=!0:"middle"!==a&&(this.extraTopMargin=!0)))}),v(g,"update",function(a){var f=a.options.rangeSelector;a=this.rangeSelector;var e=this.extraBottomMargin,
c=this.extraTopMargin;f&&f.enabled&&!N(a)&&(this.options.rangeSelector.enabled=!0,this.rangeSelector=new A(this));this.extraTopMargin=this.extraBottomMargin=!1;a&&(a.render(),f=f&&f.verticalAlign||a.options&&a.options.verticalAlign,a.options.floating||("bottom"===f?this.extraBottomMargin=!0:"middle"!==f&&(this.extraTopMargin=!0)),this.extraBottomMargin!==e||this.extraTopMargin!==c)&&(this.isDirtyBox=!0)}),v(g,"render",function(){var a=this.rangeSelector;a&&!a.options.floating&&(a.render(),a=a.options.verticalAlign,
"bottom"===a?this.extraBottomMargin=!0:"middle"!==a&&(this.extraTopMargin=!0))}),v(g,"getMargins",function(){var a=this.rangeSelector;a&&(a=a.getHeight(),this.extraTopMargin&&(this.plotTop+=a),this.extraBottomMargin&&(this.marginBottom+=a))}),g.prototype.callbacks.push(function(a){function f(){e=a.xAxis[0].getExtremes();g=a.legend;k=null===c||void 0===c?void 0:c.options.verticalAlign;E(e.min)&&c.render(e.min,e.max);c&&g.display&&"top"===k&&k===g.options.verticalAlign&&(h=D(a.spacingBox),h.y="vertical"===
g.options.layout?a.plotTop:h.y+c.getHeight(),g.group.placed=!1,g.align(h))}var e,c=a.rangeSelector,g,h,k;if(c){var q=v(a.xAxis[0],"afterSetExtremes",function(a){c.render(a.min,a.max)});var r=v(a,"redraw",f);f()}v(a,"destroy",function(){c&&(r(),q())})}),k.RangeSelector=A)});P(A,"parts/StockChart.js",[A["parts/Axis.js"],A["parts/Globals.js"],A["parts/Point.js"],A["parts/Utilities.js"]],function(k,g,A,v){var H=v.addEvent,G=v.arrayMax,N=v.arrayMin,M=v.clamp,y=v.defined,I=v.extend,J=v.find,E=v.format,
D=v.isNumber,z=v.isString,t=v.merge,q=v.pick,r=v.splat,h=g.Chart;v=g.Series;var f=g.SVGRenderer,a=v.prototype,l=a.init,e=a.processData,c=A.prototype.tooltipFormatter;g.StockChart=g.stockChart=function(a,c,e){var f=z(a)||a.nodeName,k=arguments[f?1:0],m=k,l=k.series,u=g.getOptions(),v,d=q(k.navigator&&k.navigator.enabled,u.navigator.enabled,!0);k.xAxis=r(k.xAxis||{}).map(function(a,c){return t({minPadding:0,maxPadding:0,overscroll:0,ordinal:!0,title:{text:null},labels:{overflow:"justify"},showLastLabel:!0},
u.xAxis,u.xAxis&&u.xAxis[c],a,{type:"datetime",categories:null},d?{startOnTick:!1,endOnTick:!1}:null)});k.yAxis=r(k.yAxis||{}).map(function(a,c){v=q(a.opposite,!0);return t({labels:{y:-2},opposite:v,showLastLabel:!(!a.categories&&"category"!==a.type),title:{text:null}},u.yAxis,u.yAxis&&u.yAxis[c],a)});k.series=null;k=t({chart:{panning:{enabled:!0,type:"x"},pinchType:"x"},navigator:{enabled:d},scrollbar:{enabled:q(u.scrollbar.enabled,!0)},rangeSelector:{enabled:q(u.rangeSelector.enabled,!0)},title:{text:null},
tooltip:{split:q(u.tooltip.split,!0),crosshairs:!0},legend:{enabled:!1}},k,{isStock:!0});k.series=m.series=l;return f?new h(a,k,e):new h(k,c)};H(v,"setOptions",function(a){var c;this.chart.options.isStock&&(this.is("column")||this.is("columnrange")?c={borderWidth:0,shadow:!1}:this.is("scatter")||this.is("sma")||(c={marker:{enabled:!1,radius:2}}),c&&(a.plotOptions[this.type]=t(a.plotOptions[this.type],c)))});H(k,"autoLabelAlign",function(a){var c=this.chart,e=this.options;c=c._labelPanes=c._labelPanes||
{};var f=this.options.labels;this.chart.options.isStock&&"yAxis"===this.coll&&(e=e.top+","+e.height,!c[e]&&f.enabled&&(15===f.x&&(f.x=0),"undefined"===typeof f.align&&(f.align="right"),c[e]=this,a.align="right",a.preventDefault()))});H(k,"destroy",function(){var a=this.chart,c=this.options&&this.options.top+","+this.options.height;c&&a._labelPanes&&a._labelPanes[c]===this&&delete a._labelPanes[c]});H(k,"getPlotLinePath",function(a){function c(a){var b="xAxis"===a?"yAxis":"xAxis";a=e.options[b];return D(a)?
[g[b][a]]:z(a)?[g.get(a)]:f.map(function(a){return a[b]})}var e=this,f=this.isLinked&&!this.series?this.linkedParent.series:this.series,g=e.chart,h=g.renderer,k=e.left,m=e.top,l,d,b,n,r=[],t=[],v=a.translatedValue,A=a.value,E=a.force;if(g.options.isStock&&!1!==a.acrossPanes&&"xAxis"===e.coll||"yAxis"===e.coll){a.preventDefault();t=c(e.coll);var G=e.isXAxis?g.yAxis:g.xAxis;G.forEach(function(a){if(y(a.options.id)?-1===a.options.id.indexOf("navigator"):1){var b=a.isXAxis?"yAxis":"xAxis";b=y(a.options[b])?
g[b][a.options[b]]:g[b][0];e===b&&t.push(a)}});var H=t.length?[]:[e.isXAxis?g.yAxis[0]:g.xAxis[0]];t.forEach(function(a){-1!==H.indexOf(a)||J(H,function(b){return b.pos===a.pos&&b.len===a.len})||H.push(a)});var I=q(v,e.translate(A,null,null,a.old));D(I)&&(e.horiz?H.forEach(function(a){var c;d=a.pos;n=d+a.len;l=b=Math.round(I+e.transB);"pass"!==E&&(l<k||l>k+e.width)&&(E?l=b=M(l,k,k+e.width):c=!0);c||r.push(["M",l,d],["L",b,n])}):H.forEach(function(a){var c;l=a.pos;b=l+a.len;d=n=Math.round(m+e.height-
I);"pass"!==E&&(d<m||d>m+e.height)&&(E?d=n=M(d,m,m+e.height):c=!0);c||r.push(["M",l,d],["L",b,n])}));a.path=0<r.length?h.crispPolyLine(r,a.lineWidth||1):null}});f.prototype.crispPolyLine=function(a,c){for(var e=0;e<a.length;e+=2){var f=a[e],g=a[e+1];f[1]===g[1]&&(f[1]=g[1]=Math.round(f[1])-c%2/2);f[2]===g[2]&&(f[2]=g[2]=Math.round(f[2])+c%2/2)}return a};H(k,"afterHideCrosshair",function(){this.crossLabel&&(this.crossLabel=this.crossLabel.hide())});H(k,"afterDrawCrosshair",function(a){var c,e;if(y(this.crosshair.label)&&
this.crosshair.label.enabled&&this.cross){var f=this.chart,g=this.logarithmic,h=this.options.crosshair.label,k=this.horiz,m=this.opposite,l=this.left,d=this.top,b=this.crossLabel,n=h.format,r="",t="inside"===this.options.tickPosition,v=!1!==this.crosshair.snap,z=0,A=a.e||this.cross&&this.cross.e,D=a.point;a=this.min;var G=this.max;g&&(a=g.lin2log(a),G=g.lin2log(G));g=k?"center":m?"right"===this.labelAlign?"right":"left":"left"===this.labelAlign?"left":"center";b||(b=this.crossLabel=f.renderer.label(null,
null,null,h.shape||"callout").addClass("highcharts-crosshair-label"+(this.series[0]&&" highcharts-color-"+this.series[0].colorIndex)).attr({align:h.align||g,padding:q(h.padding,8),r:q(h.borderRadius,3),zIndex:2}).add(this.labelGroup),f.styledMode||b.attr({fill:h.backgroundColor||this.series[0]&&this.series[0].color||"#666666",stroke:h.borderColor||"","stroke-width":h.borderWidth||0}).css(I({color:"#ffffff",fontWeight:"normal",fontSize:"11px",textAlign:"center"},h.style)));k?(g=v?D.plotX+l:A.chartX,
d+=m?0:this.height):(g=m?this.width+l:0,d=v?D.plotY+d:A.chartY);n||h.formatter||(this.dateTime&&(r="%b %d, %Y"),n="{value"+(r?":"+r:"")+"}");r=v?D[this.isXAxis?"x":"y"]:this.toValue(k?A.chartX:A.chartY);b.attr({text:n?E(n,{value:r},f):h.formatter.call(this,r),x:g,y:d,visibility:r<a||r>G?"hidden":"visible"});h=b.getBBox();if(k){if(t&&!m||!t&&m)d=b.y-h.height}else d=b.y-h.height/2;k?(c=l-h.x,e=l+this.width-h.x):(c="left"===this.labelAlign?l:0,e="right"===this.labelAlign?l+this.width:f.chartWidth);b.translateX<
c&&(z=c-b.translateX);b.translateX+h.width>=e&&(z=-(b.translateX+h.width-e));b.attr({x:g+z,y:d,anchorX:k?g:this.opposite?0:f.chartWidth,anchorY:k?this.opposite?f.chartHeight:0:d+h.height/2})}});a.init=function(){l.apply(this,arguments);this.setCompare(this.options.compare)};a.setCompare=function(a){this.modifyValue="value"===a||"percent"===a?function(c,e){var f=this.compareValue;return"undefined"!==typeof c&&"undefined"!==typeof f?(c="value"===a?c-f:c/f*100-(100===this.options.compareBase?0:100),
e&&(e.change=c),c):0}:null;this.userOptions.compare=a;this.chart.hasRendered&&(this.isDirty=!0)};a.processData=function(a){var c,f=-1,g=!0===this.options.compareStart?0:1;e.apply(this,arguments);if(this.xAxis&&this.processedYData){var h=this.processedXData;var k=this.processedYData;var m=k.length;this.pointArrayMap&&(f=this.pointArrayMap.indexOf(this.options.pointValKey||this.pointValKey||"y"));for(c=0;c<m-g;c++){var l=k[c]&&-1<f?k[c][f]:k[c];if(D(l)&&h[c+g]>=this.xAxis.min&&0!==l){this.compareValue=
l;break}}}};H(v,"afterGetExtremes",function(a){a=a.dataExtremes;if(this.modifyValue&&a){var c=[this.modifyValue(a.dataMin),this.modifyValue(a.dataMax)];a.dataMin=N(c);a.dataMax=G(c)}});k.prototype.setCompare=function(a,c){this.isXAxis||(this.series.forEach(function(c){c.setCompare(a)}),q(c,!0)&&this.chart.redraw())};A.prototype.tooltipFormatter=function(a){var e=this.series.chart.numberFormatter;a=a.replace("{point.change}",(0<this.change?"+":"")+e(this.change,q(this.series.tooltipOptions.changeDecimals,
2)));return c.apply(this,[a])};H(v,"render",function(){var a=this.chart;if(!(a.is3d&&a.is3d()||a.polar)&&this.xAxis&&!this.xAxis.isRadial){var c=this.yAxis.len;if(this.xAxis.axisLine){var e=a.plotTop+a.plotHeight-this.yAxis.pos-this.yAxis.len,f=Math.floor(this.xAxis.axisLine.strokeWidth()/2);0<=e&&(c-=Math.max(f-e,0))}!this.clipBox&&this.animate?(this.clipBox=t(a.clipBox),this.clipBox.width=this.xAxis.len,this.clipBox.height=c):a[this.sharedClipKey]&&(a[this.sharedClipKey].animate({width:this.xAxis.len,
height:c}),a[this.sharedClipKey+"m"]&&a[this.sharedClipKey+"m"].animate({width:this.xAxis.len}))}});H(h,"update",function(a){a=a.options;"scrollbar"in a&&this.navigator&&(t(!0,this.options.scrollbar,a.scrollbar),this.navigator.update({},!1),delete a.scrollbar)})});P(A,"masters/modules/stock.src.js",[],function(){});P(A,"masters/highstock.src.js",[A["masters/highcharts.src.js"]],function(k){k.product="Highstock";return k});A["masters/highstock.src.js"]._modules=A;return A["masters/highstock.src.js"]});
//# sourceMappingURL=highstock.js.map

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// custom-data-chart-barrons-0.8.56.min.js